import { i as __reExport, r as __export } from "./rolldown-runtime-Bg48TavK.es.js";
import { $ as map, B as getFileObject, C as ellipsis_vertical_solid_default, D as AIWriter_default, E as comment_solid_default, F as TrackChangesBasePluginKey, G as isNode, H as createUint8ArrayFromArrayBuffer, J as varStorage, K as offChange, L as seedEditorStateToYDoc, N as CommentsPluginKey, O as getRichTextExtensions, P as createOrUpdateTrackedChangeComment, Q as removeAwarenessStates, R as onCollaborationProviderSynced, S as caret_down_solid_default, T as check_solid_default, U as fromBase64, V as comments_module_events, W as toBase64, X as applyAwarenessUpdate, Y as Awareness, Z as encodeAwarenessUpdate, at as readVarUint, b as SuperToolbar, ct as length, dt as writeVarUint8Array, et as ObservableV2, ft as create, g as makeTrackedChangeAnchorKey, i as SuperEditor_default, it as readVarString, k as getStarterExtensions, lt as toUint8Array, mt as pow, nt as getUnixTime, o as PresentationEditor, ot as readVarUint8Array, pt as min, q as onChange, r as SuperInput_default, rt as createDecoder, s as Editor, st as createEncoder, tt as setIfUndefined, u as getTrackedChangeIndex, ut as writeVarUint, w as xmark_solid_default, z as v_click_outside_default } from "./src-CkCw258n.es.js";
import { Ls as composeAuthorColorResolver, Na as ySyncPluginKey, Z as resolveTrackedChangeInStory, nt as getTrackChanges, tt as enumerateStructuralRowChanges } from "./SuperConverter-BBOL1zJ-.es.js";
import { a as init_dist, i as global, n as init_dist$1, r as process$1 } from "./jszip-C49i9kUs.es.js";
import { n as v4_default } from "./uuid-B2wVPhPi.es.js";
import { cn as actorIdentitiesMatch, dn as normalizeActorEmail, fn as normalizeActorName, ln as getActorIdentity, un as getActorIdentityKey } from "./create-headless-toolbar-EMbyHacR.es.js";
import { a as HTML, i as DOCX, o as PDF, s as documentTypes } from "./DocxZipper-FUsfThjV.es.js";
import { t as __plugin_vue_export_helper_default } from "./_plugin-vue_export-helper-5t5P5NuM.es.js";
import { n as shallowEqual } from "./create-super-doc-ui-3Le7HY_m.es.js";
import { t as import_eventemitter3 } from "./eventemitter3-BnGqBE-Q.es.js";
import { t as createZip } from "./zipper-yaJVJ4z9.es.js";
import { t as blank_default } from "./blank-docx-1Y-uWgjm.es.js";
import { n as PDF_TO_CSS_UNITS } from "./constants-DBcgc8OY.es.js";
import * as Y from "yjs";
import { Doc, Map as Map$1 } from "yjs";
import * as Vue from "vue";
import { Fragment, Teleport, computed, createApp, createBlock, createCommentVNode, createElementBlock, createElementVNode, createTextVNode, createVNode, defineAsyncComponent, defineComponent, getCurrentInstance, guardReactiveProps, inject, isRef, markRaw, mergeProps, nextTick, normalizeClass, normalizeProps, normalizeStyle, onBeforeUnmount, onMounted, openBlock, reactive, ref, renderList, renderSlot, resolveDirective, resolveDynamicComponent, shallowRef, toDisplayString, toRaw, toRef, unref, watch, withCtx, withDirectives, withModifiers } from "vue";
import { HocuspocusProvider, HocuspocusProviderWebsocket } from "@hocuspocus/provider";
function compareVersions(version1, version2) {
	const v1Parts = version1.split(".").map(Number);
	const v2Parts = version2.split(".").map(Number);
	for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
		const v1 = v1Parts[i] || 0;
		const v2 = v2Parts[i] || 0;
		if (v1 > v2) return 1;
		if (v1 < v2) return -1;
	}
	return 0;
}
function hasUser(entry) {
	return entry[1].user !== void 0;
}
const awarenessStatesToArray = (context, states) => {
	const seenUsers = /* @__PURE__ */ new Set();
	return Array.from(states.entries()).filter(hasUser).filter(([clientId, value]) => {
		const identityKey = getActorIdentityKey({
			actor: value.user,
			fallbackKey: clientId
		});
		if (!identityKey) return false;
		if (seenUsers.has(identityKey)) return false;
		seenUsers.add(identityKey);
		return true;
	}).map(([key, value]) => {
		const identityKey = getActorIdentityKey({
			actor: value.user,
			fallbackKey: key
		});
		let color = context.userColorMap.get(identityKey);
		if (!color) {
			color = value.user.color || (context.config.colors.length > 0 ? context.config.colors[context.colorIndex % context.config.colors.length] : void 0);
			context.userColorMap.set(identityKey, color);
			context.colorIndex++;
		}
		return {
			clientId: key,
			...value.user,
			color
		};
	});
};
const shuffleArray = (array) => {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
	return array;
};
const getSchemaIntrospection = async (options = {}) => {
	const { editor, extensions, mode = "docx" } = options;
	if (editor) return editor.getSchemaSummaryJSON();
	const tempEditor = new Editor({
		extensions: Array.isArray(extensions) && extensions.length ? extensions : mode === "docx" ? getStarterExtensions() : getRichTextExtensions(),
		mode,
		isHeadless: true,
		deferDocumentLoad: true,
		telemetry: { enabled: false }
	});
	try {
		return await tempEditor.getSchemaSummaryJSON();
	} finally {
		if (typeof tempEditor.destroy === "function") tempEditor.destroy();
	}
};
var lib_exports = /* @__PURE__ */ __export({
	Vue: () => Vue,
	Vue2: () => void 0,
	del: () => del,
	install: () => install,
	isVue2: () => false,
	isVue3: () => true,
	set: () => set
}, 1);
import * as import_vue from "vue";
__reExport(lib_exports, import_vue, void 0, 1);
function install() {}
function set(target, key, val) {
	if (Array.isArray(target)) {
		target.length = Math.max(target.length, key);
		target.splice(key, 1, val);
		return val;
	}
	target[key] = val;
	return val;
}
function del(target, key) {
	if (Array.isArray(target)) {
		target.splice(key, 1);
		return;
	}
	delete target[key];
}
function getDevtoolsGlobalHook() {
	return getTarget().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function getTarget() {
	return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const isProxyAvailable = typeof Proxy === "function";
const HOOK_SETUP = "devtools-plugin:setup";
const HOOK_PLUGIN_SETTINGS_SET = "plugin:settings:set";
var supported;
var perf;
function isPerformanceSupported() {
	var _a;
	if (supported !== void 0) return supported;
	if (typeof window !== "undefined" && window.performance) {
		supported = true;
		perf = window.performance;
	} else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
		supported = true;
		perf = globalThis.perf_hooks.performance;
	} else supported = false;
	return supported;
}
function now$1() {
	return isPerformanceSupported() ? perf.now() : Date.now();
}
var ApiProxy = class {
	constructor(plugin, hook) {
		this.target = null;
		this.targetQueue = [];
		this.onQueue = [];
		this.plugin = plugin;
		this.hook = hook;
		const defaultSettings = {};
		if (plugin.settings) for (const id in plugin.settings) defaultSettings[id] = plugin.settings[id].defaultValue;
		const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
		let currentSettings = Object.assign({}, defaultSettings);
		try {
			const raw = localStorage.getItem(localSettingsSaveId);
			const data = JSON.parse(raw);
			Object.assign(currentSettings, data);
		} catch (e) {}
		this.fallbacks = {
			getSettings() {
				return currentSettings;
			},
			setSettings(value) {
				try {
					localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
				} catch (e) {}
				currentSettings = value;
			},
			now() {
				return now$1();
			}
		};
		if (hook) hook.on(HOOK_PLUGIN_SETTINGS_SET, (pluginId, value) => {
			if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
		});
		this.proxiedOn = new Proxy({}, { get: (_target, prop) => {
			if (this.target) return this.target.on[prop];
			else return (...args) => {
				this.onQueue.push({
					method: prop,
					args
				});
			};
		} });
		this.proxiedTarget = new Proxy({}, { get: (_target, prop) => {
			if (this.target) return this.target[prop];
			else if (prop === "on") return this.proxiedOn;
			else if (Object.keys(this.fallbacks).includes(prop)) return (...args) => {
				this.targetQueue.push({
					method: prop,
					args,
					resolve: () => {}
				});
				return this.fallbacks[prop](...args);
			};
			else return (...args) => {
				return new Promise((resolve) => {
					this.targetQueue.push({
						method: prop,
						args,
						resolve
					});
				});
			};
		} });
	}
	async setRealTarget(target) {
		this.target = target;
		for (const item of this.onQueue) this.target.on[item.method](...item.args);
		for (const item of this.targetQueue) item.resolve(await this.target[item.method](...item.args));
	}
};
function setupDevtoolsPlugin(pluginDescriptor, setupFn) {
	const descriptor = pluginDescriptor;
	const target = getTarget();
	const hook = getDevtoolsGlobalHook();
	const enableProxy = isProxyAvailable && descriptor.enableEarlyProxy;
	if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit(HOOK_SETUP, pluginDescriptor, setupFn);
	else {
		const proxy = enableProxy ? new ApiProxy(descriptor, hook) : null;
		(target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || []).push({
			pluginDescriptor: descriptor,
			setupFn,
			proxy
		});
		if (proxy) setupFn(proxy.proxiedTarget);
	}
}
init_dist();
init_dist$1();
var activePinia;
var setActivePinia = (pinia) => activePinia = pinia;
var piniaSymbol = process$1.env.NODE_ENV !== "production" ? Symbol("pinia") : Symbol();
function isPlainObject(o) {
	return o && typeof o === "object" && Object.prototype.toString.call(o) === "[object Object]" && typeof o.toJSON !== "function";
}
var MutationType;
(function(MutationType$1) {
	MutationType$1["direct"] = "direct";
	MutationType$1["patchObject"] = "patch object";
	MutationType$1["patchFunction"] = "patch function";
})(MutationType || (MutationType = {}));
var IS_CLIENT = typeof window !== "undefined";
var _global = /* @__PURE__ */ (() => typeof window === "object" && window.window === window ? window : typeof self === "object" && self.self === self ? self : typeof global === "object" && global.global === global ? global : typeof globalThis === "object" ? globalThis : { HTMLElement: null })();
function bom(blob, { autoBom = false } = {}) {
	if (autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([String.fromCharCode(65279), blob], { type: blob.type });
	return blob;
}
function download(url, name, opts) {
	const xhr = new XMLHttpRequest();
	xhr.open("GET", url);
	xhr.responseType = "blob";
	xhr.onload = function() {
		saveAs(xhr.response, name, opts);
	};
	xhr.onerror = function() {
		console.error("could not download file");
	};
	xhr.send();
}
function corsEnabled(url) {
	const xhr = new XMLHttpRequest();
	xhr.open("HEAD", url, false);
	try {
		xhr.send();
	} catch (e) {}
	return xhr.status >= 200 && xhr.status <= 299;
}
function click(node) {
	try {
		node.dispatchEvent(new MouseEvent("click"));
	} catch (e) {
		const evt = document.createEvent("MouseEvents");
		evt.initMouseEvent("click", true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
		node.dispatchEvent(evt);
	}
}
var _navigator = typeof navigator === "object" ? navigator : { userAgent: "" };
var isMacOSWebView = /* @__PURE__ */ (() => /Macintosh/.test(_navigator.userAgent) && /AppleWebKit/.test(_navigator.userAgent) && !/Safari/.test(_navigator.userAgent))();
var saveAs = !IS_CLIENT ? () => {} : typeof HTMLAnchorElement !== "undefined" && "download" in HTMLAnchorElement.prototype && !isMacOSWebView ? downloadSaveAs : "msSaveOrOpenBlob" in _navigator ? msSaveAs : fileSaverSaveAs;
function downloadSaveAs(blob, name = "download", opts) {
	const a = document.createElement("a");
	a.download = name;
	a.rel = "noopener";
	if (typeof blob === "string") {
		a.href = blob;
		if (a.origin !== location.origin) if (corsEnabled(a.href)) download(blob, name, opts);
		else {
			a.target = "_blank";
			click(a);
		}
		else click(a);
	} else {
		a.href = URL.createObjectURL(blob);
		setTimeout(function() {
			URL.revokeObjectURL(a.href);
		}, 4e4);
		setTimeout(function() {
			click(a);
		}, 0);
	}
}
function msSaveAs(blob, name = "download", opts) {
	if (typeof blob === "string") if (corsEnabled(blob)) download(blob, name, opts);
	else {
		const a = document.createElement("a");
		a.href = blob;
		a.target = "_blank";
		setTimeout(function() {
			click(a);
		});
	}
	else navigator.msSaveOrOpenBlob(bom(blob, opts), name);
}
function fileSaverSaveAs(blob, name, opts, popup) {
	popup = popup || open("", "_blank");
	if (popup) popup.document.title = popup.document.body.innerText = "downloading...";
	if (typeof blob === "string") return download(blob, name, opts);
	const force = blob.type === "application/octet-stream";
	const isSafari = /constructor/i.test(String(_global.HTMLElement)) || "safari" in _global;
	const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
	if ((isChromeIOS || force && isSafari || isMacOSWebView) && typeof FileReader !== "undefined") {
		const reader = new FileReader();
		reader.onloadend = function() {
			let url = reader.result;
			if (typeof url !== "string") {
				popup = null;
				throw new Error("Wrong reader.result type");
			}
			url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, "data:attachment/file;");
			if (popup) popup.location.href = url;
			else location.assign(url);
			popup = null;
		};
		reader.readAsDataURL(blob);
	} else {
		const url = URL.createObjectURL(blob);
		if (popup) popup.location.assign(url);
		else location.href = url;
		popup = null;
		setTimeout(function() {
			URL.revokeObjectURL(url);
		}, 4e4);
	}
}
function toastMessage(message, type) {
	const piniaMessage = "🍍 " + message;
	if (typeof __VUE_DEVTOOLS_TOAST__ === "function") __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
	else if (type === "error") console.error(piniaMessage);
	else if (type === "warn") console.warn(piniaMessage);
	else console.log(piniaMessage);
}
function isPinia(o) {
	return "_a" in o && "install" in o;
}
function checkClipboardAccess() {
	if (!("clipboard" in navigator)) {
		toastMessage(`Your browser doesn't support the Clipboard API`, "error");
		return true;
	}
}
function checkNotFocusedError(error) {
	if (error instanceof Error && error.message.toLowerCase().includes("document is not focused")) {
		toastMessage("You need to activate the \"Emulate a focused page\" setting in the \"Rendering\" panel of devtools.", "warn");
		return true;
	}
	return false;
}
async function actionGlobalCopyState(pinia) {
	if (checkClipboardAccess()) return;
	try {
		await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
		toastMessage("Global state copied to clipboard.");
	} catch (error) {
		if (checkNotFocusedError(error)) return;
		toastMessage(`Failed to serialize the state. Check the console for more details.`, "error");
		console.error(error);
	}
}
async function actionGlobalPasteState(pinia) {
	if (checkClipboardAccess()) return;
	try {
		loadStoresState(pinia, JSON.parse(await navigator.clipboard.readText()));
		toastMessage("Global state pasted from clipboard.");
	} catch (error) {
		if (checkNotFocusedError(error)) return;
		toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, "error");
		console.error(error);
	}
}
async function actionGlobalSaveState(pinia) {
	try {
		saveAs(new Blob([JSON.stringify(pinia.state.value)], { type: "text/plain;charset=utf-8" }), "pinia-state.json");
	} catch (error) {
		toastMessage(`Failed to export the state as JSON. Check the console for more details.`, "error");
		console.error(error);
	}
}
var fileInput;
function getFileOpener() {
	if (!fileInput) {
		fileInput = document.createElement("input");
		fileInput.type = "file";
		fileInput.accept = ".json";
	}
	function openFile() {
		return new Promise((resolve, reject) => {
			fileInput.onchange = async () => {
				const files = fileInput.files;
				if (!files) return resolve(null);
				const file = files.item(0);
				if (!file) return resolve(null);
				return resolve({
					text: await file.text(),
					file
				});
			};
			fileInput.oncancel = () => resolve(null);
			fileInput.onerror = reject;
			fileInput.click();
		});
	}
	return openFile;
}
async function actionGlobalOpenStateFile(pinia) {
	try {
		const result = await getFileOpener()();
		if (!result) return;
		const { text, file } = result;
		loadStoresState(pinia, JSON.parse(text));
		toastMessage(`Global state imported from "${file.name}".`);
	} catch (error) {
		toastMessage(`Failed to import the state from JSON. Check the console for more details.`, "error");
		console.error(error);
	}
}
function loadStoresState(pinia, state) {
	for (const key in state) {
		const storeState = pinia.state.value[key];
		if (storeState) Object.assign(storeState, state[key]);
		else pinia.state.value[key] = state[key];
	}
}
function formatDisplay(display) {
	return { _custom: { display } };
}
var PINIA_ROOT_LABEL = "🍍 Pinia (root)";
var PINIA_ROOT_ID = "_root";
function formatStoreForInspectorTree(store) {
	return isPinia(store) ? {
		id: PINIA_ROOT_ID,
		label: PINIA_ROOT_LABEL
	} : {
		id: store.$id,
		label: store.$id
	};
}
function formatStoreForInspectorState(store) {
	if (isPinia(store)) {
		const storeNames = Array.from(store._s.keys());
		const storeMap = store._s;
		return {
			state: storeNames.map((storeId) => ({
				editable: true,
				key: storeId,
				value: store.state.value[storeId]
			})),
			getters: storeNames.filter((id) => storeMap.get(id)._getters).map((id) => {
				const store$1 = storeMap.get(id);
				return {
					editable: false,
					key: id,
					value: store$1._getters.reduce((getters, key) => {
						getters[key] = store$1[key];
						return getters;
					}, {})
				};
			})
		};
	}
	const state = { state: Object.keys(store.$state).map((key) => ({
		editable: true,
		key,
		value: store.$state[key]
	})) };
	if (store._getters && store._getters.length) state.getters = store._getters.map((getterName) => ({
		editable: false,
		key: getterName,
		value: store[getterName]
	}));
	if (store._customProperties.size) state.customProperties = Array.from(store._customProperties).map((key) => ({
		editable: true,
		key,
		value: store[key]
	}));
	return state;
}
function formatEventData(events) {
	if (!events) return {};
	if (Array.isArray(events)) return events.reduce((data, event) => {
		data.keys.push(event.key);
		data.operations.push(event.type);
		data.oldValue[event.key] = event.oldValue;
		data.newValue[event.key] = event.newValue;
		return data;
	}, {
		oldValue: {},
		keys: [],
		operations: [],
		newValue: {}
	});
	else return {
		operation: formatDisplay(events.type),
		key: formatDisplay(events.key),
		oldValue: events.oldValue,
		newValue: events.newValue
	};
}
function formatMutationType(type) {
	switch (type) {
		case MutationType.direct: return "mutation";
		case MutationType.patchFunction: return "$patch";
		case MutationType.patchObject: return "$patch";
		default: return "unknown";
	}
}
var isTimelineActive = true;
var componentStateTypes = [];
var MUTATIONS_LAYER_ID = "pinia:mutations";
var INSPECTOR_ID = "pinia";
var { assign: assign$1 } = Object;
var getStoreType = (id) => "🍍 " + id;
function registerPiniaDevtools(app, pinia) {
	setupDevtoolsPlugin({
		id: "dev.esm.pinia",
		label: "Pinia 🍍",
		logo: "https://pinia.vuejs.org/logo.svg",
		packageName: "pinia",
		homepage: "https://pinia.vuejs.org",
		componentStateTypes,
		app
	}, (api) => {
		if (typeof api.now !== "function") toastMessage("You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
		api.addTimelineLayer({
			id: MUTATIONS_LAYER_ID,
			label: `Pinia 🍍`,
			color: 15064968
		});
		api.addInspector({
			id: INSPECTOR_ID,
			label: "Pinia 🍍",
			icon: "storage",
			treeFilterPlaceholder: "Search stores",
			actions: [
				{
					icon: "content_copy",
					action: () => {
						actionGlobalCopyState(pinia);
					},
					tooltip: "Serialize and copy the state"
				},
				{
					icon: "content_paste",
					action: async () => {
						await actionGlobalPasteState(pinia);
						api.sendInspectorTree(INSPECTOR_ID);
						api.sendInspectorState(INSPECTOR_ID);
					},
					tooltip: "Replace the state with the content of your clipboard"
				},
				{
					icon: "save",
					action: () => {
						actionGlobalSaveState(pinia);
					},
					tooltip: "Save the state as a JSON file"
				},
				{
					icon: "folder_open",
					action: async () => {
						await actionGlobalOpenStateFile(pinia);
						api.sendInspectorTree(INSPECTOR_ID);
						api.sendInspectorState(INSPECTOR_ID);
					},
					tooltip: "Import the state from a JSON file"
				}
			],
			nodeActions: [{
				icon: "restore",
				tooltip: "Reset the state (with \"$reset\")",
				action: (nodeId) => {
					const store = pinia._s.get(nodeId);
					if (!store) toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, "warn");
					else if (typeof store.$reset !== "function") toastMessage(`Cannot reset "${nodeId}" store because it doesn't have a "$reset" method implemented.`, "warn");
					else {
						store.$reset();
						toastMessage(`Store "${nodeId}" reset.`);
					}
				}
			}]
		});
		api.on.inspectComponent((payload, ctx) => {
			const proxy = payload.componentInstance && payload.componentInstance.proxy;
			if (proxy && proxy._pStores) {
				const piniaStores = payload.componentInstance.proxy._pStores;
				Object.values(piniaStores).forEach((store) => {
					payload.instanceData.state.push({
						type: getStoreType(store.$id),
						key: "state",
						editable: true,
						value: store._isOptionsAPI ? { _custom: {
							value: (0, lib_exports.toRaw)(store.$state),
							actions: [{
								icon: "restore",
								tooltip: "Reset the state of this store",
								action: () => store.$reset()
							}]
						} } : Object.keys(store.$state).reduce((state, key) => {
							state[key] = store.$state[key];
							return state;
						}, {})
					});
					if (store._getters && store._getters.length) payload.instanceData.state.push({
						type: getStoreType(store.$id),
						key: "getters",
						editable: false,
						value: store._getters.reduce((getters, key) => {
							try {
								getters[key] = store[key];
							} catch (error) {
								getters[key] = error;
							}
							return getters;
						}, {})
					});
				});
			}
		});
		api.on.getInspectorTree((payload) => {
			if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
				let stores = [pinia];
				stores = stores.concat(Array.from(pinia._s.values()));
				payload.rootNodes = (payload.filter ? stores.filter((store) => "$id" in store ? store.$id.toLowerCase().includes(payload.filter.toLowerCase()) : PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase())) : stores).map(formatStoreForInspectorTree);
			}
		});
		globalThis.$pinia = pinia;
		api.on.getInspectorState((payload) => {
			if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
				const inspectedStore = payload.nodeId === PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
				if (!inspectedStore) return;
				if (inspectedStore) {
					if (payload.nodeId !== PINIA_ROOT_ID) globalThis.$store = (0, lib_exports.toRaw)(inspectedStore);
					payload.state = formatStoreForInspectorState(inspectedStore);
				}
			}
		});
		api.on.editInspectorState((payload, ctx) => {
			if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
				const inspectedStore = payload.nodeId === PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
				if (!inspectedStore) return toastMessage(`store "${payload.nodeId}" not found`, "error");
				const { path } = payload;
				if (!isPinia(inspectedStore)) {
					if (path.length !== 1 || !inspectedStore._customProperties.has(path[0]) || path[0] in inspectedStore.$state) path.unshift("$state");
				} else path.unshift("state");
				isTimelineActive = false;
				payload.set(inspectedStore, path, payload.state.value);
				isTimelineActive = true;
			}
		});
		api.on.editComponentState((payload) => {
			if (payload.type.startsWith("🍍")) {
				const storeId = payload.type.replace(/^🍍\s*/, "");
				const store = pinia._s.get(storeId);
				if (!store) return toastMessage(`store "${storeId}" not found`, "error");
				const { path } = payload;
				if (path[0] !== "state") return toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
				path[0] = "$state";
				isTimelineActive = false;
				payload.set(store, path, payload.state.value);
				isTimelineActive = true;
			}
		});
	});
}
function addStoreToDevtools(app, store) {
	if (!componentStateTypes.includes(getStoreType(store.$id))) componentStateTypes.push(getStoreType(store.$id));
	setupDevtoolsPlugin({
		id: "dev.esm.pinia",
		label: "Pinia 🍍",
		logo: "https://pinia.vuejs.org/logo.svg",
		packageName: "pinia",
		homepage: "https://pinia.vuejs.org",
		componentStateTypes,
		app,
		settings: { logStoreChanges: {
			label: "Notify about new/deleted stores",
			type: "boolean",
			defaultValue: true
		} }
	}, (api) => {
		const now$2 = typeof api.now === "function" ? api.now.bind(api) : Date.now;
		store.$onAction(({ after, onError, name, args }) => {
			const groupId = runningActionId++;
			api.addTimelineEvent({
				layerId: MUTATIONS_LAYER_ID,
				event: {
					time: now$2(),
					title: "🛫 " + name,
					subtitle: "start",
					data: {
						store: formatDisplay(store.$id),
						action: formatDisplay(name),
						args
					},
					groupId
				}
			});
			after((result) => {
				activeAction = void 0;
				api.addTimelineEvent({
					layerId: MUTATIONS_LAYER_ID,
					event: {
						time: now$2(),
						title: "🛬 " + name,
						subtitle: "end",
						data: {
							store: formatDisplay(store.$id),
							action: formatDisplay(name),
							args,
							result
						},
						groupId
					}
				});
			});
			onError((error) => {
				activeAction = void 0;
				api.addTimelineEvent({
					layerId: MUTATIONS_LAYER_ID,
					event: {
						time: now$2(),
						logType: "error",
						title: "💥 " + name,
						subtitle: "end",
						data: {
							store: formatDisplay(store.$id),
							action: formatDisplay(name),
							args,
							error
						},
						groupId
					}
				});
			});
		}, true);
		store._customProperties.forEach((name) => {
			(0, lib_exports.watch)(() => (0, lib_exports.unref)(store[name]), (newValue, oldValue) => {
				api.notifyComponentUpdate();
				api.sendInspectorState(INSPECTOR_ID);
				if (isTimelineActive) api.addTimelineEvent({
					layerId: MUTATIONS_LAYER_ID,
					event: {
						time: now$2(),
						title: "Change",
						subtitle: name,
						data: {
							newValue,
							oldValue
						},
						groupId: activeAction
					}
				});
			}, { deep: true });
		});
		store.$subscribe(({ events, type }, state) => {
			api.notifyComponentUpdate();
			api.sendInspectorState(INSPECTOR_ID);
			if (!isTimelineActive) return;
			const eventData = {
				time: now$2(),
				title: formatMutationType(type),
				data: assign$1({ store: formatDisplay(store.$id) }, formatEventData(events)),
				groupId: activeAction
			};
			if (type === MutationType.patchFunction) eventData.subtitle = "⤵️";
			else if (type === MutationType.patchObject) eventData.subtitle = "🧩";
			else if (events && !Array.isArray(events)) eventData.subtitle = events.type;
			if (events) eventData.data["rawEvent(s)"] = { _custom: {
				display: "DebuggerEvent",
				type: "object",
				tooltip: "raw DebuggerEvent[]",
				value: events
			} };
			api.addTimelineEvent({
				layerId: MUTATIONS_LAYER_ID,
				event: eventData
			});
		}, {
			detached: true,
			flush: "sync"
		});
		const hotUpdate = store._hotUpdate;
		store._hotUpdate = (0, lib_exports.markRaw)((newStore) => {
			hotUpdate(newStore);
			api.addTimelineEvent({
				layerId: MUTATIONS_LAYER_ID,
				event: {
					time: now$2(),
					title: "🔥 " + store.$id,
					subtitle: "HMR update",
					data: {
						store: formatDisplay(store.$id),
						info: formatDisplay(`HMR update`)
					}
				}
			});
			api.notifyComponentUpdate();
			api.sendInspectorTree(INSPECTOR_ID);
			api.sendInspectorState(INSPECTOR_ID);
		});
		const { $dispose } = store;
		store.$dispose = () => {
			$dispose();
			api.notifyComponentUpdate();
			api.sendInspectorTree(INSPECTOR_ID);
			api.sendInspectorState(INSPECTOR_ID);
			api.getSettings().logStoreChanges && toastMessage(`Disposed "${store.$id}" store 🗑`);
		};
		api.notifyComponentUpdate();
		api.sendInspectorTree(INSPECTOR_ID);
		api.sendInspectorState(INSPECTOR_ID);
		api.getSettings().logStoreChanges && toastMessage(`"${store.$id}" store installed 🆕`);
	});
}
var runningActionId = 0;
var activeAction;
function patchActionForGrouping(store, actionNames, wrapWithProxy) {
	const actions = actionNames.reduce((storeActions, actionName) => {
		storeActions[actionName] = (0, lib_exports.toRaw)(store)[actionName];
		return storeActions;
	}, {});
	for (const actionName in actions) store[actionName] = function() {
		const _actionId = runningActionId;
		const trackedStore = wrapWithProxy ? new Proxy(store, {
			get(...args) {
				activeAction = _actionId;
				return Reflect.get(...args);
			},
			set(...args) {
				activeAction = _actionId;
				return Reflect.set(...args);
			}
		}) : store;
		activeAction = _actionId;
		const retValue = actions[actionName].apply(trackedStore, arguments);
		activeAction = void 0;
		return retValue;
	};
}
function devtoolsPlugin({ app, store, options }) {
	if (store.$id.startsWith("__hot:")) return;
	store._isOptionsAPI = !!options.state;
	if (!store._p._testing) {
		patchActionForGrouping(store, Object.keys(options.actions), store._isOptionsAPI);
		const originalHotUpdate = store._hotUpdate;
		(0, lib_exports.toRaw)(store)._hotUpdate = function(newStore) {
			originalHotUpdate.apply(this, arguments);
			patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions), !!store._isOptionsAPI);
		};
	}
	addStoreToDevtools(app, store);
}
function createPinia() {
	const scope = (0, lib_exports.effectScope)(true);
	const state = scope.run(() => (0, lib_exports.ref)({}));
	let _p = [];
	let toBeInstalled = [];
	const pinia = (0, lib_exports.markRaw)({
		install(app) {
			setActivePinia(pinia);
			pinia._a = app;
			app.provide(piniaSymbol, pinia);
			app.config.globalProperties.$pinia = pinia;
			/* istanbul ignore else */
			if ((process$1.env.NODE_ENV !== "production" || false) && !(process$1.env.NODE_ENV === "test") && IS_CLIENT) registerPiniaDevtools(app, pinia);
			toBeInstalled.forEach((plugin) => _p.push(plugin));
			toBeInstalled = [];
		},
		use(plugin) {
			if (!this._a && true) toBeInstalled.push(plugin);
			else _p.push(plugin);
			return this;
		},
		_p,
		_a: null,
		_e: scope,
		_s: /* @__PURE__ */ new Map(),
		state
	});
	if ((process$1.env.NODE_ENV !== "production" || false) && !(process$1.env.NODE_ENV === "test") && IS_CLIENT && typeof Proxy !== "undefined") pinia.use(devtoolsPlugin);
	return pinia;
}
function patchObject(newState, oldState) {
	for (const key in oldState) {
		const subPatch = oldState[key];
		if (!(key in newState)) continue;
		const targetValue = newState[key];
		if (isPlainObject(targetValue) && isPlainObject(subPatch) && !(0, lib_exports.isRef)(subPatch) && !(0, lib_exports.isReactive)(subPatch)) newState[key] = patchObject(targetValue, subPatch);
		else newState[key] = subPatch;
	}
	return newState;
}
var noop = () => {};
function addSubscription(subscriptions, callback, detached, onCleanup = noop) {
	subscriptions.push(callback);
	const removeSubscription = () => {
		const idx = subscriptions.indexOf(callback);
		if (idx > -1) {
			subscriptions.splice(idx, 1);
			onCleanup();
		}
	};
	if (!detached && (0, lib_exports.getCurrentScope)()) (0, lib_exports.onScopeDispose)(removeSubscription);
	return removeSubscription;
}
function triggerSubscriptions(subscriptions, ...args) {
	subscriptions.slice().forEach((callback) => {
		callback(...args);
	});
}
var fallbackRunWithContext = (fn) => fn();
var ACTION_MARKER = Symbol();
var ACTION_NAME = Symbol();
function mergeReactiveObjects(target, patchToApply) {
	if (target instanceof Map && patchToApply instanceof Map) patchToApply.forEach((value, key) => target.set(key, value));
	else if (target instanceof Set && patchToApply instanceof Set) patchToApply.forEach(target.add, target);
	for (const key in patchToApply) {
		if (!patchToApply.hasOwnProperty(key)) continue;
		const subPatch = patchToApply[key];
		const targetValue = target[key];
		if (isPlainObject(targetValue) && isPlainObject(subPatch) && target.hasOwnProperty(key) && !(0, lib_exports.isRef)(subPatch) && !(0, lib_exports.isReactive)(subPatch)) target[key] = mergeReactiveObjects(targetValue, subPatch);
		else target[key] = subPatch;
	}
	return target;
}
var skipHydrateSymbol = process$1.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : Symbol();
function shouldHydrate(obj) {
	return !isPlainObject(obj) || !obj.hasOwnProperty(skipHydrateSymbol);
}
var { assign } = Object;
function isComputed(o) {
	return !!((0, lib_exports.isRef)(o) && o.effect);
}
function createOptionsStore(id, options, pinia, hot) {
	const { state, actions, getters } = options;
	const initialState = pinia.state.value[id];
	let store;
	function setup() {
		if (!initialState && (!(process$1.env.NODE_ENV !== "production") || !hot)) pinia.state.value[id] = state ? state() : {};
		const localState = process$1.env.NODE_ENV !== "production" && hot ? (0, lib_exports.toRefs)((0, lib_exports.ref)(state ? state() : {}).value) : (0, lib_exports.toRefs)(pinia.state.value[id]);
		return assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name) => {
			if (process$1.env.NODE_ENV !== "production" && name in localState) console.warn(`[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${name}" in store "${id}".`);
			computedGetters[name] = (0, lib_exports.markRaw)((0, lib_exports.computed)(() => {
				setActivePinia(pinia);
				const store$1 = pinia._s.get(id);
				return getters[name].call(store$1, store$1);
			}));
			return computedGetters;
		}, {}));
	}
	store = createSetupStore(id, setup, options, pinia, hot, true);
	return store;
}
function createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
	let scope;
	const optionsForPlugin = assign({ actions: {} }, options);
	/* istanbul ignore if */
	if (process$1.env.NODE_ENV !== "production" && !pinia._e.active) throw new Error("Pinia destroyed");
	const $subscribeOptions = { deep: true };
	/* istanbul ignore else */
	if (process$1.env.NODE_ENV !== "production" && true) $subscribeOptions.onTrigger = (event) => {
		/* istanbul ignore else */
		if (isListening) debuggerEvents = event;
		else if (isListening == false && !store._hotUpdating)
 /* istanbul ignore else */
		if (Array.isArray(debuggerEvents)) debuggerEvents.push(event);
		else console.error("🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug.");
	};
	let isListening;
	let isSyncListening;
	let subscriptions = [];
	let actionSubscriptions = [];
	let debuggerEvents;
	const initialState = pinia.state.value[$id];
	if (!isOptionsStore && !initialState && (!(process$1.env.NODE_ENV !== "production") || !hot)) pinia.state.value[$id] = {};
	const hotState = (0, lib_exports.ref)({});
	let activeListener;
	function $patch(partialStateOrMutator) {
		let subscriptionMutation;
		isListening = isSyncListening = false;
		/* istanbul ignore else */
		if (process$1.env.NODE_ENV !== "production") debuggerEvents = [];
		if (typeof partialStateOrMutator === "function") {
			partialStateOrMutator(pinia.state.value[$id]);
			subscriptionMutation = {
				type: MutationType.patchFunction,
				storeId: $id,
				events: debuggerEvents
			};
		} else {
			mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
			subscriptionMutation = {
				type: MutationType.patchObject,
				payload: partialStateOrMutator,
				storeId: $id,
				events: debuggerEvents
			};
		}
		const myListenerId = activeListener = Symbol();
		(0, lib_exports.nextTick)().then(() => {
			if (activeListener === myListenerId) isListening = true;
		});
		isSyncListening = true;
		triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
	}
	const $reset = isOptionsStore ? function $reset$1() {
		const { state } = options;
		const newState = state ? state() : {};
		this.$patch(($state) => {
			assign($state, newState);
		});
	} : process$1.env.NODE_ENV !== "production" ? () => {
		throw new Error(`🍍: Store "${$id}" is built using the setup syntax and does not implement $reset().`);
	} : noop;
	function $dispose() {
		scope.stop();
		subscriptions = [];
		actionSubscriptions = [];
		pinia._s.delete($id);
	}
	const action = (fn, name = "") => {
		if (ACTION_MARKER in fn) {
			fn[ACTION_NAME] = name;
			return fn;
		}
		const wrappedAction = function() {
			setActivePinia(pinia);
			const args = Array.from(arguments);
			const afterCallbackList = [];
			const onErrorCallbackList = [];
			function after(callback) {
				afterCallbackList.push(callback);
			}
			function onError(callback) {
				onErrorCallbackList.push(callback);
			}
			triggerSubscriptions(actionSubscriptions, {
				args,
				name: wrappedAction[ACTION_NAME],
				store,
				after,
				onError
			});
			let ret;
			try {
				ret = fn.apply(this && this.$id === $id ? this : store, args);
			} catch (error) {
				triggerSubscriptions(onErrorCallbackList, error);
				throw error;
			}
			if (ret instanceof Promise) return ret.then((value) => {
				triggerSubscriptions(afterCallbackList, value);
				return value;
			}).catch((error) => {
				triggerSubscriptions(onErrorCallbackList, error);
				return Promise.reject(error);
			});
			triggerSubscriptions(afterCallbackList, ret);
			return ret;
		};
		wrappedAction[ACTION_MARKER] = true;
		wrappedAction[ACTION_NAME] = name;
		return wrappedAction;
	};
	const _hmrPayload = /* @__PURE__ */ (0, lib_exports.markRaw)({
		actions: {},
		getters: {},
		state: [],
		hotState
	});
	const partialStore = {
		_p: pinia,
		$id,
		$onAction: addSubscription.bind(null, actionSubscriptions),
		$patch,
		$reset,
		$subscribe(callback, options$1 = {}) {
			const removeSubscription = addSubscription(subscriptions, callback, options$1.detached, () => stopWatcher());
			const stopWatcher = scope.run(() => (0, lib_exports.watch)(() => pinia.state.value[$id], (state) => {
				if (options$1.flush === "sync" ? isSyncListening : isListening) callback({
					storeId: $id,
					type: MutationType.direct,
					events: debuggerEvents
				}, state);
			}, assign({}, $subscribeOptions, options$1)));
			return removeSubscription;
		},
		$dispose
	};
	const store = (0, lib_exports.reactive)(process$1.env.NODE_ENV !== "production" || (process$1.env.NODE_ENV !== "production" || false) && !(process$1.env.NODE_ENV === "test") && IS_CLIENT ? assign({
		_hmrPayload,
		_customProperties: (0, lib_exports.markRaw)(/* @__PURE__ */ new Set())
	}, partialStore) : partialStore);
	pinia._s.set($id, store);
	const setupStore = (pinia._a && pinia._a.runWithContext || fallbackRunWithContext)(() => pinia._e.run(() => (scope = (0, lib_exports.effectScope)()).run(() => setup({ action }))));
	for (const key in setupStore) {
		const prop = setupStore[key];
		if ((0, lib_exports.isRef)(prop) && !isComputed(prop) || (0, lib_exports.isReactive)(prop)) {
			if (process$1.env.NODE_ENV !== "production" && hot) set(hotState.value, key, (0, lib_exports.toRef)(setupStore, key));
			else if (!isOptionsStore) {
				if (initialState && shouldHydrate(prop)) if ((0, lib_exports.isRef)(prop)) prop.value = initialState[key];
				else mergeReactiveObjects(prop, initialState[key]);
				pinia.state.value[$id][key] = prop;
			}
			/* istanbul ignore else */
			if (process$1.env.NODE_ENV !== "production") _hmrPayload.state.push(key);
		} else if (typeof prop === "function") {
			setupStore[key] = process$1.env.NODE_ENV !== "production" && hot ? prop : action(prop, key);
			/* istanbul ignore else */
			if (process$1.env.NODE_ENV !== "production") _hmrPayload.actions[key] = prop;
			optionsForPlugin.actions[key] = prop;
		} else if (process$1.env.NODE_ENV !== "production") {
			if (isComputed(prop)) {
				_hmrPayload.getters[key] = isOptionsStore ? options.getters[key] : prop;
				if (IS_CLIENT) (setupStore._getters || (setupStore._getters = (0, lib_exports.markRaw)([]))).push(key);
			}
		}
	}
	assign(store, setupStore);
	assign((0, lib_exports.toRaw)(store), setupStore);
	Object.defineProperty(store, "$state", {
		get: () => process$1.env.NODE_ENV !== "production" && hot ? hotState.value : pinia.state.value[$id],
		set: (state) => {
			/* istanbul ignore if */
			if (process$1.env.NODE_ENV !== "production" && hot) throw new Error("cannot set hotState");
			$patch(($state) => {
				assign($state, state);
			});
		}
	});
	/* istanbul ignore else */
	if (process$1.env.NODE_ENV !== "production") store._hotUpdate = (0, lib_exports.markRaw)((newStore) => {
		store._hotUpdating = true;
		newStore._hmrPayload.state.forEach((stateKey) => {
			if (stateKey in store.$state) {
				const newStateTarget = newStore.$state[stateKey];
				const oldStateSource = store.$state[stateKey];
				if (typeof newStateTarget === "object" && isPlainObject(newStateTarget) && isPlainObject(oldStateSource)) patchObject(newStateTarget, oldStateSource);
				else newStore.$state[stateKey] = oldStateSource;
			}
			set(store, stateKey, (0, lib_exports.toRef)(newStore.$state, stateKey));
		});
		Object.keys(store.$state).forEach((stateKey) => {
			if (!(stateKey in newStore.$state)) del(store, stateKey);
		});
		isListening = false;
		isSyncListening = false;
		pinia.state.value[$id] = (0, lib_exports.toRef)(newStore._hmrPayload, "hotState");
		isSyncListening = true;
		(0, lib_exports.nextTick)().then(() => {
			isListening = true;
		});
		for (const actionName in newStore._hmrPayload.actions) {
			const actionFn = newStore[actionName];
			set(store, actionName, action(actionFn, actionName));
		}
		for (const getterName in newStore._hmrPayload.getters) {
			const getter = newStore._hmrPayload.getters[getterName];
			set(store, getterName, isOptionsStore ? (0, lib_exports.computed)(() => {
				setActivePinia(pinia);
				return getter.call(store, store);
			}) : getter);
		}
		Object.keys(store._hmrPayload.getters).forEach((key) => {
			if (!(key in newStore._hmrPayload.getters)) del(store, key);
		});
		Object.keys(store._hmrPayload.actions).forEach((key) => {
			if (!(key in newStore._hmrPayload.actions)) del(store, key);
		});
		store._hmrPayload = newStore._hmrPayload;
		store._getters = newStore._getters;
		store._hotUpdating = false;
	});
	if ((process$1.env.NODE_ENV !== "production" || false) && !(process$1.env.NODE_ENV === "test") && IS_CLIENT) {
		const nonEnumerable = {
			writable: true,
			configurable: true,
			enumerable: false
		};
		[
			"_p",
			"_hmrPayload",
			"_getters",
			"_customProperties"
		].forEach((p) => {
			Object.defineProperty(store, p, assign({ value: store[p] }, nonEnumerable));
		});
	}
	pinia._p.forEach((extender) => {
		/* istanbul ignore else */
		if ((process$1.env.NODE_ENV !== "production" || false) && !(process$1.env.NODE_ENV === "test") && IS_CLIENT) {
			const extensions = scope.run(() => extender({
				store,
				app: pinia._a,
				pinia,
				options: optionsForPlugin
			}));
			Object.keys(extensions || {}).forEach((key) => store._customProperties.add(key));
			assign(store, extensions);
		} else assign(store, scope.run(() => extender({
			store,
			app: pinia._a,
			pinia,
			options: optionsForPlugin
		})));
	});
	if (process$1.env.NODE_ENV !== "production" && store.$state && typeof store.$state === "object" && typeof store.$state.constructor === "function" && !store.$state.constructor.toString().includes("[native code]")) console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${store.$id}".`);
	if (initialState && isOptionsStore && options.hydrate) options.hydrate(store.$state, initialState);
	isListening = true;
	isSyncListening = true;
	return store;
}
function defineStore(idOrOptions, setup, setupOptions) {
	let id;
	let options;
	const isSetupStore = typeof setup === "function";
	if (typeof idOrOptions === "string") {
		id = idOrOptions;
		options = isSetupStore ? setupOptions : setup;
	} else {
		options = idOrOptions;
		id = idOrOptions.id;
		if (process$1.env.NODE_ENV !== "production" && typeof id !== "string") throw new Error(`[🍍]: "defineStore()" must be passed a store id as its first argument.`);
	}
	function useStore(pinia, hot) {
		const hasContext = (0, lib_exports.hasInjectionContext)();
		pinia = (process$1.env.NODE_ENV === "test" && activePinia && activePinia._testing ? null : pinia) || (hasContext ? (0, lib_exports.inject)(piniaSymbol, null) : null);
		if (pinia) setActivePinia(pinia);
		if (process$1.env.NODE_ENV !== "production" && !activePinia) throw new Error("[🍍]: \"getActivePinia()\" was called but there was no active Pinia. Are you trying to use a store before calling \"app.use(pinia)\"?\nSee https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.\nThis will fail in production.");
		pinia = activePinia;
		if (!pinia._s.has(id)) {
			if (isSetupStore) createSetupStore(id, setup, options, pinia);
			else createOptionsStore(id, options, pinia);
			/* istanbul ignore else */
			if (process$1.env.NODE_ENV !== "production") useStore._pinia = pinia;
		}
		const store = pinia._s.get(id);
		if (process$1.env.NODE_ENV !== "production" && hot) {
			const hotId = "__hot:" + id;
			const newStore = isSetupStore ? createSetupStore(hotId, setup, options, pinia, true) : createOptionsStore(hotId, assign({}, options), pinia, true);
			hot._hotUpdate(newStore);
			delete pinia.state.value[hotId];
			pinia._s.delete(hotId);
		}
		if (process$1.env.NODE_ENV !== "production" && IS_CLIENT) {
			const currentInstance = (0, lib_exports.getCurrentInstance)();
			if (currentInstance && currentInstance.proxy && !hot) {
				const vm = currentInstance.proxy;
				const cache = "_pStores" in vm ? vm._pStores : vm._pStores = {};
				cache[id] = store;
			}
		}
		return store;
	}
	useStore.$id = id;
	return useStore;
}
function storeToRefs(store) {
	{
		const rawStore = (0, lib_exports.toRaw)(store);
		const refs = {};
		for (const key in rawStore) {
			const value = rawStore[key];
			if (value.effect) refs[key] = (0, lib_exports.computed)({
				get: () => store[key],
				set(value$1) {
					store[key] = value$1;
				}
			});
			else if ((0, lib_exports.isRef)(value) || (0, lib_exports.isReactive)(value)) refs[key] = (0, lib_exports.toRef)(store, key);
		}
		return refs;
	}
}
const extractBrowserFile = (input) => {
	if (!input) return null;
	if (typeof File === "function" && input instanceof File) return input;
	if (typeof Blob === "function" && input instanceof Blob) {
		if (typeof File === "function") {
			const name = input.name || "document";
			return new File([input], name, { type: input.type });
		}
		return input;
	}
	if (input.originFileObj) return extractBrowserFile(input.originFileObj);
	if (input.file) return extractBrowserFile(input.file);
	if (input.raw) return extractBrowserFile(input.raw);
	return null;
};
var inferTypeFromName = (name = "") => {
	const lower = String(name).toLowerCase();
	if (lower.endsWith(".docx")) return DOCX;
	if (lower.endsWith(".pdf")) return PDF;
	if (lower.endsWith(".html") || lower.endsWith(".htm")) return HTML;
	if (lower.endsWith(".md") || lower.endsWith(".markdown")) return "text/markdown";
	return "";
};
const normalizeDocumentEntry = (entry) => {
	const maybeFile = extractBrowserFile(entry);
	if (maybeFile) {
		const name = maybeFile.name || entry && entry.name || "document";
		return {
			type: maybeFile.type || inferTypeFromName(name) || "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
			data: maybeFile,
			name
		};
	}
	if (entry && typeof entry === "object" && "data" in entry) {
		const file = extractBrowserFile(entry.data);
		if (file) {
			const type = entry.type || file.type || inferTypeFromName(file.name) || "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
			return {
				...entry,
				type,
				data: file,
				name: entry.name || file.name || "document"
			};
		}
	}
	return entry;
};
function useFieldValueWatcher(field, originalValue) {
	const fieldId = field.itemid;
	const rawField = field;
	const value = originalValue !== null && typeof originalValue === "object" ? reactive({ ...originalValue }) : ref(originalValue);
	const change = ref(null);
	const handleChange = (newValue, oldValue) => {
		change.value = {
			fieldId: fieldId.value,
			changeTime: Date.now(),
			oldValue,
			newValue,
			originalField: rawField
		};
	};
	watch(value, handleChange);
	return { value };
}
function useField(field) {
	const id = ref(field.itemid);
	const icon = ref(field.itemicon);
	const iconPack = ref(field.itemiconpack);
	const label = ref(field.itemdisplaylabel);
	const originalValue = field.itemlinkvalue;
	const placeholder = field.itemplaceholdertext;
	const { value } = useFieldValueWatcher(field, originalValue, ref([]));
	const fieldType = ref(field.itemtype);
	const fieldSubType = ref(field.itemfieldtype);
	const originalJSON = field;
	const fieldStyle = reactive({
		fontFamily: field.fontfamily || "Arial",
		fontSize: field.font_size || "12pt",
		originalFontSize: field.original_font_size || "12pt"
	});
	const logicRules = ref(field.logicrules);
	const hidden = ref(false);
	const additionalOptions = reactive({});
	const fieldHandlers = {
		SELECT: useSelectField,
		IMAGEINPUT: useImageField,
		CHECKBOXINPUT: useCheckboxField
	};
	if (fieldType.value in fieldHandlers) Object.assign(additionalOptions, fieldHandlers[fieldType.value](field));
	return {
		id,
		icon,
		iconPack,
		label,
		placeholder,
		fieldType,
		fieldSubType,
		value,
		format: ref(field.itemformat),
		logicRules,
		hidden,
		originalJSON,
		fieldStyle,
		valueGetter: field.valueGetter,
		...additionalOptions
	};
}
function useImageField(field) {
	return {
		fontfamily: ref(field.fontfamily),
		iteminputtype: ref(field.iteminputtype)
	};
}
function useSelectField(field) {
	return { options: ref(field.itemoptions) };
}
function useCheckboxField(field) {
	const options = ref(field.itemoptions);
	if (options.value) options.value = options.value.map((option) => {
		return {
			label: option.itemdisplaylabel,
			value: option.itemlinkvalue,
			checked: option.ischecked,
			id: option.itemid,
			annotationId: option.annotationId
		};
	});
	return { options };
}
var channels = /* @__PURE__ */ new Map();
/* c8 ignore start */
var LocalStoragePolyfill = class {
	constructor(room) {
		this.room = room;
		this.onmessage = null;
		this._onChange = (e) => e.key === room && this.onmessage !== null && this.onmessage({ data: fromBase64(e.newValue || "") });
		onChange(this._onChange);
	}
	postMessage(buf) {
		varStorage.setItem(this.room, toBase64(createUint8ArrayFromArrayBuffer(buf)));
	}
	close() {
		offChange(this._onChange);
	}
};
/* c8 ignore stop */
/* c8 ignore next */
var BC = typeof BroadcastChannel === "undefined" ? LocalStoragePolyfill : BroadcastChannel;
var getChannel = (room) => setIfUndefined(channels, room, () => {
	const subs = create();
	const bc = new BC(room);
	/* c8 ignore next */
	bc.onmessage = (e) => subs.forEach((sub) => sub(e.data, "broadcastchannel"));
	return {
		bc,
		subs
	};
});
const subscribe = (room, f) => {
	getChannel(room).subs.add(f);
	return f;
};
const unsubscribe = (room, f) => {
	const channel = getChannel(room);
	const unsubscribed = channel.subs.delete(f);
	if (unsubscribed && channel.subs.size === 0) {
		channel.bc.close();
		channels.delete(room);
	}
	return unsubscribed;
};
const publish = (room, data, origin = null) => {
	const c = getChannel(room);
	c.bc.postMessage(data);
	c.subs.forEach((sub) => sub(data, origin));
};
const writeSyncStep1 = (encoder, doc) => {
	writeVarUint(encoder, 0);
	writeVarUint8Array(encoder, Y.encodeStateVector(doc));
};
const writeSyncStep2 = (encoder, doc, encodedStateVector) => {
	writeVarUint(encoder, 1);
	writeVarUint8Array(encoder, Y.encodeStateAsUpdate(doc, encodedStateVector));
};
const readSyncStep1 = (decoder, encoder, doc) => writeSyncStep2(encoder, doc, readVarUint8Array(decoder));
const readSyncStep2 = (decoder, doc, transactionOrigin, errorHandler) => {
	try {
		Y.applyUpdate(doc, readVarUint8Array(decoder), transactionOrigin);
	} catch (error) {
		if (errorHandler != null) errorHandler(error);
		console.error("Caught error while handling a Yjs update", error);
	}
};
const writeUpdate = (encoder, update) => {
	writeVarUint(encoder, 2);
	writeVarUint8Array(encoder, update);
};
const readUpdate = readSyncStep2;
const readSyncMessage = (decoder, encoder, doc, transactionOrigin, errorHandler) => {
	const messageType = readVarUint(decoder);
	switch (messageType) {
		case 0:
			readSyncStep1(decoder, encoder, doc);
			break;
		case 1:
			readSyncStep2(decoder, doc, transactionOrigin, errorHandler);
			break;
		case 2:
			readUpdate(decoder, doc, transactionOrigin, errorHandler);
			break;
		default: throw new Error("Unknown message type");
	}
	return messageType;
};
const readAuthMessage = (decoder, y, permissionDeniedHandler$1) => {
	switch (readVarUint(decoder)) {
		case 0: permissionDeniedHandler$1(y, readVarString(decoder));
	}
};
const encodeQueryParams = (params) => map(params, (val, key) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join("&");
init_dist$1();
var messageHandlers = [];
messageHandlers[0] = (encoder, decoder, provider, emitSynced, _messageType) => {
	writeVarUint(encoder, 0);
	const syncMessageType = readSyncMessage(decoder, encoder, provider.doc, provider);
	if (emitSynced && syncMessageType === 1 && !provider.synced) provider.synced = true;
};
messageHandlers[3] = (encoder, _decoder, provider, _emitSynced, _messageType) => {
	writeVarUint(encoder, 1);
	writeVarUint8Array(encoder, encodeAwarenessUpdate(provider.awareness, Array.from(provider.awareness.getStates().keys())));
};
messageHandlers[1] = (_encoder, decoder, provider, _emitSynced, _messageType) => {
	applyAwarenessUpdate(provider.awareness, readVarUint8Array(decoder), provider);
};
messageHandlers[2] = (_encoder, decoder, provider, _emitSynced, _messageType) => {
	readAuthMessage(decoder, provider.doc, (_ydoc, reason) => permissionDeniedHandler(provider, reason));
};
var messageReconnectTimeout = 3e4;
var permissionDeniedHandler = (provider, reason) => console.warn(`Permission denied to access ${provider.url}.\n${reason}`);
var readMessage = (provider, buf, emitSynced) => {
	const decoder = createDecoder(buf);
	const encoder = createEncoder();
	const messageType = readVarUint(decoder);
	const messageHandler = provider.messageHandlers[messageType];
	if (messageHandler) messageHandler(encoder, decoder, provider, emitSynced, messageType);
	else console.error("Unable to compute message");
	return encoder;
};
var closeWebsocketConnection = (provider, ws, event) => {
	if (ws === provider.ws) {
		provider.emit("connection-close", [event, provider]);
		provider.ws = null;
		ws.close();
		provider.wsconnecting = false;
		if (provider.wsconnected) {
			provider.wsconnected = false;
			provider.synced = false;
			removeAwarenessStates(provider.awareness, Array.from(provider.awareness.getStates().keys()).filter((client) => client !== provider.doc.clientID), provider);
			provider.emit("status", [{ status: "disconnected" }]);
		} else provider.wsUnsuccessfulReconnects++;
		setTimeout(setupWS, min(pow(2, provider.wsUnsuccessfulReconnects) * 100, provider.maxBackoffTime), provider);
	}
};
var setupWS = (provider) => {
	if (provider.shouldConnect && provider.ws === null) {
		const websocket = new provider._WS(provider.url, provider.protocols);
		websocket.binaryType = "arraybuffer";
		provider.ws = websocket;
		provider.wsconnecting = true;
		provider.wsconnected = false;
		provider.synced = false;
		websocket.onmessage = (event) => {
			provider.wsLastMessageReceived = getUnixTime();
			const encoder = readMessage(provider, new Uint8Array(event.data), true);
			if (length(encoder) > 1) websocket.send(toUint8Array(encoder));
		};
		websocket.onerror = (event) => {
			provider.emit("connection-error", [event, provider]);
		};
		websocket.onclose = (event) => {
			closeWebsocketConnection(provider, websocket, event);
		};
		websocket.onopen = () => {
			provider.wsLastMessageReceived = getUnixTime();
			provider.wsconnecting = false;
			provider.wsconnected = true;
			provider.wsUnsuccessfulReconnects = 0;
			provider.emit("status", [{ status: "connected" }]);
			const encoder = createEncoder();
			writeVarUint(encoder, 0);
			writeSyncStep1(encoder, provider.doc);
			websocket.send(toUint8Array(encoder));
			if (provider.awareness.getLocalState() !== null) {
				const encoderAwarenessState = createEncoder();
				writeVarUint(encoderAwarenessState, 1);
				writeVarUint8Array(encoderAwarenessState, encodeAwarenessUpdate(provider.awareness, [provider.doc.clientID]));
				websocket.send(toUint8Array(encoderAwarenessState));
			}
		};
		provider.emit("status", [{ status: "connecting" }]);
	}
};
var broadcastMessage = (provider, buf) => {
	const ws = provider.ws;
	if (provider.wsconnected && ws && ws.readyState === ws.OPEN) ws.send(buf);
	if (provider.bcconnected) publish(provider.bcChannel, buf, provider);
};
var WebsocketProvider = class extends ObservableV2 {
	constructor(serverUrl, roomname, doc, { connect = true, awareness = new Awareness(doc), params = {}, protocols = [], WebSocketPolyfill = WebSocket, resyncInterval = -1, maxBackoffTime = 2500, disableBc = false } = {}) {
		super();
		while (serverUrl[serverUrl.length - 1] === "/") serverUrl = serverUrl.slice(0, serverUrl.length - 1);
		this.serverUrl = serverUrl;
		this.bcChannel = serverUrl + "/" + roomname;
		this.maxBackoffTime = maxBackoffTime;
		this.params = params;
		this.protocols = protocols;
		this.roomname = roomname;
		this.doc = doc;
		this._WS = WebSocketPolyfill;
		this.awareness = awareness;
		this.wsconnected = false;
		this.wsconnecting = false;
		this.bcconnected = false;
		this.disableBc = disableBc;
		this.wsUnsuccessfulReconnects = 0;
		this.messageHandlers = messageHandlers.slice();
		this._synced = false;
		this.ws = null;
		this.wsLastMessageReceived = 0;
		this.shouldConnect = connect;
		this._resyncInterval = 0;
		if (resyncInterval > 0) this._resyncInterval = setInterval(() => {
			if (this.ws && this.ws.readyState === WebSocket.OPEN) {
				const encoder = createEncoder();
				writeVarUint(encoder, 0);
				writeSyncStep1(encoder, doc);
				this.ws.send(toUint8Array(encoder));
			}
		}, resyncInterval);
		this._bcSubscriber = (data, origin) => {
			if (origin !== this) {
				const encoder = readMessage(this, new Uint8Array(data), false);
				if (length(encoder) > 1) publish(this.bcChannel, toUint8Array(encoder), this);
			}
		};
		this._updateHandler = (update, origin) => {
			if (origin !== this) {
				const encoder = createEncoder();
				writeVarUint(encoder, 0);
				writeUpdate(encoder, update);
				broadcastMessage(this, toUint8Array(encoder));
			}
		};
		this.doc.on("update", this._updateHandler);
		this._awarenessUpdateHandler = ({ added, updated, removed }, _origin) => {
			const changedClients = added.concat(updated).concat(removed);
			const encoder = createEncoder();
			writeVarUint(encoder, 1);
			writeVarUint8Array(encoder, encodeAwarenessUpdate(awareness, changedClients));
			broadcastMessage(this, toUint8Array(encoder));
		};
		this._exitHandler = () => {
			removeAwarenessStates(this.awareness, [doc.clientID], "app closed");
		};
		if (isNode && typeof process$1 !== "undefined") process$1.on("exit", this._exitHandler);
		awareness.on("update", this._awarenessUpdateHandler);
		this._checkInterval = setInterval(() => {
			if (this.wsconnected && messageReconnectTimeout < getUnixTime() - this.wsLastMessageReceived) closeWebsocketConnection(this, this.ws, null);
		}, messageReconnectTimeout / 10);
		if (connect) this.connect();
	}
	get url() {
		const encodedParams = encodeQueryParams(this.params);
		return this.serverUrl + "/" + this.roomname + (encodedParams.length === 0 ? "" : "?" + encodedParams);
	}
	get synced() {
		return this._synced;
	}
	set synced(state) {
		if (this._synced !== state) {
			this._synced = state;
			this.emit("synced", [state]);
			this.emit("sync", [state]);
		}
	}
	destroy() {
		if (this._resyncInterval !== 0) clearInterval(this._resyncInterval);
		clearInterval(this._checkInterval);
		this.disconnect();
		if (isNode && typeof process$1 !== "undefined") process$1.off("exit", this._exitHandler);
		this.awareness.off("update", this._awarenessUpdateHandler);
		this.doc.off("update", this._updateHandler);
		super.destroy();
	}
	connectBc() {
		if (this.disableBc) return;
		if (!this.bcconnected) {
			subscribe(this.bcChannel, this._bcSubscriber);
			this.bcconnected = true;
		}
		const encoderSync = createEncoder();
		writeVarUint(encoderSync, 0);
		writeSyncStep1(encoderSync, this.doc);
		publish(this.bcChannel, toUint8Array(encoderSync), this);
		const encoderState = createEncoder();
		writeVarUint(encoderState, 0);
		writeSyncStep2(encoderState, this.doc);
		publish(this.bcChannel, toUint8Array(encoderState), this);
		const encoderAwarenessQuery = createEncoder();
		writeVarUint(encoderAwarenessQuery, 3);
		publish(this.bcChannel, toUint8Array(encoderAwarenessQuery), this);
		const encoderAwarenessState = createEncoder();
		writeVarUint(encoderAwarenessState, 1);
		writeVarUint8Array(encoderAwarenessState, encodeAwarenessUpdate(this.awareness, [this.doc.clientID]));
		publish(this.bcChannel, toUint8Array(encoderAwarenessState), this);
	}
	disconnectBc() {
		const encoder = createEncoder();
		writeVarUint(encoder, 1);
		writeVarUint8Array(encoder, encodeAwarenessUpdate(this.awareness, [this.doc.clientID], /* @__PURE__ */ new Map()));
		broadcastMessage(this, toUint8Array(encoder));
		if (this.bcconnected) {
			unsubscribe(this.bcChannel, this._bcSubscriber);
			this.bcconnected = false;
		}
	}
	disconnect() {
		this.shouldConnect = false;
		this.disconnectBc();
		if (this.ws !== null) closeWebsocketConnection(this, this.ws, null);
	}
	connect() {
		this.shouldConnect = true;
		if (!this.wsconnected && this.ws === null) {
			setupWS(this);
			this.connectBc();
		}
	}
};
function awarenessHandler(context, { changes = {}, states }) {
	const { added = [], removed = [] } = changes;
	const payload = {
		states: awarenessStatesToArray(context, states),
		added,
		removed,
		superdoc: context
	};
	context.emit("awareness-update", payload);
}
function createProvider({ config, user, documentId, socket, superdocInstance }) {
	console.warn("[superdoc] Internal provider creation is deprecated. Pass { ydoc, provider } to modules.collaboration instead.");
	if (!config.providerType) config.providerType = "superdoc";
	const providers = {
		hocuspocus: () => createHocuspocusProvider({
			config,
			user,
			documentId,
			socket,
			superdocInstance
		}),
		superdoc: () => createSuperDocProvider({
			config,
			user,
			documentId,
			socket,
			superdocInstance
		})
	};
	if (!providers) throw new Error(`Provider type ${config.providerType} is not supported.`);
	return providers[config.providerType]();
}
function createSuperDocProvider({ config, user, documentId, superdocInstance }) {
	const ydoc = new Doc({ gc: false });
	const options = { params: { ...config.params } };
	const provider = new WebsocketProvider(config.url, documentId, ydoc, options);
	provider.awareness.setLocalStateField("user", user);
	provider.awareness.on("update", (changes = {}) => {
		return awarenessHandler(superdocInstance, {
			changes,
			states: provider.awareness.getStates()
		});
	});
	return {
		provider,
		ydoc
	};
}
function createHocuspocusProvider({ config, user, documentId, socket, superdocInstance }) {
	const ydoc = new Doc({ gc: false });
	const provider = new HocuspocusProvider({
		websocketProvider: socket,
		document: ydoc,
		name: documentId,
		token: config.token || "",
		preserveConnection: false,
		onAuthenticationFailed: () => onAuthenticationFailed(documentId),
		onConnect: () => onConnect(superdocInstance, documentId),
		onDisconnect: () => onDisconnect(superdocInstance, documentId),
		onDestroy: () => onDestroy(superdocInstance, documentId)
	});
	provider.setAwarenessField("user", user);
	provider.on("awarenessUpdate", (params) => {
		return awarenessHandler(superdocInstance, { states: params.states });
	});
	return {
		provider,
		ydoc
	};
}
var onAuthenticationFailed = (data, documentId) => {
	console.warn("🔒 [superdoc] Authentication failed", data, "document", documentId);
};
var onConnect = (superdocInstance, documentId) => {
	console.warn("🔌 [superdoc] Connected -- ", documentId);
};
var onDisconnect = (superdocInstance, documentId) => {
	console.warn("🔌 [superdoc] Disconnected", documentId);
};
var onDestroy = (superdocInstance, documentId) => {
	console.warn("🔌 [superdoc] Destroyed", documentId);
};
function setupAwarenessHandler(provider, superdocInstance, user) {
	const awareness = provider.awareness;
	if (!awareness) {
		console.warn("[superdoc] External provider missing awareness property");
		return () => {};
	}
	if (user && awareness.setLocalStateField) awareness.setLocalStateField("user", user);
	const handler = (changes = {}) => {
		awarenessHandler(superdocInstance, {
			changes,
			states: awareness.getStates()
		});
	};
	awareness.on("change", handler);
	return () => {
		if (typeof awareness.off === "function") awareness.off("change", handler);
	};
}
const addYComment = (yArray, ydoc, event, user) => {
	const { comment } = event;
	const yComment = new Map$1(Object.entries(comment));
	ydoc.transact(() => {
		yArray.push([yComment]);
	}, { user });
};
const updateYComment = (yArray, ydoc, event, user) => {
	const { comment } = event;
	const yComment = new Map$1(Object.entries(comment));
	const commentIndex = getCommentIndex(yArray, comment);
	if (commentIndex === -1) return;
	ydoc.transact(() => {
		yArray.delete(commentIndex, 1);
		yArray.insert(commentIndex, [yComment]);
	}, { user });
};
const deleteYComment = (yArray, ydoc, event, user) => {
	const { comment } = event;
	const commentIndex = getCommentIndex(yArray, comment);
	if (commentIndex === -1) return;
	ydoc.transact(() => {
		yArray.delete(commentIndex, 1);
	}, { user });
};
const getCommentIndex = (yArray, comment) => {
	return yArray.toJSON().findIndex((c) => c.commentId === comment.commentId);
};
const loadCommentsFromYdoc = (superdoc) => {
	if (!superdoc?.ydoc || !superdoc?.commentsStore) return false;
	const comments = superdoc.ydoc.getArray("comments").toJSON();
	const seenCommentIdByKey = /* @__PURE__ */ new Map();
	const filtered = [];
	comments.forEach((c) => {
		const key = c?.importedId ?? c?.commentId;
		if (!key) return;
		if (seenCommentIdByKey.has(key)) {
			const existingCommentId = seenCommentIdByKey.get(key);
			const currentCommentId = c?.commentId;
			if (existingCommentId && currentCommentId && existingCommentId !== currentCommentId) console.warn(`[SuperDoc] Duplicate collaboration comment key "${key}" detected with conflicting commentId values. Keeping first entry and dropping duplicate.`, {
				key,
				keptCommentId: existingCommentId,
				droppedCommentId: currentCommentId
			});
			return;
		}
		seenCommentIdByKey.set(key, c?.commentId);
		if (!c?.commentId) {
			filtered.push({
				...c,
				commentId: key
			});
			return;
		}
		filtered.push(c);
	});
	superdoc.commentsStore.commentsList = filtered.map((c) => useComment(c));
	if (superdoc.provider?.synced) superdoc.commentsStore.hasSyncedCollaborationComments = true;
	return true;
};
const initCollaborationComments = (superdoc) => {
	if (!superdoc.config.modules.comments || !superdoc.provider) return;
	if (superdoc._commentsCollabInitialized) {
		loadCommentsFromYdoc(superdoc);
		return;
	}
	superdoc._commentsCollabInitialized = true;
	const commentsArray = superdoc.ydoc.getArray("comments");
	const updateCommentsStore = () => loadCommentsFromYdoc(superdoc);
	const onSuperDocYdocSynced = () => {
		if (!updateCommentsStore()) setTimeout(updateCommentsStore, 0);
		if (superdoc.commentsStore) {
			const parent = superdoc.commentsStore.commentsParentElement;
			const ids = superdoc.commentsStore.editorCommentIds;
			superdoc.commentsStore.handleEditorLocationsUpdate(parent, ids);
			superdoc.commentsStore.hasSyncedCollaborationComments = true;
		}
		superdoc.provider.off("synced", onSuperDocYdocSynced);
	};
	superdoc.provider.on("synced", onSuperDocYdocSynced);
	if (!updateCommentsStore()) setTimeout(updateCommentsStore, 0);
	commentsArray.observe((event) => {
		if (!superdoc.commentsStore) return;
		const currentUser = superdoc.config.user;
		const { user = {} } = event?.transaction?.origin || {};
		if (actorIdentitiesMatch({
			current: currentUser,
			other: user
		})) return;
		updateCommentsStore();
	});
};
const initSuperdocYdoc = (superdoc) => {
	const { isInternal } = superdoc.config;
	const baseName = `${superdoc.config.superdocId}-superdoc`;
	if (!superdoc.config.superdocId) return;
	const documentId = isInternal ? baseName : `${baseName}-external`;
	const { provider: superdocProvider, ydoc: superdocYdoc } = createProvider({
		config: superdoc.config.modules.collaboration,
		user: superdoc.config.user,
		documentId,
		socket: superdoc.config.socket,
		superdocInstance: superdoc
	});
	return {
		ydoc: superdocYdoc,
		provider: superdocProvider
	};
};
const makeDocumentsCollaborative = (superdoc) => {
	const processedDocuments = [];
	superdoc.config.documents.forEach((doc) => {
		superdoc.config.user.color = superdoc.colors[0];
		const { provider, ydoc } = createProvider({
			config: superdoc.config.modules.collaboration,
			user: superdoc.config.user,
			documentId: doc.id,
			socket: superdoc.config.socket,
			superdocInstance: superdoc
		});
		doc.provider = provider;
		doc.socket = superdoc.config.socket;
		doc.ydoc = ydoc;
		doc.role = superdoc.config.role;
		processedDocuments.push(doc);
	});
	return processedDocuments;
};
const syncCommentsToClients = (superdoc, event) => {
	if (!superdoc.isCollaborative || !superdoc.config.modules.comments) return;
	const yArray = superdoc.ydoc.getArray("comments");
	const user = superdoc.config.user;
	switch (event.type) {
		case "add":
			addYComment(yArray, superdoc.ydoc, event, user);
			break;
		case "update":
			updateYComment(yArray, superdoc.ydoc, event, user);
			break;
		case "resolved":
			updateYComment(yArray, superdoc.ydoc, event, user);
			break;
		case "deleted":
			deleteYComment(yArray, superdoc.ydoc, event, user);
			break;
	}
};
function useSelection(params) {
	const documentId = ref(params.documentId);
	const page = ref(params.page);
	const selectionBounds = reactive(params.selectionBounds || {});
	const source = ref(params.source);
	const getContainerId = () => `${documentId.value}-page-${page.value}`;
	const getContainerLocation = (parentContainer) => {
		if (!parentContainer) return {
			top: 0,
			left: 0
		};
		const parentBounds = parentContainer.getBoundingClientRect();
		const container = document.getElementById(getContainerId());
		let containerBounds = {
			top: 0,
			left: 0
		};
		if (container) containerBounds = container.getBoundingClientRect();
		return {
			top: Number((containerBounds.top - parentBounds.top).toFixed(3)),
			left: Number((containerBounds.left - parentBounds.left).toFixed(3))
		};
	};
	const getValues = () => {
		return {
			documentId: documentId.value,
			page: page.value,
			selectionBounds: toRaw(selectionBounds),
			source: source.value
		};
	};
	return {
		documentId,
		page,
		selectionBounds,
		source,
		getValues,
		getContainerId,
		getContainerLocation
	};
}
var getCommentIds = (comment) => [comment?.commentId, comment?.importedId].filter((id) => id != null).map((id) => String(id));
function getThreadDescendants(superdoc, rootComment) {
	const store = superdoc?.commentsStore;
	if (!store) return [];
	const raw = store.commentsList;
	const list = Array.isArray(raw) ? raw : raw?.value ?? [];
	const threadIds = new Set(getCommentIds(rootComment));
	const descendants = [];
	let expanded = true;
	while (expanded) {
		expanded = false;
		for (const comment of list) {
			if (!comment) continue;
			const ids = getCommentIds(comment);
			if (ids.some((id) => threadIds.has(id))) continue;
			if (![comment.parentCommentId, comment.threadingParentCommentId].filter((id) => id != null).map((id) => String(id)).some((id) => threadIds.has(id))) continue;
			descendants.push(comment);
			ids.forEach((id) => threadIds.add(id));
			expanded = true;
		}
	}
	return descendants;
}
function useComment(params) {
	const uid = ref(params.uid);
	const commentId = params.commentId || v4_default();
	const importedId = params.importedId;
	const parentCommentId = params.parentCommentId;
	const trackedChangeParentId = params.trackedChangeParentId;
	const fileId = params.fileId;
	const fileType = params.fileType;
	const createdAtVersionNumber = params.createdAtVersionNumber;
	const isInternal = ref(params.isInternal !== void 0 ? params.isInternal : true);
	const mentions = ref([]);
	const commentElement = ref(null);
	const isFocused = ref(params.isFocused || false);
	const creatorId = ref(params.creatorId ?? null);
	const creatorEmail = ref(params.creatorEmail ?? null);
	const creatorName = ref(params.creatorName ?? null);
	const creatorImage = ref(params.creatorImage ?? null);
	const createdTime = ref(params.createdTime || Date.now());
	const importedAuthor = ref(params.importedAuthor || null);
	const docxCommentJSON = ref(params.docxCommentJSON || null);
	const origin = params.origin;
	const threadingMethod = params.threadingMethod;
	const threadingStyleOverride = params.threadingStyleOverride;
	const threadingParentCommentId = params.threadingParentCommentId;
	const originalXmlStructure = params.originalXmlStructure;
	const commentText = ref(params.commentText || "");
	const selection = params.selection ? useSelection(params.selection) : useSelection({
		documentId: fileId,
		page: 1,
		selectionBounds: {}
	});
	const floatingPosition = params.selection?.selectionBounds ? { ...params.selection.selectionBounds } : {
		top: 0,
		left: 0,
		right: 0,
		bottom: 0
	};
	const trackedChange = ref(params.trackedChange);
	const trackedChangeType = ref(params.trackedChangeType || null);
	const trackedChangeText = ref(params.trackedChangeText || null);
	const trackedChangeDisplayType = ref(params.trackedChangeDisplayType || null);
	const trackedChangeStory = ref(params.trackedChangeStory || null);
	const trackedChangeStoryKind = ref(params.trackedChangeStoryKind || null);
	const trackedChangeStoryLabel = ref(params.trackedChangeStoryLabel || "");
	const trackedChangeAnchorKey = ref(params.trackedChangeAnchorKey || null);
	const deletedText = ref(params.deletedText || null);
	const resolvedTime = ref(params.resolvedTime || null);
	const resolvedById = ref(params.resolvedById || null);
	const resolvedByEmail = ref(params.resolvedByEmail || null);
	const resolvedByName = ref(params.resolvedByName || null);
	const resolveComment = ({ id, email, name, superdoc }) => {
		if (resolvedTime.value) return;
		resolvedTime.value = Date.now();
		resolvedById.value = id ?? null;
		resolvedByEmail.value = email;
		resolvedByName.value = name;
		propagateUpdate(superdoc, {
			type: comments_module_events.RESOLVED,
			comment: getValues()
		});
		const commands = superdoc.activeEditor?.commands;
		if (trackedChange.value) {
			commands?.resolveComment({
				commentId,
				importedId
			});
			return;
		}
		const replies = getThreadDescendants(superdoc, {
			commentId,
			importedId
		});
		if (replies.length && typeof commands?.resolveCommentThread === "function") commands.resolveCommentThread({ comments: [{
			commentId,
			importedId,
			preserveAnchor: true
		}, ...replies.map((reply) => ({
			commentId: reply.commentId,
			importedId: reply.importedId,
			preserveAnchor: false
		}))] });
		else commands?.resolveComment({
			commentId,
			importedId
		});
	};
	const setIsInternal = ({ isInternal: newIsInternal, superdoc }) => {
		const previousValue = isInternal.value;
		if (previousValue === newIsInternal) return;
		isInternal.value = newIsInternal;
		propagateUpdate(superdoc, {
			type: comments_module_events.UPDATE,
			changes: [{
				key: "isInternal",
				value: newIsInternal,
				previousValue
			}],
			comment: getValues()
		});
		const activeEditor = superdoc.activeEditor;
		if (!activeEditor) return;
		activeEditor.commands.setCommentInternal({
			commentId,
			importedId,
			isInternal: newIsInternal
		});
	};
	const setActive = (superdoc) => {
		const { activeEditor } = superdoc;
		activeEditor?.commands.setActiveComment({
			commentId,
			importedId
		});
	};
	const setText = ({ text, superdoc, suppressUpdate }) => {
		commentText.value = text;
		mentions.value = extractMentions(text);
		if (suppressUpdate) return;
		propagateUpdate(superdoc, {
			type: comments_module_events.UPDATE,
			changes: [{
				key: "text",
				value: text
			}],
			comment: getValues()
		});
	};
	const extractMentions = (htmlString) => {
		const mentionElements = [...new DOMParser().parseFromString(htmlString, "text/html").querySelectorAll("span[data-type=\"mention\"]")];
		const uniqueMentions = [];
		mentionElements.forEach((span) => {
			if (!uniqueMentions.some((m) => {
				const hasEmail = m.email === span.getAttribute("email");
				const hasName = m.name === span.getAttribute("name");
				return hasEmail && hasName;
			})) uniqueMentions.push({
				name: span.getAttribute("name"),
				email: span.getAttribute("email")
			});
		});
		return uniqueMentions;
	};
	const updatePosition = (coords, parentElement) => {
		selection.source = "super-editor";
		const parentTop = parentElement?.getBoundingClientRect()?.top;
		selection.selectionBounds = {
			top: coords.top - parentTop,
			left: coords.left,
			right: coords.right,
			bottom: coords.bottom - parentTop
		};
	};
	const getCommentUser = () => {
		return importedAuthor.value ? {
			name: importedAuthor.value.name || "(Imported)",
			email: importedAuthor.value.email
		} : {
			id: creatorId.value,
			name: creatorName.value,
			email: creatorEmail.value,
			image: creatorImage.value
		};
	};
	const propagateUpdate = (superdoc, event) => {
		superdoc.emit("comments-update", event);
		syncCommentsToClients(superdoc, event);
	};
	const getValues = () => {
		return {
			uid: uid.value,
			commentId,
			importedId,
			parentCommentId,
			trackedChangeParentId,
			fileId,
			fileType,
			mentions: mentions.value.map((u) => {
				return {
					...u,
					name: u.name ? u.name : u.email
				};
			}),
			createdAtVersionNumber,
			creatorId: creatorId.value,
			creatorEmail: creatorEmail.value,
			creatorName: creatorName.value,
			creatorImage: creatorImage.value,
			createdTime: createdTime.value,
			importedAuthor: importedAuthor.value,
			docxCommentJSON: docxCommentJSON.value,
			isInternal: isInternal.value,
			commentText: commentText.value,
			selection: selection ? selection.getValues() : null,
			trackedChange: trackedChange.value,
			trackedChangeText: trackedChangeText.value,
			trackedChangeType: trackedChangeType.value,
			trackedChangeDisplayType: trackedChangeDisplayType.value,
			trackedChangeStory: trackedChangeStory.value,
			trackedChangeStoryKind: trackedChangeStoryKind.value,
			trackedChangeStoryLabel: trackedChangeStoryLabel.value,
			trackedChangeAnchorKey: trackedChangeAnchorKey.value,
			deletedText: deletedText.value,
			resolvedTime: resolvedTime.value,
			resolvedById: resolvedById.value,
			resolvedByEmail: resolvedByEmail.value,
			resolvedByName: resolvedByName.value,
			origin,
			threadingMethod,
			threadingStyleOverride,
			threadingParentCommentId,
			originalXmlStructure
		};
	};
	return reactive({
		uid,
		commentId,
		importedId,
		parentCommentId,
		trackedChangeParentId,
		fileId,
		fileType,
		mentions,
		commentElement,
		isFocused,
		creatorId,
		creatorEmail,
		creatorName,
		creatorImage,
		createdTime,
		isInternal,
		commentText,
		selection,
		floatingPosition,
		trackedChange,
		deletedText,
		trackedChangeType,
		trackedChangeText,
		trackedChangeDisplayType,
		trackedChangeStory,
		trackedChangeStoryKind,
		trackedChangeStoryLabel,
		trackedChangeAnchorKey,
		resolvedTime,
		resolvedById,
		resolvedByEmail,
		resolvedByName,
		importedAuthor,
		docxCommentJSON,
		origin,
		threadingMethod,
		threadingStyleOverride,
		threadingParentCommentId,
		originalXmlStructure,
		setText,
		getValues,
		resolveComment,
		setIsInternal,
		setActive,
		updatePosition,
		getCommentUser
	});
}
function useDocument(params, superdocConfig) {
	const id = params.id;
	const type = initDocumentType(params);
	const data = params.data;
	const config = superdocConfig;
	const state = params.state;
	const role = params.role;
	const html = params.html;
	const markdown = params.markdown;
	const password = params.password;
	const editorMountNonce = ref(0);
	const container = ref(null);
	const pageContainers = ref([]);
	const isReady = ref(false);
	const rulers = ref(superdocConfig.rulers);
	const ydoc = shallowRef(params.ydoc);
	const provider = shallowRef(params.provider);
	const socket = shallowRef(params.socket);
	const isNewFile = ref(params.isNewFile);
	const editorRef = shallowRef(null);
	const setEditor = (ref$2) => editorRef.value = ref$2;
	const getEditor = () => editorRef.value;
	const presentationEditorRef = shallowRef(null);
	const setPresentationEditor = (ref$2) => presentationEditorRef.value = ref$2;
	const getPresentationEditor = () => presentationEditorRef.value;
	function initDocumentType({ type: type$1, data: data$1 }) {
		if (data$1?.type) return data$1.type;
		if (type$1) return documentTypes[type$1] || type$1;
		throw new Error("Document type not specified");
	}
	const removeComments = () => {
		conversationsBackup.value = conversations.value;
		conversations.value = [];
	};
	const restoreComments = () => {
		conversations.value = conversationsBackup.value;
		console.debug("[superdoc] Restored comments:", conversations.value);
	};
	const rawFields = ref(params.fields || []);
	const fields = ref(params.fields?.map((f) => useField(f)) || []);
	const annotations = ref(params.annotations || []);
	const conversations = ref(initConversations());
	const conversationsBackup = ref(conversations.value);
	const commentThreadingProfile = ref(params.commentThreadingProfile || null);
	function initConversations() {
		if (!config.modules.comments) return [];
		return params.conversations?.map((c) => useComment(c)) || [];
	}
	const core = ref(null);
	const removeConversation = (conversationId) => {
		const index = conversations.value.findIndex((c) => c.conversationId === conversationId);
		if (index > -1) conversations.value.splice(index, 1);
	};
	return {
		id,
		data,
		html,
		markdown,
		password,
		type,
		config,
		state,
		role,
		core,
		editorMountNonce,
		ydoc,
		provider,
		socket,
		isNewFile,
		container,
		pageContainers,
		isReady,
		rulers,
		rawFields,
		fields,
		annotations,
		conversations,
		commentThreadingProfile,
		setEditor,
		getEditor,
		setPresentationEditor,
		getPresentationEditor,
		removeComments,
		restoreComments,
		removeConversation
	};
}
const useSuperdocStore = defineStore("superdoc", () => {
	const currentConfig = ref(null);
	let exceptionHandler = null;
	const commentsStore = useCommentsStore();
	const documents = ref([]);
	const documentBounds = ref([]);
	const pages = reactive({});
	const documentUsers = ref([]);
	const activeZoom = ref(100);
	const zoomMode = ref("manual");
	const viewportMetrics = ref(null);
	const isReady = ref(false);
	const isInternal = ref(false);
	const users = ref([]);
	const user = reactive({
		name: null,
		email: null
	});
	const modules = reactive({});
	const activeSelection = ref(null);
	const selectionPosition = ref({
		left: 0,
		top: 0,
		width: 0,
		height: 0,
		source: null
	});
	const reset = () => {
		documents.value = [];
		documentBounds.value = [];
		Object.assign(pages, {});
		documentUsers.value = [];
		isReady.value = false;
		user.name = null;
		user.email = null;
		Object.assign(modules, {});
		activeSelection.value = null;
	};
	const documentScroll = reactive({
		scrollTop: 0,
		scrollLeft: 0
	});
	const setExceptionHandler = (handler) => {
		exceptionHandler = typeof handler === "function" ? handler : null;
	};
	const emitException = (payload) => {
		const handler = exceptionHandler || currentConfig.value?.onException;
		if (typeof handler === "function") handler(payload);
	};
	const init = async (config) => {
		reset();
		currentConfig.value = config;
		if (config.zoom?.initial !== void 0) {
			const initialZoom = config.zoom.initial;
			if (typeof initialZoom === "number" && Number.isFinite(initialZoom) && initialZoom > 0) activeZoom.value = initialZoom;
			else console.warn("[SuperDoc] zoom.initial expects a positive number representing percentage");
		}
		if (config.zoom?.mode !== void 0) {
			const mode = config.zoom.mode;
			if (mode === "manual" || mode === "fit-width") zoomMode.value = mode;
			else console.warn("[SuperDoc] zoom.mode expects 'manual' or 'fit-width'");
		}
		const { documents: configDocs, modules: configModules, user: configUser, users: configUsers } = config;
		documentUsers.value = configUsers || [];
		Object.assign(user, configUser);
		Object.assign(modules, configModules);
		if (!Object.prototype.hasOwnProperty.call(modules, "comments")) modules.comments = {};
		if (!configDocs?.length && !config.modules.collaboration) {
			const newDoc = await getFileObject(blank_default, "blank.docx", DOCX);
			const newDocConfig = {
				id: v4_default(),
				type: DOCX,
				data: newDoc,
				name: "blank.docx",
				isNewFile: true
			};
			if (config.html) newDocConfig.html = config.html;
			if (config.markdown) newDocConfig.markdown = config.markdown;
			configDocs.push(newDocConfig);
		}
		await initializeDocuments(configDocs);
		isReady.value = true;
	};
	const initializeDocuments = async (docsToProcess = []) => {
		if (!docsToProcess) return [];
		for (let doc of docsToProcess) {
			if (!doc) {
				emitException({
					error: /* @__PURE__ */ new Error("Received empty document entry during initialization."),
					stage: "document-init",
					document: doc
				});
				console.warn("[superdoc] Skipping empty document entry.");
				continue;
			}
			try {
				let docWithData = await _initializeDocumentData(doc);
				if (!docWithData) {
					emitException({
						error: /* @__PURE__ */ new Error("Document could not be initialized with the provided configuration."),
						stage: "document-init",
						document: doc
					});
					console.warn("[superdoc] Skipping document due to invalid configuration:", doc);
					continue;
				}
				const smartDoc = useDocument(docWithData, currentConfig.value);
				documents.value.push(smartDoc);
			} catch (e) {
				emitException({
					error: e,
					stage: "document-init",
					document: doc
				});
				console.warn("[superdoc] Error initializing document:", doc, "with error:", e, "Skipping document.");
			}
		}
	};
	const _blobToFile = (blob, name, type) => {
		return new File([blob], name, { type });
	};
	const _initializeDocumentData = async (doc) => {
		doc = normalizeDocumentEntry(doc);
		if (currentConfig.value?.html) doc.html = currentConfig.value.html;
		if (!doc.data && doc.url && !doc.type) doc.type = DOCX;
		if (currentConfig.value?.modules.collaboration && !doc.isNewFile) return {
			...doc,
			data: null,
			url: null
		};
		if (doc.data instanceof File) {
			let fileName = doc.name;
			const extension = doc.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? ".docx" : doc.type === "application/pdf" ? ".pdf" : ".bin";
			if (!fileName) fileName = `document${extension}`;
			else if (!fileName.includes(".")) fileName = `${fileName}${extension}`;
			if (doc.data.name !== fileName) {
				const fileObject = _blobToFile(doc.data, fileName, doc.data.type || doc.type);
				return {
					...doc,
					name: fileName,
					data: fileObject
				};
			}
			if (!doc.name) return {
				...doc,
				name: fileName
			};
			return doc;
		} else if (doc.data instanceof Blob) {
			let fileName = doc.name;
			if (!fileName) fileName = `document${doc.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? ".docx" : doc.type === "application/pdf" ? ".pdf" : ".bin"}`;
			const fileObject = _blobToFile(doc.data, fileName, doc.data.type || doc.type);
			return {
				...doc,
				data: fileObject
			};
		} else if (doc.data) return doc;
		else if (doc.url && doc.type) {
			if (doc.type.toLowerCase() === "docx") doc.type = DOCX;
			else if (doc.type.toLowerCase() === "pdf") doc.type = PDF;
			try {
				const fileObject = await getFileObject(doc.url, doc.name || "document", doc.type);
				return {
					...doc,
					data: fileObject
				};
			} catch (err) {
				const message = err instanceof Error ? err.message : String(err);
				console.debug("[SuperDoc] Failed to fetch document from URL:", message);
				throw err;
			}
		}
		return null;
	};
	const areDocumentsReady = computed(() => {
		for (let obj of documents.value.filter((doc) => doc.type === "pdf")) if (!obj.isReady) return false;
		return true;
	});
	const getDocument = (documentId) => documents.value.find((doc) => doc.id === documentId);
	const getPageBounds = (documentId, page) => {
		const matchedPage = pages[documentId];
		if (!matchedPage) return;
		const pageInfo = matchedPage.find((p) => p.page == page);
		if (!pageInfo || !pageInfo.container) return;
		const { height } = pageInfo.container.getBoundingClientRect();
		return { top: height * (page - 1) };
	};
	const handlePageReady = (documentId, index, containerBounds) => {
		if (!pages[documentId]) pages[documentId] = [];
		pages[documentId].push({
			page: index,
			containerBounds
		});
		const doc = getDocument(documentId);
		if (!doc) return;
		doc.pageContainers.push({
			page: index,
			containerBounds
		});
	};
	return {
		commentsStore,
		documents,
		documentBounds,
		pages,
		documentUsers,
		users,
		activeZoom,
		zoomMode,
		viewportMetrics,
		documentScroll,
		isInternal,
		selectionPosition,
		activeSelection,
		isReady,
		user,
		modules,
		areDocumentsReady,
		init,
		setExceptionHandler,
		reset,
		handlePageReady,
		getDocument,
		getPageBounds
	};
});
const groupChanges = (changes) => {
	const markMetaKeys = {
		trackInsert: "insertedMark",
		trackDelete: "deletionMark",
		trackFormat: "formatMark"
	};
	const byId = /* @__PURE__ */ new Map();
	for (const change of changes) {
		const id = change.mark.attrs.id;
		if (!byId.has(id)) byId.set(id, []);
		byId.get(id).push(change);
	}
	const grouped = [];
	for (const [, group] of byId) {
		if (group.length === 1) {
			const c = group[0];
			const key = markMetaKeys[c.mark.type.name];
			grouped.push({
				from: c.from,
				to: c.to,
				[key]: c
			});
			continue;
		}
		const processed = /* @__PURE__ */ new Set();
		for (let i = 0; i < group.length; i++) {
			if (processed.has(i)) continue;
			const c1 = group[i];
			const c1Key = markMetaKeys[c1.mark.type.name];
			const c2 = group[i + 1];
			if (c2 && !processed.has(i + 1) && c1.to === c2.from && c1.mark.type.name !== c2.mark.type.name) {
				const c2Key = markMetaKeys[c2.mark.type.name];
				grouped.push({
					from: c1.from,
					to: c2.to,
					[c1Key]: c1,
					[c2Key]: c2
				});
				processed.add(i);
				processed.add(i + 1);
				continue;
			}
			let foundMatch = false;
			for (let j = i + 1; j < group.length; j++) {
				if (processed.has(j)) continue;
				const cj = group[j];
				if (c1.mark.type.name !== cj.mark.type.name) {
					const cjKey = markMetaKeys[cj.mark.type.name];
					grouped.push({
						from: Math.min(c1.from, cj.from),
						to: Math.max(c1.to, cj.to),
						[c1Key]: c1,
						[cjKey]: cj
					});
					processed.add(i);
					processed.add(j);
					foundMatch = true;
					break;
				}
			}
			if (!foundMatch) {
				grouped.push({
					from: c1.from,
					to: c1.to,
					[c1Key]: c1
				});
				processed.add(i);
			}
		}
	}
	return grouped;
};
var HEADER_FOOTER_TRACKED_CHANGE_STORY_TYPE = "headerFooterPart";
var toFinitePageIndex = (value) => {
	return Number.isFinite(value) ? Number(value) : null;
};
var buildPageScopedInstanceId = (positionKey, pageIndex) => {
	return `${positionKey}::page:${pageIndex}`;
};
var aggregateRectBounds = (rects) => {
	if (!Array.isArray(rects) || rects.length === 0) return null;
	let left = Number.POSITIVE_INFINITY;
	let top = Number.POSITIVE_INFINITY;
	let right = Number.NEGATIVE_INFINITY;
	let bottom = Number.NEGATIVE_INFINITY;
	rects.forEach((rect) => {
		if (![
			rect?.left,
			rect?.top,
			rect?.right,
			rect?.bottom
		].every(Number.isFinite)) return;
		left = Math.min(left, rect.left);
		top = Math.min(top, rect.top);
		right = Math.max(right, rect.right);
		bottom = Math.max(bottom, rect.bottom);
	});
	if (![
		left,
		top,
		right,
		bottom
	].every(Number.isFinite)) return null;
	return {
		left,
		top,
		right,
		bottom,
		width: right - left,
		height: bottom - top
	};
};
var groupRectsByPage = (rects) => {
	const groupedRects = /* @__PURE__ */ new Map();
	rects.forEach((rect) => {
		const pageIndex = toFinitePageIndex(rect?.pageIndex);
		if (pageIndex == null) return;
		const pageRects = groupedRects.get(pageIndex);
		if (pageRects) {
			pageRects.push(rect);
			return;
		}
		groupedRects.set(pageIndex, [rect]);
	});
	return [...groupedRects.entries()].sort((a, b) => a[0] - b[0]).map(([pageIndex, pageRects]) => ({
		pageIndex,
		rects: pageRects
	}));
};
var isRepeatedHeaderFooterTrackedChange = (comment, positionEntry) => {
	if (!comment?.trackedChange) return false;
	if (comment?.trackedChangeStory?.storyType !== HEADER_FOOTER_TRACKED_CHANGE_STORY_TYPE) return false;
	return groupRectsByPage(positionEntry?.rects).length > 1;
};
var buildSingleFloatingCommentInstance = ({ id, threadId, comment, positionKey, positionEntry }) => {
	return {
		id,
		threadId,
		comment,
		positionKey,
		positionEntry: positionEntry ?? null,
		pageIndex: toFinitePageIndex(positionEntry?.pageIndex),
		isPrimary: true
	};
};
var buildRepeatedHeaderFooterInstances = ({ comment, positionKey, positionEntry }) => {
	const rectGroups = groupRectsByPage(positionEntry?.rects);
	if (rectGroups.length < 2) return [];
	const primaryPageIndex = toFinitePageIndex(positionEntry?.pageIndex) ?? rectGroups[0]?.pageIndex ?? null;
	return rectGroups.map(({ pageIndex, rects }) => {
		const bounds = aggregateRectBounds(rects);
		if (!bounds) return null;
		return {
			id: buildPageScopedInstanceId(positionKey, pageIndex),
			threadId: comment?.commentId ?? positionKey,
			comment,
			positionKey,
			pageIndex,
			isPrimary: pageIndex === primaryPageIndex,
			positionEntry: {
				...positionEntry,
				pageIndex,
				rects,
				bounds
			}
		};
	}).filter(Boolean);
};
const buildFloatingCommentInstances = ({ comment, positionKey, positionEntry, fallbackId }) => {
	const instanceId = positionKey ?? fallbackId;
	if (!instanceId) return [];
	if (isRepeatedHeaderFooterTrackedChange(comment, positionEntry) && positionKey) {
		const repeatedInstances = buildRepeatedHeaderFooterInstances({
			comment,
			positionKey,
			positionEntry
		});
		if (repeatedInstances.length > 0) return repeatedInstances;
	}
	return [buildSingleFloatingCommentInstance({
		id: instanceId,
		threadId: comment?.commentId ?? fallbackId,
		comment,
		positionKey,
		positionEntry
	})];
};
const useCommentsStore = defineStore("comments", () => {
	const BODY_TRACKED_CHANGE_STORY = {
		kind: "story",
		storyType: "body"
	};
	const isBodyTrackedChangeComment = (comment) => {
		if (!comment?.trackedChange) return false;
		const storyType = comment?.trackedChangeStory?.storyType;
		if (storyType == null || storyType === "body") return true;
		return comment?.trackedChangeAnchorKey?.startsWith?.("tc::body::") === true;
	};
	const buildBodyTrackedChangeAnchorKey = (rawId) => {
		if (rawId === void 0 || rawId === null) return null;
		return makeTrackedChangeAnchorKey({
			storyKey: "body",
			rawId: String(rawId)
		});
	};
	const buildStructuralTrackedChangeId = (structural) => {
		if (!structural) return null;
		const sourceId = structural.sourceId ? String(structural.sourceId) : "";
		if (sourceId) return `word:structural:${sourceId}`;
		return structural.id ? String(structural.id) : null;
	};
	const superdocStore = useSuperdocStore();
	const commentsConfig = reactive({
		name: "comments",
		readOnly: false,
		allowResolve: true,
		showResolved: false
	});
	const viewingVisibility = reactive({
		documentMode: "editing",
		commentsVisible: false,
		trackChangesVisible: false
	});
	const isDebugging = false;
	const debounceTimers = {};
	const trackedChangeResolutionSnapshots = /* @__PURE__ */ new WeakMap();
	const COMMENT_EVENTS = comments_module_events;
	const hasInitializedComments = ref(false);
	const hasSyncedCollaborationComments = ref(false);
	const commentsParentElement = ref(null);
	const hasInitializedLocations = ref(false);
	const activeComment = ref(null);
	const activeFloatingCommentInstanceId = ref(null);
	const editingCommentId = ref(null);
	const commentDialogs = ref([]);
	const overlappingComments = ref([]);
	const overlappedIds = /* @__PURE__ */ new Set([]);
	const suppressInternalExternal = ref(true);
	const currentCommentText = ref("");
	const commentsList = ref([]);
	const isCommentsListVisible = ref(false);
	const editorCommentIds = ref([]);
	const editorCommentPositions = ref({});
	const isCommentHighlighted = ref(false);
	const floatingCommentsOffset = ref(0);
	const sortedConversations = ref([]);
	const visibleConversations = ref([]);
	const skipSelectionUpdate = ref(false);
	const isFloatingCommentsReady = ref(false);
	const generalCommentIds = ref([]);
	const instantSidebarAlignmentTargetY = ref(null);
	const instantSidebarAlignmentThreadId = ref(null);
	const instantSidebarAlignmentInstanceId = ref(null);
	const pendingComment = ref(null);
	const isViewingMode = computed(() => viewingVisibility.documentMode === "viewing");
	const init = (config = {}) => {
		const updatedConfig = {
			...commentsConfig,
			...config
		};
		Object.assign(commentsConfig, updatedConfig);
		suppressInternalExternal.value = commentsConfig.suppressInternalExternal || false;
		if (config.comments && config.comments.length) commentsList.value = config.comments?.map((c) => useComment(c)) || [];
	};
	const normalizeCommentId = (id) => id === void 0 || id === null ? null : String(id);
	const getPositionEntryByAlias = (id) => {
		const normalizedId = normalizeCommentId(id);
		if (!normalizedId) return {
			key: null,
			entry: null
		};
		const positions = editorCommentPositions.value || {};
		if (positions[normalizedId] !== void 0) return {
			key: normalizedId,
			entry: positions[normalizedId]
		};
		for (const [key, entry] of Object.entries(positions)) {
			const entryKey = normalizeCommentId(entry?.key);
			const threadId = normalizeCommentId(entry?.threadId);
			if (entryKey === normalizedId || threadId === normalizedId) return {
				key,
				entry
			};
		}
		return {
			key: null,
			entry: null
		};
	};
	const boundsOverlap = (a, b) => {
		if (!a || !b) return false;
		const left = Math.max(Number(a.left), Number(b.left));
		const right = Math.min(Number(a.right), Number(b.right));
		const top = Math.max(Number(a.top), Number(b.top));
		const bottom = Math.min(Number(a.bottom), Number(b.bottom));
		return [
			left,
			right,
			top,
			bottom
		].every(Number.isFinite) && right > left && bottom > top;
	};
	const isEquivalentTrackedChangePosition = (candidate, existing) => {
		if (!candidate || !existing) return false;
		if (candidate.kind !== "trackedChange" || existing.kind !== "trackedChange") return false;
		if (candidate.storyKey && existing.storyKey && candidate.storyKey !== existing.storyKey) return false;
		const candidatePage = Number(candidate.pageIndex);
		const existingPage = Number(existing.pageIndex);
		if (Number.isFinite(candidatePage) && Number.isFinite(existingPage) && candidatePage !== existingPage) return false;
		if (boundsOverlap(candidate.bounds, existing.bounds)) return true;
		const candidateStart = Number(candidate.start);
		const candidateEnd = Number(candidate.end);
		const existingStart = Number(existing.start);
		const existingEnd = Number(existing.end);
		return [
			candidateStart,
			candidateEnd,
			existingStart,
			existingEnd
		].every(Number.isFinite) && candidateStart === existingStart && candidateEnd === existingEnd;
	};
	const getTrackedChangeCommentByPositionAlias = (id) => {
		const { entry: targetEntry } = getPositionEntryByAlias(id);
		if (!targetEntry) return null;
		const matches = commentsList.value.filter((comment) => {
			if (!comment?.trackedChange) return false;
			return [
				comment.trackedChangeAnchorKey,
				comment.commentId,
				comment.importedId
			].some((alias) => {
				const { entry } = getPositionEntryByAlias(alias);
				return isEquivalentTrackedChangePosition(targetEntry, entry);
			});
		});
		return matches.length === 1 ? matches[0] : null;
	};
	const getComment = (id) => {
		if (id === void 0 || id === null) return null;
		return commentsList.value.find((c) => c.commentId == id || c.importedId == id || c.trackedChangeAnchorKey == id) || getTrackedChangeCommentByPositionAlias(id);
	};
	const getThreadParent = (comment) => {
		if (!comment?.parentCommentId) return comment;
		return getComment(comment.parentCommentId);
	};
	const shouldThreadWithTrackedChange = (comment) => {
		if (!comment?.trackedChangeParentId) return false;
		const trackedChange = getComment(comment.trackedChangeParentId);
		return Boolean(trackedChange?.trackedChange);
	};
	const getCommentPositionKey = (commentOrId) => {
		if (!commentOrId) return null;
		const positions = editorCommentPositions.value || {};
		if (typeof commentOrId === "string") {
			if (positions[commentOrId]) return commentOrId;
			const resolvedComment = getComment(commentOrId);
			if (!resolvedComment) return commentOrId;
			const commentId$1 = resolvedComment.commentId ?? null;
			const importedId$1 = resolvedComment.importedId ?? null;
			const trackedChangeAnchorKey$1 = resolvedComment.trackedChangeAnchorKey ?? null;
			if (trackedChangeAnchorKey$1 && positions[trackedChangeAnchorKey$1]) return trackedChangeAnchorKey$1;
			if (commentId$1 && positions[commentId$1]) return commentId$1;
			if (importedId$1 && positions[importedId$1]) return importedId$1;
			return trackedChangeAnchorKey$1 ?? commentId$1 ?? importedId$1 ?? null;
		}
		const commentId = commentOrId.commentId ?? null;
		const importedId = commentOrId.importedId ?? null;
		const trackedChangeAnchorKey = commentOrId.trackedChangeAnchorKey ?? null;
		if (trackedChangeAnchorKey && positions[trackedChangeAnchorKey]) return trackedChangeAnchorKey;
		if (commentId && positions[commentId]) return commentId;
		if (importedId && positions[importedId]) return importedId;
		return trackedChangeAnchorKey ?? commentId ?? importedId ?? null;
	};
	const getCommentAliasIds = (commentOrId) => {
		if (commentOrId === void 0 || commentOrId === null) return [];
		const rawId = typeof commentOrId === "object" ? null : commentOrId;
		const comment = typeof commentOrId === "object" ? commentOrId : getComment(commentOrId);
		const seen = /* @__PURE__ */ new Set();
		return [
			rawId,
			getCommentPositionKey(comment),
			comment?.trackedChangeAnchorKey,
			comment?.commentId,
			comment?.importedId
		].map((id) => normalizeCommentId(id)).filter((id) => {
			if (!id || seen.has(id)) return false;
			seen.add(id);
			return true;
		});
	};
	const resolveCommentPositionEntry = (commentOrId, preferredId) => {
		const currentPositions = editorCommentPositions.value || {};
		const seen = /* @__PURE__ */ new Set();
		for (const key of [preferredId, ...getCommentAliasIds(commentOrId)].map((id) => normalizeCommentId(id)).filter(Boolean)) {
			if (seen.has(key)) continue;
			seen.add(key);
			const entry = currentPositions[key];
			if (entry !== void 0) return {
				key,
				entry
			};
		}
		return {
			key: null,
			entry: null
		};
	};
	const clearResolvedMetadata = (comment) => {
		if (!comment) return;
		if (comment.resolvedTime != null || comment.resolvedById != null || comment.resolvedByEmail != null || comment.resolvedByName != null) trackedChangeResolutionSnapshots.set(comment, {
			resolvedTime: comment.resolvedTime ?? null,
			resolvedById: comment.resolvedById ?? null,
			resolvedByEmail: comment.resolvedByEmail ?? null,
			resolvedByName: comment.resolvedByName ?? null
		});
		comment.resolvedTime = null;
		comment.resolvedById = null;
		comment.resolvedByEmail = null;
		comment.resolvedByName = null;
	};
	const restoreResolvedMetadata = (comment) => {
		if (!comment) return false;
		const snapshot = trackedChangeResolutionSnapshots.get(comment);
		if (!snapshot) return false;
		comment.resolvedTime = snapshot.resolvedTime ?? Date.now();
		comment.resolvedById = snapshot.resolvedById ?? null;
		comment.resolvedByEmail = snapshot.resolvedByEmail ?? null;
		comment.resolvedByName = snapshot.resolvedByName ?? null;
		return true;
	};
	const getCommentEventPayload = (comment) => typeof comment?.getValues === "function" ? comment.getValues() : { ...comment };
	const isEditorBackedComment = (comment) => {
		const source = comment?.selection?.source;
		if (source == null) return true;
		return source === "super-editor";
	};
	const isTrackedChangeThread = (comment) => Boolean(comment?.trackedChange) || Boolean(comment?.trackedChangeParentId);
	const syncTrackedChangePositionsWithDocument = ({ documentId, editor } = {}) => {
		if (!editor?.state) return 0;
		if (!commentsList.value?.length) return 0;
		const currentPositions = editorCommentPositions.value || {};
		if (!Object.keys(currentPositions).length) return 0;
		const resolveExistingPositionKey = (aliasIds) => aliasIds.find((key) => currentPositions[key] !== void 0) ?? null;
		const candidateRootPositionKeys = /* @__PURE__ */ new Set();
		const rootAliasesByPositionKey = /* @__PURE__ */ new Map();
		commentsList.value.forEach((comment) => {
			if (!comment?.trackedChange) return;
			if (documentId) {
				const resolvedDocumentId = comment?.fileId ?? null;
				if (resolvedDocumentId && resolvedDocumentId !== documentId) return;
			}
			const aliasIds = getCommentAliasIds(comment);
			const normalizedPositionKey = resolveExistingPositionKey(aliasIds);
			if (!normalizedPositionKey) return;
			candidateRootPositionKeys.add(normalizedPositionKey);
			rootAliasesByPositionKey.set(normalizedPositionKey, new Set(aliasIds));
		});
		if (!candidateRootPositionKeys.size) return 0;
		const trackedIds = new Set(getTrackChanges(editor.state).map(({ mark }) => mark?.attrs?.id).filter((id) => id !== void 0 && id !== null).map((id) => String(id)));
		const trackedChangeIndex = typeof getTrackedChangeIndex === "function" ? getTrackedChangeIndex(editor) : null;
		let liveAnchorKeySource = [];
		try {
			liveAnchorKeySource = trackedChangeIndex?.getAll?.() ?? [];
		} catch {}
		const liveAnchorKeys = new Set(liveAnchorKeySource.map((snapshot) => snapshot?.anchorKey).filter((anchorKey) => typeof anchorKey === "string" && anchorKey.length > 0));
		const staleRootPositionKeys = new Set(Array.from(candidateRootPositionKeys).filter((positionKey) => {
			const aliases = rootAliasesByPositionKey.get(positionKey) ?? new Set([positionKey]);
			if (Array.from(aliases).some((alias) => liveAnchorKeys.has(alias))) return false;
			return !Array.from(aliases).some((alias) => trackedIds.has(alias));
		}));
		if (!staleRootPositionKeys.size) return 0;
		const staleRootAliasIds = /* @__PURE__ */ new Set();
		staleRootPositionKeys.forEach((positionKey) => {
			(rootAliasesByPositionKey.get(positionKey) ?? new Set([positionKey])).forEach((alias) => staleRootAliasIds.add(alias));
		});
		const stalePositionKeys = new Set(staleRootPositionKeys);
		commentsList.value.forEach((comment) => {
			const normalizedPositionKey = resolveExistingPositionKey(getCommentAliasIds(comment));
			if (!normalizedPositionKey) return;
			if ([comment?.trackedChangeParentId, comment?.parentCommentId].map((id) => normalizeCommentId(id)).filter(Boolean).some((id) => staleRootAliasIds.has(id))) stalePositionKeys.add(normalizedPositionKey);
		});
		const nextPositions = { ...currentPositions };
		stalePositionKeys.forEach((key) => {
			delete nextPositions[key];
		});
		editorCommentPositions.value = nextPositions;
		if (activeComment.value !== void 0 && activeComment.value !== null) {
			const activeCommentModel = getComment(activeComment.value);
			const activeAliases = new Set(getCommentAliasIds(activeCommentModel ?? activeComment.value));
			const activeParentKeys = [activeCommentModel?.trackedChangeParentId, activeCommentModel?.parentCommentId].map((id) => normalizeCommentId(id)).filter(Boolean);
			if (Array.from(activeAliases).some((id) => staleRootAliasIds.has(id)) || activeParentKeys.some((id) => staleRootAliasIds.has(id))) clearActiveCommentSelection();
		}
		return stalePositionKeys.size;
	};
	const collectStandardCommentDocumentState = (editor) => {
		const doc = editor?.state?.doc;
		if (!doc || typeof doc.descendants !== "function") return null;
		const liveMarkIds = /* @__PURE__ */ new Set();
		const resolvedAnchorIds = /* @__PURE__ */ new Set();
		doc.descendants((node) => {
			node.marks?.filter((mark) => mark?.type?.name === "commentMark").forEach((mark) => {
				[mark.attrs?.commentId, mark.attrs?.importedId].map((id) => normalizeCommentId(id)).filter(Boolean).forEach((id) => liveMarkIds.add(id));
			});
			const typeName = node.type?.name;
			if (typeName !== "commentRangeStart" && typeName !== "commentRangeEnd") return;
			const anchorId = normalizeCommentId(node.attrs?.["w:id"]);
			if (anchorId) resolvedAnchorIds.add(anchorId);
		});
		return {
			liveMarkIds,
			resolvedAnchorIds
		};
	};
	const getFallbackCommentsEditor = () => {
		const docs = superdocStore.documents;
		if (!Array.isArray(docs)) return null;
		for (const doc of docs) {
			const editor = typeof doc?.getEditor === "function" ? doc.getEditor() : null;
			if (editor?.state?.doc) return editor;
		}
		return null;
	};
	const syncResolvedCommentsWithDocument = ({ editor } = {}) => {
		const documentState = collectStandardCommentDocumentState(editor ?? getFallbackCommentsEditor());
		const docPositions = editorCommentPositions.value || {};
		const activeKeys = new Set(Object.keys(docPositions));
		if (!documentState && !activeKeys.size) return 0;
		let changed = 0;
		commentsList.value.forEach((comment) => {
			if (!isEditorBackedComment(comment) || isTrackedChangeThread(comment)) return;
			if (documentState) {
				const aliasIds = getCommentAliasIds(comment);
				const hasLiveMark = aliasIds.some((id) => documentState.liveMarkIds.has(id));
				const hasResolvedAnchor = aliasIds.some((id) => documentState.resolvedAnchorIds.has(id));
				if (hasLiveMark && comment.resolvedTime != null) {
					clearResolvedMetadata(comment);
					changed += 1;
					return;
				}
				if (!hasLiveMark && hasResolvedAnchor && comment.resolvedTime == null && restoreResolvedMetadata(comment)) changed += 1;
				return;
			}
			const { key } = resolveCommentPositionEntry(comment);
			if (!key) return;
			if (activeKeys.has(String(key)) && comment.resolvedTime != null) {
				clearResolvedMetadata(comment);
				changed += 1;
			}
		});
		return changed;
	};
	watch(editorCommentPositions, () => {
		syncResolvedCommentsWithDocument();
	});
	watch(commentsList, () => {
		syncResolvedCommentsWithDocument();
	}, { deep: false });
	const getCommentPositionRange = (position) => {
		if (!position) return null;
		const start = position.start ?? position.pos ?? position.from;
		const end = position.end ?? position.to ?? start;
		if (!Number.isFinite(start) || !Number.isFinite(end)) return null;
		return {
			start,
			end
		};
	};
	const getCommentPosition = (commentOrId) => {
		return resolveCommentPositionEntry(commentOrId).entry ?? null;
	};
	const getCommentAnchoredText = (commentOrId, options = {}) => {
		const comment = typeof commentOrId === "object" ? commentOrId : getComment(commentOrId);
		if (!comment) return null;
		const range = getCommentPositionRange(resolveCommentPositionEntry(commentOrId).entry ?? null);
		if (!range) return null;
		const docNode = (superdocStore.getDocument(comment.fileId)?.getEditor?.())?.state?.doc;
		if (!docNode?.textBetween) return null;
		const separator = options.separator ?? " ";
		const text = docNode.textBetween(range.start, range.end, separator, separator);
		return options.trim === false ? text : text?.trim();
	};
	const getCommentAnchorData = (commentOrId, options = {}) => {
		const position = getCommentPosition(commentOrId);
		if (!position) return null;
		return {
			position,
			anchoredText: getCommentAnchoredText(commentOrId, options)
		};
	};
	const isThreadVisible = (comment) => {
		if (!isViewingMode.value) return true;
		const parent = getThreadParent(comment);
		if (!parent && comment?.parentCommentId) return false;
		return Boolean(parent?.trackedChange) || Boolean(comment?.trackedChangeParentId) ? viewingVisibility.trackChangesVisible : viewingVisibility.commentsVisible;
	};
	const setActiveComment = (superdoc, id) => {
		const activeEditor = superdoc?.activeEditor;
		if (id === void 0 || id === null) {
			clearActiveCommentSelection();
			activeEditor?.commands?.setActiveComment({ commentId: null });
			return;
		}
		const comment = getComment(id);
		if (!comment) return;
		activeComment.value = comment.commentId;
		syncActiveFloatingInstanceWithComment(comment.commentId);
		activeEditor?.commands?.setActiveComment({ commentId: activeComment.value });
	};
	const handleTrackedChangeUpdate = ({ superdoc, params, broadcastChanges = true }) => {
		const { event, changeId, trackedChangeText, trackedChangeType, trackedChangeDisplayType, deletedText, authorId, authorEmail, authorImage, date, author: authorName, importedAuthor, documentId, coords, trackedChangeStory, trackedChangeStoryKind, trackedChangeStoryLabel, trackedChangeAnchorKey } = params;
		const normalizedChangeId = changeId != null ? String(changeId) : null;
		const normalizedDocumentId = documentId != null ? String(documentId) : null;
		if (!(trackedChangeDisplayType === "tableInsert" || trackedChangeDisplayType === "tableDelete") && normalizedChangeId) {
			const effectiveDocumentId = normalizedDocumentId ?? (superdoc?.activeEditor?.options?.documentId != null ? String(superdoc.activeEditor.options.documentId) : null);
			const docState = (effectiveDocumentId ? superdocStore.getDocument(effectiveDocumentId)?.getEditor?.() : null)?.state ?? superdoc?.activeEditor?.state ?? null;
			if (docState) {
				const { ranges: tableRanges, ids: structuralIds } = computeTrackedTableSummaryForState(docState);
				const ranges = getTrackChanges(docState, normalizedChangeId);
				const inRange = tableRanges.length > 0 && ranges.length > 0 && isInlineRangeInsideTrackedTable(ranges, tableRanges);
				const isStructuralRowIdEcho = ranges.length === 0 && structuralIds.has(normalizedChangeId);
				if (inRange || isStructuralRowIdEcho) {
					pruneSuppressedInlineTableComments({
						suppressedIds: new Set([normalizedChangeId]),
						activeDocumentId: effectiveDocumentId,
						superdoc,
						broadcastChanges
					});
					return;
				}
			}
		}
		const hasStoryMetadata = trackedChangeStory !== void 0 || trackedChangeStoryKind !== void 0 || trackedChangeStoryLabel !== void 0 || trackedChangeAnchorKey !== void 0;
		const normalizedTrackedChangeStory = hasStoryMetadata ? trackedChangeStory ?? null : BODY_TRACKED_CHANGE_STORY;
		const normalizedTrackedChangeStoryKind = hasStoryMetadata ? trackedChangeStoryKind ?? null : "body";
		const normalizedTrackedChangeStoryLabel = hasStoryMetadata && trackedChangeStoryLabel !== void 0 ? trackedChangeStoryLabel : "";
		const normalizedTrackedChangeAnchorKey = trackedChangeAnchorKey !== void 0 ? trackedChangeAnchorKey ?? null : hasStoryMetadata ? null : buildBodyTrackedChangeAnchorKey(normalizedChangeId);
		const comment = getPendingComment({
			documentId,
			commentId: changeId,
			trackedChange: true,
			trackedChangeText,
			trackedChangeType,
			trackedChangeDisplayType,
			deletedText,
			createdTime: date,
			creatorId: authorId ?? null,
			creatorName: authorName,
			creatorEmail: authorEmail,
			creatorImage: authorImage,
			isInternal: false,
			importedAuthor,
			trackedChangeStory: normalizedTrackedChangeStory,
			trackedChangeStoryKind: normalizedTrackedChangeStoryKind,
			trackedChangeStoryLabel: normalizedTrackedChangeStoryLabel,
			trackedChangeAnchorKey: normalizedTrackedChangeAnchorKey,
			selection: {
				source: "super-editor",
				selectionBounds: coords
			}
		});
		const findTrackedChangeById = () => {
			const normalizedAnchorKey = normalizedTrackedChangeAnchorKey != null ? String(normalizedTrackedChangeAnchorKey) : null;
			if (!normalizedChangeId) return null;
			const matchesId = (trackedComment) => {
				if (!trackedComment) return false;
				const commentAnchorKey = trackedComment.trackedChangeAnchorKey != null ? String(trackedComment.trackedChangeAnchorKey) : null;
				if (normalizedAnchorKey && commentAnchorKey) return commentAnchorKey === normalizedAnchorKey;
				const commentId = trackedComment.commentId != null ? String(trackedComment.commentId) : null;
				const importedId = trackedComment.importedId != null ? String(trackedComment.importedId) : null;
				return commentId === normalizedChangeId || importedId === normalizedChangeId;
			};
			if (normalizedDocumentId) return commentsList.value.find((trackedComment) => matchesId(trackedComment) && belongsToTrackedChangeSyncDocument(trackedComment, normalizedDocumentId));
			return commentsList.value.find(matchesId);
		};
		const emitTrackedChangeEvent = (event$1) => {
			if (!broadcastChanges) return;
			syncCommentsToClients(superdoc, event$1);
			debounceEmit(changeId, event$1, superdoc);
		};
		const setIfChanged = (target, key, value) => {
			if (target?.[key] == null && value == null) return false;
			if (!target || shallowEqual(target[key], value)) return false;
			target[key] = value;
			return true;
		};
		const applyStoryMetadata = (target) => {
			if (!target) return false;
			let didChange = false;
			if (normalizedTrackedChangeStory !== void 0 && normalizedTrackedChangeStory !== null) didChange = setIfChanged(target, "trackedChangeStory", normalizedTrackedChangeStory) || didChange;
			if (normalizedTrackedChangeStoryKind !== void 0 && normalizedTrackedChangeStoryKind !== null) didChange = setIfChanged(target, "trackedChangeStoryKind", normalizedTrackedChangeStoryKind) || didChange;
			if (normalizedTrackedChangeStoryLabel !== void 0 && normalizedTrackedChangeStoryLabel !== "") didChange = setIfChanged(target, "trackedChangeStoryLabel", normalizedTrackedChangeStoryLabel) || didChange;
			if (normalizedTrackedChangeAnchorKey !== void 0 && normalizedTrackedChangeAnchorKey !== null) didChange = setIfChanged(target, "trackedChangeAnchorKey", normalizedTrackedChangeAnchorKey) || didChange;
			return didChange;
		};
		const applyChangedFields = (target) => {
			const fields = {
				trackedChangeText: trackedChangeText ?? null,
				trackedChangeType: trackedChangeType ?? null,
				trackedChangeDisplayType: trackedChangeDisplayType ?? null,
				deletedText: deletedText ?? null,
				creatorId: authorId ?? null,
				creatorName: authorName ?? null,
				creatorEmail: authorEmail ?? null,
				creatorImage: authorImage ?? null,
				createdTime: date ?? null
			};
			let didChange = false;
			for (const [key, value] of Object.entries(fields)) didChange = setIfChanged(target, key, value) || didChange;
			return applyStoryMetadata(target) || didChange;
		};
		const updateExistingTrackedChange = (trackedComment) => {
			const wasResolved = Boolean(trackedComment.resolvedTime || trackedComment.resolvedById || trackedComment.resolvedByEmail || trackedComment.resolvedByName);
			if (wasResolved) clearResolvedMetadata(trackedComment);
			return applyChangedFields(trackedComment) || wasResolved;
		};
		if (event === "add") {
			const existing = findTrackedChangeById();
			if (existing) {
				if (!updateExistingTrackedChange(existing)) return;
				emitTrackedChangeEvent({
					type: COMMENT_EVENTS.UPDATE,
					comment: getCommentEventPayload(existing)
				});
				return;
			}
			addComment({
				superdoc,
				comment,
				broadcastChanges
			});
		} else if (event === "update") {
			const existingTrackedChange = findTrackedChangeById();
			if (!existingTrackedChange) return;
			if (!updateExistingTrackedChange(existingTrackedChange)) return;
			emitTrackedChangeEvent({
				type: COMMENT_EVENTS.UPDATE,
				comment: getCommentEventPayload(existingTrackedChange)
			});
		} else if (event === "resolve") {
			const existingTrackedChange = findTrackedChangeById();
			const resolveArgs = {
				id: params.resolvedById ?? superdoc?.user?.id ?? null,
				email: params.resolvedByEmail ?? superdoc?.user?.email ?? null,
				name: params.resolvedByName ?? superdoc?.user?.name ?? null,
				superdoc
			};
			if (existingTrackedChange && !existingTrackedChange.resolvedTime) existingTrackedChange.resolveComment(resolveArgs);
		}
	};
	const collectTrackedChangeMarksByType = (trackedChanges = []) => ({
		insertedMark: trackedChanges.find(({ mark }) => mark?.type?.name === "trackInsert")?.mark ?? null,
		deletionMark: trackedChanges.find(({ mark }) => mark?.type?.name === "trackDelete")?.mark ?? null,
		formatMark: trackedChanges.find(({ mark }) => mark?.type?.name === "trackFormat")?.mark ?? null
	});
	const refreshTrackedChangeCommentsByIds = ({ superdoc, editor, changeIds, broadcastChanges = true }) => {
		if (!superdoc || !editor?.state || !Array.isArray(changeIds) || !changeIds.length) return;
		const documentId = editor?.options?.documentId != null ? String(editor.options.documentId) : null;
		if (!documentId) return;
		for (const changeId of new Set(changeIds.map((id) => id != null ? String(id) : null).filter(Boolean))) {
			const trackedChangesForId = getTrackChanges(editor.state, changeId);
			if (!trackedChangesForId.length) continue;
			const params = createOrUpdateTrackedChangeComment({
				event: "update",
				marks: collectTrackedChangeMarksByType(trackedChangesForId),
				nodes: [],
				newEditorState: editor.state,
				documentId,
				trackedChangesForId
			});
			if (!params) continue;
			params.trackedChangeStory = BODY_TRACKED_CHANGE_STORY;
			params.trackedChangeStoryKind = "body";
			params.trackedChangeStoryLabel = "";
			params.trackedChangeAnchorKey = buildBodyTrackedChangeAnchorKey(params.changeId ?? changeId);
			handleTrackedChangeUpdate({
				superdoc,
				params,
				broadcastChanges
			});
		}
	};
	const requestInstantSidebarAlignment = (targetY = null, threadId = null, instanceId = null) => {
		const hasTargetY = Number.isFinite(targetY);
		instantSidebarAlignmentTargetY.value = hasTargetY ? targetY : null;
		instantSidebarAlignmentThreadId.value = hasTargetY && threadId != null ? String(threadId) : null;
		const resolvedInstanceId = instanceId ?? threadId;
		instantSidebarAlignmentInstanceId.value = hasTargetY && resolvedInstanceId != null ? String(resolvedInstanceId) : null;
	};
	const peekInstantSidebarAlignment = () => {
		const targetY = instantSidebarAlignmentTargetY.value;
		return Number.isFinite(targetY) ? targetY : null;
	};
	const clearInstantSidebarAlignment = () => {
		instantSidebarAlignmentTargetY.value = null;
		instantSidebarAlignmentThreadId.value = null;
		instantSidebarAlignmentInstanceId.value = null;
	};
	const debounceEmit = (commentId, event, superdoc, delay = 1e3) => {
		if (debounceTimers[commentId]) clearTimeout(debounceTimers[commentId]);
		debounceTimers[commentId] = setTimeout(() => {
			if (superdoc) superdoc.emit("comments-update", event);
			delete debounceTimers[commentId];
		}, delay);
	};
	const getPendingSelectionSnapshot = (superdoc, selection) => {
		if (selection?.source !== "super-editor") return null;
		const editor = superdoc?.activeEditor;
		const selectionDocumentId = selection?.documentId ?? null;
		const editorDocumentId = editor?.options?.documentId ?? null;
		if (!selectionDocumentId || !editorDocumentId || selectionDocumentId !== editorDocumentId) return null;
		try {
			return editor?.doc?.selection?.current?.() ?? null;
		} catch {
			return null;
		}
	};
	const showAddComment = (superdoc, targetClientY = null) => {
		const pendingSelection = getPendingSelectionSnapshot(superdoc, superdocStore.activeSelection);
		const event = {
			type: COMMENT_EVENTS.PENDING,
			pendingSelection
		};
		superdoc.emit("comments-update", event);
		const selection = { ...superdocStore.activeSelection };
		selection.selectionBounds = { ...selection.selectionBounds };
		if (superdocStore.selectionPosition?.source && superdocStore.selectionPosition.source !== "pdf") superdocStore.selectionPosition.source = null;
		pendingComment.value = getPendingComment({
			selection,
			documentId: selection.documentId,
			parentCommentId: null
		});
		if (!superdoc.config.isInternal) pendingComment.value.isInternal = false;
		if (superdoc.activeEditor?.commands) superdoc.activeEditor.commands.insertComment({
			...pendingComment.value.getValues(),
			commentId: "pending",
			skipEmit: true
		});
		if (pendingComment.value.selection.source === "super-editor" && superdocStore.selectionPosition) superdocStore.selectionPosition.source = "super-editor";
		requestInstantSidebarAlignment(targetClientY, "pending");
		setActiveFloatingCommentInstance(null);
		activeComment.value = pendingComment.value.commentId;
	};
	const getPositionSortValue = (comment) => {
		const position = resolveCommentPositionEntry(comment).entry;
		if (!position) return null;
		if (Number.isFinite(position.start)) return position.start;
		if (Number.isFinite(position.pos)) return position.pos;
		if (Number.isFinite(position.from)) return position.from;
		if (Number.isFinite(position.to)) return position.to;
		if (Number.isFinite(position.pageIndex) && Number.isFinite(position?.bounds?.top)) return position.pageIndex * 1e6 + position.bounds.top;
		return null;
	};
	const compareByCreatedTime = (a, b) => (a.createdTime ?? 0) - (b.createdTime ?? 0);
	const compareByPosition = (a, b) => {
		const posA = getPositionSortValue(a);
		const posB = getPositionSortValue(b);
		const hasA = Number.isFinite(posA);
		const hasB = Number.isFinite(posB);
		if (hasA && hasB && posA !== posB) return posA - posB;
		if (hasA && !hasB) return -1;
		if (!hasA && hasB) return 1;
		return compareByCreatedTime(a, b);
	};
	const buildGroupedComments = (sorter) => {
		const parentComments = [];
		const resolvedComments = [];
		const childCommentMap = /* @__PURE__ */ new Map();
		commentsList.value.forEach((comment) => {
			if (!isThreadVisible(comment)) return;
			const trackedChangeParentId = shouldThreadWithTrackedChange(comment) ? comment.trackedChangeParentId : null;
			const parentId = comment.parentCommentId || trackedChangeParentId;
			if (comment.resolvedTime) resolvedComments.push(comment);
			else if (!parentId && !comment.resolvedTime) parentComments.push({ ...comment });
			else if (parentId) {
				if (!childCommentMap.has(parentId)) childCommentMap.set(parentId, []);
				childCommentMap.get(parentId).push(comment);
			}
		});
		return {
			parentComments: parentComments.sort(sorter),
			resolvedComments: resolvedComments.sort(sorter)
		};
	};
	const getGroupedComments = computed(() => buildGroupedComments(compareByCreatedTime));
	const getCommentsByPosition = computed(() => buildGroupedComments(compareByPosition));
	const hasOverlapId = (id) => overlappedIds.includes(id);
	const documentsWithConverations = computed(() => {
		return superdocStore.documents;
	});
	const getConfig = computed(() => {
		return commentsConfig;
	});
	const getCommentLocation = (selection, parent) => {
		const containerBounds = selection.getContainerLocation(parent);
		return {
			top: containerBounds.top + selection.selectionBounds.top,
			left: containerBounds.left + selection.selectionBounds.left
		};
	};
	const getPendingComment = ({ selection, documentId, parentCommentId, ...options }) => {
		return _getNewcomment({
			selection,
			documentId,
			parentCommentId,
			...options
		});
	};
	const _getNewcomment = ({ selection, documentId, parentCommentId, ...options }) => {
		let activeDocument;
		if (documentId) activeDocument = superdocStore.getDocument(documentId);
		else if (selection) activeDocument = superdocStore.getDocument(selection.documentId);
		if (!activeDocument) activeDocument = superdocStore.documents[0];
		return useComment({
			fileId: activeDocument.id,
			fileType: activeDocument.type,
			parentCommentId,
			creatorId: superdocStore.user.id,
			creatorEmail: superdocStore.user.email,
			creatorName: superdocStore.user.name,
			creatorImage: superdocStore.user.image,
			commentText: currentCommentText.value,
			selection,
			...options
		});
	};
	const removePendingComment = (superdoc) => {
		const hadPending = !!pendingComment.value;
		currentCommentText.value = "";
		pendingComment.value = null;
		superdocStore.selectionPosition = null;
		if (hadPending) clearActiveCommentSelection();
		superdoc?.activeEditor?.commands?.removeComment({ commentId: "pending" });
	};
	const addComment = ({ superdoc, comment, skipEditorUpdate = false, broadcastChanges = true }) => {
		let parentComment = commentsList.value.find((c) => c.commentId === activeComment.value);
		if (!parentComment) parentComment = comment;
		const newComment = useComment(comment.getValues());
		if (pendingComment.value) newComment.setText({
			text: currentCommentText.value,
			suppressUpdate: true
		});
		else newComment.setText({
			text: comment.commentText,
			suppressUpdate: true
		});
		newComment.selection.source = pendingComment.value?.selection?.source ?? newComment.selection.source;
		if (parentComment) newComment.isInternal = parentComment.isInternal;
		if (!superdoc.config.isInternal) newComment.isInternal = false;
		commentsList.value.push(newComment);
		removePendingComment(superdoc);
		if (!skipEditorUpdate && !comment.trackedChange && superdoc.activeEditor?.commands && !comment.parentCommentId) superdoc.activeEditor.commands.insertComment({
			...newComment.getValues(),
			skipEmit: true
		});
		const event = {
			type: COMMENT_EVENTS.ADD,
			comment: newComment.getValues()
		};
		if (broadcastChanges) {
			syncCommentsToClients(superdoc, event);
			superdoc.emit("comments-update", event);
		}
	};
	const deleteComment = ({ commentId: commentIdToDelete, superdoc }) => {
		const commentIndex = commentsList.value.findIndex((c) => c.commentId === commentIdToDelete);
		const comment = commentsList.value[commentIndex];
		if (!comment) return;
		const { commentId, importedId } = comment;
		const { fileId } = comment;
		superdoc.activeEditor?.commands?.removeComment({
			commentId,
			importedId
		});
		commentsList.value.splice(commentIndex, 1);
		const childCommentIds = commentsList.value.filter((c) => c.parentCommentId === commentId).map((c) => c.commentId || c.importedId);
		commentsList.value = commentsList.value.filter((c) => !childCommentIds.includes(c.commentId));
		if (activeComment.value === commentId || childCommentIds.includes(activeComment.value)) clearActiveCommentSelection();
		const event = {
			type: COMMENT_EVENTS.DELETED,
			comment: comment.getValues(),
			changes: [{
				key: "deleted",
				commentId,
				fileId
			}]
		};
		superdoc.emit("comments-update", event);
		syncCommentsToClients(superdoc, event);
	};
	const cancelComment = (superdoc) => {
		removePendingComment(superdoc);
	};
	const normalizeImportedCreatorName = (creatorName) => {
		if (typeof creatorName !== "string") return null;
		return creatorName.replace(/\s*\(imported\)\s*$/u, "").trim() || null;
	};
	const bootstrapImportedTrackedChangeComments = (editor, superdoc) => {
		if (!editor || !superdoc) return;
		createCommentForTrackChanges(editor, superdoc);
		syncStoryTrackedChangeComments({
			superdoc,
			editor
		});
		syncStructuralTrackedChangeComments({
			superdoc,
			editor
		});
	};
	function resetCommentsForReplacedDocument(documentId) {
		const activeDocumentId = documentId != null ? String(documentId) : null;
		if (!activeDocumentId) return;
		const removedComments = commentsList.value.filter((comment) => belongsToDocument(comment, activeDocumentId, { allowSingleDocumentMismatch: true }));
		if (!removedComments.length) return;
		const removedAliasIds = /* @__PURE__ */ new Set();
		removedComments.forEach((comment) => {
			getCommentAliasIds(comment).forEach((id) => removedAliasIds.add(id));
		});
		commentsList.value = commentsList.value.filter((comment) => !removedComments.includes(comment));
		if (removedAliasIds.size) {
			const nextPositions = { ...editorCommentPositions.value || {} };
			removedAliasIds.forEach((id) => {
				delete nextPositions[id];
			});
			editorCommentPositions.value = nextPositions;
		}
		const activeCommentId = activeComment.value != null ? String(activeComment.value) : null;
		if (activeCommentId && removedAliasIds.has(activeCommentId)) clearActiveCommentSelection();
	}
	const processLoadedDocxComments = async ({ superdoc, editor, comments, documentId, replacedFile = false }) => {
		const document$1 = superdocStore.getDocument(documentId);
		if (document$1?.commentThreadingProfile) document$1.commentThreadingProfile.value = editor?.converter?.commentThreadingProfile || null;
		if (replacedFile) resetCommentsForReplacedDocument(documentId);
		comments.forEach((comment) => {
			const textElements = Array.isArray(comment.elements) ? comment.elements : [];
			const htmlContent = getHtmlFromComment(textElements);
			if (!htmlContent && !comment.trackedChange) return;
			const creatorName = normalizeImportedCreatorName(comment.creatorName);
			const importedName = creatorName ? `${creatorName} (imported)` : null;
			addComment({
				superdoc,
				comment: useComment({
					fileId: documentId,
					fileType: document$1.type,
					docxCommentJSON: textElements.length ? textElements : null,
					commentId: comment.commentId,
					isInternal: false,
					parentCommentId: comment.parentCommentId,
					trackedChangeParentId: comment.trackedChangeParentId,
					creatorId: null,
					creatorName,
					createdTime: comment.createdTime,
					creatorEmail: comment.creatorEmail,
					importedAuthor: {
						...importedName ? { name: importedName } : {},
						email: comment.creatorEmail
					},
					commentText: htmlContent,
					resolvedTime: comment.isDone ? Date.now() : null,
					resolvedById: null,
					resolvedByEmail: comment.isDone ? comment.creatorEmail : null,
					resolvedByName: comment.isDone ? importedName || "(Imported)" : null,
					trackedChange: comment.trackedChange || false,
					trackedChangeText: comment.trackedChangeText,
					trackedChangeType: comment.trackedChangeType,
					trackedChangeDisplayType: comment.trackedChangeDisplayType,
					deletedText: comment.trackedDeletedText,
					origin: comment.origin || "word",
					threadingMethod: comment.threadingMethod,
					threadingStyleOverride: comment.threadingStyleOverride,
					threadingParentCommentId: comment.threadingParentCommentId,
					originalXmlStructure: comment.originalXmlStructure
				})
			});
		});
		if (replacedFile) {
			bootstrapImportedTrackedChangeComments(editor, superdoc);
			return;
		}
		setTimeout(() => {
			bootstrapImportedTrackedChangeComments(editor, superdoc);
		}, 0);
	};
	const createCommentForTrackChanges = (editor, superdoc, trackedChangesOverride = null, options = {}) => {
		const { reopenResolved = false, refreshExisting = false, broadcastChanges = true } = options;
		const trackedChanges = trackedChangesOverride ?? getTrackChanges(editor.state);
		const groupedChanges = groupChanges(trackedChanges);
		const activeDocumentId = editor?.options?.documentId != null ? String(editor.options.documentId) : null;
		if (!activeDocumentId) return;
		const skipIds = /* @__PURE__ */ new Set();
		const existingTrackedChangeById = /* @__PURE__ */ new Map();
		commentsList.value.forEach((comment) => {
			if (!comment?.trackedChange) return;
			if (!belongsToTrackedChangeSyncDocument(comment, activeDocumentId)) return;
			if (!isBodyTrackedChangeComment(comment)) return;
			const commentIds = [comment.commentId, comment.importedId].map((id) => id != null ? String(id) : null).filter(Boolean);
			if (comment.resolvedTime) {
				if (!reopenResolved) commentIds.forEach((id) => skipIds.add(id));
				return;
			}
			commentIds.forEach((id) => {
				existingTrackedChangeById.set(id, comment);
				if (!refreshExisting) skipIds.add(id);
			});
		});
		const changesByIdMap = /* @__PURE__ */ new Map();
		for (const change of trackedChanges) {
			const id = change.mark.attrs.id;
			if (!changesByIdMap.has(id)) changesByIdMap.set(id, []);
			changesByIdMap.get(id).push(change);
		}
		const documentId = activeDocumentId;
		const processedIds = /* @__PURE__ */ new Set();
		groupedChanges.forEach(({ insertedMark, deletionMark, formatMark }) => {
			const id = insertedMark?.mark.attrs.id || deletionMark?.mark.attrs.id || formatMark?.mark.attrs.id;
			if (id == null) return;
			const normalizedId = String(id);
			if (processedIds.has(normalizedId)) return;
			processedIds.add(normalizedId);
			if (!refreshExisting && skipIds.has(normalizedId)) return;
			const existingTrackedChange = existingTrackedChangeById.get(normalizedId);
			const marks = {
				...insertedMark && { insertedMark: insertedMark.mark },
				...deletionMark && { deletionMark: deletionMark.mark },
				...formatMark && { formatMark: formatMark.mark }
			};
			const params = createOrUpdateTrackedChangeComment({
				event: existingTrackedChange ? "update" : "add",
				marks,
				nodes: [],
				newEditorState: editor.state,
				documentId,
				trackedChangesForId: changesByIdMap.get(id) || []
			});
			if (params) {
				const anchorKey = buildBodyTrackedChangeAnchorKey(params.changeId ?? id);
				params.trackedChangeStory = BODY_TRACKED_CHANGE_STORY;
				params.trackedChangeStoryKind = "body";
				params.trackedChangeStoryLabel = "";
				params.trackedChangeAnchorKey = anchorKey;
				handleTrackedChangeUpdate({
					superdoc,
					params,
					broadcastChanges
				});
				if (!existingTrackedChange) {
					skipIds.add(normalizedId);
					if (params.changeId != null) skipIds.add(String(params.changeId));
					if (params.importedId != null) skipIds.add(String(params.importedId));
				}
			}
		});
		const { tr } = editor.view.state;
		tr.setMeta(CommentsPluginKey, { type: "force" });
		editor.view.dispatch(tr);
	};
	const pruneSuppressedInlineTableComments = ({ suppressedIds, activeDocumentId, superdoc = null, broadcastChanges = true }) => {
		if (!(suppressedIds instanceof Set) || !suppressedIds.size || !activeDocumentId) return;
		const removedComments = [];
		commentsList.value = commentsList.value.filter((comment) => {
			if (!comment?.trackedChange) return true;
			if (!isBodyTrackedChangeComment(comment)) return true;
			if (isStructuralTableBubble(comment)) return true;
			if (!belongsToTrackedChangeSyncDocument(comment, activeDocumentId)) return true;
			const commentId = comment.commentId != null ? String(comment.commentId) : null;
			const importedId = comment.importedId != null ? String(comment.importedId) : null;
			if (!(commentId && suppressedIds.has(commentId) || importedId && suppressedIds.has(importedId))) return true;
			removedComments.push(comment);
			return false;
		});
		if (!removedComments.length) return;
		const removedIds = /* @__PURE__ */ new Set();
		removedComments.forEach((comment) => {
			if (comment.commentId != null) removedIds.add(String(comment.commentId));
			if (comment.importedId != null) removedIds.add(String(comment.importedId));
			const payload = getCommentEventPayload(comment);
			const event = {
				type: COMMENT_EVENTS.DELETED,
				comment: payload,
				changes: [{
					key: "deleted",
					commentId: payload.commentId,
					fileId: payload.fileId
				}]
			};
			if (broadcastChanges) {
				syncCommentsToClients(superdoc, event);
				superdoc?.emit?.("comments-update", event);
			}
		});
		const activeCommentId = activeComment.value != null ? String(activeComment.value) : null;
		if (activeCommentId && removedIds.has(activeCommentId)) clearActiveCommentSelection();
	};
	const getCommentDocumentId = (comment) => {
		if (!comment) return null;
		if (comment.fileId != null) return String(comment.fileId);
		if (comment.documentId != null) return String(comment.documentId);
		if (comment.selection?.documentId != null) return String(comment.selection.documentId);
		return null;
	};
	const getOpenDocuments = () => {
		const docs = Array.isArray(superdocStore.documents) ? superdocStore.documents : superdocStore.documents?.value;
		return Array.isArray(docs) ? docs : [];
	};
	const getSingleOpenDocumentId = () => {
		const docs = getOpenDocuments();
		if (docs.length !== 1) return null;
		return docs[0]?.id != null ? String(docs[0].id) : null;
	};
	const belongsToDocument = (comment, activeDocumentId, options = {}) => {
		const { allowSingleDocumentMismatch = false } = options;
		if (!activeDocumentId) return false;
		const commentDocumentId = getCommentDocumentId(comment);
		if (commentDocumentId) {
			if (commentDocumentId === activeDocumentId) return true;
			const singleOpenDocumentId = getSingleOpenDocumentId();
			return allowSingleDocumentMismatch && singleOpenDocumentId === activeDocumentId;
		}
		return getSingleOpenDocumentId() === activeDocumentId;
	};
	const belongsToTrackedChangeSyncDocument = (comment, activeDocumentId) => {
		return belongsToDocument(comment, activeDocumentId, { allowSingleDocumentMismatch: true });
	};
	const pruneStaleTrackedChangeComments = (liveTrackedChangeIds, liveTrackedChangeAnchorKeys, activeDocumentId, superdoc = null, { broadcastChanges = true } = {}) => {
		if (!(liveTrackedChangeIds instanceof Set) || !activeDocumentId) return;
		const removedIds = /* @__PURE__ */ new Set();
		const restoredComments = [];
		const previousComments = [...commentsList.value];
		commentsList.value = commentsList.value.filter((comment) => {
			if (!comment?.trackedChange) return true;
			if (!belongsToTrackedChangeSyncDocument(comment, activeDocumentId)) return true;
			const commentId = comment.commentId != null ? String(comment.commentId) : null;
			const importedId = comment.importedId != null ? String(comment.importedId) : null;
			const anchorKey = comment.trackedChangeAnchorKey != null ? String(comment.trackedChangeAnchorKey) : null;
			const hasLiveCommentId = Boolean(commentId && liveTrackedChangeIds.has(commentId));
			const hasLiveImportedId = Boolean(importedId && liveTrackedChangeIds.has(importedId));
			const hasLiveAnchorKey = Boolean(anchorKey && liveTrackedChangeAnchorKeys?.has(anchorKey));
			if (!commentId && !importedId && !anchorKey || hasLiveCommentId || hasLiveImportedId || hasLiveAnchorKey) return true;
			if (comment.resolvedTime) return true;
			const resolutionSnapshot = trackedChangeResolutionSnapshots.get(comment);
			if (resolutionSnapshot) {
				comment.resolvedTime = resolutionSnapshot.resolvedTime ?? Date.now();
				comment.resolvedById = resolutionSnapshot.resolvedById ?? null;
				comment.resolvedByEmail = resolutionSnapshot.resolvedByEmail ?? null;
				comment.resolvedByName = resolutionSnapshot.resolvedByName ?? null;
				restoredComments.push(comment);
				return true;
			}
			if (commentId) removedIds.add(commentId);
			if (importedId) removedIds.add(importedId);
			return false;
		});
		restoredComments.forEach((comment) => {
			const payload = getCommentEventPayload(comment);
			const event = {
				type: COMMENT_EVENTS.UPDATE,
				comment: payload
			};
			if (broadcastChanges) {
				syncCommentsToClients(superdoc, event);
				superdoc?.emit?.("comments-update", event);
			}
		});
		if (!removedIds.size) return;
		let didRemoveDescendants = true;
		while (didRemoveDescendants) {
			didRemoveDescendants = false;
			commentsList.value = commentsList.value.filter((comment) => {
				if (!belongsToTrackedChangeSyncDocument(comment, activeDocumentId)) return true;
				const parentCommentId = comment.parentCommentId != null ? String(comment.parentCommentId) : null;
				const trackedChangeParentId = comment.trackedChangeParentId != null ? String(comment.trackedChangeParentId) : null;
				if (!(parentCommentId && removedIds.has(parentCommentId) || trackedChangeParentId && removedIds.has(trackedChangeParentId))) return true;
				const commentId = comment.commentId != null ? String(comment.commentId) : null;
				const importedId = comment.importedId != null ? String(comment.importedId) : null;
				if (commentId) removedIds.add(commentId);
				if (importedId) removedIds.add(importedId);
				didRemoveDescendants = true;
				return false;
			});
		}
		previousComments.filter((comment) => {
			if (!belongsToTrackedChangeSyncDocument(comment, activeDocumentId)) return false;
			const commentId = comment.commentId != null ? String(comment.commentId) : null;
			const importedId = comment.importedId != null ? String(comment.importedId) : null;
			return commentId && removedIds.has(commentId) || importedId && removedIds.has(importedId);
		}).forEach((comment) => {
			const payload = getCommentEventPayload(comment);
			const event = {
				type: COMMENT_EVENTS.DELETED,
				comment: payload,
				changes: [{
					key: "deleted",
					commentId: payload.commentId,
					fileId: payload.fileId
				}]
			};
			if (broadcastChanges) {
				syncCommentsToClients(superdoc, event);
				superdoc?.emit?.("comments-update", event);
			}
		});
		const activeCommentId = activeComment.value != null ? String(activeComment.value) : null;
		const activeCommentBelongsToActiveDocument = previousComments.some((comment) => {
			const commentId = comment.commentId != null ? String(comment.commentId) : null;
			const importedId = comment.importedId != null ? String(comment.importedId) : null;
			return belongsToTrackedChangeSyncDocument(comment, activeDocumentId) && (commentId && commentId === activeCommentId || importedId && importedId === activeCommentId);
		});
		if (activeCommentId && removedIds.has(activeCommentId) && activeCommentBelongsToActiveDocument) clearActiveCommentSelection();
	};
	const decideTrackedChangeFromSidebar = ({ superdoc, comment, decision }) => {
		if (!comment?.trackedChange) return { ok: false };
		const activeEditor = superdoc?.activeEditor;
		if (!activeEditor) return { ok: false };
		const id = comment.commentId ?? comment.importedId;
		if (!id) return { ok: false };
		const story = comment.trackedChangeStory ?? void 0;
		const documentApi = typeof activeEditor.doc === "object" ? activeEditor.doc : null;
		if (documentApi?.trackChanges?.decide) try {
			const target = story ? {
				id,
				story
			} : { id };
			const receipt = documentApi.trackChanges.decide({
				decision,
				target
			});
			return {
				ok: true,
				success: Boolean(receipt?.success)
			};
		} catch (error) {
			if (story) return {
				ok: false,
				error
			};
		}
		const commandName = decision === "accept" ? "acceptTrackedChangeById" : "rejectTrackedChangeById";
		const command = activeEditor.commands?.[commandName];
		if (typeof command !== "function") return { ok: false };
		return {
			ok: true,
			success: Boolean(command(id))
		};
	};
	const syncTrackedChangeComments = ({ superdoc, editor, broadcastChanges = true }) => {
		if (!superdoc || !editor) return;
		const activeDocumentId = editor?.options?.documentId != null ? String(editor.options.documentId) : null;
		if (!activeDocumentId) return;
		const trackedChanges = getTrackChanges(editor.state);
		const liveTrackedChangeIds = /* @__PURE__ */ new Set();
		trackedChanges.forEach((change) => {
			const id = change?.mark?.attrs?.id;
			if (id == null) return;
			liveTrackedChangeIds.add(String(id));
		});
		const trackedChangeIndex = typeof getTrackedChangeIndex === "function" ? getTrackedChangeIndex(editor) : null;
		let storySnapshots = [];
		try {
			storySnapshots = trackedChangeIndex?.getAll?.() ?? [];
		} catch {}
		pruneStaleTrackedChangeComments(liveTrackedChangeIds, new Set(storySnapshots.map((snapshot) => snapshot?.anchorKey).filter((anchorKey) => typeof anchorKey === "string" && anchorKey.length > 0)), activeDocumentId, superdoc, { broadcastChanges });
		createCommentForTrackChanges(editor, superdoc, trackedChanges, {
			reopenResolved: true,
			refreshExisting: true,
			broadcastChanges
		});
		syncStoryTrackedChangeComments({
			superdoc,
			editor,
			broadcastChanges,
			snapshots: storySnapshots
		});
		syncStructuralTrackedChangeComments({
			superdoc,
			editor,
			broadcastChanges
		});
	};
	const syncStructuralTrackedChangeComments = ({ superdoc, editor, broadcastChanges = true }) => {
		const activeDocumentId = editor?.options?.documentId != null ? String(editor.options.documentId) : null;
		if (!activeDocumentId) return;
		const enumerate = enumerateStructuralRowChanges;
		if (typeof enumerate !== "function") return;
		let structuralChanges = [];
		try {
			structuralChanges = enumerate(editor.state) ?? [];
		} catch {
			structuralChanges = [];
		}
		for (const structural of structuralChanges) {
			if (!structural?.decidable || !structural?.wholeTable) continue;
			const publicId = buildStructuralTrackedChangeId(structural);
			if (!publicId) continue;
			const anchorKey = buildBodyTrackedChangeAnchorKey(publicId);
			const displayType = structural.subtype === "table-insert" ? "tableInsert" : "tableDelete";
			const trackedChangeType = structural.side === "insertion" ? "trackInsert" : "trackDelete";
			const normalizedPublicId = String(publicId);
			const normalizedAnchorKey = anchorKey != null ? String(anchorKey) : null;
			handleTrackedChangeUpdate({
				superdoc,
				params: {
					event: commentsList.value.find((comment) => {
						if (!comment?.trackedChange) return false;
						if (!belongsToTrackedChangeSyncDocument(comment, activeDocumentId)) return false;
						const commentAnchorKey = comment.trackedChangeAnchorKey != null ? String(comment.trackedChangeAnchorKey) : null;
						if (normalizedAnchorKey && commentAnchorKey) return commentAnchorKey === normalizedAnchorKey;
						const commentId = comment.commentId != null ? String(comment.commentId) : null;
						const importedId = comment.importedId != null ? String(comment.importedId) : null;
						return commentId === normalizedPublicId || importedId === normalizedPublicId;
					}) ? "update" : "add",
					changeId: publicId,
					trackedChangeText: "",
					trackedChangeType,
					trackedChangeDisplayType: displayType,
					deletedText: null,
					authorId: null,
					authorEmail: structural.authorEmail || null,
					authorImage: structural.authorImage || null,
					date: structural.date || null,
					author: structural.author || null,
					importedAuthor: structural.importedAuthor ? { name: structural.importedAuthor } : null,
					documentId: activeDocumentId,
					coords: null,
					trackedChangeStory: BODY_TRACKED_CHANGE_STORY,
					trackedChangeStoryKind: "body",
					trackedChangeStoryLabel: "",
					trackedChangeAnchorKey: anchorKey
				},
				broadcastChanges
			});
		}
	};
	const syncStoryTrackedChangeComments = ({ superdoc, editor, broadcastChanges = true, snapshots = null }) => {
		const activeDocumentId = editor?.options?.documentId != null ? String(editor.options.documentId) : null;
		if (!activeDocumentId) return;
		let resolvedSnapshots = snapshots;
		if (!Array.isArray(resolvedSnapshots)) {
			if (typeof getTrackedChangeIndex !== "function") return;
			const index = getTrackedChangeIndex(editor);
			if (!index) return;
			try {
				resolvedSnapshots = index.getAll();
			} catch {
				return;
			}
		}
		for (const snapshot of resolvedSnapshots) {
			if (snapshot.storyKind === "body") continue;
			upsertStoryTrackedChangeComment({
				superdoc,
				editor,
				snapshot,
				documentId: activeDocumentId,
				broadcastChanges
			});
		}
	};
	const getStoryTrackedChangeDisplayType = (snapshot) => {
		if (snapshot?.type !== "structural") return snapshot?.type ?? null;
		return snapshot?.subtype === "table-delete" ? "tableDelete" : "tableInsert";
	};
	const getStoryTrackedChangeType = (snapshot) => {
		if (snapshot?.type !== "structural") return snapshot?.type ?? null;
		return snapshot?.subtype === "table-delete" ? "trackDelete" : "trackInsert";
	};
	const isStoryTrackedChangeDeletion = (snapshot) => {
		if (!snapshot) return false;
		if (snapshot.type === "delete") return true;
		return snapshot.type === "structural" && snapshot.subtype === "table-delete";
	};
	const buildStoryTrackedChangeParams = ({ editor, snapshot, documentId, event }) => {
		const trackedChangeType = getStoryTrackedChangeType(snapshot);
		const trackedChangeDisplayType = getStoryTrackedChangeDisplayType(snapshot);
		const fallbackParams = {
			event,
			changeId: snapshot.runtimeRef.rawId,
			trackedChangeText: isStoryTrackedChangeDeletion(snapshot) ? "" : snapshot.excerpt ?? "",
			trackedChangeType,
			trackedChangeDisplayType,
			deletedText: isStoryTrackedChangeDeletion(snapshot) ? snapshot.excerpt ?? "" : null,
			authorId: snapshot.authorId,
			authorEmail: snapshot.authorEmail,
			authorImage: snapshot.authorImage,
			date: snapshot.date,
			author: snapshot.author,
			documentId,
			coords: null,
			trackedChangeStory: snapshot.story,
			trackedChangeStoryKind: snapshot.storyKind,
			trackedChangeStoryLabel: snapshot.storyLabel,
			trackedChangeAnchorKey: snapshot.anchorKey
		};
		if (typeof resolveTrackedChangeInStory !== "function") return fallbackParams;
		let resolvedChange = null;
		try {
			resolvedChange = resolveTrackedChangeInStory(editor, {
				kind: "entity",
				entityType: "trackedChange",
				entityId: snapshot.runtimeRef.rawId,
				story: snapshot.story
			});
		} catch {
			resolvedChange = null;
		}
		const storyEditorState = resolvedChange?.editor?.state ?? null;
		if (!storyEditorState) return fallbackParams;
		let trackedChangesForId = [];
		try {
			trackedChangesForId = getTrackChanges(storyEditorState, resolvedChange.change.rawId) ?? [];
		} catch {
			trackedChangesForId = [];
		}
		const resolvedParams = createOrUpdateTrackedChangeComment({
			event,
			marks: collectTrackedChangeMarksByType(trackedChangesForId),
			nodes: [],
			newEditorState: storyEditorState,
			documentId,
			trackedChangesForId
		});
		if (!resolvedParams) return fallbackParams;
		resolvedParams.trackedChangeStory = snapshot.story;
		resolvedParams.trackedChangeStoryKind = snapshot.storyKind;
		resolvedParams.trackedChangeStoryLabel = snapshot.storyLabel;
		resolvedParams.trackedChangeAnchorKey = snapshot.anchorKey;
		return resolvedParams;
	};
	const upsertStoryTrackedChangeComment = ({ superdoc, editor, snapshot, documentId, broadcastChanges }) => {
		if (!snapshot?.runtimeRef?.rawId) return;
		const existingComment = commentsList.value.find((comment) => {
			if (!comment?.trackedChange) return false;
			const commentAnchorKey = comment.trackedChangeAnchorKey != null ? String(comment.trackedChangeAnchorKey) : null;
			if (commentAnchorKey && snapshot.anchorKey) return commentAnchorKey === snapshot.anchorKey;
			if (commentAnchorKey || snapshot.anchorKey) return false;
			return comment.commentId === snapshot.runtimeRef.rawId || comment.importedId === snapshot.runtimeRef.rawId;
		});
		handleTrackedChangeUpdate({
			superdoc,
			params: buildStoryTrackedChangeParams({
				editor,
				snapshot,
				documentId,
				event: existingComment ? "update" : "add"
			}),
			broadcastChanges
		});
		if (existingComment) {
			existingComment.trackedChangeStory = snapshot.story;
			existingComment.trackedChangeStoryKind = snapshot.storyKind;
			existingComment.trackedChangeStoryLabel = snapshot.storyLabel;
			existingComment.trackedChangeAnchorKey = snapshot.anchorKey;
		}
	};
	const normalizeDocxSchemaForExport = (value) => {
		if (!value) return [];
		return (Array.isArray(value) ? value : [value]).filter(Boolean);
	};
	const translateCommentsForExport = () => {
		const processedComments = [];
		commentsList.value.forEach((comment) => {
			const values = comment.getValues();
			const richText = values.commentText;
			const docxSchema = normalizeDocxSchemaForExport(values.docxCommentJSON);
			const schema = docxSchema.length ? docxSchema : convertHtmlToSchema(richText);
			processedComments.push({
				...values,
				commentJSON: schema
			});
		});
		return processedComments;
	};
	const convertHtmlToSchema = (commentHTML) => {
		const json = new Editor({
			mode: "text",
			isHeadless: true,
			content: commentHTML,
			extensions: getRichTextExtensions()
		}).getJSON();
		return Array.isArray(json?.content) ? json.content.filter(Boolean) : [];
	};
	const handleEditorLocationsUpdate = (allCommentPositions) => {
		if (allCommentPositions == null) return;
		const normalizedPositions = {};
		Object.entries(allCommentPositions).forEach(([key, entry]) => {
			normalizedPositions[key] = entry;
			const rawTrackedChangeKey = entry?.kind === "trackedChange" && entry?.storyKey === "body" && entry?.threadId != null ? String(entry.threadId) : null;
			if (rawTrackedChangeKey && normalizedPositions[rawTrackedChangeKey] === void 0) normalizedPositions[rawTrackedChangeKey] = entry;
			const canonicalKey = typeof entry?.key === "string" ? entry.key : null;
			if (canonicalKey && normalizedPositions[canonicalKey] === void 0) normalizedPositions[canonicalKey] = entry;
		});
		editorCommentPositions.value = normalizedPositions;
	};
	const clearEditorCommentPositions = () => {
		editorCommentPositions.value = {};
	};
	const isStructuralTableBubble = (comment) => {
		if (!comment?.trackedChange) return false;
		const displayType = comment?.trackedChangeDisplayType;
		if (displayType === "tableInsert" || displayType === "tableDelete") return true;
		return [
			comment?.commentId,
			comment?.importedId,
			comment?.trackedChangeAnchorKey
		].map((id) => id != null ? String(id) : "").filter(Boolean).some((id) => id.includes("word:structural:"));
	};
	const trackedTableSummaryCache = /* @__PURE__ */ new WeakMap();
	const computeTrackedTableSummaryForState = (state) => {
		if (!state) return {
			ranges: [],
			ids: /* @__PURE__ */ new Set()
		};
		const cached = trackedTableSummaryCache.get(state);
		if (cached) return cached;
		const ranges = [];
		const ids = /* @__PURE__ */ new Set();
		const add = (value) => {
			if (value != null && value !== "") ids.add(String(value));
		};
		const enumerate = enumerateStructuralRowChanges;
		if (typeof enumerate === "function") {
			let structuralChanges = [];
			try {
				structuralChanges = enumerate(state) ?? [];
			} catch {
				structuralChanges = [];
			}
			for (const change of structuralChanges) {
				if (!change?.decidable || !change?.wholeTable) continue;
				const from = Number(change.tableFrom);
				const to = Number(change.tableTo);
				if (Number.isFinite(from) && Number.isFinite(to)) ranges.push({
					from,
					to
				});
				add(change.id);
				add(change.revisionId);
				add(change.revisionGroupId);
				add(change.sourceId);
				for (const row of change.rows || []) {
					const tc = row?.node?.attrs?.trackChange;
					add(tc?.id);
					add(tc?.sourceId);
				}
			}
		}
		const summary = {
			ranges,
			ids
		};
		trackedTableSummaryCache.set(state, summary);
		return summary;
	};
	const getTrackedTableRangesForDocument = (fileId) => {
		const editor = superdocStore.getDocument(fileId)?.getEditor?.();
		return computeTrackedTableSummaryForState(editor?.state).ranges;
	};
	const isInlineRangeInsideTrackedTable = (changeRanges, tableRanges) => {
		if (!tableRanges?.length || !changeRanges?.length) return false;
		return changeRanges.every((seg) => {
			const start = Number(seg?.from);
			const end = Number(seg?.to);
			if (!Number.isFinite(start) || !Number.isFinite(end)) return false;
			return tableRanges.some((table) => start >= table.from && end <= table.to);
		});
	};
	const isInlineTrackedChangeInsideTrackedTable = (comment) => {
		if (!comment?.trackedChange) return false;
		if (isStructuralTableBubble(comment)) return false;
		const ranges = getTrackedTableRangesForDocument(comment?.fileId);
		if (!ranges.length) return false;
		const entry = resolveCommentPositionEntry(comment).entry;
		const range = getCommentPositionRange(entry);
		if (!range) return false;
		return ranges.some((table) => range.start >= table.from && range.end <= table.to);
	};
	const getFloatingComments = computed(() => {
		return getGroupedComments.value?.parentComments.filter((c) => !c.resolvedTime).filter((c) => {
			if (!isEditorBackedComment(c)) return true;
			return Boolean(resolveCommentPositionEntry(c).entry);
		}).filter((c) => !isInlineTrackedChangeInsideTrackedTable(c));
	});
	const getFloatingCommentInstances = computed(() => {
		return getFloatingComments.value.flatMap((comment) => {
			const { key, entry } = resolveCommentPositionEntry(comment);
			return buildFloatingCommentInstances({
				comment,
				positionKey: key,
				positionEntry: entry,
				fallbackId: getCommentAliasIds(comment)[0] ?? normalizeCommentId(comment?.commentId) ?? null
			});
		});
	});
	const normalizeFloatingCommentInstanceId = (instanceId) => {
		return instanceId == null ? null : String(instanceId);
	};
	const setActiveFloatingCommentInstance = (instanceId = null) => {
		activeFloatingCommentInstanceId.value = normalizeFloatingCommentInstanceId(instanceId);
	};
	const clearActiveCommentSelection = () => {
		activeComment.value = null;
		setActiveFloatingCommentInstance(null);
	};
	const doesFloatingInstanceBelongToComment = (instanceId, commentId) => {
		if (instanceId == null || commentId == null) return false;
		return getFloatingCommentInstances.value.some((instance) => String(instance.id) === String(instanceId) && String(instance.comment?.commentId ?? instance.threadId ?? "") === String(commentId));
	};
	const syncActiveFloatingInstanceWithComment = (commentId) => {
		if (!doesFloatingInstanceBelongToComment(activeFloatingCommentInstanceId.value, commentId)) setActiveFloatingCommentInstance(null);
	};
	const setViewingVisibility = ({ documentMode, commentsVisible, trackChangesVisible } = {}) => {
		if (typeof documentMode === "string") viewingVisibility.documentMode = documentMode;
		if (typeof commentsVisible === "boolean") viewingVisibility.commentsVisible = commentsVisible;
		if (typeof trackChangesVisible === "boolean") viewingVisibility.trackChangesVisible = trackChangesVisible;
	};
	const normalizeCommentForEditor = (node) => {
		if (Array.isArray(node)) return node.map((child) => normalizeCommentForEditor(child)).flat().filter(Boolean);
		if (!node || typeof node !== "object") return node;
		const stripTextStyleAttrs = (attrs) => {
			if (!attrs) return attrs;
			const rest = { ...attrs };
			delete rest.fontSize;
			delete rest.fontFamily;
			delete rest.eastAsiaFontFamily;
			return Object.keys(rest).length ? rest : void 0;
		};
		const normalizeMark = (mark) => {
			if (!mark) return mark;
			const typeName = typeof mark.type === "string" ? mark.type : mark.type?.name;
			const attrs = mark?.attrs ? { ...mark.attrs } : void 0;
			if (typeName === "textStyle" && attrs) return {
				...mark,
				attrs: stripTextStyleAttrs(attrs)
			};
			return {
				...mark,
				attrs
			};
		};
		const cloneMarks = (marks) => Array.isArray(marks) ? marks.filter(Boolean).map((mark) => normalizeMark(mark)) : void 0;
		const cloneAttrs = (attrs) => attrs && typeof attrs === "object" ? { ...attrs } : void 0;
		if (!Array.isArray(node.content)) return {
			type: node.type,
			...node.text !== void 0 ? { text: node.text } : {},
			...node.attrs ? { attrs: cloneAttrs(node.attrs) } : {},
			...node.marks ? { marks: cloneMarks(node.marks) } : {}
		};
		const normalizedChildren = node.content.map((child) => normalizeCommentForEditor(child)).flat().filter(Boolean);
		if (node.type === "run") return normalizedChildren;
		return {
			type: node.type,
			...node.attrs ? { attrs: cloneAttrs(node.attrs) } : {},
			...node.marks ? { marks: cloneMarks(node.marks) } : {},
			content: normalizedChildren
		};
	};
	const getHtmlFromComment = (commentTextElements) => {
		const elementsArray = Array.isArray(commentTextElements) ? commentTextElements : commentTextElements ? [commentTextElements] : [];
		if (!elementsArray.some((element) => element?.content?.length)) return;
		try {
			const normalizedContent = normalizeCommentForEditor(elementsArray);
			const contentArray = Array.isArray(normalizedContent) ? normalizedContent : normalizedContent ? [normalizedContent] : [];
			if (!contentArray.length) return null;
			return new Editor({
				mode: "text",
				isHeadless: true,
				content: {
					type: "doc",
					content: contentArray
				},
				loadFromSchema: true,
				extensions: getRichTextExtensions()
			}).getHTML();
		} catch (error) {
			console.warn("Failed to convert comment", error);
			return;
		}
	};
	return {
		COMMENT_EVENTS,
		isDebugging,
		hasInitializedComments,
		hasSyncedCollaborationComments,
		editingCommentId,
		activeComment,
		activeFloatingCommentInstanceId,
		commentDialogs,
		overlappingComments,
		overlappedIds,
		suppressInternalExternal,
		pendingComment,
		currentCommentText,
		commentsList,
		isCommentsListVisible,
		generalCommentIds,
		editorCommentIds,
		commentsParentElement,
		editorCommentPositions,
		hasInitializedLocations,
		isCommentHighlighted,
		floatingCommentsOffset,
		sortedConversations,
		visibleConversations,
		skipSelectionUpdate,
		isFloatingCommentsReady,
		instantSidebarAlignmentTargetY,
		instantSidebarAlignmentThreadId,
		instantSidebarAlignmentInstanceId,
		getConfig,
		documentsWithConverations,
		getGroupedComments,
		getCommentsByPosition,
		getFloatingComments,
		getFloatingCommentInstances,
		getCommentAliasIds,
		getCommentPositionKey,
		getCommentPosition,
		getCommentAnchoredText,
		getCommentAnchorData,
		resolveCommentPositionEntry,
		getCommentDocumentId,
		belongsToDocument,
		init,
		setViewingVisibility,
		getComment,
		setActiveComment,
		getCommentLocation,
		hasOverlapId,
		getPendingComment,
		showAddComment,
		addComment,
		cancelComment,
		deleteComment,
		removePendingComment,
		processLoadedDocxComments,
		translateCommentsForExport,
		handleEditorLocationsUpdate,
		clearEditorCommentPositions,
		handleTrackedChangeUpdate,
		refreshTrackedChangeCommentsByIds,
		syncResolvedCommentsWithDocument,
		syncTrackedChangePositionsWithDocument,
		setActiveFloatingCommentInstance,
		requestInstantSidebarAlignment,
		peekInstantSidebarAlignment,
		clearInstantSidebarAlignment,
		syncTrackedChangeComments,
		decideTrackedChangeFromSidebar
	};
});
const superdocIcons = {
	comment: comment_solid_default,
	caretDown: caret_down_solid_default,
	internal: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z\"/></svg>",
	external: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=\"M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z\"/></svg>",
	markDone: check_solid_default,
	acceptChange: check_solid_default,
	rejectChange: xmark_solid_default,
	overflow: ellipsis_vertical_solid_default
};
var COMMENT_FOCUS_VIEWPORT_RATIO = .38;
var COMMENT_HIGHLIGHT_SELECTOR$1 = ".superdoc-comment-highlight";
var isElementVisibleInViewport = (element) => {
	if (typeof element?.getBoundingClientRect !== "function") return false;
	const bounds = element.getBoundingClientRect();
	if (!Number.isFinite(bounds.top) || !Number.isFinite(bounds.bottom)) return false;
	return bounds.bottom > 0 && bounds.top < window.innerHeight;
};
var parseCommaSeparated = (value) => {
	if (!value) return [];
	return value.split(",").map((entry) => entry.trim()).filter(Boolean);
};
var parseImportedIdMap = (value) => {
	const ids = [];
	if (!value) return ids;
	value.split(",").forEach((entry) => {
		const separatorIndex = entry.indexOf("=");
		if (separatorIndex <= 0) return;
		ids.push(entry.slice(0, separatorIndex), entry.slice(separatorIndex + 1));
	});
	return ids.filter(Boolean);
};
const getPreferredCommentFocusTargetClientY = () => {
	return Math.round(window.innerHeight * COMMENT_FOCUS_VIEWPORT_RATIO);
};
const getVisibleThreadAnchorClientY = (layersElement, positionEntry) => {
	const anchorTop = positionEntry?.bounds?.top;
	if (!Number.isFinite(anchorTop) || typeof layersElement?.getBoundingClientRect !== "function") return null;
	const anchorClientY = layersElement.getBoundingClientRect().top + anchorTop;
	if (anchorClientY < 0 || anchorClientY >= window.innerHeight) return null;
	return anchorClientY;
};
const getVisibleThreadHighlightClientY = (threadIds) => {
	if (typeof document === "undefined") return null;
	const candidateIds = new Set((threadIds ?? []).map((id) => String(id)).filter(Boolean));
	if (candidateIds.size === 0) return null;
	let visibleTop = null;
	const highlights = document.querySelectorAll(COMMENT_HIGHLIGHT_SELECTOR$1);
	for (const highlight of highlights) {
		const highlightIds = new Set([...parseCommaSeparated(highlight.getAttribute("data-comment-ids")), ...parseImportedIdMap(highlight.getAttribute("data-comment-imported-ids"))]);
		if (![...candidateIds].some((id) => highlightIds.has(id))) continue;
		if (!isElementVisibleInViewport(highlight)) continue;
		const highlightTop = highlight.getBoundingClientRect().top;
		if (!Number.isFinite(highlightTop)) continue;
		visibleTop = visibleTop == null ? highlightTop : Math.min(visibleTop, highlightTop);
	}
	return visibleTop;
};
const scrollThreadAnchorToFocusTarget = (presentation, primaryThreadId, fallbackThreadId, targetClientY) => {
	if (!presentation || !Number.isFinite(targetClientY)) return null;
	const tryThread = (threadId) => {
		if (!threadId) return null;
		const reachableClientY = presentation.getReachableThreadAnchorClientY(threadId, targetClientY);
		if (!Number.isFinite(reachableClientY)) return null;
		return presentation.scrollThreadAnchorToClientY(threadId, targetClientY, { behavior: "auto" }) ? reachableClientY : null;
	};
	const primaryTargetY = tryThread(primaryThreadId);
	if (Number.isFinite(primaryTargetY)) return primaryTargetY;
	if (!fallbackThreadId || fallbackThreadId === primaryThreadId) return null;
	return tryThread(fallbackThreadId);
};
const DEFAULT_UI_FONT_FAMILY = "Arial, Helvetica, sans-serif";
function useUiFontFamily() {
	const instance = getCurrentInstance();
	return { uiFontFamily: computed(() => {
		const configured = instance?.proxy?.$superdoc?.config?.uiDisplayFallbackFont;
		if (typeof configured === "string" && configured.trim()) return configured.trim();
		return DEFAULT_UI_FONT_FAMILY;
	}) };
}
var _hoisted_1$19 = { class: "comments-dropdown" };
var _hoisted_2$12 = ["onClick"];
var _hoisted_3$10 = {
	key: 0,
	class: "comments-dropdown__option-icon"
};
var _hoisted_4$4 = ["innerHTML"];
var _hoisted_5$2 = { class: "comments-dropdown__option-label" };
var CommentsDropdown_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "CommentsDropdown",
	props: {
		options: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Boolean,
			default: false
		},
		contentStyle: {
			type: Object,
			default: () => ({})
		}
	},
	emits: ["select"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const isOpen = ref(false);
		const triggerRef = ref(null);
		const menuRef = ref(null);
		const menuPosition = ref({
			top: "0px",
			left: "0px"
		});
		const menuStyle = computed(() => ({
			...props.contentStyle,
			position: "fixed",
			top: menuPosition.value.top,
			left: menuPosition.value.left,
			zIndex: 1200
		}));
		const setOpen = (value) => {
			if (props.disabled && value) return;
			isOpen.value = value;
		};
		const toggle = () => {
			if (props.disabled) return;
			setOpen(!isOpen.value);
		};
		const close = () => {
			if (!isOpen.value) return;
			setOpen(false);
		};
		const updateMenuPosition = () => {
			if (!triggerRef.value) return;
			const rect = triggerRef.value.getBoundingClientRect();
			const menuWidth = menuRef.value?.offsetWidth ?? 0;
			const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
			const gutter = 8;
			let left = rect.left;
			const maxLeft = Math.max(gutter, viewportWidth - menuWidth - gutter);
			left = Math.min(Math.max(gutter, left), maxLeft);
			menuPosition.value = {
				top: `${rect.bottom + 4}px`,
				left: `${left}px`
			};
		};
		const handleTriggerClick = (event) => {
			event.stopPropagation();
			toggle();
		};
		const onOptionClick = (option) => {
			if (option?.disabled) return;
			emit("select", option?.key, option);
			close();
		};
		const hasIcon = (option) => Boolean(option?.iconString) || Boolean(option?.icon);
		const renderIcon = (option) => {
			if (option?.iconString) return option.iconString;
			if (typeof option?.icon === "function") return option.icon(option);
			return option?.icon || null;
		};
		const OptionIcon = defineComponent({
			name: "CommentsDropdownOptionIcon",
			props: { option: {
				type: Object,
				required: true
			} },
			setup(componentProps) {
				return () => renderIcon(componentProps.option);
			}
		});
		const handlePointerDown = (event) => {
			if (!isOpen.value) return;
			const target = event.target;
			if (!(target instanceof Element)) return;
			const insideTrigger = triggerRef.value?.contains(target);
			const insideMenu = menuRef.value?.contains(target);
			if (insideTrigger || insideMenu) return;
			close();
		};
		const handleEscape = (event) => {
			if (event.key !== "Escape") return;
			close();
		};
		watch(isOpen, async (open$1) => {
			if (!open$1) return;
			await nextTick();
			updateMenuPosition();
		});
		watch(isOpen, (open$1) => {
			if (open$1) {
				document.addEventListener("pointerdown", handlePointerDown, true);
				document.addEventListener("keydown", handleEscape, true);
				window.addEventListener("resize", updateMenuPosition);
				window.addEventListener("scroll", updateMenuPosition, true);
			} else {
				document.removeEventListener("pointerdown", handlePointerDown, true);
				document.removeEventListener("keydown", handleEscape, true);
				window.removeEventListener("resize", updateMenuPosition);
				window.removeEventListener("scroll", updateMenuPosition, true);
			}
		});
		onBeforeUnmount(() => {
			document.removeEventListener("pointerdown", handlePointerDown, true);
			document.removeEventListener("keydown", handleEscape, true);
			window.removeEventListener("resize", updateMenuPosition);
			window.removeEventListener("scroll", updateMenuPosition, true);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$19, [createElementVNode("div", {
				ref_key: "triggerRef",
				ref: triggerRef,
				class: "comments-dropdown__trigger",
				onClick: handleTriggerClick
			}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 512), (openBlock(), createBlock(Teleport, { to: "body" }, [isOpen.value ? (openBlock(), createElementBlock("div", {
				key: 0,
				ref_key: "menuRef",
				ref: menuRef,
				class: "comments-dropdown__menu",
				style: normalizeStyle(menuStyle.value)
			}, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (option) => {
				return openBlock(), createElementBlock("div", {
					key: option.key,
					class: normalizeClass(["comments-dropdown__option", { "sd-disabled": option.disabled }]),
					onClick: ($event) => onOptionClick(option)
				}, [hasIcon(option) ? (openBlock(), createElementBlock("span", _hoisted_3$10, [option.iconString ? (openBlock(), createElementBlock("span", {
					key: 0,
					innerHTML: option.iconString
				}, null, 8, _hoisted_4$4)) : (openBlock(), createBlock(unref(OptionIcon), {
					key: 1,
					option
				}, null, 8, ["option"]))])) : createCommentVNode("", true), createElementVNode("span", _hoisted_5$2, toDisplayString(option.label), 1)], 10, _hoisted_2$12);
			}), 128))], 4)) : createCommentVNode("", true)]))]);
		};
	}
}, [["__scopeId", "data-v-7eced80a"]]);
var _hoisted_1$18 = { class: "sd-comment-option" };
var _hoisted_2$11 = ["innerHTML"];
var _hoisted_3$9 = { class: "sd-option-state" };
var _hoisted_4$3 = ["innerHTML"];
var InternalDropdown_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "InternalDropdown",
	props: {
		state: {
			type: String,
			required: false
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},
	emits: ["select"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const props = __props;
		const { uiFontFamily } = useUiFontFamily();
		const options = [{
			label: "Internal",
			key: "internal",
			iconString: superdocIcons.internal,
			backgroundColor: "var(--sd-ui-comments-internal-bg, #CDE6E6)"
		}, {
			label: "External",
			key: "external",
			iconString: superdocIcons.external,
			backgroundColor: "var(--sd-ui-comments-external-bg, #F5CFDA)"
		}];
		const getState = computed(() => {
			return options.find((o) => o.key === activeState.value)?.label;
		});
		const getStyle = computed(() => {
			if (!props.state) return {};
			const activeOption = options.find((o) => o.key === activeState.value);
			if (!activeOption) return {};
			const style = { backgroundColor: activeOption.backgroundColor };
			if (props.isDisabled) {
				style.opacity = .5;
				style.cursor = "default";
			}
			return style;
		});
		const handleSelect = (key, suppressEmit = false) => {
			activeState.value = key;
			activeIcon.value = options.find((o) => o.key === key)?.iconString;
			if (suppressEmit) return;
			emit("select", key);
		};
		const activeState = ref(props.state);
		const activeIcon = ref(null);
		watch(() => props.state, (newVal) => {
			handleSelect(newVal);
		});
		onMounted(() => {
			handleSelect(props.state, true);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "sd-internal-dropdown",
				style: normalizeStyle(getStyle.value),
				"data-sd-part": "dropdown-trigger"
			}, [createVNode(CommentsDropdown_default, {
				options,
				onSelect: _cache[0] || (_cache[0] = ($event) => handleSelect($event)),
				disabled: __props.isDisabled,
				"content-style": { fontFamily: unref(uiFontFamily) }
			}, {
				default: withCtx(() => [createElementVNode("div", _hoisted_1$18, [
					createElementVNode("div", {
						class: "sd-active-icon",
						innerHTML: activeIcon.value
					}, null, 8, _hoisted_2$11),
					createElementVNode("div", _hoisted_3$9, toDisplayString(getState.value), 1),
					createElementVNode("div", {
						class: "sd-dropdown-caret",
						innerHTML: unref(superdocIcons).caretDown
					}, null, 8, _hoisted_4$3)
				])]),
				_: 1
			}, 8, ["disabled", "content-style"])], 4);
		};
	}
}, [["__scopeId", "data-v-138d641e"]]);
function formatDate(timestamp) {
	const date = new Date(timestamp);
	const hours = date.getHours();
	const minutes = date.getMinutes();
	const meridiem = hours >= 12 ? "PM" : "AM";
	const formattedHours = hours % 12 || 12;
	const month = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	][date.getMonth()];
	const day = date.getDate();
	return `${`${formattedHours}:${minutes.toString().padStart(2, "0")}${meridiem}`} ${month} ${day}`;
}
const PERMISSIONS = Object.freeze({
	RESOLVE_OWN: "RESOLVE_OWN",
	RESOLVE_OTHER: "RESOLVE_OTHER",
	REJECT_OWN: "REJECT_OWN",
	REJECT_OTHER: "REJECT_OTHER",
	COMMENTS_OVERFLOW_OWN: "COMMENTS_OVERFLOW",
	COMMENTS_OVERFLOW_OTHER: "COMMENTS_OVERFLOW_OTHER",
	COMMENTS_DELETE_OWN: "COMMENTS_DELETE_OWN",
	COMMENTS_DELETE_OTHER: "COMMENTS_DELETE_OTHER",
	UPLOAD_VERSION: "UPLOAD_VERSION",
	VERSION_HISTORY: "VERSION_HISTORY"
});
var ROLES = Object.freeze({
	EDITOR: "editor",
	SUGGESTER: "suggester",
	VIEWER: "viewer"
});
var PERMISSION_MATRIX = Object.freeze({
	[PERMISSIONS.RESOLVE_OWN]: {
		internal: [ROLES.EDITOR],
		external: [ROLES.EDITOR]
	},
	[PERMISSIONS.RESOLVE_OTHER]: {
		internal: [ROLES.EDITOR],
		external: [ROLES.EDITOR]
	},
	[PERMISSIONS.REJECT_OWN]: {
		internal: [ROLES.EDITOR, ROLES.SUGGESTER],
		external: [ROLES.EDITOR, ROLES.SUGGESTER]
	},
	[PERMISSIONS.REJECT_OTHER]: {
		internal: [ROLES.EDITOR],
		external: [ROLES.EDITOR]
	},
	[PERMISSIONS.COMMENTS_OVERFLOW_OWN]: {
		internal: [ROLES.EDITOR, ROLES.SUGGESTER],
		external: [ROLES.EDITOR, ROLES.SUGGESTER]
	},
	[PERMISSIONS.COMMENTS_OVERFLOW_OTHER]: {
		internal: [ROLES.EDITOR],
		external: [ROLES.EDITOR]
	},
	[PERMISSIONS.COMMENTS_DELETE_OWN]: {
		internal: [ROLES.EDITOR, ROLES.SUGGESTER],
		external: [ROLES.EDITOR, ROLES.SUGGESTER]
	},
	[PERMISSIONS.COMMENTS_DELETE_OTHER]: {
		internal: [ROLES.EDITOR],
		external: [ROLES.EDITOR]
	},
	[PERMISSIONS.UPLOAD_VERSION]: {
		internal: [ROLES.EDITOR],
		external: []
	},
	[PERMISSIONS.VERSION_HISTORY]: {
		internal: [ROLES.EDITOR],
		external: []
	}
});
var pickResolver = (context = {}) => {
	if (typeof context.permissionResolver === "function") return context.permissionResolver;
	if (context.superdoc?.config?.modules?.comments?.permissionResolver) {
		const resolver = context.superdoc.config.modules.comments.permissionResolver;
		if (typeof resolver === "function") return resolver;
	}
	if (typeof context.superdoc?.config?.permissionResolver === "function") return context.superdoc.config.permissionResolver;
	return null;
};
var defaultDecisionFor = (permission, role, isInternal) => {
	const internalExternal = isInternal ? "internal" : "external";
	return PERMISSION_MATRIX[permission]?.[internalExternal]?.includes(role) ?? false;
};
const isAllowed = (permission, role, isInternal, context = {}) => {
	const defaultDecision = defaultDecisionFor(permission, role, isInternal);
	const resolver = pickResolver(context);
	if (typeof resolver !== "function") return defaultDecision;
	const decision = resolver({
		permission,
		role,
		isInternal,
		defaultDecision,
		comment: context.comment ?? null,
		currentUser: context.currentUser ?? context.superdoc?.config?.user ?? null,
		superdoc: context.superdoc ?? null,
		trackedChange: context.trackedChange ?? null
	});
	return typeof decision === "boolean" ? decision : defaultDecision;
};
var _hoisted_1$17 = { class: "user-container" };
var _hoisted_2$10 = ["src"];
var _hoisted_3$8 = {
	key: 1,
	class: "user-bg"
};
var Avatar_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "Avatar",
	props: { user: {
		type: Object,
		required: true
	} },
	setup(__props) {
		const getInitials = (name, email) => {
			if (!name && !email) return;
			if (name) {
				const parts = name.trim().split(/\s+/).filter((p) => /^[a-zA-Z]/.test(p));
				if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
				if (parts.length === 1) return parts[0][0].toUpperCase();
			}
			return email?.substring(0, 1)?.toUpperCase() || null;
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$17, [__props.user.image ? (openBlock(), createElementBlock("img", {
				key: 0,
				class: "user-bg",
				src: __props.user.image.startsWith("http") ? __props.user.image : `data:image/png;base64,${__props.user.image}`
			}, null, 8, _hoisted_2$10)) : (openBlock(), createElementBlock("span", _hoisted_3$8, toDisplayString(getInitials(__props.user.name, __props.user.email)), 1))]);
		};
	}
}, [["__scopeId", "data-v-c95b2073"]]);
var _hoisted_1$16 = { class: "card-section comment-header" };
var _hoisted_2$9 = { class: "comment-header-left" };
var _hoisted_3$7 = { class: "user-info" };
var _hoisted_4$2 = { class: "user-name" };
var _hoisted_5$1 = {
	key: 0,
	class: "imported-tag"
};
var _hoisted_6$1 = {
	key: 0,
	class: "user-timestamp"
};
var _hoisted_7$1 = ["innerHTML"];
var _hoisted_8$1 = ["innerHTML"];
var _hoisted_9$1 = { class: "overflow-menu__icon" };
var _hoisted_10$1 = ["innerHTML"];
var CommentHeader_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "CommentHeader",
	props: {
		timestamp: {
			type: Number,
			required: false
		},
		config: {
			type: Object,
			required: true
		},
		comment: {
			type: Object,
			required: false
		},
		isPendingInput: {
			type: Boolean,
			required: false,
			default: false
		},
		isActive: {
			type: Boolean,
			default: false
		}
	},
	emits: [
		"resolve",
		"reject",
		"overflow-select"
	],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const commentsStore = useCommentsStore();
		const props = __props;
		const { proxy } = getCurrentInstance();
		const role = proxy.$superdoc.config.role;
		const isInternal = proxy.$superdoc.config.isInternal;
		const isCommentOwnedByCurrentUser = (comment) => {
			const currentUser = proxy.$superdoc.config.user;
			const otherUser = {
				id: comment?.creatorId,
				email: comment?.creatorEmail
			};
			if (actorIdentitiesMatch({
				current: currentUser,
				other: otherUser
			})) return true;
			const currentIdentity = getActorIdentity(currentUser);
			const otherIdentity = getActorIdentity(otherUser);
			if (currentIdentity.hasId || currentIdentity.hasEmail || otherIdentity.hasId || otherIdentity.hasEmail) return false;
			if (comment?.origin != null || Boolean(comment?.importedAuthor?.name)) return false;
			const currentName = normalizeActorName(currentUser?.name);
			const commentName = normalizeActorName(comment?.creatorName);
			return Boolean(currentName && commentName && currentName === commentName);
		};
		const isOwnComment = computed(() => isCommentOwnedByCurrentUser(props.comment));
		const { uiFontFamily } = useUiFontFamily();
		const OVERFLOW_OPTIONS = Object.freeze({
			edit: {
				label: "Edit",
				key: "edit"
			},
			delete: {
				label: "Delete",
				key: "delete"
			}
		});
		const generallyAllowed = computed(() => {
			if (!props.comment) return false;
			if (props.comment.resolvedTime) return false;
			if (commentsStore.pendingComment) return false;
			if (props.isPendingInput) return false;
			return true;
		});
		const allowResolve = computed(() => {
			if (!generallyAllowed.value) return false;
			if (props.comment.parentCommentId) return false;
			if (props.comment.trackedChangeParentId) return false;
			const context = {
				comment: props.comment,
				currentUser: proxy.$superdoc.config.user,
				superdoc: proxy.$superdoc
			};
			if (isOwnComment.value || props.comment.trackedChange) return isAllowed(PERMISSIONS.RESOLVE_OWN, role, isInternal, context);
			else return isAllowed(PERMISSIONS.RESOLVE_OTHER, role, isInternal, context);
		});
		const allowReject = computed(() => {
			if (!generallyAllowed.value) return false;
			if (!props.comment.trackedChange) return false;
			const context = {
				comment: props.comment,
				currentUser: proxy.$superdoc.config.user,
				superdoc: proxy.$superdoc
			};
			if (isOwnComment.value || props.comment.trackedChange) return isAllowed(PERMISSIONS.REJECT_OWN, role, isInternal, context);
			else return isAllowed(PERMISSIONS.REJECT_OTHER, role, isInternal, context);
		});
		const allowOverflow = computed(() => {
			if (!generallyAllowed.value) return false;
			if (props.comment.trackedChange) return false;
			if (props.isPendingInput) return false;
			if (getOverflowOptions.value.length === 0) return false;
			return true;
		});
		const getOverflowOptions = computed(() => {
			if (!generallyAllowed.value) return false;
			const allowedOptions = [];
			const options = /* @__PURE__ */ new Set();
			if (!props.config.readOnly && isCommentOwnedByCurrentUser(props.comment)) options.add("edit");
			const isOwnComment$1 = isCommentOwnedByCurrentUser(props.comment);
			const context = {
				comment: props.comment,
				currentUser: proxy.$superdoc.config.user,
				superdoc: proxy.$superdoc
			};
			if (isOwnComment$1 && isAllowed(PERMISSIONS.COMMENTS_DELETE_OWN, role, isInternal, context)) options.add("delete");
			else if (!isOwnComment$1 && isAllowed(PERMISSIONS.COMMENTS_DELETE_OTHER, role, isInternal, context)) options.add("delete");
			options.forEach((option) => allowedOptions.push(OVERFLOW_OPTIONS[option]));
			return allowedOptions;
		});
		const handleResolve = () => emit("resolve");
		const handleReject = () => emit("reject");
		const handleSelect = (value) => emit("overflow-select", value);
		const isImported = computed(() => {
			if (!(props.comment.origin != null || !!props.comment.importedAuthor?.name)) return false;
			if (isCommentOwnedByCurrentUser(props.comment)) return false;
			return true;
		});
		const getCurrentUser = computed(() => {
			if (props.isPendingInput) return proxy.$superdoc.config.user;
			const user = props.comment.getCommentUser();
			if (user?.name) {
				const cleaned = user.name.replace(/\s*\(imported\)\s*/gi, "").trim();
				if (cleaned) return {
					...user,
					name: cleaned
				};
			}
			return user;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$16, [createElementVNode("div", _hoisted_2$9, [createVNode(Avatar_default, {
				user: getCurrentUser.value,
				class: "avatar"
			}, null, 8, ["user"]), createElementVNode("div", _hoisted_3$7, [createElementVNode("div", _hoisted_4$2, [createTextVNode(toDisplayString(getCurrentUser.value.name), 1), isImported.value ? (openBlock(), createElementBlock("span", _hoisted_5$1, "IMPORTED")) : createCommentVNode("", true)]), props.comment.createdTime ? (openBlock(), createElementBlock("div", _hoisted_6$1, toDisplayString(unref(formatDate)(props.comment.createdTime)), 1)) : createCommentVNode("", true)])]), createElementVNode("div", { class: normalizeClass(["overflow-menu", { "is-visible": props.isActive }]) }, [
				allowResolve.value ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "overflow-menu__icon",
					innerHTML: unref(superdocIcons).markDone,
					onClick: withModifiers(handleResolve, ["stop", "prevent"])
				}, null, 8, _hoisted_7$1)) : createCommentVNode("", true),
				allowReject.value ? (openBlock(), createElementBlock("div", {
					key: 1,
					class: "overflow-menu__icon",
					innerHTML: unref(superdocIcons).rejectChange,
					onClick: withModifiers(handleReject, ["stop", "prevent"])
				}, null, 8, _hoisted_8$1)) : createCommentVNode("", true),
				allowOverflow.value ? (openBlock(), createBlock(CommentsDropdown_default, {
					key: 2,
					options: getOverflowOptions.value,
					onSelect: handleSelect,
					"content-style": { fontFamily: unref(uiFontFamily) }
				}, {
					default: withCtx(() => [createElementVNode("div", _hoisted_9$1, [createElementVNode("div", {
						class: "overflow-icon",
						innerHTML: unref(superdocIcons).overflow
					}, null, 8, _hoisted_10$1)])]),
					_: 1
				}, 8, ["options", "content-style"])) : createCommentVNode("", true)
			], 2)]);
		};
	}
}, [["__scopeId", "data-v-66ecf6cc"]]);
var _hoisted_1$15 = { class: "input-section" };
var CommentInput_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "CommentInput",
	props: {
		users: {
			type: Array,
			required: false,
			default: () => []
		},
		config: {
			type: Object,
			required: true
		},
		isFocused: {
			type: Boolean,
			default: false
		},
		includeHeader: {
			type: Boolean,
			default: true
		},
		comment: {
			type: Object,
			required: false
		}
	},
	emits: ["focus"],
	setup(__props, { expose: __expose, emit: __emit }) {
		const emit = __emit;
		useSuperdocStore();
		const { currentCommentText } = storeToRefs(useCommentsStore());
		const inputRef = ref(null);
		const handleFocusChange = (focused) => emit("focus", focused);
		const focus = () => {
			inputRef.value?.focus?.();
		};
		__expose({ focus });
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$15, [__props.includeHeader ? (openBlock(), createBlock(CommentHeader_default, {
				key: 0,
				config: __props.config,
				comment: __props.comment,
				"is-pending-input": true
			}, null, 8, ["config", "comment"])) : createCommentVNode("", true), createElementVNode("div", { class: normalizeClass(["comment-entry", { "sd-input-active": __props.isFocused }]) }, [createVNode(unref(SuperInput_default), {
				ref_key: "inputRef",
				ref: inputRef,
				class: "superdoc-field",
				placeholder: "Add a comment",
				modelValue: unref(currentCommentText),
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(currentCommentText) ? currentCommentText.value = $event : null),
				users: __props.users,
				onFocus: _cache[1] || (_cache[1] = ($event) => handleFocusChange(true)),
				onBlur: _cache[2] || (_cache[2] = ($event) => handleFocusChange(false))
			}, null, 8, ["modelValue", "users"])], 2)]);
		};
	}
}, [["__scopeId", "data-v-93ebf2d2"]]);
const collectTrackedChangeThread = (parentComment, allComments) => {
	const trackedChangeId = parentComment.commentId;
	const threadIds = new Set([trackedChangeId]);
	const queue = [];
	allComments.forEach((comment) => {
		if (comment.commentId === trackedChangeId) return;
		const isDirectChild = comment.parentCommentId === trackedChangeId;
		const isTrackedChangeAnchoredRoot = comment.trackedChangeParentId === trackedChangeId && !comment.parentCommentId;
		if (isDirectChild || isTrackedChangeAnchoredRoot) {
			threadIds.add(comment.commentId);
			queue.push(comment.commentId);
		}
	});
	for (let i = 0; i < queue.length; i += 1) {
		const parentId = queue[i];
		allComments.forEach((comment) => {
			if (comment.parentCommentId === parentId && !threadIds.has(comment.commentId)) {
				threadIds.add(comment.commentId);
				queue.push(comment.commentId);
			}
		});
	}
	return allComments.filter((comment) => threadIds.has(comment.commentId));
};
var _hoisted_1$14 = [
	"data-comment-instance-id",
	"data-comment-thread-id",
	"data-comment-position-key",
	"data-comment-page-index"
];
var _hoisted_2$8 = {
	key: 0,
	class: "existing-internal-input"
};
var _hoisted_3$6 = { class: "new-comment-input-wrapper" };
var _hoisted_4$1 = { class: "reply-actions" };
var _hoisted_5 = ["disabled"];
var _hoisted_6 = {
	key: 0,
	class: "resolved-badge"
};
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = {
	key: 1,
	class: "existing-internal-input"
};
var _hoisted_9 = {
	key: 0,
	class: "card-section comment-body"
};
var _hoisted_10 = { key: 0 };
var _hoisted_11 = { class: "tracked-change-text is-inserted" };
var _hoisted_12 = { key: 1 };
var _hoisted_13 = { class: "tracked-change-text is-inserted" };
var _hoisted_14 = { key: 2 };
var _hoisted_15 = { key: 3 };
var _hoisted_16 = { key: 4 };
var _hoisted_17 = { key: 5 };
var _hoisted_18 = { class: "tracked-change-text" };
var _hoisted_19 = { key: 6 };
var _hoisted_20 = { class: "tracked-change-text is-deleted" };
var _hoisted_21 = { class: "tracked-change-text is-inserted" };
var _hoisted_22 = { key: 7 };
var _hoisted_23 = { class: "tracked-change-text is-deleted" };
var _hoisted_24 = { key: 8 };
var _hoisted_25 = { class: "tracked-change-text is-inserted" };
var _hoisted_26 = {
	key: 1,
	class: "card-section comment-body"
};
var _hoisted_27 = ["innerHTML"];
var _hoisted_28 = {
	key: 1,
	class: "comment"
};
var _hoisted_29 = {
	key: 2,
	class: "reply-expanded"
};
var _hoisted_30 = { class: "reply-input-wrapper" };
var _hoisted_31 = { class: "reply-actions" };
var _hoisted_32 = ["onClick"];
var _hoisted_33 = ["onClick", "disabled"];
var _hoisted_34 = { class: "collapsed-avatars" };
var _hoisted_35 = {
	key: 3,
	class: "comment-separator"
};
var _hoisted_36 = {
	key: 1,
	class: "reply-expanded"
};
var _hoisted_37 = { class: "reply-input-wrapper" };
var _hoisted_38 = { class: "reply-actions" };
var _hoisted_39 = ["disabled"];
var CLICK_OUTSIDE_HIT_TOLERANCE_PX = 3;
var CommentDialog_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "CommentDialog",
	props: {
		comment: {
			type: Object,
			required: true
		},
		autoFocus: {
			type: Boolean,
			default: false
		},
		parent: {
			type: Object,
			required: false
		},
		floatingInstanceId: {
			type: String,
			default: null
		},
		floatingPageIndex: {
			type: Number,
			default: null
		},
		floatingPositionEntry: {
			type: Object,
			default: null
		},
		isFloatingInstanceActive: {
			type: Boolean,
			default: void 0
		}
	},
	emits: [
		"click-outside",
		"ready",
		"dialog-exit",
		"resize"
	],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const props = __props;
		const { proxy } = getCurrentInstance();
		const superdocStore = useSuperdocStore();
		const commentsStore = useCommentsStore();
		const { addComment, cancelComment, deleteComment, getCommentAliasIds, removePendingComment, getCommentDocumentId, requestInstantSidebarAlignment, resolveCommentPositionEntry, clearInstantSidebarAlignment, setActiveFloatingCommentInstance } = commentsStore;
		const { suppressInternalExternal, getConfig, activeComment, activeFloatingCommentInstanceId, floatingCommentsOffset, pendingComment, currentCommentText, isDebugging, editingCommentId, editorCommentPositions, isCommentHighlighted } = storeToRefs(commentsStore);
		const isInternal = ref(true);
		const commentInput = ref(null);
		const editCommentInputs = ref(/* @__PURE__ */ new Map());
		const CLICK_OUTSIDE_HIT_SAMPLE_OFFSETS = [
			[0, 0],
			[-CLICK_OUTSIDE_HIT_TOLERANCE_PX, 0],
			[CLICK_OUTSIDE_HIT_TOLERANCE_PX, 0],
			[0, -CLICK_OUTSIDE_HIT_TOLERANCE_PX],
			[0, CLICK_OUTSIDE_HIT_TOLERANCE_PX]
		];
		const CLICK_OUTSIDE_IGNORED_SELECTORS = [
			".comments-dropdown__option-label",
			".comments-dropdown__menu",
			".comments-dropdown__option",
			".comments-dropdown__option-icon",
			".comments-dropdown__trigger",
			".superdoc-comment-highlight",
			".sd-editor-comment-highlight",
			".sd-editor-tracked-change-highlight",
			"[data-track-change-id]",
			".track-insert",
			".track-insert-dec",
			".track-delete",
			".track-delete-dec",
			".track-format",
			".track-format-dec"
		].join(",");
		const setEditCommentInputRef = (commentId) => (el) => {
			if (!commentId) return;
			if (el) {
				editCommentInputs.value.set(commentId, el);
				if (editingCommentId.value === commentId) nextTick(() => {
					focusEditInput(commentId);
				});
			} else editCommentInputs.value.delete(commentId);
		};
		const elementContainsClickPoint = (element, clientX, clientY) => {
			const rect = element?.getBoundingClientRect?.();
			if (!rect || ![
				rect.left,
				rect.top,
				rect.right,
				rect.bottom
			].every(Number.isFinite) || rect.width <= 0 || rect.height <= 0) return false;
			return CLICK_OUTSIDE_HIT_SAMPLE_OFFSETS.some(([offsetX, offsetY]) => {
				const sampleX = clientX + offsetX;
				const sampleY = clientY + offsetY;
				return sampleX >= rect.left && sampleX <= rect.right && sampleY >= rect.top && sampleY <= rect.bottom;
			});
		};
		const findIgnoredElementByGeometry = (clientX, clientY) => {
			if (!Number.isFinite(clientX) || !Number.isFinite(clientY)) return null;
			const ignoredElements = document.querySelectorAll(CLICK_OUTSIDE_IGNORED_SELECTORS);
			for (const element of ignoredElements) if (element instanceof HTMLElement && elementContainsClickPoint(element, clientX, clientY)) return element;
			return null;
		};
		const focusEditInput = (commentId) => {
			editCommentInputs.value.get(commentId)?.focus?.();
		};
		const commentDialogElement = ref(null);
		const getCommentFocusThreadId = (comment) => {
			if (comment.resolvedTime) return comment.commentId;
			return comment.importedId || comment.commentId;
		};
		const getEntryBoundsCoordinate = (entry, coordinate) => {
			const value = entry?.bounds?.[coordinate];
			return Number.isFinite(value) ? value : null;
		};
		const entriesShareLine = (entry, candidateEntry) => {
			if (!entry || !candidateEntry) return false;
			if (entry.pageIndex !== candidateEntry.pageIndex) return false;
			const entryTop = getEntryBoundsCoordinate(entry, "top");
			const candidateTop = getEntryBoundsCoordinate(candidateEntry, "top");
			return entryTop != null && candidateTop != null && Math.abs(entryTop - candidateTop) < .5;
		};
		const entriesOverlapHorizontalSpan = (entry, candidateEntry) => {
			const entryLeft = getEntryBoundsCoordinate(entry, "left");
			const candidateLeft = getEntryBoundsCoordinate(candidateEntry, "left");
			const entryRight = getEntryBoundsCoordinate(entry, "right");
			const candidateRight = getEntryBoundsCoordinate(candidateEntry, "right");
			if ([
				entryLeft,
				candidateLeft,
				entryRight,
				candidateRight
			].some((value) => value == null)) return false;
			return candidateLeft < entryRight && entryLeft < candidateRight;
		};
		const entriesOverlapRange = (entry, candidateEntry) => {
			const entryStart = entry?.start;
			const entryEnd = entry?.end;
			const candidateStart = candidateEntry?.start;
			const candidateEnd = candidateEntry?.end;
			if (![
				entryStart,
				entryEnd,
				candidateStart,
				candidateEnd
			].every(Number.isFinite)) return false;
			return candidateStart <= entryEnd && entryStart <= candidateEnd;
		};
		const shouldIncludeThreadAlias = (entry, candidateEntry) => {
			if (!entry || !candidateEntry) return false;
			if (entry.kind && candidateEntry.kind && entry.kind !== candidateEntry.kind) return false;
			if (entry.storyKey && candidateEntry.storyKey && entry.storyKey !== candidateEntry.storyKey) return false;
			if (candidateEntry.start === entry.start && candidateEntry.end === entry.end) return true;
			return entriesShareLine(entry, candidateEntry) && entriesOverlapHorizontalSpan(entry, candidateEntry) && entriesOverlapRange(entry, candidateEntry);
		};
		const getThreadHighlightLookupIds = (commentOrId) => {
			const lookupIds = new Set(getCommentAliasIds(commentOrId));
			const { key, entry } = resolveCommentPositionEntry(commentOrId);
			if (key) lookupIds.add(key);
			if (!entry) return [...lookupIds];
			Object.entries(editorCommentPositions.value ?? {}).forEach(([id, candidateEntry]) => {
				if (shouldIncludeThreadAlias(entry, candidateEntry)) lookupIds.add(id);
			});
			return [...lookupIds];
		};
		const isDialogAlreadyAlignedWithTarget = (dialogElement, targetClientY, tolerancePx = 24) => {
			if (!Number.isFinite(targetClientY) || typeof dialogElement?.getBoundingClientRect !== "function") return false;
			const dialogTop = dialogElement.getBoundingClientRect().top;
			return Number.isFinite(dialogTop) && Math.abs(dialogTop - targetClientY) <= tolerancePx;
		};
		const currentFloatingInstanceId = computed(() => {
			return props.floatingInstanceId ?? props.comment.commentId ?? null;
		});
		const isDialogActive = computed(() => {
			if (typeof props.isFloatingInstanceActive === "boolean") return props.isFloatingInstanceActive;
			if (activeComment.value !== props.comment.commentId) return false;
			if (props.floatingInstanceId == null) return true;
			return activeFloatingCommentInstanceId.value === props.floatingInstanceId;
		});
		const resolvedBadgeLabel = computed(() => {
			if (!props.comment.resolvedTime) return null;
			return props.comment.trackedChange ? "Accepted" : "Resolved";
		});
		const isPendingNewComment = computed(() => {
			return pendingComment.value && pendingComment.value.commentId === props.comment.commentId;
		});
		const showSeparator = computed(() => (index) => {
			const visible = visibleComments.value;
			if (showInputSection.value && index === visible.length - 1) return true;
			return visible.length > 1 && index !== visible.length - 1;
		});
		const showInputSection = computed(() => {
			return !getConfig.readOnly && isDialogActive.value && !props.comment.resolvedTime && !isEditingAnyComment.value;
		});
		const isReplying = ref(false);
		const startReply = () => {
			isReplying.value = true;
			nextTick(() => {
				commentInput.value?.focus?.();
				emit("resize");
			});
		};
		const comments = computed(() => {
			const parentComment = props.comment;
			const allComments = commentsStore.commentsList;
			return (parentComment.trackedChange ? collectTrackedChangeThread(parentComment, allComments) : allComments.filter((comment) => {
				const isThreadedComment = comment.parentCommentId === parentComment.commentId;
				const isThisComment = comment.commentId === parentComment.commentId;
				return isThreadedComment || isThisComment;
			})).sort((a, b) => {
				if (a.commentId === parentComment.commentId) return -1;
				if (b.commentId === parentComment.commentId) return 1;
				return a.createdTime - b.createdTime;
			});
		});
		const textExpanded = ref(false);
		const parentBodyRef = ref(null);
		const isTextOverflowing = ref(false);
		const shouldTruncate = computed(() => !textExpanded.value);
		const toggleTruncation = () => {
			textExpanded.value = !textExpanded.value;
			nextTick(() => emit("resize"));
		};
		const checkOverflow = () => {
			if (textExpanded.value) return;
			const el = parentBodyRef.value;
			if (!el) {
				isTextOverflowing.value = false;
				return;
			}
			isTextOverflowing.value = el.scrollHeight > el.clientHeight + 1;
		};
		watch(parentBodyRef, () => {
			nextTick(checkOverflow);
		});
		watch(isDialogActive, (active) => {
			if (!active) {
				textExpanded.value = false;
				threadExpanded.value = false;
				isReplying.value = false;
				nextTick(() => emit("resize"));
			}
		});
		const threadExpanded = ref(false);
		const childComments = computed(() => comments.value.slice(1));
		const shouldCollapseThread = computed(() => {
			if (threadExpanded.value) return false;
			return childComments.value.length >= 2;
		});
		const visibleComments = computed(() => {
			if (!shouldCollapseThread.value) return comments.value;
			return [comments.value[0], childComments.value[childComments.value.length - 1]].filter(Boolean);
		});
		const collapsedReplyCount = computed(() => {
			if (!shouldCollapseThread.value) return 0;
			return childComments.value.length - 1;
		});
		const collapsedReplyAuthors = computed(() => {
			if (!shouldCollapseThread.value) return [];
			const hidden = childComments.value.slice(0, -1);
			const seen = /* @__PURE__ */ new Set();
			return hidden.map((c) => typeof c.getCommentUser === "function" ? c.getCommentUser() : {
				name: c.creatorName,
				email: c.creatorEmail || c.email
			}).filter((u) => {
				if (!u) return false;
				const key = u.email || u.name;
				if (seen.has(key)) return false;
				seen.add(key);
				return true;
			}).slice(0, 3);
		});
		const expandThread = () => {
			threadExpanded.value = true;
			setFocus();
			nextTick(() => emit("resize"));
		};
		const isInternalDropdownDisabled = computed(() => {
			if (props.comment.resolvedTime) return true;
			return getConfig.value.readOnly;
		});
		const isEditingThisComment = computed(() => (comment) => {
			return isDialogActive.value && editingCommentId.value === comment.commentId;
		});
		const isEditingAnyComment = computed(() => {
			if (!editingCommentId.value || !isDialogActive.value) return false;
			return comments.value.some((c) => c.commentId === editingCommentId.value);
		});
		const shouldShowInternalExternal = computed(() => {
			if (!proxy.$superdoc.config.isInternal) return false;
			return !suppressInternalExternal.value && !props.comment.trackedChange;
		});
		const hasTextContent = computed(() => {
			return currentCommentText.value && currentCommentText.value !== "<p></p>";
		});
		const setFocus = () => {
			const editor = proxy.$superdoc.activeEditor;
			const isTrackedChange = Boolean(props.comment?.trackedChange);
			const targetClientY = getPreferredCommentFocusTargetClientY();
			const isInstanceScopedDialog = props.floatingInstanceId != null;
			const willChangeActiveDialog = !props.comment.resolvedTime && (activeComment.value !== props.comment.commentId || isInstanceScopedDialog && currentFloatingInstanceId.value !== activeFloatingCommentInstanceId.value);
			let instantAlignmentTargetY = targetClientY;
			if (editor) {
				const { entry: resolvedFocusEntry } = resolveCommentPositionEntry(props.comment);
				const focusEntry = props.floatingPositionEntry ?? resolvedFocusEntry;
				const usePageScopedAnchorOnly = Number.isFinite(props.floatingPageIndex) && props.comment?.trackedChangeStory?.storyType === "headerFooterPart";
				const visibleAnchorTargetY = getVisibleThreadAnchorClientY(props.parent, focusEntry);
				const visibleHighlightTargetY = usePageScopedAnchorOnly ? null : getVisibleThreadHighlightClientY(getThreadHighlightLookupIds(props.comment));
				const visibleThreadTargetY = Number.isFinite(visibleHighlightTargetY) ? visibleHighlightTargetY : visibleAnchorTargetY;
				const shouldSkipFocusScroll = isDialogAlreadyAlignedWithTarget(commentDialogElement.value, visibleThreadTargetY);
				const cursorId = getCommentFocusThreadId(props.comment);
				const documentId = getCommentDocumentId(props.comment);
				const presentation = documentId ? PresentationEditor.getInstance(documentId) : null;
				let reachableTargetY = null;
				if (isTrackedChange) {
					const trackedTarget = props.comment.trackedChangeStory ? {
						kind: "entity",
						entityType: "trackedChange",
						entityId: cursorId,
						story: props.comment.trackedChangeStory,
						...Number.isFinite(props.floatingPageIndex) ? { pageIndex: props.floatingPageIndex } : {}
					} : {
						kind: "entity",
						entityType: "trackedChange",
						entityId: cursorId
					};
					if (presentation?.navigateTo) presentation.navigateTo(trackedTarget);
					else if (props.comment.resolvedTime) editor.commands?.setCursorById(cursorId);
					else {
						const activeCommentId = props.comment.commentId;
						if (!editor.commands?.setCursorById(cursorId, { activeCommentId })) editor.commands?.setActiveComment({ commentId: activeCommentId });
					}
				} else {
					if (props.comment.resolvedTime) editor.commands?.setCursorById(cursorId);
					else {
						const activeCommentId = props.comment.commentId;
						if (!editor.commands?.setCursorById(cursorId, { activeCommentId })) editor.commands?.setActiveComment({ commentId: activeCommentId });
					}
					const fallbackThreadId = props.comment.commentId;
					reachableTargetY = shouldSkipFocusScroll ? null : scrollThreadAnchorToFocusTarget(presentation, cursorId, fallbackThreadId, targetClientY);
				}
				if (Number.isFinite(visibleHighlightTargetY)) instantAlignmentTargetY = visibleHighlightTargetY;
				else if (Number.isFinite(visibleAnchorTargetY)) instantAlignmentTargetY = visibleAnchorTargetY;
				else if (Number.isFinite(reachableTargetY)) instantAlignmentTargetY = reachableTargetY;
			}
			if (willChangeActiveDialog) if (props.floatingInstanceId) requestInstantSidebarAlignment(instantAlignmentTargetY, props.comment.commentId, props.floatingInstanceId);
			else requestInstantSidebarAlignment(instantAlignmentTargetY, props.comment.commentId);
			else clearInstantSidebarAlignment();
			if (!props.comment.resolvedTime) {
				activeComment.value = props.comment.commentId;
				if (props.floatingInstanceId) setActiveFloatingCommentInstance(props.floatingInstanceId);
			}
		};
		const handleClickOutside = (e) => {
			const targetElement = e.target instanceof Element ? e.target : e.target?.parentElement;
			const elementAtPoint = document.elementFromPoint(e.clientX, e.clientY);
			if (targetElement?.closest?.(CLICK_OUTSIDE_IGNORED_SELECTORS) || elementAtPoint?.closest?.(CLICK_OUTSIDE_IGNORED_SELECTORS) || findIgnoredElementByGeometry(e.clientX, e.clientY) || isCommentHighlighted.value) return;
			if (e.target.closest?.(".comments-dialog") && !commentDialogElement.value?.contains(e.target)) return;
			if (isPendingNewComment.value) {
				cancelComment(proxy.$superdoc);
				return;
			}
			if (!isDialogActive.value) return;
			floatingCommentsOffset.value = 0;
			emit("dialog-exit");
			activeComment.value = null;
			commentsStore.setActiveComment(proxy.$superdoc, activeComment.value);
			isCommentHighlighted.value = false;
		};
		const handleAddComment = () => {
			const options = {
				documentId: props.comment.fileId,
				isInternal: pendingComment.value ? pendingComment.value.isInternal : isInternal.value,
				parentCommentId: pendingComment.value ? null : props.comment.commentId
			};
			if (pendingComment.value) options.selection = pendingComment.value.selection.getValues();
			const comment = commentsStore.getPendingComment(options);
			addComment({
				superdoc: proxy.$superdoc,
				comment
			});
			isReplying.value = false;
			nextTick(() => emit("resize"));
		};
		const handleReject = () => {
			const customHandler = proxy.$superdoc.config.onTrackedChangeBubbleReject;
			if (props.comment.trackedChange && typeof customHandler === "function") customHandler(props.comment, proxy.$superdoc.activeEditor);
			else if (props.comment.trackedChange) commentsStore.decideTrackedChangeFromSidebar({
				superdoc: proxy.$superdoc,
				comment: props.comment,
				decision: "reject"
			});
			else commentsStore.deleteComment({
				superdoc: proxy.$superdoc,
				commentId: props.comment.commentId
			});
			if (props.comment.trackedChange) props.comment.resolveComment({
				id: superdocStore.user.id,
				email: superdocStore.user.email,
				name: superdocStore.user.name,
				superdoc: proxy.$superdoc
			});
			nextTick(() => {
				commentsStore.lastUpdate = /* @__PURE__ */ new Date();
				activeComment.value = null;
				commentsStore.setActiveComment(proxy.$superdoc, activeComment.value);
				proxy.$superdoc.focus?.();
			});
		};
		const handleResolve = () => {
			const customHandler = proxy.$superdoc.config.onTrackedChangeBubbleAccept;
			if (props.comment.trackedChange && typeof customHandler === "function") customHandler(props.comment, proxy.$superdoc.activeEditor);
			else if (props.comment.trackedChange) commentsStore.decideTrackedChangeFromSidebar({
				superdoc: proxy.$superdoc,
				comment: props.comment,
				decision: "accept"
			});
			props.comment.resolveComment({
				id: superdocStore.user.id,
				email: superdocStore.user.email,
				name: superdocStore.user.name,
				superdoc: proxy.$superdoc
			});
			nextTick(() => {
				commentsStore.lastUpdate = /* @__PURE__ */ new Date();
				activeComment.value = null;
				commentsStore.setActiveComment(proxy.$superdoc, activeComment.value);
				proxy.$superdoc.focus?.();
			});
		};
		const handleOverflowSelect = (value, comment) => {
			switch (value) {
				case "edit":
					currentCommentText.value = comment?.commentText?.value ?? comment?.commentText ?? "";
					activeComment.value = props.comment.commentId;
					if (props.floatingInstanceId) setActiveFloatingCommentInstance(props.floatingInstanceId);
					editingCommentId.value = comment.commentId;
					commentsStore.setActiveComment(proxy.$superdoc, activeComment.value);
					nextTick(() => {
						focusEditInput(comment.commentId);
					});
					break;
				case "delete":
					deleteComment({
						superdoc: proxy.$superdoc,
						commentId: comment.commentId
					});
					break;
			}
		};
		const handleCommentUpdate = (comment) => {
			editingCommentId.value = null;
			comment.setText({
				text: currentCommentText.value,
				superdoc: proxy.$superdoc
			});
			removePendingComment(proxy.$superdoc);
		};
		const handleInternalExternalSelect = (value) => {
			const isPendingComment = !!pendingComment.value;
			const isInternal$1 = value.toLowerCase() === "internal";
			if (!isPendingComment) props.comment.setIsInternal({
				isInternal: isInternal$1,
				superdoc: proxy.$superdoc
			});
			else pendingComment.value.isInternal = isInternal$1;
		};
		const getSidebarCommentStyle = computed(() => {
			const style = {};
			if (isDialogActive.value || isPendingNewComment.value || isEditingAnyComment.value) style.zIndex = 50;
			return style;
		});
		const getProcessedDate = (timestamp) => {
			return typeof timestamp === "string" ? new Date(timestamp).getTime() : timestamp;
		};
		const handleCancel = (comment) => {
			editingCommentId.value = null;
			isReplying.value = false;
			cancelComment(proxy.$superdoc);
		};
		const usersFiltered = computed(() => {
			const users = proxy.$superdoc.users;
			if (props.comment.isInternal === true) return users.filter((user) => user.access?.role === "internal");
			return users;
		});
		onMounted(() => {
			if (props.autoFocus) nextTick(() => setFocus());
			if (isPendingNewComment.value) nextTick(() => {
				commentInput.value?.focus?.();
			});
			nextTick(() => {
				emit("ready", {
					commentId: props.floatingInstanceId ?? (props.comment.importedId !== void 0 ? props.comment.importedId : props.comment.commentId),
					elementRef: commentDialogElement
				});
				checkOverflow();
			});
		});
		watch(showInputSection, (isVisible) => {
			if (!isVisible) return;
			nextTick(() => {
				commentInput.value?.focus?.();
			});
		}, { immediate: true });
		watch(editingCommentId, (commentId) => {
			if (!commentId || !isDialogActive.value) return;
			const entry = comments.value.find((comment) => comment.commentId === commentId);
			if (!entry || entry.trackedChange) return;
			nextTick(() => {
				focusEditInput(commentId);
			});
		});
		return (_ctx, _cache) => {
			const _directive_click_outside = resolveDirective("click-outside");
			return withDirectives((openBlock(), createElementBlock("div", {
				class: normalizeClass(["comments-dialog", {
					"is-active": isDialogActive.value || isPendingNewComment.value,
					"is-resolved": props.comment.resolvedTime
				}]),
				onClick: withModifiers(setFocus, ["stop", "prevent"]),
				style: normalizeStyle(getSidebarCommentStyle.value),
				ref_key: "commentDialogElement",
				ref: commentDialogElement,
				role: "dialog",
				"data-sd-part": "comment-thread",
				"data-editor-ui-surface": "",
				"data-comment-instance-id": props.floatingInstanceId ?? "",
				"data-comment-thread-id": props.comment.commentId ?? "",
				"data-comment-position-key": props.comment.trackedChangeAnchorKey ?? "",
				"data-comment-page-index": Number.isFinite(props.floatingPageIndex) ? props.floatingPageIndex : ""
			}, [isPendingNewComment.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
				shouldShowInternalExternal.value ? (openBlock(), createElementBlock("div", _hoisted_2$8, [createVNode(InternalDropdown_default, {
					onClick: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop", "prevent"])),
					class: "sd-internal-dropdown",
					"is-disabled": false,
					state: unref(pendingComment).isInternal ? "internal" : "external",
					onSelect: handleInternalExternalSelect
				}, null, 8, ["state"])])) : createCommentVNode("", true),
				createVNode(CommentHeader_default, {
					config: unref(getConfig),
					comment: props.comment,
					"is-pending-input": true
				}, null, 8, ["config", "comment"]),
				createElementVNode("div", _hoisted_3$6, [createVNode(CommentInput_default, {
					ref_key: "commentInput",
					ref: commentInput,
					users: usersFiltered.value,
					config: unref(getConfig),
					comment: props.comment,
					"include-header": false
				}, null, 8, [
					"users",
					"config",
					"comment"
				])]),
				createElementVNode("div", _hoisted_4$1, [createElementVNode("button", {
					class: "sd-button reply-btn-cancel",
					onClick: withModifiers(handleCancel, ["stop", "prevent"])
				}, "Cancel"), createElementVNode("button", {
					class: normalizeClass(["sd-button primary reply-btn-primary", { "sd-is-disabled": !hasTextContent.value }]),
					onClick: withModifiers(handleAddComment, ["stop", "prevent"]),
					disabled: !hasTextContent.value
				}, " Comment ", 10, _hoisted_5)])
			], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
				resolvedBadgeLabel.value ? (openBlock(), createElementBlock("div", _hoisted_6, [createElementVNode("span", {
					class: "resolved-badge__icon",
					innerHTML: unref(superdocIcons).markDone
				}, null, 8, _hoisted_7), createTextVNode(" " + toDisplayString(resolvedBadgeLabel.value), 1)])) : createCommentVNode("", true),
				shouldShowInternalExternal.value ? (openBlock(), createElementBlock("div", _hoisted_8, [createVNode(InternalDropdown_default, {
					onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop", "prevent"])),
					class: "sd-internal-dropdown",
					"is-disabled": isInternalDropdownDisabled.value,
					state: __props.comment.isInternal ? "internal" : "external",
					onSelect: handleInternalExternalSelect
				}, null, 8, ["is-disabled", "state"])])) : createCommentVNode("", true),
				(openBlock(true), createElementBlock(Fragment, null, renderList(visibleComments.value, (comment, index) => {
					return openBlock(), createElementBlock("div", {
						key: comment.commentId,
						class: "conversation-item"
					}, [
						createVNode(CommentHeader_default, {
							config: unref(getConfig),
							timestamp: getProcessedDate(comment.createdTime),
							comment,
							"is-active": isDialogActive.value,
							onResolve: handleResolve,
							onReject: handleReject,
							onOverflowSelect: ($event) => handleOverflowSelect($event, comment)
						}, null, 8, [
							"config",
							"timestamp",
							"comment",
							"is-active",
							"onOverflowSelect"
						]),
						comment.trackedChange ? (openBlock(), createElementBlock("div", _hoisted_9, [
							createElementVNode("div", {
								class: normalizeClass(["tracked-change", { "is-truncated": shouldTruncate.value && index === 0 }]),
								ref_for: true,
								ref: index === 0 ? (el) => parentBodyRef.value = el : void 0
							}, [comment.trackedChangeDisplayType === "hyperlinkAdded" ? (openBlock(), createElementBlock("div", _hoisted_10, [_cache[2] || (_cache[2] = createElementVNode("span", { class: "change-type" }, "Added hyperlink ", -1)), createElementVNode("span", _hoisted_11, "\"" + toDisplayString(comment.trackedChangeText) + "\"", 1)])) : comment.trackedChangeDisplayType === "hyperlinkModified" ? (openBlock(), createElementBlock("div", _hoisted_12, [_cache[3] || (_cache[3] = createElementVNode("span", { class: "change-type" }, "Changed hyperlink to ", -1)), createElementVNode("span", _hoisted_13, "\"" + toDisplayString(comment.trackedChangeText) + "\"", 1)])) : comment.trackedChangeDisplayType === "paragraphSplit" ? (openBlock(), createElementBlock("div", _hoisted_14, [..._cache[4] || (_cache[4] = [createElementVNode("span", { class: "change-type" }, "Added new line", -1)])])) : comment.trackedChangeDisplayType === "tableInsert" ? (openBlock(), createElementBlock("div", _hoisted_15, [..._cache[5] || (_cache[5] = [createElementVNode("span", { class: "change-type" }, "Added table", -1)])])) : comment.trackedChangeDisplayType === "tableDelete" ? (openBlock(), createElementBlock("div", _hoisted_16, [..._cache[6] || (_cache[6] = [createElementVNode("span", { class: "change-type" }, "Deleted table", -1)])])) : comment.trackedChangeType === "trackFormat" ? (openBlock(), createElementBlock("div", _hoisted_17, [_cache[7] || (_cache[7] = createElementVNode("span", { class: "change-type" }, "Format: ", -1)), createElementVNode("span", _hoisted_18, toDisplayString(comment.trackedChangeText), 1)])) : comment.trackedChangeType === "both" ? (openBlock(), createElementBlock("div", _hoisted_19, [
								_cache[8] || (_cache[8] = createElementVNode("span", { class: "change-type" }, "Replaced ", -1)),
								createElementVNode("span", _hoisted_20, "\"" + toDisplayString(comment.deletedText) + "\"", 1),
								_cache[9] || (_cache[9] = createElementVNode("span", { class: "change-type" }, " with ", -1)),
								createElementVNode("span", _hoisted_21, "\"" + toDisplayString(comment.trackedChangeText) + "\"", 1)
							])) : comment.deletedText ? (openBlock(), createElementBlock("div", _hoisted_22, [_cache[10] || (_cache[10] = createElementVNode("span", { class: "change-type" }, "Deleted ", -1)), createElementVNode("span", _hoisted_23, "\"" + toDisplayString(comment.deletedText) + "\"", 1)])) : comment.trackedChangeText ? (openBlock(), createElementBlock("div", _hoisted_24, [_cache[11] || (_cache[11] = createElementVNode("span", { class: "change-type" }, "Added ", -1)), createElementVNode("span", _hoisted_25, "\"" + toDisplayString(comment.trackedChangeText) + "\"", 1)])) : createCommentVNode("", true)], 2),
							shouldTruncate.value && isTextOverflowing.value && index === 0 ? (openBlock(), createElementBlock("div", {
								key: 0,
								class: "show-more-toggle",
								onClick: withModifiers(toggleTruncation, ["stop", "prevent"])
							}, " Show more ")) : createCommentVNode("", true),
							textExpanded.value && isTextOverflowing.value && index === 0 ? (openBlock(), createElementBlock("div", {
								key: 1,
								class: "show-more-toggle",
								onClick: withModifiers(toggleTruncation, ["stop", "prevent"])
							}, " Show less ")) : createCommentVNode("", true)
						])) : createCommentVNode("", true),
						!comment.trackedChange ? (openBlock(), createElementBlock("div", _hoisted_26, [
							!unref(isDebugging) && !isEditingThisComment.value(comment) ? (openBlock(), createElementBlock("div", {
								key: 0,
								class: normalizeClass(["comment", { "is-truncated": shouldTruncate.value && index === 0 }]),
								ref_for: true,
								ref: index === 0 ? (el) => parentBodyRef.value = el : void 0,
								innerHTML: comment.commentText
							}, null, 10, _hoisted_27)) : unref(isDebugging) && !isEditingThisComment.value(comment) ? (openBlock(), createElementBlock("div", _hoisted_28, toDisplayString(unref(editorCommentPositions)[comment.importedId !== void 0 ? comment.importedId : comment.commentId]?.bounds), 1)) : (openBlock(), createElementBlock("div", _hoisted_29, [createElementVNode("div", _hoisted_30, [createVNode(CommentInput_default, {
								ref_for: true,
								ref: setEditCommentInputRef(comment.commentId),
								users: usersFiltered.value,
								config: unref(getConfig),
								"include-header": false,
								comment
							}, null, 8, [
								"users",
								"config",
								"comment"
							])]), createElementVNode("div", _hoisted_31, [createElementVNode("button", {
								class: "sd-button reply-btn-cancel",
								onClick: withModifiers(($event) => handleCancel(comment), ["stop", "prevent"])
							}, "Cancel", 8, _hoisted_32), createElementVNode("button", {
								class: normalizeClass(["sd-button primary reply-btn-primary", { "sd-is-disabled": !hasTextContent.value }]),
								onClick: withModifiers(($event) => handleCommentUpdate(comment), ["stop", "prevent"]),
								disabled: !hasTextContent.value
							}, " Update ", 10, _hoisted_33)])])),
							shouldTruncate.value && isTextOverflowing.value && index === 0 && !isEditingThisComment.value(comment) ? (openBlock(), createElementBlock("div", {
								key: 3,
								class: "show-more-toggle",
								onClick: withModifiers(toggleTruncation, ["stop", "prevent"])
							}, " Show more ")) : createCommentVNode("", true),
							textExpanded.value && isTextOverflowing.value && index === 0 && !isEditingThisComment.value(comment) ? (openBlock(), createElementBlock("div", {
								key: 4,
								class: "show-more-toggle",
								onClick: withModifiers(toggleTruncation, ["stop", "prevent"])
							}, " Show less ")) : createCommentVNode("", true)
						])) : createCommentVNode("", true),
						shouldCollapseThread.value && index === 0 ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [_cache[12] || (_cache[12] = createElementVNode("div", { class: "comment-separator" }, null, -1)), createElementVNode("div", {
							class: "collapsed-replies",
							onClick: withModifiers(expandThread, ["stop", "prevent"])
						}, [createElementVNode("div", _hoisted_34, [(openBlock(true), createElementBlock(Fragment, null, renderList(collapsedReplyAuthors.value, (author) => {
							return openBlock(), createBlock(Avatar_default, {
								key: author.email || author.name,
								user: author,
								class: "mini-avatar"
							}, null, 8, ["user"]);
						}), 128))]), createElementVNode("span", null, toDisplayString(collapsedReplyCount.value) + " more " + toDisplayString(collapsedReplyCount.value === 1 ? "reply" : "replies"), 1)])], 64)) : createCommentVNode("", true),
						showSeparator.value(index) ? (openBlock(), createElementBlock("div", _hoisted_35)) : createCommentVNode("", true)
					]);
				}), 128)),
				showInputSection.value && !unref(getConfig).readOnly ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [!isReplying.value ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "reply-pill",
					onClick: withModifiers(startReply, ["stop", "prevent"])
				}, "Reply or add others with @")) : (openBlock(), createElementBlock("div", _hoisted_36, [createElementVNode("div", _hoisted_37, [createVNode(CommentInput_default, {
					ref_key: "commentInput",
					ref: commentInput,
					users: usersFiltered.value,
					config: unref(getConfig),
					comment: props.comment,
					"include-header": false
				}, null, 8, [
					"users",
					"config",
					"comment"
				])]), createElementVNode("div", _hoisted_38, [createElementVNode("button", {
					class: "sd-button reply-btn-cancel",
					onClick: withModifiers(handleCancel, ["stop", "prevent"])
				}, "Cancel"), createElementVNode("button", {
					class: normalizeClass(["sd-button primary reply-btn-primary", { "sd-is-disabled": !hasTextContent.value }]),
					onClick: withModifiers(handleAddComment, ["stop", "prevent"]),
					disabled: !hasTextContent.value
				}, " Reply ", 10, _hoisted_39)])]))], 64)) : createCommentVNode("", true)
			], 64))], 14, _hoisted_1$14)), [[_directive_click_outside, handleClickOutside]]);
		};
	}
}, [["__scopeId", "data-v-dd8237be"]]);
var _hoisted_1$13 = { class: "comments-list" };
var _hoisted_2$7 = { key: 0 };
var _hoisted_3$5 = [
	"data-comment-instance-id",
	"data-comment-thread-id",
	"data-comment-position-key",
	"data-comment-page-index"
];
var _hoisted_4 = { key: 1 };
var REPEATED_HEADER_FOOTER_STORY_TYPE = "headerFooterPart";
var commentsList_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "commentsList",
	props: {
		showMainComments: {
			type: Boolean,
			default: true
		},
		showResolvedComments: {
			type: Boolean,
			default: true
		}
	},
	setup(__props) {
		const props = __props;
		const commentsStore = useCommentsStore();
		const isCommentsListVisible = toRef(commentsStore, "isCommentsListVisible");
		const groupedComments = computed(() => commentsStore.getGroupedComments);
		const floatingCommentInstances = computed(() => commentsStore.getFloatingCommentInstances);
		const { activeComment, activeFloatingCommentInstanceId } = storeToRefs(commentsStore);
		const getRepeatedHeaderFooterInstances = (comment) => {
			const matchingInstances = floatingCommentInstances.value.filter((instance) => instance?.comment?.commentId === comment?.commentId);
			if (matchingInstances.length < 2) return [];
			if (!comment?.trackedChange) return [];
			if (comment?.trackedChangeStory?.storyType !== REPEATED_HEADER_FOOTER_STORY_TYPE) return [];
			return matchingInstances;
		};
		const isRepeatedInstanceActive = (instance) => {
			if (!instance?.comment?.commentId) return false;
			if (activeComment.value !== instance.comment.commentId) return false;
			if (activeFloatingCommentInstanceId.value == null) return instance.isPrimary === true;
			return String(activeFloatingCommentInstanceId.value) === String(instance.id);
		};
		const buildParentCommentDisplayItems = (comment) => {
			const repeatedInstances = getRepeatedHeaderFooterInstances(comment);
			if (!repeatedInstances.length) return [{
				id: comment.commentId,
				comment,
				floatingInstanceId: null,
				floatingPageIndex: null,
				floatingPositionEntry: null,
				isFloatingInstanceActive: void 0
			}];
			return repeatedInstances.map((instance) => ({
				id: instance.id,
				comment,
				floatingInstanceId: String(instance.id),
				floatingPageIndex: instance.pageIndex,
				floatingPositionEntry: instance.positionEntry ?? null,
				isFloatingInstanceActive: isRepeatedInstanceActive(instance)
			}));
		};
		const parentCommentDisplayItems = computed(() => {
			return groupedComments.value.parentComments.flatMap((comment) => buildParentCommentDisplayItems(comment));
		});
		const shouldShowResolvedComments = computed(() => {
			return props.showResolvedComments && groupedComments.value?.resolvedComments?.length > 0;
		});
		onMounted(() => {
			isCommentsListVisible.value = true;
		});
		onBeforeUnmount(() => {
			isCommentsListVisible.value = false;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$13, [__props.showMainComments ? (openBlock(), createElementBlock("div", _hoisted_2$7, [(openBlock(true), createElementBlock(Fragment, null, renderList(parentCommentDisplayItems.value, (item) => {
				return openBlock(), createElementBlock("div", {
					key: item.id,
					class: "comment-item",
					"data-comment-instance-id": item.floatingInstanceId ?? "",
					"data-comment-thread-id": item.comment.commentId ?? "",
					"data-comment-position-key": item.comment.trackedChangeAnchorKey ?? "",
					"data-comment-page-index": Number.isFinite(item.floatingPageIndex) ? item.floatingPageIndex : ""
				}, [createVNode(CommentDialog_default, {
					comment: item.comment,
					"floating-instance-id": item.floatingInstanceId,
					"floating-page-index": item.floatingPageIndex,
					"floating-position-entry": item.floatingPositionEntry,
					"is-floating-instance-active": item.isFloatingInstanceActive
				}, null, 8, [
					"comment",
					"floating-instance-id",
					"floating-page-index",
					"floating-position-entry",
					"is-floating-instance-active"
				])], 8, _hoisted_3$5);
			}), 128))])) : createCommentVNode("", true), shouldShowResolvedComments.value ? (openBlock(), createElementBlock("div", _hoisted_4, [_cache[0] || (_cache[0] = createElementVNode("div", { class: "comment-title" }, "Resolved", -1)), (openBlock(true), createElementBlock(Fragment, null, renderList(groupedComments.value.resolvedComments, (comment) => {
				return openBlock(), createElementBlock("div", {
					key: comment.commentId,
					class: "comment-item"
				}, [createVNode(CommentDialog_default, { comment }, null, 8, ["comment"])]);
			}), 128))])) : createCommentVNode("", true)]);
		};
	}
}, [["__scopeId", "data-v-e89dbc33"]]);
var SuperComments = class extends import_eventemitter3.default {
	element;
	config = {
		comments: [],
		element: null,
		commentsStore: null
	};
	constructor(options, superdoc) {
		super();
		this.config = {
			...this.config,
			...options
		};
		this.element = this.config.element;
		this.app = null;
		this.superdoc = superdoc;
		this.open();
	}
	createVueApp() {
		this.app = createApp(commentsList_default);
		const parentProvides = this.superdoc?.app?._context?.provides;
		if (parentProvides && this.app?._context?.provides) Object.setPrototypeOf(this.app._context.provides, parentProvides);
		if (this.superdoc?.pinia) {
			setActivePinia(this.superdoc.pinia);
			this.app.use(this.superdoc.pinia);
			this.app.config.globalProperties.$pinia = this.superdoc.pinia;
		}
		this.app.directive("click-outside", v_click_outside_default);
		this.app.config.globalProperties.$superdoc = this.superdoc;
		if (!this.element && this.config.selector) this.element = document.getElementById(this.config.selector);
		this.container = this.app.mount(this.element);
	}
	close() {
		if (this.app) {
			this.app.unmount();
			this.app = null;
			this.container = null;
			this.element = null;
		}
	}
	open() {
		if (!this.app) this.createVueApp();
	}
};
var CSS_PX_PER_INCH = 96;
var SIDEBAR_SELECTOR = ".superdoc__right-sidebar";
var PDF_PAGE_SELECTOR = ".sd-pdf-viewer-page";
const FIT_WIDTH_DEFAULTS = Object.freeze({
	min: 10,
	max: 100,
	padding: 0
});
const resolveFitWidthOptions = (rawFitConfig) => {
	const raw = rawFitConfig && typeof rawFitConfig === "object" ? rawFitConfig : {};
	const positiveOr = (value, fallback) => typeof value === "number" && Number.isFinite(value) && value > 0 ? value : fallback;
	const min$1 = positiveOr(raw.min, FIT_WIDTH_DEFAULTS.min);
	const max = positiveOr(raw.max, FIT_WIDTH_DEFAULTS.max);
	const padding = typeof raw.padding === "number" && Number.isFinite(raw.padding) && raw.padding >= 0 ? raw.padding : FIT_WIDTH_DEFAULTS.padding;
	return {
		min: Math.min(min$1, max),
		max: Math.max(min$1, max),
		padding
	};
};
const computeFitZoom = (availableWidth, documentWidth) => {
	if (!(availableWidth > 0) || !(documentWidth > 0)) return null;
	return Math.round(availableWidth / documentWidth * 100);
};
const computeAppliedFitZoom = (availableWidth, documentWidth, options) => {
	const padded = computeFitZoom(availableWidth - options.padding, documentWidth);
	if (padded === null) return null;
	return Math.max(1, Math.round(Math.min(options.max, Math.max(options.min, padded))));
};
const normalizePdfPageMeasurement = (measured, scaleFactor, zoomFactor) => {
	if (!(measured > 0)) return null;
	if (Number.isFinite(scaleFactor) && scaleFactor > 0) return measured / scaleFactor * PDF_TO_CSS_UNITS;
	return zoomFactor > 0 ? measured / zoomFactor : measured;
};
function useViewportFit({ getSuperdoc, superdocContainerWidth, isReady, activeZoom, zoomMode, viewportMetrics, showCommentsSidebar, rightSidebarRef, superdocRoot, documents }) {
	const resolveEditorPageWidth = (editor) => {
		if (!editor) return null;
		let widestPage = 0;
		try {
			const pages = editor.getPages?.();
			if (Array.isArray(pages)) for (const page of pages) {
				const width = page?.size?.w;
				if (typeof width === "number" && Number.isFinite(width) && width > widestPage) widestPage = width;
			}
		} catch {
			widestPage = 0;
		}
		if (widestPage > 0) return widestPage;
		let pageStyles = null;
		try {
			pageStyles = editor.getPageStyles?.() ?? null;
		} catch {
			pageStyles = null;
		}
		const pageWidthInches = pageStyles?.pageSize?.width;
		if (typeof pageWidthInches === "number" && Number.isFinite(pageWidthInches) && pageWidthInches > 0) return pageWidthInches * CSS_PX_PER_INCH;
		return null;
	};
	const resolvePdfPageWidth = () => {
		if (!(documents?.value ?? []).some((doc) => doc?.type === "application/pdf")) return null;
		const root = superdocRoot.value;
		if (!root?.querySelectorAll) return null;
		let widest = 0;
		for (const page of root.querySelectorAll(PDF_PAGE_SELECTOR)) {
			const measured = Number(page.clientWidth) || Number(page.getBoundingClientRect?.().width) || 0;
			let scaleFactor = NaN;
			if (typeof window !== "undefined" && typeof window.getComputedStyle === "function") scaleFactor = Number.parseFloat(window.getComputedStyle(page).getPropertyValue("--scale-factor"));
			const zoomFactor = (activeZoom.value ?? 100) / 100;
			const normalized = normalizePdfPageMeasurement(measured, scaleFactor, zoomFactor);
			if (normalized !== null && normalized > widest) widest = normalized;
		}
		return widest > 0 ? widest : null;
	};
	const resolveBaseDocumentWidth = () => {
		const superdoc = getSuperdoc();
		if (!superdoc) return null;
		const widths = [];
		const docs = documents?.value ?? [];
		for (const doc of docs) {
			if (doc?.type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document") continue;
			const width = resolveEditorPageWidth(doc.getEditor?.());
			if (width !== null) widths.push(width);
		}
		if (widths.length === 0) {
			const width = resolveEditorPageWidth(superdoc.activeEditor);
			if (width !== null) widths.push(width);
		}
		const pdfWidth = resolvePdfPageWidth();
		if (pdfWidth !== null) widths.push(pdfWidth);
		if (widths.length > 0) return Math.max(...widths);
		if (superdoc.activeEditor) {
			const docEl = superdocRoot.value?.querySelector?.(".superdoc__document");
			const measured = Number(docEl?.clientWidth) || Number(docEl?.getBoundingClientRect?.().width) || 0;
			if (measured > 0) {
				const zoomFactor = (activeZoom.value ?? 100) / 100;
				return zoomFactor > 0 ? measured / zoomFactor : measured;
			}
		}
		return null;
	};
	const resolveSidebarWidth = () => {
		if (!showCommentsSidebar?.value) return 0;
		const sidebarEl = rightSidebarRef?.value ?? superdocRoot.value?.querySelector?.(SIDEBAR_SELECTOR);
		const measured = Number(sidebarEl?.offsetWidth) || Number(sidebarEl?.getBoundingClientRect?.().width) || 0;
		return measured > 0 ? measured : 0;
	};
	const applyFitWidth = (superdoc, metrics) => {
		const options = resolveFitWidthOptions(superdoc.config?.zoom?.fitWidth);
		const target = computeAppliedFitZoom(metrics.availableWidth, metrics.documentWidth, options);
		if (target === null) return;
		if (target === activeZoom.value) return;
		activeZoom.value = target;
		superdoc.emit("zoomChange", {
			zoom: target,
			mode: "fit-width"
		});
	};
	const evaluateViewport = () => {
		const superdoc = getSuperdoc();
		if (!superdoc) return;
		const containerWidth = superdocContainerWidth.value;
		if (!(containerWidth > 0)) return;
		if (!isReady.value) return;
		const documentWidth = resolveBaseDocumentWidth();
		if (documentWidth === null) return;
		const availableWidth = containerWidth - resolveSidebarWidth();
		const fitZoom = computeFitZoom(availableWidth, documentWidth);
		if (fitZoom === null) return;
		const metrics = Object.freeze({
			availableWidth,
			documentWidth,
			fitZoom
		});
		const previous = viewportMetrics.value;
		if (!previous || previous.availableWidth !== availableWidth || previous.documentWidth !== documentWidth || previous.fitZoom !== fitZoom) viewportMetrics.value = metrics;
		if (!previous || previous.fitZoom !== fitZoom || Math.round(previous.documentWidth) !== Math.round(documentWidth)) superdoc.emit("viewport-change", metrics);
		if (zoomMode.value === "fit-width") applyFitWidth(superdoc, metrics);
	};
	watch(superdocContainerWidth, () => {
		nextTick(() => evaluateViewport());
	});
	watch(isReady, (ready) => {
		if (ready) evaluateViewport();
	});
	watch(zoomMode, (mode) => {
		if (mode === "fit-width") evaluateViewport();
	});
	if (showCommentsSidebar) watch(showCommentsSidebar, () => {
		nextTick(() => evaluateViewport());
	});
	const handleEditorCreate = () => {
		nextTick(() => evaluateViewport());
	};
	const handlePaginationUpdate = () => {
		nextTick(() => evaluateViewport());
	};
	const handlePdfDocumentReady = () => {
		nextTick(() => evaluateViewport());
	};
	const superdocAtSetup = getSuperdoc();
	superdocAtSetup?.on?.("editorCreate", handleEditorCreate);
	superdocAtSetup?.on?.("pagination-update", handlePaginationUpdate);
	superdocAtSetup?.on?.("pdf:document-ready", handlePdfDocumentReady);
	onBeforeUnmount(() => {
		superdocAtSetup?.off?.("editorCreate", handleEditorCreate);
		superdocAtSetup?.off?.("pagination-update", handlePaginationUpdate);
		superdocAtSetup?.off?.("pdf:document-ready", handlePdfDocumentReady);
	});
	return { evaluateViewport };
}
var _hoisted_1$12 = {
	class: "comments-container",
	id: "commentsContainer"
};
var _hoisted_2$6 = { class: "comments-layer" };
var _hoisted_3$4 = ["onClick", "data-id"];
var CommentsLayer_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "CommentsLayer",
	props: {
		user: {
			type: Object,
			required: true
		},
		parent: {
			type: Object,
			required: true
		}
	},
	emits: ["highlight-click"],
	setup(__props, { expose: __expose, emit: __emit }) {
		const superdocStore = useSuperdocStore();
		const commentsStore = useCommentsStore();
		const { COMMENT_EVENTS } = commentsStore;
		const { documentsWithConverations, activeComment, floatingCommentsOffset, getGroupedComments } = storeToRefs(commentsStore);
		const { documents, activeZoom } = storeToRefs(superdocStore);
		const { proxy } = getCurrentInstance();
		const emit = __emit;
		const props = __props;
		const addCommentEntry = (selection) => {
			const params = {
				creatorId: props.user.id,
				creatorEmail: props.user.email,
				creatorName: props.user.name,
				documentId: selection.documentId,
				selection,
				isFocused: true
			};
			const bounds = selection.selectionBounds;
			if (bounds.top > bounds.bottom) {
				const temp = bounds.top;
				bounds.top = bounds.bottom;
				bounds.bottom = temp;
			}
			if (bounds.left > bounds.right) {
				const temp = bounds.left;
				bounds.left = bounds.right;
				bounds.right = temp;
			}
			selection.selectionBounds = bounds;
			const matchedDocument = documents.value.find((c) => c.id === selection.documentId);
			const newConvo = useComment(params);
			activeComment.value = newConvo.commentId;
			matchedDocument.conversations.push(newConvo);
			proxy.$superdoc.emit("comments-update", {
				type: COMMENT_EVENTS.NEW,
				comment: newConvo.getValues()
			});
		};
		const getStyle = (conversation) => {
			const { selection, commentId } = conversation;
			selection.getContainerLocation(props.parent);
			const placement = conversation.selection.selectionBounds;
			const zoom = selection?.source === "pdf" ? (activeZoom.value ?? 100) / 100 : 1;
			const internalHighlightColor = "#078383";
			const externalHighlightColor = "#B1124B";
			let opacity = "33";
			activeComment.value === commentId && (opacity = "66");
			let fillColor = conversation.isInternal ? internalHighlightColor : externalHighlightColor;
			fillColor += opacity;
			return {
				position: "absolute",
				top: parseFloat(placement.top) * zoom + "px",
				left: placement.left * zoom + "px",
				width: (placement.right - placement.left) * zoom + "px",
				height: (placement.bottom - placement.top) * zoom + "px",
				backgroundColor: fillColor,
				pointerEvents: conversation.suppressClick ? "none" : "auto"
			};
		};
		const setFloatingCommentOffset = (conversation) => {
			floatingCommentsOffset.value = conversation.selection.selectionBounds.top;
		};
		const activateComment = (comment, e) => {
			comment.isFocused = true;
			activeComment.value = comment.commentId;
			comment.setActive(proxy.$superdoc);
			emit("highlight-click", comment);
		};
		const getCurrentComments = computed(() => {
			return getGroupedComments.value?.parentComments.filter((c) => c.selection && c.selection.selectionBounds?.top).filter((c) => !c.resolvedTime).filter((c) => c.selection?.source !== "super-editor");
		});
		watch(activeComment, (newVal) => {
			if (!newVal) return;
			document.querySelector(`[data-id="${newVal}"]`)?.scrollIntoView({
				behavior: "smooth",
				block: "center"
			});
		});
		__expose({
			addCommentEntry,
			activateComment,
			setFloatingCommentOffset
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$12, [createElementVNode("div", _hoisted_2$6, [(openBlock(true), createElementBlock(Fragment, null, renderList(getCurrentComments.value, (conversation) => {
				return openBlock(), createElementBlock("div", {
					class: "sd-comment-anchor sd-highlight",
					onClick: withModifiers(($event) => activateComment(conversation, $event), ["stop", "prevent"]),
					"data-id": conversation.commentId,
					style: normalizeStyle(getStyle(conversation))
				}, null, 12, _hoisted_3$4);
			}), 256))])]);
		};
	}
}, [["__scopeId", "data-v-0d6137fb"]]);
var _hoisted_1$11 = [
	"data-comment-id",
	"data-comment-instance-id",
	"data-comment-thread-id",
	"data-comment-position-key",
	"data-comment-page-index"
];
var _heightsCache = {};
var FloatingComments_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "FloatingComments",
	props: {
		currentDocument: {
			type: Object,
			required: true
		},
		parent: {
			type: Object,
			required: true
		}
	},
	setup(__props) {
		const ESTIMATED_HEIGHT = 110;
		const OBSERVER_MARGIN = 600;
		const resolveCollisions = (positions, activeIndex, gap) => {
			if (activeIndex >= 0) {
				positions[activeIndex].top = positions[activeIndex].anchorTop;
				let cursor = positions[activeIndex].top + positions[activeIndex].height + gap;
				for (let i = activeIndex + 1; i < positions.length; i++) {
					positions[i].top = Math.max(positions[i].anchorTop, cursor);
					cursor = positions[i].top + positions[i].height + gap;
				}
				cursor = positions[activeIndex].top - gap;
				for (let i = activeIndex - 1; i >= 0; i--) {
					const bottomEdge = cursor - positions[i].height;
					positions[i].top = Math.min(positions[i].anchorTop, bottomEdge);
					cursor = positions[i].top - gap;
				}
				const minTop = Math.min(...positions.map((p) => p.top));
				if (minTop < 0) {
					const shift = Math.abs(minTop);
					for (const p of positions) p.top += shift;
				}
			} else for (let i = 1; i < positions.length; i++) {
				const prev = positions[i - 1];
				const minTop = prev.top + prev.height + gap;
				if (positions[i].top < minTop) positions[i].top = minTop;
			}
		};
		const props = __props;
		const superdocStore = useSuperdocStore();
		const commentsStore = useCommentsStore();
		const { clearInstantSidebarAlignment } = commentsStore;
		const { activeComment, activeFloatingCommentInstanceId, editorCommentPositions, pendingComment, editingCommentId, instantSidebarAlignmentTargetY, instantSidebarAlignmentThreadId, instantSidebarAlignmentInstanceId } = storeToRefs(commentsStore);
		const { activeZoom } = storeToRefs(superdocStore);
		const floatingCommentInstances = computed(() => {
			const currentFloatingCommentInstances = commentsStore.getFloatingCommentInstances;
			return Array.isArray(currentFloatingCommentInstances) ? currentFloatingCommentInstances : [];
		});
		const floatingCommentsContainer = ref(null);
		const commentsRenderKey = ref(0);
		const sidebarOffsetY = ref(0);
		const disableInstantLayoutTransitions = ref(false);
		const isPendingThread = (commentOrId) => {
			const pendingId = pendingComment.value?.commentId;
			if (!pendingId) return false;
			if (typeof commentOrId === "object") return commentOrId?.commentId === pendingId;
			return commentOrId === pendingId || commentOrId === "pending";
		};
		const getThreadId = (comment) => {
			return comment?.commentId ?? comment?.importedId ?? null;
		};
		const resolveFloatingInstanceId = (threadId, preferredInstanceId = null) => {
			if (threadId == null) return null;
			const normalizedThreadId = String(threadId);
			const matchingInstances = floatingCommentInstances.value.filter((instance) => String(getThreadId(instance.comment)) === normalizedThreadId);
			if (!matchingInstances.length) return null;
			if (preferredInstanceId != null) {
				const preferredInstance = matchingInstances.find((instance) => String(instance.id) === String(preferredInstanceId));
				if (preferredInstance) return preferredInstance.id;
			}
			return matchingInstances.find((instance) => instance.isPrimary)?.id ?? matchingInstances[0]?.id ?? null;
		};
		const activeCommentInstanceId = computed(() => {
			if (!activeComment.value) return null;
			return resolveFloatingInstanceId(activeComment.value, activeFloatingCommentInstanceId.value);
		});
		const measuredHeights = ref({ ..._heightsCache });
		const visibleIds = ref(/* @__PURE__ */ new Set());
		const placeholderRefs = ref({});
		let observer = null;
		const observedElements = /* @__PURE__ */ new Set();
		const getAnchorTop = (instance) => {
			if (props.currentDocument.type === "application/pdf") {
				const zoom = (activeZoom.value ?? 100) / 100;
				return Number(instance?.comment?.selection?.selectionBounds?.top) * zoom;
			}
			return instance?.positionEntry?.bounds?.top;
		};
		const getPendingAnchorTop = () => {
			const positionEntry = editorCommentPositions.value["pending"];
			if (typeof positionEntry?.bounds?.top === "number" && !isNaN(positionEntry.bounds.top)) return positionEntry.bounds.top;
			const zoom = props.currentDocument.type === "application/pdf" ? (activeZoom.value ?? 100) / 100 : 1;
			const top = Number(pendingComment.value?.selection?.selectionBounds?.top);
			return isNaN(top) ? null : top * zoom;
		};
		const instantAlignmentInstanceKey = computed(() => {
			if (!instantSidebarAlignmentThreadId.value) return null;
			return resolveFloatingInstanceId(instantSidebarAlignmentThreadId.value, instantSidebarAlignmentInstanceId.value);
		});
		const allPositions = computed(() => {
			const instances = floatingCommentInstances.value;
			const hasPending = pendingComment.value && pendingComment.value.fileId === props.currentDocument.id;
			if (!instances.length && !hasPending) return [];
			const positions = [];
			for (const instance of instances) {
				const key = instance?.id;
				const top = getAnchorTop(instance);
				const threadId = getThreadId(instance?.comment);
				if (!key || !threadId || typeof top !== "number" || isNaN(top)) continue;
				positions.push({
					id: key,
					threadId,
					pageIndex: instance?.pageIndex ?? null,
					anchorTop: top,
					top,
					height: measuredHeights.value[key] || ESTIMATED_HEIGHT,
					commentRef: instance.comment,
					instanceRef: instance
				});
			}
			if (hasPending) {
				const pendingTop = getPendingAnchorTop();
				if (typeof pendingTop === "number" && !isNaN(pendingTop)) positions.push({
					id: "pending",
					anchorTop: pendingTop,
					top: pendingTop,
					height: measuredHeights.value["pending"] || ESTIMATED_HEIGHT,
					commentRef: pendingComment.value
				});
			}
			positions.sort((a, b) => a.anchorTop - b.anchorTop);
			const activeKey = hasPending ? "pending" : activeCommentInstanceId.value;
			resolveCollisions(positions, activeKey ? positions.findIndex((p) => p.id === activeKey) : -1, 15);
			return positions;
		});
		const totalHeight = computed(() => {
			if (!allPositions.value.length) return 0;
			let max = 0;
			for (const p of allPositions.value) {
				const bottom = p.top + p.height;
				if (bottom > max) max = bottom;
			}
			return max + 50;
		});
		const wrapperMinHeight = computed(() => {
			return totalHeight.value + Math.max(0, sidebarOffsetY.value);
		});
		const setupObserver = () => {
			if (observer) observer.disconnect();
			observer = new IntersectionObserver((entries) => {
				const newVisible = new Set(visibleIds.value);
				for (const entry of entries) {
					const id = entry.target.dataset.commentId;
					if (!id) continue;
					if (entry.isIntersecting) newVisible.add(id);
					else newVisible.delete(id);
				}
				visibleIds.value = newVisible;
			}, { rootMargin: `${OBSERVER_MARGIN}px 0px ${OBSERVER_MARGIN}px 0px` });
		};
		const observePlaceholders = () => {
			if (!observer) return;
			const currentElements = /* @__PURE__ */ new Set();
			for (const pos of allPositions.value) {
				const el = placeholderRefs.value[pos.id];
				if (!el) continue;
				currentElements.add(el);
				if (!observedElements.has(el)) {
					observer.observe(el);
					observedElements.add(el);
				}
			}
			for (const el of observedElements) if (!currentElements.has(el)) {
				observer.unobserve(el);
				observedElements.delete(el);
			}
		};
		const storeHeight = (key, height) => {
			if (height <= 0 || height === measuredHeights.value[key]) return;
			_heightsCache[key] = height;
			measuredHeights.value = {
				...measuredHeights.value,
				[key]: height
			};
		};
		const handleDialog = (dialog) => {
			if (!dialog) return;
			const { elementRef, commentId: instanceId } = dialog;
			if (!elementRef) return;
			nextTick(() => {
				const bounds = elementRef.value?.getBoundingClientRect();
				if (!bounds || bounds.height <= 0) return;
				if (instanceId) storeHeight(instanceId, bounds.height);
			});
		};
		const handleResize = (position) => {
			const key = position?.id;
			if (!key) return;
			nextTick(() => {
				const el = placeholderRefs.value[key];
				if (!el) return;
				const dialog = el.querySelector(".comments-dialog");
				if (!dialog) return;
				storeHeight(key, dialog.getBoundingClientRect().height);
				const isActiveInstance = key === activeCommentInstanceId.value;
				const isPending = key === "pending";
				const isEditingThread = !!editingCommentId.value && !!activeComment.value && position?.threadId != null && String(position.threadId) === String(activeComment.value);
				if (!isActiveInstance && !isPending && !isEditingThread) return;
				remeasureCommentKeys(allPositions.value.map((pos) => pos.id));
				scheduleDeferredRemeasure(() => allPositions.value.map((pos) => pos.id));
			});
		};
		const setInstantLayoutTransitionsDisabled = (disabled) => {
			disableInstantLayoutTransitions.value = disabled;
		};
		const alignCommentKeyToClientY = (key, targetY, onComplete) => {
			if (!Number.isFinite(targetY)) {
				onComplete?.(false);
				return;
			}
			const el = placeholderRefs.value[key];
			if (!el) {
				onComplete?.(false);
				return;
			}
			const currentTop = el.getBoundingClientRect().top;
			sidebarOffsetY.value += targetY - currentTop;
			onComplete?.(true);
		};
		const setPlaceholderRef = (id, el) => {
			if (el) {
				placeholderRefs.value[id] = el;
				if (observer && !observedElements.has(el)) {
					observer.observe(el);
					observedElements.add(el);
				}
			} else {
				const prev = placeholderRefs.value[id];
				if (prev && observer) {
					observer.unobserve(prev);
					observedElements.delete(prev);
				}
				delete placeholderRefs.value[id];
			}
		};
		let remeasureTimers = [];
		let scrollTimer = null;
		const clearDeferredRemeasureTimers = () => {
			remeasureTimers.forEach(clearTimeout);
			remeasureTimers = [];
		};
		const remeasureCommentKeys = (keys) => {
			for (const key of keys.filter(Boolean)) {
				const el = placeholderRefs.value[key];
				if (!el) continue;
				const dialog = el.querySelector(".comments-dialog");
				if (!dialog) continue;
				storeHeight(key, dialog.getBoundingClientRect().height);
			}
		};
		const REMEASURE_AFTER_DOM_SETTLE_MS = 50;
		const REMEASURE_AFTER_PLACEHOLDER_TRANSITION_MS = 350;
		const scheduleDeferredRemeasure = (keysOrGetter) => {
			clearDeferredRemeasureTimers();
			const resolveKeys = typeof keysOrGetter === "function" ? keysOrGetter : () => keysOrGetter;
			remeasureTimers.push(setTimeout(() => remeasureCommentKeys(resolveKeys()), REMEASURE_AFTER_DOM_SETTLE_MS));
			remeasureTimers.push(setTimeout(() => remeasureCommentKeys(resolveKeys()), REMEASURE_AFTER_PLACEHOLDER_TRANSITION_MS));
		};
		const finishInstantSidebarAlignment = () => {
			clearInstantSidebarAlignment();
			requestAnimationFrame(() => {
				setInstantLayoutTransitionsDisabled(false);
			});
		};
		const applyInstantSidebarAlignment = (key, targetY) => {
			if (!key || !Number.isFinite(targetY)) return;
			setInstantLayoutTransitionsDisabled(true);
			nextTick(() => {
				remeasureCommentKeys([key]);
				alignCommentKeyToClientY(key, targetY, () => {
					finishInstantSidebarAlignment();
				});
			});
		};
		watch(activeCommentInstanceId, (newKey, oldKey) => {
			clearDeferredRemeasureTimers();
			const keysToRemeasure = [newKey, oldKey];
			const hasPendingInstantAlignment = newKey && newKey === instantAlignmentInstanceKey.value && Number.isFinite(instantSidebarAlignmentTargetY.value);
			nextTick(() => {
				if (hasPendingInstantAlignment) {
					remeasureCommentKeys(keysToRemeasure);
					return;
				}
				scheduleDeferredRemeasure(keysToRemeasure);
			});
		});
		watch([
			activeCommentInstanceId,
			instantAlignmentInstanceKey,
			instantSidebarAlignmentTargetY
		], ([activeKey, requestKey, targetY]) => {
			if (!activeKey || !requestKey || activeKey !== requestKey || !Number.isFinite(targetY)) return;
			applyInstantSidebarAlignment(activeKey, targetY);
		});
		watch(editingCommentId, () => {
			clearDeferredRemeasureTimers();
			nextTick(() => {
				scheduleDeferredRemeasure(() => allPositions.value.map((pos) => pos.id));
			});
		});
		watch(activeComment, () => {
			if (scrollTimer) clearTimeout(scrollTimer);
			if (!activeComment.value) {
				clearInstantSidebarAlignment();
				setInstantLayoutTransitionsDisabled(false);
				sidebarOffsetY.value = 0;
				return;
			}
			if (!(isPendingThread(activeComment.value) ? pendingComment.value : commentsStore.getComment(activeComment.value))) return;
			const key = isPendingThread(activeComment.value) ? "pending" : activeCommentInstanceId.value;
			if (!key) return;
			if (key === instantAlignmentInstanceKey.value && Number.isFinite(instantSidebarAlignmentTargetY.value)) {
				setInstantLayoutTransitionsDisabled(true);
				return;
			}
			nextTick(() => {
				const applyAlignment = () => {
					const el = placeholderRefs.value[key];
					if (!el) return;
					const parentRect = props.parent?.getBoundingClientRect?.();
					if (!parentRect) return;
					const activePosition = allPositions.value.find((position) => position.id === key);
					const anchorTop = key === "pending" ? getPendingAnchorTop() : activePosition?.anchorTop;
					if (typeof anchorTop !== "number" || isNaN(anchorTop)) return;
					const currentTop = el.getBoundingClientRect().top;
					const desiredTop = parentRect.top + anchorTop;
					sidebarOffsetY.value += desiredTop - currentTop;
				};
				scrollTimer = setTimeout(applyAlignment, 400);
			});
		});
		watch(activeZoom, () => {
			if (props.currentDocument.type === "application/pdf") {
				for (const k in _heightsCache) delete _heightsCache[k];
				measuredHeights.value = {};
				commentsRenderKey.value += 1;
			}
		});
		let prevPositionIds = /* @__PURE__ */ new Set();
		watch(allPositions, (positions) => {
			const currentIds = new Set(positions.map((p) => p.id));
			const newVisible = new Set(visibleIds.value);
			let visibilityChanged = false;
			let nearbyTop = -Infinity;
			let nearbyBottom = Infinity;
			const container = floatingCommentsContainer.value;
			if (container) {
				const rect = container.getBoundingClientRect();
				nearbyTop = -rect.top - OBSERVER_MARGIN;
				nearbyBottom = -rect.top + window.innerHeight + OBSERVER_MARGIN;
			}
			const positionById = new Map(positions.map((p) => [p.id, p]));
			for (const id of currentIds) if (!newVisible.has(id)) {
				const pos = positionById.get(id);
				if (!pos || pos.top >= nearbyTop && pos.top <= nearbyBottom) {
					newVisible.add(id);
					visibilityChanged = true;
				}
			}
			for (const id of newVisible) if (!currentIds.has(id)) {
				newVisible.delete(id);
				visibilityChanged = true;
			}
			if (visibilityChanged) visibleIds.value = newVisible;
			for (const id of prevPositionIds) if (!currentIds.has(id)) delete _heightsCache[id];
			if (prevPositionIds.size !== currentIds.size || [...prevPositionIds].some((id) => !currentIds.has(id))) {
				const cleaned = {};
				for (const id of currentIds) if (_heightsCache[id]) cleaned[id] = _heightsCache[id];
				measuredHeights.value = cleaned;
				nextTick(() => {
					for (const pos of positions) {
						const el = placeholderRefs.value[pos.id];
						if (!el) continue;
						const dialog = el.querySelector(".comments-dialog");
						if (!dialog) continue;
						storeHeight(pos.id, dialog.getBoundingClientRect().height);
					}
				});
			}
			prevPositionIds = currentIds;
			nextTick(observePlaceholders);
		});
		onMounted(() => {
			setupObserver();
			nextTick(observePlaceholders);
		});
		onBeforeUnmount(() => {
			if (observer) {
				observer.disconnect();
				observer = null;
				observedElements.clear();
			}
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "section-wrapper",
				ref_key: "floatingCommentsContainer",
				ref: floatingCommentsContainer,
				style: normalizeStyle({
					minHeight: wrapperMinHeight.value + "px",
					transition: disableInstantLayoutTransitions.value ? "none" : void 0
				})
			}, [createElementVNode("div", {
				class: "sidebar-container",
				style: normalizeStyle({
					transform: `translateY(${sidebarOffsetY.value}px)`,
					transition: disableInstantLayoutTransitions.value ? "none" : void 0
				})
			}, [(openBlock(true), createElementBlock(Fragment, null, renderList(allPositions.value, (pos) => {
				return openBlock(), createElementBlock("div", {
					key: pos.id,
					ref_for: true,
					ref: (el) => setPlaceholderRef(pos.id, el),
					"data-comment-id": pos.id,
					"data-comment-instance-id": pos.id,
					"data-comment-thread-id": pos.threadId,
					"data-comment-position-key": pos.instanceRef?.positionKey ?? "",
					"data-comment-page-index": pos.pageIndex ?? "",
					style: normalizeStyle({
						top: pos.top + "px",
						height: pos.height + "px",
						transition: disableInstantLayoutTransitions.value ? "none" : void 0
					}),
					class: "comment-placeholder"
				}, [visibleIds.value.has(pos.id) || pos.id === activeCommentInstanceId.value || pos.id === "pending" ? (openBlock(), createBlock(CommentDialog_default, {
					key: pos.id + commentsRenderKey.value,
					onReady: handleDialog,
					onResize: ($event) => handleResize(pos),
					class: "floating-comment",
					parent: __props.parent,
					comment: pos.commentRef,
					"floating-instance-id": pos.id,
					"floating-page-index": pos.pageIndex,
					"floating-position-entry": pos.instanceRef?.positionEntry ?? null,
					"is-floating-instance-active": pos.id === activeCommentInstanceId.value
				}, null, 8, [
					"onResize",
					"parent",
					"comment",
					"floating-instance-id",
					"floating-page-index",
					"floating-position-entry",
					"is-floating-instance-active"
				])) : createCommentVNode("", true)], 12, _hoisted_1$11);
			}), 128))], 4)], 4);
		};
	}
}, [["__scopeId", "data-v-04df5ac1"]]);
var TextField_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "TextField",
	props: {
		field: {
			type: Object,
			required: true
		},
		isEditing: {
			type: Boolean,
			required: false,
			default: false
		},
		styleOverride: {
			type: Object,
			required: false,
			default: () => ({})
		}
	},
	setup(__props) {
		const props = __props;
		const getStyle = computed(() => {
			const style = { ...props.styleOverride };
			if (!props.isEditing) return style;
			style.backgroundColor = "#FFF";
			return style;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "text-field",
				style: normalizeStyle(getStyle.value)
			}, toDisplayString(__props.field.value || __props.field.placeholder), 5);
		};
	}
}, [["__scopeId", "data-v-f3984d30"]]);
var _hoisted_1$10 = ["innerHTML"];
var ParagraphField_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "ParagraphField",
	props: {
		field: {
			type: Object,
			required: true
		},
		isEditing: {
			type: Boolean,
			required: false,
			default: false
		},
		styleOverride: {
			type: Object,
			required: false,
			default: () => ({})
		}
	},
	setup(__props) {
		const getStyle = computed(() => {
			return { fontSize: "11pt" };
		});
		return (_ctx, _cache) => {
			return __props.field.value ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "paragraph-field",
				innerHTML: __props.field.value
			}, null, 8, _hoisted_1$10)) : (openBlock(), createElementBlock("span", {
				key: 1,
				style: normalizeStyle(getStyle.value)
			}, toDisplayString(__props.field.placeholder || __props.field.label), 5));
		};
	}
}, [["__scopeId", "data-v-ce5a87b3"]]);
var _hoisted_1$9 = ["src"];
var _hoisted_2$5 = { key: 1 };
var ImageField_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "ImageField",
	props: {
		field: {
			type: Object,
			required: true
		},
		isEditing: {
			type: Boolean,
			required: false,
			default: false
		},
		styleOverride: {
			type: Object,
			required: false,
			default: () => ({})
		},
		optionId: {
			type: String,
			required: true
		},
		noStyle: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	setup(__props) {
		const props = __props;
		const getStyle = computed(() => {
			return {
				maxHeight: props.styleOverride.coordinates?.minHeight,
				maxWidth: props.styleOverride.coordinates?.minWidth
			};
		});
		const imageValue = computed(() => {
			if (props.field.valueGetter && typeof props.field.valueGetter === "function") return props.field.valueGetter({ annotationId: props.optionId });
			if (typeof props.field.value === "string") return props.field.value;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "image-field",
				style: normalizeStyle(getStyle.value)
			}, [__props.field.value && imageValue.value ? (openBlock(), createElementBlock("img", {
				key: 0,
				src: imageValue.value,
				alt: "image",
				style: normalizeStyle(getStyle.value)
			}, null, 12, _hoisted_1$9)) : !__props.noStyle ? (openBlock(), createElementBlock("span", _hoisted_2$5, toDisplayString(__props.field.placeholder || __props.field.label), 1)) : createCommentVNode("", true)], 4);
		};
	}
}, [["__scopeId", "data-v-7dd69850"]]);
var _hoisted_1$8 = { class: "checkbox-container" };
var _hoisted_2$4 = {
	key: 0,
	class: "checkbox-editing-placeholder"
};
var CheckboxField_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "CheckboxField",
	props: {
		field: {
			type: Object,
			required: true
		},
		isEditing: {
			type: Boolean,
			required: false,
			default: false
		},
		optionId: {
			type: String,
			required: true
		},
		styleOverride: {
			type: Object,
			required: false,
			default: () => ({})
		}
	},
	setup(__props) {
		const props = __props;
		const getValue = computed(() => {
			return props.field.options.find((o) => o.annotationId.includes(props.optionId))?.checked;
		});
		const getPreviewStyle = computed(() => {
			const borderWidth = 2;
			const width = Number.parseFloat(props.styleOverride?.coordinates?.minWidth || 0) - borderWidth + "px";
			return {
				width,
				height: Number.parseFloat(props.styleOverride?.coordinates?.minHeight || 0) - borderWidth + "px",
				fontSize: parseFloat(width) + "pt"
			};
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$8, [props.isEditing ? (openBlock(), createElementBlock("div", _hoisted_2$4)) : (openBlock(), createElementBlock("div", {
				key: 1,
				class: "checkbox-preview",
				style: normalizeStyle(getPreviewStyle.value)
			}, toDisplayString(getValue.value ? "x" : ""), 5))]);
		};
	}
}, [["__scopeId", "data-v-4581e928"]]);
var _hoisted_1$7 = { key: 0 };
var SelectField_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "SelectField",
	props: {
		field: {
			type: Object,
			required: true
		},
		fieldStyle: {
			type: Object,
			required: false,
			default: () => ({})
		},
		styleOverride: {
			type: Object,
			required: false,
			default: () => ({})
		}
	},
	setup(__props) {
		const props = __props;
		const getStyle = computed(() => {
			if (!props.isEditing) return { ...props.styleOverride };
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				style: normalizeStyle(getStyle.value),
				class: "select-container"
			}, [!props.isEditing ? (openBlock(), createElementBlock("div", _hoisted_1$7, toDisplayString(__props.field.value || __props.field.placeholder), 1)) : createCommentVNode("", true)], 4);
		};
	}
}, [["__scopeId", "data-v-1e49d9b3"]]);
const floor = (val, precision) => {
	const multiplier = 10 ** (precision || 0);
	return Math.floor(val * multiplier) / multiplier;
};
const useHrbrFieldsStore = defineStore("hrbr-fields", () => {
	const { documents } = storeToRefs(useSuperdocStore());
	const hrbrFieldsConfig = reactive({ name: "hrbr-fields" });
	const fieldComponentsMap = Object.freeze({
		TEXTINPUT: markRaw(TextField_default),
		HTMLINPUT: markRaw(ParagraphField_default),
		SELECT: markRaw(SelectField_default),
		CHECKBOXINPUT: markRaw(CheckboxField_default),
		SIGNATUREINPUT: markRaw(ImageField_default),
		IMAGEINPUT: markRaw(ImageField_default)
	});
	const getField = (documentId, fieldId) => {
		const doc = documents.value.find((d) => d.id === documentId);
		if (!doc) return;
		const field = doc.fields.find((f) => f.id === fieldId);
		if (field) return field;
	};
	const getAnnotations = computed(() => {
		const mappedAnnotations = [];
		documents.value.forEach((doc) => {
			const { id, annotations } = doc;
			const docContainer = doc.container;
			if (!docContainer) return;
			const bounds = docContainer.getBoundingClientRect();
			const pageBoundsMap = doc.pageContainers;
			if (!bounds || !pageBoundsMap) return;
			annotations.forEach((annotation) => {
				const { itemid: fieldId, page, nostyle } = annotation;
				let annotationId = annotation.pageannotation;
				if (annotation.itemfieldtype === "CHECKBOXINPUT") annotationId = annotation.annotationid;
				const { x1, y1, x2, y2 } = annotation;
				const coordinates = {
					x1,
					y1,
					x2,
					y2
				};
				const pageContainer = document.getElementById(`${id}-page-${page + 1}`);
				if (!pageContainer) return;
				const pageBounds = pageContainer.getBoundingClientRect();
				const pageInfo = doc.pageContainers.find((p) => p.page === page);
				const scale = pageBounds.height / pageInfo.containerBounds.originalHeight;
				const mappedCoordinates = _mapAnnotation(coordinates, scale, pageBounds.bottom - bounds.top, pageBounds.left - bounds.left);
				const annotationStyle = {
					fontSize: floor(annotation.original_font_size * scale, 2) + "pt",
					fontFamily: annotation.fontfamily || "Arial",
					originalFontSize: floor(annotation.original_font_size * scale, 2),
					coordinates: mappedCoordinates
				};
				const field = {
					documentId: id,
					fieldId,
					page,
					annotationId,
					originalAnnotationId: annotation.originalannotationid,
					coordinates: mappedCoordinates,
					style: annotationStyle,
					nostyle: nostyle ?? false
				};
				mappedAnnotations.push(field);
			});
		});
		return mappedAnnotations;
	});
	const _mapAnnotation = (coordinates, scale, pageBottom, boundsLeft) => {
		const { x1, y1, x2, y2 } = coordinates;
		const mappedX1 = x1 * scale;
		const mappedY1 = y1 * scale;
		const mappedX2 = x2 * scale;
		const mappedY2 = y2 * scale;
		return {
			top: `${pageBottom - mappedY2}px`,
			left: `${mappedX1 + boundsLeft}px`,
			minWidth: `${mappedX2 - mappedX1}px`,
			minHeight: `${mappedY2 - mappedY1}px`
		};
	};
	return {
		hrbrFieldsConfig,
		fieldComponentsMap,
		getAnnotations,
		getField
	};
});
var _hoisted_1$6 = { class: "main-container" };
var HrbrFieldsLayer_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "HrbrFieldsLayer",
	props: { fields: {
		type: Object,
		required: true
	} },
	setup(__props) {
		const hrbrFieldsStore = useHrbrFieldsStore();
		const { getAnnotations } = storeToRefs(hrbrFieldsStore);
		const { fieldComponentsMap, getField } = hrbrFieldsStore;
		const getStyle = computed(() => (entry) => {
			const { coordinates, field } = entry;
			if (["TEXTINPUT", "SELECT"].includes(field.fieldType)) coordinates.top = `${coordinates.top.split("px")[0] - 4}px`;
			if (["HTMLINPUT"].includes(field.fieldType)) coordinates.width = `${coordinates.minWidth.split("px")[0] / 1.3362445414847162}px`;
			return {
				position: "absolute",
				...coordinates,
				lineHeight: 1
			};
		});
		const getAnnotationWithField = computed(() => {
			const annotationsWithFields = [];
			getAnnotations.value.forEach((annotation) => {
				const field = getField(annotation.documentId, annotation.fieldId);
				if (!field) return;
				annotationsWithFields.push({
					...annotation,
					field
				});
			});
			return annotationsWithFields;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$6, [(openBlock(true), createElementBlock(Fragment, null, renderList(getAnnotationWithField.value, (entry) => {
				return openBlock(), createElementBlock("div", {
					style: normalizeStyle(getStyle.value(entry)),
					class: normalizeClass(["field-container", { "field-container--no-style": entry.nostyle }])
				}, [(openBlock(), createBlock(resolveDynamicComponent(unref(fieldComponentsMap)[entry.field.fieldType]), {
					class: "field-component",
					field: entry.field,
					"style-override": entry.style,
					"option-id": entry.originalAnnotationId,
					"no-style": entry.nostyle,
					"is-editing": false
				}, null, 8, [
					"field",
					"style-override",
					"option-id",
					"no-style"
				]))], 6);
			}), 256))]);
		};
	}
}, [["__scopeId", "data-v-22e6ae02"]]);
var _hoisted_1$5 = ["data-page-index"];
var WhiteboardPage_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "WhiteboardPage",
	props: {
		whiteboard: {
			type: Object,
			required: true
		},
		page: {
			type: Object,
			required: true
		},
		pageSize: {
			type: Object,
			default: null
		},
		pageOffset: {
			type: Object,
			default: null
		},
		enabled: {
			type: Boolean,
			default: true
		}
	},
	setup(__props) {
		const props = __props;
		const containerRef = ref(null);
		const mountPage = () => {
			const container = containerRef.value;
			if (!container || !props.page) return;
			props.page.mount(container);
			if (props.pageSize) props.page.resize(props.pageSize.width, props.pageSize.height);
		};
		const handleDrop = (event) => {
			if (!props.page || !event?.dataTransfer) return;
			if (!props.enabled || props.whiteboard.getTool() !== "select") return;
			event.preventDefault();
			event.stopPropagation();
			const container = containerRef.value;
			if (!container) return;
			const rect = container.getBoundingClientRect();
			const x = event.clientX - rect.left;
			const y = event.clientY - rect.top;
			const currentWidth = props.pageSize?.width;
			const originalWidth = props.pageSize?.originalWidth ?? currentWidth;
			const scale = Number.isFinite(currentWidth) && Number.isFinite(originalWidth) && originalWidth ? currentWidth / originalWidth : 1;
			if (handleStickerDrop(event, x, y, scale)) return;
			if (handleFileImageDrop(event, x, y, scale)) return;
			if (handleCommentDrop(event, x, y)) return;
			handlePlainTextDrop(event, x, y);
		};
		const handleStickerDrop = (event, x, y, scale) => {
			const stickerId = event.dataTransfer.getData("application/sticker");
			if (!stickerId) return false;
			const sticker = (props.whiteboard.getType("stickers") || []).find((item) => item.id === stickerId);
			if (!sticker?.src) return false;
			props.page.addImage({
				stickerId: sticker.id,
				x,
				y,
				src: sticker.src,
				width: Number.isFinite(sticker.width) ? sticker.width * scale : sticker.width,
				height: Number.isFinite(sticker.height) ? sticker.height * scale : sticker.height,
				type: "sticker"
			});
			return true;
		};
		const handleFileImageDrop = (event, x, y, scale) => {
			const imageFile = Array.from(event.dataTransfer.files || []).find((file) => file.type.startsWith("image/"));
			if (!imageFile) return false;
			const reader = new FileReader();
			reader.onload = () => {
				if (typeof reader.result !== "string") return;
				props.page.addImage({
					x,
					y,
					src: reader.result,
					type: "image"
				});
			};
			reader.readAsDataURL(imageFile);
			return true;
		};
		const handleCommentDrop = (event, x, y) => {
			const commentId = event.dataTransfer.getData("application/comment");
			if (!commentId) return false;
			const comment = (props.whiteboard.getType("comments") || []).find((item) => item.id === commentId);
			if (!comment?.text) return false;
			props.page.addText({
				x,
				y,
				content: comment.text
			});
			return true;
		};
		const handlePlainTextDrop = (event, x, y) => {
			const text = event.dataTransfer.getData("text/plain");
			if (!text) return false;
			props.page.addText({
				x,
				y,
				content: text
			});
			return true;
		};
		watch(() => [
			props.page,
			props.pageSize?.width,
			props.pageSize?.height
		], () => {
			nextTick(mountPage);
		});
		onMounted(() => {
			mountPage();
		});
		onBeforeUnmount(() => {
			props.page?.destroy();
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "containerRef",
				ref: containerRef,
				class: "whiteboard-page",
				"data-page-index": __props.page.pageIndex,
				onDragover: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"])),
				onDrop: withModifiers(handleDrop, ["prevent"]),
				style: normalizeStyle({
					width: (__props.pageSize?.width ?? __props.page.size?.width) + "px",
					height: (__props.pageSize?.height ?? __props.page.size?.height) + "px",
					transform: `translate(${__props.pageOffset?.left ?? 0}px, ${__props.pageOffset?.top ?? 0}px)`
				})
			}, null, 44, _hoisted_1$5);
		};
	}
}, [["__scopeId", "data-v-c876c9b5"]]);
var WhiteboardLayer_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "WhiteboardLayer",
	props: {
		whiteboard: {
			type: Object,
			required: true
		},
		pages: {
			type: Array,
			default: () => []
		},
		pageSizes: {
			type: Object,
			default: () => ({})
		},
		pageOffsets: {
			type: Object,
			default: () => ({})
		},
		enabled: {
			type: Boolean,
			default: true
		},
		opacity: {
			type: Number,
			default: 1
		}
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "whiteboard-layer",
				"aria-hidden": "true",
				style: normalizeStyle({
					opacity: __props.opacity,
					pointerEvents: __props.enabled ? "auto" : "none"
				})
			}, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.pages, (page) => {
				return openBlock(), createBlock(WhiteboardPage_default, {
					key: page.pageIndex,
					page,
					"page-size": __props.pageSizes?.[page.pageIndex],
					"page-offset": __props.pageOffsets?.[page.pageIndex],
					whiteboard: __props.whiteboard,
					enabled: __props.enabled
				}, null, 8, [
					"page",
					"page-size",
					"page-offset",
					"whiteboard",
					"enabled"
				]);
			}), 128))], 4);
		};
	}
}, [["__scopeId", "data-v-8448a15a"]]);
const useWhiteboard = ({ proxy, layers, documents, modules }) => {
	const whiteboardModuleConfig = computed(() => {
		const config = modules.value?.whiteboard ?? modules.whiteboard;
		if (config === false || config == null) return null;
		return config;
	});
	const whiteboard = proxy?.$superdoc?.whiteboard;
	const whiteboardPages = shallowRef([]);
	const whiteboardPageSizes = reactive({});
	const whiteboardPageOffsets = reactive({});
	const whiteboardReady = ref(false);
	const whiteboardReadyPages = ref(0);
	const whiteboardTotalPages = ref(0);
	const whiteboardOpacity = ref(1);
	const whiteboardEnabled = ref(whiteboardModuleConfig.value?.enabled ?? false);
	const checkWhiteboardReady = () => {
		if (whiteboardReady.value) return;
		whiteboardReadyPages.value += 1;
		const total = whiteboardTotalPages.value || whiteboardPages.value.length;
		if (total && whiteboardReadyPages.value >= total) {
			whiteboardReady.value = true;
			proxy?.$superdoc?.emit("whiteboard:ready", { whiteboard });
		}
	};
	const handleWhiteboardPageReady = (payload) => {
		if (!payload) return;
		const doc = documents.value?.[0];
		if (!doc) return;
		if (doc.type === "application/pdf") handleWhiteboardPDFPageReady(payload);
	};
	const handleWhiteboardPDFPageReady = (payload) => {
		const { pageIndex, width, height, originalWidth, originalHeight } = payload;
		const size = {
			width,
			height,
			originalWidth,
			originalHeight
		};
		whiteboard?.setPageSize(pageIndex, size);
		whiteboardPageSizes[pageIndex] = size;
		const existingPage = whiteboard?.getPage(pageIndex);
		if (existingPage) existingPage.setSize(size);
		if (whiteboard) {
			whiteboardPages.value = whiteboard.getPages().sort((a, b) => a.pageIndex - b.pageIndex).map((page) => markRaw(page));
			whiteboardTotalPages.value = whiteboardPages.value.length;
		}
		nextTick(() => {
			updateWhiteboardPageOffsets();
			checkWhiteboardReady();
		});
	};
	const handleWhiteboardChange = (data) => {
		proxy?.$superdoc?.emit("whiteboard:change", data);
	};
	const handleWhiteboardSetData = (pages) => {
		pages.forEach((page) => {
			const size = whiteboardPageSizes[page.pageIndex];
			if (size) page.setSize(size);
		});
		whiteboardPages.value = pages.map((page) => markRaw(page));
		whiteboardTotalPages.value = whiteboardPages.value.length;
		nextTick(() => updateWhiteboardPageOffsets());
	};
	const handleWhiteboardEnabled = (enabled) => {
		whiteboardEnabled.value = enabled;
		proxy?.$superdoc?.emit("whiteboard:enabled", enabled);
	};
	const handleWhiteboardOpacity = (opacity) => {
		whiteboardOpacity.value = opacity;
	};
	const handleWhiteboardTool = (tool) => {
		proxy?.$superdoc?.emit("whiteboard:tool", tool);
	};
	const updateWhiteboardPageSizes = () => {
		const doc = documents.value?.[0];
		if (!doc) return;
		if (doc.type === "application/pdf") updateWhiteboardPDFPageSizes({ doc });
	};
	const updateWhiteboardPDFPageSizes = ({ doc }) => {
		whiteboardPages.value.forEach((page) => {
			const pageId = `${doc.id}-page-${page.pageIndex + 1}`;
			const pageEl = document.querySelector(`[data-page-id="${pageId}"]`);
			if (!pageEl) return;
			const pageBounds = pageEl.getBoundingClientRect();
			const existingSize = whiteboardPageSizes[page.pageIndex] || {};
			const originalWidth = existingSize.originalWidth ?? page.size?.originalWidth ?? pageBounds.width;
			const originalHeight = existingSize.originalHeight ?? page.size?.originalHeight ?? pageBounds.height;
			const size = {
				width: pageBounds.width,
				height: pageBounds.height,
				originalWidth,
				originalHeight
			};
			whiteboardPageSizes[page.pageIndex] = size;
			page.setSize(size);
		});
	};
	const updateWhiteboardPageOffsets = () => {
		const layerBounds = layers.value?.getBoundingClientRect?.();
		if (!layerBounds) return;
		const doc = documents.value?.[0];
		if (!doc) return;
		if (doc.type === "application/pdf") updateWhiteboardPDFPageOffsets({
			doc,
			layerBounds
		});
	};
	const updateWhiteboardPDFPageOffsets = ({ doc, layerBounds }) => {
		whiteboardPages.value.forEach((page) => {
			const pageId = `${doc.id}-page-${page.pageIndex + 1}`;
			const pageEl = document.querySelector(`[data-page-id="${pageId}"]`);
			if (!pageEl) return;
			const pageBounds = pageEl.getBoundingClientRect();
			whiteboardPageOffsets[page.pageIndex] = {
				top: pageBounds.top - layerBounds.top,
				left: pageBounds.left - layerBounds.left
			};
		});
	};
	if (whiteboard) {
		whiteboard.on("change", handleWhiteboardChange);
		whiteboard.on("setData", handleWhiteboardSetData);
		whiteboard.on("enabled", handleWhiteboardEnabled);
		whiteboard.on("opacity", handleWhiteboardOpacity);
		whiteboard.on("tool", handleWhiteboardTool);
	}
	onBeforeUnmount(() => {
		if (!whiteboard) return;
		whiteboard.off("change", handleWhiteboardChange);
		whiteboard.off("setData", handleWhiteboardSetData);
		whiteboard.off("opacity", handleWhiteboardOpacity);
		whiteboard.off("enabled", handleWhiteboardEnabled);
		whiteboard.off("tool", handleWhiteboardTool);
	});
	return {
		whiteboard,
		whiteboardModuleConfig,
		whiteboardPages,
		whiteboardPageSizes,
		whiteboardPageOffsets,
		whiteboardEnabled,
		whiteboardOpacity,
		whiteboardReady,
		handleWhiteboardPageReady,
		updateWhiteboardPageSizes,
		updateWhiteboardPageOffsets
	};
};
var _hoisted_1$4 = { class: "superdoc-html-viewer" };
var _hoisted_2$3 = { class: "superdoc-html-viewer__document" };
var _hoisted_3$3 = ["innerHTML"];
var HtmlViewer_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "HtmlViewer",
	props: {
		fileSource: {
			type: [File, Blob],
			required: true
		},
		documentId: {
			type: String,
			required: true
		}
	},
	emits: ["ready", "selection-change"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const documentContent = ref("");
		const emit = __emit;
		const handleSelectionChange = () => {
			const selection = window.getSelection();
			console.debug("selection from html viewer", selection);
			emit("selection-change", selection);
		};
		const getDocumentHtml = (fileSource) => {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (e) => {
					const htmlString = e.target.result;
					resolve(htmlString);
				};
				reader.onerror = (e) => reject(e);
				reader.readAsText(fileSource);
			});
		};
		const initViewer = async () => {
			try {
				documentContent.value = await getDocumentHtml(props.fileSource);
				emit("ready", props.documentId);
			} catch (error) {
				emit("error", error);
				console.error("Error loading document", error);
			}
		};
		onMounted(() => {
			initViewer();
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$4, [createElementVNode("div", _hoisted_2$3, [createElementVNode("div", {
				class: "superdoc-html-viewer__content",
				innerHTML: documentContent.value,
				onMouseup: handleSelectionChange
			}, null, 40, _hoisted_3$3)])]);
		};
	}
}, [["__scopeId", "data-v-da3494ba"]]);
var _hoisted_1$3 = {
	class: "ai-highlight-container",
	id: "aiHighlightContainer"
};
var AiLayer_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "AiLayer",
	props: { editor: {
		type: Object,
		required: false,
		default: null
	} },
	setup(__props, { expose: __expose }) {
		const props = __props;
		const superdocStore = useSuperdocStore();
		const highlightLayer = ref(null);
		const getStyle = () => {
			const placement = superdocStore.activeSelection.selectionBounds;
			return {
				position: "absolute",
				top: parseFloat(placement.top) + "px",
				left: placement.left + "px",
				width: placement.right - placement.left + "px",
				height: placement.bottom - placement.top + "px",
				backgroundColor: "#6366f133",
				pointerEvents: "none"
			};
		};
		const addAiHighlight = () => {
			if (props.editor && !props.editor.isDestroyed) props.editor.commands.insertAiMark();
			else if (highlightLayer.value && !highlightLayer.value.hasChildNodes()) {
				const highlightDiv = document.createElement("div");
				highlightDiv.className = "ai-highlight-anchor sd-highlight";
				Object.assign(highlightDiv.style, getStyle());
				highlightLayer.value.appendChild(highlightDiv);
			}
		};
		const updateAiHighlight = () => {
			if (props.editor && !props.editor.isDestroyed) props.editor.commands.updateAiHighlightStyle("sd-ai-highlight-pulse");
			else if (highlightLayer.value) {
				const highlights = highlightLayer.value.querySelectorAll(".ai-highlight-anchor");
				Array.from(highlights).forEach((highlight) => {
					highlight.classList.add("sd-ai-highlight-pulse");
				});
			}
		};
		const removeAiHighlight = () => {
			if (props.editor && !props.editor.isDestroyed) props.editor.commands.removeAiMark();
			if (highlightLayer.value) highlightLayer.value.innerHTML = "";
		};
		__expose({
			addAiHighlight,
			removeAiHighlight,
			updateAiHighlight
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$3, [createElementVNode("div", {
				class: "ai-highlight-layer",
				ref_key: "highlightLayer",
				ref: highlightLayer
			}, null, 512)]);
		};
	}
}, [["__scopeId", "data-v-497b8118"]]);
function useSelectedText(editorRef, options = {}) {
	const getActiveRuntime = typeof options.getActiveRuntime === "function" ? options.getActiveRuntime : null;
	return { selectedText: computed(() => {
		const editor = editorRef.value;
		const runtime = getActiveRuntime?.();
		if (runtime?.getCapabilities?.().selection?.canReadSelectedText) return runtime.getSelectedText();
		if (!editor?.state) return "";
		return editor.state.doc.textBetween(editor.state.selection.from, editor.state.selection.to, " ");
	}) };
}
function useAi({ activeEditorRef }) {
	const showAiLayer = ref(false);
	const showAiWriter = ref(false);
	const aiWriterPosition = reactive({
		top: 0,
		left: 0
	});
	const aiLayer = ref(null);
	const showAiWriterAtCursor = () => {
		const editor = activeEditorRef.value;
		if (!editor || editor.isDestroyed) {
			console.error("[useAi] Editor not available");
			return;
		}
		try {
			const { view } = editor;
			const { selection } = view.state;
			if (!selection.empty) editor.commands.insertAiMark();
			let coords;
			try {
				coords = view.coordsAtPos(selection.$head.pos);
			} catch {
				const domSelection = window.getSelection();
				if (domSelection.rangeCount > 0) {
					const rect = domSelection.getRangeAt(0).getBoundingClientRect();
					coords = {
						top: rect.top,
						left: rect.left
					};
				} else {
					const editorRect = view.dom.getBoundingClientRect();
					coords = {
						top: editorRect.top + 50,
						left: editorRect.left + 50
					};
				}
			}
			aiWriterPosition.top = coords.top + 30 + "px";
			aiWriterPosition.left = coords.left + "px";
			showAiWriter.value = true;
		} catch (error) {
			console.error("[useAi] Error displaying AIWriter:", error);
			try {
				const rect = activeEditorRef.value.view.dom.getBoundingClientRect();
				aiWriterPosition.top = rect.top + 100 + "px";
				aiWriterPosition.left = rect.left + 100 + "px";
				showAiWriter.value = true;
			} catch (e) {
				console.error("[useAi] Failed to get fallback position:", e);
			}
		}
	};
	const handleAiWriterClose = () => {
		showAiWriter.value = false;
	};
	const initAiLayer = (value = true) => {
		showAiLayer.value = value;
	};
	const handleAiToolClick = () => {
		const editor = activeEditorRef.value;
		if (!editor || editor.isDestroyed) {
			console.error("[useAi] Editor not available");
			return;
		}
		editor.commands.insertAiMark();
		showAiWriterAtCursor();
	};
	return {
		showAiLayer,
		showAiWriter,
		aiWriterPosition,
		aiLayer,
		initAiLayer,
		showAiWriterAtCursor,
		handleAiWriterClose,
		handleAiToolClick
	};
}
var isHighContrastMode = ref(false);
function useHighContrastMode() {
	const setHighContrastMode = (value) => {
		isHighContrastMode.value = value;
	};
	return {
		isHighContrastMode,
		setHighContrastMode
	};
}
const VALID_COMMENTS_DISPLAY_MODES = new Set([
	"auto",
	"sidebar",
	"inline"
]);
function normalizeCommentsUiPolicy(commentsConfig) {
	if (!commentsConfig || commentsConfig === false || typeof commentsConfig !== "object") return commentsConfig;
	const normalized = { ...commentsConfig };
	const displayMode = normalized.displayMode;
	if (!VALID_COMMENTS_DISPLAY_MODES.has(displayMode)) delete normalized.displayMode;
	const breakpoint = normalized.compactBreakpointPx;
	if (!(typeof breakpoint === "number" && Number.isFinite(breakpoint) && breakpoint >= 0)) delete normalized.compactBreakpointPx;
	const measurementSelector = normalized.compactMeasurementSelector;
	if (!(typeof measurementSelector === "string" && measurementSelector.trim().length > 0)) delete normalized.compactMeasurementSelector;
	else normalized.compactMeasurementSelector = measurementSelector.trim();
	return normalized;
}
var SUPERDOC_DOCUMENT_SELECTOR = ".superdoc__document";
var isValidCompactBreakpoint = (value) => {
	return typeof value === "number" && Number.isFinite(value) && value >= 0;
};
var getRequiredSidebarWidth = (documentWidth) => {
	return documentWidth + 320 + 24;
};
function useCommentSmallScreen({ commentsModuleConfig, superdocRoot, layers }) {
	const superdocContainerWidth = ref(0);
	const isCompactCommentsMode = ref(false);
	let commentsContainerResizeObserver = null;
	let compactMeasurementTarget = null;
	const isValidMeasurementTarget = (element) => {
		if (!(element instanceof HTMLElement)) return false;
		if ((typeof window !== "undefined" ? window.getComputedStyle(element) : null)?.display === "contents") return false;
		const clientWidth = Number(element.clientWidth ?? 0);
		const rectWidth = Number(element.getBoundingClientRect?.().width ?? 0);
		return Number.isFinite(clientWidth) && clientWidth > 0 || Number.isFinite(rectWidth) && rectWidth > 0;
	};
	const resolveCompactMeasurementTarget = () => {
		const root = superdocRoot.value;
		const selector = commentsModuleConfig.value?.compactMeasurementSelector;
		if (typeof selector === "string" && selector.trim().length > 0 && typeof document !== "undefined") {
			const selected = document.querySelector(selector.trim());
			if (isValidMeasurementTarget(selected)) return selected;
		}
		let ancestor = root?.parentElement ?? null;
		while (ancestor) {
			if (isValidMeasurementTarget(ancestor)) return ancestor;
			ancestor = ancestor.parentElement;
		}
		if (isValidMeasurementTarget(root)) return root;
		if (root instanceof HTMLElement) return root;
		return null;
	};
	const ensureCompactMeasurementObserver = () => {
		const ResizeObserverClass = typeof window !== "undefined" ? window.ResizeObserver : void 0;
		if (typeof ResizeObserverClass === "undefined") return;
		const nextTarget = resolveCompactMeasurementTarget();
		if (nextTarget === compactMeasurementTarget) return;
		if (commentsContainerResizeObserver) {
			commentsContainerResizeObserver.disconnect();
			commentsContainerResizeObserver = null;
		}
		compactMeasurementTarget = nextTarget;
		if (!compactMeasurementTarget) return;
		commentsContainerResizeObserver = new ResizeObserverClass(() => {
			recalculateCompactCommentsMode();
		});
		commentsContainerResizeObserver.observe(compactMeasurementTarget);
	};
	const getAvailableCommentsContainerWidth = () => {
		ensureCompactMeasurementObserver();
		const clientWidth = Number(compactMeasurementTarget?.clientWidth ?? 0);
		if (Number.isFinite(clientWidth) && clientWidth > 0) return clientWidth;
		const rectWidth = Number(compactMeasurementTarget?.getBoundingClientRect?.().width ?? 0);
		if (Number.isFinite(rectWidth) && rectWidth > 0) return rectWidth;
		return 0;
	};
	const getMeasuredDocumentWidth = () => {
		const documentElement = superdocRoot.value?.querySelector?.(SUPERDOC_DOCUMENT_SELECTOR);
		const layersElement = layers.value;
		const measuredFromDocument = Number(documentElement?.clientWidth ?? documentElement?.getBoundingClientRect?.().width ?? 0);
		if (Number.isFinite(measuredFromDocument) && measuredFromDocument > 0) return measuredFromDocument;
		const measuredFromLayers = Number(layersElement?.clientWidth ?? layersElement?.getBoundingClientRect?.().width ?? 0);
		if (Number.isFinite(measuredFromLayers) && measuredFromLayers > 0) return measuredFromLayers;
		return 816;
	};
	const recalculateCompactCommentsMode = () => {
		const width = getAvailableCommentsContainerWidth();
		const commentsConfig = commentsModuleConfig.value;
		const displayMode = commentsConfig?.displayMode ?? "sidebar";
		if (displayMode === "sidebar") {
			superdocContainerWidth.value = width;
			isCompactCommentsMode.value = false;
			return;
		}
		if (displayMode === "inline") {
			superdocContainerWidth.value = width;
			isCompactCommentsMode.value = true;
			return;
		}
		if (!(Number.isFinite(width) && width > 0)) return;
		superdocContainerWidth.value = width;
		const configuredBreakpoint = commentsConfig?.compactBreakpointPx;
		if (isValidCompactBreakpoint(configuredBreakpoint)) {
			isCompactCommentsMode.value = width < configuredBreakpoint;
			return;
		}
		isCompactCommentsMode.value = width < getRequiredSidebarWidth(getMeasuredDocumentWidth());
	};
	onBeforeUnmount(() => {
		if (commentsContainerResizeObserver) {
			commentsContainerResizeObserver.disconnect();
			commentsContainerResizeObserver = null;
		}
		compactMeasurementTarget = null;
	});
	return {
		superdocContainerWidth,
		isCompactCommentsMode,
		recalculateCompactCommentsMode,
		ensureCompactMeasurementObserver
	};
}
var POPOVER_WIDTH_PX = 320;
var SAFE_MARGIN_PX = 12;
var MIN_BOTTOM_SPACE_PX = 220;
var ANCHOR_TOP_OFFSET_PX = 16;
var INTERACTION_ANCHOR_TTL_MS = 500;
var COMMENT_HIGHLIGHT_SELECTOR = ".superdoc-comment-highlight[data-comment-ids]";
var COMMENT_HIGHLIGHT_DATA_ATTR = "data-comment-ids";
var PDF_COMMENT_ANCHOR_SELECTOR = ".sd-comment-anchor";
var clamp = (value, min$1, max) => Math.min(Math.max(value, min$1), max);
var toNumber = (value) => Number(value);
var isFiniteNumber = (value) => Number.isFinite(value);
var getCommentAnchorId = (comment) => comment?.commentId ?? comment?.importedId ?? null;
var parseCommentIds = (value) => String(value || "").split(",").map((s) => s.trim()).filter(Boolean);
var resolveInteractionAnchor = (lastClickAnchor) => {
	const anchor = lastClickAnchor?.value;
	if (!anchor) return null;
	const ts = toNumber(anchor.ts);
	if (!isFiniteNumber(ts) || Date.now() - ts > INTERACTION_ANCHOR_TTL_MS) return null;
	const x = toNumber(anchor.x);
	const rectBottom = toNumber(anchor.anchorRect?.bottom);
	const y = isFiniteNumber(rectBottom) ? rectBottom : toNumber(anchor.y);
	if (!isFiniteNumber(x) || !isFiniteNumber(y)) return null;
	return {
		x,
		y
	};
};
var resolveInlineHighlightAnchorRect = ({ rootEl, comment, pendingComment }) => {
	if (Boolean(pendingComment?.value && comment?.commentId === pendingComment.value?.commentId)) {
		const nodes = rootEl.querySelectorAll(COMMENT_HIGHLIGHT_SELECTOR);
		for (const node of nodes) {
			if (!parseCommentIds(node.getAttribute(COMMENT_HIGHLIGHT_DATA_ATTR)).includes("pending")) continue;
			if (typeof node.getBoundingClientRect !== "function") continue;
			return node.getBoundingClientRect();
		}
	}
	const anchorId = getCommentAnchorId(comment);
	if (!anchorId) return null;
	const safeId = String(anchorId);
	const highlightNodes = rootEl.querySelectorAll(COMMENT_HIGHLIGHT_SELECTOR);
	for (const node of highlightNodes) {
		if (!parseCommentIds(node.getAttribute(COMMENT_HIGHLIGHT_DATA_ATTR)).includes(safeId)) continue;
		if (typeof node.getBoundingClientRect !== "function") continue;
		return node.getBoundingClientRect();
	}
	const tcNode = rootEl.querySelector(`[data-track-change-id="${safeId}"]`);
	if (tcNode && typeof tcNode.getBoundingClientRect === "function") return tcNode.getBoundingClientRect();
	return null;
};
var resolveEntryAnchorBottom = (resolveCommentPositionEntry, comment) => {
	const { entry } = resolveCommentPositionEntry(getCommentAnchorId(comment));
	const boundsBottom = toNumber(entry?.bounds?.bottom);
	if (isFiniteNumber(boundsBottom)) return boundsBottom;
	return toNumber(entry?.bounds?.top);
};
var isPdfContextForAnchorLookup = ({ selectionPosition, comment, pendingComment }) => selectionPosition.value?.source === "pdf" || comment?.selection?.source === "pdf" || pendingComment.value?.selection?.source === "pdf";
var resolvePdfDomAnchorBottom = ({ rootEl, layersRect, comment }) => {
	const anchorId = getCommentAnchorId(comment);
	if (anchorId == null) return NaN;
	const anchorElement = rootEl.querySelector(`${PDF_COMMENT_ANCHOR_SELECTOR}[data-id="${String(anchorId)}"]`);
	if (!anchorElement || typeof anchorElement.getBoundingClientRect !== "function") return NaN;
	return toNumber(anchorElement.getBoundingClientRect().bottom) - toNumber(layersRect.top);
};
var resolvePendingSelectionAnchorBottom = ({ comment, pendingComment, selectionPosition, activeZoom }) => {
	if (!pendingComment.value || comment?.commentId !== pendingComment.value?.commentId) return NaN;
	const selectedBottom = toNumber(selectionPosition.value?.bottom);
	if (isFiniteNumber(selectedBottom)) return selectedBottom * (selectionPosition.value?.source === "pdf" ? (activeZoom.value ?? 100) / 100 : 1);
	const selectedTop = toNumber(selectionPosition.value?.top);
	if (!isFiniteNumber(selectedTop)) return NaN;
	return selectedTop * (selectionPosition.value?.source === "pdf" ? (activeZoom.value ?? 100) / 100 : 1);
};
var toPopoverStyle = ({ top, left }) => ({
	top: `${Math.round(top)}px`,
	left: `${Math.round(left)}px`,
	right: "auto"
});
var resolvePopoverPosition = ({ rootRect, layersRect, anchorBottom, anchorClientX = NaN }) => {
	const top = clamp(layersRect.top - rootRect.top + anchorBottom + ANCHOR_TOP_OFFSET_PX, SAFE_MARGIN_PX, Math.max(SAFE_MARGIN_PX, rootRect.height - MIN_BOTTOM_SPACE_PX));
	const maxLeft = Math.max(SAFE_MARGIN_PX, rootRect.width - POPOVER_WIDTH_PX - SAFE_MARGIN_PX);
	let left;
	if (isFiniteNumber(anchorClientX)) left = clamp(anchorClientX - rootRect.left + SAFE_MARGIN_PX, SAFE_MARGIN_PX, maxLeft);
	else {
		const rightCandidate = rootRect.width - (layersRect.left - rootRect.left + layersRect.width) + SAFE_MARGIN_PX;
		left = clamp(rootRect.width - rightCandidate - POPOVER_WIDTH_PX, SAFE_MARGIN_PX, maxLeft);
	}
	return {
		top,
		left
	};
};
function useCompactCommentPopover({ activeComment, pendingComment, activeCompactComment, showCommentsSidebar, selectionPosition, activeZoom, superdocRoot, layers, documents, resolveCommentPositionEntry, clearActiveComment, clearPendingComment }) {
	const fallback = {
		top: "12px",
		right: "12px"
	};
	const compactPopoverLayoutTick = ref(0);
	const lastClickAnchor = ref({
		x: null,
		y: null,
		ts: 0,
		anchorRect: null
	});
	let compactPopoverRafId = null;
	let compactPopoverReturnFocusEl = null;
	const resetClickAnchor = () => {
		lastClickAnchor.value = {
			x: null,
			y: null,
			ts: 0,
			anchorRect: null
		};
	};
	const clearCompactPopoverIfPdfClickedOutside = (root, target, anchorElement) => {
		if (!documents.value?.some((doc) => doc.type === "application/pdf")) return false;
		const compactPopoverEl = root.querySelector(".superdoc__compact-comment-popover");
		if (!activeCompactComment.value || !compactPopoverEl || compactPopoverEl.contains(target) || anchorElement) return false;
		if (pendingComment.value) {
			clearPendingComment();
			clearActiveComment();
		} else clearActiveComment();
		resetClickAnchor();
		return true;
	};
	const trackCompactPopoverClickAnchor = (e) => {
		const root = superdocRoot.value;
		if (!root || !layers.value?.contains(e.target)) return;
		const anchorElement = (typeof document.elementsFromPoint === "function" ? document.elementsFromPoint(e.clientX, e.clientY) : []).find((node) => node?.nodeType === 1 && root.contains(node) && node.closest("[data-track-change-id], .superdoc-comment-highlight, .sd-comment-anchor"))?.closest("[data-track-change-id], .superdoc-comment-highlight, .sd-comment-anchor") ?? (e.target?.nodeType === 1 ? e.target.closest("[data-track-change-id], .superdoc-comment-highlight, .sd-comment-anchor") : null);
		if (clearCompactPopoverIfPdfClickedOutside(root, e.target, anchorElement)) return;
		if (e.button !== 0 || e.pointerType !== "mouse") return;
		const anchorRect = anchorElement && typeof anchorElement.getBoundingClientRect === "function" ? anchorElement.getBoundingClientRect() : null;
		if (!anchorRect) return;
		lastClickAnchor.value = {
			x: e.clientX,
			y: anchorRect.bottom,
			ts: Date.now(),
			anchorRect: {
				left: anchorRect.left,
				right: anchorRect.right,
				top: anchorRect.top,
				bottom: anchorRect.bottom
			}
		};
	};
	const compactCommentPopoverStyle = computed(() => {
		compactPopoverLayoutTick.value;
		const comment = activeCompactComment.value;
		if (!comment) return fallback;
		const rootEl = superdocRoot.value;
		const layersEl = layers.value;
		if (!rootEl || !layersEl) return fallback;
		const rootRect = rootEl.getBoundingClientRect();
		const layersRect = layersEl.getBoundingClientRect();
		const interactionAnchor = resolveInteractionAnchor(lastClickAnchor);
		const inlineRect = !interactionAnchor ? resolveInlineHighlightAnchorRect({
			rootEl,
			comment,
			pendingComment
		}) : null;
		let anchorBottom = NaN;
		let anchorClientX = NaN;
		if (interactionAnchor) {
			anchorBottom = interactionAnchor.y - layersRect.top;
			anchorClientX = interactionAnchor.x;
		} else if (inlineRect) {
			anchorBottom = inlineRect.bottom - layersRect.top;
			anchorClientX = inlineRect.left;
		} else anchorBottom = resolveEntryAnchorBottom(resolveCommentPositionEntry, comment);
		if (!isFiniteNumber(anchorBottom) && isPdfContextForAnchorLookup({
			selectionPosition,
			comment,
			pendingComment
		})) anchorBottom = resolvePdfDomAnchorBottom({
			rootEl,
			layersRect,
			comment
		});
		if (!isFiniteNumber(anchorBottom)) anchorBottom = resolvePendingSelectionAnchorBottom({
			comment,
			pendingComment,
			selectionPosition,
			activeZoom
		});
		if (!isFiniteNumber(anchorBottom)) return fallback;
		return toPopoverStyle(resolvePopoverPosition({
			rootRect,
			layersRect,
			anchorBottom,
			anchorClientX
		}));
	});
	watch([
		activeComment,
		pendingComment,
		selectionPosition,
		activeZoom,
		showCommentsSidebar,
		lastClickAnchor
	], () => {
		const requestAnimationFrameFn = typeof window !== "undefined" ? window.requestAnimationFrame : null;
		const cancelAnimationFrameFn = typeof window !== "undefined" ? window.cancelAnimationFrame : null;
		if (compactPopoverRafId != null) cancelAnimationFrameFn?.(compactPopoverRafId);
		if (!requestAnimationFrameFn) return;
		compactPopoverRafId = requestAnimationFrameFn(() => {
			compactPopoverLayoutTick.value += 1;
			compactPopoverRafId = null;
		});
	}, { deep: false });
	watch(activeCompactComment, (current, previous) => {
		if (!previous && current) {
			const activeEl = document.activeElement;
			if (activeEl instanceof HTMLElement) compactPopoverReturnFocusEl = activeEl;
		}
	}, { deep: false });
	watch(pendingComment, (current, previous) => {
		if (!previous && current) resetClickAnchor();
	});
	onMounted(() => {
		document.addEventListener("pointerdown", trackCompactPopoverClickAnchor, true);
	});
	onBeforeUnmount(() => {
		document.removeEventListener("pointerdown", trackCompactPopoverClickAnchor, true);
		const cancelAnimationFrameFn = typeof window !== "undefined" ? window.cancelAnimationFrame : null;
		if (compactPopoverRafId != null) {
			cancelAnimationFrameFn?.(compactPopoverRafId);
			compactPopoverRafId = null;
		}
		compactPopoverReturnFocusEl = null;
	});
	const closeCompactCommentPopover = () => {
		if (!activeCompactComment.value) return;
		if (pendingComment.value) {
			clearPendingComment();
			clearActiveComment();
		} else clearActiveComment();
		if (compactPopoverReturnFocusEl && typeof compactPopoverReturnFocusEl.focus === "function") compactPopoverReturnFocusEl.focus();
		compactPopoverReturnFocusEl = null;
	};
	return {
		compactCommentPopoverStyle,
		closeCompactCommentPopover,
		resetClickAnchor
	};
}
var RECOVERABLE_CODES = ["DOCX_PASSWORD_REQUIRED", "DOCX_PASSWORD_INVALID"];
var SIGNAL_TIMEOUT_MS = 3e4;
var DEFAULT_TEXTS$1 = {
	title: "Password Required",
	invalidTitle: "Incorrect Password",
	description: "This document is password protected. Enter the password to open it.",
	placeholder: "Enter password",
	inputAriaLabel: "Document password",
	submitLabel: "Open",
	cancelLabel: "Cancel",
	busyLabel: "Decrypting…",
	invalidMessage: "Incorrect password. Please try again.",
	timeoutMessage: "Timed out while decrypting. Please try again.",
	genericErrorMessage: "Unable to decrypt this document."
};
function usePasswordPrompt({ getSurfaceManager, getPasswordPromptConfig, onUnhandled }) {
	const queue = [];
	const activePrompt = shallowRef(null);
	const pendingSignals = /* @__PURE__ */ new Map();
	let destroyed = false;
	function handleEncryptionError(doc, errorCode, originalException) {
		if (!doc || !RECOVERABLE_CODES.includes(errorCode)) return false;
		if (getPasswordPromptConfig() === false) return false;
		if (!getSurfaceManager()) return false;
		const pending = pendingSignals.get(doc.id);
		if (pending) {
			clearTimeout(pending.timer);
			pending.resolve({
				success: false,
				errorCode
			});
			pendingSignals.delete(doc.id);
			return true;
		}
		const existing = queue.find((e) => e.doc.id === doc.id);
		if (existing) {
			existing.errorCode = errorCode;
			existing.originalException = originalException;
			return true;
		}
		if (activePrompt.value?.doc.id === doc.id) return true;
		queue.push({
			doc,
			errorCode,
			originalException
		});
		drainQueue();
		return true;
	}
	function handleEditorReady(doc) {
		if (!doc) return;
		const pending = pendingSignals.get(doc.id);
		if (pending) {
			clearTimeout(pending.timer);
			pending.resolve({ success: true });
			pendingSignals.delete(doc.id);
		}
	}
	function destroy() {
		destroyed = true;
		for (const [, signal] of pendingSignals) {
			clearTimeout(signal.timer);
			signal.resolve({
				success: false,
				errorCode: "destroyed"
			});
		}
		pendingSignals.clear();
		queue.length = 0;
		activePrompt.value = null;
	}
	function drainQueue() {
		if (destroyed) return;
		if (activePrompt.value) return;
		if (queue.length === 0) return;
		const entry = queue.shift();
		if (!entry) return;
		showPrompt(entry).catch((err) => {
			activePrompt.value = null;
			console.error("[SuperDoc] Password prompt error:", err);
			onUnhandled?.(entry.doc, entry.errorCode, entry.originalException);
			drainQueue();
		});
	}
	async function showPrompt({ doc, errorCode, originalException }) {
		const manager = getSurfaceManager();
		if (!manager || destroyed) return;
		const config = resolveConfig();
		const attemptPassword = (password) => {
			doc.password = password;
			doc.editorMountNonce++;
			return new Promise((resolve) => {
				const timer = setTimeout(() => {
					pendingSignals.delete(doc.id);
					resolve({
						success: false,
						errorCode: "timeout"
					});
				}, SIGNAL_TIMEOUT_MS);
				pendingSignals.set(doc.id, {
					resolve,
					timer
				});
			});
		};
		const passwordPrompt = {
			documentId: doc.id,
			errorCode,
			texts: config.texts,
			attemptPassword
		};
		const resolution = resolveRendering(config, {
			documentId: doc.id,
			errorCode,
			texts: config.texts
		});
		if (resolution.suppressed) {
			onUnhandled?.(doc, errorCode, originalException);
			drainQueue();
			return;
		}
		activePrompt.value = {
			doc,
			surfaceHandle: null
		};
		let handle;
		if (resolution.component) handle = manager.open({
			mode: "dialog",
			closeOnBackdrop: false,
			ariaLabel: config.texts.title,
			component: markRaw(resolution.component),
			props: {
				...resolution.props,
				passwordPrompt
			}
		});
		else if (resolution.render) {
			const userRender = resolution.render;
			handle = manager.open({
				mode: "dialog",
				closeOnBackdrop: false,
				ariaLabel: config.texts.title,
				render: (ctx) => userRender({
					container: ctx.container,
					passwordPrompt,
					resolve: ctx.resolve,
					close: ctx.close,
					surfaceId: ctx.surfaceId,
					mode: ctx.mode
				})
			});
		} else {
			const PasswordPromptSurface = (await import("./PasswordPromptSurface-DfoFTBdi.es.js")).default;
			const surfaceId = `password-prompt-${doc.id}`;
			handle = manager.open({
				id: surfaceId,
				mode: "dialog",
				closeOnBackdrop: false,
				ariaLabelledBy: `sd-password-prompt-heading-${surfaceId}`,
				component: markRaw(PasswordPromptSurface),
				props: { passwordPrompt }
			});
		}
		activePrompt.value = {
			doc,
			surfaceHandle: handle
		};
		await handle.result;
		activePrompt.value = null;
		drainQueue();
	}
	function resolveConfig() {
		const raw = getPasswordPromptConfig();
		if (raw === false) return {
			enabled: false,
			texts: DEFAULT_TEXTS$1
		};
		const cfg = typeof raw === "object" && raw !== null ? raw : {};
		if (cfg.component != null && typeof cfg.render === "function") throw new Error("modules.surfaces.passwordPrompt cannot provide both \"component\" and \"render\". Use one or the other.");
		return {
			enabled: true,
			texts: {
				title: cfg.title ?? DEFAULT_TEXTS$1.title,
				invalidTitle: cfg.invalidTitle ?? DEFAULT_TEXTS$1.invalidTitle,
				description: cfg.description ?? DEFAULT_TEXTS$1.description,
				placeholder: cfg.placeholder ?? DEFAULT_TEXTS$1.placeholder,
				inputAriaLabel: cfg.inputAriaLabel ?? DEFAULT_TEXTS$1.inputAriaLabel,
				submitLabel: cfg.submitLabel ?? DEFAULT_TEXTS$1.submitLabel,
				cancelLabel: cfg.cancelLabel ?? DEFAULT_TEXTS$1.cancelLabel,
				busyLabel: cfg.busyLabel ?? DEFAULT_TEXTS$1.busyLabel,
				invalidMessage: cfg.invalidMessage ?? DEFAULT_TEXTS$1.invalidMessage,
				timeoutMessage: cfg.timeoutMessage ?? DEFAULT_TEXTS$1.timeoutMessage,
				genericErrorMessage: cfg.genericErrorMessage ?? DEFAULT_TEXTS$1.genericErrorMessage
			},
			component: cfg.component,
			props: cfg.props,
			render: cfg.render,
			resolver: cfg.resolver
		};
	}
	function resolveRendering(config, resolverCtx) {
		if (typeof config.resolver === "function") {
			const resolution = config.resolver(resolverCtx);
			if (resolution != null && resolution.type !== "default") {
				if (resolution.type === "none") return { suppressed: true };
				if (resolution.type === "custom") return {
					component: resolution.component,
					props: resolution.props
				};
				if (resolution.type === "external") return { render: resolution.render };
			}
		}
		if (config.component != null) return {
			component: config.component,
			props: config.props
		};
		if (typeof config.render === "function") return { render: config.render };
		return { builtin: true };
	}
	return {
		handleEncryptionError,
		handleEditorReady,
		destroy
	};
}
var DEFAULT_TEXTS = {
	findPlaceholder: "Find",
	findAriaLabel: "Find text",
	replacePlaceholder: "Replace",
	replaceAriaLabel: "Replace text",
	noResultsLabel: "No results",
	previousMatchLabel: "Previous match (Shift+Enter)",
	previousMatchAriaLabel: "Previous match",
	nextMatchLabel: "Next match (Enter)",
	nextMatchAriaLabel: "Next match",
	closeLabel: "Close (Escape)",
	closeAriaLabel: "Close find and replace",
	replaceLabel: "Replace",
	replaceAllLabel: "All",
	toggleReplaceLabel: "Toggle replace",
	toggleReplaceAriaLabel: "Toggle replace",
	matchCaseLabel: "Aa",
	matchCaseAriaLabel: "Match case",
	ignoreDiacriticsLabel: "ä≡a",
	ignoreDiacriticsAriaLabel: "Ignore diacritics"
};
function getSearchStorage(editor) {
	if (!editor) return null;
	const byName = editor.extensionStorage?.Search ?? editor.storage?.Search;
	if (byName?.searchIndex || byName?.searchResults) return byName;
	const store = editor.extensionStorage ?? editor.storage;
	if (store) for (const key of Object.keys(store)) {
		const val = store[key];
		if (val && typeof val === "object" && "searchIndex" in val && "searchResults" in val) return val;
	}
	return null;
}
function useFindReplace({ getSurfaceManager, getActiveEditor, activeEditorRef, getFindReplaceConfig }) {
	let currentSurfaceHandle = null;
	let currentEditor = null;
	let destroyed = false;
	let opening = false;
	const isOpen = ref(false);
	let focusFindInputFn = null;
	const findQuery = ref("");
	const replaceText = ref("");
	const caseSensitive = ref(false);
	const ignoreDiacritics = ref(false);
	const showReplace = ref(false);
	const matchCount = ref(0);
	const activeMatchIndex = ref(-1);
	let currentTexts = DEFAULT_TEXTS;
	const matchLabel = computed(() => {
		if (!findQuery.value) return "";
		if (matchCount.value === 0) return currentTexts.noResultsLabel;
		return `${activeMatchIndex.value + 1} of ${matchCount.value}`;
	});
	const hasMatches = computed(() => matchCount.value > 0);
	let debounceTimer = null;
	let syncInterval = null;
	function runSearch() {
		if (!currentEditor) return;
		if (!findQuery.value) {
			try {
				currentEditor.commands.clearSearchSession();
			} catch {}
			matchCount.value = 0;
			activeMatchIndex.value = -1;
			return;
		}
		try {
			const result = currentEditor.commands.setSearchSession(findQuery.value, {
				caseSensitive: caseSensitive.value,
				ignoreDiacritics: ignoreDiacritics.value,
				highlight: true,
				searchModel: "visible"
			});
			matchCount.value = result.matches.length;
			activeMatchIndex.value = result.activeMatchIndex;
		} catch {}
	}
	function debouncedSearch() {
		if (debounceTimer) clearTimeout(debounceTimer);
		debounceTimer = setTimeout(runSearch, 150);
	}
	watch(findQuery, () => {
		if (isOpen.value) debouncedSearch();
	});
	watch(caseSensitive, () => {
		if (isOpen.value) runSearch();
	});
	watch(ignoreDiacritics, () => {
		if (isOpen.value) runSearch();
	});
	let currentReplaceEnabled = true;
	function goNext() {
		if (!hasMatches.value || !currentEditor) return;
		try {
			activeMatchIndex.value = currentEditor.commands.nextSearchMatch().activeMatchIndex;
		} catch {}
	}
	function goPrev() {
		if (!hasMatches.value || !currentEditor) return;
		try {
			activeMatchIndex.value = currentEditor.commands.previousSearchMatch().activeMatchIndex;
		} catch {}
	}
	function replaceCurrent() {
		if (!currentReplaceEnabled) return;
		if (!hasMatches.value || !currentEditor) return;
		try {
			const result = currentEditor.commands.replaceSearchMatch(replaceText.value);
			matchCount.value = result.matches.length;
			activeMatchIndex.value = result.activeMatchIndex;
		} catch {}
	}
	function replaceAll() {
		if (!currentReplaceEnabled) return;
		if (!hasMatches.value || !currentEditor) return;
		try {
			currentEditor.commands.replaceAllSearchMatches(replaceText.value);
			matchCount.value = 0;
			activeMatchIndex.value = -1;
		} catch {}
	}
	function syncFromEditorStorage() {
		const storage = getSearchStorage(currentEditor);
		if (!storage) return;
		const results = storage.searchResults;
		const count = Array.isArray(results) ? results.length : 0;
		const idx = storage.activeMatchIndex ?? -1;
		if (count !== matchCount.value) matchCount.value = count;
		if (idx !== activeMatchIndex.value) activeMatchIndex.value = idx;
	}
	function startPolling() {
		stopPolling();
		syncInterval = setInterval(syncFromEditorStorage, 200);
	}
	function stopPolling() {
		if (debounceTimer) clearTimeout(debounceTimer);
		debounceTimer = null;
		if (syncInterval) clearInterval(syncInterval);
		syncInterval = null;
	}
	function resetState() {
		findQuery.value = "";
		replaceText.value = "";
		caseSensitive.value = false;
		ignoreDiacritics.value = false;
		showReplace.value = false;
		matchCount.value = 0;
		activeMatchIndex.value = -1;
	}
	function resolveConfig() {
		const raw = typeof getFindReplaceConfig === "function" ? getFindReplaceConfig() : void 0;
		if (raw === false || raw == null) return {
			enabled: false,
			texts: DEFAULT_TEXTS,
			replaceEnabled: true
		};
		if (raw === true) return {
			enabled: true,
			texts: DEFAULT_TEXTS,
			replaceEnabled: true
		};
		const cfg = typeof raw === "object" ? raw : {};
		if (cfg.component != null && typeof cfg.render === "function") throw new Error("modules.surfaces.findReplace cannot provide both \"component\" and \"render\". Use one or the other.");
		return {
			enabled: true,
			texts: {
				findPlaceholder: cfg.findPlaceholder ?? DEFAULT_TEXTS.findPlaceholder,
				findAriaLabel: cfg.findAriaLabel ?? DEFAULT_TEXTS.findAriaLabel,
				replacePlaceholder: cfg.replacePlaceholder ?? DEFAULT_TEXTS.replacePlaceholder,
				replaceAriaLabel: cfg.replaceAriaLabel ?? DEFAULT_TEXTS.replaceAriaLabel,
				noResultsLabel: cfg.noResultsLabel ?? DEFAULT_TEXTS.noResultsLabel,
				previousMatchLabel: cfg.previousMatchLabel ?? DEFAULT_TEXTS.previousMatchLabel,
				previousMatchAriaLabel: cfg.previousMatchAriaLabel ?? DEFAULT_TEXTS.previousMatchAriaLabel,
				nextMatchLabel: cfg.nextMatchLabel ?? DEFAULT_TEXTS.nextMatchLabel,
				nextMatchAriaLabel: cfg.nextMatchAriaLabel ?? DEFAULT_TEXTS.nextMatchAriaLabel,
				closeLabel: cfg.closeLabel ?? DEFAULT_TEXTS.closeLabel,
				closeAriaLabel: cfg.closeAriaLabel ?? DEFAULT_TEXTS.closeAriaLabel,
				replaceLabel: cfg.replaceLabel ?? DEFAULT_TEXTS.replaceLabel,
				replaceAllLabel: cfg.replaceAllLabel ?? DEFAULT_TEXTS.replaceAllLabel,
				toggleReplaceLabel: cfg.toggleReplaceLabel ?? DEFAULT_TEXTS.toggleReplaceLabel,
				toggleReplaceAriaLabel: cfg.toggleReplaceAriaLabel ?? DEFAULT_TEXTS.toggleReplaceAriaLabel,
				matchCaseLabel: cfg.matchCaseLabel ?? DEFAULT_TEXTS.matchCaseLabel,
				matchCaseAriaLabel: cfg.matchCaseAriaLabel ?? DEFAULT_TEXTS.matchCaseAriaLabel,
				ignoreDiacriticsLabel: cfg.ignoreDiacriticsLabel ?? DEFAULT_TEXTS.ignoreDiacriticsLabel,
				ignoreDiacriticsAriaLabel: cfg.ignoreDiacriticsAriaLabel ?? DEFAULT_TEXTS.ignoreDiacriticsAriaLabel
			},
			replaceEnabled: cfg.replaceEnabled ?? true,
			component: cfg.component,
			props: cfg.props,
			render: cfg.render,
			resolver: cfg.resolver
		};
	}
	function resolveRendering(config, resolverCtx) {
		if (typeof config.resolver === "function") {
			const resolution = config.resolver(resolverCtx);
			if (resolution != null && resolution.type !== "default") {
				if (resolution.type === "none") return { suppressed: true };
				if (resolution.type === "custom") return {
					component: resolution.component,
					props: resolution.props
				};
				if (resolution.type === "external") return { render: resolution.render };
			}
		}
		if (config.component != null) return {
			component: config.component,
			props: config.props
		};
		if (typeof config.render === "function") return { render: config.render };
		return { builtin: true };
	}
	function createHandle(config, closeFn) {
		return {
			findQuery,
			replaceText,
			caseSensitive,
			ignoreDiacritics,
			showReplace,
			matchCount,
			activeMatchIndex,
			matchLabel,
			hasMatches,
			replaceEnabled: config.replaceEnabled ?? true,
			texts: config.texts,
			goNext,
			goPrev,
			replaceCurrent,
			replaceAll,
			registerFocusFn: (fn) => {
				focusFindInputFn = fn;
			},
			close: (reason) => closeFn(reason)
		};
	}
	function wrapHandleForExternal(handle) {
		return {
			get findQuery() {
				return handle.findQuery.value;
			},
			set findQuery(v) {
				handle.findQuery.value = v;
			},
			get replaceText() {
				return handle.replaceText.value;
			},
			set replaceText(v) {
				handle.replaceText.value = v;
			},
			get caseSensitive() {
				return handle.caseSensitive.value;
			},
			set caseSensitive(v) {
				handle.caseSensitive.value = v;
			},
			get ignoreDiacritics() {
				return handle.ignoreDiacritics.value;
			},
			set ignoreDiacritics(v) {
				handle.ignoreDiacritics.value = v;
			},
			get showReplace() {
				return handle.showReplace.value;
			},
			set showReplace(v) {
				handle.showReplace.value = v;
			},
			get matchCount() {
				return handle.matchCount.value;
			},
			get activeMatchIndex() {
				return handle.activeMatchIndex.value;
			},
			get matchLabel() {
				return handle.matchLabel.value;
			},
			get hasMatches() {
				return handle.hasMatches.value;
			},
			replaceEnabled: handle.replaceEnabled,
			texts: handle.texts,
			goNext: handle.goNext,
			goPrev: handle.goPrev,
			replaceCurrent: handle.replaceCurrent,
			replaceAll: handle.replaceAll,
			registerFocusFn: handle.registerFocusFn,
			close: handle.close
		};
	}
	function clearEditorSession(editor) {
		if (!editor) return;
		try {
			editor.commands.clearSearchSession();
		} catch {}
	}
	function wouldOpen() {
		try {
			if (destroyed) return false;
			if (!getSurfaceManager()) return false;
			if (!getActiveEditor()) return false;
			if (currentSurfaceHandle && isOpen.value) return true;
			const config = resolveConfig();
			if (!config.enabled) return false;
			return !resolveRendering(config, {
				texts: config.texts,
				replaceEnabled: config.replaceEnabled ?? true
			}).suppressed;
		} catch {
			return false;
		}
	}
	async function open$1() {
		if (destroyed) return;
		const manager = getSurfaceManager();
		if (!manager) return;
		if (currentSurfaceHandle && isOpen.value) {
			focusFindInputFn?.();
			return;
		}
		if (opening) return;
		opening = true;
		try {
			const editor = getActiveEditor();
			if (!editor) {
				opening = false;
				return;
			}
			const config = resolveConfig();
			if (!config.enabled) {
				opening = false;
				return;
			}
			const resolution = resolveRendering(config, {
				texts: config.texts,
				replaceEnabled: config.replaceEnabled ?? true
			});
			if (resolution.suppressed) {
				opening = false;
				return;
			}
			resetState();
			currentTexts = config.texts;
			currentReplaceEnabled = config.replaceEnabled ?? true;
			if (currentEditor && currentEditor !== editor) clearEditorSession(currentEditor);
			currentEditor = editor;
			focusFindInputFn = null;
			let lateCloseFn = () => {};
			const handle = createHandle(config, (reason) => lateCloseFn(reason));
			let surfaceHandle;
			if (resolution.component) surfaceHandle = manager.open({
				mode: "floating",
				ariaLabel: config.texts.findAriaLabel,
				closeOnEscape: true,
				floating: {
					placement: "top-right",
					autoFocus: true
				},
				component: markRaw(resolution.component),
				props: {
					...resolution.props,
					findReplace: handle
				}
			});
			else if (resolution.render) {
				const userRender = resolution.render;
				surfaceHandle = manager.open({
					mode: "floating",
					ariaLabel: config.texts.findAriaLabel,
					closeOnEscape: true,
					floating: {
						placement: "top-right",
						autoFocus: true
					},
					render: (ctx) => userRender({
						container: ctx.container,
						findReplace: wrapHandleForExternal(handle),
						resolve: ctx.resolve,
						close: ctx.close,
						surfaceId: ctx.surfaceId,
						mode: ctx.mode
					})
				});
			} else {
				let FindReplaceSurface;
				try {
					FindReplaceSurface = (await import("./FindReplaceSurface-KxF3Q8yW.es.js")).default;
				} catch {
					opening = false;
					return;
				}
				if (destroyed || currentSurfaceHandle && isOpen.value) {
					opening = false;
					return;
				}
				const freshEditor = getActiveEditor() || editor;
				if (currentEditor !== freshEditor) {
					clearEditorSession(currentEditor);
					currentEditor = freshEditor;
				}
				surfaceHandle = manager.open({
					mode: "floating",
					ariaLabel: config.texts.findAriaLabel,
					component: markRaw(FindReplaceSurface),
					closeOnEscape: true,
					floating: {
						placement: "top-right",
						autoFocus: true
					},
					props: { findReplace: handle }
				});
			}
			lateCloseFn = (reason) => surfaceHandle.close(reason ?? "programmatic");
			currentSurfaceHandle = surfaceHandle;
			isOpen.value = true;
			opening = false;
			startPolling();
			const handleId = surfaceHandle.id;
			surfaceHandle.result.then(() => {
				if (currentSurfaceHandle?.id === handleId) {
					stopPolling();
					clearEditorSession(currentEditor);
					currentSurfaceHandle = null;
					isOpen.value = false;
					focusFindInputFn = null;
				} else clearEditorSession(editor !== currentEditor ? editor : null);
			});
		} catch (err) {
			opening = false;
			throw err;
		}
	}
	function close() {
		if (currentSurfaceHandle) currentSurfaceHandle.close("programmatic");
	}
	if (activeEditorRef) watch(activeEditorRef, (newEditor, oldEditor) => {
		if (!isOpen.value || !currentSurfaceHandle) return;
		if (newEditor === oldEditor) return;
		clearEditorSession(oldEditor);
		close();
	});
	function destroy() {
		destroyed = true;
		stopPolling();
		close();
		currentEditor = null;
		focusFindInputFn = null;
	}
	return {
		open: open$1,
		close,
		isOpen,
		wouldOpen,
		destroy
	};
}
var COMMAND_NAME_BY_KIND = {
	"text.insert": "insertContent",
	"text.replace": "insertContent",
	"text.paste": "insertContent",
	"history.undo": "undo",
	"history.redo": "redo",
	"structural.splitBlock": "splitBlock",
	"formatting.applyMark": "toggleMark"
};
var SUPPORTED_COMMAND_KINDS = Object.keys(COMMAND_NAME_BY_KIND);
var ZOOM_MIN = 25;
var ZOOM_MAX = 400;
function isHistoryKind(kind) {
	return kind === "history.undo" || kind === "history.redo";
}
function errorMessage(err) {
	if (err instanceof Error) return err.message;
	return String(err);
}
function createV1EditorRuntimeAdapter(options) {
	const { id, documentId, root, editor, onUnregister, setGlobalZoom } = options;
	let presentationEditor = null;
	let state = "opening";
	let disposed = false;
	let unregistered = false;
	const positions = /* @__PURE__ */ new Map();
	let tokenSeq = 0;
	let revision = 0;
	const currentRevisionTokenCache = /* @__PURE__ */ new Map();
	const listeners = /* @__PURE__ */ new Set();
	let paginationHandler = null;
	let zoomHandler = null;
	let pageCount = 0;
	let zoomPercent = 100;
	function emit(event) {
		for (const listener of Array.from(listeners)) try {
			listener(event);
		} catch {}
	}
	function mintToken(pmPos) {
		const cached = currentRevisionTokenCache.get(pmPos);
		if (cached) return cached;
		const tokenId = `v1-pos-${tokenSeq++}`;
		positions.set(tokenId, pmPos);
		const token = {
			runtimeId: id,
			tokenId,
			revision
		};
		currentRevisionTokenCache.set(pmPos, token);
		return token;
	}
	function invalidatePositionTokens() {
		revision += 1;
		positions.clear();
		currentRevisionTokenCache.clear();
	}
	function resolveToken(token) {
		if (token.runtimeId !== id) return {
			ok: false,
			reason: "wrong-runtime-token"
		};
		if (token.revision !== revision || !positions.has(token.tokenId)) return {
			ok: false,
			reason: "stale-position-token"
		};
		return {
			ok: true,
			pos: positions.get(token.tokenId)
		};
	}
	function capabilities() {
		const hasPresentation = presentationEditor !== null;
		return {
			lifecycle: {
				canFocus: true,
				canDispose: true
			},
			selection: {
				canReadSelectedText: true,
				canReadSelectionSnapshot: true,
				canMintPositionTokens: true
			},
			commands: {
				canDispatch: state === "editing-ready",
				supportedCommands: SUPPORTED_COMMAND_KINDS
			},
			layout: {
				supported: hasPresentation,
				hasSyncSnapshot: hasPresentation
			},
			zoom: {
				supported: true,
				min: ZOOM_MIN,
				max: ZOOM_MAX
			},
			navigation: {
				supported: hasPresentation && typeof presentationEditor?.scrollToPosition === "function",
				targets: ["position"]
			},
			persistence: {
				canSave: false,
				canExportDocx: true
			}
		};
	}
	function snapshot() {
		return {
			id,
			kind: "v1",
			documentId,
			state,
			capabilities: capabilities()
		};
	}
	function invokeCommand(command, commandFn) {
		switch (command.kind) {
			case "text.insert":
			case "text.replace":
			case "text.paste": return commandFn(command.text);
			case "formatting.applyMark": return commandFn(command.mark, command.value);
			default: return commandFn();
		}
	}
	async function dispatch(command) {
		if (disposed || state === "disposed") return {
			status: "rejected",
			reason: "runtime-not-ready"
		};
		if (state === "saving") return {
			status: "rejected",
			reason: "host-saving"
		};
		if (state !== "editing-ready") return {
			status: "rejected",
			reason: "runtime-not-ready"
		};
		const token = "at" in command ? command.at : "range" in command ? command.range : void 0;
		if (token) {
			const resolved = resolveToken(token);
			if (!resolved.ok) return {
				status: "rejected",
				reason: resolved.reason
			};
			return {
				status: "rejected",
				reason: "target-unsupported",
				detail: "positioned v1 dispatch is deferred until selection/range placement is explicitly supported"
			};
		}
		const name = COMMAND_NAME_BY_KIND[command.kind];
		if (!name) return {
			status: "rejected",
			reason: "command-unsupported",
			detail: command.kind
		};
		const commandFn = editor.commands?.[name];
		if (typeof commandFn !== "function") return {
			status: "rejected",
			reason: "command-unsupported",
			detail: name
		};
		const revisionBeforeInvoke = revision;
		let result;
		try {
			result = invokeCommand(command, commandFn);
		} catch (err) {
			return {
				status: "rejected",
				reason: "command-failed",
				detail: errorMessage(err)
			};
		}
		const history = isHistoryKind(command.kind);
		if (result === false || result === null || result === void 0) {
			if (history) return {
				status: "history-noop",
				reason: command.kind === "history.undo" ? "nothing-to-undo" : "nothing-to-redo"
			};
			return {
				status: "noop",
				reason: "no-effect"
			};
		}
		if (revision === revisionBeforeInvoke) invalidatePositionTokens();
		if (history) return {
			status: "history-committed",
			result
		};
		return {
			status: "committed",
			receipt: result
		};
	}
	function selectedText() {
		const st = editor.state;
		if (!st) return "";
		return st.doc.textBetween(st.selection.from, st.selection.to, " ");
	}
	function selectionSnapshot() {
		const st = editor.state;
		if (!st) return null;
		const { from, to } = st.selection;
		const text = st.doc.textBetween(from, to, " ");
		const isEmpty = from === to;
		return {
			isRange: !isEmpty,
			isEmpty,
			text,
			anchor: mintToken(from),
			focus: mintToken(to)
		};
	}
	function layoutSnapshot() {
		if (!presentationEditor) return null;
		return {
			pageCount,
			currentPage: 1,
			zoom: zoomPercent
		};
	}
	function toolbarState() {
		return {
			activeMarks: [],
			disabled: []
		};
	}
	async function toArrayBuffer(value) {
		if (value instanceof ArrayBuffer) return value;
		if (typeof Blob !== "undefined" && value instanceof Blob) return value.arrayBuffer();
		if (ArrayBuffer.isView(value)) {
			const view = value;
			return view.buffer.slice(view.byteOffset, view.byteOffset + view.byteLength);
		}
		throw new Error("v1 runtime: exportDocx returned an unrepresentable value");
	}
	async function exportDocx(options$1) {
		if (typeof editor.exportDocx !== "function") throw new Error("v1 runtime: editor.exportDocx is unavailable");
		return toArrayBuffer(await editor.exportDocx(options$1?.hint));
	}
	async function save() {
		throw new Error("v1 runtime: save is SuperDoc-level orchestration; use the SuperDoc save/export path (capabilities.persistence.canSave === false)");
	}
	async function setZoom(percent) {
		if (disposed) return {
			status: "rejected",
			reason: "runtime-not-ready"
		};
		if (typeof percent !== "number" || !Number.isFinite(percent)) return {
			status: "rejected",
			reason: "target-unsupported",
			detail: "zoom must be a finite number"
		};
		if (percent < ZOOM_MIN || percent > ZOOM_MAX) return {
			status: "rejected",
			reason: "target-unsupported",
			detail: `zoom out of range [${ZOOM_MIN}, ${ZOOM_MAX}]`
		};
		const factor = percent / 100;
		if (typeof setGlobalZoom === "function") setGlobalZoom(factor);
		else if (typeof presentationEditor?.setZoom === "function") presentationEditor.setZoom(factor);
		else return {
			status: "rejected",
			reason: "capability-unsupported",
			detail: "no zoom forwarder available"
		};
		zoomPercent = percent;
		emit({
			type: "layout-change",
			layout: {
				pageCount,
				currentPage: 1,
				zoom: zoomPercent
			}
		});
		return { status: "committed" };
	}
	async function reveal(target) {
		if (disposed) return {
			status: "rejected",
			reason: "runtime-not-ready"
		};
		if (target.kind !== "position") return {
			status: "rejected",
			reason: "target-unsupported",
			detail: `${target.kind} reveal deferred to the editor runtime boundary`
		};
		const resolved = resolveToken(target.position);
		if (!resolved.ok) return {
			status: "rejected",
			reason: resolved.reason
		};
		const scrollTo = presentationEditor?.scrollToPosition;
		if (typeof scrollTo !== "function") return {
			status: "rejected",
			reason: "capability-unsupported",
			detail: "presentation editor not ready"
		};
		return scrollTo.call(presentationEditor, resolved.pos) ? { status: "committed" } : {
			status: "noop",
			reason: "no-effect"
		};
	}
	async function focus(_options) {
		if (disposed) return false;
		if (typeof presentationEditor?.focus === "function") {
			presentationEditor.focus();
			return true;
		}
		if (typeof editor.focus === "function") {
			editor.focus();
			return true;
		}
		if (typeof editor.view?.focus === "function") {
			editor.view.focus();
			return true;
		}
		return false;
	}
	function dispose() {
		if (disposed) return;
		disposed = true;
		if (typeof editor.off === "function") {
			editor.off("destroy", handleEditorDestroy);
			editor.off("update", handleEditorUpdate);
		}
		if (presentationEditor) detachPresentationListeners(presentationEditor);
		state = "disposed";
		emit({ type: "disposed" });
		listeners.clear();
		positions.clear();
		currentRevisionTokenCache.clear();
		if (!unregistered) {
			unregistered = true;
			onUnregister?.(id);
		}
	}
	function handleEditorDestroy() {
		dispose();
	}
	function handleEditorUpdate() {
		if (disposed) return;
		invalidatePositionTokens();
	}
	function detachPresentationListeners(pe) {
		if (typeof pe.off !== "function") return;
		if (paginationHandler) pe.off("paginationUpdate", paginationHandler);
		if (zoomHandler) pe.off("zoomChange", zoomHandler);
		paginationHandler = null;
		zoomHandler = null;
	}
	function attachPresentationEditor(pe) {
		if (disposed) return;
		if (presentationEditor) detachPresentationListeners(presentationEditor);
		presentationEditor = pe;
		paginationHandler = (payload) => {
			const pages = payload?.layout?.pages;
			pageCount = Array.isArray(pages) ? pages.length : pageCount;
			emit({
				type: "layout-change",
				layout: {
					pageCount,
					currentPage: 1,
					zoom: zoomPercent
				}
			});
		};
		zoomHandler = (payload) => {
			const z = payload?.zoom;
			if (typeof z === "number" && Number.isFinite(z)) {
				zoomPercent = Math.round(z * 100);
				emit({
					type: "layout-change",
					layout: {
						pageCount,
						currentPage: 1,
						zoom: zoomPercent
					}
				});
			}
		};
		if (typeof pe.on === "function") {
			pe.on("paginationUpdate", paginationHandler);
			pe.on("zoomChange", zoomHandler);
		}
		const wasReady = state === "editing-ready";
		state = "editing-ready";
		if (!wasReady) emit({
			type: "state-change",
			state
		});
		emit({
			type: "capabilities-change",
			capabilities: capabilities()
		});
	}
	if (typeof editor.on === "function") {
		editor.on("destroy", handleEditorDestroy);
		editor.on("update", handleEditorUpdate);
	}
	return {
		runtime: {
			id,
			kind: "v1",
			documentId,
			root,
			getCapabilities: capabilities,
			getSnapshot: snapshot,
			getLegacyEditorProjection: () => editor,
			focus,
			dispose,
			dispatch,
			getSelectedText: selectedText,
			getSelectionSnapshot: selectionSnapshot,
			getToolbarState: toolbarState,
			getLayoutSnapshot: layoutSnapshot,
			save,
			exportDocx,
			setZoom,
			reveal,
			subscribe(listener) {
				listeners.add(listener);
				return () => {
					listeners.delete(listener);
				};
			}
		},
		attachPresentationEditor
	};
}
const RUNTIME_ROOT_ATTRIBUTE = "data-superdoc-runtime-id";
function markRuntimeRoot(root, id) {
	root.setAttribute(RUNTIME_ROOT_ATTRIBUTE, id);
}
function unmarkRuntimeRoot(root) {
	root.removeAttribute(RUNTIME_ROOT_ATTRIBUTE);
}
function collectTouchedTrackedChangeIds(transaction, { trackChangesPluginKey = null } = {}) {
	const ids = /* @__PURE__ */ new Set();
	const addMarkId = (mark) => {
		const id = mark?.attrs?.id;
		if (id != null) ids.add(String(id));
	};
	const meta = trackChangesPluginKey ? transaction?.getMeta?.(trackChangesPluginKey) : null;
	if (meta) [
		meta.insertedMark,
		meta.deletionMark,
		meta.formatMark
	].forEach(addMarkId);
	if (!transaction?.docChanged || !transaction?.doc || !transaction?.mapping?.maps?.length) return ids;
	const docSize = transaction.doc.content.size;
	transaction.mapping.maps.forEach((stepMap, stepIndex) => {
		stepMap.forEach((oldStart, oldEnd, newStart, newEnd) => {
			const mappingOffset = stepIndex + 1;
			const mappedFrom = transaction.mapping.slice(mappingOffset).map(newStart, 1);
			const mappedTo = transaction.mapping.slice(mappingOffset).map(newEnd, -1);
			const from = Math.max(0, mappedFrom - 1);
			const to = Math.min(docSize, mappedTo + 1);
			if (from >= to) return;
			transaction.doc.nodesBetween(from, to, (node) => {
				node.marks?.forEach((mark) => {
					const markName = mark.type?.name;
					if (markName === "trackInsert" || markName === "trackDelete" || markName === "trackFormat") addMarkId(mark);
				});
			});
		});
	});
	return ids;
}
function transactionTouchesStructuralChange(transaction) {
	if (!transaction?.docChanged || !transaction?.doc || !transaction?.mapping?.maps?.length) return false;
	const docSize = transaction.doc.content.size;
	let touched = false;
	transaction.mapping.maps.forEach((stepMap, stepIndex) => {
		if (touched) return;
		stepMap.forEach((oldStart, oldEnd, newStart, newEnd) => {
			if (touched) return;
			const mappingOffset = stepIndex + 1;
			const mappedFrom = transaction.mapping.slice(mappingOffset).map(newStart, 1);
			const mappedTo = transaction.mapping.slice(mappingOffset).map(newEnd, -1);
			const from = Math.max(0, mappedFrom - 1);
			const to = Math.min(docSize, mappedTo + 1);
			if (from >= to) return;
			transaction.doc.nodesBetween(from, to, (node) => {
				if (touched) return false;
				if (node?.type?.name !== "tableRow") return void 0;
				const tc = node.attrs?.trackChange;
				if (tc && (tc.type === "rowInsert" || tc.type === "rowDelete")) {
					touched = true;
					return false;
				}
			});
		});
	});
	return touched;
}
var SurfaceExternalMount_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "SurfaceExternalMount",
	props: {
		surfaceId: {
			type: String,
			required: true
		},
		mode: {
			type: String,
			required: true
		},
		request: {
			type: Object,
			required: true
		},
		render: {
			type: Function,
			required: true
		},
		resolve: {
			type: Function,
			required: true
		},
		close: {
			type: Function,
			required: true
		}
	},
	setup(__props) {
		const props = __props;
		const container = ref(null);
		let destroyFn = null;
		function mount() {
			cleanup();
			if (!container.value || !props.render) return;
			destroyFn = props.render({
				container: container.value,
				surfaceId: props.surfaceId,
				mode: props.mode,
				request: props.request,
				resolve: props.resolve,
				close: props.close
			})?.destroy ?? null;
		}
		function cleanup() {
			if (typeof destroyFn === "function") destroyFn();
			destroyFn = null;
			if (container.value) container.value.innerHTML = "";
		}
		onMounted(mount);
		onBeforeUnmount(cleanup);
		watch(() => props.surfaceId, () => {
			mount();
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "container",
				ref: container,
				class: "sd-surface-external-mount"
			}, null, 512);
		};
	}
}, [["__scopeId", "data-v-b2412c5d"]]);
const FOCUSABLE_SELECTOR = [
	"a[href]",
	"button:not([disabled])",
	"textarea:not([disabled])",
	"input:not([disabled])",
	"select:not([disabled])",
	"[tabindex]:not([tabindex=\"-1\"])"
].join(", ");
var _hoisted_1$2 = ["aria-labelledby", "aria-label"];
var _hoisted_2$2 = ["id"];
var _hoisted_3$2 = { class: "sd-surface-dialog__content" };
var SurfaceDialog_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "SurfaceDialog",
	props: {
		surface: {
			type: Object,
			required: true
		},
		scrollLockTarget: {
			type: Object,
			default: null
		}
	},
	emits: ["close"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const dialogRef = ref(null);
		const titleId = computed(() => props.surface.request.title ? `sd-surface-title-${props.surface.id}` : void 0);
		const labelledBy = computed(() => titleId.value ?? props.surface.request.ariaLabelledBy ?? void 0);
		const ariaLabel = computed(() => labelledBy.value ? void 0 : props.surface.request.ariaLabel);
		let previouslyFocusedElement = null;
		function trapFocus(event) {
			if (!dialogRef.value) return;
			const focusable = dialogRef.value.querySelectorAll(FOCUSABLE_SELECTOR);
			if (focusable.length === 0) return;
			const first = focusable[0];
			const last = focusable[focusable.length - 1];
			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault();
				last.focus();
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault();
				first.focus();
			}
		}
		function setInitialFocus() {
			if (!dialogRef.value) return;
			const firstFocusable = dialogRef.value.querySelector(FOCUSABLE_SELECTOR);
			if (firstFocusable) firstFocusable.focus();
			else dialogRef.value.focus();
		}
		let scrollLockTarget = null;
		let originalOverflow = "";
		function lockScroll() {
			if (props.scrollLockTarget) scrollLockTarget = props.scrollLockTarget;
			else {
				const superdocRoot = dialogRef.value?.closest(".superdoc");
				scrollLockTarget = superdocRoot?.querySelector(".superdoc__layers") ?? superdocRoot;
			}
			if (!scrollLockTarget) return;
			originalOverflow = scrollLockTarget.style.overflow;
			scrollLockTarget.style.overflow = "hidden";
		}
		function unlockScroll() {
			if (!scrollLockTarget) return;
			scrollLockTarget.style.overflow = originalOverflow;
			scrollLockTarget = null;
			originalOverflow = "";
		}
		function handleKeydown(event) {
			if (event.key === "Tab") {
				trapFocus(event);
				return;
			}
			if (event.key === "Escape" && props.surface.request.closeOnEscape !== false) {
				event.stopPropagation();
				emit("close");
			}
		}
		function handleBackdropClick(event) {
			if (event.target === event.currentTarget && props.surface.request.closeOnBackdrop !== false) emit("close");
		}
		const shellProps = computed(() => ({
			surfaceId: props.surface.id,
			mode: "dialog",
			request: props.surface.request,
			resolve: props.surface.resolve,
			close: props.surface.close
		}));
		const mergedComponentProps = computed(() => {
			return {
				...props.surface.props ?? {},
				...shellProps.value
			};
		});
		const maxWidth = computed(() => {
			const reqMax = props.surface.request.dialog?.maxWidth;
			if (reqMax != null) return typeof reqMax === "number" ? `${reqMax}px` : reqMax;
		});
		const cardStyle = computed(() => {
			const style = {};
			if (maxWidth.value) style["max-width"] = maxWidth.value;
			return style;
		});
		onMounted(async () => {
			previouslyFocusedElement = document.activeElement;
			lockScroll();
			await nextTick();
			setInitialFocus();
		});
		watch(() => props.scrollLockTarget, (target, previousTarget) => {
			if (target === previousTarget) return;
			unlockScroll();
			lockScroll();
		});
		onBeforeUnmount(() => {
			unlockScroll();
			if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === "function") previouslyFocusedElement.focus();
			previouslyFocusedElement = null;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "sd-surface-dialog-backdrop",
				onMousedown: withModifiers(handleBackdropClick, ["self"]),
				onKeydown: handleKeydown
			}, [createElementVNode("div", {
				ref_key: "dialogRef",
				ref: dialogRef,
				class: "sd-surface-dialog",
				style: normalizeStyle(cardStyle.value),
				role: "dialog",
				"aria-modal": "true",
				"aria-labelledby": labelledBy.value,
				"aria-label": ariaLabel.value,
				tabindex: "-1"
			}, [__props.surface.request.title ? (openBlock(), createElementBlock("div", {
				key: 0,
				id: titleId.value,
				class: "sd-surface-dialog__title"
			}, toDisplayString(__props.surface.request.title), 9, _hoisted_2$2)) : createCommentVNode("", true), createElementVNode("div", _hoisted_3$2, [__props.surface.render ? (openBlock(), createBlock(SurfaceExternalMount_default, {
				key: 0,
				"surface-id": __props.surface.id,
				mode: "dialog",
				request: __props.surface.request,
				render: __props.surface.render,
				resolve: __props.surface.resolve,
				close: __props.surface.close
			}, null, 8, [
				"surface-id",
				"request",
				"render",
				"resolve",
				"close"
			])) : __props.surface.component ? (openBlock(), createBlock(resolveDynamicComponent(__props.surface.component), normalizeProps(mergeProps({ key: 1 }, mergedComponentProps.value)), null, 16)) : createCommentVNode("", true)])], 12, _hoisted_1$2)], 32);
		};
	}
}, [["__scopeId", "data-v-20bf8e4b"]]);
var _hoisted_1$1 = ["aria-labelledby", "aria-label"];
var _hoisted_2$1 = ["id"];
var _hoisted_3$1 = { class: "sd-surface-floating__content" };
var SurfaceFloating_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "SurfaceFloating",
	props: { surface: {
		type: Object,
		required: true
	} },
	setup(__props, { expose: __expose }) {
		const props = __props;
		const floatingRef = ref(null);
		__expose({ rootEl: floatingRef });
		const titleId = computed(() => props.surface.request.title ? `sd-surface-title-${props.surface.id}` : void 0);
		const labelledBy = computed(() => titleId.value ?? props.surface.request.ariaLabelledBy ?? void 0);
		const ariaLabel = computed(() => labelledBy.value ? void 0 : props.surface.request.ariaLabel);
		const floatingOpts = computed(() => props.surface.request.floating ?? {});
		const hasExplicitInsets = computed(() => {
			const o = floatingOpts.value;
			return o.top != null || o.right != null || o.bottom != null || o.left != null;
		});
		const floatingClasses = computed(() => {
			const classes = ["sd-surface-floating"];
			if (!hasExplicitInsets.value) {
				const placement = floatingOpts.value.placement ?? "top-right";
				classes.push(`sd-surface-floating--${placement}`);
			}
			return classes;
		});
		function toPx(value) {
			if (value == null) return void 0;
			return typeof value === "number" ? `${value}px` : value;
		}
		const floatingStyle = computed(() => {
			const o = floatingOpts.value;
			const style = {};
			if (o.top != null) style.top = toPx(o.top);
			if (o.right != null) style.right = toPx(o.right);
			if (o.bottom != null) style.bottom = toPx(o.bottom);
			if (o.left != null) style.left = toPx(o.left);
			if (o.width != null) style.width = toPx(o.width);
			if (o.maxWidth != null) style["max-width"] = toPx(o.maxWidth);
			if (o.maxHeight != null) style["max-height"] = toPx(o.maxHeight);
			return style;
		});
		const shellProps = computed(() => ({
			surfaceId: props.surface.id,
			mode: "floating",
			request: props.surface.request,
			resolve: props.surface.resolve,
			close: props.surface.close
		}));
		const mergedComponentProps = computed(() => {
			return {
				...props.surface.props ?? {},
				...shellProps.value
			};
		});
		let previouslyFocusedElement = null;
		let didTakeFocus = false;
		onMounted(async () => {
			if (floatingOpts.value.autoFocus === false) return;
			await nextTick();
			if (!floatingRef.value) return;
			const firstFocusable = floatingRef.value.querySelector(FOCUSABLE_SELECTOR);
			if (firstFocusable) {
				previouslyFocusedElement = document.activeElement;
				firstFocusable.focus();
				didTakeFocus = true;
			}
		});
		onBeforeUnmount(() => {
			if (didTakeFocus && previouslyFocusedElement && typeof previouslyFocusedElement.focus === "function") previouslyFocusedElement.focus();
			previouslyFocusedElement = null;
			didTakeFocus = false;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "floatingRef",
				ref: floatingRef,
				class: normalizeClass(floatingClasses.value),
				style: normalizeStyle(floatingStyle.value),
				role: "dialog",
				"aria-labelledby": labelledBy.value,
				"aria-label": ariaLabel.value,
				"data-editor-ui-surface": ""
			}, [__props.surface.request.title ? (openBlock(), createElementBlock("div", {
				key: 0,
				id: titleId.value,
				class: "sd-surface-floating__title"
			}, toDisplayString(__props.surface.request.title), 9, _hoisted_2$1)) : createCommentVNode("", true), createElementVNode("div", _hoisted_3$1, [__props.surface.render ? (openBlock(), createBlock(SurfaceExternalMount_default, {
				key: 0,
				"surface-id": __props.surface.id,
				mode: "floating",
				request: __props.surface.request,
				render: __props.surface.render,
				resolve: __props.surface.resolve,
				close: __props.surface.close
			}, null, 8, [
				"surface-id",
				"request",
				"render",
				"resolve",
				"close"
			])) : __props.surface.component ? (openBlock(), createBlock(resolveDynamicComponent(__props.surface.component), normalizeProps(mergeProps({ key: 1 }, mergedComponentProps.value)), null, 16)) : createCommentVNode("", true)])], 14, _hoisted_1$1);
		};
	}
}, [["__scopeId", "data-v-51d59bd5"]]);
var SurfaceHost_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "SurfaceHost",
	props: { geometryTarget: {
		type: Object,
		default: null
	} },
	setup(__props) {
		const props = __props;
		const surfaceManager = inject("surfaceManager", null);
		const dialog = computed(() => surfaceManager?.activeDialog.value ?? null);
		const floating = computed(() => surfaceManager?.activeFloating.value ?? null);
		const hasAnySurface = computed(() => dialog.value != null || floating.value != null);
		const hostRef = ref(null);
		const floatingRef = ref(null);
		const hostStyle = ref({});
		const CLIPPING_OVERFLOW = new Set([
			"hidden",
			"scroll",
			"auto",
			"clip"
		]);
		function collectClippingAncestors(el) {
			const ancestors = [];
			let ancestor = el.parentElement;
			while (ancestor) {
				const style = getComputedStyle(ancestor);
				if (CLIPPING_OVERFLOW.has(style.overflowX) || CLIPPING_OVERFLOW.has(style.overflowY)) ancestors.push(ancestor);
				ancestor = ancestor.parentElement;
			}
			return ancestors;
		}
		function computeVisibleRect(el, clippingAncestors$1) {
			let top = 0;
			let left = 0;
			let right = window.innerWidth;
			let bottom = window.innerHeight;
			for (const ancestor of clippingAncestors$1) {
				const ar = ancestor.getBoundingClientRect();
				const style = getComputedStyle(ancestor);
				if (CLIPPING_OVERFLOW.has(style.overflowX)) {
					left = Math.max(left, ar.left);
					right = Math.min(right, ar.right);
				}
				if (CLIPPING_OVERFLOW.has(style.overflowY)) {
					top = Math.max(top, ar.top);
					bottom = Math.min(bottom, ar.bottom);
				}
			}
			const r = el.getBoundingClientRect();
			top = Math.max(top, r.top);
			left = Math.max(left, r.left);
			right = Math.min(right, r.right);
			bottom = Math.min(bottom, r.bottom);
			return {
				top,
				left,
				width: Math.max(right - left, 0),
				height: Math.max(bottom - top, 0)
			};
		}
		let geometryTarget = null;
		let clippingAncestors = [];
		let rafId = 0;
		let resizeObserver = null;
		function updateHostRect() {
			if (!geometryTarget) return;
			const { top, left, width, height } = computeVisibleRect(geometryTarget, clippingAncestors);
			hostStyle.value = {
				position: "fixed",
				top: `${top}px`,
				left: `${left}px`,
				width: `${width}px`,
				height: `${height}px`
			};
		}
		function scheduleUpdate() {
			if (rafId) return;
			rafId = requestAnimationFrame(() => {
				rafId = 0;
				updateHostRect();
			});
		}
		function setupGeometry() {
			geometryTarget = props.geometryTarget ?? null;
			if (!geometryTarget) return;
			clippingAncestors = collectClippingAncestors(geometryTarget);
			updateHostRect();
			window.addEventListener("scroll", scheduleUpdate, true);
			window.addEventListener("resize", scheduleUpdate);
			resizeObserver = new ResizeObserver(scheduleUpdate);
			resizeObserver.observe(geometryTarget);
			for (const ancestor of clippingAncestors) resizeObserver.observe(ancestor);
		}
		function teardownGeometry() {
			if (rafId) {
				cancelAnimationFrame(rafId);
				rafId = 0;
			}
			window.removeEventListener("scroll", scheduleUpdate, true);
			window.removeEventListener("resize", scheduleUpdate);
			if (resizeObserver) {
				resizeObserver.disconnect();
				resizeObserver = null;
			}
			geometryTarget = null;
			clippingAncestors = [];
		}
		watch(hasAnySurface, (active) => {
			if (active) setupGeometry();
			else teardownGeometry();
		});
		watch(() => props.geometryTarget, (target) => {
			if (target && hasAnySurface.value && !geometryTarget) setupGeometry();
		});
		onMounted(() => {
			if (hasAnySurface.value) setupGeometry();
		});
		function handleFloatingEscape(event) {
			const f = floating.value;
			if (!f || f.settled) return;
			if (dialog.value) return;
			if (event.key === "Escape" && f.request.closeOnEscape !== false) {
				event.stopPropagation();
				surfaceManager.close(f.id);
			}
		}
		let escapeListenerAttached = false;
		function attachEscapeListener() {
			if (escapeListenerAttached) return;
			document.addEventListener("keydown", handleFloatingEscape, true);
			escapeListenerAttached = true;
		}
		function detachEscapeListener() {
			if (!escapeListenerAttached) return;
			document.removeEventListener("keydown", handleFloatingEscape, true);
			escapeListenerAttached = false;
		}
		function handleOutsidePointerDown(event) {
			const f = floating.value;
			if (!f || f.settled) return;
			if (dialog.value) return;
			const rootEl = floatingRef.value?.rootEl;
			if (rootEl && !rootEl.contains(event.target)) surfaceManager.close(f.id);
		}
		let pointerListenerAttached = false;
		function attachPointerListener() {
			if (pointerListenerAttached) return;
			document.addEventListener("pointerdown", handleOutsidePointerDown, true);
			pointerListenerAttached = true;
		}
		function detachPointerListener() {
			if (!pointerListenerAttached) return;
			document.removeEventListener("pointerdown", handleOutsidePointerDown, true);
			pointerListenerAttached = false;
		}
		watch(floating, (f) => {
			if (f && !f.settled) {
				attachEscapeListener();
				if (f.request.floating?.closeOnOutsidePointerDown) attachPointerListener();
				else detachPointerListener();
			} else {
				detachEscapeListener();
				detachPointerListener();
			}
		}, { immediate: true });
		onBeforeUnmount(() => {
			teardownGeometry();
			detachEscapeListener();
			detachPointerListener();
		});
		function handleDialogClose() {
			const d = dialog.value;
			if (d && !d.settled) surfaceManager.close(d.id);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Teleport, { to: "body" }, [hasAnySurface.value ? (openBlock(), createElementBlock("div", {
				key: 0,
				ref_key: "hostRef",
				ref: hostRef,
				class: "sd-surface-host",
				style: normalizeStyle(hostStyle.value)
			}, [floating.value ? (openBlock(), createBlock(SurfaceFloating_default, {
				key: floating.value.id,
				surface: floating.value,
				ref_key: "floatingRef",
				ref: floatingRef
			}, null, 8, ["surface"])) : createCommentVNode("", true), dialog.value ? (openBlock(), createBlock(SurfaceDialog_default, {
				key: dialog.value.id,
				surface: dialog.value,
				"scroll-lock-target": unref(geometryTarget),
				onClose: handleDialogClose
			}, null, 8, ["surface", "scroll-lock-target"])) : createCommentVNode("", true)], 4)) : createCommentVNode("", true)]);
		};
	}
}, [["__scopeId", "data-v-c6a3b75f"]]);
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = { class: "superdoc__document document" };
var _hoisted_3 = { class: "floating-comments" };
var SuperDoc_default = /* @__PURE__ */ __plugin_vue_export_helper_default({
	__name: "SuperDoc",
	emits: ["selection-update"],
	setup(__props, { emit: __emit }) {
		const PdfViewer = defineAsyncComponent(() => import("./PdfViewer-As15LwzN.es.js"));
		const getDocumentLoadPassword = (doc) => doc.password ?? proxy.$superdoc.config.password;
		const superdocStore = useSuperdocStore();
		const commentsStore = useCommentsStore();
		const { documents, isReady, areDocumentsReady, selectionPosition, activeSelection, activeZoom, zoomMode, viewportMetrics } = storeToRefs(superdocStore);
		const { handlePageReady, modules, user, getDocument } = superdocStore;
		const surfaceManager = inject("surfaceManager", null);
		const passwordPrompt = usePasswordPrompt({
			getSurfaceManager: () => surfaceManager,
			getPasswordPromptConfig: () => proxy.$superdoc?.config?.modules?.surfaces?.passwordPrompt,
			onUnhandled: (doc, errorCode, originalException) => {
				proxy.$superdoc?.emit("exception", {
					error: originalException?.error ?? /* @__PURE__ */ new Error(`Password prompt unhandled: ${errorCode}`),
					editor: originalException?.editor ?? null,
					code: errorCode,
					documentId: doc?.id
				});
			}
		});
		const { getConfig, documentsWithConverations, commentsList, pendingComment, activeComment, skipSelectionUpdate, commentsByDocument, isCommentsListVisible, isFloatingCommentsReady, generalCommentIds, hasSyncedCollaborationComments, editorCommentPositions, hasInitializedLocations, isCommentHighlighted } = storeToRefs(commentsStore);
		const { showAddComment, handleEditorLocationsUpdate, handleTrackedChangeUpdate, refreshTrackedChangeCommentsByIds, syncTrackedChangePositionsWithDocument, syncTrackedChangeComments, addComment, getComment, resolveCommentPositionEntry, belongsToDocument, COMMENT_EVENTS, requestInstantSidebarAlignment, peekInstantSidebarAlignment, clearInstantSidebarAlignment } = commentsStore;
		const { proxy } = getCurrentInstance();
		commentsStore.proxy = proxy;
		const floatingComments = computed(() => {
			const currentFloatingComments = unref(commentsStore.getFloatingComments);
			return Array.isArray(currentFloatingComments) ? currentFloatingComments : [];
		});
		const { isHighContrastMode: isHighContrastMode$1 } = useHighContrastMode();
		const { uiFontFamily } = useUiFontFamily();
		const isViewingMode = () => proxy?.$superdoc?.config?.documentMode === "viewing";
		const allowSelectionInViewMode = () => !!proxy?.$superdoc?.config?.allowSelectionInViewMode;
		const isViewingCommentsVisible = computed(() => isViewingMode() && proxy?.$superdoc?.config?.comments?.visible === true);
		const isFindReplaceEnabled = computed(() => {
			const val = proxy?.$superdoc?.config?.modules?.surfaces?.findReplace;
			return val === true || typeof val === "object" && val !== null;
		});
		const isViewingTrackChangesVisible = computed(() => isViewingMode() && proxy?.$superdoc?.config?.trackChanges?.visible === true);
		const shouldRenderCommentsInViewing = computed(() => {
			if (!isViewingMode()) return true;
			return isViewingCommentsVisible.value || isViewingTrackChangesVisible.value;
		});
		const resolvedProofingConfig = computed(() => {
			if (proxy.$superdoc.config.proofing !== void 0) return proxy.$superdoc.config.proofing;
			return proxy.$superdoc.config.layoutEngineOptions?.proofing;
		});
		const commentsModuleConfig = computed(() => {
			const config = modules.comments;
			if (config === false || config == null) return null;
			return config;
		});
		const superdocStyleVars = computed(() => {
			const vars = { "--sd-ui-font-family": uiFontFamily.value };
			const commentsConfig = proxy.$superdoc.config.modules?.comments;
			if (!commentsConfig || commentsConfig === false) return vars;
			if (commentsConfig.highlightHoverColor) vars["--sd-comments-highlight-hover"] = commentsConfig.highlightHoverColor;
			const activeTrackChangeColors = {
				...commentsConfig.trackChangeHighlightColors || {},
				...commentsConfig.trackChangeActiveHighlightColors || {}
			};
			if (activeTrackChangeColors.insertBorder) vars["--sd-tracked-changes-insert-border"] = activeTrackChangeColors.insertBorder;
			if (activeTrackChangeColors.insertBackground) vars["--sd-tracked-changes-insert-background"] = activeTrackChangeColors.insertBackground;
			if (activeTrackChangeColors.deleteBorder) vars["--sd-tracked-changes-delete-border"] = activeTrackChangeColors.deleteBorder;
			if (activeTrackChangeColors.deleteBackground) vars["--sd-tracked-changes-delete-background"] = activeTrackChangeColors.deleteBackground;
			if (activeTrackChangeColors.formatBorder) vars["--sd-tracked-changes-format-border"] = activeTrackChangeColors.formatBorder;
			return vars;
		});
		const superdocRoot = ref(null);
		const layers = ref(null);
		const rightSidebarRef = ref(null);
		const pdfViewerRef = ref(null);
		const pendingReplayTrackedChangeSync = ref(false);
		const toolsMenuPosition = reactive({
			top: null,
			right: "-25px",
			zIndex: 101
		});
		const { superdocContainerWidth, isCompactCommentsMode, recalculateCompactCommentsMode, ensureCompactMeasurementObserver } = useCommentSmallScreen({
			commentsModuleConfig,
			superdocRoot,
			layers
		});
		const commentsLayer = ref(null);
		const activeEditorRef = computed(() => proxy.$superdoc.activeEditor);
		const findReplace = useFindReplace({
			getSurfaceManager: () => surfaceManager,
			getActiveEditor: () => proxy.$superdoc?.activeEditor,
			activeEditorRef,
			getFindReplaceConfig: () => proxy.$superdoc?.config?.modules?.surfaces?.findReplace
		});
		const { selectedText } = useSelectedText(activeEditorRef, { getActiveRuntime: () => proxy.$superdoc?.getActiveRuntime?.() });
		const { showAiLayer, showAiWriter, aiWriterPosition, aiLayer, initAiLayer, showAiWriterAtCursor, handleAiWriterClose, handleAiToolClick } = useAi({ activeEditorRef });
		const hrbrFieldsLayer = ref(null);
		const pdfConfig = proxy.$superdoc.config.modules?.pdf || {};
		const flushPendingReplayTrackedChangeSync = () => {
			if (!pendingReplayTrackedChangeSync.value) return;
			pendingReplayTrackedChangeSync.value = false;
			syncTrackedChangeComments({
				superdoc: proxy.$superdoc,
				editor: proxy.$superdoc?.activeEditor
			});
		};
		let queuedTrackedChangeCommentResync = null;
		let isTrackedChangeCommentResyncQueued = false;
		const flushQueuedTrackedChangeCommentResync = () => {
			isTrackedChangeCommentResyncQueued = false;
			const pendingResync = queuedTrackedChangeCommentResync;
			queuedTrackedChangeCommentResync = null;
			if (!pendingResync?.editor) return;
			if (pendingResync.fullResync) {
				syncTrackedChangeComments({
					superdoc: proxy.$superdoc,
					editor: pendingResync.editor,
					broadcastChanges: pendingResync.broadcastChanges
				});
				return;
			}
			refreshTrackedChangeCommentsByIds({
				superdoc: proxy.$superdoc,
				editor: pendingResync.editor,
				changeIds: Array.from(pendingResync.changeIds ?? []),
				broadcastChanges: pendingResync.broadcastChanges
			});
		};
		const queueTrackedChangeCommentResync = ({ editor, changeIds = null, broadcastChanges = true } = {}) => {
			if (!editor || changeIds && !changeIds.size) return;
			const existingChangeIds = queuedTrackedChangeCommentResync?.changeIds ?? /* @__PURE__ */ new Set();
			queuedTrackedChangeCommentResync = {
				editor,
				fullResync: !changeIds || Boolean(queuedTrackedChangeCommentResync?.fullResync),
				changeIds: changeIds ? new Set([...existingChangeIds, ...changeIds]) : existingChangeIds,
				broadcastChanges: Boolean(queuedTrackedChangeCommentResync?.broadcastChanges) || Boolean(broadcastChanges)
			};
			if (isTrackedChangeCommentResyncQueued) return;
			isTrackedChangeCommentResyncQueued = true;
			queueMicrotask(flushQueuedTrackedChangeCommentResync);
		};
		const scheduleReplayTrackedChangeSync = () => {
			pendingReplayTrackedChangeSync.value = true;
			const activeDocId = proxy.$superdoc?.activeEditor?.options?.documentId;
			const hasPresentationBridge = Boolean(activeDocId && PresentationEditor.getInstance(activeDocId) && layers.value);
			nextTick(() => {
				flushPendingReplayTrackedChangeSync();
			});
			if (!hasPresentationBridge || !shouldRenderCommentsInViewing.value) return;
		};
		const handleDocumentReady = (documentId, container) => {
			const doc = getDocument(documentId);
			doc.isReady = true;
			doc.container = container;
			if (areDocumentsReady.value) {
				if (!proxy.$superdoc.config.collaboration) isReady.value = true;
			}
			ensureInitialFallbackZoom();
			isFloatingCommentsReady.value = true;
			hasInitializedLocations.value = true;
			proxy.$superdoc.broadcastPdfDocumentReady();
		};
		const getPendingCommentTargetClientY = () => {
			if (!selectionPosition.value || !layers.value) return null;
			const zoom = selectionPosition.value.source === "pdf" ? (activeZoom.value ?? 100) / 100 : 1;
			const top = Number(selectionPosition.value.top);
			if (!Number.isFinite(top)) return null;
			return layers.value.getBoundingClientRect().top + top * zoom;
		};
		const handleToolClick = (tool) => {
			const toolOptions = {
				comments: () => showAddComment(proxy.$superdoc, getPendingCommentTargetClientY()),
				ai: () => handleAiToolClick()
			};
			if (tool in toolOptions) toolOptions[tool](activeSelection.value, selectionPosition.value);
			activeSelection.value = null;
			toolsMenuPosition.top = null;
		};
		const handleDocumentMouseDown = (e) => {
			if (pendingComment.value) return;
		};
		const handleHighlightClick = () => toolsMenuPosition.top = null;
		const onCommentsLoaded = ({ editor, comments, replacedFile }) => {
			if (editor.options.shouldLoadComments || replacedFile) nextTick(() => {
				commentsStore.processLoadedDocxComments({
					superdoc: proxy.$superdoc,
					editor,
					comments,
					documentId: editor.options.documentId,
					replacedFile
				});
			});
		};
		const onEditorBeforeCreate = ({ editor }) => {
			proxy.$superdoc?.broadcastEditorBeforeCreate(editor);
		};
		const onEditorContentControlFocus = (payload) => {
			proxy.$superdoc.emit("content-control:active-change", payload);
		};
		const onEditorContentControlBlur = (payload) => {
			proxy.$superdoc.emit("content-control:active-change", payload);
		};
		const onEditorContentControlClick = (payload) => {
			proxy.$superdoc.emit("content-control:click", payload);
		};
		const subDocumentRoots = /* @__PURE__ */ new Map();
		const v1Runtimes = /* @__PURE__ */ new Map();
		let v1RuntimeSeq = 0;
		const setSubDocumentRoot = (doc, el) => {
			if (!doc?.id) return;
			if (el) subDocumentRoots.set(doc.id, el);
			else subDocumentRoots.delete(doc.id);
		};
		const registerV1Runtime = (documentId, editor) => {
			const root = subDocumentRoots.get(documentId);
			if (!root) {
				console.warn("[SuperDoc] v1 runtime host root unavailable; skipping runtime registration for", documentId);
				return;
			}
			const existing = v1Runtimes.get(documentId);
			if (existing) existing.adapter.runtime.dispose();
			const runtimeId = `v1:${documentId}:${++v1RuntimeSeq}`;
			const adapter = createV1EditorRuntimeAdapter({
				id: runtimeId,
				documentId,
				root,
				editor,
				setGlobalZoom: (factor) => PresentationEditor.setGlobalZoom(factor),
				onUnregister: (id) => {
					proxy.$superdoc.unregisterEditorRuntime(id);
					const current = v1Runtimes.get(documentId);
					if (current && current.runtimeId === id) v1Runtimes.delete(documentId);
					const hostRoot = subDocumentRoots.get(documentId);
					if (hostRoot) unmarkRuntimeRoot(hostRoot);
				}
			});
			markRuntimeRoot(root, runtimeId);
			proxy.$superdoc.registerEditorRuntime(adapter.runtime);
			v1Runtimes.set(documentId, {
				runtimeId,
				adapter
			});
			proxy.$superdoc.setActiveRuntime(runtimeId, "v1-editor-create");
		};
		const onEditorCreate = ({ editor }) => {
			const { documentId } = editor.options;
			getDocument(documentId).setEditor(editor);
			registerV1Runtime(documentId, editor);
			proxy.$superdoc.setActiveEditor(editor);
			editor.on?.("contentControlFocus", onEditorContentControlFocus);
			editor.on?.("contentControlBlur", onEditorContentControlBlur);
			editor.on?.("contentControlClick", onEditorContentControlClick);
			proxy.$superdoc.broadcastEditorCreate(editor);
			initAiLayer(true);
		};
		const onEditorReady = ({ editor, presentationEditor }) => {
			ensureInitialFallbackZoom();
			if (!presentationEditor) return;
			const { documentId } = editor.options;
			const doc = getDocument(documentId);
			if (doc) {
				passwordPrompt.handleEditorReady(doc);
				doc.setPresentationEditor(presentationEditor);
				if (doc.password) doc.password = void 0;
			}
			const v1Runtime = v1Runtimes.get(documentId);
			if (v1Runtime) v1Runtime.adapter.attachPresentationEditor(presentationEditor);
			presentationEditor.setContextMenuDisabled?.(proxy.$superdoc.config.disableContextMenu);
			getTrackedChangeIndex(editor);
			presentationEditor.on("commentPositions", ({ positions }) => {
				const commentsConfig = proxy.$superdoc.config.modules?.comments;
				if (!commentsConfig || commentsConfig === false) return;
				if (!shouldRenderCommentsInViewing.value) {
					commentsStore.clearEditorCommentPositions?.();
					return;
				}
				handleEditorLocationsUpdate(presentationEditor.getCommentBounds(positions, layers.value));
				flushPendingReplayTrackedChangeSync();
				if (!hasInitializedLocations.value) hasInitializedLocations.value = true;
			});
			editor.on?.("tracked-changes-changed", ({ editor: sourceEditor, source }) => {
				if (source === "body-edit") return;
				if (!shouldRenderCommentsInViewing.value) {
					commentsStore.clearEditorCommentPositions?.();
					return;
				}
				syncTrackedChangeComments({
					superdoc: proxy.$superdoc,
					editor: sourceEditor ?? editor
				});
			});
			presentationEditor.on("paginationUpdate", ({ layout }) => {
				const totalPages = layout.pages.length;
				proxy.$superdoc.emit("pagination-update", {
					totalPages,
					superdoc: proxy.$superdoc
				});
			});
			presentationEditor.on("headerFooterUpdate", (payload = {}) => {
				proxy.$superdoc.emit("editor-update", buildEditorUpdatePayload(payload));
			});
			presentationEditor.on("headerFooterTransaction", (payload = {}) => {
				emitEditorTransaction(buildEditorTransactionPayload(payload));
			});
		};
		const onEditorDestroy = () => {
			proxy.$superdoc.broadcastEditorDestroy();
		};
		const onEditorFocus = ({ editor }) => {
			const documentId = editor?.options?.documentId;
			const entry = documentId ? v1Runtimes.get(documentId) : null;
			if (entry) proxy.$superdoc.setActiveRuntime(entry.runtimeId, "v1-editor-focus");
			proxy.$superdoc.setActiveEditor(editor);
		};
		const activateRuntimeFromEvent = (event, reason) => {
			proxy.$superdoc?.activateRuntimeFromEventTarget?.(event.target, reason);
		};
		const handleRuntimeFocusIn = (event) => activateRuntimeFromEvent(event, "focusin");
		const handleRuntimePointerDown = (event) => activateRuntimeFromEvent(event, "pointerdown");
		const handleRuntimeMouseDown = (event) => activateRuntimeFromEvent(event, "mousedown");
		const onEditorDocumentLocked = ({ editor, isLocked, lockedBy }) => {
			proxy.$superdoc.lockSuperdoc(isLocked, lockedBy);
		};
		const buildEditorPayloadBase = ({ editor, sourceEditor, surface = "body", headerId = null, sectionType = null } = {}) => {
			const effectiveEditor = editor ?? sourceEditor;
			return {
				editor: effectiveEditor,
				sourceEditor: sourceEditor ?? effectiveEditor,
				surface,
				headerId,
				sectionType
			};
		};
		const buildEditorUpdatePayload = (payload = {}) => {
			return buildEditorPayloadBase(payload);
		};
		const onEditorUpdate = (payload = {}) => {
			proxy.$superdoc.emit("editor-update", buildEditorUpdatePayload(payload));
		};
		const buildEditorTransactionPayload = ({ transaction, duration, ...payload } = {}) => {
			return {
				...buildEditorPayloadBase(payload),
				transaction,
				duration
			};
		};
		const emitEditorTransaction = (payload = {}) => {
			if (typeof proxy.$superdoc.config.onTransaction === "function") proxy.$superdoc.config.onTransaction(payload);
		};
		let selectionUpdateRafId = null;
		const onEditorSelectionChange = ({ editor }) => {
			if (selectionUpdateRafId != null) {
				cancelAnimationFrame(selectionUpdateRafId);
				selectionUpdateRafId = null;
			}
			if (skipSelectionUpdate.value) {
				skipSelectionUpdate.value = false;
				if (isViewingMode() && !allowSelectionInViewMode()) resetSelection();
				return;
			}
			if (isViewingMode() && !allowSelectionInViewMode()) {
				resetSelection();
				return;
			}
			selectionUpdateRafId = requestAnimationFrame(() => {
				selectionUpdateRafId = null;
				if (isViewingMode() && !allowSelectionInViewMode()) {
					resetSelection();
					return;
				}
				processSelectionChange(editor);
			});
		};
		const processSelectionChange = (editor, transaction) => {
			const { documentId } = editor.options;
			const txnSelection = transaction?.selection;
			const stateSelection = editor.state?.selection ?? editor.view?.state?.selection;
			const selectionWithPositions = txnSelection?.$from && txnSelection?.$to && txnSelection || stateSelection || txnSelection;
			if (!selectionWithPositions) return;
			const { $from, $to } = selectionWithPositions;
			if (!$from || !$to) return;
			const docSize = editor.state?.doc?.content?.size ?? editor.view?.state?.doc?.content?.size ?? Number.POSITIVE_INFINITY;
			if ($from.pos > docSize || $to.pos > docSize) {
				updateSelection({
					x: null,
					y: null,
					x2: null,
					y2: null,
					source: "super-editor"
				});
				return;
			}
			if ($from.pos === $to.pos) updateSelection({
				x: null,
				y: null,
				x2: null,
				y2: null,
				source: "super-editor"
			});
			if (!layers.value) return;
			const presentation = PresentationEditor.getInstance(documentId);
			if (!presentation) {
				const { view: view$1 } = editor;
				const safeCoordsAtPos$1 = (pos) => {
					try {
						return view$1.coordsAtPos(pos);
					} catch (err) {
						console.warn("[superdoc] Ignoring selection coords error", err);
						return null;
					}
				};
				const fromCoords$1 = safeCoordsAtPos$1($from.pos);
				const toCoords$1 = safeCoordsAtPos$1($to.pos);
				if (!fromCoords$1 || !toCoords$1) return;
				const layerBounds$1 = layers.value.getBoundingClientRect();
				const top$1 = Math.max(96, fromCoords$1.top - layerBounds$1.top);
				const bottom$1 = toCoords$1.bottom - layerBounds$1.top;
				handleSelectionChange(useSelection({
					selectionBounds: {
						top: top$1,
						left: fromCoords$1.left,
						right: toCoords$1.left,
						bottom: bottom$1
					},
					page: 1,
					documentId,
					source: "super-editor"
				}));
				return;
			}
			const layoutRange = presentation.getSelectionBounds($from.pos, $to.pos, layers.value);
			if (layoutRange) {
				const { bounds, pageIndex } = layoutRange;
				updateSelection({
					startX: bounds.left,
					startY: bounds.top,
					x: bounds.right,
					y: bounds.bottom,
					source: "super-editor"
				});
				handleSelectionChange(useSelection({
					selectionBounds: { ...bounds },
					page: pageIndex + 1,
					documentId,
					source: "super-editor"
				}));
				return;
			}
			const { view } = editor;
			const safeCoordsAtPos = (pos) => {
				try {
					return view.coordsAtPos(pos);
				} catch (err) {
					console.warn("[superdoc] Ignoring selection coords error", err);
					return null;
				}
			};
			const fromCoords = safeCoordsAtPos($from.pos);
			const toCoords = safeCoordsAtPos($to.pos);
			if (!fromCoords || !toCoords) return;
			const layerBounds = layers.value.getBoundingClientRect();
			const top = Math.max(96, fromCoords.top - layerBounds.top);
			const bottom = toCoords.bottom - layerBounds.top;
			handleSelectionChange(useSelection({
				selectionBounds: {
					top,
					left: fromCoords.left,
					right: toCoords.left,
					bottom
				},
				page: 1,
				documentId,
				source: "super-editor"
			}));
		};
		const onEditorCollaborationReady = ({ editor }) => {
			proxy.$superdoc.emit("collaboration-ready", { editor });
			nextTick(() => {
				isReady.value = true;
				const commentId = new URLSearchParams(window.location.search).get("commentId");
				if (commentId) scrollToComment(commentId);
			});
		};
		const onEditorContentError = ({ error, editor }) => {
			proxy.$superdoc.emit("content-error", {
				error,
				editor
			});
		};
		const onEditorException = (doc, { error, editor, code }) => {
			if (passwordPrompt.handleEncryptionError(doc, code, {
				error,
				editor
			})) return true;
			proxy.$superdoc.emit("exception", {
				error,
				editor,
				code,
				documentId: doc?.id
			});
			return false;
		};
		const onEditorListdefinitionsChange = (params) => {
			proxy.$superdoc.emit("list-definitions-change", params);
		};
		let suppressCommentActivationUntilTs = 0;
		const markContextMenuOpen = () => {
			suppressCommentActivationUntilTs = Date.now() + 250;
		};
		const shouldSuppressCommentActivation = () => Date.now() < suppressCommentActivationUntilTs;
		const handleDocumentContextMenu = (event) => {
			const root = superdocRoot.value;
			if (!root) return;
			if (!(event.target instanceof Node) || !root.contains(event.target)) return;
			if (layers.value?.contains(event.target)) {
				commentsStore.setActiveComment(proxy.$superdoc, null);
				commentsStore.removePendingComment(proxy.$superdoc);
				resetClickAnchor();
			}
			markContextMenuOpen();
		};
		const editorOptions = (doc) => {
			const onFontsResolvedFn = proxy.$superdoc.listeners?.("fonts-resolved")?.length > 0 ? proxy.$superdoc.listeners("fonts-resolved")[0] : null;
			const useLayoutEngine = proxy.$superdoc.config.useLayoutEngine !== false;
			const ydocFragment = doc.ydoc?.getXmlFragment?.("supereditor");
			const ydocParts = doc.ydoc?.getMap?.("parts");
			const legacyContent = (doc.ydoc?.getMap?.("meta"))?.has("docx");
			const ydocHasContent = ydocFragment && ydocFragment.length > 0 || ydocParts && ydocParts.size > 0 || legacyContent;
			const isNewFile = doc.isNewFile && !ydocHasContent;
			return {
				isDebug: proxy.$superdoc.config.isDebug || false,
				documentId: doc.id,
				user: proxy.$superdoc.user,
				users: proxy.$superdoc.users,
				colors: proxy.$superdoc.colors,
				role: proxy.$superdoc.config.role,
				html: doc.html,
				markdown: doc.markdown,
				documentMode: proxy.$superdoc.config.documentMode,
				allowSelectionInViewMode: proxy.$superdoc.config.allowSelectionInViewMode,
				rulers: doc.rulers,
				rulerContainer: proxy.$superdoc.config.rulerContainer,
				isInternal: proxy.$superdoc.config.isInternal,
				annotations: proxy.$superdoc.config.annotations,
				isCommentsEnabled: Boolean(commentsModuleConfig.value),
				isAiEnabled: proxy.$superdoc.config.modules?.ai,
				contextMenuConfig: (() => {
					if (proxy.$superdoc.config.modules?.slashMenu && !proxy.$superdoc.config.modules?.contextMenu) console.warn("[SuperDoc] modules.slashMenu is deprecated. Use modules.contextMenu instead.");
					return proxy.$superdoc.config.modules?.contextMenu ?? proxy.$superdoc.config.modules?.slashMenu;
				})(),
				slashMenuConfig: proxy.$superdoc.config.modules?.contextMenu ?? proxy.$superdoc.config.modules?.slashMenu,
				comments: {
					highlightColors: commentsModuleConfig.value?.highlightColors,
					highlightOpacity: commentsModuleConfig.value?.highlightOpacity
				},
				trackedChanges: proxy.$superdoc.config.modules?.trackChanges,
				experimental: proxy.$superdoc.config.experimental,
				editorCtor: useLayoutEngine ? PresentationEditor : void 0,
				onBeforeCreate: onEditorBeforeCreate,
				onCreate: onEditorCreate,
				onDestroy: onEditorDestroy,
				onFocus: onEditorFocus,
				onDocumentLocked: onEditorDocumentLocked,
				onUpdate: onEditorUpdate,
				onSelectionUpdate: onEditorSelectionChange,
				onCollaborationReady: onEditorCollaborationReady,
				onContentError: onEditorContentError,
				onException: (payload) => onEditorException(doc, payload),
				onCommentsLoaded,
				onCommentsUpdate: onEditorCommentsUpdate,
				onCommentLocationsUpdate: (payload) => onEditorCommentLocationsUpdate(doc, payload),
				onListDefinitionsChange: onEditorListdefinitionsChange,
				onFontsResolved: onFontsResolvedFn,
				fontAssets: proxy.$superdoc.config.fonts,
				onTransaction: onEditorTransaction,
				ydoc: doc.ydoc,
				collaborationProvider: doc.provider || null,
				isNewFile,
				password: getDocumentLoadPassword(doc),
				handleImageUpload: proxy.$superdoc.config.handleImageUpload,
				externalExtensions: proxy.$superdoc.config.editorExtensions || [],
				suppressDefaultDocxStyles: proxy.$superdoc.config.suppressDefaultDocxStyles,
				disableContextMenu: proxy.$superdoc.config.disableContextMenu,
				jsonOverride: proxy.$superdoc.config.jsonOverride,
				viewOptions: proxy.$superdoc.config.viewOptions,
				contained: proxy.$superdoc.config.contained,
				linkPopoverResolver: proxy.$superdoc.config.modules?.links?.popoverResolver,
				layoutEngineOptions: useLayoutEngine ? {
					...proxy.$superdoc.config.layoutEngineOptions || {},
					proofing: resolvedProofingConfig.value,
					debugLabel: proxy.$superdoc.config.layoutEngineOptions?.debugLabel ?? doc.name ?? doc.id,
					zoom: (activeZoom.value ?? 100) / 100,
					emitCommentPositionsInViewing: isViewingMode() && shouldRenderCommentsInViewing.value,
					enableCommentsInViewing: isViewingCommentsVisible.value,
					contentControlsChrome: proxy.$superdoc.config.modules?.contentControls?.chrome,
					resolveTrackedChangeColor: composeAuthorColorResolver(proxy.$superdoc.config.modules?.trackChanges?.authorColors)
				} : void 0,
				permissionResolver: (payload = {}) => proxy.$superdoc.canPerformPermission({
					role: proxy.$superdoc.config.role,
					isInternal: proxy.$superdoc.config.isInternal,
					...payload
				}),
				licenseKey: proxy.$superdoc.config.licenseKey,
				telemetry: proxy.$superdoc.config.telemetry?.enabled ? {
					enabled: true,
					endpoint: proxy.$superdoc.config.telemetry?.endpoint,
					metadata: proxy.$superdoc.config.telemetry?.metadata,
					licenseKey: proxy.$superdoc.config.telemetry?.licenseKey
				} : null
			};
		};
		const onEditorCommentLocationsUpdate = (doc, { allCommentIds: activeThreadId, allCommentPositions } = {}) => {
			const commentsConfig = proxy.$superdoc.config.modules?.comments;
			if (!commentsConfig || commentsConfig === false) return;
			if (!shouldRenderCommentsInViewing.value) {
				commentsStore.clearEditorCommentPositions?.();
				return;
			}
			const presentation = PresentationEditor.getInstance(doc.id);
			if (!presentation) {
				handleEditorLocationsUpdate(allCommentPositions, activeThreadId);
				flushPendingReplayTrackedChangeSync();
				return;
			}
			handleEditorLocationsUpdate(presentation.getCommentBounds(allCommentPositions, layers.value), activeThreadId);
			flushPendingReplayTrackedChangeSync();
		};
		const REPLAY_MUTABLE_COMMENT_FIELDS = new Set([
			"commentText",
			"isInternal",
			"parentCommentId",
			"trackedChangeParentId",
			"threadingParentCommentId",
			"trackedChange",
			"trackedChangeType",
			"trackedChangeText",
			"trackedChangeDisplayType",
			"trackedChangeStory",
			"trackedChangeStoryKind",
			"trackedChangeStoryLabel",
			"trackedChangeAnchorKey",
			"deletedText",
			"resolvedTime",
			"resolvedById",
			"resolvedByEmail",
			"resolvedByName",
			"importedAuthor",
			"docxCommentJSON"
		]);
		const applyReplayIsDoneResolutionFallback = (target, payload = {}) => {
			if (!target || payload.isDone === void 0) return;
			if (payload.resolvedTime != null || payload.resolvedById != null || payload.resolvedByEmail != null || payload.resolvedByName != null) return;
			if (payload.isDone) {
				target.resolvedTime = target.resolvedTime || Date.now();
				target.resolvedById = target.resolvedById || payload.creatorId || null;
				target.resolvedByEmail = target.resolvedByEmail || payload.creatorEmail || null;
				target.resolvedByName = target.resolvedByName || payload.creatorName || null;
				return;
			}
			target.resolvedTime = null;
			target.resolvedById = null;
			target.resolvedByEmail = null;
			target.resolvedByName = null;
		};
		const applyReplayUpdateToComment = (commentModel, payload, resolvedText) => {
			if (!commentModel || !payload) return;
			if (Array.isArray(payload.elements)) commentModel.docxCommentJSON = payload.elements;
			Object.entries(payload).forEach(([key, value]) => {
				if (value === void 0) return;
				if (key === "text") return;
				if (key === "elements") return;
				if (!REPLAY_MUTABLE_COMMENT_FIELDS.has(key)) return;
				commentModel[key] = value;
			});
			if (resolvedText !== void 0) commentModel.commentText = resolvedText;
			applyReplayIsDoneResolutionFallback(commentModel, payload);
		};
		const normalizeReplayCommentModelPayload = (payload = {}) => {
			const normalizedPayload = { ...payload };
			if (!normalizedPayload.commentText && normalizedPayload.text) normalizedPayload.commentText = normalizedPayload.text;
			if (!normalizedPayload.docxCommentJSON && Array.isArray(normalizedPayload.elements)) normalizedPayload.docxCommentJSON = normalizedPayload.elements;
			applyReplayIsDoneResolutionFallback(normalizedPayload, normalizedPayload);
			return normalizedPayload;
		};
		const syncInstantSidebarAlignmentFromEditorSelection = (commentId) => {
			if (Number.isFinite(peekInstantSidebarAlignment())) return;
			if (commentId == null) {
				clearInstantSidebarAlignment();
				return;
			}
			const layersElement = layers.value;
			const { entry } = resolveCommentPositionEntry(commentId);
			const targetClientY = getVisibleThreadAnchorClientY(layersElement, entry);
			if (Number.isFinite(targetClientY)) {
				requestInstantSidebarAlignment(targetClientY, commentId);
				return;
			}
			clearInstantSidebarAlignment();
		};
		const isSameActiveCommentSelection = (commentId) => {
			if (commentId == null || activeComment.value == null) return false;
			return String(activeComment.value) === String(commentId);
		};
		const onEditorCommentsUpdate = (params = {}) => {
			let { activeCommentId, type, comment: commentPayload } = params;
			let shouldSyncActiveComment = Object.prototype.hasOwnProperty.call(params, "activeCommentId");
			const resolveCommentEventIds = (payload) => {
				const ids = [payload?.importedId, payload?.commentId].filter(Boolean).map((value) => String(value));
				return [...new Set(ids)];
			};
			const resolveDocumentScopedCommentMatch = (payload) => {
				const candidateIds = [payload?.importedId, payload?.commentId].filter(Boolean).map((value) => String(value));
				const activeDocumentId = proxy.$superdoc?.activeEditor?.options?.documentId != null ? String(proxy.$superdoc.activeEditor.options.documentId) : null;
				for (const candidateId of candidateIds) {
					const existingComment = commentsList.value.find((comment) => {
						const commentId = comment?.commentId != null ? String(comment.commentId) : null;
						const importedId = comment?.importedId != null ? String(comment.importedId) : null;
						if (!(commentId === candidateId || importedId === candidateId)) return false;
						if (!activeDocumentId || typeof belongsToDocument !== "function") return true;
						return belongsToDocument(comment, activeDocumentId);
					});
					if (existingComment) {
						const matchedCommentId = existingComment?.commentId ?? existingComment?.importedId ?? candidateId;
						return {
							id: matchedCommentId != null ? String(matchedCommentId) : null,
							existingComment
						};
					}
				}
				return {
					id: candidateIds[0] || null,
					existingComment: null
				};
			};
			if (type === "replayCompleted") scheduleReplayTrackedChangeSync();
			if (COMMENT_EVENTS?.ADD && type === COMMENT_EVENTS.ADD && commentPayload) {
				commentPayload = normalizeReplayCommentModelPayload(commentPayload);
				const currentUser = proxy.$superdoc?.user;
				if (currentUser) {
					if (!commentPayload.creatorId) commentPayload.creatorId = currentUser.id;
					if (!commentPayload.creatorName) commentPayload.creatorName = currentUser.name;
					if (!commentPayload.creatorEmail) commentPayload.creatorEmail = currentUser.email;
				}
				if (!commentPayload.createdTime) commentPayload.createdTime = Date.now();
				const primaryDocumentId = commentPayload.documentId || documents.value?.[0]?.id;
				if (!commentPayload.documentId && primaryDocumentId) commentPayload.documentId = primaryDocumentId;
				if (!commentPayload.fileId && primaryDocumentId) commentPayload.fileId = primaryDocumentId;
				const { id, existingComment } = resolveDocumentScopedCommentMatch(commentPayload);
				if (id && !existingComment) {
					const commentModel = useComment(commentPayload);
					addComment({
						superdoc: proxy.$superdoc,
						comment: commentModel,
						skipEditorUpdate: true
					});
				}
			}
			if (COMMENT_EVENTS?.UPDATE && type === COMMENT_EVENTS.UPDATE && commentPayload) {
				const { id, existingComment } = resolveDocumentScopedCommentMatch(commentPayload);
				if (id) {
					const resolvedText = commentPayload.commentText || commentPayload.text;
					if (existingComment) applyReplayUpdateToComment(existingComment, commentPayload, resolvedText);
					else {
						const commentModel = useComment(normalizeReplayCommentModelPayload(commentPayload));
						addComment({
							superdoc: proxy.$superdoc,
							comment: commentModel,
							skipEditorUpdate: true
						});
					}
				}
			}
			if (COMMENT_EVENTS?.DELETED && type === COMMENT_EVENTS.DELETED && commentPayload) {
				const targetIds = resolveCommentEventIds(commentPayload);
				if (targetIds.length) {
					const activeDocumentId = proxy.$superdoc?.activeEditor?.options?.documentId != null ? String(proxy.$superdoc.activeEditor.options.documentId) : null;
					const isInActiveDocument = (comment) => {
						if (!activeDocumentId || typeof belongsToDocument !== "function") return true;
						return belongsToDocument(comment, activeDocumentId);
					};
					const removedCommentIds = /* @__PURE__ */ new Set();
					commentsList.value.forEach((comment) => {
						if (!isInActiveDocument(comment)) return;
						const commentId = comment.commentId != null ? String(comment.commentId) : null;
						const importedId = comment.importedId != null ? String(comment.importedId) : null;
						if (!(commentId && targetIds.includes(commentId) || importedId && targetIds.includes(importedId))) return;
						if (commentId) removedCommentIds.add(commentId);
						if (importedId) removedCommentIds.add(importedId);
					});
					if (removedCommentIds.size) {
						let expanded = true;
						while (expanded) {
							expanded = false;
							commentsList.value.forEach((comment) => {
								if (!isInActiveDocument(comment)) return;
								const commentId = comment.commentId != null ? String(comment.commentId) : null;
								const importedId = comment.importedId != null ? String(comment.importedId) : null;
								const parentCommentId = comment.parentCommentId != null ? String(comment.parentCommentId) : null;
								const trackedChangeParentId = comment.trackedChangeParentId != null ? String(comment.trackedChangeParentId) : null;
								const isRemovedComment = commentId && removedCommentIds.has(commentId) || importedId && removedCommentIds.has(importedId);
								const isDescendantOfRemovedComment = parentCommentId && removedCommentIds.has(parentCommentId) || trackedChangeParentId && removedCommentIds.has(trackedChangeParentId);
								if (!isRemovedComment && !isDescendantOfRemovedComment) return;
								const sizeBefore = removedCommentIds.size;
								if (commentId) removedCommentIds.add(commentId);
								if (importedId) removedCommentIds.add(importedId);
								if (removedCommentIds.size > sizeBefore) expanded = true;
							});
						}
						const previousComments = [...commentsList.value];
						commentsList.value = commentsList.value.filter((comment) => {
							if (!isInActiveDocument(comment)) return true;
							const commentId = comment.commentId != null ? String(comment.commentId) : null;
							const importedId = comment.importedId != null ? String(comment.importedId) : null;
							return !(commentId && removedCommentIds.has(commentId) || importedId && removedCommentIds.has(importedId));
						});
						const activeCommentKey = activeComment.value != null ? String(activeComment.value) : null;
						const activeCommentModel = activeCommentKey != null ? previousComments.find((comment) => {
							const commentId = comment.commentId != null ? String(comment.commentId) : null;
							const importedId = comment.importedId != null ? String(comment.importedId) : null;
							return commentId === activeCommentKey || importedId === activeCommentKey;
						}) : null;
						const activeCommentInActiveDocument = activeCommentModel ? isInActiveDocument(activeCommentModel) : false;
						if (activeCommentKey && removedCommentIds.has(activeCommentKey) && activeCommentInActiveDocument) {
							activeCommentId = null;
							shouldSyncActiveComment = true;
						}
					}
				}
			}
			if (type === "trackedChange") handleTrackedChangeUpdate({
				superdoc: proxy.$superdoc,
				params
			});
			if (shouldSyncActiveComment && activeCommentId != null && shouldSuppressCommentActivation()) shouldSyncActiveComment = false;
			if (shouldSyncActiveComment && (activeCommentId == null || !isSameActiveCommentSelection(activeCommentId))) syncInstantSidebarAlignmentFromEditorSelection(activeCommentId);
			nextTick(() => {
				if (pendingComment.value) return;
				if (shouldSyncActiveComment) commentsStore.setActiveComment(proxy.$superdoc, activeCommentId);
				if (shouldSyncActiveComment) {
					isCommentHighlighted.value = true;
					setTimeout(() => {
						isCommentHighlighted.value = false;
					}, 0);
				}
			});
			if (typeof proxy.$superdoc.config.onCommentsUpdate === "function") proxy.$superdoc.config.onCommentsUpdate(params);
		};
		const isHistoryUndoRedoInput = (inputType) => inputType === "historyUndo" || inputType === "historyRedo";
		const isCollaborationReplayTransaction = (transaction, ySyncMeta) => {
			return Boolean(transaction?.docChanged && ySyncMeta?.isChangeOrigin);
		};
		const isPeerCollaborationReplayTransaction = (transaction, ySyncMeta) => {
			const inputType = transaction?.getMeta?.("inputType");
			return isCollaborationReplayTransaction(transaction, ySyncMeta) && !isHistoryUndoRedoInput(inputType) && !Boolean(ySyncMeta?.isUndoRedoOperation);
		};
		const shouldResyncTrackedChangeThreads = (transaction, ySyncMeta = transaction?.getMeta?.(ySyncPluginKey)) => {
			const inputType = transaction?.getMeta?.("inputType");
			const isLocalHistoryUndoRedo = isHistoryUndoRedoInput(inputType);
			const isLocalCollabUndoRedo = Boolean(ySyncMeta?.isUndoRedoOperation);
			return isLocalHistoryUndoRedo || isLocalCollabUndoRedo || isCollaborationReplayTransaction(transaction, ySyncMeta);
		};
		const collectTouchedChangeIds = (transaction) => {
			return collectTouchedTrackedChangeIds(transaction, { trackChangesPluginKey: TrackChangesBasePluginKey });
		};
		const onEditorTransaction = (payload = {}) => {
			const { editor, transaction } = payload;
			const ySyncMeta = transaction?.getMeta?.(ySyncPluginKey);
			if (shouldResyncTrackedChangeThreads(transaction, ySyncMeta)) {
				const documentId = editor?.options?.documentId;
				commentsStore.syncResolvedCommentsWithDocument?.({
					documentId,
					editor
				});
				syncTrackedChangePositionsWithDocument({
					documentId,
					editor
				});
				queueTrackedChangeCommentResync({
					editor,
					broadcastChanges: !isPeerCollaborationReplayTransaction(transaction, ySyncMeta)
				});
			} else if (transactionTouchesStructuralChange(transaction)) queueTrackedChangeCommentResync({ editor });
			else queueTrackedChangeCommentResync({
				editor,
				changeIds: collectTouchedChangeIds(transaction)
			});
			emitEditorTransaction(buildEditorTransactionPayload(payload));
		};
		const isCommentsEnabled = computed(() => Boolean(commentsModuleConfig.value));
		const shouldUseSidebarComments = computed(() => {
			const displayMode = commentsModuleConfig.value?.displayMode ?? "sidebar";
			if (!VALID_COMMENTS_DISPLAY_MODES.has(displayMode)) return true;
			if (displayMode === "sidebar") return true;
			if (displayMode === "inline") return false;
			if (displayMode !== "auto") return true;
			return !isCompactCommentsMode.value;
		});
		const showCommentsSidebar = computed(() => {
			if (!shouldRenderCommentsInViewing.value) return false;
			if (!shouldUseSidebarComments.value) return false;
			return pendingComment.value || floatingComments.value.length > 0 && isReady.value && layers.value && isCommentsEnabled.value && !isCommentsListVisible.value;
		});
		const activeCompactComment = computed(() => {
			if (showCommentsSidebar.value) return null;
			if (!isCommentsEnabled.value) return null;
			if (pendingComment.value) return pendingComment.value;
			if (!activeComment.value) return null;
			return getComment(activeComment.value) ?? null;
		});
		const { compactCommentPopoverStyle, closeCompactCommentPopover, resetClickAnchor } = useCompactCommentPopover({
			activeComment,
			pendingComment,
			activeCompactComment,
			showCommentsSidebar,
			superdocRoot,
			layers,
			documents,
			resolveCommentPositionEntry,
			selectionPosition,
			activeZoom,
			clearActiveComment: () => commentsStore.setActiveComment(proxy.$superdoc, null),
			clearPendingComment: () => commentsStore.removePendingComment(proxy.$superdoc)
		});
		const showToolsFloatingMenu = computed(() => {
			if (!isCommentsEnabled.value) return false;
			return selectionPosition.value && toolsMenuPosition.top && !getConfig.value?.readOnly;
		});
		computed(() => {
			if (!isCommentsEnabled.value) return false;
			return !getConfig.value?.readOnly && selectionPosition.value;
		});
		watch(showCommentsSidebar, (value) => {
			proxy.$superdoc.broadcastSidebarToggle(value);
		});
		useViewportFit({
			getSuperdoc: () => proxy.$superdoc,
			superdocContainerWidth,
			isReady,
			activeZoom,
			zoomMode,
			viewportMetrics,
			showCommentsSidebar,
			rightSidebarRef,
			superdocRoot,
			documents
		});
		const scrollToComment = (commentId) => {
			proxy.$superdoc.scrollToComment(commentId);
		};
		onMounted(() => {
			const config = commentsModuleConfig.value;
			if (config && !config.readOnly) document.addEventListener("mousedown", handleDocumentMouseDown);
			document.addEventListener("contextmenu", handleDocumentContextMenu, true);
			document.addEventListener("keydown", handleDocumentShortcut, true);
			document.addEventListener("focusin", handleRuntimeFocusIn, true);
			document.addEventListener("pointerdown", handleRuntimePointerDown, true);
			document.addEventListener("mousedown", handleRuntimeMouseDown, true);
			recalculateCompactCommentsMode();
			ensureCompactMeasurementObserver();
		});
		function isFindShortcutEvent(e) {
			return (e.metaKey || e.ctrlKey) && !e.altKey && e.key?.toLowerCase?.() === "f";
		}
		function isFormattingMarksShortcutEvent(e) {
			return (e.metaKey || e.ctrlKey) && e.shiftKey && !e.altKey && (e.code === "Digit8" || e.key === "8" || e.key === "*");
		}
		function isFocusInsideSuperDoc() {
			const root = superdocRoot.value;
			const activeElement = document.activeElement;
			if (!(activeElement instanceof Node)) return false;
			if (root?.contains(activeElement)) return true;
			const activeEditorDom = proxy.$superdoc?.activeEditor?.view?.dom;
			return activeEditorDom instanceof Node && (activeElement === activeEditorDom || activeEditorDom.contains?.(activeElement));
		}
		function handleFindShortcut(e) {
			if (!isFindShortcutEvent(e)) return;
			if (!isFindReplaceEnabled.value) return;
			if (!isFocusInsideSuperDoc()) return;
			if (!findReplace.wouldOpen()) return;
			e.preventDefault();
			e.stopPropagation();
			findReplace.open();
		}
		function handleFormattingMarksShortcut(e) {
			if (!isFormattingMarksShortcutEvent(e)) return;
			if (!isFocusInsideSuperDoc()) return;
			e.preventDefault();
			e.stopPropagation();
			proxy.$superdoc.toggleFormattingMarks?.();
		}
		function handleDocumentShortcut(e) {
			if (e.key === "Escape" && activeCompactComment.value) {
				e.preventDefault();
				e.stopPropagation();
				closeCompactCommentPopover();
				return;
			}
			handleFindShortcut(e);
			if (e.defaultPrevented) return;
			handleFormattingMarksShortcut(e);
		}
		function handleContainerKeydown(e) {
			handleFindShortcut(e);
			if (e.defaultPrevented) return;
			handleFormattingMarksShortcut(e);
		}
		onBeforeUnmount(() => {
			passwordPrompt.destroy();
			findReplace.destroy();
			for (const entry of Array.from(v1Runtimes.values())) entry.adapter.runtime.dispose();
			v1Runtimes.clear();
			subDocumentRoots.clear();
			document.removeEventListener("mousedown", handleDocumentMouseDown);
			document.removeEventListener("contextmenu", handleDocumentContextMenu, true);
			document.removeEventListener("keydown", handleDocumentShortcut, true);
			document.removeEventListener("focusin", handleRuntimeFocusIn, true);
			document.removeEventListener("pointerdown", handleRuntimePointerDown, true);
			document.removeEventListener("mousedown", handleRuntimeMouseDown, true);
			if (selectionUpdateRafId != null) {
				cancelAnimationFrame(selectionUpdateRafId);
				selectionUpdateRafId = null;
			}
		});
		const selectionLayer = ref(null);
		const isDragging = ref(false);
		const getSelectionPosition = computed(() => {
			if (!selectionPosition.value || selectionPosition.value.source === "super-editor") return {
				x: null,
				y: null
			};
			const zoom = selectionPosition.value.source === "pdf" ? (activeZoom.value ?? 100) / 100 : 1;
			const top = selectionPosition.value.top * zoom;
			const left = selectionPosition.value.left * zoom;
			const right = selectionPosition.value.right * zoom;
			const bottom = selectionPosition.value.bottom * zoom;
			return {
				zIndex: 500,
				borderRadius: "4px",
				top: top + "px",
				left: left + "px",
				height: Math.abs(top - bottom) + "px",
				width: Math.abs(left - right) + "px"
			};
		});
		const handleSelectionChange = (selection) => {
			if (isViewingMode() && !allowSelectionInViewMode()) {
				resetSelection();
				return;
			}
			if (!selection.selectionBounds || !isCommentsEnabled.value) return;
			resetSelection();
			const isMobileView = window.matchMedia("(max-width: 768px)").matches;
			updateSelection({
				startX: selection.selectionBounds.left,
				startY: selection.selectionBounds.top,
				x: selection.selectionBounds.right,
				y: selection.selectionBounds.bottom,
				source: selection.source
			});
			if (!selectionPosition.value) return;
			const selectionIsWideEnough = Math.abs(selectionPosition.value.left - selectionPosition.value.right) > 5;
			const selectionIsTallEnough = Math.abs(selectionPosition.value.top - selectionPosition.value.bottom) > 5;
			if (!selectionIsWideEnough || !selectionIsTallEnough) {
				selectionLayer.value.style.pointerEvents = "none";
				resetSelection();
				return;
			}
			activeSelection.value = selection;
			const zoom = selection.source === "pdf" || selection.source?.value === "pdf" ? (activeZoom.value ?? 100) / 100 : 1;
			toolsMenuPosition.top = selection.selectionBounds.top * zoom + "px";
			toolsMenuPosition.right = isMobileView ? "0" : "-25px";
		};
		const resetSelection = () => {
			selectionPosition.value = null;
			toolsMenuPosition.top = null;
		};
		const updateSelection = ({ startX, startY, x, y, source, page }) => {
			if (!(typeof startX === "number" || typeof startY === "number") && !(typeof x === "number" || typeof y === "number")) {
				resetSelection();
				return;
			}
			if (!selectionPosition.value) {
				if (startY == null || startX == null) return;
				selectionPosition.value = {
					top: startY,
					left: startX,
					right: startX,
					bottom: startY,
					startX,
					startY,
					source,
					page: page ?? null
				};
			}
			if (typeof startX === "number") selectionPosition.value.startX = startX;
			if (typeof startY === "number") selectionPosition.value.startY = startY;
			if (typeof y === "number") if (y < selectionPosition.value.startY) selectionPosition.value.top = y;
			else selectionPosition.value.bottom = y;
			if (typeof x === "number") if (x < selectionPosition.value.startX) selectionPosition.value.left = x;
			else selectionPosition.value.right = x;
		};
		const getPdfPageNumberFromEvent = (event) => {
			const x = event?.clientX;
			const y = event?.clientY;
			if (typeof x !== "number" || typeof y !== "number") return null;
			const pageEl = document.elementsFromPoint(x, y).find((el) => el?.dataset?.pdfPage != null);
			if (pageEl) {
				const pageNumber = Number(pageEl.dataset?.pageNumber);
				return Number.isFinite(pageNumber) ? pageNumber : null;
			}
			return null;
		};
		const handleSelectionStart = (e) => {
			resetSelection();
			selectionLayer.value.style.pointerEvents = "auto";
			nextTick(() => {
				isDragging.value = true;
				selectionLayer.value.style.pointerEvents = "none";
				const pageNumber = getPdfPageNumberFromEvent(e);
				selectionLayer.value.style.pointerEvents = "auto";
				if (!pageNumber) {
					isDragging.value = false;
					selectionLayer.value.style.pointerEvents = "none";
					return;
				}
				const layerBounds = selectionLayer.value.getBoundingClientRect();
				const zoom = activeZoom.value / 100;
				updateSelection({
					startX: (e.clientX - layerBounds.left) / zoom,
					startY: (e.clientY - layerBounds.top) / zoom,
					page: pageNumber,
					source: "pdf"
				});
				selectionLayer.value.addEventListener("mousemove", handleDragMove);
			});
		};
		const handleDragMove = (e) => {
			if (!isDragging.value) return;
			const layerBounds = selectionLayer.value.getBoundingClientRect();
			const zoom = activeZoom.value / 100;
			updateSelection({
				x: (e.clientX - layerBounds.left) / zoom,
				y: (e.clientY - layerBounds.top) / zoom
			});
		};
		const handleDragEnd = (e) => {
			if (!isDragging.value) return;
			selectionLayer.value.removeEventListener("mousemove", handleDragMove);
			if (!selectionPosition.value) return;
			const pageNumber = selectionPosition.value.page ?? getPdfPageNumberFromEvent(e);
			handleSelectionChange(useSelection({
				selectionBounds: {
					top: selectionPosition.value.top,
					left: selectionPosition.value.left,
					right: selectionPosition.value.right,
					bottom: selectionPosition.value.bottom
				},
				page: pageNumber ?? 1,
				documentId: documents.value[0].id,
				source: "pdf"
			}));
			selectionLayer.value.style.pointerEvents = "none";
		};
		const shouldShowSelection = computed(() => {
			const config = proxy.$superdoc.config.modules?.comments;
			if (!config || config === false) return false;
			return !config.readOnly;
		});
		const handleSuperEditorPageMarginsChange = (doc, params) => {
			doc.documentMarginsLastChange = params.pageMargins;
		};
		const handlePdfClick = (e) => {
			if (!isCommentsEnabled.value) return;
			resetSelection();
			isDragging.value = true;
			handleSelectionStart(e);
		};
		const handlePdfSelectionRaw = ({ selectionBounds, documentId, page }) => {
			if (!selectionBounds || !documentId) return;
			handleSelectionChange(useSelection({
				selectionBounds,
				documentId,
				page,
				source: "pdf"
			}));
		};
		const applyFallbackZoomStyles = (zoomFactor) => {
			(layers.value?.querySelectorAll(".superdoc__sub-document"))?.forEach((el) => {
				if (el.querySelector(".sd-pdf-viewer")) return;
				if (zoomFactor === 1) {
					el.style.transformOrigin = "";
					el.style.transform = "";
					el.style.width = "";
				} else {
					el.style.transformOrigin = "top left";
					el.style.transform = `scale(${zoomFactor})`;
					el.style.width = `${100 / zoomFactor}%`;
				}
			});
		};
		let initialFallbackZoomApplied = false;
		const ensureInitialFallbackZoom = () => {
			if (initialFallbackZoomApplied) return;
			if (proxy.$superdoc.config.useLayoutEngine !== false) return;
			const zoomFactor = (activeZoom.value ?? 100) / 100;
			if (zoomFactor === 1) return;
			initialFallbackZoomApplied = true;
			nextTick(() => applyFallbackZoomStyles(zoomFactor));
		};
		watch(() => activeZoom.value, (zoom) => {
			const zoomFactor = (zoom ?? 100) / 100;
			if (proxy.$superdoc.config.useLayoutEngine !== false) PresentationEditor.setGlobalZoom(zoomFactor);
			else {
				initialFallbackZoomApplied = true;
				applyFallbackZoomStyles(zoomFactor);
			}
			getPDFViewer()?.updateScale(zoomFactor);
			nextTick(() => {
				updateWhiteboardPageSizes();
				updateWhiteboardPageOffsets();
			});
		});
		watch(floatingComments, () => {
			if (!hasInitializedLocations.value) hasInitializedLocations.value = true;
		});
		const { whiteboardModuleConfig, whiteboard, whiteboardPages, whiteboardPageSizes, whiteboardPageOffsets, whiteboardEnabled, whiteboardOpacity, handleWhiteboardPageReady, updateWhiteboardPageSizes, updateWhiteboardPageOffsets } = useWhiteboard({
			proxy,
			layers,
			documents,
			modules
		});
		const getPDFViewer = () => {
			return Array.isArray(pdfViewerRef.value) ? pdfViewerRef.value[0] : pdfViewerRef.value;
		};
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "superdocRoot",
				ref: superdocRoot,
				class: normalizeClass(["superdoc", {
					"superdoc--with-sidebar": showCommentsSidebar.value,
					"superdoc--web-layout": unref(proxy).$superdoc.config.viewOptions?.layout === "web",
					"superdoc--contained": unref(proxy).$superdoc.config.contained,
					"high-contrast": unref(isHighContrastMode$1)
				}]),
				style: normalizeStyle(superdocStyleVars.value),
				onKeydown: handleContainerKeydown
			}, [
				createElementVNode("div", {
					class: "superdoc__layers layers",
					ref_key: "layers",
					ref: layers,
					role: "group"
				}, [showToolsFloatingMenu.value ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "superdoc__tools tools",
					style: normalizeStyle(toolsMenuPosition)
				}, [createElementVNode("div", {
					class: "tools-item",
					"data-id": "is-tool",
					onMousedown: _cache[0] || (_cache[0] = withModifiers(($event) => handleToolClick("comments"), ["stop", "prevent"]))
				}, [createElementVNode("div", {
					class: "superdoc__tools-icon",
					innerHTML: unref(superdocIcons).comment
				}, null, 8, _hoisted_1)], 32), unref(proxy).$superdoc.config.modules.ai ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "tools-item",
					"data-id": "is-tool",
					onMousedown: _cache[1] || (_cache[1] = withModifiers(($event) => handleToolClick("ai"), ["stop", "prevent"]))
				}, [..._cache[4] || (_cache[4] = [createElementVNode("div", { class: "superdoc__tools-icon ai-tool" }, null, -1)])], 32)) : createCommentVNode("", true)], 4)) : createCommentVNode("", true), createElementVNode("div", _hoisted_2, [
					isCommentsEnabled.value ? (openBlock(), createElementBlock("div", {
						key: 0,
						class: "superdoc__selection-layer selection-layer",
						onMousedown: handleSelectionStart,
						onMouseup: handleDragEnd,
						ref_key: "selectionLayer",
						ref: selectionLayer
					}, [unref(selectionPosition) && shouldShowSelection.value ? (openBlock(), createElementBlock("div", {
						key: 0,
						style: normalizeStyle(getSelectionPosition.value),
						class: "superdoc__temp-selection temp-selection sd-highlight sd-initial-highlight"
					}, null, 4)) : createCommentVNode("", true)], 544)) : createCommentVNode("", true),
					"hrbr-fields" in unref(modules) && layers.value ? (openBlock(), createBlock(HrbrFieldsLayer_default, {
						key: 1,
						fields: unref(modules)["hrbr-fields"],
						class: "superdoc__comments-layer comments-layer",
						style: { "z-index": "2" },
						ref_key: "hrbrFieldsLayer",
						ref: hrbrFieldsLayer
					}, null, 8, ["fields"])) : createCommentVNode("", true),
					layers.value ? (openBlock(), createBlock(CommentsLayer_default, {
						key: 2,
						class: "superdoc__comments-layer comments-layer",
						style: { "z-index": "3" },
						ref_key: "commentsLayer",
						ref: commentsLayer,
						parent: layers.value,
						user: unref(user),
						onHighlightClick: handleHighlightClick
					}, null, 8, ["parent", "user"])) : createCommentVNode("", true),
					unref(showAiLayer) ? (openBlock(), createBlock(AiLayer_default, {
						key: 3,
						class: "ai-layer",
						style: { "z-index": "4" },
						ref_key: "aiLayer",
						ref: aiLayer,
						editor: unref(proxy).$superdoc.activeEditor
					}, null, 8, ["editor"])) : createCommentVNode("", true),
					layers.value && unref(whiteboardModuleConfig) ? (openBlock(), createBlock(WhiteboardLayer_default, {
						key: 4,
						style: { "z-index": "3" },
						whiteboard: unref(whiteboard),
						pages: unref(whiteboardPages),
						"page-sizes": unref(whiteboardPageSizes),
						"page-offsets": unref(whiteboardPageOffsets),
						enabled: unref(whiteboardEnabled),
						opacity: unref(whiteboardOpacity)
					}, null, 8, [
						"whiteboard",
						"pages",
						"page-sizes",
						"page-offsets",
						"enabled",
						"opacity"
					])) : createCommentVNode("", true),
					(openBlock(true), createElementBlock(Fragment, null, renderList(unref(documents), (doc) => {
						return openBlock(), createElementBlock("div", {
							class: "superdoc__sub-document sub-document",
							key: `${doc.id}:${doc.editorMountNonce}`,
							ref_for: true,
							ref: (el) => setSubDocumentRoot(doc, el)
						}, [
							doc.type === unref("application/pdf") ? (openBlock(), createBlock(unref(PdfViewer), {
								key: 0,
								file: doc.data,
								"file-id": doc.id,
								"initial-scale": (unref(activeZoom) ?? 100) / 100,
								config: unref(pdfConfig),
								onSelectionRaw: handlePdfSelectionRaw,
								onBypassSelection: handlePdfClick,
								onPageRendered: unref(handleWhiteboardPageReady),
								onDocumentReady: _cache[2] || (_cache[2] = ({ documentId, viewerContainer }) => handleDocumentReady(documentId, viewerContainer)),
								ref_for: true,
								ref_key: "pdfViewerRef",
								ref: pdfViewerRef
							}, null, 8, [
								"file",
								"file-id",
								"initial-scale",
								"config",
								"onPageRendered"
							])) : createCommentVNode("", true),
							doc.type === unref("application/vnd.openxmlformats-officedocument.wordprocessingml.document") ? (openBlock(), createBlock(unref(SuperEditor_default), {
								key: 1,
								"file-source": doc.data,
								state: doc.state,
								"document-id": doc.id,
								options: {
									...editorOptions(doc),
									rulers: doc.rulers
								},
								onEditorReady,
								onPageMarginsChange: ($event) => handleSuperEditorPageMarginsChange(doc, $event)
							}, null, 8, [
								"file-source",
								"state",
								"document-id",
								"options",
								"onPageMarginsChange"
							])) : createCommentVNode("", true),
							doc.type === unref("text/html") ? (openBlock(), createBlock(HtmlViewer_default, {
								key: 2,
								onReady: _cache[3] || (_cache[3] = (id) => handleDocumentReady(id, null)),
								onSelectionChange: handleSelectionChange,
								"file-source": doc.data,
								"document-id": doc.id
							}, null, 8, ["file-source", "document-id"])) : createCommentVNode("", true)
						]);
					}), 128))
				])], 512),
				showCommentsSidebar.value ? (openBlock(), createElementBlock("div", {
					key: 0,
					ref_key: "rightSidebarRef",
					ref: rightSidebarRef,
					class: "superdoc__right-sidebar right-sidebar"
				}, [createElementVNode("div", _hoisted_3, [unref(hasInitializedLocations) && (floatingComments.value.length > 0 || unref(pendingComment)) ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(unref(documentsWithConverations), (doc) => {
					return openBlock(), createBlock(FloatingComments_default, {
						parent: layers.value,
						"current-document": doc
					}, null, 8, ["parent", "current-document"]);
				}), 256)) : createCommentVNode("", true)])], 512)) : createCommentVNode("", true),
				activeCompactComment.value ? (openBlock(), createElementBlock("div", {
					key: 1,
					class: "superdoc__compact-comment-popover",
					style: normalizeStyle(unref(compactCommentPopoverStyle))
				}, [createVNode(CommentDialog_default, {
					comment: activeCompactComment.value,
					parent: layers.value
				}, null, 8, ["comment", "parent"])], 4)) : createCommentVNode("", true),
				unref(showAiWriter) ? (openBlock(), createElementBlock("div", {
					key: 2,
					class: "ai-writer-container",
					style: normalizeStyle(unref(aiWriterPosition))
				}, [createVNode(unref(AIWriter_default), {
					"selected-text": unref(selectedText),
					"handle-close": unref(handleAiWriterClose),
					editor: unref(proxy).$superdoc.activeEditor,
					"api-key": unref(proxy).$superdoc.toolbar?.config?.aiApiKey,
					endpoint: unref(proxy).$superdoc.config?.modules?.ai?.endpoint
				}, null, 8, [
					"selected-text",
					"handle-close",
					"editor",
					"api-key",
					"endpoint"
				])], 4)) : createCommentVNode("", true),
				createVNode(SurfaceHost_default, { "geometry-target": layers.value }, null, 8, ["geometry-target"])
			], 38);
		};
	}
}, [["__scopeId", "data-v-957c6f8e"]]);
var PINIA_DEVTOOLS_SETUP_EVENT = "devtools-plugin:setup";
var PINIA_DEVTOOLS_PLUGIN_ID = "dev.esm.pinia";
var piniaDevtoolsSuppressionState = {
	disabledAppRefCounts: /* @__PURE__ */ new Map(),
	hook: null,
	originalHookEmit: null,
	isHookPropertyPatched: false,
	originalHookPropertyDescriptor: null,
	hookPropertyValue: void 0,
	isQueuePropertyPatched: false,
	originalQueuePropertyDescriptor: null,
	queuePropertyValue: void 0,
	queue: null,
	originalQueuePush: null
};
var isPiniaDevtoolsSetupForSuppressedApp = (event, descriptor) => event === PINIA_DEVTOOLS_SETUP_EVENT && descriptor?.id === PINIA_DEVTOOLS_PLUGIN_ID && descriptor?.app && piniaDevtoolsSuppressionState.disabledAppRefCounts.has(descriptor.app);
var isPiniaDevtoolsQueueEntryForSuppressedApp = (entry) => Array.isArray(entry) && isPiniaDevtoolsSetupForSuppressedApp(PINIA_DEVTOOLS_SETUP_EVENT, entry[0]);
var setDevtoolsQueueValue = (value) => {
	if (piniaDevtoolsSuppressionState.isQueuePropertyPatched) {
		piniaDevtoolsSuppressionState.queuePropertyValue = value;
		return;
	}
	globalThis.__VUE_DEVTOOLS_PLUGINS__ = value;
};
var purgeDevtoolsPluginQueueForApp = (app) => {
	const queue = globalThis.__VUE_DEVTOOLS_PLUGINS__;
	if (!Array.isArray(queue)) return;
	for (let i = queue.length - 1; i >= 0; i--) {
		const [descriptor] = queue[i];
		if (descriptor?.id === PINIA_DEVTOOLS_PLUGIN_ID && descriptor?.app === app) queue.splice(i, 1);
	}
};
var restoreDevtoolsQueuePushPatch = () => {
	const { queue, originalQueuePush } = piniaDevtoolsSuppressionState;
	if (queue && typeof originalQueuePush === "function") queue.push = originalQueuePush;
	piniaDevtoolsSuppressionState.queue = null;
	piniaDevtoolsSuppressionState.originalQueuePush = null;
};
var restoreDevtoolsHookEmitPatch = () => {
	const { hook, originalHookEmit } = piniaDevtoolsSuppressionState;
	if (hook && typeof originalHookEmit === "function") hook.emit = originalHookEmit;
	piniaDevtoolsSuppressionState.hook = null;
	piniaDevtoolsSuppressionState.originalHookEmit = null;
};
var ensureDevtoolsQueuePushPatched = () => {
	const existingQueue = globalThis.__VUE_DEVTOOLS_PLUGINS__;
	if (existingQueue == null) {
		setDevtoolsQueueValue([]);
		ensureDevtoolsQueuePushPatched();
		return;
	}
	if (!Array.isArray(existingQueue)) return;
	const queue = existingQueue;
	if (piniaDevtoolsSuppressionState.queue === queue) return;
	restoreDevtoolsQueuePushPatch();
	const originalQueuePush = queue.push;
	if (typeof originalQueuePush !== "function") return;
	piniaDevtoolsSuppressionState.queue = queue;
	piniaDevtoolsSuppressionState.originalQueuePush = originalQueuePush;
	queue.push = function patchedQueuePush(...entries) {
		const retainedEntries = entries.filter((entry) => !isPiniaDevtoolsQueueEntryForSuppressedApp(entry));
		if (retainedEntries.length === 0) return this.length;
		return originalQueuePush.apply(this, retainedEntries);
	};
};
var ensureDevtoolsQueueAssignmentPatched = () => {
	if (piniaDevtoolsSuppressionState.isQueuePropertyPatched) {
		ensureDevtoolsQueuePushPatched();
		return;
	}
	const queueDescriptor = Object.getOwnPropertyDescriptor(globalThis, "__VUE_DEVTOOLS_PLUGINS__");
	if (queueDescriptor?.configurable === false) {
		ensureDevtoolsQueuePushPatched();
		return;
	}
	piniaDevtoolsSuppressionState.originalQueuePropertyDescriptor = queueDescriptor ?? null;
	piniaDevtoolsSuppressionState.queuePropertyValue = globalThis.__VUE_DEVTOOLS_PLUGINS__;
	Object.defineProperty(globalThis, "__VUE_DEVTOOLS_PLUGINS__", {
		configurable: true,
		enumerable: queueDescriptor?.enumerable ?? true,
		get() {
			return piniaDevtoolsSuppressionState.queuePropertyValue;
		},
		set(value) {
			piniaDevtoolsSuppressionState.queuePropertyValue = value;
			ensureDevtoolsQueuePushPatched();
		}
	});
	piniaDevtoolsSuppressionState.isQueuePropertyPatched = true;
	ensureDevtoolsQueuePushPatched();
};
var restoreDevtoolsQueueAssignmentPatch = () => {
	if (!piniaDevtoolsSuppressionState.isQueuePropertyPatched) return;
	const { queuePropertyValue, originalQueuePropertyDescriptor } = piniaDevtoolsSuppressionState;
	delete globalThis.__VUE_DEVTOOLS_PLUGINS__;
	if (originalQueuePropertyDescriptor) if ("value" in originalQueuePropertyDescriptor) Object.defineProperty(globalThis, "__VUE_DEVTOOLS_PLUGINS__", {
		configurable: originalQueuePropertyDescriptor.configurable,
		enumerable: originalQueuePropertyDescriptor.enumerable,
		writable: originalQueuePropertyDescriptor.writable,
		value: queuePropertyValue
	});
	else {
		Object.defineProperty(globalThis, "__VUE_DEVTOOLS_PLUGINS__", originalQueuePropertyDescriptor);
		if (typeof originalQueuePropertyDescriptor.set === "function") originalQueuePropertyDescriptor.set.call(globalThis, queuePropertyValue);
	}
	else if (queuePropertyValue !== void 0) globalThis.__VUE_DEVTOOLS_PLUGINS__ = queuePropertyValue;
	piniaDevtoolsSuppressionState.isQueuePropertyPatched = false;
	piniaDevtoolsSuppressionState.originalQueuePropertyDescriptor = null;
	piniaDevtoolsSuppressionState.queuePropertyValue = void 0;
};
var ensureDevtoolsHookEmitPatched = () => {
	const hook = globalThis?.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	if (!hook || typeof hook.emit !== "function") return;
	if (piniaDevtoolsSuppressionState.hook === hook) return;
	restoreDevtoolsHookEmitPatch();
	const originalHookEmit = hook.emit;
	piniaDevtoolsSuppressionState.hook = hook;
	piniaDevtoolsSuppressionState.originalHookEmit = originalHookEmit;
	hook.emit = function patchedEmit(event, ...args) {
		const [pluginDescriptor] = args;
		if (isPiniaDevtoolsSetupForSuppressedApp(event, pluginDescriptor)) return;
		return originalHookEmit.call(this, event, ...args);
	};
};
var ensureDevtoolsHookAssignmentPatched = () => {
	if (piniaDevtoolsSuppressionState.isHookPropertyPatched) {
		ensureDevtoolsHookEmitPatched();
		return;
	}
	const hookDescriptor = Object.getOwnPropertyDescriptor(globalThis, "__VUE_DEVTOOLS_GLOBAL_HOOK__");
	if (hookDescriptor?.configurable === false) {
		ensureDevtoolsHookEmitPatched();
		return;
	}
	piniaDevtoolsSuppressionState.originalHookPropertyDescriptor = hookDescriptor ?? null;
	piniaDevtoolsSuppressionState.hookPropertyValue = globalThis.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	Object.defineProperty(globalThis, "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
		configurable: true,
		enumerable: hookDescriptor?.enumerable ?? true,
		get() {
			return piniaDevtoolsSuppressionState.hookPropertyValue;
		},
		set(value) {
			piniaDevtoolsSuppressionState.hookPropertyValue = value;
			ensureDevtoolsHookEmitPatched();
		}
	});
	piniaDevtoolsSuppressionState.isHookPropertyPatched = true;
	ensureDevtoolsHookEmitPatched();
};
var restoreDevtoolsHookAssignmentPatch = () => {
	if (!piniaDevtoolsSuppressionState.isHookPropertyPatched) return;
	const { hookPropertyValue, originalHookPropertyDescriptor } = piniaDevtoolsSuppressionState;
	delete globalThis.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	if (originalHookPropertyDescriptor) if ("value" in originalHookPropertyDescriptor) Object.defineProperty(globalThis, "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
		configurable: originalHookPropertyDescriptor.configurable,
		enumerable: originalHookPropertyDescriptor.enumerable,
		writable: originalHookPropertyDescriptor.writable,
		value: hookPropertyValue
	});
	else {
		Object.defineProperty(globalThis, "__VUE_DEVTOOLS_GLOBAL_HOOK__", originalHookPropertyDescriptor);
		if (typeof originalHookPropertyDescriptor.set === "function") originalHookPropertyDescriptor.set.call(globalThis, hookPropertyValue);
	}
	else if (hookPropertyValue !== void 0) globalThis.__VUE_DEVTOOLS_GLOBAL_HOOK__ = hookPropertyValue;
	piniaDevtoolsSuppressionState.isHookPropertyPatched = false;
	piniaDevtoolsSuppressionState.originalHookPropertyDescriptor = null;
	piniaDevtoolsSuppressionState.hookPropertyValue = void 0;
};
var restoreDevtoolsSuppressionPatchesIfIdle = () => {
	if (piniaDevtoolsSuppressionState.disabledAppRefCounts.size > 0) return;
	restoreDevtoolsHookEmitPatch();
	restoreDevtoolsHookAssignmentPatch();
	restoreDevtoolsQueuePushPatch();
	restoreDevtoolsQueueAssignmentPatch();
};
var setPiniaDevtoolsSuppressedForApp = (app, isSuppressed) => {
	if (!isSuppressed) return () => {};
	const refCount = piniaDevtoolsSuppressionState.disabledAppRefCounts.get(app) ?? 0;
	piniaDevtoolsSuppressionState.disabledAppRefCounts.set(app, refCount + 1);
	ensureDevtoolsHookAssignmentPatched();
	ensureDevtoolsQueueAssignmentPatched();
	return () => {
		const currentRefCount = piniaDevtoolsSuppressionState.disabledAppRefCounts.get(app);
		if (!currentRefCount) return;
		if (currentRefCount === 1) piniaDevtoolsSuppressionState.disabledAppRefCounts.delete(app);
		else piniaDevtoolsSuppressionState.disabledAppRefCounts.set(app, currentRefCount - 1);
		restoreDevtoolsSuppressionPatchesIfIdle();
	};
};
const createSuperdocVueApp = ({ disablePiniaDevtools = false } = {}) => {
	const app = createApp(SuperDoc_default);
	const pinia = createPinia();
	const cleanupPiniaDevtoolsSuppression = setPiniaDevtoolsSuppressedForApp(app, disablePiniaDevtools);
	let superdocStore;
	let commentsStore;
	let highContrastModeStore;
	try {
		app.use(pinia);
		if (disablePiniaDevtools) purgeDevtoolsPluginQueueForApp(app);
		app.directive("click-outside", v_click_outside_default);
		superdocStore = useSuperdocStore();
		commentsStore = useCommentsStore();
		highContrastModeStore = useHighContrastMode();
	} catch (error) {
		cleanupPiniaDevtoolsSuppression();
		throw error;
	}
	if (typeof app.unmount === "function") {
		const originalUnmount = app.unmount.bind(app);
		app.unmount = (...args) => {
			cleanupPiniaDevtoolsSuppression();
			return originalUnmount(...args);
		};
	}
	return {
		app,
		pinia,
		superdocStore,
		commentsStore,
		highContrastModeStore
	};
};
var MIME_TYPES = {
	docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	pdf: "application/pdf",
	zip: "application/zip",
	html: "text/html",
	txt: "text/plain;charset=utf-8",
	json: "application/json"
};
var getMimeType = (extension) => {
	if (!extension || typeof extension.toLowerCase !== "function") return "application/octet-stream";
	return MIME_TYPES[extension.toLowerCase()] || "application/octet-stream";
};
var ensureBlob = (data, extension) => {
	if (data instanceof Blob) return data;
	const mimeType = getMimeType(extension);
	if (data instanceof ArrayBuffer) return new Blob([data], { type: mimeType });
	if (ArrayBuffer.isView(data)) {
		const { buffer, byteOffset, byteLength } = data;
		const slice = buffer.slice(byteOffset, byteOffset + byteLength);
		return new Blob([slice], { type: mimeType });
	}
	if (typeof data === "string") return new Blob([data], { type: mimeType });
	if (data == null) throw new TypeError("createDownload requires a Blob, ArrayBuffer, or ArrayBufferView.");
	throw new TypeError(`Cannot create download from value of type ${typeof data}`);
};
const createDownload = (data, name, extension) => {
	const blob = ensureBlob(data, extension);
	if (typeof URL === "undefined" || typeof URL.createObjectURL !== "function") return blob;
	if (typeof document === "undefined" || typeof document.createElement !== "function") return blob;
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = `${name}.${extension}`;
	const shouldAppend = document.body && typeof document.body.appendChild === "function";
	if (shouldAppend) document.body.appendChild(a);
	a.click();
	if (shouldAppend) document.body.removeChild(a);
	if (typeof URL.revokeObjectURL === "function") setTimeout(() => URL.revokeObjectURL(url), 0);
	return blob;
};
const cleanName = (currentName) => {
	const lowerName = currentName.toLowerCase();
	if (lowerName.endsWith(".docx")) return currentName.slice(0, -5);
	if (lowerName.endsWith(".pdf")) return currentName.slice(0, -4);
	return currentName;
};
function overwriteRoomComments(ydoc, commentsList) {
	const commentsArray = ydoc.getArray("comments");
	const locals = commentsList ?? [];
	ydoc.transact(() => {
		if (commentsArray.length > 0) commentsArray.delete(0, commentsArray.length);
		const serialized = locals.map((c) => typeof c.getValues === "function" ? c.getValues() : c).filter(Boolean).map((values) => new Map$1(Object.entries(values)));
		if (serialized.length > 0) commentsArray.push(serialized);
	});
}
function overwriteRoomLockState(ydoc, { isLocked, lockedBy }) {
	const metaMap = ydoc.getMap("meta");
	ydoc.transact(() => {
		if (isLocked) {
			metaMap.set("locked", true);
			metaMap.set("lockedBy", lockedBy);
		} else {
			metaMap.delete("locked");
			metaMap.delete("lockedBy");
		}
	});
}
var EventEmitter$1 = class {
	#events = /* @__PURE__ */ new Map();
	on(name, fn) {
		const callbacks = this.#events.get(name);
		if (callbacks) callbacks.push(fn);
		else this.#events.set(name, [fn]);
	}
	emit(name, ...args) {
		const callbacks = this.#events.get(name);
		if (!callbacks) return;
		for (const fn of callbacks) fn.apply(this, args);
	}
	off(name, fn) {
		const callbacks = this.#events.get(name);
		if (!callbacks) return;
		if (fn) this.#events.set(name, callbacks.filter((cb) => cb !== fn));
		else this.#events.delete(name);
	}
	once(name, fn) {
		const wrapper = (...args) => {
			this.off(name, wrapper);
			fn.apply(this, args);
		};
		this.on(name, wrapper);
	}
	removeAllListeners() {
		this.#events = /* @__PURE__ */ new Map();
	}
};
function flattenPoints(points) {
	return points.flatMap((pair) => [pair[0], pair[1]]);
}
function getRandomId(prefix = "id") {
	return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}
function createTextarea(options = {}) {
	const { value = "", left, top, width, height, fontSize = 16, fontFamily = "Arial, sans-serif", color = "#000", background = "transparent", resize = "none" } = options;
	const textarea = document.createElement("textarea");
	textarea.value = value;
	const style = textarea.style;
	style.position = "absolute";
	if (left != null) style.left = `${left}px`;
	if (top != null) style.top = `${top}px`;
	if (width != null) style.width = typeof width === "number" ? `${width}px` : width;
	if (height != null) style.height = typeof height === "number" ? `${height}px` : height;
	style.minWidth = 120;
	style.fontSize = typeof fontSize === "number" ? `${fontSize}px` : fontSize;
	style.fontFamily = fontFamily;
	style.color = color;
	style.background = background;
	style.border = "2px solid #3c97fe80";
	style.padding = "2px 4px";
	style.margin = "0";
	style.zIndex = "1000";
	style.overflow = "hidden";
	style.resize = resize;
	style.outline = "none";
	return textarea;
}
var DEFAULT_TEXT_FONT_SIZE = 18;
var WhiteboardPage = class {
	pageIndex = null;
	strokes = [];
	text = [];
	images = [];
	size = null;
	originalSize = null;
	#Renderer = null;
	#stage = null;
	#layer = null;
	#strokesLayer = null;
	#transformer = null;
	#containerEl = null;
	#pendingImageIds = /* @__PURE__ */ new Set();
	#isDrawing = false;
	#currentLine = null;
	#currentPoints = [];
	#currentStrokeWidth = null;
	#currentTool = "select";
	#enabled = false;
	#selectedNode = null;
	#strokeColor = "#2293fb";
	#strokeWidth = 5;
	#onChange = null;
	#onToolChange = null;
	constructor(props) {
		this.#init(props);
	}
	#init(props) {
		this.#Renderer = props.Renderer;
		this.#enabled = props.enabled;
		this.pageIndex = props.pageIndex;
		this.#onChange = props.onChange;
		this.#onToolChange = props.onToolChange;
	}
	#toNormalizedPoint(x, y) {
		const width = this.size?.width || 1;
		const height = this.size?.height || 1;
		return {
			xN: x / width,
			yN: y / height
		};
	}
	#fromNormalizedPoint(xN, yN) {
		const width = this.size?.width || 1;
		const height = this.size?.height || 1;
		return {
			x: xN * width,
			y: yN * height
		};
	}
	#toNormalizedSize(width, height) {
		const pageWidth = this.size?.width || 1;
		const pageHeight = this.size?.height || 1;
		return {
			wN: width / pageWidth,
			hN: height / pageHeight
		};
	}
	#fromNormalizedSize(wN, hN) {
		const pageWidth = this.size?.width || 1;
		const pageHeight = this.size?.height || 1;
		return {
			width: wN * pageWidth,
			height: hN * pageHeight
		};
	}
	#fromNormalizedStroke(stroke) {
		const { width: pageWidth = 1, height: pageHeight = 1 } = this.size || {};
		return {
			points: (Array.isArray(stroke.pointsN) ? stroke.pointsN : []).map((pair) => {
				return [pair[0] * pageWidth, pair[1] * pageHeight];
			}),
			strokeWidth: Number.isFinite(stroke.widthN) ? stroke.widthN * ((pageWidth + pageHeight) / 2) : this.#strokeWidth
		};
	}
	#toNormalizedStroke(stroke) {
		const { width: pageWidth = 1, height: pageHeight = 1 } = this.size || {};
		return {
			pointsN: (Array.isArray(stroke.points) ? stroke.points : []).map((pair) => [pair[0] / pageWidth, pair[1] / pageHeight]),
			widthN: Number.isFinite(stroke.width) ? stroke.width / ((pageWidth + pageHeight) / 2) : void 0
		};
	}
	#fromNormalizedText(item) {
		const { width: pageWidth = 1, height: pageHeight = 1 } = this.size || {};
		return {
			x: (item.xN ?? 0) * pageWidth,
			y: (item.yN ?? 0) * pageHeight,
			width: Number.isFinite(item.widthN) ? item.widthN * pageWidth : void 0,
			fontSize: Number.isFinite(item.fontSizeN) ? item.fontSizeN * pageHeight : DEFAULT_TEXT_FONT_SIZE
		};
	}
	#toNormalizedText(item) {
		const { width: pageWidth = 1, height: pageHeight = 1 } = this.size || {};
		const originalHeight = this.originalSize?.height ?? pageHeight;
		return {
			xN: (item.x ?? 0) / pageWidth,
			yN: (item.y ?? 0) / pageHeight,
			widthN: Number.isFinite(item.width) ? item.width / pageWidth : null,
			fontSizeN: Number.isFinite(item.fontSize) ? item.fontSize / originalHeight : DEFAULT_TEXT_FONT_SIZE / originalHeight
		};
	}
	#fromNormalizedImage(item) {
		const { width: pageWidth = 1, height: pageHeight = 1 } = this.size || {};
		return {
			x: (item.xN ?? 0) * pageWidth,
			y: (item.yN ?? 0) * pageHeight,
			width: Number.isFinite(item.widthN) ? item.widthN * pageWidth : void 0,
			height: Number.isFinite(item.heightN) ? item.heightN * pageHeight : void 0
		};
	}
	#toNormalizedImage(item) {
		const { width: pageWidth = 1, height: pageHeight = 1 } = this.size || {};
		return {
			xN: (item.x ?? 0) / pageWidth,
			yN: (item.y ?? 0) / pageHeight,
			widthN: Number.isFinite(item.width) ? item.width / pageWidth : null,
			heightN: Number.isFinite(item.height) ? item.height / pageHeight : null
		};
	}
	#getCurrentScale() {
		const current = this.size?.width;
		const original = this.originalSize?.width ?? current;
		if (!Number.isFinite(current) || !Number.isFinite(original) || !original) return 1;
		return current / original;
	}
	#attachEventListeners() {
		if (!this.#stage || !this.#layer) return;
		this.#stage.on("mousedown touchstart", (event) => {
			this.#handleDrawStart(event);
		});
		this.#stage.on("mousemove touchmove", (event) => {
			this.#handleDrawMove(event);
		});
		this.#stage.on("mouseup touchend", (event) => {
			this.#handleDrawEnd(event);
		});
		this.#stage.on("click tap", (event) => {
			this.#handleStageClick(event);
		});
		window.addEventListener("keydown", this.#handleKeydown);
	}
	setTool(tool) {
		this.#currentTool = tool;
		this.#updateStrokesLayerListening();
		this.#clearSelection();
		this.render();
	}
	getTool() {
		return this.#currentTool;
	}
	setEnabled(enabled) {
		this.#enabled = Boolean(enabled);
		this.#updateStrokesLayerListening();
		this.#clearSelection();
		this.render();
	}
	isEnabled() {
		return this.#enabled;
	}
	setSize(size) {
		if (!size) return;
		const { width, height, originalWidth, originalHeight } = size;
		this.size = {
			width,
			height
		};
		this.originalSize = {
			width: originalWidth ?? null,
			height: originalHeight ?? null
		};
	}
	resize(width, height) {
		if (!this.#stage) return;
		this.#stage.size({
			width,
			height
		});
		this.#applyPixelRatio();
		this.render();
	}
	mount(container) {
		if (!container) return;
		if (this.#stage && this.#containerEl === container) return;
		if (this.#stage) this.destroy();
		const width = this.size?.width || container.clientWidth || 1;
		const height = this.size?.height || container.clientHeight || 1;
		this.#containerEl = container;
		this.#stage = new this.#Renderer.Stage({
			container,
			width,
			height
		});
		this.#layer = new this.#Renderer.Layer();
		this.#strokesLayer = new this.#Renderer.Layer();
		this.#stage.add(this.#layer);
		this.#stage.add(this.#strokesLayer);
		this.#applyPixelRatio();
		this.#updateStrokesLayerListening();
		this.#attachEventListeners();
		this.render();
	}
	render() {
		if (!this.#layer) return;
		if (this.#transformer) {
			this.#transformer.destroy();
			this.#transformer = null;
		}
		this.#layer.find(".wb-text").forEach((node) => node.destroy());
		this.#strokesLayer.destroyChildren();
		this.renderStrokes();
		this.renderText();
		this.renderImages();
		this.#layer.batchDraw();
		this.#strokesLayer.batchDraw();
	}
	#applyPixelRatio() {
		const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
		if (this.#layer?.getCanvas) this.#layer.getCanvas().setPixelRatio(ratio);
		if (this.#strokesLayer?.getCanvas) this.#strokesLayer.getCanvas().setPixelRatio(ratio);
	}
	#updateStrokesLayerListening() {
		if (!this.#strokesLayer) return;
		const isDrawMode = this.#currentTool === "draw" || this.#currentTool === "erase";
		const isListening = Boolean(this.#enabled && isDrawMode);
		this.#strokesLayer.listening(isListening);
	}
	renderStrokes() {
		this.strokes.forEach((stroke) => {
			const { points, strokeWidth } = this.#fromNormalizedStroke(stroke);
			const line = new this.#Renderer.Line({
				points: flattenPoints(points),
				stroke: stroke.color || this.#strokeColor,
				strokeWidth,
				lineCap: "round",
				lineJoin: "round",
				globalCompositeOperation: stroke.type === "erase" ? "destination-out" : "source-over"
			});
			line.name("wb-stroke");
			this.#strokesLayer.add(line);
		});
	}
	renderText() {
		this.text.forEach((item) => {
			const { x, y, width, fontSize } = this.#fromNormalizedText(item);
			const textNode = new this.#Renderer.Text({
				x,
				y,
				text: item.content,
				fontSize,
				fontFamily: "Arial, sans-serif",
				fill: "#2293fb",
				draggable: this.#currentTool === "select",
				width
			});
			textNode.name("wb-text");
			textNode._whiteboardId = item.id;
			this.#attachTextNodeEvents(textNode, item);
			this.#layer.add(textNode);
		});
	}
	#attachTextNodeEvents(textNode, item) {
		textNode.on("click tap", (event) => {
			if (this.#currentTool !== "select" || !this.#enabled) return;
			event.cancelBubble = true;
			this.#selectNode(textNode);
		});
		textNode.on("dragend", () => {
			const { xN, yN } = this.#toNormalizedText({
				x: textNode.x(),
				y: textNode.y(),
				fontSize: item.fontSizeN ? item.fontSizeN * (this.size?.height || 1) : DEFAULT_TEXT_FONT_SIZE,
				width: item.widthN ? item.widthN * (this.size?.width || 1) : null
			});
			item.xN = xN;
			item.yN = yN;
			this.#triggerChanged();
		});
		textNode.on("transform", () => {
			textNode.scaleY(1);
			textNode.setAttrs({
				width: textNode.width() * textNode.scaleX(),
				scaleX: 1
			});
		});
		textNode.on("transformend", () => {
			textNode.setAttrs({
				width: Math.max(1, textNode.width() * textNode.scaleX()),
				scaleX: 1,
				scaleY: 1
			});
			const nextWidth = textNode.width();
			const pageWidth = this.size?.width || 1;
			item.widthN = nextWidth / pageWidth;
			item.xN = textNode.x() / pageWidth;
			item.yN = textNode.y() / (this.size?.height || 1);
			this.#triggerChanged();
		});
		textNode.on("dblclick dbltap", (event) => {
			if (this.#currentTool !== "select" || !this.#enabled) return;
			event.cancelBubble = true;
			this.#editTextNode(textNode, item);
		});
	}
	renderImages() {
		const existingNodes = this.#layer?.find(".wb-image") ?? [];
		const existingById = /* @__PURE__ */ new Map();
		existingNodes.forEach((node) => {
			existingById.set(node._whiteboardId, node);
		});
		const imageIds = new Set(this.images.map((item) => item.id));
		existingNodes.forEach((node) => {
			if (!imageIds.has(node._whiteboardId)) node.destroy();
		});
		const renderImageItem = (item, name) => {
			const { x, y, width, height } = this.#fromNormalizedImage(item);
			const existing = existingById.get(item.id);
			if (existing) {
				if (Number.isFinite(x)) existing.x(x);
				if (Number.isFinite(y)) existing.y(y);
				if (Number.isFinite(width)) existing.width(width);
				if (Number.isFinite(height)) existing.height(height);
				existing.draggable(this.#currentTool === "select");
				return;
			}
			if (this.#pendingImageIds.has(item.id)) return;
			this.#pendingImageIds.add(item.id);
			const imageObj = new window.Image();
			imageObj.crossOrigin = "Anonymous";
			imageObj.onload = () => {
				if (existingById.get(item.id)) {
					this.#pendingImageIds.delete(item.id);
					return;
				}
				if (!this.#layer) {
					this.#pendingImageIds.delete(item.id);
					return;
				}
				const imageNode = new this.#Renderer.Image({
					x,
					y,
					image: imageObj,
					width: width ?? imageObj.width,
					height: height ?? imageObj.height,
					draggable: this.#currentTool === "select"
				});
				imageNode.name(name);
				imageNode._whiteboardId = item.id;
				this.#attachImageNodeEvents(imageNode, item);
				this.#layer.add(imageNode);
				this.#layer.batchDraw();
				this.#pendingImageIds.delete(item.id);
			};
			imageObj.onerror = () => {
				this.#pendingImageIds.delete(item.id);
			};
			imageObj.src = item.src;
		};
		this.images.forEach((item) => renderImageItem(item, "wb-image"));
	}
	#attachImageNodeEvents(imageNode, item) {
		imageNode.on("click tap", (event) => {
			if (this.#currentTool !== "select" || !this.#enabled) return;
			event.cancelBubble = true;
			this.#selectNode(imageNode);
		});
		imageNode.on("dragend", () => {
			const pageWidth = this.size?.width || 1;
			const pageHeight = this.size?.height || 1;
			item.xN = imageNode.x() / pageWidth;
			item.yN = imageNode.y() / pageHeight;
			this.#triggerChanged();
		});
		imageNode.on("transformend", () => {
			const scaleX = imageNode.scaleX();
			const scaleY = imageNode.scaleY();
			const nextWidth = Math.max(1, imageNode.width() * scaleX);
			const nextHeight = Math.max(1, imageNode.height() * scaleY);
			imageNode.scale({
				x: 1,
				y: 1
			});
			imageNode.width(nextWidth);
			imageNode.height(nextHeight);
			const pageWidth = this.size?.width || 1;
			const pageHeight = this.size?.height || 1;
			item.widthN = nextWidth / pageWidth;
			item.heightN = nextHeight / pageHeight;
			item.xN = imageNode.x() / pageWidth;
			item.yN = imageNode.y() / pageHeight;
			this.#triggerChanged();
		});
	}
	destroy() {
		if (this.#stage) this.#stage.destroy();
		this.#stage = null;
		this.#layer = null;
		this.#strokesLayer = null;
		this.#containerEl = null;
		this.#isDrawing = false;
		this.#currentLine = null;
		this.#currentPoints = [];
		this.#selectedNode = null;
		this.#transformer = null;
		window.removeEventListener("keydown", this.#handleKeydown);
	}
	toJSON() {
		return {
			strokes: this.strokes,
			text: this.text,
			images: this.images
		};
	}
	applyData(data = {}) {
		const strokes = Array.isArray(data.strokes) ? data.strokes : [];
		const text = Array.isArray(data.text) ? data.text : [];
		const images = Array.isArray(data.images) ? data.images : [];
		this.strokes = strokes;
		this.text = text;
		this.images = images;
		this.render();
	}
	#triggerChanged() {
		if (this.#onChange) this.#onChange();
	}
	addStroke(stroke) {
		if (!stroke || !Array.isArray(stroke.points)) return;
		const { pointsN, widthN } = this.#toNormalizedStroke(stroke);
		this.strokes.push({
			pointsN,
			widthN,
			color: stroke.color,
			type: stroke.type
		});
	}
	addText(item) {
		if (!item || typeof item.content !== "string") return;
		const { xN, yN, widthN, fontSizeN } = this.#toNormalizedText(item);
		this.text.push({
			id: item.id ?? getRandomId("text"),
			xN,
			yN,
			content: item.content,
			fontSizeN,
			widthN
		});
		this.render();
		this.#triggerChanged();
	}
	addImage(item) {
		if (!item || !item.src) return;
		const { xN, yN, widthN, heightN } = this.#toNormalizedImage(item);
		const imageItem = {
			id: item.id ?? getRandomId("image"),
			stickerId: item.stickerId ?? (item.type === "sticker" ? item.id ?? null : null),
			xN,
			yN,
			src: item.src,
			widthN,
			heightN,
			type: item.type ?? "image"
		};
		this.images.push(imageItem);
		this.render();
		this.#triggerChanged();
	}
	#clearSelection() {
		if (!this.#transformer) return;
		this.#transformer.destroy();
		this.#transformer = null;
		this.#selectedNode = null;
		this.#layer?.batchDraw();
	}
	#selectNode(node) {
		if (!this.#layer) return;
		this.#selectedNode = node;
		const isText = node.name && node.name() === "wb-text";
		const anchors = isText ? ["middle-left", "middle-right"] : [
			"top-left",
			"top-right",
			"bottom-left",
			"bottom-right"
		];
		const boundBoxFunc = (oldBox, newBox) => {
			const min$1 = 20;
			if (newBox.width < min$1) return oldBox;
			if (isText) return {
				...newBox,
				height: oldBox.height,
				y: oldBox.y
			};
			if (newBox.height < min$1) return oldBox;
			return newBox;
		};
		if (!this.#transformer) {
			this.#transformer = new this.#Renderer.Transformer({
				nodes: [node],
				enabledAnchors: anchors,
				rotateEnabled: false,
				keepRatio: false,
				boundBoxFunc
			});
			this.#layer.add(this.#transformer);
		} else {
			this.#transformer.nodes([node]);
			this.#transformer.enabledAnchors(anchors);
			this.#transformer.boundBoxFunc(boundBoxFunc);
		}
		this.#layer.batchDraw();
	}
	#deleteSelectedNode() {
		if (!this.#selectedNode) return;
		const node = this.#selectedNode;
		const name = node.name && node.name();
		const handler = {
			"wb-text": () => {
				const id = node._whiteboardId;
				this.text = this.text.filter((item) => item.id !== id);
			},
			"wb-image": () => {
				const id = node._whiteboardId;
				this.images = this.images.filter((item) => item.id !== id);
			}
		}[name];
		if (handler) handler();
		node.destroy();
		this.#clearSelection();
		this.render();
	}
	#handleKeydown = (event) => {
		if (!this.#selectedNode || !this.#enabled || this.#currentTool !== "select") return;
		const targetTag = event.target?.tagName;
		if (targetTag === "INPUT" || targetTag === "TEXTAREA") return;
		if (event.key === "Backspace" || event.key === "Delete") {
			event.preventDefault();
			this.#deleteSelectedNode();
			this.#triggerChanged();
		}
	};
	#handleStageClick(event) {
		if (!this.#enabled || !this.#stage) return;
		const handler = {
			text: () => {
				const pos = this.#stage.getPointerPosition();
				if (!pos) return;
				this.#startTextInput(pos.x, pos.y);
			},
			select: () => {
				if (event?.target === this.#stage) this.#clearSelection();
			}
		}[this.#currentTool];
		if (handler) handler();
	}
	#handleDrawStart() {
		if (!this.#enabled || this.#currentTool !== "draw" && this.#currentTool !== "erase") return;
		this.#isDrawing = true;
		const pos = this.#stage.getPointerPosition();
		if (!pos) return;
		const isErase = this.#currentTool === "erase";
		const strokeWidth = this.#strokeWidth * this.#getCurrentScale();
		this.#currentPoints = [pos.x, pos.y];
		this.#currentLine = new this.#Renderer.Line({
			points: this.#currentPoints,
			stroke: this.#strokeColor,
			strokeWidth: isErase ? strokeWidth * 3 : strokeWidth,
			lineCap: "round",
			lineJoin: "round",
			globalCompositeOperation: isErase ? "destination-out" : "source-over"
		});
		this.#currentStrokeWidth = strokeWidth;
		this.#strokesLayer.add(this.#currentLine);
	}
	#handleDrawMove() {
		if (!this.#enabled || this.#currentTool !== "draw" && this.#currentTool !== "erase") return;
		if (!this.#isDrawing || !this.#currentLine) return;
		const pos = this.#stage.getPointerPosition();
		if (!pos) return;
		this.#currentPoints.push(pos.x, pos.y);
		this.#currentLine.points(this.#currentPoints);
		this.#strokesLayer.batchDraw();
	}
	#handleDrawEnd() {
		if (!this.#enabled || this.#currentTool !== "draw" && this.#currentTool !== "erase") return;
		if (!this.#isDrawing || !this.#currentLine) return;
		this.#isDrawing = false;
		const pairs = [];
		for (let i = 0; i < this.#currentPoints.length; i += 2) pairs.push([this.#currentPoints[i], this.#currentPoints[i + 1]]);
		const isErase = this.#currentTool === "erase";
		const baseWidth = this.#currentStrokeWidth ?? this.#strokeWidth;
		this.addStroke({
			points: pairs,
			color: this.#strokeColor,
			width: isErase ? baseWidth * 3 : baseWidth,
			type: isErase ? "erase" : "draw"
		});
		this.#triggerChanged();
		this.#currentLine = null;
		this.#currentPoints = [];
		this.#currentStrokeWidth = null;
	}
	#startTextInput(x, y) {
		if (!this.#containerEl) return;
		const fontSize = DEFAULT_TEXT_FONT_SIZE * this.#getCurrentScale();
		const textarea = createTextarea({
			left: x,
			top: y,
			height: Math.ceil(fontSize * 1.4),
			background: "transparent",
			fontSize,
			color: "#2293fb"
		});
		this.#containerEl.append(textarea);
		textarea.focus();
		textarea.select();
		let finished = false;
		const finish = () => {
			if (finished) return;
			finished = true;
			const text = textarea.value.trim();
			if (text) {
				this.addText({
					x,
					y,
					content: text
				});
				if (this.#currentTool === "text" && this.#onToolChange) this.#onToolChange("select");
			}
			if (textarea.parentNode === this.#containerEl) this.#containerEl.removeChild(textarea);
		};
		textarea.addEventListener("keydown", (event) => {
			if (event.key === "Enter" && !event.shiftKey) {
				event.preventDefault();
				finish();
			}
			if (event.key === "Escape") {
				event.preventDefault();
				finish();
			}
		});
		textarea.addEventListener("blur", finish);
	}
	#editTextNode(textNode, item) {
		if (!this.#containerEl || !this.#stage) return;
		this.#clearSelection();
		const textPosition = textNode.position();
		const textarea = createTextarea({
			value: textNode.text(),
			left: textPosition.x,
			top: textPosition.y,
			width: Math.max(textNode.width(), 120),
			height: Math.max(textNode.height(), 24),
			fontSize: textNode.fontSize(),
			fontFamily: textNode.fontFamily(),
			color: textNode.fill ? textNode.fill() : "#2293fb",
			background: "white",
			resize: "both"
		});
		this.#containerEl.appendChild(textarea);
		textarea.focus();
		textarea.select();
		let finished = false;
		const finish = () => {
			if (finished) return;
			finished = true;
			const value = textarea.value.trim();
			if (value) {
				textNode.text(value);
				item.content = value;
				this.#layer.batchDraw();
				this.#triggerChanged();
			}
			if (textarea.parentNode) textarea.parentNode.removeChild(textarea);
		};
		textarea.addEventListener("keydown", (event) => {
			if (event.key === "Enter" && !event.shiftKey) {
				event.preventDefault();
				finish();
			}
			if (event.key === "Escape") {
				event.preventDefault();
				finish();
			}
		});
		textarea.addEventListener("blur", finish);
	}
};
var Whiteboard = class extends EventEmitter$1 {
	#Renderer = null;
	#superdoc = null;
	#pages = /* @__PURE__ */ new Map();
	#registry = /* @__PURE__ */ new Map();
	#currentTool = "select";
	#enabled = false;
	#opacity = 1;
	#onChange = null;
	#onSetData = null;
	#onEnabledChange = null;
	constructor(props = {}) {
		super();
		this.#init(props);
	}
	#init(props) {
		this.#Renderer = props.Renderer;
		this.#superdoc = props.superdoc;
		this.#enabled = props.enabled;
		this.#onChange = props.onChange;
		this.#onSetData = props.onSetData;
		this.#onEnabledChange = props.onEnabledChange;
	}
	register(type, items) {
		this.#registry.set(type, items);
	}
	getType(type) {
		return this.#registry.get(type);
	}
	setTool(tool) {
		this.#currentTool = tool;
		this.#pages.forEach((page) => page.setTool(tool));
		this.emit("tool", tool);
	}
	getTool() {
		return this.#currentTool;
	}
	setEnabled(enabled) {
		this.#enabled = enabled;
		this.#pages.forEach((page) => page.setEnabled(this.#enabled));
		this.emit("enabled", this.#enabled);
		if (this.#onEnabledChange) this.#onEnabledChange(this.#enabled);
	}
	isEnabled() {
		return this.#enabled;
	}
	setOpacity(opacity) {
		const value = opacity;
		this.#opacity = Number.isFinite(value) ? Math.min(1, Math.max(0, value)) : 1;
		this.emit("opacity", this.#opacity);
	}
	getOpacity() {
		return this.#opacity;
	}
	getPages() {
		return Array.from(this.#pages.values());
	}
	rerender() {
		this.#pages.forEach((page) => page.render());
	}
	setPageSize(pageIndex, size) {
		this.#createPage(pageIndex).setSize(size);
	}
	#createPage(pageIndex) {
		const existing = this.#pages.get(pageIndex);
		if (existing) return existing;
		const page = new WhiteboardPage({
			Renderer: this.#Renderer,
			enabled: this.#enabled,
			pageIndex,
			onChange: () => {
				this.#emitChange();
			},
			onToolChange: (tool) => {
				this.setTool(tool);
			}
		});
		page.setTool(this.#currentTool);
		page.setEnabled(this.#enabled);
		this.#pages.set(pageIndex, page);
		return page;
	}
	getPage(pageIndex) {
		return this.#pages.get(pageIndex);
	}
	getWhiteboardData() {
		const pages = {};
		const pageSizes = {};
		for (const page of this.#pages.values()) {
			pages[page.pageIndex] = page.toJSON();
			if (page.size) pageSizes[page.pageIndex] = {
				width: page.size.width,
				height: page.size.height,
				originalWidth: page.originalSize?.width ?? null,
				originalHeight: page.originalSize?.height ?? null
			};
		}
		return {
			pages,
			meta: { pageSizes },
			version: 1
		};
	}
	setWhiteboardData(json) {
		this.#pages.clear();
		const pages = json?.pages || {};
		Object.keys(pages).forEach((key) => {
			const parsedIndex = Number(key);
			const pageIndex = Number.isNaN(parsedIndex) ? key : parsedIndex;
			this.#createPage(pageIndex).applyData(pages[key]);
		});
		this.emit("setData", this.getPages());
		if (this.#onSetData) this.#onSetData(this.getPages());
		this.#emitChange();
	}
	#emitChange() {
		const data = this.getWhiteboardData();
		this.emit("change", data);
		if (this.#onChange) this.#onChange(data);
	}
};
init_dist();
var PI_OVER_180 = Math.PI / 180;
function detectBrowser() {
	return typeof window !== "undefined" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
}
const glob = typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof WorkerGlobalScope !== "undefined" ? self : {};
const Konva$2 = {
	_global: glob,
	version: "10.2.5",
	isBrowser: detectBrowser(),
	isUnminified: /param/.test(function(param) {}.toString()),
	dblClickWindow: 400,
	getAngle(angle) {
		return Konva$2.angleDeg ? angle * PI_OVER_180 : angle;
	},
	enableTrace: false,
	pointerEventsEnabled: true,
	autoDrawEnabled: true,
	hitOnDragEnabled: false,
	capturePointerEventsEnabled: false,
	_mouseListenClick: false,
	_touchListenClick: false,
	_pointerListenClick: false,
	_mouseInDblClickWindow: false,
	_touchInDblClickWindow: false,
	_pointerInDblClickWindow: false,
	_mouseDblClickPointerId: null,
	_touchDblClickPointerId: null,
	_pointerDblClickPointerId: null,
	_renderBackend: "web",
	legacyTextRendering: false,
	pixelRatio: typeof window !== "undefined" && window.devicePixelRatio || 1,
	dragDistance: 3,
	angleDeg: true,
	showWarnings: true,
	dragButtons: [0, 1],
	isDragging() {
		return Konva$2["DD"].isDragging;
	},
	isTransforming() {
		var _a, _b;
		return (_b = (_a = Konva$2["Transformer"]) === null || _a === void 0 ? void 0 : _a.isTransforming()) !== null && _b !== void 0 ? _b : false;
	},
	isDragReady() {
		return !!Konva$2["DD"].node;
	},
	releaseCanvasOnDestroy: true,
	document: glob.document,
	_injectGlobal(Konva$3) {
		if (typeof glob.Konva !== "undefined") console.error("Several Konva instances detected. It is not recommended to use multiple Konva instances in the same environment.");
		glob.Konva = Konva$3;
	}
};
const _registerNode = (NodeClass) => {
	Konva$2[NodeClass.prototype.getClassName()] = NodeClass;
};
Konva$2._injectGlobal(Konva$2);
var NODE_ERROR = `Konva.js unsupported environment.

Looks like you are trying to use Konva.js in Node.js environment. because "document" object is undefined.

To use Konva.js in Node.js environment, you need to use the "canvas-backend" or "skia-backend" module.

bash: npm install canvas
js: import "konva/canvas-backend";

or

bash: npm install skia-canvas
js: import "konva/skia-backend";
`;
var ensureBrowser = () => {
	if (typeof document === "undefined") throw new Error(NODE_ERROR);
};
var Transform = class Transform {
	constructor(m = [
		1,
		0,
		0,
		1,
		0,
		0
	]) {
		this.dirty = false;
		this.m = m && m.slice() || [
			1,
			0,
			0,
			1,
			0,
			0
		];
	}
	reset() {
		this.m[0] = 1;
		this.m[1] = 0;
		this.m[2] = 0;
		this.m[3] = 1;
		this.m[4] = 0;
		this.m[5] = 0;
	}
	copy() {
		return new Transform(this.m);
	}
	copyInto(tr) {
		tr.m[0] = this.m[0];
		tr.m[1] = this.m[1];
		tr.m[2] = this.m[2];
		tr.m[3] = this.m[3];
		tr.m[4] = this.m[4];
		tr.m[5] = this.m[5];
	}
	point(point) {
		const m = this.m;
		return {
			x: m[0] * point.x + m[2] * point.y + m[4],
			y: m[1] * point.x + m[3] * point.y + m[5]
		};
	}
	translate(x, y) {
		this.m[4] += this.m[0] * x + this.m[2] * y;
		this.m[5] += this.m[1] * x + this.m[3] * y;
		return this;
	}
	scale(sx, sy) {
		this.m[0] *= sx;
		this.m[1] *= sx;
		this.m[2] *= sy;
		this.m[3] *= sy;
		return this;
	}
	rotate(rad) {
		const c = Math.cos(rad);
		const s = Math.sin(rad);
		const m11 = this.m[0] * c + this.m[2] * s;
		const m12 = this.m[1] * c + this.m[3] * s;
		const m21 = this.m[0] * -s + this.m[2] * c;
		const m22 = this.m[1] * -s + this.m[3] * c;
		this.m[0] = m11;
		this.m[1] = m12;
		this.m[2] = m21;
		this.m[3] = m22;
		return this;
	}
	getTranslation() {
		return {
			x: this.m[4],
			y: this.m[5]
		};
	}
	skew(sx, sy) {
		const m11 = this.m[0] + this.m[2] * sy;
		const m12 = this.m[1] + this.m[3] * sy;
		const m21 = this.m[2] + this.m[0] * sx;
		const m22 = this.m[3] + this.m[1] * sx;
		this.m[0] = m11;
		this.m[1] = m12;
		this.m[2] = m21;
		this.m[3] = m22;
		return this;
	}
	multiply(matrix) {
		const m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
		const m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
		const m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
		const m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
		const dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
		const dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
		this.m[0] = m11;
		this.m[1] = m12;
		this.m[2] = m21;
		this.m[3] = m22;
		this.m[4] = dx;
		this.m[5] = dy;
		return this;
	}
	invert() {
		const d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
		const m0 = this.m[3] * d;
		const m1 = -this.m[1] * d;
		const m2 = -this.m[2] * d;
		const m3 = this.m[0] * d;
		const m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
		const m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
		this.m[0] = m0;
		this.m[1] = m1;
		this.m[2] = m2;
		this.m[3] = m3;
		this.m[4] = m4;
		this.m[5] = m5;
		return this;
	}
	getMatrix() {
		return this.m;
	}
	decompose() {
		const a = this.m[0];
		const b = this.m[1];
		const c = this.m[2];
		const d = this.m[3];
		const e = this.m[4];
		const f = this.m[5];
		const delta = a * d - b * c;
		const result = {
			x: e,
			y: f,
			rotation: 0,
			scaleX: 0,
			scaleY: 0,
			skewX: 0,
			skewY: 0
		};
		if (a != 0 || b != 0) {
			const r = Math.sqrt(a * a + b * b);
			result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
			result.scaleX = r;
			result.scaleY = delta / r;
			result.skewX = (a * c + b * d) / delta;
			result.skewY = 0;
		} else if (c != 0 || d != 0) {
			const s = Math.sqrt(c * c + d * d);
			result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
			result.scaleX = delta / s;
			result.scaleY = s;
			result.skewX = 0;
			result.skewY = (a * c + b * d) / delta;
		}
		result.rotation = Util._getRotation(result.rotation);
		return result;
	}
};
var OBJECT_ARRAY = "[object Array]", OBJECT_NUMBER = "[object Number]", OBJECT_STRING = "[object String]", OBJECT_BOOLEAN = "[object Boolean]", PI_OVER_DEG180 = Math.PI / 180, DEG180_OVER_PI = 180 / Math.PI, HASH = "#", EMPTY_STRING$1 = "", ZERO = "0", KONVA_WARNING = "Konva warning: ", KONVA_ERROR = "Konva error: ", RGB_PAREN = "rgb(", COLORS = {
	aliceblue: [
		240,
		248,
		255
	],
	antiquewhite: [
		250,
		235,
		215
	],
	aqua: [
		0,
		255,
		255
	],
	aquamarine: [
		127,
		255,
		212
	],
	azure: [
		240,
		255,
		255
	],
	beige: [
		245,
		245,
		220
	],
	bisque: [
		255,
		228,
		196
	],
	black: [
		0,
		0,
		0
	],
	blanchedalmond: [
		255,
		235,
		205
	],
	blue: [
		0,
		0,
		255
	],
	blueviolet: [
		138,
		43,
		226
	],
	brown: [
		165,
		42,
		42
	],
	burlywood: [
		222,
		184,
		135
	],
	cadetblue: [
		95,
		158,
		160
	],
	chartreuse: [
		127,
		255,
		0
	],
	chocolate: [
		210,
		105,
		30
	],
	coral: [
		255,
		127,
		80
	],
	cornflowerblue: [
		100,
		149,
		237
	],
	cornsilk: [
		255,
		248,
		220
	],
	crimson: [
		220,
		20,
		60
	],
	cyan: [
		0,
		255,
		255
	],
	darkblue: [
		0,
		0,
		139
	],
	darkcyan: [
		0,
		139,
		139
	],
	darkgoldenrod: [
		184,
		132,
		11
	],
	darkgray: [
		169,
		169,
		169
	],
	darkgreen: [
		0,
		100,
		0
	],
	darkgrey: [
		169,
		169,
		169
	],
	darkkhaki: [
		189,
		183,
		107
	],
	darkmagenta: [
		139,
		0,
		139
	],
	darkolivegreen: [
		85,
		107,
		47
	],
	darkorange: [
		255,
		140,
		0
	],
	darkorchid: [
		153,
		50,
		204
	],
	darkred: [
		139,
		0,
		0
	],
	darksalmon: [
		233,
		150,
		122
	],
	darkseagreen: [
		143,
		188,
		143
	],
	darkslateblue: [
		72,
		61,
		139
	],
	darkslategray: [
		47,
		79,
		79
	],
	darkslategrey: [
		47,
		79,
		79
	],
	darkturquoise: [
		0,
		206,
		209
	],
	darkviolet: [
		148,
		0,
		211
	],
	deeppink: [
		255,
		20,
		147
	],
	deepskyblue: [
		0,
		191,
		255
	],
	dimgray: [
		105,
		105,
		105
	],
	dimgrey: [
		105,
		105,
		105
	],
	dodgerblue: [
		30,
		144,
		255
	],
	firebrick: [
		178,
		34,
		34
	],
	floralwhite: [
		255,
		255,
		240
	],
	forestgreen: [
		34,
		139,
		34
	],
	fuchsia: [
		255,
		0,
		255
	],
	gainsboro: [
		220,
		220,
		220
	],
	ghostwhite: [
		248,
		248,
		255
	],
	gold: [
		255,
		215,
		0
	],
	goldenrod: [
		218,
		165,
		32
	],
	gray: [
		128,
		128,
		128
	],
	green: [
		0,
		128,
		0
	],
	greenyellow: [
		173,
		255,
		47
	],
	grey: [
		128,
		128,
		128
	],
	honeydew: [
		240,
		255,
		240
	],
	hotpink: [
		255,
		105,
		180
	],
	indianred: [
		205,
		92,
		92
	],
	indigo: [
		75,
		0,
		130
	],
	ivory: [
		255,
		255,
		240
	],
	khaki: [
		240,
		230,
		140
	],
	lavender: [
		230,
		230,
		250
	],
	lavenderblush: [
		255,
		240,
		245
	],
	lawngreen: [
		124,
		252,
		0
	],
	lemonchiffon: [
		255,
		250,
		205
	],
	lightblue: [
		173,
		216,
		230
	],
	lightcoral: [
		240,
		128,
		128
	],
	lightcyan: [
		224,
		255,
		255
	],
	lightgoldenrodyellow: [
		250,
		250,
		210
	],
	lightgray: [
		211,
		211,
		211
	],
	lightgreen: [
		144,
		238,
		144
	],
	lightgrey: [
		211,
		211,
		211
	],
	lightpink: [
		255,
		182,
		193
	],
	lightsalmon: [
		255,
		160,
		122
	],
	lightseagreen: [
		32,
		178,
		170
	],
	lightskyblue: [
		135,
		206,
		250
	],
	lightslategray: [
		119,
		136,
		153
	],
	lightslategrey: [
		119,
		136,
		153
	],
	lightsteelblue: [
		176,
		196,
		222
	],
	lightyellow: [
		255,
		255,
		224
	],
	lime: [
		0,
		255,
		0
	],
	limegreen: [
		50,
		205,
		50
	],
	linen: [
		250,
		240,
		230
	],
	magenta: [
		255,
		0,
		255
	],
	maroon: [
		128,
		0,
		0
	],
	mediumaquamarine: [
		102,
		205,
		170
	],
	mediumblue: [
		0,
		0,
		205
	],
	mediumorchid: [
		186,
		85,
		211
	],
	mediumpurple: [
		147,
		112,
		219
	],
	mediumseagreen: [
		60,
		179,
		113
	],
	mediumslateblue: [
		123,
		104,
		238
	],
	mediumspringgreen: [
		0,
		250,
		154
	],
	mediumturquoise: [
		72,
		209,
		204
	],
	mediumvioletred: [
		199,
		21,
		133
	],
	midnightblue: [
		25,
		25,
		112
	],
	mintcream: [
		245,
		255,
		250
	],
	mistyrose: [
		255,
		228,
		225
	],
	moccasin: [
		255,
		228,
		181
	],
	navajowhite: [
		255,
		222,
		173
	],
	navy: [
		0,
		0,
		128
	],
	oldlace: [
		253,
		245,
		230
	],
	olive: [
		128,
		128,
		0
	],
	olivedrab: [
		107,
		142,
		35
	],
	orange: [
		255,
		165,
		0
	],
	orangered: [
		255,
		69,
		0
	],
	orchid: [
		218,
		112,
		214
	],
	palegoldenrod: [
		238,
		232,
		170
	],
	palegreen: [
		152,
		251,
		152
	],
	paleturquoise: [
		175,
		238,
		238
	],
	palevioletred: [
		219,
		112,
		147
	],
	papayawhip: [
		255,
		239,
		213
	],
	peachpuff: [
		255,
		218,
		185
	],
	peru: [
		205,
		133,
		63
	],
	pink: [
		255,
		192,
		203
	],
	plum: [
		221,
		160,
		203
	],
	powderblue: [
		176,
		224,
		230
	],
	purple: [
		128,
		0,
		128
	],
	rebeccapurple: [
		102,
		51,
		153
	],
	red: [
		255,
		0,
		0
	],
	rosybrown: [
		188,
		143,
		143
	],
	royalblue: [
		65,
		105,
		225
	],
	saddlebrown: [
		139,
		69,
		19
	],
	salmon: [
		250,
		128,
		114
	],
	sandybrown: [
		244,
		164,
		96
	],
	seagreen: [
		46,
		139,
		87
	],
	seashell: [
		255,
		245,
		238
	],
	sienna: [
		160,
		82,
		45
	],
	silver: [
		192,
		192,
		192
	],
	skyblue: [
		135,
		206,
		235
	],
	slateblue: [
		106,
		90,
		205
	],
	slategray: [
		119,
		128,
		144
	],
	slategrey: [
		119,
		128,
		144
	],
	snow: [
		255,
		255,
		250
	],
	springgreen: [
		0,
		255,
		127
	],
	steelblue: [
		70,
		130,
		180
	],
	tan: [
		210,
		180,
		140
	],
	teal: [
		0,
		128,
		128
	],
	thistle: [
		216,
		191,
		216
	],
	transparent: [
		255,
		255,
		255,
		0
	],
	tomato: [
		255,
		99,
		71
	],
	turquoise: [
		64,
		224,
		208
	],
	violet: [
		238,
		130,
		238
	],
	wheat: [
		245,
		222,
		179
	],
	white: [
		255,
		255,
		255
	],
	whitesmoke: [
		245,
		245,
		245
	],
	yellow: [
		255,
		255,
		0
	],
	yellowgreen: [
		154,
		205,
		5
	]
}, RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
var animQueue = [];
var _isCanvasFarblingActive = null;
var req = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame || function(f) {
	setTimeout(f, 16);
};
const Util = {
	_isElement(obj) {
		return !!(obj && obj.nodeType == 1);
	},
	_isFunction(obj) {
		return !!(obj && obj.constructor && obj.call && obj.apply);
	},
	_isPlainObject(obj) {
		return !!obj && obj.constructor === Object;
	},
	_isArray(obj) {
		return Object.prototype.toString.call(obj) === OBJECT_ARRAY;
	},
	_isNumber(obj) {
		return Object.prototype.toString.call(obj) === OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
	},
	_isString(obj) {
		return Object.prototype.toString.call(obj) === OBJECT_STRING;
	},
	_isBoolean(obj) {
		return Object.prototype.toString.call(obj) === OBJECT_BOOLEAN;
	},
	isObject(val) {
		return val instanceof Object;
	},
	isValidSelector(selector) {
		if (typeof selector !== "string") return false;
		const firstChar = selector[0];
		return firstChar === "#" || firstChar === "." || firstChar === firstChar.toUpperCase();
	},
	_sign(number) {
		if (number === 0) return 1;
		if (number > 0) return 1;
		else return -1;
	},
	requestAnimFrame(callback) {
		animQueue.push(callback);
		if (animQueue.length === 1) req(function() {
			const queue = animQueue;
			animQueue = [];
			queue.forEach(function(cb) {
				cb();
			});
		});
	},
	createCanvasElement() {
		ensureBrowser();
		const canvas = document.createElement("canvas");
		try {
			canvas.style = canvas.style || {};
		} catch (e) {}
		return canvas;
	},
	createImageElement() {
		ensureBrowser();
		return document.createElement("img");
	},
	_isInDocument(el) {
		while (el = el.parentNode) if (el == document) return true;
		return false;
	},
	_urlToImage(url, callback) {
		const imageObj = Util.createImageElement();
		imageObj.onload = function() {
			callback(imageObj);
		};
		imageObj.src = url;
	},
	_rgbToHex(r, g, b) {
		return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
	},
	_hexToRgb(hex) {
		hex = hex.replace(HASH, EMPTY_STRING$1);
		const bigint = parseInt(hex, 16);
		return {
			r: bigint >> 16 & 255,
			g: bigint >> 8 & 255,
			b: bigint & 255
		};
	},
	getRandomColor() {
		let randColor = (Math.random() * 16777215 << 0).toString(16);
		while (randColor.length < 6) randColor = ZERO + randColor;
		return HASH + randColor;
	},
	isCanvasFarblingActive() {
		if (_isCanvasFarblingActive !== null) return _isCanvasFarblingActive;
		if (typeof document === "undefined") {
			_isCanvasFarblingActive = false;
			return false;
		}
		const c = this.createCanvasElement();
		c.width = 10;
		c.height = 10;
		const ctx = c.getContext("2d", { willReadFrequently: true });
		ctx.clearRect(0, 0, 10, 10);
		ctx.fillStyle = "#282828";
		ctx.fillRect(0, 0, 10, 10);
		const d = ctx.getImageData(0, 0, 10, 10).data;
		let isFarbling = false;
		for (let i = 0; i < 100; i++) if (d[i * 4] !== 40 || d[i * 4 + 1] !== 40 || d[i * 4 + 2] !== 40 || d[i * 4 + 3] !== 255) {
			isFarbling = true;
			break;
		}
		_isCanvasFarblingActive = isFarbling;
		this.releaseCanvas(c);
		return _isCanvasFarblingActive;
	},
	getHitColor() {
		const color = this.getRandomColor();
		return this.isCanvasFarblingActive() ? this.getSnappedHexColor(color) : color;
	},
	getHitColorKey(r, g, b) {
		if (this.isCanvasFarblingActive()) {
			r = Math.round(r / 5) * 5;
			g = Math.round(g / 5) * 5;
			b = Math.round(b / 5) * 5;
		}
		return HASH + this._rgbToHex(r, g, b);
	},
	getSnappedHexColor(hex) {
		const rgb = this._hexToRgb(hex);
		return HASH + this._rgbToHex(Math.round(rgb.r / 5) * 5, Math.round(rgb.g / 5) * 5, Math.round(rgb.b / 5) * 5);
	},
	getRGB(color) {
		let rgb;
		if (color in COLORS) {
			rgb = COLORS[color];
			return {
				r: rgb[0],
				g: rgb[1],
				b: rgb[2]
			};
		} else if (color[0] === HASH) return this._hexToRgb(color.substring(1));
		else if (color.substr(0, 4) === RGB_PAREN) {
			rgb = RGB_REGEX.exec(color.replace(/ /g, ""));
			return {
				r: parseInt(rgb[1], 10),
				g: parseInt(rgb[2], 10),
				b: parseInt(rgb[3], 10)
			};
		} else return {
			r: 0,
			g: 0,
			b: 0
		};
	},
	colorToRGBA(str) {
		str = str || "black";
		return Util._namedColorToRBA(str) || Util._hex3ColorToRGBA(str) || Util._hex4ColorToRGBA(str) || Util._hex6ColorToRGBA(str) || Util._hex8ColorToRGBA(str) || Util._rgbColorToRGBA(str) || Util._rgbaColorToRGBA(str) || Util._hslColorToRGBA(str);
	},
	_namedColorToRBA(str) {
		const c = COLORS[str.toLowerCase()];
		if (!c) return null;
		return {
			r: c[0],
			g: c[1],
			b: c[2],
			a: 1
		};
	},
	_rgbColorToRGBA(str) {
		if (str.indexOf("rgb(") === 0) {
			str = str.match(/rgb\(([^)]+)\)/)[1];
			const parts = str.split(/ *, */).map(Number);
			return {
				r: parts[0],
				g: parts[1],
				b: parts[2],
				a: 1
			};
		}
	},
	_rgbaColorToRGBA(str) {
		if (str.indexOf("rgba(") === 0) {
			str = str.match(/rgba\(([^)]+)\)/)[1];
			const parts = str.split(/ *, */).map((n, index) => {
				if (n.slice(-1) === "%") return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
				return Number(n);
			});
			return {
				r: parts[0],
				g: parts[1],
				b: parts[2],
				a: parts[3]
			};
		}
	},
	_hex8ColorToRGBA(str) {
		if (str[0] === "#" && str.length === 9) return {
			r: parseInt(str.slice(1, 3), 16),
			g: parseInt(str.slice(3, 5), 16),
			b: parseInt(str.slice(5, 7), 16),
			a: parseInt(str.slice(7, 9), 16) / 255
		};
	},
	_hex6ColorToRGBA(str) {
		if (str[0] === "#" && str.length === 7) return {
			r: parseInt(str.slice(1, 3), 16),
			g: parseInt(str.slice(3, 5), 16),
			b: parseInt(str.slice(5, 7), 16),
			a: 1
		};
	},
	_hex4ColorToRGBA(str) {
		if (str[0] === "#" && str.length === 5) return {
			r: parseInt(str[1] + str[1], 16),
			g: parseInt(str[2] + str[2], 16),
			b: parseInt(str[3] + str[3], 16),
			a: parseInt(str[4] + str[4], 16) / 255
		};
	},
	_hex3ColorToRGBA(str) {
		if (str[0] === "#" && str.length === 4) return {
			r: parseInt(str[1] + str[1], 16),
			g: parseInt(str[2] + str[2], 16),
			b: parseInt(str[3] + str[3], 16),
			a: 1
		};
	},
	_hslColorToRGBA(str) {
		if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
			const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
			const h$1 = Number(hsl[0]) / 360;
			const s = Number(hsl[1]) / 100;
			const l = Number(hsl[2]) / 100;
			let t2;
			let t3;
			let val;
			if (s === 0) {
				val = l * 255;
				return {
					r: Math.round(val),
					g: Math.round(val),
					b: Math.round(val),
					a: 1
				};
			}
			if (l < .5) t2 = l * (1 + s);
			else t2 = l + s - l * s;
			const t1 = 2 * l - t2;
			const rgb = [
				0,
				0,
				0
			];
			for (let i = 0; i < 3; i++) {
				t3 = h$1 + 1 / 3 * -(i - 1);
				if (t3 < 0) t3++;
				if (t3 > 1) t3--;
				if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
				else if (2 * t3 < 1) val = t2;
				else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
				else val = t1;
				rgb[i] = val * 255;
			}
			return {
				r: Math.round(rgb[0]),
				g: Math.round(rgb[1]),
				b: Math.round(rgb[2]),
				a: 1
			};
		}
	},
	haveIntersection(r1, r2) {
		return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
	},
	cloneObject(obj) {
		const retObj = {};
		for (const key in obj) if (this._isPlainObject(obj[key])) retObj[key] = this.cloneObject(obj[key]);
		else if (this._isArray(obj[key])) retObj[key] = this.cloneArray(obj[key]);
		else retObj[key] = obj[key];
		return retObj;
	},
	cloneArray(arr) {
		return arr.slice(0);
	},
	degToRad(deg) {
		return deg * PI_OVER_DEG180;
	},
	radToDeg(rad) {
		return rad * DEG180_OVER_PI;
	},
	_degToRad(deg) {
		Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead.");
		return Util.degToRad(deg);
	},
	_radToDeg(rad) {
		Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead.");
		return Util.radToDeg(rad);
	},
	_getRotation(radians) {
		return Konva$2.angleDeg ? Util.radToDeg(radians) : radians;
	},
	_capitalize(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	},
	throw(str) {
		throw new Error(KONVA_ERROR + str);
	},
	error(str) {
		console.error(KONVA_ERROR + str);
	},
	warn(str) {
		if (!Konva$2.showWarnings) return;
		console.warn(KONVA_WARNING + str);
	},
	each(obj, func) {
		for (const key in obj) func(key, obj[key]);
	},
	_inRange(val, left, right) {
		return left <= val && val < right;
	},
	_getProjectionToSegment(x1, y1, x2, y2, x3, y3) {
		let x, y, dist;
		const pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
		if (pd2 == 0) {
			x = x1;
			y = y1;
			dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
		} else {
			const u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
			if (u < 0) {
				x = x1;
				y = y1;
				dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
			} else if (u > 1) {
				x = x2;
				y = y2;
				dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
			} else {
				x = x1 + u * (x2 - x1);
				y = y1 + u * (y2 - y1);
				dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
			}
		}
		return [
			x,
			y,
			dist
		];
	},
	_getProjectionToLine(pt, line, isClosed) {
		const pc = Util.cloneObject(pt);
		let dist = Number.MAX_VALUE;
		line.forEach(function(p1, i) {
			if (!isClosed && i === line.length - 1) return;
			const p2 = line[(i + 1) % line.length];
			const proj = Util._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
			const px = proj[0], py = proj[1], pdist = proj[2];
			if (pdist < dist) {
				pc.x = px;
				pc.y = py;
				dist = pdist;
			}
		});
		return pc;
	},
	_prepareArrayForTween(startArray, endArray, isClosed) {
		const start = [], end = [];
		if (startArray.length > endArray.length) {
			const temp = endArray;
			endArray = startArray;
			startArray = temp;
		}
		for (let n = 0; n < startArray.length; n += 2) start.push({
			x: startArray[n],
			y: startArray[n + 1]
		});
		for (let n = 0; n < endArray.length; n += 2) end.push({
			x: endArray[n],
			y: endArray[n + 1]
		});
		const newStart = [];
		end.forEach(function(point) {
			const pr = Util._getProjectionToLine(point, start, isClosed);
			newStart.push(pr.x);
			newStart.push(pr.y);
		});
		return newStart;
	},
	_prepareToStringify(obj) {
		let desc;
		obj.visitedByCircularReferenceRemoval = true;
		for (const key in obj) {
			if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == "object")) continue;
			desc = Object.getOwnPropertyDescriptor(obj, key);
			if (obj[key].visitedByCircularReferenceRemoval || Util._isElement(obj[key])) if (desc.configurable) delete obj[key];
			else return null;
			else if (Util._prepareToStringify(obj[key]) === null) if (desc.configurable) delete obj[key];
			else return null;
		}
		delete obj.visitedByCircularReferenceRemoval;
		return obj;
	},
	_assign(target, source) {
		for (const key in source) target[key] = source[key];
		return target;
	},
	_getFirstPointerId(evt) {
		if (!evt.touches) return evt.pointerId || 999;
		else return evt.changedTouches[0].identifier;
	},
	releaseCanvas(...canvases) {
		if (!Konva$2.releaseCanvasOnDestroy) return;
		canvases.forEach((c) => {
			c.width = 0;
			c.height = 0;
		});
	},
	drawRoundedRectPath(context, width, height, cornerRadius) {
		let xOrigin = width < 0 ? width : 0;
		let yOrigin = height < 0 ? height : 0;
		width = Math.abs(width);
		height = Math.abs(height);
		let topLeft = 0;
		let topRight = 0;
		let bottomLeft = 0;
		let bottomRight = 0;
		if (typeof cornerRadius === "number") topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
		else {
			topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
			topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
			bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
			bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
		}
		context.moveTo(xOrigin + topLeft, yOrigin);
		context.lineTo(xOrigin + width - topRight, yOrigin);
		context.arc(xOrigin + width - topRight, yOrigin + topRight, topRight, Math.PI * 3 / 2, 0, false);
		context.lineTo(xOrigin + width, yOrigin + height - bottomRight);
		context.arc(xOrigin + width - bottomRight, yOrigin + height - bottomRight, bottomRight, 0, Math.PI / 2, false);
		context.lineTo(xOrigin + bottomLeft, yOrigin + height);
		context.arc(xOrigin + bottomLeft, yOrigin + height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
		context.lineTo(xOrigin, yOrigin + topLeft);
		context.arc(xOrigin + topLeft, yOrigin + topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
	},
	drawRoundedPolygonPath(context, points, sides, radius, cornerRadius) {
		radius = Math.abs(radius);
		for (let i = 0; i < sides; i++) {
			const prev = points[(i - 1 + sides) % sides];
			const curr = points[i];
			const next = points[(i + 1) % sides];
			const vec1 = {
				x: curr.x - prev.x,
				y: curr.y - prev.y
			};
			const vec2 = {
				x: next.x - curr.x,
				y: next.y - curr.y
			};
			const len1 = Math.hypot(vec1.x, vec1.y);
			const len2 = Math.hypot(vec2.x, vec2.y);
			let currCornerRadius;
			if (typeof cornerRadius === "number") currCornerRadius = cornerRadius;
			else currCornerRadius = i < cornerRadius.length ? cornerRadius[i] : 0;
			currCornerRadius = radius * Math.cos(Math.PI / sides) * Math.min(1, currCornerRadius / radius * 2);
			const normalVec1 = {
				x: vec1.x / len1,
				y: vec1.y / len1
			};
			const normalVec2 = {
				x: vec2.x / len2,
				y: vec2.y / len2
			};
			const p1 = {
				x: curr.x - normalVec1.x * currCornerRadius,
				y: curr.y - normalVec1.y * currCornerRadius
			};
			const p2 = {
				x: curr.x + normalVec2.x * currCornerRadius,
				y: curr.y + normalVec2.y * currCornerRadius
			};
			if (i === 0) context.moveTo(p1.x, p1.y);
			else context.lineTo(p1.x, p1.y);
			context.arcTo(curr.x, curr.y, p2.x, p2.y, currCornerRadius);
		}
	}
};
function simplifyArray(arr) {
	const retArr = [], len = arr.length, util = Util;
	for (let n = 0; n < len; n++) {
		let val = arr[n];
		if (util._isNumber(val)) val = Math.round(val * 1e3) / 1e3;
		else if (!util._isString(val)) val = val + "";
		retArr.push(val);
	}
	return retArr;
}
var COMMA = ",", OPEN_PAREN = "(", CLOSE_PAREN = ")", OPEN_PAREN_BRACKET = "([", CLOSE_BRACKET_PAREN = "])", SEMICOLON = ";", DOUBLE_PAREN = "()", EQUALS = "=", CONTEXT_METHODS = [
	"arc",
	"arcTo",
	"beginPath",
	"bezierCurveTo",
	"clearRect",
	"clip",
	"closePath",
	"createLinearGradient",
	"createPattern",
	"createRadialGradient",
	"drawImage",
	"ellipse",
	"fill",
	"fillText",
	"getImageData",
	"createImageData",
	"lineTo",
	"moveTo",
	"putImageData",
	"quadraticCurveTo",
	"rect",
	"roundRect",
	"restore",
	"rotate",
	"save",
	"scale",
	"setLineDash",
	"setTransform",
	"stroke",
	"strokeText",
	"transform",
	"translate"
];
var CONTEXT_PROPERTIES = [
	"fillStyle",
	"strokeStyle",
	"shadowColor",
	"shadowBlur",
	"shadowOffsetX",
	"shadowOffsetY",
	"letterSpacing",
	"lineCap",
	"lineDashOffset",
	"lineJoin",
	"lineWidth",
	"miterLimit",
	"direction",
	"font",
	"textAlign",
	"textBaseline",
	"globalAlpha",
	"globalCompositeOperation",
	"imageSmoothingEnabled",
	"filter"
];
var traceArrMax = 100;
var _cssFiltersSupported = null;
function isCSSFiltersSupported() {
	if (_cssFiltersSupported !== null) return _cssFiltersSupported;
	try {
		const ctx = Util.createCanvasElement().getContext("2d");
		if (!ctx) {
			_cssFiltersSupported = false;
			return false;
		}
		return !!ctx && "filter" in ctx;
	} catch (e) {
		_cssFiltersSupported = false;
		return false;
	}
}
var Context = class {
	constructor(canvas) {
		this.canvas = canvas;
		if (Konva$2.enableTrace) {
			this.traceArr = [];
			this._enableTrace();
		}
	}
	fillShape(shape) {
		if (shape.fillEnabled()) this._fill(shape);
	}
	_fill(shape) {}
	strokeShape(shape) {
		if (shape.hasStroke()) this._stroke(shape);
	}
	_stroke(shape) {}
	fillStrokeShape(shape) {
		if (shape.attrs.fillAfterStrokeEnabled) {
			this.strokeShape(shape);
			this.fillShape(shape);
		} else {
			this.fillShape(shape);
			this.strokeShape(shape);
		}
	}
	getTrace(relaxed, rounded) {
		let traceArr = this.traceArr, len = traceArr.length, str = "", n, trace, method, args;
		for (n = 0; n < len; n++) {
			trace = traceArr[n];
			method = trace.method;
			if (method) {
				args = trace.args;
				str += method;
				if (relaxed) str += DOUBLE_PAREN;
				else if (Util._isArray(args[0])) str += OPEN_PAREN_BRACKET + args.join(COMMA) + CLOSE_BRACKET_PAREN;
				else {
					if (rounded) args = args.map((a) => typeof a === "number" ? Math.floor(a) : a);
					str += OPEN_PAREN + args.join(COMMA) + CLOSE_PAREN;
				}
			} else {
				str += trace.property;
				if (!relaxed) str += EQUALS + trace.val;
			}
			str += SEMICOLON;
		}
		return str;
	}
	clearTrace() {
		this.traceArr = [];
	}
	_trace(str) {
		let traceArr = this.traceArr, len;
		traceArr.push(str);
		len = traceArr.length;
		if (len >= traceArrMax) traceArr.shift();
	}
	reset() {
		const pixelRatio = this.getCanvas().getPixelRatio();
		this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
	}
	getCanvas() {
		return this.canvas;
	}
	clear(bounds) {
		const canvas = this.getCanvas();
		if (bounds) this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
		else this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
	}
	_applyLineCap(shape) {
		const lineCap = shape.attrs.lineCap;
		if (lineCap) this.setAttr("lineCap", lineCap);
	}
	_applyOpacity(shape) {
		const absOpacity = shape.getAbsoluteOpacity();
		if (absOpacity !== 1) this.setAttr("globalAlpha", absOpacity);
	}
	_applyLineJoin(shape) {
		const lineJoin = shape.attrs.lineJoin;
		if (lineJoin) this.setAttr("lineJoin", lineJoin);
	}
	_applyMiterLimit(shape) {
		const miterLimit = shape.attrs.miterLimit;
		if (miterLimit != null) this.setAttr("miterLimit", miterLimit);
	}
	setAttr(attr, val) {
		this._context[attr] = val;
	}
	arc(x, y, radius, startAngle, endAngle, counterClockwise) {
		this._context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
	}
	arcTo(x1, y1, x2, y2, radius) {
		this._context.arcTo(x1, y1, x2, y2, radius);
	}
	beginPath() {
		this._context.beginPath();
	}
	bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
		this._context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
	}
	clearRect(x, y, width, height) {
		this._context.clearRect(x, y, width, height);
	}
	clip(...args) {
		this._context.clip.apply(this._context, args);
	}
	closePath() {
		this._context.closePath();
	}
	createImageData(width, height) {
		const a = arguments;
		if (a.length === 2) return this._context.createImageData(width, height);
		else if (a.length === 1) return this._context.createImageData(width);
	}
	createLinearGradient(x0, y0, x1, y1) {
		return this._context.createLinearGradient(x0, y0, x1, y1);
	}
	createPattern(image, repetition) {
		return this._context.createPattern(image, repetition);
	}
	createRadialGradient(x0, y0, r0, x1, y1, r1) {
		return this._context.createRadialGradient(x0, y0, r0, x1, y1, r1);
	}
	drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
		const a = arguments, _context = this._context;
		if (a.length === 3) _context.drawImage(image, sx, sy);
		else if (a.length === 5) _context.drawImage(image, sx, sy, sWidth, sHeight);
		else if (a.length === 9) _context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
	}
	ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise) {
		this._context.ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise);
	}
	isPointInPath(x, y, path, fillRule) {
		if (path) return this._context.isPointInPath(path, x, y, fillRule);
		return this._context.isPointInPath(x, y, fillRule);
	}
	fill(...args) {
		this._context.fill.apply(this._context, args);
	}
	fillRect(x, y, width, height) {
		this._context.fillRect(x, y, width, height);
	}
	strokeRect(x, y, width, height) {
		this._context.strokeRect(x, y, width, height);
	}
	fillText(text, x, y, maxWidth) {
		if (maxWidth) this._context.fillText(text, x, y, maxWidth);
		else this._context.fillText(text, x, y);
	}
	measureText(text) {
		return this._context.measureText(text);
	}
	getImageData(sx, sy, sw, sh) {
		return this._context.getImageData(sx, sy, sw, sh);
	}
	lineTo(x, y) {
		this._context.lineTo(x, y);
	}
	moveTo(x, y) {
		this._context.moveTo(x, y);
	}
	rect(x, y, width, height) {
		this._context.rect(x, y, width, height);
	}
	roundRect(x, y, width, height, radii) {
		this._context.roundRect(x, y, width, height, radii);
	}
	putImageData(imageData, dx, dy) {
		this._context.putImageData(imageData, dx, dy);
	}
	quadraticCurveTo(cpx, cpy, x, y) {
		this._context.quadraticCurveTo(cpx, cpy, x, y);
	}
	restore() {
		this._context.restore();
	}
	rotate(angle) {
		this._context.rotate(angle);
	}
	save() {
		this._context.save();
	}
	scale(x, y) {
		this._context.scale(x, y);
	}
	setLineDash(segments) {
		if (this._context.setLineDash) this._context.setLineDash(segments);
		else if ("mozDash" in this._context) this._context["mozDash"] = segments;
		else if ("webkitLineDash" in this._context) this._context["webkitLineDash"] = segments;
	}
	getLineDash() {
		return this._context.getLineDash();
	}
	setTransform(a, b, c, d, e, f) {
		this._context.setTransform(a, b, c, d, e, f);
	}
	stroke(path2d) {
		if (path2d) this._context.stroke(path2d);
		else this._context.stroke();
	}
	strokeText(text, x, y, maxWidth) {
		this._context.strokeText(text, x, y, maxWidth);
	}
	transform(a, b, c, d, e, f) {
		this._context.transform(a, b, c, d, e, f);
	}
	translate(x, y) {
		this._context.translate(x, y);
	}
	_enableTrace() {
		let that = this, len = CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
		const func = function(methodName) {
			let origMethod = that[methodName], ret;
			that[methodName] = function() {
				args = simplifyArray(Array.prototype.slice.call(arguments, 0));
				ret = origMethod.apply(that, arguments);
				that._trace({
					method: methodName,
					args
				});
				return ret;
			};
		};
		for (n = 0; n < len; n++) func(CONTEXT_METHODS[n]);
		that.setAttr = function() {
			origSetter.apply(that, arguments);
			const prop = arguments[0];
			let val = arguments[1];
			if (prop === "shadowOffsetX" || prop === "shadowOffsetY" || prop === "shadowBlur") val = val / this.canvas.getPixelRatio();
			that._trace({
				property: prop,
				val
			});
		};
	}
	_applyGlobalCompositeOperation(node) {
		const op = node.attrs.globalCompositeOperation;
		if (!(!op || op === "source-over")) this.setAttr("globalCompositeOperation", op);
	}
};
CONTEXT_PROPERTIES.forEach(function(prop) {
	Object.defineProperty(Context.prototype, prop, {
		get() {
			return this._context[prop];
		},
		set(val) {
			this._context[prop] = val;
		}
	});
});
var SceneContext = class extends Context {
	constructor(canvas, { willReadFrequently = false } = {}) {
		super(canvas);
		this._context = canvas._canvas.getContext("2d", { willReadFrequently });
	}
	_fillColor(shape) {
		const fill = shape.fill();
		this.setAttr("fillStyle", fill);
		shape._fillFunc(this);
	}
	_fillPattern(shape) {
		this.setAttr("fillStyle", shape._getFillPattern());
		shape._fillFunc(this);
	}
	_fillLinearGradient(shape) {
		const grd = shape._getLinearGradient();
		if (grd) {
			this.setAttr("fillStyle", grd);
			shape._fillFunc(this);
		}
	}
	_fillRadialGradient(shape) {
		const grd = shape._getRadialGradient();
		if (grd) {
			this.setAttr("fillStyle", grd);
			shape._fillFunc(this);
		}
	}
	_fill(shape) {
		const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
		if (hasColor && fillPriority === "color") {
			this._fillColor(shape);
			return;
		}
		const hasPattern = shape.getFillPatternImage();
		if (hasPattern && fillPriority === "pattern") {
			this._fillPattern(shape);
			return;
		}
		const hasLinearGradient = shape.getFillLinearGradientColorStops();
		if (hasLinearGradient && fillPriority === "linear-gradient") {
			this._fillLinearGradient(shape);
			return;
		}
		const hasRadialGradient = shape.getFillRadialGradientColorStops();
		if (hasRadialGradient && fillPriority === "radial-gradient") {
			this._fillRadialGradient(shape);
			return;
		}
		if (hasColor) this._fillColor(shape);
		else if (hasPattern) this._fillPattern(shape);
		else if (hasLinearGradient) this._fillLinearGradient(shape);
		else if (hasRadialGradient) this._fillRadialGradient(shape);
	}
	_strokeLinearGradient(shape) {
		const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
		if (colorStops) {
			for (let n = 0; n < colorStops.length; n += 2) grd.addColorStop(colorStops[n], colorStops[n + 1]);
			this.setAttr("strokeStyle", grd);
		}
	}
	_stroke(shape) {
		const dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
		if (shape.hasStroke()) {
			if (!strokeScaleEnabled) {
				this.save();
				const pixelRatio = this.getCanvas().getPixelRatio();
				this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
			}
			this._applyLineCap(shape);
			if (dash && shape.dashEnabled()) {
				this.setLineDash(dash);
				this.setAttr("lineDashOffset", shape.dashOffset());
			}
			this.setAttr("lineWidth", shape.strokeWidth());
			if (!shape.getShadowForStrokeEnabled()) this.setAttr("shadowColor", "rgba(0,0,0,0)");
			if (shape.getStrokeLinearGradientColorStops()) this._strokeLinearGradient(shape);
			else this.setAttr("strokeStyle", shape.stroke());
			shape._strokeFunc(this);
			if (!strokeScaleEnabled) this.restore();
		}
	}
	_applyShadow(shape) {
		var _a, _b, _c;
		const color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : "black", blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
			x: 0,
			y: 0
		}, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
		this.setAttr("shadowColor", color);
		this.setAttr("shadowBlur", blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
		this.setAttr("shadowOffsetX", offset.x * scaleX);
		this.setAttr("shadowOffsetY", offset.y * scaleY);
	}
};
var HitContext = class extends Context {
	constructor(canvas) {
		super(canvas);
		this._context = canvas._canvas.getContext("2d", { willReadFrequently: true });
	}
	_fill(shape) {
		this.save();
		this.setAttr("fillStyle", shape.colorKey);
		shape._fillFuncHit(this);
		this.restore();
	}
	strokeShape(shape) {
		if (shape.hasHitStroke()) this._stroke(shape);
	}
	_stroke(shape) {
		if (shape.hasHitStroke()) {
			const strokeScaleEnabled = shape.getStrokeScaleEnabled();
			if (!strokeScaleEnabled) {
				this.save();
				const pixelRatio = this.getCanvas().getPixelRatio();
				this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
			}
			this._applyLineCap(shape);
			const hitStrokeWidth = shape.hitStrokeWidth();
			const strokeWidth = hitStrokeWidth === "auto" ? shape.strokeWidth() : hitStrokeWidth;
			this.setAttr("lineWidth", strokeWidth);
			this.setAttr("strokeStyle", shape.colorKey);
			shape._strokeFuncHit(this);
			if (!strokeScaleEnabled) this.restore();
		}
	}
};
var _pixelRatio;
function getDevicePixelRatio() {
	if (_pixelRatio) return _pixelRatio;
	const canvas = Util.createCanvasElement();
	const context = canvas.getContext("2d");
	_pixelRatio = (function() {
		return (Konva$2._global.devicePixelRatio || 1) / (context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1);
	})();
	Util.releaseCanvas(canvas);
	return _pixelRatio;
}
var Canvas = class {
	constructor(config) {
		this.pixelRatio = 1;
		this.width = 0;
		this.height = 0;
		this.isCache = false;
		this.pixelRatio = (config || {}).pixelRatio || Konva$2.pixelRatio || getDevicePixelRatio();
		this._canvas = Util.createCanvasElement();
		this._canvas.style.padding = "0";
		this._canvas.style.margin = "0";
		this._canvas.style.border = "0";
		this._canvas.style.background = "transparent";
		this._canvas.style.position = "absolute";
		this._canvas.style.top = "0";
		this._canvas.style.left = "0";
	}
	getContext() {
		return this.context;
	}
	getPixelRatio() {
		return this.pixelRatio;
	}
	setPixelRatio(pixelRatio) {
		const previousRatio = this.pixelRatio;
		this.pixelRatio = pixelRatio;
		this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
	}
	setWidth(width) {
		this.width = this._canvas.width = width * this.pixelRatio;
		this._canvas.style.width = width + "px";
		const pixelRatio = this.pixelRatio;
		this.getContext()._context.scale(pixelRatio, pixelRatio);
	}
	setHeight(height) {
		this.height = this._canvas.height = height * this.pixelRatio;
		this._canvas.style.height = height + "px";
		const pixelRatio = this.pixelRatio;
		this.getContext()._context.scale(pixelRatio, pixelRatio);
	}
	getWidth() {
		return this.width;
	}
	getHeight() {
		return this.height;
	}
	setSize(width, height) {
		this.setWidth(width || 0);
		this.setHeight(height || 0);
	}
	toDataURL(mimeType, quality) {
		try {
			return this._canvas.toDataURL(mimeType, quality);
		} catch (e) {
			try {
				return this._canvas.toDataURL();
			} catch (err) {
				Util.error("Unable to get data URL. " + err.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.");
				return "";
			}
		}
	}
};
var SceneCanvas = class extends Canvas {
	constructor(config = {
		width: 0,
		height: 0,
		willReadFrequently: false
	}) {
		super(config);
		this.context = new SceneContext(this, { willReadFrequently: config.willReadFrequently });
		this.setSize(config.width, config.height);
	}
};
var HitCanvas = class extends Canvas {
	constructor(config = {
		width: 0,
		height: 0
	}) {
		super(config);
		this.hitCanvas = true;
		this.context = new HitContext(this);
		this.setSize(config.width, config.height);
	}
};
const DD = {
	get isDragging() {
		let flag = false;
		DD._dragElements.forEach((elem) => {
			if (elem.dragStatus === "dragging") flag = true;
		});
		return flag;
	},
	justDragged: false,
	get node() {
		let node;
		DD._dragElements.forEach((elem) => {
			node = elem.node;
		});
		return node;
	},
	_dragElements: /* @__PURE__ */ new Map(),
	_drag(evt) {
		const nodesToFireEvents = [];
		DD._dragElements.forEach((elem, key) => {
			const { node } = elem;
			const stage = node.getStage();
			stage.setPointersPositions(evt);
			if (elem.pointerId === void 0) elem.pointerId = Util._getFirstPointerId(evt);
			const pos = stage._changedPointerPositions.find((pos$1) => pos$1.id === elem.pointerId);
			if (!pos) return;
			if (elem.dragStatus !== "dragging") {
				const dragDistance = node.dragDistance();
				if (Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y)) < dragDistance) return;
				node.startDrag({ evt });
				if (!node.isDragging()) return;
			}
			node._setDragPosition(evt, elem);
			nodesToFireEvents.push(node);
		});
		nodesToFireEvents.forEach((node) => {
			if (!node.getStage()) return;
			node.fire("dragmove", {
				type: "dragmove",
				target: node,
				evt
			}, true);
		});
	},
	_endDragBefore(evt) {
		const drawNodes = [];
		DD._dragElements.forEach((elem) => {
			const { node } = elem;
			const stage = node.getStage();
			if (evt) stage.setPointersPositions(evt);
			if (!stage._changedPointerPositions.find((pos) => pos.id === elem.pointerId)) return;
			if (elem.dragStatus === "dragging" || elem.dragStatus === "stopped") {
				DD.justDragged = true;
				Konva$2._mouseListenClick = false;
				Konva$2._touchListenClick = false;
				Konva$2._pointerListenClick = false;
				elem.dragStatus = "stopped";
			}
			const drawNode = elem.node.getLayer() || elem.node instanceof Konva$2["Stage"] && elem.node;
			if (drawNode && drawNodes.indexOf(drawNode) === -1) drawNodes.push(drawNode);
		});
		drawNodes.forEach((drawNode) => {
			drawNode.draw();
		});
	},
	_endDragAfter(evt) {
		DD._dragElements.forEach((elem, key) => {
			if (elem.dragStatus === "stopped") elem.node.fire("dragend", {
				type: "dragend",
				target: elem.node,
				evt
			}, true);
			if (elem.dragStatus !== "dragging") DD._dragElements.delete(key);
		});
	}
};
if (Konva$2.isBrowser) {
	window.addEventListener("mouseup", DD._endDragBefore, true);
	window.addEventListener("touchend", DD._endDragBefore, true);
	window.addEventListener("touchcancel", DD._endDragBefore, true);
	window.addEventListener("mousemove", DD._drag);
	window.addEventListener("touchmove", DD._drag);
	window.addEventListener("mouseup", DD._endDragAfter, false);
	window.addEventListener("touchend", DD._endDragAfter, false);
	window.addEventListener("touchcancel", DD._endDragAfter, false);
}
function _formatValue(val) {
	if (Util._isString(val)) return "\"" + val + "\"";
	if (Object.prototype.toString.call(val) === "[object Number]") return val;
	if (Util._isBoolean(val)) return val;
	return Object.prototype.toString.call(val);
}
function RGBComponent(val) {
	if (val > 255) return 255;
	else if (val < 0) return 0;
	return Math.round(val);
}
function getNumberValidator() {
	if (Konva$2.isUnminified) return function(val, attr) {
		if (!Util._isNumber(val)) Util.warn(_formatValue(val) + " is a not valid value for \"" + attr + "\" attribute. The value should be a number.");
		return val;
	};
}
function getNumberOrArrayOfNumbersValidator(noOfElements) {
	if (Konva$2.isUnminified) return function(val, attr) {
		let isNumber = Util._isNumber(val);
		let isValidArray = Util._isArray(val) && val.length == noOfElements;
		if (!isNumber && !isValidArray) Util.warn(_formatValue(val) + " is a not valid value for \"" + attr + "\" attribute. The value should be a number or Array<number>(" + noOfElements + ")");
		return val;
	};
}
function getNumberOrAutoValidator() {
	if (Konva$2.isUnminified) return function(val, attr) {
		if (!(Util._isNumber(val) || val === "auto")) Util.warn(_formatValue(val) + " is a not valid value for \"" + attr + "\" attribute. The value should be a number or \"auto\".");
		return val;
	};
}
function getStringValidator() {
	if (Konva$2.isUnminified) return function(val, attr) {
		if (!Util._isString(val)) Util.warn(_formatValue(val) + " is a not valid value for \"" + attr + "\" attribute. The value should be a string.");
		return val;
	};
}
function getStringOrGradientValidator() {
	if (Konva$2.isUnminified) return function(val, attr) {
		const isString = Util._isString(val);
		const isGradient = Object.prototype.toString.call(val) === "[object CanvasGradient]" || val && val["addColorStop"];
		if (!(isString || isGradient)) Util.warn(_formatValue(val) + " is a not valid value for \"" + attr + "\" attribute. The value should be a string or a native gradient.");
		return val;
	};
}
function getNumberArrayValidator() {
	if (Konva$2.isUnminified) return function(val, attr) {
		const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
		if (TypedArray && val instanceof TypedArray) return val;
		if (!Util._isArray(val)) Util.warn(_formatValue(val) + " is a not valid value for \"" + attr + "\" attribute. The value should be a array of numbers.");
		else val.forEach(function(item) {
			if (!Util._isNumber(item)) Util.warn("\"" + attr + "\" attribute has non numeric element " + item + ". Make sure that all elements are numbers.");
		});
		return val;
	};
}
function getBooleanValidator() {
	if (Konva$2.isUnminified) return function(val, attr) {
		if (!(val === true || val === false)) Util.warn(_formatValue(val) + " is a not valid value for \"" + attr + "\" attribute. The value should be a boolean.");
		return val;
	};
}
function getComponentValidator(components) {
	if (Konva$2.isUnminified) return function(val, attr) {
		if (val === void 0 || val === null) return val;
		if (!Util.isObject(val)) Util.warn(_formatValue(val) + " is a not valid value for \"" + attr + "\" attribute. The value should be an object with properties " + components);
		return val;
	};
}
var GET = "get";
var SET$1 = "set";
const Factory = {
	addGetterSetter(constructor, attr, def, validator, after) {
		Factory.addGetter(constructor, attr, def);
		Factory.addSetter(constructor, attr, validator, after);
		Factory.addOverloadedGetterSetter(constructor, attr);
	},
	addGetter(constructor, attr, def) {
		const method = GET + Util._capitalize(attr);
		constructor.prototype[method] = constructor.prototype[method] || function() {
			const val = this.attrs[attr];
			return val === void 0 ? def : val;
		};
	},
	addSetter(constructor, attr, validator, after) {
		const method = SET$1 + Util._capitalize(attr);
		if (!constructor.prototype[method]) Factory.overWriteSetter(constructor, attr, validator, after);
	},
	overWriteSetter(constructor, attr, validator, after) {
		const method = SET$1 + Util._capitalize(attr);
		constructor.prototype[method] = function(val) {
			if (validator && val !== void 0 && val !== null) val = validator.call(this, val, attr);
			this._setAttr(attr, val);
			if (after) after.call(this);
			return this;
		};
	},
	addComponentsGetterSetter(constructor, attr, components, validator, after) {
		const len = components.length, capitalize = Util._capitalize, getter = GET + capitalize(attr), setter = SET$1 + capitalize(attr);
		constructor.prototype[getter] = function() {
			const ret = {};
			for (let n = 0; n < len; n++) {
				const component = components[n];
				ret[component] = this.getAttr(attr + capitalize(component));
			}
			return ret;
		};
		const basicValidator = getComponentValidator(components);
		constructor.prototype[setter] = function(val) {
			const oldVal = this.attrs[attr];
			if (validator) val = validator.call(this, val, attr);
			if (basicValidator) basicValidator.call(this, val, attr);
			for (const key in val) {
				if (!val.hasOwnProperty(key)) continue;
				this._setAttr(attr + capitalize(key), val[key]);
			}
			if (!val) components.forEach((component) => {
				this._setAttr(attr + capitalize(component), void 0);
			});
			this._fireChangeEvent(attr, oldVal, val);
			if (after) after.call(this);
			return this;
		};
		Factory.addOverloadedGetterSetter(constructor, attr);
	},
	addOverloadedGetterSetter(constructor, attr) {
		const capitalizedAttr = Util._capitalize(attr), setter = SET$1 + capitalizedAttr, getter = GET + capitalizedAttr;
		constructor.prototype[attr] = function() {
			if (arguments.length) {
				this[setter](arguments[0]);
				return this;
			}
			return this[getter]();
		};
	},
	addDeprecatedGetterSetter(constructor, attr, def, validator) {
		Util.error("Adding deprecated " + attr);
		const method = GET + Util._capitalize(attr);
		const message = attr + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
		constructor.prototype[method] = function() {
			Util.error(message);
			const val = this.attrs[attr];
			return val === void 0 ? def : val;
		};
		Factory.addSetter(constructor, attr, validator, function() {
			Util.error(message);
		});
		Factory.addOverloadedGetterSetter(constructor, attr);
	},
	backCompat(constructor, methods) {
		Util.each(methods, function(oldMethodName, newMethodName) {
			const method = constructor.prototype[newMethodName];
			const oldGetter = GET + Util._capitalize(oldMethodName);
			const oldSetter = SET$1 + Util._capitalize(oldMethodName);
			function deprecated() {
				method.apply(this, arguments);
				Util.error("\"" + oldMethodName + "\" method is deprecated and will be removed soon. Use \"\"" + newMethodName + "\" instead.");
			}
			constructor.prototype[oldMethodName] = deprecated;
			constructor.prototype[oldGetter] = deprecated;
			constructor.prototype[oldSetter] = deprecated;
		});
	},
	afterSetFilter() {
		this._filterUpToDate = false;
	}
};
function parseCSSFilters(cssFilter) {
	const filterRegex = /(\w+)\(([^)]+)\)/g;
	let match;
	while ((match = filterRegex.exec(cssFilter)) !== null) {
		const [, filterName, filterValue] = match;
		switch (filterName) {
			case "blur": {
				const blurRadius = parseFloat(filterValue.replace("px", ""));
				return function(imageData) {
					this.blurRadius(blurRadius * .5);
					const KonvaFilters = Konva$2.Filters;
					if (KonvaFilters && KonvaFilters.Blur) KonvaFilters.Blur.call(this, imageData);
				};
			}
			case "brightness": {
				const brightness = filterValue.includes("%") ? parseFloat(filterValue) / 100 : parseFloat(filterValue);
				return function(imageData) {
					this.brightness(brightness);
					const KonvaFilters = Konva$2.Filters;
					if (KonvaFilters && KonvaFilters.Brightness) KonvaFilters.Brightness.call(this, imageData);
				};
			}
			case "contrast": {
				const contrast = parseFloat(filterValue);
				return function(imageData) {
					const konvaContrast = 100 * (Math.sqrt(contrast) - 1);
					this.contrast(konvaContrast);
					const KonvaFilters = Konva$2.Filters;
					if (KonvaFilters && KonvaFilters.Contrast) KonvaFilters.Contrast.call(this, imageData);
				};
			}
			case "grayscale": return function(imageData) {
				const KonvaFilters = Konva$2.Filters;
				if (KonvaFilters && KonvaFilters.Grayscale) KonvaFilters.Grayscale.call(this, imageData);
			};
			case "sepia": return function(imageData) {
				const KonvaFilters = Konva$2.Filters;
				if (KonvaFilters && KonvaFilters.Sepia) KonvaFilters.Sepia.call(this, imageData);
			};
			case "invert": return function(imageData) {
				const KonvaFilters = Konva$2.Filters;
				if (KonvaFilters && KonvaFilters.Invert) KonvaFilters.Invert.call(this, imageData);
			};
			default:
				Util.warn(`CSS filter "${filterName}" is not supported in fallback mode. Consider using function filters for better compatibility.`);
				break;
		}
	}
	return () => {};
}
var ABSOLUTE_OPACITY = "absoluteOpacity", ALL_LISTENERS = "allEventListeners", ABSOLUTE_TRANSFORM = "absoluteTransform", ABSOLUTE_SCALE = "absoluteScale", CANVAS = "canvas", CHANGE = "Change", CHILDREN = "children", KONVA = "konva", LISTENING = "listening", MOUSEENTER$1 = "mouseenter", MOUSELEAVE$1 = "mouseleave", POINTERENTER$1 = "pointerenter", POINTERLEAVE$1 = "pointerleave", TOUCHENTER = "touchenter", TOUCHLEAVE = "touchleave", SET = "set", SHAPE = "Shape", SPACE$1 = " ", STAGE$1 = "stage", TRANSFORM = "transform", UPPER_STAGE = "Stage", VISIBLE = "visible", TRANSFORM_CHANGE_STR$1 = [
	"xChange.konva",
	"yChange.konva",
	"scaleXChange.konva",
	"scaleYChange.konva",
	"skewXChange.konva",
	"skewYChange.konva",
	"rotationChange.konva",
	"offsetXChange.konva",
	"offsetYChange.konva",
	"transformsEnabledChange.konva"
].join(SPACE$1);
var idCounter$1 = 1;
var Node$1 = class Node$1 {
	constructor(config) {
		this._id = idCounter$1++;
		this.eventListeners = {};
		this.attrs = {};
		this.index = 0;
		this._allEventListeners = null;
		this.parent = null;
		this._cache = /* @__PURE__ */ new Map();
		this._attachedDepsListeners = /* @__PURE__ */ new Map();
		this._lastPos = null;
		this._batchingTransformChange = false;
		this._needClearTransformCache = false;
		this._filterUpToDate = false;
		this._isUnderCache = false;
		this._dragEventId = null;
		this._shouldFireChangeEvents = false;
		this.setAttrs(config);
		this._shouldFireChangeEvents = true;
	}
	hasChildren() {
		return false;
	}
	_clearCache(attr) {
		if ((attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM) && this._cache.get(attr)) this._cache.get(attr).dirty = true;
		else if (attr) this._cache.delete(attr);
		else this._cache.clear();
	}
	_getCache(attr, privateGetter) {
		let cache = this._cache.get(attr);
		if (cache === void 0 || (attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM) && cache.dirty === true) {
			cache = privateGetter.call(this);
			this._cache.set(attr, cache);
		}
		return cache;
	}
	_calculate(name, deps, getter) {
		if (!this._attachedDepsListeners.get(name)) {
			const depsString = deps.map((dep) => dep + "Change.konva").join(SPACE$1);
			this.on(depsString, () => {
				this._clearCache(name);
			});
			this._attachedDepsListeners.set(name, true);
		}
		return this._getCache(name, getter);
	}
	_getCanvasCache() {
		return this._cache.get(CANVAS);
	}
	_clearSelfAndDescendantCache(attr) {
		this._clearCache(attr);
		if (attr === ABSOLUTE_TRANSFORM) this.fire("absoluteTransformChange");
	}
	clearCache() {
		if (this._cache.has(CANVAS)) {
			const { scene, filter, hit } = this._cache.get(CANVAS);
			Util.releaseCanvas(scene._canvas, filter._canvas, hit._canvas);
			this._cache.delete(CANVAS);
		}
		this._clearSelfAndDescendantCache();
		this._requestDraw();
		return this;
	}
	cache(config) {
		const conf = config || {};
		let rect = {};
		if (conf.x === void 0 || conf.y === void 0 || conf.width === void 0 || conf.height === void 0) rect = this.getClientRect({
			skipTransform: true,
			relativeTo: this.getParent() || void 0
		});
		let width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === void 0 ? Math.floor(rect.x) : conf.x, y = conf.y === void 0 ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
		if (!width || !height) {
			Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
			return;
		}
		const extraPaddingX = Math.abs(Math.round(rect.x) - x) > .5 ? 1 : 0;
		const extraPaddingY = Math.abs(Math.round(rect.y) - y) > .5 ? 1 : 0;
		width += offset * 2 + extraPaddingX;
		height += offset * 2 + extraPaddingY;
		x -= offset;
		y -= offset;
		const cachedSceneCanvas = new SceneCanvas({
			pixelRatio,
			width,
			height
		}), cachedFilterCanvas = new SceneCanvas({
			pixelRatio,
			width: 0,
			height: 0,
			willReadFrequently: true
		}), cachedHitCanvas = new HitCanvas({
			pixelRatio: hitCanvasPixelRatio,
			width,
			height
		}), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
		const bufferCanvas = new SceneCanvas({
			width: cachedSceneCanvas.width / cachedSceneCanvas.pixelRatio + Math.abs(x),
			height: cachedSceneCanvas.height / cachedSceneCanvas.pixelRatio + Math.abs(y),
			pixelRatio: cachedSceneCanvas.pixelRatio
		}), bufferContext = bufferCanvas.getContext();
		cachedHitCanvas.isCache = true;
		cachedSceneCanvas.isCache = true;
		this._cache.delete(CANVAS);
		this._filterUpToDate = false;
		if (conf.imageSmoothingEnabled === false) {
			cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
			cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
		}
		sceneContext.save();
		hitContext.save();
		bufferContext.save();
		sceneContext.translate(-x, -y);
		hitContext.translate(-x, -y);
		bufferContext.translate(-x, -y);
		bufferCanvas.x = x;
		bufferCanvas.y = y;
		this._isUnderCache = true;
		this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
		this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
		this.drawScene(cachedSceneCanvas, this, bufferCanvas);
		this.drawHit(cachedHitCanvas, this);
		this._isUnderCache = false;
		sceneContext.restore();
		hitContext.restore();
		if (drawBorder) {
			sceneContext.save();
			sceneContext.beginPath();
			sceneContext.rect(0, 0, width, height);
			sceneContext.closePath();
			sceneContext.setAttr("strokeStyle", "red");
			sceneContext.setAttr("lineWidth", 5);
			sceneContext.stroke();
			sceneContext.restore();
		}
		Util.releaseCanvas(bufferCanvas._canvas);
		this._cache.set(CANVAS, {
			scene: cachedSceneCanvas,
			filter: cachedFilterCanvas,
			hit: cachedHitCanvas,
			x,
			y
		});
		this._requestDraw();
		return this;
	}
	isCached() {
		return this._cache.has(CANVAS);
	}
	getClientRect(config) {
		throw new Error("abstract \"getClientRect\" method call");
	}
	_transformedRect(rect, top) {
		const points = [
			{
				x: rect.x,
				y: rect.y
			},
			{
				x: rect.x + rect.width,
				y: rect.y
			},
			{
				x: rect.x + rect.width,
				y: rect.y + rect.height
			},
			{
				x: rect.x,
				y: rect.y + rect.height
			}
		];
		let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
		const trans = this.getAbsoluteTransform(top);
		points.forEach(function(point) {
			const transformed = trans.point(point);
			if (minX === void 0) {
				minX = maxX = transformed.x;
				minY = maxY = transformed.y;
			}
			minX = Math.min(minX, transformed.x);
			minY = Math.min(minY, transformed.y);
			maxX = Math.max(maxX, transformed.x);
			maxY = Math.max(maxY, transformed.y);
		});
		return {
			x: minX,
			y: minY,
			width: maxX - minX,
			height: maxY - minY
		};
	}
	_drawCachedSceneCanvas(context) {
		context.save();
		context._applyOpacity(this);
		context._applyGlobalCompositeOperation(this);
		const canvasCache = this._getCanvasCache();
		context.translate(canvasCache.x, canvasCache.y);
		const cacheCanvas = this._getCachedSceneCanvas();
		const ratio = cacheCanvas.pixelRatio;
		context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
		context.restore();
	}
	_drawCachedHitCanvas(context) {
		const canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
		context.save();
		context.translate(canvasCache.x, canvasCache.y);
		context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
		context.restore();
	}
	_getCachedSceneCanvas() {
		let filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
		if (!filters || filters.length === 0) return sceneCanvas;
		if (this._filterUpToDate) return filterCanvas;
		let useNativeOnly = true;
		for (let i = 0; i < filters.length; i++) {
			if (typeof filters[i] === "string" && !isCSSFiltersSupported()) {}
			if (typeof filters[i] !== "string" || !isCSSFiltersSupported()) {
				useNativeOnly = false;
				break;
			}
		}
		const ratio = sceneCanvas.pixelRatio;
		filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
		if (useNativeOnly) {
			const finalFilter = filters.join(" ");
			filterContext.save();
			filterContext.setAttr("filter", finalFilter);
			filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
			filterContext.restore();
			this._filterUpToDate = true;
			return filterCanvas;
		}
		try {
			len = filters.length;
			filterContext.clear();
			filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
			imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
			for (n = 0; n < len; n++) {
				filter = filters[n];
				if (typeof filter === "string") filter = parseCSSFilters(filter);
				filter.call(this, imageData);
				filterContext.putImageData(imageData, 0, 0);
			}
		} catch (e) {
			Util.error("Unable to apply filter. " + e.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
		}
		this._filterUpToDate = true;
		return filterCanvas;
	}
	on(...args) {
		const evtStr = args[0];
		const selectorOrHandler = args[1];
		args[2];
		if (this._cache) this._cache.delete(ALL_LISTENERS);
		if (args.length === 3) return this._delegate.apply(this, args);
		const events = evtStr.split(SPACE$1);
		for (let n = 0; n < events.length; n++) {
			const parts = events[n].split(".");
			const baseEvent = parts[0];
			const name = parts[1] || "";
			if (!this.eventListeners[baseEvent]) this.eventListeners[baseEvent] = [];
			this.eventListeners[baseEvent].push({
				name,
				handler: selectorOrHandler
			});
		}
		return this;
	}
	off(evtStr, callback) {
		let events = (evtStr || "").split(SPACE$1), len = events.length, n, t, event, parts, baseEvent, name;
		this._cache && this._cache.delete(ALL_LISTENERS);
		if (!evtStr) for (t in this.eventListeners) this._off(t);
		for (n = 0; n < len; n++) {
			event = events[n];
			parts = event.split(".");
			baseEvent = parts[0];
			name = parts[1];
			if (baseEvent) {
				if (this.eventListeners[baseEvent]) this._off(baseEvent, name, callback);
			} else for (t in this.eventListeners) this._off(t, name, callback);
		}
		return this;
	}
	dispatchEvent(evt) {
		const e = {
			target: this,
			type: evt.type,
			evt
		};
		this.fire(evt.type, e);
		return this;
	}
	addEventListener(type, handler) {
		this.on(type, function(evt) {
			handler.call(this, evt.evt);
		});
		return this;
	}
	removeEventListener(type) {
		this.off(type);
		return this;
	}
	_delegate(event, selector, handler) {
		const stopNode = this;
		this.on(event, function(evt) {
			const targets = evt.target.findAncestors(selector, true, stopNode);
			for (let i = 0; i < targets.length; i++) {
				evt = Util.cloneObject(evt);
				evt.currentTarget = targets[i];
				handler.call(targets[i], evt);
			}
		});
		return this;
	}
	remove() {
		if (this.isDragging()) this.stopDrag();
		DD._dragElements.delete(this._id);
		DD._dragElements.forEach((elem, key) => {
			if (this.isAncestorOf(elem.node)) DD._dragElements.delete(key);
		});
		this._remove();
		return this;
	}
	_clearCaches() {
		this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
		this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
		this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
		this._clearSelfAndDescendantCache(STAGE$1);
		this._clearSelfAndDescendantCache(VISIBLE);
		this._clearSelfAndDescendantCache(LISTENING);
	}
	_remove() {
		this._clearCaches();
		const parent = this.getParent();
		if (parent && parent.children) {
			parent.children.splice(this.index, 1);
			parent._setChildrenIndices();
			this.parent = null;
		}
	}
	destroy() {
		this.remove();
		this.clearCache();
		return this;
	}
	getAttr(attr) {
		const method = "get" + Util._capitalize(attr);
		if (Util._isFunction(this[method])) return this[method]();
		return this.attrs[attr];
	}
	getAncestors() {
		let parent = this.getParent(), ancestors = [];
		while (parent) {
			ancestors.push(parent);
			parent = parent.getParent();
		}
		return ancestors;
	}
	getAttrs() {
		return this.attrs || {};
	}
	setAttrs(config) {
		this._batchTransformChanges(() => {
			let key, method;
			if (!config) return this;
			for (key in config) {
				if (key === CHILDREN) continue;
				method = SET + Util._capitalize(key);
				if (Util._isFunction(this[method])) this[method](config[key]);
				else this._setAttr(key, config[key]);
			}
		});
		return this;
	}
	isListening() {
		return this._getCache(LISTENING, this._isListening);
	}
	_isListening(relativeTo) {
		if (!this.listening()) return false;
		const parent = this.getParent();
		if (parent && parent !== relativeTo && this !== relativeTo) return parent._isListening(relativeTo);
		else return true;
	}
	isVisible() {
		return this._getCache(VISIBLE, this._isVisible);
	}
	_isVisible(relativeTo) {
		if (!this.visible()) return false;
		const parent = this.getParent();
		if (parent && parent !== relativeTo && this !== relativeTo) return parent._isVisible(relativeTo);
		else return true;
	}
	shouldDrawHit(top, skipDragCheck = false) {
		if (top) return this._isVisible(top) && this._isListening(top);
		const layer = this.getLayer();
		let layerUnderDrag = false;
		DD._dragElements.forEach((elem) => {
			if (elem.dragStatus !== "dragging") return;
			else if (elem.node.nodeType === "Stage") layerUnderDrag = true;
			else if (elem.node.getLayer() === layer) layerUnderDrag = true;
		});
		const dragSkip = !skipDragCheck && !Konva$2.hitOnDragEnabled && (layerUnderDrag || Konva$2.isTransforming());
		return this.isListening() && this.isVisible() && !dragSkip;
	}
	show() {
		this.visible(true);
		return this;
	}
	hide() {
		this.visible(false);
		return this;
	}
	getZIndex() {
		return this.index || 0;
	}
	getAbsoluteZIndex() {
		let depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
		function addChildren(children) {
			nodes = [];
			len = children.length;
			for (n = 0; n < len; n++) {
				child = children[n];
				index++;
				if (child.nodeType !== SHAPE) nodes = nodes.concat(child.getChildren().slice());
				if (child._id === that._id) n = len;
			}
			if (nodes.length > 0 && nodes[0].getDepth() <= depth) addChildren(nodes);
		}
		const stage = this.getStage();
		if (that.nodeType !== UPPER_STAGE && stage) addChildren(stage.getChildren());
		return index;
	}
	getDepth() {
		let depth = 0, parent = this.parent;
		while (parent) {
			depth++;
			parent = parent.parent;
		}
		return depth;
	}
	_batchTransformChanges(func) {
		this._batchingTransformChange = true;
		func();
		this._batchingTransformChange = false;
		if (this._needClearTransformCache) {
			this._clearCache(TRANSFORM);
			this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
		}
		this._needClearTransformCache = false;
	}
	setPosition(pos) {
		this._batchTransformChanges(() => {
			this.x(pos.x);
			this.y(pos.y);
		});
		return this;
	}
	getPosition() {
		return {
			x: this.x(),
			y: this.y()
		};
	}
	getRelativePointerPosition() {
		const stage = this.getStage();
		if (!stage) return null;
		const pos = stage.getPointerPosition();
		if (!pos) return null;
		const transform = this.getAbsoluteTransform().copy();
		transform.invert();
		return transform.point(pos);
	}
	getAbsolutePosition(top) {
		let haveCachedParent = false;
		let parent = this.parent;
		while (parent) {
			if (parent.isCached()) {
				haveCachedParent = true;
				break;
			}
			parent = parent.parent;
		}
		if (haveCachedParent && !top) top = true;
		const absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new Transform(), offset = this.offset();
		absoluteTransform.m = absoluteMatrix.slice();
		absoluteTransform.translate(offset.x, offset.y);
		return absoluteTransform.getTranslation();
	}
	setAbsolutePosition(pos) {
		const { x, y, ...origTrans } = this._clearTransform();
		this.attrs.x = x;
		this.attrs.y = y;
		this._clearCache(TRANSFORM);
		const it = this._getAbsoluteTransform().copy();
		it.invert();
		it.translate(pos.x, pos.y);
		pos = {
			x: this.attrs.x + it.getTranslation().x,
			y: this.attrs.y + it.getTranslation().y
		};
		this._setTransform(origTrans);
		this.setPosition({
			x: pos.x,
			y: pos.y
		});
		this._clearCache(TRANSFORM);
		this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
		return this;
	}
	_setTransform(trans) {
		let key;
		for (key in trans) this.attrs[key] = trans[key];
	}
	_clearTransform() {
		const trans = {
			x: this.x(),
			y: this.y(),
			rotation: this.rotation(),
			scaleX: this.scaleX(),
			scaleY: this.scaleY(),
			offsetX: this.offsetX(),
			offsetY: this.offsetY(),
			skewX: this.skewX(),
			skewY: this.skewY()
		};
		this.attrs.x = 0;
		this.attrs.y = 0;
		this.attrs.rotation = 0;
		this.attrs.scaleX = 1;
		this.attrs.scaleY = 1;
		this.attrs.offsetX = 0;
		this.attrs.offsetY = 0;
		this.attrs.skewX = 0;
		this.attrs.skewY = 0;
		return trans;
	}
	move(change) {
		let changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
		if (changeX !== void 0) x += changeX;
		if (changeY !== void 0) y += changeY;
		this.setPosition({
			x,
			y
		});
		return this;
	}
	_eachAncestorReverse(func, top) {
		let family = [], parent = this.getParent(), len, n;
		if (top && top._id === this._id) return;
		family.unshift(this);
		while (parent && (!top || parent._id !== top._id)) {
			family.unshift(parent);
			parent = parent.parent;
		}
		len = family.length;
		for (n = 0; n < len; n++) func(family[n]);
	}
	rotate(theta) {
		this.rotation(this.rotation() + theta);
		return this;
	}
	moveToTop() {
		if (!this.parent) {
			Util.warn("Node has no parent. moveToTop function is ignored.");
			return false;
		}
		const index = this.index;
		if (index < this.parent.getChildren().length - 1) {
			this.parent.children.splice(index, 1);
			this.parent.children.push(this);
			this.parent._setChildrenIndices();
			return true;
		}
		return false;
	}
	moveUp() {
		if (!this.parent) {
			Util.warn("Node has no parent. moveUp function is ignored.");
			return false;
		}
		const index = this.index;
		if (index < this.parent.getChildren().length - 1) {
			this.parent.children.splice(index, 1);
			this.parent.children.splice(index + 1, 0, this);
			this.parent._setChildrenIndices();
			return true;
		}
		return false;
	}
	moveDown() {
		if (!this.parent) {
			Util.warn("Node has no parent. moveDown function is ignored.");
			return false;
		}
		const index = this.index;
		if (index > 0) {
			this.parent.children.splice(index, 1);
			this.parent.children.splice(index - 1, 0, this);
			this.parent._setChildrenIndices();
			return true;
		}
		return false;
	}
	moveToBottom() {
		if (!this.parent) {
			Util.warn("Node has no parent. moveToBottom function is ignored.");
			return false;
		}
		const index = this.index;
		if (index > 0) {
			this.parent.children.splice(index, 1);
			this.parent.children.unshift(this);
			this.parent._setChildrenIndices();
			return true;
		}
		return false;
	}
	setZIndex(zIndex) {
		if (!this.parent) {
			Util.warn("Node has no parent. zIndex parameter is ignored.");
			return this;
		}
		if (zIndex < 0 || zIndex >= this.parent.children.length) Util.warn("Unexpected value " + zIndex + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
		const index = this.index;
		this.parent.children.splice(index, 1);
		this.parent.children.splice(zIndex, 0, this);
		this.parent._setChildrenIndices();
		return this;
	}
	getAbsoluteOpacity() {
		return this._getCache(ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
	}
	_getAbsoluteOpacity() {
		let absOpacity = this.opacity();
		const parent = this.getParent();
		if (parent && !parent._isUnderCache) absOpacity *= parent.getAbsoluteOpacity();
		return absOpacity;
	}
	moveTo(newContainer) {
		if (this.getParent() !== newContainer) {
			this._remove();
			newContainer.add(this);
		}
		return this;
	}
	toObject() {
		let attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
		const obj = {
			attrs: {},
			className: this.getClassName()
		};
		for (key in attrs) {
			val = attrs[key];
			nonPlainObject = Util.isObject(val) && !Util._isPlainObject(val) && !Util._isArray(val);
			if (nonPlainObject) continue;
			getter = typeof this[key] === "function" && this[key];
			delete attrs[key];
			defaultValue = getter ? getter.call(this) : null;
			attrs[key] = val;
			if (defaultValue !== val) obj.attrs[key] = val;
		}
		return Util._prepareToStringify(obj);
	}
	toJSON() {
		return JSON.stringify(this.toObject());
	}
	getParent() {
		return this.parent;
	}
	findAncestors(selector, includeSelf, stopNode) {
		const res = [];
		if (includeSelf && this._isMatch(selector)) res.push(this);
		let ancestor = this.parent;
		while (ancestor) {
			if (ancestor === stopNode) return res;
			if (ancestor._isMatch(selector)) res.push(ancestor);
			ancestor = ancestor.parent;
		}
		return res;
	}
	isAncestorOf(node) {
		return false;
	}
	findAncestor(selector, includeSelf, stopNode) {
		return this.findAncestors(selector, includeSelf, stopNode)[0];
	}
	_isMatch(selector) {
		if (!selector) return false;
		if (typeof selector === "function") return selector(this);
		let selectorArr = selector.replace(/ /g, "").split(","), len = selectorArr.length, n, sel;
		for (n = 0; n < len; n++) {
			sel = selectorArr[n];
			if (!Util.isValidSelector(sel)) {
				Util.warn("Selector \"" + sel + "\" is invalid. Allowed selectors examples are \"#foo\", \".bar\" or \"Group\".");
				Util.warn("If you have a custom shape with such className, please change it to start with upper letter like \"Triangle\".");
				Util.warn("Konva is awesome, right?");
			}
			if (sel.charAt(0) === "#") {
				if (this.id() === sel.slice(1)) return true;
			} else if (sel.charAt(0) === ".") {
				if (this.hasName(sel.slice(1))) return true;
			} else if (this.className === sel || this.nodeType === sel) return true;
		}
		return false;
	}
	getLayer() {
		const parent = this.getParent();
		return parent ? parent.getLayer() : null;
	}
	getStage() {
		return this._getCache(STAGE$1, this._getStage);
	}
	_getStage() {
		const parent = this.getParent();
		if (parent) return parent.getStage();
		else return null;
	}
	fire(eventType, evt = {}, bubble) {
		evt.target = evt.target || this;
		if (bubble) this._fireAndBubble(eventType, evt);
		else this._fire(eventType, evt);
		return this;
	}
	getAbsoluteTransform(top) {
		if (top) return this._getAbsoluteTransform(top);
		else return this._getCache(ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
	}
	_getAbsoluteTransform(top) {
		let at;
		if (top) {
			at = new Transform();
			this._eachAncestorReverse(function(node) {
				const transformsEnabled = node.transformsEnabled();
				if (transformsEnabled === "all") at.multiply(node.getTransform());
				else if (transformsEnabled === "position") at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
			}, top);
			return at;
		} else {
			at = this._cache.get(ABSOLUTE_TRANSFORM) || new Transform();
			if (this.parent) this.parent.getAbsoluteTransform().copyInto(at);
			else at.reset();
			const transformsEnabled = this.transformsEnabled();
			if (transformsEnabled === "all") at.multiply(this.getTransform());
			else if (transformsEnabled === "position") {
				const x = this.attrs.x || 0;
				const y = this.attrs.y || 0;
				const offsetX = this.attrs.offsetX || 0;
				const offsetY = this.attrs.offsetY || 0;
				at.translate(x - offsetX, y - offsetY);
			}
			at.dirty = false;
			return at;
		}
	}
	getAbsoluteScale(top) {
		let parent = this;
		while (parent) {
			if (parent._isUnderCache) top = parent;
			parent = parent.getParent();
		}
		const attrs = this.getAbsoluteTransform(top).decompose();
		return {
			x: attrs.scaleX,
			y: attrs.scaleY
		};
	}
	getAbsoluteRotation() {
		return this.getAbsoluteTransform().decompose().rotation;
	}
	getTransform() {
		return this._getCache(TRANSFORM, this._getTransform);
	}
	_getTransform() {
		var _a, _b;
		const m = this._cache.get(TRANSFORM) || new Transform();
		m.reset();
		const x = this.x(), y = this.y(), rotation = Konva$2.getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
		if (x !== 0 || y !== 0) m.translate(x, y);
		if (rotation !== 0) m.rotate(rotation);
		if (skewX !== 0 || skewY !== 0) m.skew(skewX, skewY);
		if (scaleX !== 1 || scaleY !== 1) m.scale(scaleX, scaleY);
		if (offsetX !== 0 || offsetY !== 0) m.translate(-1 * offsetX, -1 * offsetY);
		m.dirty = false;
		return m;
	}
	clone(obj) {
		let attrs = Util.cloneObject(this.attrs), key, allListeners, len, n, listener;
		for (key in obj) attrs[key] = obj[key];
		const node = new this.constructor(attrs);
		for (key in this.eventListeners) {
			allListeners = this.eventListeners[key];
			len = allListeners.length;
			for (n = 0; n < len; n++) {
				listener = allListeners[n];
				if (listener.name.indexOf(KONVA) < 0) {
					if (!node.eventListeners[key]) node.eventListeners[key] = [];
					node.eventListeners[key].push(listener);
				}
			}
		}
		return node;
	}
	_toKonvaCanvas(config) {
		config = config || {};
		const box = this.getClientRect();
		const stage = this.getStage(), x = config.x !== void 0 ? config.x : Math.floor(box.x), y = config.y !== void 0 ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new SceneCanvas({
			width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
			height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
			pixelRatio
		}), context = canvas.getContext();
		const bufferCanvas = new SceneCanvas({
			width: canvas.width / canvas.pixelRatio + Math.abs(x),
			height: canvas.height / canvas.pixelRatio + Math.abs(y),
			pixelRatio: canvas.pixelRatio
		});
		if (config.imageSmoothingEnabled === false) context._context.imageSmoothingEnabled = false;
		context.save();
		if (x || y) context.translate(-1 * x, -1 * y);
		this.drawScene(canvas, void 0, bufferCanvas);
		context.restore();
		return canvas;
	}
	toCanvas(config) {
		return this._toKonvaCanvas(config)._canvas;
	}
	toDataURL(config) {
		config = config || {};
		const mimeType = config.mimeType || null, quality = config.quality || null;
		const url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
		if (config.callback) config.callback(url);
		return url;
	}
	toImage(config) {
		return new Promise((resolve, reject) => {
			try {
				const callback = config === null || config === void 0 ? void 0 : config.callback;
				if (callback) delete config.callback;
				Util._urlToImage(this.toDataURL(config), function(img) {
					resolve(img);
					callback === null || callback === void 0 || callback(img);
				});
			} catch (err) {
				reject(err);
			}
		});
	}
	toBlob(config) {
		return new Promise((resolve, reject) => {
			try {
				const callback = config === null || config === void 0 ? void 0 : config.callback;
				if (callback) delete config.callback;
				this.toCanvas(config).toBlob((blob) => {
					resolve(blob);
					callback === null || callback === void 0 || callback(blob);
				}, config === null || config === void 0 ? void 0 : config.mimeType, config === null || config === void 0 ? void 0 : config.quality);
			} catch (err) {
				reject(err);
			}
		});
	}
	setSize(size) {
		this.width(size.width);
		this.height(size.height);
		return this;
	}
	getSize() {
		return {
			width: this.width(),
			height: this.height()
		};
	}
	getClassName() {
		return this.className || this.nodeType;
	}
	getType() {
		return this.nodeType;
	}
	getDragDistance() {
		if (this.attrs.dragDistance !== void 0) return this.attrs.dragDistance;
		else if (this.parent) return this.parent.getDragDistance();
		else return Konva$2.dragDistance;
	}
	_off(type, name, callback) {
		let evtListeners = this.eventListeners[type], i, evtName, handler;
		for (i = 0; i < evtListeners.length; i++) {
			evtName = evtListeners[i].name;
			handler = evtListeners[i].handler;
			if ((evtName !== "konva" || name === "konva") && (!name || evtName === name) && (!callback || callback === handler)) {
				evtListeners.splice(i, 1);
				if (evtListeners.length === 0) {
					delete this.eventListeners[type];
					break;
				}
				i--;
			}
		}
	}
	_fireChangeEvent(attr, oldVal, newVal) {
		this._fire(attr + CHANGE, {
			oldVal,
			newVal
		});
	}
	addName(name) {
		if (!this.hasName(name)) {
			const oldName = this.name();
			const newName = oldName ? oldName + " " + name : name;
			this.name(newName);
		}
		return this;
	}
	hasName(name) {
		if (!name) return false;
		const fullName = this.name();
		if (!fullName) return false;
		return (fullName || "").split(/\s/g).indexOf(name) !== -1;
	}
	removeName(name) {
		const names = (this.name() || "").split(/\s/g);
		const index = names.indexOf(name);
		if (index !== -1) {
			names.splice(index, 1);
			this.name(names.join(" "));
		}
		return this;
	}
	setAttr(attr, val) {
		const func = this[SET + Util._capitalize(attr)];
		if (Util._isFunction(func)) func.call(this, val);
		else this._setAttr(attr, val);
		return this;
	}
	_requestDraw() {
		if (Konva$2.autoDrawEnabled) {
			const drawNode = this.getLayer() || this.getStage();
			drawNode === null || drawNode === void 0 || drawNode.batchDraw();
		}
	}
	_setAttr(key, val) {
		const oldVal = this.attrs[key];
		if (oldVal === val && !Util.isObject(val)) return;
		if (val === void 0 || val === null) delete this.attrs[key];
		else this.attrs[key] = val;
		if (this._shouldFireChangeEvents) this._fireChangeEvent(key, oldVal, val);
		this._requestDraw();
	}
	_setComponentAttr(key, component, val) {
		let oldVal;
		if (val !== void 0) {
			oldVal = this.attrs[key];
			if (!oldVal) this.attrs[key] = this.getAttr(key);
			this.attrs[key][component] = val;
			this._fireChangeEvent(key, oldVal, val);
		}
	}
	_fireAndBubble(eventType, evt, compareShape) {
		if (evt && this.nodeType === SHAPE) evt.target = this;
		const nonBubbling = [
			MOUSEENTER$1,
			MOUSELEAVE$1,
			POINTERENTER$1,
			POINTERLEAVE$1,
			TOUCHENTER,
			TOUCHLEAVE
		];
		if (!(nonBubbling.indexOf(eventType) !== -1 && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === "Stage" && !compareShape))) {
			this._fire(eventType, evt);
			const stopBubble = nonBubbling.indexOf(eventType) !== -1 && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
			if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) if (compareShape && compareShape.parent) this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
			else this._fireAndBubble.call(this.parent, eventType, evt);
		}
	}
	_getProtoListeners(eventType) {
		var _a, _b;
		const { nodeType } = this;
		const allListeners = Node$1.protoListenerMap.get(nodeType) || {};
		let events = allListeners === null || allListeners === void 0 ? void 0 : allListeners[eventType];
		if (events === void 0) {
			events = [];
			let obj = Object.getPrototypeOf(this);
			while (obj) {
				const hierarchyEvents = (_b = (_a = obj.eventListeners) === null || _a === void 0 ? void 0 : _a[eventType]) !== null && _b !== void 0 ? _b : [];
				events.push(...hierarchyEvents);
				obj = Object.getPrototypeOf(obj);
			}
			allListeners[eventType] = events;
			Node$1.protoListenerMap.set(nodeType, allListeners);
		}
		return events;
	}
	_fire(eventType, evt) {
		evt = evt || {};
		evt.currentTarget = this;
		evt.type = eventType;
		const topListeners = this._getProtoListeners(eventType);
		if (topListeners) {
			const list = topListeners.slice();
			for (let i = 0; i < list.length; i++) list[i].handler.call(this, evt);
		}
		const selfListeners = this.eventListeners[eventType];
		if (selfListeners) {
			const list = selfListeners.slice();
			const origLen = list.length;
			for (let i = 0; i < list.length; i++) list[i].handler.call(this, evt);
			const liveListeners = this.eventListeners[eventType];
			if (liveListeners) for (let i = origLen; i < liveListeners.length; i++) liveListeners[i].handler.call(this, evt);
		}
	}
	draw() {
		this.drawScene();
		this.drawHit();
		return this;
	}
	_createDragElement(evt) {
		const pointerId = evt ? evt.pointerId : void 0;
		const stage = this.getStage();
		const ap = this.getAbsolutePosition();
		if (!stage) return;
		const pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
		DD._dragElements.set(this._id, {
			node: this,
			startPointerPos: pos,
			offset: {
				x: pos.x - ap.x,
				y: pos.y - ap.y
			},
			dragStatus: "ready",
			pointerId,
			startEvent: evt
		});
	}
	startDrag(evt, bubbleEvent = true) {
		if (!DD._dragElements.has(this._id)) this._createDragElement(evt);
		const elem = DD._dragElements.get(this._id);
		elem.dragStatus = "dragging";
		this.fire("dragstart", {
			type: "dragstart",
			target: this,
			evt: elem.startEvent && elem.startEvent.evt || evt && evt.evt
		}, bubbleEvent);
	}
	_setDragPosition(evt, elem) {
		const pos = this.getStage()._getPointerById(elem.pointerId);
		if (!pos) return;
		let newNodePos = {
			x: pos.x - elem.offset.x,
			y: pos.y - elem.offset.y
		};
		const dbf = this.dragBoundFunc();
		if (dbf !== void 0) {
			const bounded = dbf.call(this, newNodePos, evt);
			if (!bounded) Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
			else newNodePos = bounded;
		}
		if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
			this.setAbsolutePosition(newNodePos);
			this._requestDraw();
		}
		this._lastPos = newNodePos;
	}
	stopDrag(evt) {
		const elem = DD._dragElements.get(this._id);
		if (elem) elem.dragStatus = "stopped";
		DD._endDragBefore(evt);
		DD._endDragAfter(evt);
	}
	setDraggable(draggable) {
		this._setAttr("draggable", draggable);
		this._dragChange();
	}
	isDragging() {
		const elem = DD._dragElements.get(this._id);
		return elem ? elem.dragStatus === "dragging" : false;
	}
	_listenDrag() {
		this._dragCleanup();
		this.on("mousedown.konva touchstart.konva", function(evt) {
			if (!(!(evt.evt["button"] !== void 0) || Konva$2.dragButtons.indexOf(evt.evt["button"]) >= 0)) return;
			if (this.isDragging()) return;
			let hasDraggingChild = false;
			DD._dragElements.forEach((elem) => {
				if (this.isAncestorOf(elem.node)) hasDraggingChild = true;
			});
			if (!hasDraggingChild) this._createDragElement(evt);
		});
	}
	_dragChange() {
		if (this.attrs.draggable) this._listenDrag();
		else {
			this._dragCleanup();
			if (!this.getStage()) return;
			const dragElement = DD._dragElements.get(this._id);
			const isDragging = dragElement && dragElement.dragStatus === "dragging";
			const isReady = dragElement && dragElement.dragStatus === "ready";
			if (isDragging) this.stopDrag();
			else if (isReady) DD._dragElements.delete(this._id);
		}
	}
	_dragCleanup() {
		this.off("mousedown.konva");
		this.off("touchstart.konva");
	}
	isClientRectOnScreen(margin = {
		x: 0,
		y: 0
	}) {
		const stage = this.getStage();
		if (!stage) return false;
		const screenRect = {
			x: -margin.x,
			y: -margin.y,
			width: stage.width() + 2 * margin.x,
			height: stage.height() + 2 * margin.y
		};
		return Util.haveIntersection(screenRect, this.getClientRect());
	}
	static create(data, container) {
		if (Util._isString(data)) data = JSON.parse(data);
		return this._createNode(data, container);
	}
	static _createNode(obj, container) {
		let className = Node$1.prototype.getClassName.call(obj), children = obj.children, no, len, n;
		if (container) obj.attrs.container = container;
		if (!Konva$2[className]) {
			Util.warn("Can not find a node with class name \"" + className + "\". Fallback to \"Shape\".");
			className = "Shape";
		}
		const Class = Konva$2[className];
		no = new Class(obj.attrs);
		if (children) {
			len = children.length;
			for (n = 0; n < len; n++) no.add(Node$1._createNode(children[n]));
		}
		return no;
	}
};
Node$1.protoListenerMap = /* @__PURE__ */ new Map();
Node$1.prototype.nodeType = "Node";
Node$1.prototype._attrsAffectingSize = [];
Node$1.prototype.eventListeners = {};
Node$1.prototype.on(TRANSFORM_CHANGE_STR$1, function() {
	if (this._batchingTransformChange) {
		this._needClearTransformCache = true;
		return;
	}
	this._clearCache(TRANSFORM);
	this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
});
Node$1.prototype.on("visibleChange.konva", function() {
	this._clearSelfAndDescendantCache(VISIBLE);
});
Node$1.prototype.on("listeningChange.konva", function() {
	this._clearSelfAndDescendantCache(LISTENING);
});
Node$1.prototype.on("opacityChange.konva", function() {
	this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
});
var addGetterSetter = Factory.addGetterSetter;
addGetterSetter(Node$1, "zIndex");
addGetterSetter(Node$1, "absolutePosition");
addGetterSetter(Node$1, "position");
addGetterSetter(Node$1, "x", 0, getNumberValidator());
addGetterSetter(Node$1, "y", 0, getNumberValidator());
addGetterSetter(Node$1, "globalCompositeOperation", "source-over", getStringValidator());
addGetterSetter(Node$1, "opacity", 1, getNumberValidator());
addGetterSetter(Node$1, "name", "", getStringValidator());
addGetterSetter(Node$1, "id", "", getStringValidator());
addGetterSetter(Node$1, "rotation", 0, getNumberValidator());
Factory.addComponentsGetterSetter(Node$1, "scale", ["x", "y"]);
addGetterSetter(Node$1, "scaleX", 1, getNumberValidator());
addGetterSetter(Node$1, "scaleY", 1, getNumberValidator());
Factory.addComponentsGetterSetter(Node$1, "skew", ["x", "y"]);
addGetterSetter(Node$1, "skewX", 0, getNumberValidator());
addGetterSetter(Node$1, "skewY", 0, getNumberValidator());
Factory.addComponentsGetterSetter(Node$1, "offset", ["x", "y"]);
addGetterSetter(Node$1, "offsetX", 0, getNumberValidator());
addGetterSetter(Node$1, "offsetY", 0, getNumberValidator());
addGetterSetter(Node$1, "dragDistance", void 0, getNumberValidator());
addGetterSetter(Node$1, "width", 0, getNumberValidator());
addGetterSetter(Node$1, "height", 0, getNumberValidator());
addGetterSetter(Node$1, "listening", true, getBooleanValidator());
addGetterSetter(Node$1, "preventDefault", true, getBooleanValidator());
addGetterSetter(Node$1, "filters", void 0, function(val) {
	this._filterUpToDate = false;
	return val;
});
addGetterSetter(Node$1, "visible", true, getBooleanValidator());
addGetterSetter(Node$1, "transformsEnabled", "all", getStringValidator());
addGetterSetter(Node$1, "size");
addGetterSetter(Node$1, "dragBoundFunc");
addGetterSetter(Node$1, "draggable", false, getBooleanValidator());
Factory.backCompat(Node$1, {
	rotateDeg: "rotate",
	setRotationDeg: "setRotation",
	getRotationDeg: "getRotation"
});
var Container = class extends Node$1 {
	constructor() {
		super(...arguments);
		this.children = [];
	}
	getChildren(filterFunc) {
		const children = this.children || [];
		if (filterFunc) return children.filter(filterFunc);
		return children;
	}
	hasChildren() {
		return this.getChildren().length > 0;
	}
	removeChildren() {
		this.getChildren().forEach((child) => {
			child.parent = null;
			child.index = 0;
			child.remove();
		});
		this.children = [];
		this._requestDraw();
		return this;
	}
	destroyChildren() {
		this.getChildren().forEach((child) => {
			child.parent = null;
			child.index = 0;
			child.destroy();
		});
		this.children = [];
		this._requestDraw();
		return this;
	}
	add(...children) {
		if (children.length === 0) return this;
		if (children.length > 1) {
			for (let i = 0; i < children.length; i++) this.add(children[i]);
			return this;
		}
		const child = children[0];
		if (child.getParent()) {
			child.moveTo(this);
			return this;
		}
		this._validateAdd(child);
		child.index = this.getChildren().length;
		child.parent = this;
		child._clearCaches();
		this.getChildren().push(child);
		this._fire("add", { child });
		this._requestDraw();
		return this;
	}
	destroy() {
		if (this.hasChildren()) this.destroyChildren();
		super.destroy();
		return this;
	}
	find(selector) {
		return this._generalFind(selector, false);
	}
	findOne(selector) {
		const result = this._generalFind(selector, true);
		return result.length > 0 ? result[0] : void 0;
	}
	_generalFind(selector, findOne) {
		const retArr = [];
		this._descendants((node) => {
			const valid = node._isMatch(selector);
			if (valid) retArr.push(node);
			if (valid && findOne) return true;
			return false;
		});
		return retArr;
	}
	_descendants(fn) {
		let shouldStop = false;
		const children = this.getChildren();
		for (const child of children) {
			shouldStop = fn(child);
			if (shouldStop) return true;
			if (!child.hasChildren()) continue;
			shouldStop = child._descendants(fn);
			if (shouldStop) return true;
		}
		return false;
	}
	toObject() {
		const obj = Node$1.prototype.toObject.call(this);
		obj.children = [];
		this.getChildren().forEach((child) => {
			obj.children.push(child.toObject());
		});
		return obj;
	}
	isAncestorOf(node) {
		let parent = node.getParent();
		while (parent) {
			if (parent._id === this._id) return true;
			parent = parent.getParent();
		}
		return false;
	}
	clone(obj) {
		const node = Node$1.prototype.clone.call(this, obj);
		this.getChildren().forEach(function(no) {
			node.add(no.clone());
		});
		return node;
	}
	getAllIntersections(pos) {
		const arr = [];
		this.find("Shape").forEach((shape) => {
			if (shape.isVisible() && shape.intersects(pos)) arr.push(shape);
		});
		return arr;
	}
	_clearSelfAndDescendantCache(attr) {
		var _a;
		super._clearSelfAndDescendantCache(attr);
		if (this.isCached()) return;
		(_a = this.children) === null || _a === void 0 || _a.forEach(function(node) {
			node._clearSelfAndDescendantCache(attr);
		});
	}
	_setChildrenIndices() {
		var _a;
		(_a = this.children) === null || _a === void 0 || _a.forEach(function(child, n) {
			child.index = n;
		});
		this._requestDraw();
	}
	drawScene(can, top, bufferCanvas) {
		const layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
		const caching = canvas && canvas.isCache;
		if (!this.isVisible() && !caching) return this;
		if (cachedSceneCanvas) {
			context.save();
			const m = this.getAbsoluteTransform(top).getMatrix();
			context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
			this._drawCachedSceneCanvas(context);
			context.restore();
		} else this._drawChildren("drawScene", canvas, top, bufferCanvas);
		return this;
	}
	drawHit(can, top) {
		if (!this.shouldDrawHit(top)) return this;
		const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache();
		if (cachedCanvas && cachedCanvas.hit) {
			context.save();
			const m = this.getAbsoluteTransform(top).getMatrix();
			context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
			this._drawCachedHitCanvas(context);
			context.restore();
		} else this._drawChildren("drawHit", canvas, top);
		return this;
	}
	_drawChildren(drawMethod, canvas, top, bufferCanvas) {
		var _a;
		const context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = typeof clipWidth === "number" && typeof clipHeight === "number" || clipFunc;
		const selfCache = top === this;
		if (hasClip) {
			context.save();
			const transform = this.getAbsoluteTransform(top);
			let m = transform.getMatrix();
			context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
			context.beginPath();
			let clipArgs;
			if (clipFunc) clipArgs = clipFunc.call(this, context, this);
			else {
				const clipX = this.clipX();
				const clipY = this.clipY();
				context.rect(clipX || 0, clipY || 0, clipWidth, clipHeight);
			}
			context.clip.apply(context, clipArgs);
			m = transform.copy().invert().getMatrix();
			context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
		}
		const hasComposition = !selfCache && this.globalCompositeOperation() !== "source-over" && drawMethod === "drawScene";
		if (hasComposition) {
			context.save();
			context._applyGlobalCompositeOperation(this);
		}
		(_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
			child[drawMethod](canvas, top, bufferCanvas);
		});
		if (hasComposition) context.restore();
		if (hasClip) context.restore();
	}
	getClientRect(config = {}) {
		var _a;
		const skipTransform = config.skipTransform;
		const relativeTo = config.relativeTo;
		let minX, minY, maxX, maxY;
		let selfRect = {
			x: Infinity,
			y: Infinity,
			width: 0,
			height: 0
		};
		const that = this;
		(_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
			if (!child.visible()) return;
			const rect = child.getClientRect({
				relativeTo: that,
				skipShadow: config.skipShadow,
				skipStroke: config.skipStroke
			});
			if (rect.width === 0 && rect.height === 0) return;
			if (minX === void 0) {
				minX = rect.x;
				minY = rect.y;
				maxX = rect.x + rect.width;
				maxY = rect.y + rect.height;
			} else {
				minX = Math.min(minX, rect.x);
				minY = Math.min(minY, rect.y);
				maxX = Math.max(maxX, rect.x + rect.width);
				maxY = Math.max(maxY, rect.y + rect.height);
			}
		});
		const shapes$1 = this.find("Shape");
		let hasVisible = false;
		for (let i = 0; i < shapes$1.length; i++) if (shapes$1[i]._isVisible(this)) {
			hasVisible = true;
			break;
		}
		if (hasVisible && minX !== void 0) selfRect = {
			x: minX,
			y: minY,
			width: maxX - minX,
			height: maxY - minY
		};
		else selfRect = {
			x: 0,
			y: 0,
			width: 0,
			height: 0
		};
		if (!skipTransform) return this._transformedRect(selfRect, relativeTo);
		return selfRect;
	}
};
Factory.addComponentsGetterSetter(Container, "clip", [
	"x",
	"y",
	"width",
	"height"
]);
Factory.addGetterSetter(Container, "clipX", void 0, getNumberValidator());
Factory.addGetterSetter(Container, "clipY", void 0, getNumberValidator());
Factory.addGetterSetter(Container, "clipWidth", void 0, getNumberValidator());
Factory.addGetterSetter(Container, "clipHeight", void 0, getNumberValidator());
Factory.addGetterSetter(Container, "clipFunc");
var Captures = /* @__PURE__ */ new Map();
var SUPPORT_POINTER_EVENTS = Konva$2._global["PointerEvent"] !== void 0;
function getCapturedShape(pointerId) {
	return Captures.get(pointerId);
}
function createEvent(evt) {
	return {
		evt,
		pointerId: evt.pointerId
	};
}
function hasPointerCapture(pointerId, shape) {
	return Captures.get(pointerId) === shape;
}
function setPointerCapture(pointerId, shape) {
	releaseCapture(pointerId);
	if (!shape.getStage()) return;
	Captures.set(pointerId, shape);
	if (SUPPORT_POINTER_EVENTS) shape._fire("gotpointercapture", createEvent(new PointerEvent("gotpointercapture")));
}
function releaseCapture(pointerId, target) {
	const shape = Captures.get(pointerId);
	if (!shape) return;
	const stage = shape.getStage();
	if (stage && stage.content) {}
	Captures.delete(pointerId);
	if (SUPPORT_POINTER_EVENTS) shape._fire("lostpointercapture", createEvent(new PointerEvent("lostpointercapture")));
}
var STAGE = "Stage", STRING = "string", PX = "px", MOUSEOUT = "mouseout", MOUSELEAVE = "mouseleave", MOUSEOVER = "mouseover", MOUSEENTER = "mouseenter", MOUSEMOVE = "mousemove", MOUSEDOWN = "mousedown", MOUSEUP = "mouseup", POINTERMOVE = "pointermove", POINTERDOWN = "pointerdown", POINTERUP = "pointerup", POINTERCANCEL = "pointercancel", LOSTPOINTERCAPTURE = "lostpointercapture", POINTEROUT = "pointerout", POINTERLEAVE = "pointerleave", POINTEROVER = "pointerover", POINTERENTER = "pointerenter", CONTEXTMENU = "contextmenu", TOUCHSTART = "touchstart", TOUCHEND = "touchend", TOUCHMOVE = "touchmove", TOUCHCANCEL = "touchcancel", WHEEL = "wheel", MAX_LAYERS_NUMBER = 5, EVENTS = [
	[MOUSEENTER, "_pointerenter"],
	[MOUSEDOWN, "_pointerdown"],
	[MOUSEMOVE, "_pointermove"],
	[MOUSEUP, "_pointerup"],
	[MOUSELEAVE, "_pointerleave"],
	[TOUCHSTART, "_pointerdown"],
	[TOUCHMOVE, "_pointermove"],
	[TOUCHEND, "_pointerup"],
	[TOUCHCANCEL, "_pointercancel"],
	[MOUSEOVER, "_pointerover"],
	[WHEEL, "_wheel"],
	[CONTEXTMENU, "_contextmenu"],
	[POINTERDOWN, "_pointerdown"],
	[POINTERMOVE, "_pointermove"],
	[POINTERUP, "_pointerup"],
	[POINTERCANCEL, "_pointercancel"],
	[POINTERLEAVE, "_pointerleave"],
	[LOSTPOINTERCAPTURE, "_lostpointercapture"]
];
var EVENTS_MAP = {
	mouse: {
		[POINTEROUT]: MOUSEOUT,
		[POINTERLEAVE]: MOUSELEAVE,
		[POINTEROVER]: MOUSEOVER,
		[POINTERENTER]: MOUSEENTER,
		[POINTERMOVE]: MOUSEMOVE,
		[POINTERDOWN]: MOUSEDOWN,
		[POINTERUP]: MOUSEUP,
		[POINTERCANCEL]: "mousecancel",
		pointerclick: "click",
		pointerdblclick: "dblclick"
	},
	touch: {
		[POINTEROUT]: "touchout",
		[POINTERLEAVE]: "touchleave",
		[POINTEROVER]: "touchover",
		[POINTERENTER]: "touchenter",
		[POINTERMOVE]: TOUCHMOVE,
		[POINTERDOWN]: TOUCHSTART,
		[POINTERUP]: TOUCHEND,
		[POINTERCANCEL]: TOUCHCANCEL,
		pointerclick: "tap",
		pointerdblclick: "dbltap"
	},
	pointer: {
		[POINTEROUT]: POINTEROUT,
		[POINTERLEAVE]: POINTERLEAVE,
		[POINTEROVER]: POINTEROVER,
		[POINTERENTER]: POINTERENTER,
		[POINTERMOVE]: POINTERMOVE,
		[POINTERDOWN]: POINTERDOWN,
		[POINTERUP]: POINTERUP,
		[POINTERCANCEL]: POINTERCANCEL,
		pointerclick: "pointerclick",
		pointerdblclick: "pointerdblclick"
	}
};
var getEventType = (type) => {
	if (type.indexOf("pointer") >= 0) return "pointer";
	if (type.indexOf("touch") >= 0) return "touch";
	return "mouse";
};
var getEventsMap = (eventType) => {
	const type = getEventType(eventType);
	if (type === "pointer") return Konva$2.pointerEventsEnabled && EVENTS_MAP.pointer;
	if (type === "touch") return EVENTS_MAP.touch;
	if (type === "mouse") return EVENTS_MAP.mouse;
};
function checkNoClip(attrs = {}) {
	if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) Util.warn("Stage does not support clipping. Please use clip for Layers or Groups.");
	return attrs;
}
var NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
const stages = [];
var Stage = class extends Container {
	constructor(config) {
		super(checkNoClip(config));
		this._pointerPositions = [];
		this._changedPointerPositions = [];
		this._buildDOM();
		this._bindContentEvents();
		stages.push(this);
		this.on("widthChange.konva heightChange.konva", this._resizeDOM);
		this.on("visibleChange.konva", this._checkVisibility);
		this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
			checkNoClip(this.attrs);
		});
		this._checkVisibility();
	}
	_validateAdd(child) {
		const isLayer = child.getType() === "Layer";
		const isFastLayer = child.getType() === "FastLayer";
		if (!(isLayer || isFastLayer)) Util.throw("You may only add layers to the stage.");
	}
	_checkVisibility() {
		if (!this.content) return;
		const style = this.visible() ? "" : "none";
		this.content.style.display = style;
	}
	setContainer(container) {
		if (typeof container === STRING) {
			let id;
			if (container.charAt(0) === ".") {
				const className = container.slice(1);
				container = document.getElementsByClassName(className)[0];
			} else {
				if (container.charAt(0) !== "#") id = container;
				else id = container.slice(1);
				container = document.getElementById(id);
			}
			if (!container) throw "Can not find container in document with id " + id;
		}
		this._setAttr("container", container);
		if (this.content) {
			if (this.content.parentElement) this.content.parentElement.removeChild(this.content);
			container.appendChild(this.content);
		}
		return this;
	}
	shouldDrawHit() {
		return true;
	}
	clear() {
		const layers = this.children, len = layers.length;
		for (let n = 0; n < len; n++) layers[n].clear();
		return this;
	}
	clone(obj) {
		if (!obj) obj = {};
		obj.container = typeof document !== "undefined" && document.createElement("div");
		return Container.prototype.clone.call(this, obj);
	}
	destroy() {
		super.destroy();
		const content = this.content;
		if (content && Util._isInDocument(content)) this.container().removeChild(content);
		const index = stages.indexOf(this);
		if (index > -1) stages.splice(index, 1);
		Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
		return this;
	}
	getPointerPosition() {
		const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
		if (!pos) {
			Util.warn(NO_POINTERS_MESSAGE);
			return null;
		}
		return {
			x: pos.x,
			y: pos.y
		};
	}
	_getPointerById(id) {
		return this._pointerPositions.find((p) => p.id === id);
	}
	getPointersPositions() {
		return this._pointerPositions;
	}
	getStage() {
		return this;
	}
	getContent() {
		return this.content;
	}
	_toKonvaCanvas(config) {
		config = { ...config };
		config.x = config.x || 0;
		config.y = config.y || 0;
		config.width = config.width || this.width();
		config.height = config.height || this.height();
		const canvas = new SceneCanvas({
			width: config.width,
			height: config.height,
			pixelRatio: config.pixelRatio || 1
		});
		const _context = canvas.getContext()._context;
		const layers = this.children;
		if (config.x || config.y) _context.translate(-1 * config.x, -1 * config.y);
		layers.forEach(function(layer) {
			if (!layer.isVisible()) return;
			const layerCanvas = layer._toKonvaCanvas(config);
			_context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
		});
		return canvas;
	}
	getIntersection(pos) {
		if (!pos) return null;
		const layers = this.children, end = layers.length - 1;
		for (let n = end; n >= 0; n--) {
			const shape = layers[n].getIntersection(pos);
			if (shape) return shape;
		}
		return null;
	}
	_resizeDOM() {
		const width = this.width();
		const height = this.height();
		if (this.content) {
			this.content.style.width = width + PX;
			this.content.style.height = height + PX;
		}
		this.bufferCanvas.setSize(width, height);
		this.bufferHitCanvas.setSize(width, height);
		this.children.forEach((layer) => {
			layer.setSize({
				width,
				height
			});
			layer.draw();
		});
	}
	add(layer, ...rest) {
		if (arguments.length > 1) {
			for (let i = 0; i < arguments.length; i++) this.add(arguments[i]);
			return this;
		}
		super.add(layer);
		const length$1 = this.children.length;
		if (length$1 > MAX_LAYERS_NUMBER) Util.warn("The stage has " + length$1 + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.");
		layer.setSize({
			width: this.width(),
			height: this.height()
		});
		layer.draw();
		if (Konva$2.isBrowser) this.content.appendChild(layer.canvas._canvas);
		return this;
	}
	getParent() {
		return null;
	}
	getLayer() {
		return null;
	}
	hasPointerCapture(pointerId) {
		return hasPointerCapture(pointerId, this);
	}
	setPointerCapture(pointerId) {
		setPointerCapture(pointerId, this);
	}
	releaseCapture(pointerId) {
		releaseCapture(pointerId, this);
	}
	getLayers() {
		return this.children;
	}
	_bindContentEvents() {
		if (!Konva$2.isBrowser) return;
		EVENTS.forEach(([event, methodName]) => {
			this.content.addEventListener(event, (evt) => {
				this[methodName](evt);
			}, { passive: false });
		});
	}
	_pointerenter(evt) {
		this.setPointersPositions(evt);
		const events = getEventsMap(evt.type);
		if (events) this._fire(events.pointerenter, {
			evt,
			target: this,
			currentTarget: this
		});
	}
	_pointerover(evt) {
		this.setPointersPositions(evt);
		const events = getEventsMap(evt.type);
		if (events) this._fire(events.pointerover, {
			evt,
			target: this,
			currentTarget: this
		});
	}
	_getTargetShape(evenType) {
		let shape = this[evenType + "targetShape"];
		if (shape && !shape.getStage()) shape = null;
		return shape;
	}
	_pointerleave(evt) {
		const events = getEventsMap(evt.type);
		const eventType = getEventType(evt.type);
		if (!events) return;
		this.setPointersPositions(evt);
		const targetShape = this._getTargetShape(eventType);
		const eventsEnabled = !(Konva$2.isDragging() || Konva$2.isTransforming()) || Konva$2.hitOnDragEnabled;
		if (targetShape && eventsEnabled) {
			targetShape._fireAndBubble(events.pointerout, { evt });
			targetShape._fireAndBubble(events.pointerleave, { evt });
			this._fire(events.pointerleave, {
				evt,
				target: this,
				currentTarget: this
			});
			this[eventType + "targetShape"] = null;
		} else if (eventsEnabled) {
			this._fire(events.pointerleave, {
				evt,
				target: this,
				currentTarget: this
			});
			this._fire(events.pointerout, {
				evt,
				target: this,
				currentTarget: this
			});
		}
		this.pointerPos = null;
		this._pointerPositions = [];
	}
	_pointerdown(evt) {
		const events = getEventsMap(evt.type);
		const eventType = getEventType(evt.type);
		if (!events) return;
		this.setPointersPositions(evt);
		let triggeredOnShape = false;
		this._changedPointerPositions.forEach((pos) => {
			const shape = this.getIntersection(pos);
			DD.justDragged = false;
			Konva$2["_" + eventType + "ListenClick"] = true;
			if (!shape || !shape.isListening()) {
				this[eventType + "ClickStartShape"] = void 0;
				return;
			}
			if (Konva$2.capturePointerEventsEnabled) shape.setPointerCapture(pos.id);
			this[eventType + "ClickStartShape"] = shape;
			shape._fireAndBubble(events.pointerdown, {
				evt,
				pointerId: pos.id
			});
			triggeredOnShape = true;
			const isTouch = evt.type.indexOf("touch") >= 0;
			if (shape.preventDefault() && evt.cancelable && isTouch) evt.preventDefault();
		});
		if (!triggeredOnShape) this._fire(events.pointerdown, {
			evt,
			target: this,
			currentTarget: this,
			pointerId: this._pointerPositions[0].id
		});
	}
	_pointermove(evt) {
		const events = getEventsMap(evt.type);
		const eventType = getEventType(evt.type);
		if (!events) return;
		const isTouchPointer = evt.type.indexOf("touch") >= 0 || evt.pointerType === "touch";
		if (Konva$2.isDragging() && DD.node.preventDefault() && evt.cancelable && isTouchPointer) evt.preventDefault();
		this.setPointersPositions(evt);
		if (!(!(Konva$2.isDragging() || Konva$2.isTransforming()) || Konva$2.hitOnDragEnabled)) return;
		const processedShapesIds = {};
		let triggeredOnShape = false;
		const targetShape = this._getTargetShape(eventType);
		this._changedPointerPositions.forEach((pos) => {
			const shape = getCapturedShape(pos.id) || this.getIntersection(pos);
			const pointerId = pos.id;
			const event = {
				evt,
				pointerId
			};
			const differentTarget = targetShape !== shape;
			if (differentTarget && targetShape) {
				targetShape._fireAndBubble(events.pointerout, { ...event }, shape);
				targetShape._fireAndBubble(events.pointerleave, { ...event }, shape);
			}
			if (shape) {
				if (processedShapesIds[shape._id]) return;
				processedShapesIds[shape._id] = true;
			}
			if (shape && shape.isListening()) {
				triggeredOnShape = true;
				if (differentTarget) {
					shape._fireAndBubble(events.pointerover, { ...event }, targetShape);
					shape._fireAndBubble(events.pointerenter, { ...event }, targetShape);
					this[eventType + "targetShape"] = shape;
				}
				shape._fireAndBubble(events.pointermove, { ...event });
			} else if (targetShape) {
				this._fire(events.pointerover, {
					evt,
					target: this,
					currentTarget: this,
					pointerId
				});
				this[eventType + "targetShape"] = null;
			}
		});
		if (!triggeredOnShape) this._fire(events.pointermove, {
			evt,
			target: this,
			currentTarget: this,
			pointerId: this._changedPointerPositions[0].id
		});
	}
	_pointerup(evt) {
		const events = getEventsMap(evt.type);
		const eventType = getEventType(evt.type);
		if (!events) return;
		this.setPointersPositions(evt);
		const clickStartShape = this[eventType + "ClickStartShape"];
		const clickEndShape = this[eventType + "ClickEndShape"];
		const processedShapesIds = {};
		let skipPointerUpTrigger = false;
		this._changedPointerPositions.forEach((pos) => {
			const shape = getCapturedShape(pos.id) || this.getIntersection(pos);
			if (shape) {
				shape.releaseCapture(pos.id);
				if (processedShapesIds[shape._id]) return;
				processedShapesIds[shape._id] = true;
			}
			const pointerId = pos.id;
			const event = {
				evt,
				pointerId
			};
			let fireDblClick = false;
			if (Konva$2["_" + eventType + "InDblClickWindow"]) {
				fireDblClick = true;
				clearTimeout(this[eventType + "DblTimeout"]);
			} else if (!DD.justDragged) {
				Konva$2["_" + eventType + "InDblClickWindow"] = true;
				clearTimeout(this[eventType + "DblTimeout"]);
			}
			this[eventType + "DblTimeout"] = setTimeout(function() {
				Konva$2["_" + eventType + "InDblClickWindow"] = false;
			}, Konva$2.dblClickWindow);
			if (shape && shape.isListening()) {
				skipPointerUpTrigger = true;
				this[eventType + "ClickEndShape"] = shape;
				shape._fireAndBubble(events.pointerup, { ...event });
				if (Konva$2["_" + eventType + "ListenClick"] && clickStartShape && clickStartShape === shape) {
					shape._fireAndBubble(events.pointerclick, { ...event });
					if (fireDblClick && clickEndShape && clickEndShape === shape) shape._fireAndBubble(events.pointerdblclick, { ...event });
				}
			} else {
				this[eventType + "ClickEndShape"] = null;
				if (!skipPointerUpTrigger) {
					this._fire(events.pointerup, {
						evt,
						target: this,
						currentTarget: this,
						pointerId: this._changedPointerPositions[0].id
					});
					skipPointerUpTrigger = true;
				}
				if (Konva$2["_" + eventType + "ListenClick"]) this._fire(events.pointerclick, {
					evt,
					target: this,
					currentTarget: this,
					pointerId
				});
				if (fireDblClick) this._fire(events.pointerdblclick, {
					evt,
					target: this,
					currentTarget: this,
					pointerId
				});
			}
		});
		if (!skipPointerUpTrigger) this._fire(events.pointerup, {
			evt,
			target: this,
			currentTarget: this,
			pointerId: this._changedPointerPositions[0].id
		});
		Konva$2["_" + eventType + "ListenClick"] = false;
		if (evt.cancelable && eventType !== "touch" && eventType !== "pointer") evt.preventDefault();
	}
	_contextmenu(evt) {
		this.setPointersPositions(evt);
		const shape = this.getIntersection(this.getPointerPosition());
		if (shape && shape.isListening()) shape._fireAndBubble(CONTEXTMENU, { evt });
		else this._fire(CONTEXTMENU, {
			evt,
			target: this,
			currentTarget: this
		});
	}
	_wheel(evt) {
		this.setPointersPositions(evt);
		const shape = this.getIntersection(this.getPointerPosition());
		if (shape && shape.isListening()) shape._fireAndBubble(WHEEL, { evt });
		else this._fire(WHEEL, {
			evt,
			target: this,
			currentTarget: this
		});
	}
	_pointercancel(evt) {
		this.setPointersPositions(evt);
		const shape = getCapturedShape(evt.pointerId) || this.getIntersection(this.getPointerPosition());
		if (shape) shape._fireAndBubble(POINTERUP, createEvent(evt));
		releaseCapture(evt.pointerId);
	}
	_lostpointercapture(evt) {
		releaseCapture(evt.pointerId);
	}
	setPointersPositions(evt) {
		const contentPosition = this._getContentPosition();
		let x = null, y = null;
		evt = evt ? evt : window.event;
		if (evt.touches !== void 0) {
			this._pointerPositions = [];
			this._changedPointerPositions = [];
			Array.prototype.forEach.call(evt.touches, (touch) => {
				this._pointerPositions.push({
					id: touch.identifier,
					x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
					y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
				});
			});
			Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch) => {
				this._changedPointerPositions.push({
					id: touch.identifier,
					x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
					y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
				});
			});
		} else {
			x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
			y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
			this.pointerPos = {
				x,
				y
			};
			this._pointerPositions = [{
				x,
				y,
				id: Util._getFirstPointerId(evt)
			}];
			this._changedPointerPositions = [{
				x,
				y,
				id: Util._getFirstPointerId(evt)
			}];
		}
	}
	_setPointerPosition(evt) {
		Util.warn("Method _setPointerPosition is deprecated. Use \"stage.setPointersPositions(event)\" instead.");
		this.setPointersPositions(evt);
	}
	_getContentPosition() {
		if (!this.content || !this.content.getBoundingClientRect) return {
			top: 0,
			left: 0,
			scaleX: 1,
			scaleY: 1
		};
		const rect = this.content.getBoundingClientRect();
		return {
			top: rect.top,
			left: rect.left,
			scaleX: rect.width / this.content.clientWidth || 1,
			scaleY: rect.height / this.content.clientHeight || 1
		};
	}
	_buildDOM() {
		this.bufferCanvas = new SceneCanvas({
			width: this.width(),
			height: this.height()
		});
		this.bufferHitCanvas = new HitCanvas({
			pixelRatio: 1,
			width: this.width(),
			height: this.height()
		});
		if (!Konva$2.isBrowser) return;
		const container = this.container();
		if (!container) throw "Stage has no container. A container is required.";
		container.innerHTML = "";
		this.content = document.createElement("div");
		this.content.style.position = "relative";
		this.content.style.userSelect = "none";
		this.content.className = "konvajs-content";
		this.content.setAttribute("role", "presentation");
		container.appendChild(this.content);
		this._resizeDOM();
	}
	cache() {
		Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.");
		return this;
	}
	clearCache() {
		return this;
	}
	batchDraw() {
		this.getChildren().forEach(function(layer) {
			layer.batchDraw();
		});
		return this;
	}
};
Stage.prototype.nodeType = STAGE;
_registerNode(Stage);
Factory.addGetterSetter(Stage, "container");
if (Konva$2.isBrowser) document.addEventListener("visibilitychange", () => {
	stages.forEach((stage) => {
		stage.batchDraw();
	});
});
var HAS_SHADOW = "hasShadow";
var SHADOW_RGBA = "shadowRGBA";
var patternImage = "patternImage";
var linearGradient = "linearGradient";
var radialGradient = "radialGradient";
var dummyContext$1;
function getDummyContext$1() {
	if (dummyContext$1) return dummyContext$1;
	dummyContext$1 = Util.createCanvasElement().getContext("2d");
	return dummyContext$1;
}
const shapes = {};
function _fillFunc$2(context) {
	const fillRule = this.attrs.fillRule;
	if (fillRule) context.fill(fillRule);
	else context.fill();
}
function _strokeFunc$2(context) {
	context.stroke();
}
function _fillFuncHit(context) {
	const fillRule = this.attrs.fillRule;
	if (fillRule) context.fill(fillRule);
	else context.fill();
}
function _strokeFuncHit(context) {
	context.stroke();
}
function _clearHasShadowCache() {
	this._clearCache(HAS_SHADOW);
}
function _clearGetShadowRGBACache() {
	this._clearCache(SHADOW_RGBA);
}
function _clearFillPatternCache() {
	this._clearCache(patternImage);
}
function _clearLinearGradientCache() {
	this._clearCache(linearGradient);
}
function _clearRadialGradientCache() {
	this._clearCache(radialGradient);
}
var Shape = class extends Node$1 {
	constructor(config) {
		super(config);
		let key;
		let attempts = 0;
		while (true) {
			key = Util.getHitColor();
			if (key && !(key in shapes)) break;
			attempts++;
			if (attempts >= 1e4) {
				Util.warn("Failed to find a unique color key for a shape. Konva may work incorrectly. Most likely your browser is using canvas farbling. Consider disabling it.");
				key = Util.getRandomColor();
				break;
			}
		}
		this.colorKey = key;
		shapes[key] = this;
	}
	getContext() {
		Util.warn("shape.getContext() method is deprecated. Please do not use it.");
		return this.getLayer().getContext();
	}
	getCanvas() {
		Util.warn("shape.getCanvas() method is deprecated. Please do not use it.");
		return this.getLayer().getCanvas();
	}
	getSceneFunc() {
		return this.attrs.sceneFunc || this["_sceneFunc"];
	}
	getHitFunc() {
		return this.attrs.hitFunc || this["_hitFunc"];
	}
	hasShadow() {
		return this._getCache(HAS_SHADOW, this._hasShadow);
	}
	_hasShadow() {
		return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
	}
	_getFillPattern() {
		return this._getCache(patternImage, this.__getFillPattern);
	}
	__getFillPattern() {
		if (this.fillPatternImage()) {
			const pattern = getDummyContext$1().createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
			if (pattern && pattern.setTransform) {
				const tr = new Transform();
				tr.translate(this.fillPatternX(), this.fillPatternY());
				tr.rotate(Konva$2.getAngle(this.fillPatternRotation()));
				tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
				tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
				const m = tr.getMatrix();
				const matrix = typeof DOMMatrix === "undefined" ? {
					a: m[0],
					b: m[1],
					c: m[2],
					d: m[3],
					e: m[4],
					f: m[5]
				} : new DOMMatrix(m);
				pattern.setTransform(matrix);
			}
			return pattern;
		}
	}
	_getLinearGradient() {
		return this._getCache(linearGradient, this.__getLinearGradient);
	}
	__getLinearGradient() {
		const colorStops = this.fillLinearGradientColorStops();
		if (colorStops) {
			const ctx = getDummyContext$1();
			const start = this.fillLinearGradientStartPoint();
			const end = this.fillLinearGradientEndPoint();
			const grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
			for (let n = 0; n < colorStops.length; n += 2) grd.addColorStop(colorStops[n], colorStops[n + 1]);
			return grd;
		}
	}
	_getRadialGradient() {
		return this._getCache(radialGradient, this.__getRadialGradient);
	}
	__getRadialGradient() {
		const colorStops = this.fillRadialGradientColorStops();
		if (colorStops) {
			const ctx = getDummyContext$1();
			const start = this.fillRadialGradientStartPoint();
			const end = this.fillRadialGradientEndPoint();
			const grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
			for (let n = 0; n < colorStops.length; n += 2) grd.addColorStop(colorStops[n], colorStops[n + 1]);
			return grd;
		}
	}
	getShadowRGBA() {
		return this._getCache(SHADOW_RGBA, this._getShadowRGBA);
	}
	_getShadowRGBA() {
		if (!this.hasShadow()) return;
		const rgba = Util.colorToRGBA(this.shadowColor());
		if (rgba) return "rgba(" + rgba.r + "," + rgba.g + "," + rgba.b + "," + rgba.a * (this.shadowOpacity() || 1) + ")";
	}
	hasFill() {
		return this._calculate("hasFill", [
			"fillEnabled",
			"fill",
			"fillPatternImage",
			"fillLinearGradientColorStops",
			"fillRadialGradientColorStops"
		], () => {
			return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
		});
	}
	hasStroke() {
		return this._calculate("hasStroke", [
			"strokeEnabled",
			"strokeWidth",
			"stroke",
			"strokeLinearGradientColorStops"
		], () => {
			return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
		});
	}
	hasHitStroke() {
		const width = this.hitStrokeWidth();
		if (width === "auto") return this.hasStroke();
		return this.strokeEnabled() && !!width;
	}
	intersects(point) {
		const stage = this.getStage();
		if (!stage) return false;
		const bufferHitCanvas = stage.bufferHitCanvas;
		bufferHitCanvas.getContext().clear();
		this.drawHit(bufferHitCanvas, void 0, true);
		return bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data[3] > 0;
	}
	destroy() {
		Node$1.prototype.destroy.call(this);
		delete shapes[this.colorKey];
		delete this.colorKey;
		return this;
	}
	_useBufferCanvas(forceFill) {
		var _a;
		if (!((_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true)) return false;
		const hasFill = forceFill || this.hasFill();
		const hasStroke = this.hasStroke();
		const isTransparent = this.getAbsoluteOpacity() !== 1;
		if (hasFill && hasStroke && isTransparent) return true;
		const hasShadow = this.hasShadow();
		const strokeForShadow = this.shadowForStrokeEnabled();
		if (hasFill && hasStroke && hasShadow && strokeForShadow) return true;
		return false;
	}
	setStrokeHitEnabled(val) {
		Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.");
		if (val) this.hitStrokeWidth("auto");
		else this.hitStrokeWidth(0);
	}
	getStrokeHitEnabled() {
		if (this.hitStrokeWidth() === 0) return false;
		else return true;
	}
	getSelfRect() {
		const size = this.size();
		return {
			x: this._centroid ? -size.width / 2 : 0,
			y: this._centroid ? -size.height / 2 : 0,
			width: size.width,
			height: size.height
		};
	}
	getClientRect(config = {}) {
		let hasCachedParent = false;
		let parent = this.getParent();
		while (parent) {
			if (parent.isCached()) {
				hasCachedParent = true;
				break;
			}
			parent = parent.getParent();
		}
		const skipTransform = config.skipTransform;
		const relativeTo = config.relativeTo || hasCachedParent && this.getStage() || void 0;
		const fillRect = this.getSelfRect();
		const strokeWidth = !config.skipStroke && this.hasStroke() && this.strokeWidth() || 0;
		const fillAndStrokeWidth = fillRect.width + strokeWidth;
		const fillAndStrokeHeight = fillRect.height + strokeWidth;
		const applyShadow = !config.skipShadow && this.hasShadow();
		const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
		const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
		const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
		const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
		const blurRadius = applyShadow && this.shadowBlur() || 0;
		const rect = {
			width: preWidth + blurRadius * 2,
			height: preHeight + blurRadius * 2,
			x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
			y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
		};
		if (!skipTransform) return this._transformedRect(rect, relativeTo);
		return rect;
	}
	drawScene(can, top, bufferCanvas) {
		const layer = this.getLayer();
		const context = (can || layer.getCanvas()).getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow();
		let stage;
		const cachingSelf = top === this;
		if (!this.isVisible() && !cachingSelf) return this;
		if (cachedCanvas) {
			context.save();
			const m = this.getAbsoluteTransform(top).getMatrix();
			context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
			this._drawCachedSceneCanvas(context);
			context.restore();
			return this;
		}
		if (!drawFunc) return this;
		context.save();
		if (this._useBufferCanvas() && true) {
			stage = this.getStage();
			const bc = bufferCanvas || stage.bufferCanvas;
			const bufferContext = bc.getContext();
			if (bufferCanvas) {
				bufferContext.save();
				bufferContext.setTransform(1, 0, 0, 1, 0, 0);
				bufferContext.clearRect(0, 0, bc.width, bc.height);
				bufferContext.restore();
			} else bufferContext.clear();
			bufferContext.save();
			bufferContext._applyLineJoin(this);
			bufferContext._applyMiterLimit(this);
			const o = this.getAbsoluteTransform(top).getMatrix();
			bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
			drawFunc.call(this, bufferContext, this);
			bufferContext.restore();
			const ratio = bc.pixelRatio;
			if (hasShadow) context._applyShadow(this);
			if (!cachingSelf) {
				context._applyOpacity(this);
				context._applyGlobalCompositeOperation(this);
			}
			context.drawImage(bc._canvas, bc.x || 0, bc.y || 0, bc.width / ratio, bc.height / ratio);
		} else {
			context._applyLineJoin(this);
			context._applyMiterLimit(this);
			if (!cachingSelf) {
				const o = this.getAbsoluteTransform(top).getMatrix();
				context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
				context._applyOpacity(this);
				context._applyGlobalCompositeOperation(this);
			}
			if (hasShadow) context._applyShadow(this);
			drawFunc.call(this, context, this);
		}
		context.restore();
		return this;
	}
	drawHit(can, top, skipDragCheck = false) {
		if (!this.shouldDrawHit(top, skipDragCheck)) return this;
		const layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
		if (!this.colorKey) Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()");
		if (cachedHitCanvas) {
			context.save();
			const m = this.getAbsoluteTransform(top).getMatrix();
			context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
			this._drawCachedHitCanvas(context);
			context.restore();
			return this;
		}
		if (!drawFunc) return this;
		context.save();
		context._applyLineJoin(this);
		context._applyMiterLimit(this);
		if (!(this === top)) {
			const o = this.getAbsoluteTransform(top).getMatrix();
			context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
		}
		drawFunc.call(this, context, this);
		context.restore();
		return this;
	}
	drawHitFromCache(alphaThreshold = 0) {
		const cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight();
		hitContext.clear();
		hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
		try {
			const hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
			const hitData = hitImageData.data;
			const len = hitData.length;
			const rgbColorKey = Util._hexToRgb(this.colorKey);
			for (let i = 0; i < len; i += 4) if (hitData[i + 3] > alphaThreshold) {
				hitData[i] = rgbColorKey.r;
				hitData[i + 1] = rgbColorKey.g;
				hitData[i + 2] = rgbColorKey.b;
				hitData[i + 3] = 255;
			} else hitData[i + 3] = 0;
			hitContext.putImageData(hitImageData, 0, 0);
		} catch (e) {
			Util.error("Unable to draw hit graph from cached scene canvas. " + e.message);
		}
		return this;
	}
	hasPointerCapture(pointerId) {
		return hasPointerCapture(pointerId, this);
	}
	setPointerCapture(pointerId) {
		setPointerCapture(pointerId, this);
	}
	releaseCapture(pointerId) {
		releaseCapture(pointerId, this);
	}
};
Shape.prototype._fillFunc = _fillFunc$2;
Shape.prototype._strokeFunc = _strokeFunc$2;
Shape.prototype._fillFuncHit = _fillFuncHit;
Shape.prototype._strokeFuncHit = _strokeFuncHit;
Shape.prototype._centroid = false;
Shape.prototype.nodeType = "Shape";
_registerNode(Shape);
Shape.prototype.eventListeners = {};
Shape.prototype.on("shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", _clearHasShadowCache);
Shape.prototype.on("shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", _clearGetShadowRGBACache);
Shape.prototype.on("fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", _clearFillPatternCache);
Shape.prototype.on("fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", _clearLinearGradientCache);
Shape.prototype.on("fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", _clearRadialGradientCache);
Factory.addGetterSetter(Shape, "stroke", void 0, getStringOrGradientValidator());
Factory.addGetterSetter(Shape, "strokeWidth", 2, getNumberValidator());
Factory.addGetterSetter(Shape, "fillAfterStrokeEnabled", false);
Factory.addGetterSetter(Shape, "hitStrokeWidth", "auto", getNumberOrAutoValidator());
Factory.addGetterSetter(Shape, "strokeHitEnabled", true, getBooleanValidator());
Factory.addGetterSetter(Shape, "perfectDrawEnabled", true, getBooleanValidator());
Factory.addGetterSetter(Shape, "shadowForStrokeEnabled", true, getBooleanValidator());
Factory.addGetterSetter(Shape, "lineJoin");
Factory.addGetterSetter(Shape, "lineCap");
Factory.addGetterSetter(Shape, "miterLimit");
Factory.addGetterSetter(Shape, "sceneFunc");
Factory.addGetterSetter(Shape, "hitFunc");
Factory.addGetterSetter(Shape, "dash");
Factory.addGetterSetter(Shape, "dashOffset", 0, getNumberValidator());
Factory.addGetterSetter(Shape, "shadowColor", void 0, getStringValidator());
Factory.addGetterSetter(Shape, "shadowBlur", 0, getNumberValidator());
Factory.addGetterSetter(Shape, "shadowOpacity", 1, getNumberValidator());
Factory.addComponentsGetterSetter(Shape, "shadowOffset", ["x", "y"]);
Factory.addGetterSetter(Shape, "shadowOffsetX", 0, getNumberValidator());
Factory.addGetterSetter(Shape, "shadowOffsetY", 0, getNumberValidator());
Factory.addGetterSetter(Shape, "fillPatternImage");
Factory.addGetterSetter(Shape, "fill", void 0, getStringOrGradientValidator());
Factory.addGetterSetter(Shape, "fillPatternX", 0, getNumberValidator());
Factory.addGetterSetter(Shape, "fillPatternY", 0, getNumberValidator());
Factory.addGetterSetter(Shape, "fillLinearGradientColorStops");
Factory.addGetterSetter(Shape, "strokeLinearGradientColorStops");
Factory.addGetterSetter(Shape, "fillRadialGradientStartRadius", 0);
Factory.addGetterSetter(Shape, "fillRadialGradientEndRadius", 0);
Factory.addGetterSetter(Shape, "fillRadialGradientColorStops");
Factory.addGetterSetter(Shape, "fillPatternRepeat", "repeat");
Factory.addGetterSetter(Shape, "fillEnabled", true);
Factory.addGetterSetter(Shape, "strokeEnabled", true);
Factory.addGetterSetter(Shape, "shadowEnabled", true);
Factory.addGetterSetter(Shape, "dashEnabled", true);
Factory.addGetterSetter(Shape, "strokeScaleEnabled", true);
Factory.addGetterSetter(Shape, "fillPriority", "color");
Factory.addComponentsGetterSetter(Shape, "fillPatternOffset", ["x", "y"]);
Factory.addGetterSetter(Shape, "fillPatternOffsetX", 0, getNumberValidator());
Factory.addGetterSetter(Shape, "fillPatternOffsetY", 0, getNumberValidator());
Factory.addComponentsGetterSetter(Shape, "fillPatternScale", ["x", "y"]);
Factory.addGetterSetter(Shape, "fillPatternScaleX", 1, getNumberValidator());
Factory.addGetterSetter(Shape, "fillPatternScaleY", 1, getNumberValidator());
Factory.addComponentsGetterSetter(Shape, "fillLinearGradientStartPoint", ["x", "y"]);
Factory.addComponentsGetterSetter(Shape, "strokeLinearGradientStartPoint", ["x", "y"]);
Factory.addGetterSetter(Shape, "fillLinearGradientStartPointX", 0);
Factory.addGetterSetter(Shape, "strokeLinearGradientStartPointX", 0);
Factory.addGetterSetter(Shape, "fillLinearGradientStartPointY", 0);
Factory.addGetterSetter(Shape, "strokeLinearGradientStartPointY", 0);
Factory.addComponentsGetterSetter(Shape, "fillLinearGradientEndPoint", ["x", "y"]);
Factory.addComponentsGetterSetter(Shape, "strokeLinearGradientEndPoint", ["x", "y"]);
Factory.addGetterSetter(Shape, "fillLinearGradientEndPointX", 0);
Factory.addGetterSetter(Shape, "strokeLinearGradientEndPointX", 0);
Factory.addGetterSetter(Shape, "fillLinearGradientEndPointY", 0);
Factory.addGetterSetter(Shape, "strokeLinearGradientEndPointY", 0);
Factory.addComponentsGetterSetter(Shape, "fillRadialGradientStartPoint", ["x", "y"]);
Factory.addGetterSetter(Shape, "fillRadialGradientStartPointX", 0);
Factory.addGetterSetter(Shape, "fillRadialGradientStartPointY", 0);
Factory.addComponentsGetterSetter(Shape, "fillRadialGradientEndPoint", ["x", "y"]);
Factory.addGetterSetter(Shape, "fillRadialGradientEndPointX", 0);
Factory.addGetterSetter(Shape, "fillRadialGradientEndPointY", 0);
Factory.addGetterSetter(Shape, "fillPatternRotation", 0);
Factory.addGetterSetter(Shape, "fillRule", void 0, getStringValidator());
Factory.backCompat(Shape, {
	dashArray: "dash",
	getDashArray: "getDash",
	setDashArray: "getDash",
	drawFunc: "sceneFunc",
	getDrawFunc: "getSceneFunc",
	setDrawFunc: "setSceneFunc",
	drawHitFunc: "hitFunc",
	getDrawHitFunc: "getHitFunc",
	setDrawHitFunc: "setHitFunc"
});
var BEFORE_DRAW = "beforeDraw", DRAW = "draw", INTERSECTION_OFFSETS = [
	{
		x: 0,
		y: 0
	},
	{
		x: -1,
		y: -1
	},
	{
		x: 1,
		y: -1
	},
	{
		x: 1,
		y: 1
	},
	{
		x: -1,
		y: 1
	}
], INTERSECTION_OFFSETS_LEN = INTERSECTION_OFFSETS.length;
var Layer = class extends Container {
	constructor(config) {
		super(config);
		this.canvas = new SceneCanvas();
		this.hitCanvas = new HitCanvas({ pixelRatio: 1 });
		this._waitingForDraw = false;
		this.on("visibleChange.konva", this._checkVisibility);
		this._checkVisibility();
		this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled);
		this._setSmoothEnabled();
	}
	createPNGStream() {
		return this.canvas._canvas.createPNGStream();
	}
	getCanvas() {
		return this.canvas;
	}
	getNativeCanvasElement() {
		return this.canvas._canvas;
	}
	getHitCanvas() {
		return this.hitCanvas;
	}
	getContext() {
		return this.getCanvas().getContext();
	}
	clear(bounds) {
		this.getContext().clear(bounds);
		this.getHitCanvas().getContext().clear(bounds);
		return this;
	}
	setZIndex(index) {
		super.setZIndex(index);
		const stage = this.getStage();
		if (stage && stage.content) {
			stage.content.removeChild(this.getNativeCanvasElement());
			if (index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
			else stage.content.appendChild(this.getNativeCanvasElement());
		}
		return this;
	}
	moveToTop() {
		Node$1.prototype.moveToTop.call(this);
		const stage = this.getStage();
		if (stage && stage.content) {
			stage.content.removeChild(this.getNativeCanvasElement());
			stage.content.appendChild(this.getNativeCanvasElement());
		}
		return true;
	}
	moveUp() {
		if (!Node$1.prototype.moveUp.call(this)) return false;
		const stage = this.getStage();
		if (!stage || !stage.content) return false;
		stage.content.removeChild(this.getNativeCanvasElement());
		if (this.index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
		else stage.content.appendChild(this.getNativeCanvasElement());
		return true;
	}
	moveDown() {
		if (Node$1.prototype.moveDown.call(this)) {
			const stage = this.getStage();
			if (stage) {
				const children = stage.children;
				if (stage.content) {
					stage.content.removeChild(this.getNativeCanvasElement());
					stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
				}
			}
			return true;
		}
		return false;
	}
	moveToBottom() {
		if (Node$1.prototype.moveToBottom.call(this)) {
			const stage = this.getStage();
			if (stage) {
				const children = stage.children;
				if (stage.content) {
					stage.content.removeChild(this.getNativeCanvasElement());
					stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
				}
			}
			return true;
		}
		return false;
	}
	getLayer() {
		return this;
	}
	remove() {
		const _canvas = this.getNativeCanvasElement();
		Node$1.prototype.remove.call(this);
		if (_canvas && _canvas.parentNode && Util._isInDocument(_canvas)) _canvas.parentNode.removeChild(_canvas);
		return this;
	}
	getStage() {
		return this.parent;
	}
	setSize({ width, height }) {
		this.canvas.setSize(width, height);
		this.hitCanvas.setSize(width, height);
		this._setSmoothEnabled();
		return this;
	}
	_validateAdd(child) {
		const type = child.getType();
		if (type !== "Group" && type !== "Shape") Util.throw("You may only add groups and shapes to a layer.");
	}
	_toKonvaCanvas(config) {
		config = { ...config };
		config.width = config.width || this.getWidth();
		config.height = config.height || this.getHeight();
		config.x = config.x !== void 0 ? config.x : this.x();
		config.y = config.y !== void 0 ? config.y : this.y();
		return Node$1.prototype._toKonvaCanvas.call(this, config);
	}
	_checkVisibility() {
		if (this.visible()) this.canvas._canvas.style.display = "block";
		else this.canvas._canvas.style.display = "none";
	}
	_setSmoothEnabled() {
		this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
	}
	getWidth() {
		if (this.parent) return this.parent.width();
	}
	setWidth() {
		Util.warn("Can not change width of layer. Use \"stage.width(value)\" function instead.");
	}
	getHeight() {
		if (this.parent) return this.parent.height();
	}
	setHeight() {
		Util.warn("Can not change height of layer. Use \"stage.height(value)\" function instead.");
	}
	batchDraw() {
		if (!this._waitingForDraw) {
			this._waitingForDraw = true;
			Util.requestAnimFrame(() => {
				this.draw();
				this._waitingForDraw = false;
			});
		}
		return this;
	}
	getIntersection(pos) {
		if (!this.isListening() || !this.isVisible()) return null;
		let spiralSearchDistance = 1;
		let continueSearch = false;
		while (true) {
			for (let i = 0; i < INTERSECTION_OFFSETS_LEN; i++) {
				const intersectionOffset = INTERSECTION_OFFSETS[i];
				const obj = this._getIntersection({
					x: pos.x + intersectionOffset.x * spiralSearchDistance,
					y: pos.y + intersectionOffset.y * spiralSearchDistance
				});
				const shape = obj.shape;
				if (shape) return shape;
				continueSearch = !!obj.antialiased;
				if (!obj.antialiased) break;
			}
			if (continueSearch) spiralSearchDistance += 1;
			else return null;
		}
	}
	_getIntersection(pos) {
		const ratio = this.hitCanvas.pixelRatio;
		const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
		const p3 = p[3];
		if (p3 === 255) {
			const shape = shapes[Util.getHitColorKey(p[0], p[1], p[2])];
			if (shape) return { shape };
			return { antialiased: true };
		} else if (p3 > 0) return { antialiased: true };
		return {};
	}
	drawScene(can, top, bufferCanvas) {
		const layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
		this._fire(BEFORE_DRAW, { node: this });
		if (this.clearBeforeDraw()) canvas.getContext().clear();
		Container.prototype.drawScene.call(this, canvas, top, bufferCanvas);
		this._fire(DRAW, { node: this });
		return this;
	}
	drawHit(can, top) {
		const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
		if (layer && layer.clearBeforeDraw()) layer.getHitCanvas().getContext().clear();
		Container.prototype.drawHit.call(this, canvas, top);
		return this;
	}
	enableHitGraph() {
		this.hitGraphEnabled(true);
		return this;
	}
	disableHitGraph() {
		this.hitGraphEnabled(false);
		return this;
	}
	setHitGraphEnabled(val) {
		Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
		this.listening(val);
	}
	getHitGraphEnabled(val) {
		Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
		return this.listening();
	}
	toggleHitCanvas() {
		if (!this.parent || !this.parent["content"]) return;
		const parent = this.parent;
		if (!!this.hitCanvas._canvas.parentNode) parent.content.removeChild(this.hitCanvas._canvas);
		else parent.content.appendChild(this.hitCanvas._canvas);
	}
	destroy() {
		Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
		return super.destroy();
	}
};
Layer.prototype.nodeType = "Layer";
_registerNode(Layer);
Factory.addGetterSetter(Layer, "imageSmoothingEnabled", true);
Factory.addGetterSetter(Layer, "clearBeforeDraw", true);
Factory.addGetterSetter(Layer, "hitGraphEnabled", true, getBooleanValidator());
var FastLayer = class extends Layer {
	constructor(attrs) {
		super(attrs);
		this.listening(false);
		Util.warn("Konva.Fast layer is deprecated. Please use \"new Konva.Layer({ listening: false })\" instead.");
	}
};
FastLayer.prototype.nodeType = "FastLayer";
_registerNode(FastLayer);
var Group = class extends Container {
	_validateAdd(child) {
		const type = child.getType();
		if (type !== "Group" && type !== "Shape") Util.throw("You may only add groups and shapes to groups.");
	}
};
Group.prototype.nodeType = "Group";
_registerNode(Group);
var now = (function() {
	if (glob.performance && glob.performance.now) return function() {
		return glob.performance.now();
	};
	return function() {
		return (/* @__PURE__ */ new Date()).getTime();
	};
})();
var Animation = class Animation {
	constructor(func, layers) {
		this.id = Animation.animIdCounter++;
		this.frame = {
			time: 0,
			timeDiff: 0,
			lastTime: now(),
			frameRate: 0
		};
		this.func = func;
		this.setLayers(layers);
	}
	setLayers(layers) {
		let lays = [];
		if (layers) lays = Array.isArray(layers) ? layers : [layers];
		this.layers = lays;
		return this;
	}
	getLayers() {
		return this.layers;
	}
	addLayer(layer) {
		const layers = this.layers;
		const len = layers.length;
		for (let n = 0; n < len; n++) if (layers[n]._id === layer._id) return false;
		this.layers.push(layer);
		return true;
	}
	isRunning() {
		const animations = Animation.animations;
		const len = animations.length;
		for (let n = 0; n < len; n++) if (animations[n].id === this.id) return true;
		return false;
	}
	start() {
		this.stop();
		this.frame.timeDiff = 0;
		this.frame.lastTime = now();
		Animation._addAnimation(this);
		return this;
	}
	stop() {
		Animation._removeAnimation(this);
		return this;
	}
	_updateFrameObject(time) {
		this.frame.timeDiff = time - this.frame.lastTime;
		this.frame.lastTime = time;
		this.frame.time += this.frame.timeDiff;
		this.frame.frameRate = 1e3 / this.frame.timeDiff;
	}
	static _addAnimation(anim) {
		this.animations.push(anim);
		this._handleAnimation();
	}
	static _removeAnimation(anim) {
		const id = anim.id;
		const animations = this.animations;
		const len = animations.length;
		for (let n = 0; n < len; n++) if (animations[n].id === id) {
			this.animations.splice(n, 1);
			break;
		}
	}
	static _runFrames() {
		const layerHash = {};
		const animations = this.animations;
		for (let n = 0; n < animations.length; n++) {
			const anim = animations[n];
			const layers = anim.layers;
			const func = anim.func;
			anim._updateFrameObject(now());
			const layersLen = layers.length;
			let needRedraw;
			if (func) needRedraw = func.call(anim, anim.frame) !== false;
			else needRedraw = true;
			if (!needRedraw) continue;
			for (let i = 0; i < layersLen; i++) {
				const layer = layers[i];
				if (layer._id !== void 0) layerHash[layer._id] = layer;
			}
		}
		for (const key in layerHash) {
			if (!layerHash.hasOwnProperty(key)) continue;
			layerHash[key].batchDraw();
		}
	}
	static _animationLoop() {
		const Anim = Animation;
		if (Anim.animations.length) {
			Anim._runFrames();
			Util.requestAnimFrame(Anim._animationLoop);
		} else Anim.animRunning = false;
	}
	static _handleAnimation() {
		if (!this.animRunning) {
			this.animRunning = true;
			Util.requestAnimFrame(this._animationLoop);
		}
	}
};
Animation.animations = [];
Animation.animIdCounter = 0;
Animation.animRunning = false;
var blacklist = {
	node: 1,
	duration: 1,
	easing: 1,
	onFinish: 1,
	yoyo: 1
}, PAUSED = 1, PLAYING = 2, REVERSING = 3, colorAttrs = [
	"fill",
	"stroke",
	"shadowColor"
];
var idCounter = 0;
var TweenEngine = class {
	constructor(prop, propFunc, func, begin, finish, duration, yoyo) {
		this.prop = prop;
		this.propFunc = propFunc;
		this.begin = begin;
		this._pos = begin;
		this.duration = duration;
		this._change = 0;
		this.prevPos = 0;
		this.yoyo = yoyo;
		this._time = 0;
		this._position = 0;
		this._startTime = 0;
		this._finish = 0;
		this.func = func;
		this._change = finish - this.begin;
		this.pause();
	}
	fire(str) {
		const handler = this[str];
		if (handler) handler();
	}
	setTime(t) {
		if (t > this.duration) if (this.yoyo) {
			this._time = this.duration;
			this.reverse();
		} else this.finish();
		else if (t < 0) if (this.yoyo) {
			this._time = 0;
			this.play();
		} else this.reset();
		else {
			this._time = t;
			this.update();
		}
	}
	getTime() {
		return this._time;
	}
	setPosition(p) {
		this.prevPos = this._pos;
		this.propFunc(p);
		this._pos = p;
	}
	getPosition(t) {
		if (t === void 0) t = this._time;
		return this.func(t, this.begin, this._change, this.duration);
	}
	play() {
		this.state = PLAYING;
		this._startTime = this.getTimer() - this._time;
		this.onEnterFrame();
		this.fire("onPlay");
	}
	reverse() {
		this.state = REVERSING;
		this._time = this.duration - this._time;
		this._startTime = this.getTimer() - this._time;
		this.onEnterFrame();
		this.fire("onReverse");
	}
	seek(t) {
		this.pause();
		this._time = t;
		this.update();
		this.fire("onSeek");
	}
	reset() {
		this.pause();
		this._time = 0;
		this.update();
		this.fire("onReset");
	}
	finish() {
		this.pause();
		this._time = this.duration;
		this.update();
		this.fire("onFinish");
	}
	update() {
		this.setPosition(this.getPosition(this._time));
		this.fire("onUpdate");
	}
	onEnterFrame() {
		const t = this.getTimer() - this._startTime;
		if (this.state === PLAYING) this.setTime(t);
		else if (this.state === REVERSING) this.setTime(this.duration - t);
	}
	pause() {
		this.state = PAUSED;
		this.fire("onPause");
	}
	getTimer() {
		return (/* @__PURE__ */ new Date()).getTime();
	}
};
var Tween = class Tween {
	constructor(config) {
		const that = this, node = config.node, nodeId = node._id, easing = config.easing || Easings.Linear, yoyo = !!config.yoyo;
		let duration, key;
		if (typeof config.duration === "undefined") duration = .3;
		else if (config.duration === 0) duration = .001;
		else duration = config.duration;
		this.node = node;
		this._id = idCounter++;
		const layers = node.getLayer() || (node instanceof Konva$2["Stage"] ? node.getLayers() : null);
		if (!layers) Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first.");
		this.anim = new Animation(function() {
			that.tween.onEnterFrame();
		}, layers);
		this.tween = new TweenEngine(key, function(i) {
			that._tweenFunc(i);
		}, easing, 0, 1, duration * 1e3, yoyo);
		this._addListeners();
		if (!Tween.attrs[nodeId]) Tween.attrs[nodeId] = {};
		if (!Tween.attrs[nodeId][this._id]) Tween.attrs[nodeId][this._id] = {};
		if (!Tween.tweens[nodeId]) Tween.tweens[nodeId] = {};
		for (key in config) if (blacklist[key] === void 0) this._addAttr(key, config[key]);
		this.reset();
		this.onFinish = config.onFinish;
		this.onReset = config.onReset;
		this.onUpdate = config.onUpdate;
	}
	_addAttr(key, end) {
		const node = this.node, nodeId = node._id;
		let diff, len, trueEnd, trueStart, endRGBA;
		const tweenId = Tween.tweens[nodeId][key];
		if (tweenId) delete Tween.attrs[nodeId][tweenId][key];
		let start = node.getAttr(key);
		if (Util._isArray(end)) {
			diff = [];
			len = Math.max(end.length, start.length);
			if (key === "points" && end.length !== start.length) if (end.length > start.length) {
				trueStart = start;
				start = Util._prepareArrayForTween(start, end, node.closed());
			} else {
				trueEnd = end;
				end = Util._prepareArrayForTween(end, start, node.closed());
			}
			if (key.indexOf("fill") === 0) for (let n = 0; n < len; n++) if (n % 2 === 0) diff.push(end[n] - start[n]);
			else {
				const startRGBA = Util.colorToRGBA(start[n]);
				endRGBA = Util.colorToRGBA(end[n]);
				start[n] = startRGBA;
				diff.push({
					r: endRGBA.r - startRGBA.r,
					g: endRGBA.g - startRGBA.g,
					b: endRGBA.b - startRGBA.b,
					a: endRGBA.a - startRGBA.a
				});
			}
			else for (let n = 0; n < len; n++) diff.push(end[n] - start[n]);
		} else if (colorAttrs.indexOf(key) !== -1) {
			start = Util.colorToRGBA(start);
			endRGBA = Util.colorToRGBA(end);
			diff = {
				r: endRGBA.r - start.r,
				g: endRGBA.g - start.g,
				b: endRGBA.b - start.b,
				a: endRGBA.a - start.a
			};
		} else diff = end - start;
		Tween.attrs[nodeId][this._id][key] = {
			start,
			diff,
			end,
			trueEnd,
			trueStart
		};
		Tween.tweens[nodeId][key] = this._id;
	}
	_tweenFunc(i) {
		const node = this.node, attrs = Tween.attrs[node._id][this._id];
		let key, attr, start, diff, newVal, n, len, end;
		for (key in attrs) {
			attr = attrs[key];
			start = attr.start;
			diff = attr.diff;
			end = attr.end;
			if (Util._isArray(start)) {
				newVal = [];
				len = Math.max(start.length, end.length);
				if (key.indexOf("fill") === 0) for (n = 0; n < len; n++) if (n % 2 === 0) newVal.push((start[n] || 0) + diff[n] * i);
				else newVal.push("rgba(" + Math.round(start[n].r + diff[n].r * i) + "," + Math.round(start[n].g + diff[n].g * i) + "," + Math.round(start[n].b + diff[n].b * i) + "," + (start[n].a + diff[n].a * i) + ")");
				else for (n = 0; n < len; n++) newVal.push((start[n] || 0) + diff[n] * i);
			} else if (colorAttrs.indexOf(key) !== -1) newVal = "rgba(" + Math.round(start.r + diff.r * i) + "," + Math.round(start.g + diff.g * i) + "," + Math.round(start.b + diff.b * i) + "," + (start.a + diff.a * i) + ")";
			else newVal = start + diff * i;
			node.setAttr(key, newVal);
		}
	}
	_addListeners() {
		this.tween.onPlay = () => {
			this.anim.start();
		};
		this.tween.onReverse = () => {
			this.anim.start();
		};
		this.tween.onPause = () => {
			this.anim.stop();
		};
		this.tween.onFinish = () => {
			const node = this.node;
			const attrs = Tween.attrs[node._id][this._id];
			if (attrs.points && attrs.points.trueEnd) node.setAttr("points", attrs.points.trueEnd);
			if (this.onFinish) this.onFinish.call(this);
		};
		this.tween.onReset = () => {
			const node = this.node;
			const attrs = Tween.attrs[node._id][this._id];
			if (attrs.points && attrs.points.trueStart) node.points(attrs.points.trueStart);
			if (this.onReset) this.onReset();
		};
		this.tween.onUpdate = () => {
			if (this.onUpdate) this.onUpdate.call(this);
		};
	}
	play() {
		this.tween.play();
		return this;
	}
	reverse() {
		this.tween.reverse();
		return this;
	}
	reset() {
		this.tween.reset();
		return this;
	}
	seek(t) {
		this.tween.seek(t * 1e3);
		return this;
	}
	pause() {
		this.tween.pause();
		return this;
	}
	finish() {
		this.tween.finish();
		return this;
	}
	destroy() {
		const nodeId = this.node._id, thisId = this._id, attrs = Tween.tweens[nodeId];
		this.pause();
		if (this.anim) this.anim.stop();
		for (const key in attrs) delete Tween.tweens[nodeId][key];
		delete Tween.attrs[nodeId][thisId];
		if (Tween.tweens[nodeId]) {
			if (Object.keys(Tween.tweens[nodeId]).length === 0) delete Tween.tweens[nodeId];
			if (Object.keys(Tween.attrs[nodeId]).length === 0) delete Tween.attrs[nodeId];
		}
	}
};
Tween.attrs = {};
Tween.tweens = {};
Node$1.prototype.to = function(params) {
	const onFinish = params.onFinish;
	params.node = this;
	params.onFinish = function() {
		this.destroy();
		if (onFinish) onFinish();
	};
	new Tween(params).play();
};
const Easings = {
	BackEaseIn(t, b, c, d) {
		const s = 1.70158;
		return c * (t /= d) * t * ((s + 1) * t - s) + b;
	},
	BackEaseOut(t, b, c, d) {
		const s = 1.70158;
		return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	},
	BackEaseInOut(t, b, c, d) {
		let s = 1.70158;
		if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
		return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	},
	ElasticEaseIn(t, b, c, d, a, p) {
		let s = 0;
		if (t === 0) return b;
		if ((t /= d) === 1) return b + c;
		if (!p) p = d * .3;
		if (!a || a < Math.abs(c)) {
			a = c;
			s = p / 4;
		} else s = p / (2 * Math.PI) * Math.asin(c / a);
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	},
	ElasticEaseOut(t, b, c, d, a, p) {
		let s = 0;
		if (t === 0) return b;
		if ((t /= d) === 1) return b + c;
		if (!p) p = d * .3;
		if (!a || a < Math.abs(c)) {
			a = c;
			s = p / 4;
		} else s = p / (2 * Math.PI) * Math.asin(c / a);
		return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	},
	ElasticEaseInOut(t, b, c, d, a, p) {
		let s = 0;
		if (t === 0) return b;
		if ((t /= d / 2) === 2) return b + c;
		if (!p) p = d * (.3 * 1.5);
		if (!a || a < Math.abs(c)) {
			a = c;
			s = p / 4;
		} else s = p / (2 * Math.PI) * Math.asin(c / a);
		if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
	},
	BounceEaseOut(t, b, c, d) {
		if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
		else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
		else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
		else return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
	},
	BounceEaseIn(t, b, c, d) {
		return c - Easings.BounceEaseOut(d - t, 0, c, d) + b;
	},
	BounceEaseInOut(t, b, c, d) {
		if (t < d / 2) return Easings.BounceEaseIn(t * 2, 0, c, d) * .5 + b;
		else return Easings.BounceEaseOut(t * 2 - d, 0, c, d) * .5 + c * .5 + b;
	},
	EaseIn(t, b, c, d) {
		return c * (t /= d) * t + b;
	},
	EaseOut(t, b, c, d) {
		return -c * (t /= d) * (t - 2) + b;
	},
	EaseInOut(t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t + b;
		return -c / 2 * (--t * (t - 2) - 1) + b;
	},
	StrongEaseIn(t, b, c, d) {
		return c * (t /= d) * t * t * t * t + b;
	},
	StrongEaseOut(t, b, c, d) {
		return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	},
	StrongEaseInOut(t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
		return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	},
	Linear(t, b, c, d) {
		return c * t / d + b;
	}
};
const Konva$1 = Util._assign(Konva$2, {
	Util,
	Transform,
	Node: Node$1,
	Container,
	Stage,
	stages,
	Layer,
	FastLayer,
	Group,
	DD,
	Shape,
	shapes,
	Animation,
	Tween,
	Easings,
	Context,
	Canvas
});
var Arc = class extends Shape {
	_sceneFunc(context) {
		const angle = Konva$2.getAngle(this.angle()), clockwise = this.clockwise();
		context.beginPath();
		context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
		context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
		context.closePath();
		context.fillStrokeShape(this);
	}
	getWidth() {
		return this.outerRadius() * 2;
	}
	getHeight() {
		return this.outerRadius() * 2;
	}
	setWidth(width) {
		this.outerRadius(width / 2);
	}
	setHeight(height) {
		this.outerRadius(height / 2);
	}
	getSelfRect() {
		const innerRadius = this.innerRadius();
		const outerRadius = this.outerRadius();
		const clockwise = this.clockwise();
		const angle = Konva$2.getAngle(clockwise ? 360 - this.angle() : this.angle());
		const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
		const boundRightRatio = 1;
		const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
		const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
		const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
		const boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
		const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
		const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
		return {
			x: boundLeft,
			y: clockwise ? -1 * boundBottom : boundTop,
			width: boundRight - boundLeft,
			height: boundBottom - boundTop
		};
	}
};
Arc.prototype._centroid = true;
Arc.prototype.className = "Arc";
Arc.prototype._attrsAffectingSize = [
	"innerRadius",
	"outerRadius",
	"angle",
	"clockwise"
];
_registerNode(Arc);
Factory.addGetterSetter(Arc, "innerRadius", 0, getNumberValidator());
Factory.addGetterSetter(Arc, "outerRadius", 0, getNumberValidator());
Factory.addGetterSetter(Arc, "angle", 0, getNumberValidator());
Factory.addGetterSetter(Arc, "clockwise", false, getBooleanValidator());
function getControlPoints(x0, y0, x1, y1, x2, y2, t) {
	const d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = t * d01 / (d01 + d12), fb = t * d12 / (d01 + d12);
	return [
		x1 - fa * (x2 - x0),
		y1 - fa * (y2 - y0),
		x1 + fb * (x2 - x0),
		y1 + fb * (y2 - y0)
	];
}
function expandPoints(p, tension) {
	const len = p.length, allPoints = [];
	for (let n = 2; n < len - 2; n += 2) {
		const cp = getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
		if (isNaN(cp[0])) continue;
		allPoints.push(cp[0]);
		allPoints.push(cp[1]);
		allPoints.push(p[n]);
		allPoints.push(p[n + 1]);
		allPoints.push(cp[2]);
		allPoints.push(cp[3]);
	}
	return allPoints;
}
function getBezierExtremaPoints(points) {
	const axisPoints = [[
		points[0],
		points[2],
		points[4],
		points[6]
	], [
		points[1],
		points[3],
		points[5],
		points[7]
	]];
	const extremaTs = [];
	for (const axis of axisPoints) {
		const a = -3 * axis[0] + 9 * axis[1] - 9 * axis[2] + 3 * axis[3];
		if (a !== 0) {
			const b = 6 * axis[0] - 12 * axis[1] + 6 * axis[2];
			const c = -3 * axis[0] + 3 * axis[1];
			const discriminant = b * b - 4 * a * c;
			if (discriminant >= 0) {
				const d = Math.sqrt(discriminant);
				extremaTs.push((-b + d) / (2 * a));
				extremaTs.push((-b - d) / (2 * a));
			}
		}
	}
	return extremaTs.filter((t) => t > 0 && t < 1).flatMap((t) => axisPoints.map((axis) => {
		const mt = 1 - t;
		return mt * mt * mt * axis[0] + 3 * mt * mt * t * axis[1] + 3 * mt * t * t * axis[2] + t * t * t * axis[3];
	}));
}
var Line = class extends Shape {
	constructor(config) {
		super(config);
		this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
			this._clearCache("tensionPoints");
		});
	}
	_sceneFunc(context) {
		const points = this.points(), length$1 = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier();
		if (!length$1) return;
		let n = 0;
		context.beginPath();
		context.moveTo(points[0], points[1]);
		if (tension !== 0 && length$1 > 4) {
			const tp = this.getTensionPoints();
			const len = tp.length;
			n = closed ? 0 : 4;
			if (!closed) context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
			while (n < len - 2) context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
			if (!closed) context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length$1 - 2], points[length$1 - 1]);
		} else if (bezier) {
			n = 2;
			while (n < length$1) context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
		} else for (n = 2; n < length$1; n += 2) context.lineTo(points[n], points[n + 1]);
		if (closed) {
			context.closePath();
			context.fillStrokeShape(this);
		} else context.strokeShape(this);
	}
	getTensionPoints() {
		return this._getCache("tensionPoints", this._getTensionPoints);
	}
	_getTensionPoints() {
		if (this.closed()) return this._getTensionPointsClosed();
		else return expandPoints(this.points(), this.tension());
	}
	_getTensionPointsClosed() {
		const p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = expandPoints(p, tension);
		return [firstControlPoints[2], firstControlPoints[3]].concat(middle).concat([
			lastControlPoints[0],
			lastControlPoints[1],
			p[len - 2],
			p[len - 1],
			lastControlPoints[2],
			lastControlPoints[3],
			firstControlPoints[0],
			firstControlPoints[1],
			p[0],
			p[1]
		]);
	}
	getWidth() {
		return this.getSelfRect().width;
	}
	getHeight() {
		return this.getSelfRect().height;
	}
	getSelfRect() {
		let points = this.points();
		if (points.length < 4) return {
			x: points[0] || 0,
			y: points[1] || 0,
			width: 0,
			height: 0
		};
		if (this.tension() !== 0) points = [
			points[0],
			points[1],
			...this._getTensionPoints(),
			points[points.length - 2],
			points[points.length - 1]
		];
		else if (this.bezier()) points = [
			points[0],
			points[1],
			...getBezierExtremaPoints(this.points()),
			points[points.length - 2],
			points[points.length - 1]
		];
		else points = this.points();
		let minX = points[0];
		let maxX = points[0];
		let minY = points[1];
		let maxY = points[1];
		let x, y;
		for (let i = 0; i < points.length / 2; i++) {
			x = points[i * 2];
			y = points[i * 2 + 1];
			minX = Math.min(minX, x);
			maxX = Math.max(maxX, x);
			minY = Math.min(minY, y);
			maxY = Math.max(maxY, y);
		}
		return {
			x: minX,
			y: minY,
			width: maxX - minX,
			height: maxY - minY
		};
	}
};
Line.prototype.className = "Line";
Line.prototype._attrsAffectingSize = [
	"points",
	"bezier",
	"tension"
];
_registerNode(Line);
Factory.addGetterSetter(Line, "closed", false);
Factory.addGetterSetter(Line, "bezier", false);
Factory.addGetterSetter(Line, "tension", 0, getNumberValidator());
Factory.addGetterSetter(Line, "points", [], getNumberArrayValidator());
const tValues = [
	[],
	[],
	[-.5773502691896257, .5773502691896257],
	[
		0,
		-.7745966692414834,
		.7745966692414834
	],
	[
		-.33998104358485626,
		.33998104358485626,
		-.8611363115940526,
		.8611363115940526
	],
	[
		0,
		-.5384693101056831,
		.5384693101056831,
		-.906179845938664,
		.906179845938664
	],
	[
		.6612093864662645,
		-.6612093864662645,
		-.2386191860831969,
		.2386191860831969,
		-.932469514203152,
		.932469514203152
	],
	[
		0,
		.4058451513773972,
		-.4058451513773972,
		-.7415311855993945,
		.7415311855993945,
		-.9491079123427585,
		.9491079123427585
	],
	[
		-.1834346424956498,
		.1834346424956498,
		-.525532409916329,
		.525532409916329,
		-.7966664774136267,
		.7966664774136267,
		-.9602898564975363,
		.9602898564975363
	],
	[
		0,
		-.8360311073266358,
		.8360311073266358,
		-.9681602395076261,
		.9681602395076261,
		-.3242534234038089,
		.3242534234038089,
		-.6133714327005904,
		.6133714327005904
	],
	[
		-.14887433898163122,
		.14887433898163122,
		-.4333953941292472,
		.4333953941292472,
		-.6794095682990244,
		.6794095682990244,
		-.8650633666889845,
		.8650633666889845,
		-.9739065285171717,
		.9739065285171717
	],
	[
		0,
		-.26954315595234496,
		.26954315595234496,
		-.5190961292068118,
		.5190961292068118,
		-.7301520055740494,
		.7301520055740494,
		-.8870625997680953,
		.8870625997680953,
		-.978228658146057,
		.978228658146057
	],
	[
		-.1252334085114689,
		.1252334085114689,
		-.3678314989981802,
		.3678314989981802,
		-.5873179542866175,
		.5873179542866175,
		-.7699026741943047,
		.7699026741943047,
		-.9041172563704749,
		.9041172563704749,
		-.9815606342467192,
		.9815606342467192
	],
	[
		0,
		-.2304583159551348,
		.2304583159551348,
		-.44849275103644687,
		.44849275103644687,
		-.6423493394403402,
		.6423493394403402,
		-.8015780907333099,
		.8015780907333099,
		-.9175983992229779,
		.9175983992229779,
		-.9841830547185881,
		.9841830547185881
	],
	[
		-.10805494870734367,
		.10805494870734367,
		-.31911236892788974,
		.31911236892788974,
		-.5152486363581541,
		.5152486363581541,
		-.6872929048116855,
		.6872929048116855,
		-.827201315069765,
		.827201315069765,
		-.9284348836635735,
		.9284348836635735,
		-.9862838086968123,
		.9862838086968123
	],
	[
		0,
		-.20119409399743451,
		.20119409399743451,
		-.3941513470775634,
		.3941513470775634,
		-.5709721726085388,
		.5709721726085388,
		-.7244177313601701,
		.7244177313601701,
		-.8482065834104272,
		.8482065834104272,
		-.937273392400706,
		.937273392400706,
		-.9879925180204854,
		.9879925180204854
	],
	[
		-.09501250983763744,
		.09501250983763744,
		-.2816035507792589,
		.2816035507792589,
		-.45801677765722737,
		.45801677765722737,
		-.6178762444026438,
		.6178762444026438,
		-.755404408355003,
		.755404408355003,
		-.8656312023878318,
		.8656312023878318,
		-.9445750230732326,
		.9445750230732326,
		-.9894009349916499,
		.9894009349916499
	],
	[
		0,
		-.17848418149584785,
		.17848418149584785,
		-.3512317634538763,
		.3512317634538763,
		-.5126905370864769,
		.5126905370864769,
		-.6576711592166907,
		.6576711592166907,
		-.7815140038968014,
		.7815140038968014,
		-.8802391537269859,
		.8802391537269859,
		-.9506755217687678,
		.9506755217687678,
		-.9905754753144174,
		.9905754753144174
	],
	[
		-.0847750130417353,
		.0847750130417353,
		-.2518862256915055,
		.2518862256915055,
		-.41175116146284263,
		.41175116146284263,
		-.5597708310739475,
		.5597708310739475,
		-.6916870430603532,
		.6916870430603532,
		-.8037049589725231,
		.8037049589725231,
		-.8926024664975557,
		.8926024664975557,
		-.9558239495713977,
		.9558239495713977,
		-.9915651684209309,
		.9915651684209309
	],
	[
		0,
		-.16035864564022537,
		.16035864564022537,
		-.31656409996362983,
		.31656409996362983,
		-.46457074137596094,
		.46457074137596094,
		-.600545304661681,
		.600545304661681,
		-.7209661773352294,
		.7209661773352294,
		-.8227146565371428,
		.8227146565371428,
		-.9031559036148179,
		.9031559036148179,
		-.96020815213483,
		.96020815213483,
		-.9924068438435844,
		.9924068438435844
	],
	[
		-.07652652113349734,
		.07652652113349734,
		-.22778585114164507,
		.22778585114164507,
		-.37370608871541955,
		.37370608871541955,
		-.5108670019508271,
		.5108670019508271,
		-.636053680726515,
		.636053680726515,
		-.7463319064601508,
		.7463319064601508,
		-.8391169718222188,
		.8391169718222188,
		-.912234428251326,
		.912234428251326,
		-.9639719272779138,
		.9639719272779138,
		-.9931285991850949,
		.9931285991850949
	],
	[
		0,
		-.1455618541608951,
		.1455618541608951,
		-.2880213168024011,
		.2880213168024011,
		-.4243421202074388,
		.4243421202074388,
		-.5516188358872198,
		.5516188358872198,
		-.6671388041974123,
		.6671388041974123,
		-.7684399634756779,
		.7684399634756779,
		-.8533633645833173,
		.8533633645833173,
		-.9200993341504008,
		.9200993341504008,
		-.9672268385663063,
		.9672268385663063,
		-.9937521706203895,
		.9937521706203895
	],
	[
		-.06973927331972223,
		.06973927331972223,
		-.20786042668822127,
		.20786042668822127,
		-.34193582089208424,
		.34193582089208424,
		-.469355837986757,
		.469355837986757,
		-.5876404035069116,
		.5876404035069116,
		-.6944872631866827,
		.6944872631866827,
		-.7878168059792081,
		.7878168059792081,
		-.8658125777203002,
		.8658125777203002,
		-.926956772187174,
		.926956772187174,
		-.9700604978354287,
		.9700604978354287,
		-.9942945854823992,
		.9942945854823992
	],
	[
		0,
		-.1332568242984661,
		.1332568242984661,
		-.26413568097034495,
		.26413568097034495,
		-.3903010380302908,
		.3903010380302908,
		-.5095014778460075,
		.5095014778460075,
		-.6196098757636461,
		.6196098757636461,
		-.7186613631319502,
		.7186613631319502,
		-.8048884016188399,
		.8048884016188399,
		-.8767523582704416,
		.8767523582704416,
		-.9329710868260161,
		.9329710868260161,
		-.9725424712181152,
		.9725424712181152,
		-.9947693349975522,
		.9947693349975522
	],
	[
		-.06405689286260563,
		.06405689286260563,
		-.1911188674736163,
		.1911188674736163,
		-.3150426796961634,
		.3150426796961634,
		-.4337935076260451,
		.4337935076260451,
		-.5454214713888396,
		.5454214713888396,
		-.6480936519369755,
		.6480936519369755,
		-.7401241915785544,
		.7401241915785544,
		-.820001985973903,
		.820001985973903,
		-.8864155270044011,
		.8864155270044011,
		-.9382745520027328,
		.9382745520027328,
		-.9747285559713095,
		.9747285559713095,
		-.9951872199970213,
		.9951872199970213
	]
];
const cValues = [
	[],
	[],
	[1, 1],
	[
		.8888888888888888,
		.5555555555555556,
		.5555555555555556
	],
	[
		.6521451548625461,
		.6521451548625461,
		.34785484513745385,
		.34785484513745385
	],
	[
		.5688888888888889,
		.47862867049936647,
		.47862867049936647,
		.23692688505618908,
		.23692688505618908
	],
	[
		.3607615730481386,
		.3607615730481386,
		.46791393457269104,
		.46791393457269104,
		.17132449237917036,
		.17132449237917036
	],
	[
		.4179591836734694,
		.3818300505051189,
		.3818300505051189,
		.27970539148927664,
		.27970539148927664,
		.1294849661688697,
		.1294849661688697
	],
	[
		.362683783378362,
		.362683783378362,
		.31370664587788727,
		.31370664587788727,
		.22238103445337448,
		.22238103445337448,
		.10122853629037626,
		.10122853629037626
	],
	[
		.3302393550012598,
		.1806481606948574,
		.1806481606948574,
		.08127438836157441,
		.08127438836157441,
		.31234707704000286,
		.31234707704000286,
		.26061069640293544,
		.26061069640293544
	],
	[
		.29552422471475287,
		.29552422471475287,
		.26926671930999635,
		.26926671930999635,
		.21908636251598204,
		.21908636251598204,
		.1494513491505806,
		.1494513491505806,
		.06667134430868814,
		.06667134430868814
	],
	[
		.2729250867779006,
		.26280454451024665,
		.26280454451024665,
		.23319376459199048,
		.23319376459199048,
		.18629021092773426,
		.18629021092773426,
		.1255803694649046,
		.1255803694649046,
		.05566856711617366,
		.05566856711617366
	],
	[
		.24914704581340277,
		.24914704581340277,
		.2334925365383548,
		.2334925365383548,
		.20316742672306592,
		.20316742672306592,
		.16007832854334622,
		.16007832854334622,
		.10693932599531843,
		.10693932599531843,
		.04717533638651183,
		.04717533638651183
	],
	[
		.2325515532308739,
		.22628318026289723,
		.22628318026289723,
		.2078160475368885,
		.2078160475368885,
		.17814598076194574,
		.17814598076194574,
		.13887351021978725,
		.13887351021978725,
		.09212149983772845,
		.09212149983772845,
		.04048400476531588,
		.04048400476531588
	],
	[
		.2152638534631578,
		.2152638534631578,
		.2051984637212956,
		.2051984637212956,
		.18553839747793782,
		.18553839747793782,
		.15720316715819355,
		.15720316715819355,
		.12151857068790319,
		.12151857068790319,
		.08015808715976021,
		.08015808715976021,
		.03511946033175186,
		.03511946033175186
	],
	[
		.2025782419255613,
		.19843148532711158,
		.19843148532711158,
		.1861610000155622,
		.1861610000155622,
		.16626920581699392,
		.16626920581699392,
		.13957067792615432,
		.13957067792615432,
		.10715922046717194,
		.10715922046717194,
		.07036604748810812,
		.07036604748810812,
		.03075324199611727,
		.03075324199611727
	],
	[
		.1894506104550685,
		.1894506104550685,
		.18260341504492358,
		.18260341504492358,
		.16915651939500254,
		.16915651939500254,
		.14959598881657674,
		.14959598881657674,
		.12462897125553388,
		.12462897125553388,
		.09515851168249279,
		.09515851168249279,
		.062253523938647894,
		.062253523938647894,
		.027152459411754096,
		.027152459411754096
	],
	[
		.17944647035620653,
		.17656270536699264,
		.17656270536699264,
		.16800410215645004,
		.16800410215645004,
		.15404576107681028,
		.15404576107681028,
		.13513636846852548,
		.13513636846852548,
		.11188384719340397,
		.11188384719340397,
		.08503614831717918,
		.08503614831717918,
		.0554595293739872,
		.0554595293739872,
		.02414830286854793,
		.02414830286854793
	],
	[
		.1691423829631436,
		.1691423829631436,
		.16427648374583273,
		.16427648374583273,
		.15468467512626524,
		.15468467512626524,
		.14064291467065065,
		.14064291467065065,
		.12255520671147846,
		.12255520671147846,
		.10094204410628717,
		.10094204410628717,
		.07642573025488905,
		.07642573025488905,
		.0497145488949698,
		.0497145488949698,
		.02161601352648331,
		.02161601352648331
	],
	[
		.1610544498487837,
		.15896884339395434,
		.15896884339395434,
		.15276604206585967,
		.15276604206585967,
		.1426067021736066,
		.1426067021736066,
		.12875396253933621,
		.12875396253933621,
		.11156664554733399,
		.11156664554733399,
		.09149002162245,
		.09149002162245,
		.06904454273764123,
		.06904454273764123,
		.0448142267656996,
		.0448142267656996,
		.019461788229726478,
		.019461788229726478
	],
	[
		.15275338713072584,
		.15275338713072584,
		.14917298647260374,
		.14917298647260374,
		.14209610931838204,
		.14209610931838204,
		.13168863844917664,
		.13168863844917664,
		.11819453196151841,
		.11819453196151841,
		.10193011981724044,
		.10193011981724044,
		.08327674157670475,
		.08327674157670475,
		.06267204833410907,
		.06267204833410907,
		.04060142980038694,
		.04060142980038694,
		.017614007139152118,
		.017614007139152118
	],
	[
		.14608113364969041,
		.14452440398997005,
		.14452440398997005,
		.13988739479107315,
		.13988739479107315,
		.13226893863333747,
		.13226893863333747,
		.12183141605372853,
		.12183141605372853,
		.10879729916714838,
		.10879729916714838,
		.09344442345603386,
		.09344442345603386,
		.0761001136283793,
		.0761001136283793,
		.057134425426857205,
		.057134425426857205,
		.036953789770852494,
		.036953789770852494,
		.016017228257774335,
		.016017228257774335
	],
	[
		.13925187285563198,
		.13925187285563198,
		.13654149834601517,
		.13654149834601517,
		.13117350478706238,
		.13117350478706238,
		.12325237681051242,
		.12325237681051242,
		.11293229608053922,
		.11293229608053922,
		.10041414444288096,
		.10041414444288096,
		.08594160621706773,
		.08594160621706773,
		.06979646842452049,
		.06979646842452049,
		.052293335152683286,
		.052293335152683286,
		.03377490158481415,
		.03377490158481415,
		.0146279952982722,
		.0146279952982722
	],
	[
		.13365457218610619,
		.1324620394046966,
		.1324620394046966,
		.12890572218808216,
		.12890572218808216,
		.12304908430672953,
		.12304908430672953,
		.11499664022241136,
		.11499664022241136,
		.10489209146454141,
		.10489209146454141,
		.09291576606003515,
		.09291576606003515,
		.07928141177671895,
		.07928141177671895,
		.06423242140852585,
		.06423242140852585,
		.04803767173108467,
		.04803767173108467,
		.030988005856979445,
		.030988005856979445,
		.013411859487141771,
		.013411859487141771
	],
	[
		.12793819534675216,
		.12793819534675216,
		.1258374563468283,
		.1258374563468283,
		.12167047292780339,
		.12167047292780339,
		.1155056680537256,
		.1155056680537256,
		.10744427011596563,
		.10744427011596563,
		.09761865210411388,
		.09761865210411388,
		.08619016153195327,
		.08619016153195327,
		.0733464814110803,
		.0733464814110803,
		.05929858491543678,
		.05929858491543678,
		.04427743881741981,
		.04427743881741981,
		.028531388628933663,
		.028531388628933663,
		.0123412297999872,
		.0123412297999872
	]
];
const binomialCoefficients = [
	[1],
	[1, 1],
	[
		1,
		2,
		1
	],
	[
		1,
		3,
		3,
		1
	]
];
const getCubicArcLength = (xs, ys, t) => {
	let sum;
	let correctedT;
	const n = 20;
	const z = t / 2;
	sum = 0;
	for (let i = 0; i < n; i++) {
		correctedT = z * tValues[n][i] + z;
		sum += cValues[n][i] * BFunc(xs, ys, correctedT);
	}
	return z * sum;
};
const getQuadraticArcLength = (xs, ys, t) => {
	if (t === void 0) t = 1;
	const ax = xs[0] - 2 * xs[1] + xs[2];
	const ay = ys[0] - 2 * ys[1] + ys[2];
	const bx = 2 * xs[1] - 2 * xs[0];
	const by = 2 * ys[1] - 2 * ys[0];
	const A = 4 * (ax * ax + ay * ay);
	const B = 4 * (ax * bx + ay * by);
	const C = bx * bx + by * by;
	if (A === 0) return t * Math.sqrt(Math.pow(xs[2] - xs[0], 2) + Math.pow(ys[2] - ys[0], 2));
	const b = B / (2 * A);
	const c = C / A;
	const u = t + b;
	const k = c - b * b;
	const uuk = u * u + k > 0 ? Math.sqrt(u * u + k) : 0;
	const bbk = b * b + k > 0 ? Math.sqrt(b * b + k) : 0;
	const term = b + Math.sqrt(b * b + k) !== 0 ? k * Math.log(Math.abs((u + uuk) / (b + bbk))) : 0;
	return Math.sqrt(A) / 2 * (u * uuk - b * bbk + term);
};
function BFunc(xs, ys, t) {
	const xbase = getDerivative(1, t, xs);
	const ybase = getDerivative(1, t, ys);
	const combined = xbase * xbase + ybase * ybase;
	return Math.sqrt(combined);
}
var getDerivative = (derivative, t, vs) => {
	const n = vs.length - 1;
	let _vs;
	let value;
	if (n === 0) return 0;
	if (derivative === 0) {
		value = 0;
		for (let k = 0; k <= n; k++) value += binomialCoefficients[n][k] * Math.pow(1 - t, n - k) * Math.pow(t, k) * vs[k];
		return value;
	} else {
		_vs = new Array(n);
		for (let k = 0; k < n; k++) _vs[k] = n * (vs[k + 1] - vs[k]);
		return getDerivative(derivative - 1, t, _vs);
	}
};
const t2length = (length$1, totalLength, func) => {
	let error = 1;
	let t = length$1 / totalLength;
	let step = (length$1 - func(t)) / totalLength;
	let numIterations = 0;
	while (error > .001) {
		const increasedTLength = func(t + step);
		const increasedTError = Math.abs(length$1 - increasedTLength) / totalLength;
		if (increasedTError < error) {
			error = increasedTError;
			t += step;
		} else {
			const decreasedTLength = func(t - step);
			const decreasedTError = Math.abs(length$1 - decreasedTLength) / totalLength;
			if (decreasedTError < error) {
				error = decreasedTError;
				t -= step;
			} else step /= 2;
		}
		numIterations++;
		if (numIterations > 500) break;
	}
	return t;
};
var Path = class Path extends Shape {
	constructor(config) {
		super(config);
		this.dataArray = [];
		this.pathLength = 0;
		this._readDataAttribute();
		this.on("dataChange.konva", function() {
			this._readDataAttribute();
		});
	}
	_readDataAttribute() {
		this.dataArray = Path.parsePathData(this.data());
		this.pathLength = Path.getPathLength(this.dataArray);
	}
	_sceneFunc(context) {
		const ca = this.dataArray;
		context.beginPath();
		let isClosed = false;
		for (let n = 0; n < ca.length; n++) {
			const c = ca[n].command;
			const p = ca[n].points;
			switch (c) {
				case "L":
					context.lineTo(p[0], p[1]);
					break;
				case "M":
					context.moveTo(p[0], p[1]);
					break;
				case "C":
					context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
					break;
				case "Q":
					context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
					break;
				case "A":
					const cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
					const r = rx > ry ? rx : ry;
					const scaleX = rx > ry ? 1 : rx / ry;
					const scaleY = rx > ry ? ry / rx : 1;
					context.translate(cx, cy);
					context.rotate(psi);
					context.scale(scaleX, scaleY);
					context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
					context.scale(1 / scaleX, 1 / scaleY);
					context.rotate(-psi);
					context.translate(-cx, -cy);
					break;
				case "z":
					isClosed = true;
					context.closePath();
					break;
			}
		}
		if (!isClosed && !this.hasFill()) context.strokeShape(this);
		else context.fillStrokeShape(this);
	}
	getSelfRect() {
		let points = [];
		this.dataArray.forEach(function(data) {
			if (data.command === "A") {
				const start = data.points[4];
				const dTheta = data.points[5];
				const end = data.points[4] + dTheta;
				let inc = Math.PI / 180;
				if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
				if (dTheta < 0) for (let t = start - inc; t > end; t -= inc) {
					const point = Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
					points.push(point.x, point.y);
				}
				else for (let t = start + inc; t < end; t += inc) {
					const point = Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
					points.push(point.x, point.y);
				}
			} else if (data.command === "C") for (let t = 0; t <= 1; t += .01) {
				const point = Path.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
				points.push(point.x, point.y);
			}
			else points = points.concat(data.points);
		});
		let minX = points[0];
		let maxX = points[0];
		let minY = points[1];
		let maxY = points[1];
		let x, y;
		for (let i = 0; i < points.length / 2; i++) {
			x = points[i * 2];
			y = points[i * 2 + 1];
			if (!isNaN(x)) {
				minX = Math.min(minX, x);
				maxX = Math.max(maxX, x);
			}
			if (!isNaN(y)) {
				minY = Math.min(minY, y);
				maxY = Math.max(maxY, y);
			}
		}
		return {
			x: minX,
			y: minY,
			width: maxX - minX,
			height: maxY - minY
		};
	}
	getLength() {
		return this.pathLength;
	}
	getPointAtLength(length$1) {
		return Path.getPointAtLengthOfDataArray(length$1, this.dataArray);
	}
	static getLineLength(x1, y1, x2, y2) {
		return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
	}
	static getPathLength(dataArray) {
		let pathLength = 0;
		for (let i = 0; i < dataArray.length; ++i) pathLength += dataArray[i].pathLength;
		return pathLength;
	}
	static getPointAtLengthOfDataArray(length$1, dataArray) {
		let points, i = 0, ii = dataArray.length;
		if (!ii) return null;
		while (i < ii && length$1 > dataArray[i].pathLength) {
			length$1 -= dataArray[i].pathLength;
			++i;
		}
		if (i === ii) {
			points = dataArray[i - 1].points.slice(-2);
			return {
				x: points[0],
				y: points[1]
			};
		}
		if (length$1 < .01) if (dataArray[i].command === "M") {
			points = dataArray[i].points.slice(0, 2);
			return {
				x: points[0],
				y: points[1]
			};
		} else return {
			x: dataArray[i].start.x,
			y: dataArray[i].start.y
		};
		const cp = dataArray[i];
		const p = cp.points;
		switch (cp.command) {
			case "L": return Path.getPointOnLine(length$1, cp.start.x, cp.start.y, p[0], p[1]);
			case "C": return Path.getPointOnCubicBezier(t2length(length$1, Path.getPathLength(dataArray), (i$1) => {
				return getCubicArcLength([
					cp.start.x,
					p[0],
					p[2],
					p[4]
				], [
					cp.start.y,
					p[1],
					p[3],
					p[5]
				], i$1);
			}), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
			case "Q": return Path.getPointOnQuadraticBezier(t2length(length$1, Path.getPathLength(dataArray), (i$1) => {
				return getQuadraticArcLength([
					cp.start.x,
					p[0],
					p[2]
				], [
					cp.start.y,
					p[1],
					p[3]
				], i$1);
			}), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
			case "A":
				const cx = p[0], cy = p[1], rx = p[2], ry = p[3], dTheta = p[5], psi = p[6];
				let theta = p[4];
				theta += dTheta * length$1 / cp.pathLength;
				return Path.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
		}
		return null;
	}
	static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
		fromX = fromX !== null && fromX !== void 0 ? fromX : P1x;
		fromY = fromY !== null && fromY !== void 0 ? fromY : P1y;
		const len = this.getLineLength(P1x, P1y, P2x, P2y);
		if (len < 1e-10) return {
			x: P1x,
			y: P1y
		};
		if (P2x === P1x) return {
			x: fromX,
			y: fromY + (P2y > P1y ? dist : -dist)
		};
		const m = (P2y - P1y) / (P2x - P1x);
		const run = Math.sqrt(dist * dist / (1 + m * m)) * (P2x < P1x ? -1 : 1);
		const rise = m * run;
		if (Math.abs(fromY - P1y - m * (fromX - P1x)) < 1e-10) return {
			x: fromX + run,
			y: fromY + rise
		};
		const u = ((fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y)) / (len * len);
		const ix = P1x + u * (P2x - P1x);
		const iy = P1y + u * (P2y - P1y);
		const pRise = this.getLineLength(fromX, fromY, ix, iy);
		const pRun = Math.sqrt(dist * dist - pRise * pRise);
		const adjustedRun = Math.sqrt(pRun * pRun / (1 + m * m)) * (P2x < P1x ? -1 : 1);
		const adjustedRise = m * adjustedRun;
		return {
			x: ix + adjustedRun,
			y: iy + adjustedRise
		};
	}
	static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
		function CB1(t) {
			return t * t * t;
		}
		function CB2(t) {
			return 3 * t * t * (1 - t);
		}
		function CB3(t) {
			return 3 * t * (1 - t) * (1 - t);
		}
		function CB4(t) {
			return (1 - t) * (1 - t) * (1 - t);
		}
		return {
			x: P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct),
			y: P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct)
		};
	}
	static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
		function QB1(t) {
			return t * t;
		}
		function QB2(t) {
			return 2 * t * (1 - t);
		}
		function QB3(t) {
			return (1 - t) * (1 - t);
		}
		return {
			x: P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct),
			y: P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct)
		};
	}
	static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
		const cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
		const pt = {
			x: rx * Math.cos(theta),
			y: ry * Math.sin(theta)
		};
		return {
			x: cx + (pt.x * cosPsi - pt.y * sinPsi),
			y: cy + (pt.x * sinPsi + pt.y * cosPsi)
		};
	}
	static parsePathData(data) {
		if (!data) return [];
		let cs = data;
		const cc = [
			"m",
			"M",
			"l",
			"L",
			"v",
			"V",
			"h",
			"H",
			"z",
			"Z",
			"c",
			"C",
			"q",
			"Q",
			"t",
			"T",
			"s",
			"S",
			"a",
			"A"
		];
		cs = cs.replace(new RegExp(" ", "g"), ",");
		for (let n = 0; n < cc.length; n++) cs = cs.replace(new RegExp(cc[n], "g"), "|" + cc[n]);
		const arr = cs.split("|");
		const ca = [];
		const coords = [];
		let cpx = 0;
		let cpy = 0;
		const re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
		let match;
		for (let n = 1; n < arr.length; n++) {
			let str = arr[n];
			let c = str.charAt(0);
			str = str.slice(1);
			coords.length = 0;
			while (match = re.exec(str)) coords.push(match[0]);
			let p = [];
			let arcParamIndex = c === "A" || c === "a" ? 0 : -1;
			for (let j = 0, jlen = coords.length; j < jlen; j++) {
				const token = coords[j];
				if (token === "00") {
					p.push(0, 0);
					if (arcParamIndex >= 0) {
						arcParamIndex += 2;
						if (arcParamIndex >= 7) arcParamIndex -= 7;
					}
					continue;
				}
				if (arcParamIndex >= 0) {
					if (arcParamIndex === 3) {
						if (/^[01]{2}\d+(?:\.\d+)?$/.test(token)) {
							p.push(parseInt(token[0], 10));
							p.push(parseInt(token[1], 10));
							p.push(parseFloat(token.slice(2)));
							arcParamIndex += 3;
							if (arcParamIndex >= 7) arcParamIndex -= 7;
							continue;
						}
						if (token === "11" || token === "10" || token === "01") {
							p.push(parseInt(token[0], 10));
							p.push(parseInt(token[1], 10));
							arcParamIndex += 2;
							if (arcParamIndex >= 7) arcParamIndex -= 7;
							continue;
						}
						if (token === "0" || token === "1") {
							p.push(parseInt(token, 10));
							arcParamIndex += 1;
							if (arcParamIndex >= 7) arcParamIndex -= 7;
							continue;
						}
					} else if (arcParamIndex === 4) {
						if (/^[01]\d+(?:\.\d+)?$/.test(token)) {
							p.push(parseInt(token[0], 10));
							p.push(parseFloat(token.slice(1)));
							arcParamIndex += 2;
							if (arcParamIndex >= 7) arcParamIndex -= 7;
							continue;
						}
						if (token === "0" || token === "1") {
							p.push(parseInt(token, 10));
							arcParamIndex += 1;
							if (arcParamIndex >= 7) arcParamIndex -= 7;
							continue;
						}
					}
					const parsedArc = parseFloat(token);
					if (!isNaN(parsedArc)) p.push(parsedArc);
					else p.push(0);
					arcParamIndex += 1;
					if (arcParamIndex >= 7) arcParamIndex -= 7;
				} else {
					const parsed = parseFloat(token);
					if (!isNaN(parsed)) p.push(parsed);
					else p.push(0);
				}
			}
			while (p.length > 0) {
				if (isNaN(p[0])) break;
				let cmd = "";
				let points = [];
				const startX = cpx, startY = cpy;
				let prevCmd, ctlPtx, ctlPty;
				let rx, ry, psi, fa, fs, x1, y1;
				switch (c) {
					case "l":
						cpx += p.shift();
						cpy += p.shift();
						cmd = "L";
						points.push(cpx, cpy);
						break;
					case "L":
						cpx = p.shift();
						cpy = p.shift();
						points.push(cpx, cpy);
						break;
					case "m":
						const dx = p.shift();
						const dy = p.shift();
						cpx += dx;
						cpy += dy;
						cmd = "M";
						if (ca.length > 2 && ca[ca.length - 1].command === "z") {
							for (let idx = ca.length - 2; idx >= 0; idx--) if (ca[idx].command === "M") {
								cpx = ca[idx].points[0] + dx;
								cpy = ca[idx].points[1] + dy;
								break;
							}
						}
						points.push(cpx, cpy);
						c = "l";
						break;
					case "M":
						cpx = p.shift();
						cpy = p.shift();
						cmd = "M";
						points.push(cpx, cpy);
						c = "L";
						break;
					case "h":
						cpx += p.shift();
						cmd = "L";
						points.push(cpx, cpy);
						break;
					case "H":
						cpx = p.shift();
						cmd = "L";
						points.push(cpx, cpy);
						break;
					case "v":
						cpy += p.shift();
						cmd = "L";
						points.push(cpx, cpy);
						break;
					case "V":
						cpy = p.shift();
						cmd = "L";
						points.push(cpx, cpy);
						break;
					case "C":
						points.push(p.shift(), p.shift(), p.shift(), p.shift());
						cpx = p.shift();
						cpy = p.shift();
						points.push(cpx, cpy);
						break;
					case "c":
						points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
						cpx += p.shift();
						cpy += p.shift();
						cmd = "C";
						points.push(cpx, cpy);
						break;
					case "S":
						ctlPtx = cpx;
						ctlPty = cpy;
						prevCmd = ca[ca.length - 1];
						if (prevCmd.command === "C") {
							ctlPtx = cpx + (cpx - prevCmd.points[2]);
							ctlPty = cpy + (cpy - prevCmd.points[3]);
						}
						points.push(ctlPtx, ctlPty, p.shift(), p.shift());
						cpx = p.shift();
						cpy = p.shift();
						cmd = "C";
						points.push(cpx, cpy);
						break;
					case "s":
						ctlPtx = cpx;
						ctlPty = cpy;
						prevCmd = ca[ca.length - 1];
						if (prevCmd.command === "C") {
							ctlPtx = cpx + (cpx - prevCmd.points[2]);
							ctlPty = cpy + (cpy - prevCmd.points[3]);
						}
						points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
						cpx += p.shift();
						cpy += p.shift();
						cmd = "C";
						points.push(cpx, cpy);
						break;
					case "Q":
						points.push(p.shift(), p.shift());
						cpx = p.shift();
						cpy = p.shift();
						points.push(cpx, cpy);
						break;
					case "q":
						points.push(cpx + p.shift(), cpy + p.shift());
						cpx += p.shift();
						cpy += p.shift();
						cmd = "Q";
						points.push(cpx, cpy);
						break;
					case "T":
						ctlPtx = cpx;
						ctlPty = cpy;
						prevCmd = ca[ca.length - 1];
						if (prevCmd.command === "Q") {
							ctlPtx = cpx + (cpx - prevCmd.points[0]);
							ctlPty = cpy + (cpy - prevCmd.points[1]);
						}
						cpx = p.shift();
						cpy = p.shift();
						cmd = "Q";
						points.push(ctlPtx, ctlPty, cpx, cpy);
						break;
					case "t":
						ctlPtx = cpx;
						ctlPty = cpy;
						prevCmd = ca[ca.length - 1];
						if (prevCmd.command === "Q") {
							ctlPtx = cpx + (cpx - prevCmd.points[0]);
							ctlPty = cpy + (cpy - prevCmd.points[1]);
						}
						cpx += p.shift();
						cpy += p.shift();
						cmd = "Q";
						points.push(ctlPtx, ctlPty, cpx, cpy);
						break;
					case "A":
						rx = p.shift();
						ry = p.shift();
						psi = p.shift();
						fa = p.shift();
						fs = p.shift();
						x1 = cpx;
						y1 = cpy;
						cpx = p.shift();
						cpy = p.shift();
						cmd = "A";
						points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
						break;
					case "a":
						rx = p.shift();
						ry = p.shift();
						psi = p.shift();
						fa = p.shift();
						fs = p.shift();
						x1 = cpx;
						y1 = cpy;
						cpx += p.shift();
						cpy += p.shift();
						cmd = "A";
						points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
						break;
				}
				ca.push({
					command: cmd || c,
					points,
					start: {
						x: startX,
						y: startY
					},
					pathLength: this.calcLength(startX, startY, cmd || c, points)
				});
			}
			if (c === "z" || c === "Z") ca.push({
				command: "z",
				points: [],
				start: void 0,
				pathLength: 0
			});
		}
		return ca;
	}
	static calcLength(x, y, cmd, points) {
		let len, p1, p2, t;
		const path = Path;
		switch (cmd) {
			case "L": return path.getLineLength(x, y, points[0], points[1]);
			case "C": return getCubicArcLength([
				x,
				points[0],
				points[2],
				points[4]
			], [
				y,
				points[1],
				points[3],
				points[5]
			], 1);
			case "Q": return getQuadraticArcLength([
				x,
				points[0],
				points[2]
			], [
				y,
				points[1],
				points[3]
			], 1);
			case "A":
				len = 0;
				const start = points[4];
				const dTheta = points[5];
				const end = points[4] + dTheta;
				let inc = Math.PI / 180;
				if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
				p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
				if (dTheta < 0) for (t = start - inc; t > end; t -= inc) {
					p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
					len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
					p1 = p2;
				}
				else for (t = start + inc; t < end; t += inc) {
					p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
					len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
					p1 = p2;
				}
				p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
				len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
				return len;
		}
		return 0;
	}
	static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
		const psi = psiDeg * (Math.PI / 180);
		const xp = Math.cos(psi) * (x1 - x2) / 2 + Math.sin(psi) * (y1 - y2) / 2;
		const yp = -1 * Math.sin(psi) * (x1 - x2) / 2 + Math.cos(psi) * (y1 - y2) / 2;
		const lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
		if (lambda > 1) {
			rx *= Math.sqrt(lambda);
			ry *= Math.sqrt(lambda);
		}
		let f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
		if (fa === fs) f *= -1;
		if (isNaN(f)) f = 0;
		const cxp = f * rx * yp / ry;
		const cyp = f * -ry * xp / rx;
		const cx = (x1 + x2) / 2 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
		const cy = (y1 + y2) / 2 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
		const vMag = function(v$1) {
			return Math.sqrt(v$1[0] * v$1[0] + v$1[1] * v$1[1]);
		};
		const vRatio = function(u$1, v$1) {
			return (u$1[0] * v$1[0] + u$1[1] * v$1[1]) / (vMag(u$1) * vMag(v$1));
		};
		const vAngle = function(u$1, v$1) {
			return (u$1[0] * v$1[1] < u$1[1] * v$1[0] ? -1 : 1) * Math.acos(vRatio(u$1, v$1));
		};
		const theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
		const u = [(xp - cxp) / rx, (yp - cyp) / ry];
		const v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
		let dTheta = vAngle(u, v);
		if (vRatio(u, v) <= -1) dTheta = Math.PI;
		if (vRatio(u, v) >= 1) dTheta = 0;
		if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * Math.PI;
		if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * Math.PI;
		return [
			cx,
			cy,
			rx,
			ry,
			theta,
			dTheta,
			psi,
			fs
		];
	}
};
Path.prototype.className = "Path";
Path.prototype._attrsAffectingSize = ["data"];
_registerNode(Path);
Factory.addGetterSetter(Path, "data");
var Arrow = class extends Line {
	_sceneFunc(ctx) {
		super._sceneFunc(ctx);
		const PI2 = Math.PI * 2;
		const points = this.points();
		let tp = points;
		const fromTension = this.tension() !== 0 && points.length > 4;
		if (fromTension) tp = this.getTensionPoints();
		const length$1 = this.pointerLength();
		const n = points.length;
		let dx, dy;
		if (fromTension) {
			const lp = [
				tp[tp.length - 4],
				tp[tp.length - 3],
				tp[tp.length - 2],
				tp[tp.length - 1],
				points[n - 2],
				points[n - 1]
			];
			const lastLength = Path.calcLength(tp[tp.length - 4], tp[tp.length - 3], "C", lp);
			const previous = Path.getPointOnQuadraticBezier(Math.min(1, 1 - length$1 / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
			dx = points[n - 2] - previous.x;
			dy = points[n - 1] - previous.y;
		} else {
			dx = points[n - 2] - points[n - 4];
			dy = points[n - 1] - points[n - 3];
		}
		const radians = (Math.atan2(dy, dx) + PI2) % PI2;
		const width = this.pointerWidth();
		if (this.pointerAtEnding()) {
			ctx.save();
			ctx.beginPath();
			ctx.translate(points[n - 2], points[n - 1]);
			ctx.rotate(radians);
			ctx.moveTo(0, 0);
			ctx.lineTo(-length$1, width / 2);
			ctx.lineTo(-length$1, -width / 2);
			ctx.closePath();
			ctx.restore();
			this.__fillStroke(ctx);
		}
		if (this.pointerAtBeginning()) {
			ctx.save();
			ctx.beginPath();
			ctx.translate(points[0], points[1]);
			if (fromTension) {
				dx = (tp[0] + tp[2]) / 2 - points[0];
				dy = (tp[1] + tp[3]) / 2 - points[1];
			} else {
				dx = points[2] - points[0];
				dy = points[3] - points[1];
			}
			ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
			ctx.moveTo(0, 0);
			ctx.lineTo(-length$1, width / 2);
			ctx.lineTo(-length$1, -width / 2);
			ctx.closePath();
			ctx.restore();
			this.__fillStroke(ctx);
		}
	}
	__fillStroke(ctx) {
		const isDashEnabled = this.dashEnabled();
		if (isDashEnabled) {
			this.attrs.dashEnabled = false;
			ctx.setLineDash([]);
		}
		ctx.fillStrokeShape(this);
		if (isDashEnabled) this.attrs.dashEnabled = true;
	}
	getSelfRect() {
		const lineRect = super.getSelfRect();
		const offset = this.pointerWidth() / 2;
		return {
			x: lineRect.x,
			y: lineRect.y - offset,
			width: lineRect.width,
			height: lineRect.height + offset * 2
		};
	}
};
Arrow.prototype.className = "Arrow";
_registerNode(Arrow);
Factory.addGetterSetter(Arrow, "pointerLength", 10, getNumberValidator());
Factory.addGetterSetter(Arrow, "pointerWidth", 10, getNumberValidator());
Factory.addGetterSetter(Arrow, "pointerAtBeginning", false);
Factory.addGetterSetter(Arrow, "pointerAtEnding", true);
var Circle = class extends Shape {
	_sceneFunc(context) {
		context.beginPath();
		context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
		context.closePath();
		context.fillStrokeShape(this);
	}
	getWidth() {
		return this.radius() * 2;
	}
	getHeight() {
		return this.radius() * 2;
	}
	setWidth(width) {
		if (this.radius() !== width / 2) this.radius(width / 2);
	}
	setHeight(height) {
		if (this.radius() !== height / 2) this.radius(height / 2);
	}
};
Circle.prototype._centroid = true;
Circle.prototype.className = "Circle";
Circle.prototype._attrsAffectingSize = ["radius"];
_registerNode(Circle);
Factory.addGetterSetter(Circle, "radius", 0, getNumberValidator());
var Ellipse = class extends Shape {
	_sceneFunc(context) {
		const rx = this.radiusX(), ry = this.radiusY();
		context.beginPath();
		context.save();
		if (rx !== ry) context.scale(1, ry / rx);
		context.arc(0, 0, rx, 0, Math.PI * 2, false);
		context.restore();
		context.closePath();
		context.fillStrokeShape(this);
	}
	getWidth() {
		return this.radiusX() * 2;
	}
	getHeight() {
		return this.radiusY() * 2;
	}
	setWidth(width) {
		this.radiusX(width / 2);
	}
	setHeight(height) {
		this.radiusY(height / 2);
	}
};
Ellipse.prototype.className = "Ellipse";
Ellipse.prototype._centroid = true;
Ellipse.prototype._attrsAffectingSize = ["radiusX", "radiusY"];
_registerNode(Ellipse);
Factory.addComponentsGetterSetter(Ellipse, "radius", ["x", "y"]);
Factory.addGetterSetter(Ellipse, "radiusX", 0, getNumberValidator());
Factory.addGetterSetter(Ellipse, "radiusY", 0, getNumberValidator());
var Image = class Image extends Shape {
	constructor(attrs) {
		super(attrs);
		this._loadListener = () => {
			this._requestDraw();
		};
		this.on("imageChange.konva", (props) => {
			this._removeImageLoad(props.oldVal);
			this._setImageLoad();
		});
		this._setImageLoad();
	}
	_setImageLoad() {
		const image = this.image();
		if (image && image.complete) return;
		if (image && image.readyState === 4) return;
		if (image && image["addEventListener"]) image["addEventListener"]("load", this._loadListener);
	}
	_removeImageLoad(image) {
		if (image && image["removeEventListener"]) image["removeEventListener"]("load", this._loadListener);
	}
	destroy() {
		this._removeImageLoad(this.image());
		super.destroy();
		return this;
	}
	_useBufferCanvas() {
		const hasCornerRadius = !!this.cornerRadius();
		const hasShadow = this.hasShadow();
		if (hasCornerRadius && hasShadow) return true;
		return super._useBufferCanvas(true);
	}
	_sceneFunc(context) {
		const width = this.getWidth();
		const height = this.getHeight();
		const cornerRadius = this.cornerRadius();
		const image = this.attrs.image;
		let params;
		if (image) {
			const cropWidth = this.attrs.cropWidth;
			const cropHeight = this.attrs.cropHeight;
			if (cropWidth && cropHeight) params = [
				image,
				this.cropX(),
				this.cropY(),
				cropWidth,
				cropHeight,
				0,
				0,
				width,
				height
			];
			else params = [
				image,
				0,
				0,
				width,
				height
			];
		}
		if (this.hasFill() || this.hasStroke() || cornerRadius) {
			context.beginPath();
			cornerRadius ? Util.drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
			context.closePath();
			context.fillStrokeShape(this);
		}
		if (image) {
			if (cornerRadius) context.clip();
			context.drawImage.apply(context, params);
		}
	}
	_hitFunc(context) {
		const width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
		context.beginPath();
		if (!cornerRadius) context.rect(0, 0, width, height);
		else Util.drawRoundedRectPath(context, width, height, cornerRadius);
		context.closePath();
		context.fillStrokeShape(this);
	}
	getWidth() {
		var _a, _b, _c;
		return (_c = (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0;
	}
	getHeight() {
		var _a, _b, _c;
		return (_c = (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : 0;
	}
	static fromURL(url, callback, onError = null) {
		const img = Util.createImageElement();
		img.onload = function() {
			callback(new Image({ image: img }));
		};
		img.onerror = onError;
		img.crossOrigin = "Anonymous";
		img.src = url;
	}
};
Image.prototype.className = "Image";
Image.prototype._attrsAffectingSize = ["image"];
_registerNode(Image);
Factory.addGetterSetter(Image, "cornerRadius", 0, getNumberOrArrayOfNumbersValidator(4));
Factory.addGetterSetter(Image, "image");
Factory.addComponentsGetterSetter(Image, "crop", [
	"x",
	"y",
	"width",
	"height"
]);
Factory.addGetterSetter(Image, "cropX", 0, getNumberValidator());
Factory.addGetterSetter(Image, "cropY", 0, getNumberValidator());
Factory.addGetterSetter(Image, "cropWidth", 0, getNumberValidator());
Factory.addGetterSetter(Image, "cropHeight", 0, getNumberValidator());
var ATTR_CHANGE_LIST$2 = [
	"fontFamily",
	"fontSize",
	"fontStyle",
	"padding",
	"lineHeight",
	"text",
	"width",
	"height",
	"pointerDirection",
	"pointerWidth",
	"pointerHeight"
], CHANGE_KONVA$1 = "Change.konva", NONE$1 = "none", UP = "up", RIGHT$1 = "right", DOWN = "down", LEFT$1 = "left", attrChangeListLen$1 = ATTR_CHANGE_LIST$2.length;
var Label = class extends Group {
	constructor(config) {
		super(config);
		this.on("add.konva", function(evt) {
			this._addListeners(evt.child);
			this._sync();
		});
	}
	getText() {
		return this.find("Text")[0];
	}
	getTag() {
		return this.find("Tag")[0];
	}
	_addListeners(text) {
		let that = this, n;
		const func = function() {
			that._sync();
		};
		for (n = 0; n < attrChangeListLen$1; n++) text.on(ATTR_CHANGE_LIST$2[n] + CHANGE_KONVA$1, func);
	}
	getWidth() {
		return this.getText().width();
	}
	getHeight() {
		return this.getText().height();
	}
	_sync() {
		let text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
		if (text && tag) {
			width = text.width();
			height = text.height();
			pointerDirection = tag.pointerDirection();
			pointerWidth = tag.pointerWidth();
			pointerHeight = tag.pointerHeight();
			x = 0;
			y = 0;
			switch (pointerDirection) {
				case UP:
					x = width / 2;
					y = -1 * pointerHeight;
					break;
				case RIGHT$1:
					x = width + pointerWidth;
					y = height / 2;
					break;
				case DOWN:
					x = width / 2;
					y = height + pointerHeight;
					break;
				case LEFT$1:
					x = -1 * pointerWidth;
					y = height / 2;
					break;
			}
			tag.setAttrs({
				x: -1 * x,
				y: -1 * y,
				width,
				height
			});
			text.setAttrs({
				x: -1 * x,
				y: -1 * y
			});
		}
	}
};
Label.prototype.className = "Label";
_registerNode(Label);
var Tag = class extends Shape {
	_sceneFunc(context) {
		const width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
		let topLeft = 0;
		let topRight = 0;
		let bottomLeft = 0;
		let bottomRight = 0;
		if (typeof cornerRadius === "number") topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
		else {
			topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
			topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
			bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
			bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
		}
		context.beginPath();
		context.moveTo(topLeft, 0);
		if (pointerDirection === UP) {
			context.lineTo((width - pointerWidth) / 2, 0);
			context.lineTo(width / 2, -1 * pointerHeight);
			context.lineTo((width + pointerWidth) / 2, 0);
		}
		context.lineTo(width - topRight, 0);
		context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
		if (pointerDirection === RIGHT$1) {
			context.lineTo(width, (height - pointerHeight) / 2);
			context.lineTo(width + pointerWidth, height / 2);
			context.lineTo(width, (height + pointerHeight) / 2);
		}
		context.lineTo(width, height - bottomRight);
		context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
		if (pointerDirection === DOWN) {
			context.lineTo((width + pointerWidth) / 2, height);
			context.lineTo(width / 2, height + pointerHeight);
			context.lineTo((width - pointerWidth) / 2, height);
		}
		context.lineTo(bottomLeft, height);
		context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
		if (pointerDirection === LEFT$1) {
			context.lineTo(0, (height + pointerHeight) / 2);
			context.lineTo(-1 * pointerWidth, height / 2);
			context.lineTo(0, (height - pointerHeight) / 2);
		}
		context.lineTo(0, topLeft);
		context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
		context.closePath();
		context.fillStrokeShape(this);
	}
	getSelfRect() {
		let x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
		if (direction === UP) {
			y -= pointerHeight;
			height += pointerHeight;
		} else if (direction === DOWN) height += pointerHeight;
		else if (direction === LEFT$1) {
			x -= pointerWidth * 1.5;
			width += pointerWidth;
		} else if (direction === RIGHT$1) width += pointerWidth * 1.5;
		return {
			x,
			y,
			width,
			height
		};
	}
};
Tag.prototype.className = "Tag";
_registerNode(Tag);
Factory.addGetterSetter(Tag, "pointerDirection", NONE$1);
Factory.addGetterSetter(Tag, "pointerWidth", 0, getNumberValidator());
Factory.addGetterSetter(Tag, "pointerHeight", 0, getNumberValidator());
Factory.addGetterSetter(Tag, "cornerRadius", 0, getNumberOrArrayOfNumbersValidator(4));
var Rect = class extends Shape {
	_sceneFunc(context) {
		const cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
		context.beginPath();
		if (!cornerRadius) context.rect(0, 0, width, height);
		else Util.drawRoundedRectPath(context, width, height, cornerRadius);
		context.closePath();
		context.fillStrokeShape(this);
	}
};
Rect.prototype.className = "Rect";
_registerNode(Rect);
Factory.addGetterSetter(Rect, "cornerRadius", 0, getNumberOrArrayOfNumbersValidator(4));
var RegularPolygon = class extends Shape {
	_sceneFunc(context) {
		const points = this._getPoints(), radius = this.radius(), sides = this.sides(), cornerRadius = this.cornerRadius();
		context.beginPath();
		if (!cornerRadius) {
			context.moveTo(points[0].x, points[0].y);
			for (let n = 1; n < points.length; n++) context.lineTo(points[n].x, points[n].y);
		} else Util.drawRoundedPolygonPath(context, points, sides, radius, cornerRadius);
		context.closePath();
		context.fillStrokeShape(this);
	}
	_getPoints() {
		const sides = this.attrs.sides;
		const radius = this.attrs.radius || 0;
		const points = [];
		for (let n = 0; n < sides; n++) points.push({
			x: radius * Math.sin(n * 2 * Math.PI / sides),
			y: -1 * radius * Math.cos(n * 2 * Math.PI / sides)
		});
		return points;
	}
	getSelfRect() {
		const points = this._getPoints();
		let minX = points[0].x;
		let maxX = points[0].x;
		let minY = points[0].y;
		let maxY = points[0].y;
		points.forEach((point) => {
			minX = Math.min(minX, point.x);
			maxX = Math.max(maxX, point.x);
			minY = Math.min(minY, point.y);
			maxY = Math.max(maxY, point.y);
		});
		return {
			x: minX,
			y: minY,
			width: maxX - minX,
			height: maxY - minY
		};
	}
	getWidth() {
		return this.radius() * 2;
	}
	getHeight() {
		return this.radius() * 2;
	}
	setWidth(width) {
		this.radius(width / 2);
	}
	setHeight(height) {
		this.radius(height / 2);
	}
};
RegularPolygon.prototype.className = "RegularPolygon";
RegularPolygon.prototype._centroid = true;
RegularPolygon.prototype._attrsAffectingSize = ["radius"];
_registerNode(RegularPolygon);
Factory.addGetterSetter(RegularPolygon, "radius", 0, getNumberValidator());
Factory.addGetterSetter(RegularPolygon, "sides", 0, getNumberValidator());
Factory.addGetterSetter(RegularPolygon, "cornerRadius", 0, getNumberOrArrayOfNumbersValidator(4));
var PIx2 = Math.PI * 2;
var Ring = class extends Shape {
	_sceneFunc(context) {
		context.beginPath();
		context.arc(0, 0, this.innerRadius(), 0, PIx2, false);
		context.moveTo(this.outerRadius(), 0);
		context.arc(0, 0, this.outerRadius(), PIx2, 0, true);
		context.closePath();
		context.fillStrokeShape(this);
	}
	getWidth() {
		return this.outerRadius() * 2;
	}
	getHeight() {
		return this.outerRadius() * 2;
	}
	setWidth(width) {
		this.outerRadius(width / 2);
	}
	setHeight(height) {
		this.outerRadius(height / 2);
	}
};
Ring.prototype.className = "Ring";
Ring.prototype._centroid = true;
Ring.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
_registerNode(Ring);
Factory.addGetterSetter(Ring, "innerRadius", 0, getNumberValidator());
Factory.addGetterSetter(Ring, "outerRadius", 0, getNumberValidator());
var Sprite = class extends Shape {
	constructor(config) {
		super(config);
		this._updated = true;
		this.anim = new Animation(() => {
			const updated = this._updated;
			this._updated = false;
			return updated;
		});
		this.on("animationChange.konva", function() {
			this.frameIndex(0);
		});
		this.on("frameIndexChange.konva", function() {
			this._updated = true;
		});
		this.on("frameRateChange.konva", function() {
			if (!this.anim.isRunning()) return;
			clearInterval(this.interval);
			this._setInterval();
		});
	}
	_sceneFunc(context) {
		const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set$1 = this.animations()[anim], offsets = this.frameOffsets(), x = set$1[ix4 + 0], y = set$1[ix4 + 1], width = set$1[ix4 + 2], height = set$1[ix4 + 3], image = this.image();
		if (this.hasFill() || this.hasStroke()) {
			context.beginPath();
			context.rect(0, 0, width, height);
			context.closePath();
			context.fillStrokeShape(this);
		}
		if (image) if (offsets) {
			const offset = offsets[anim], ix2 = index * 2;
			context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
		} else context.drawImage(image, x, y, width, height, 0, 0, width, height);
	}
	_hitFunc(context) {
		const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set$1 = this.animations()[anim], offsets = this.frameOffsets(), width = set$1[ix4 + 2], height = set$1[ix4 + 3];
		context.beginPath();
		if (offsets) {
			const offset = offsets[anim];
			const ix2 = index * 2;
			context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
		} else context.rect(0, 0, width, height);
		context.closePath();
		context.fillShape(this);
	}
	_useBufferCanvas() {
		return super._useBufferCanvas(true);
	}
	_setInterval() {
		const that = this;
		this.interval = setInterval(function() {
			that._updateIndex();
		}, 1e3 / this.frameRate());
	}
	start() {
		if (this.isRunning()) return;
		const layer = this.getLayer();
		this.anim.setLayers(layer);
		this._setInterval();
		this.anim.start();
	}
	stop() {
		this.anim.stop();
		clearInterval(this.interval);
	}
	isRunning() {
		return this.anim.isRunning();
	}
	_updateIndex() {
		const index = this.frameIndex(), animation = this.animation();
		if (index < this.animations()[animation].length / 4 - 1) this.frameIndex(index + 1);
		else this.frameIndex(0);
	}
};
Sprite.prototype.className = "Sprite";
_registerNode(Sprite);
Factory.addGetterSetter(Sprite, "animation");
Factory.addGetterSetter(Sprite, "animations");
Factory.addGetterSetter(Sprite, "frameOffsets");
Factory.addGetterSetter(Sprite, "image");
Factory.addGetterSetter(Sprite, "frameIndex", 0, getNumberValidator());
Factory.addGetterSetter(Sprite, "frameRate", 17, getNumberValidator());
Factory.backCompat(Sprite, {
	index: "frameIndex",
	getIndex: "getFrameIndex",
	setIndex: "setFrameIndex"
});
var Star = class extends Shape {
	_sceneFunc(context) {
		const innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
		context.beginPath();
		context.moveTo(0, 0 - outerRadius);
		for (let n = 1; n < numPoints * 2; n++) {
			const radius = n % 2 === 0 ? outerRadius : innerRadius;
			const x = radius * Math.sin(n * Math.PI / numPoints);
			const y = -1 * radius * Math.cos(n * Math.PI / numPoints);
			context.lineTo(x, y);
		}
		context.closePath();
		context.fillStrokeShape(this);
	}
	getWidth() {
		return this.outerRadius() * 2;
	}
	getHeight() {
		return this.outerRadius() * 2;
	}
	setWidth(width) {
		this.outerRadius(width / 2);
	}
	setHeight(height) {
		this.outerRadius(height / 2);
	}
};
Star.prototype.className = "Star";
Star.prototype._centroid = true;
Star.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
_registerNode(Star);
Factory.addGetterSetter(Star, "numPoints", 5, getNumberValidator());
Factory.addGetterSetter(Star, "innerRadius", 0, getNumberValidator());
Factory.addGetterSetter(Star, "outerRadius", 0, getNumberValidator());
function stringToArray(string) {
	return [...string].reduce((acc, char, index, array) => {
		if (/\p{Emoji}/u.test(char)) {
			const nextChar = array[index + 1];
			if (nextChar && /\p{Emoji_Modifier}|\u200D/u.test(nextChar)) {
				acc.push(char + nextChar);
				array[index + 1] = "";
			} else acc.push(char);
		} else if (/\p{Regional_Indicator}{2}/u.test(char + (array[index + 1] || ""))) acc.push(char + array[index + 1]);
		else if (index > 0 && /\p{Mn}|\p{Me}|\p{Mc}/u.test(char)) acc[acc.length - 1] += char;
		else if (char) acc.push(char);
		return acc;
	}, []);
}
var AUTO = "auto", CENTER = "center", INHERIT = "inherit", JUSTIFY = "justify", CHANGE_KONVA = "Change.konva", CONTEXT_2D = "2d", DASH = "-", LEFT = "left", TEXT = "text", TEXT_UPPER = "Text", TOP = "top", BOTTOM = "bottom", MIDDLE = "middle", NORMAL$1 = "normal", PX_SPACE = "px ", SPACE = " ", RIGHT = "right", RTL = "rtl", WORD = "word", CHAR = "char", NONE = "none", ELLIPSIS = "…", ATTR_CHANGE_LIST$1 = [
	"direction",
	"fontFamily",
	"fontSize",
	"fontStyle",
	"fontVariant",
	"padding",
	"align",
	"verticalAlign",
	"lineHeight",
	"text",
	"width",
	"height",
	"wrap",
	"ellipsis",
	"letterSpacing"
], attrChangeListLen = ATTR_CHANGE_LIST$1.length;
var _shadowOpacityBuggy = null;
function hasShadowOpacityBug() {
	if (_shadowOpacityBuggy !== null) return _shadowOpacityBuggy;
	_shadowOpacityBuggy = false;
	try {
		const c = document.createElement("canvas");
		c.width = 10;
		c.height = 10;
		const ctx = c.getContext(CONTEXT_2D);
		if (ctx) {
			ctx.globalAlpha = 0;
			ctx.shadowColor = "black";
			ctx.shadowBlur = 5;
			ctx.shadowOffsetX = 5;
			ctx.shadowOffsetY = 5;
			ctx.fillStyle = "black";
			ctx.font = "10px Arial";
			ctx.fillText("X", 0, 10);
			const data = ctx.getImageData(0, 0, 10, 10).data;
			for (let i = 3; i < data.length; i += 4) if (data[i] > 0) {
				_shadowOpacityBuggy = true;
				break;
			}
		}
	} catch (e) {}
	return _shadowOpacityBuggy;
}
function normalizeFontFamily(fontFamily) {
	return fontFamily.split(",").map((family) => {
		family = family.trim();
		const hasSpace = family.indexOf(" ") >= 0;
		const hasQuotes = family.indexOf("\"") >= 0 || family.indexOf("'") >= 0;
		if (hasSpace && !hasQuotes) family = `"${family}"`;
		return family;
	}).join(", ");
}
var dummyContext;
function getDummyContext() {
	if (dummyContext) return dummyContext;
	dummyContext = Util.createCanvasElement().getContext(CONTEXT_2D);
	return dummyContext;
}
function _fillFunc$1(context) {
	context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function _strokeFunc$1(context) {
	context.setAttr("miterLimit", 2);
	context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function checkDefaultFill(config) {
	config = config || {};
	if (!config.fillLinearGradientColorStops && !config.fillRadialGradientColorStops && !config.fillPatternImage) config.fill = config.fill || "black";
	return config;
}
var Text$1 = class extends Shape {
	constructor(config) {
		super(checkDefaultFill(config));
		this._partialTextX = 0;
		this._partialTextY = 0;
		for (let n = 0; n < attrChangeListLen; n++) this.on(ATTR_CHANGE_LIST$1[n] + CHANGE_KONVA, this._setTextData);
		this._setTextData();
	}
	_sceneFunc(context) {
		var _a, _b;
		const textArr = this.textArr, textArrLen = textArr.length;
		if (!this.text()) return;
		let padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), direction = this.direction(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), charRenderFunc = this.charRenderFunc(), fill = this.fill(), textDecoration = this.textDecoration(), underlineOffset = this.underlineOffset(), shouldUnderline = textDecoration.indexOf("underline") !== -1, shouldLineThrough = textDecoration.indexOf("line-through") !== -1, n;
		direction = direction === INHERIT ? context.direction : direction;
		let translateY = lineHeightPx / 2;
		let baseline = MIDDLE;
		if (!Konva$2.legacyTextRendering) {
			const metrics = this.measureSize("M");
			baseline = "alphabetic";
			translateY = (((_a = metrics.fontBoundingBoxAscent) !== null && _a !== void 0 ? _a : metrics.actualBoundingBoxAscent) - ((_b = metrics.fontBoundingBoxDescent) !== null && _b !== void 0 ? _b : metrics.actualBoundingBoxDescent)) / 2 + lineHeightPx / 2;
		}
		if (direction === RTL) context.setAttr("direction", direction);
		context.setAttr("font", this._getContextFont());
		context.setAttr("textBaseline", baseline);
		context.setAttr("textAlign", LEFT);
		if (verticalAlign === MIDDLE) alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
		else if (verticalAlign === BOTTOM) alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
		context.translate(padding, alignY + padding);
		for (n = 0; n < textArrLen; n++) {
			let lineTranslateX = 0;
			let lineTranslateY = 0;
			const obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph;
			context.save();
			if (align === RIGHT) lineTranslateX += totalWidth - width - padding * 2;
			else if (align === CENTER) lineTranslateX += (totalWidth - width - padding * 2) / 2;
			if (shouldUnderline) {
				context.save();
				context.beginPath();
				const yOffset = underlineOffset !== null && underlineOffset !== void 0 ? underlineOffset : !Konva$2.legacyTextRendering ? Math.round(fontSize / 4) : Math.round(fontSize / 2);
				const x = lineTranslateX;
				const y = translateY + lineTranslateY + yOffset;
				context.moveTo(x, y);
				const lineWidth = align === JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
				context.lineTo(x + Math.round(lineWidth), y);
				context.lineWidth = fontSize / 15;
				context.strokeStyle = this._getLinearGradient() || fill;
				context.stroke();
				context.restore();
			}
			const lineThroughStartX = lineTranslateX;
			if (direction !== RTL && (letterSpacing !== 0 || align === JUSTIFY || charRenderFunc)) {
				const spacesNumber = text.split(" ").length - 1;
				const array = stringToArray(text);
				for (let li = 0; li < array.length; li++) {
					const letter = array[li];
					if (letter === " " && !lastLine && align === JUSTIFY) lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
					this._partialTextX = lineTranslateX;
					this._partialTextY = translateY + lineTranslateY;
					this._partialText = letter;
					if (charRenderFunc) {
						context.save();
						const previousGraphemes = textArr.slice(0, n).reduce((acc, line) => acc + stringToArray(line.text).length, 0);
						charRenderFunc({
							char: letter,
							index: li + previousGraphemes,
							x: lineTranslateX,
							y: translateY + lineTranslateY,
							lineIndex: n,
							column: li,
							isLastInLine: lastLine,
							width: this.measureSize(letter).width,
							context
						});
					}
					context.fillStrokeShape(this);
					if (charRenderFunc) context.restore();
					lineTranslateX += this.measureSize(letter).width + letterSpacing;
				}
			} else {
				if (letterSpacing !== 0) context.setAttr("letterSpacing", `${letterSpacing}px`);
				this._partialTextX = lineTranslateX;
				this._partialTextY = translateY + lineTranslateY;
				this._partialText = text;
				context.fillStrokeShape(this);
			}
			if (shouldLineThrough) {
				context.save();
				context.beginPath();
				const yOffset = !Konva$2.legacyTextRendering ? -Math.round(fontSize / 4) : 0;
				const x = lineThroughStartX;
				context.moveTo(x, translateY + lineTranslateY + yOffset);
				const lineWidth = align === JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
				context.lineTo(x + Math.round(lineWidth), translateY + lineTranslateY + yOffset);
				context.lineWidth = fontSize / 15;
				context.strokeStyle = this._getLinearGradient() || fill;
				context.stroke();
				context.restore();
			}
			context.restore();
			if (textArrLen > 1) translateY += lineHeightPx;
		}
	}
	_hitFunc(context) {
		const width = this.getWidth(), height = this.getHeight();
		context.beginPath();
		context.rect(0, 0, width, height);
		context.closePath();
		context.fillStrokeShape(this);
	}
	setText(text) {
		const str = Util._isString(text) ? text : text === null || text === void 0 ? "" : text + "";
		this._setAttr(TEXT, str);
		return this;
	}
	getWidth() {
		return this.attrs.width === AUTO || this.attrs.width === void 0 ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
	}
	getHeight() {
		return this.attrs.height === AUTO || this.attrs.height === void 0 ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
	}
	getTextWidth() {
		return this.textWidth;
	}
	getTextHeight() {
		Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.");
		return this.textHeight;
	}
	measureSize(text) {
		var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
		let _context = getDummyContext(), fontSize = this.fontSize(), metrics;
		_context.save();
		_context.font = this._getContextFont();
		metrics = _context.measureText(text);
		_context.restore();
		const scaleFactor = fontSize / 100;
		return {
			actualBoundingBoxAscent: (_a = metrics.actualBoundingBoxAscent) !== null && _a !== void 0 ? _a : 71.58203125 * scaleFactor,
			actualBoundingBoxDescent: (_b = metrics.actualBoundingBoxDescent) !== null && _b !== void 0 ? _b : 0,
			actualBoundingBoxLeft: (_c = metrics.actualBoundingBoxLeft) !== null && _c !== void 0 ? _c : -7.421875 * scaleFactor,
			actualBoundingBoxRight: (_d = metrics.actualBoundingBoxRight) !== null && _d !== void 0 ? _d : 75.732421875 * scaleFactor,
			alphabeticBaseline: (_e = metrics.alphabeticBaseline) !== null && _e !== void 0 ? _e : 0,
			emHeightAscent: (_f = metrics.emHeightAscent) !== null && _f !== void 0 ? _f : 100 * scaleFactor,
			emHeightDescent: (_g = metrics.emHeightDescent) !== null && _g !== void 0 ? _g : -20 * scaleFactor,
			fontBoundingBoxAscent: (_h = metrics.fontBoundingBoxAscent) !== null && _h !== void 0 ? _h : 91 * scaleFactor,
			fontBoundingBoxDescent: (_j = metrics.fontBoundingBoxDescent) !== null && _j !== void 0 ? _j : 21 * scaleFactor,
			hangingBaseline: (_k = metrics.hangingBaseline) !== null && _k !== void 0 ? _k : 72.80000305175781 * scaleFactor,
			ideographicBaseline: (_l = metrics.ideographicBaseline) !== null && _l !== void 0 ? _l : -21 * scaleFactor,
			width: metrics.width,
			height: fontSize
		};
	}
	_getContextFont() {
		return this.fontStyle() + SPACE + this.fontVariant() + SPACE + (this.fontSize() + PX_SPACE) + normalizeFontFamily(this.fontFamily());
	}
	_addTextLine(line) {
		if (this.align() === JUSTIFY) line = line.trim();
		const width = this._getTextWidth(line);
		return this.textArr.push({
			text: line,
			width,
			lastInParagraph: false
		});
	}
	_getTextWidth(text) {
		const letterSpacing = this.letterSpacing();
		const length$1 = text.length;
		return getDummyContext().measureText(text).width + letterSpacing * length$1;
	}
	_setTextData() {
		let lines = this.text().split("\n"), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== AUTO && width !== void 0, fixedHeight = height !== AUTO && height !== void 0, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), wrapAtWord = wrap !== CHAR && wrap !== NONE, shouldAddEllipsis = this.ellipsis();
		this.textArr = [];
		getDummyContext().font = this._getContextFont();
		const additionalWidth = shouldAddEllipsis ? this._getTextWidth(ELLIPSIS) : 0;
		for (let i = 0, max = lines.length; i < max; ++i) {
			let line = lines[i];
			let lineWidth = this._getTextWidth(line);
			if (fixedWidth && lineWidth > maxWidth) while (line.length > 0) {
				let low = 0, high = stringToArray(line).length, match = "", matchWidth = 0;
				while (low < high) {
					const mid = low + high >>> 1, substr = stringToArray(line).slice(0, mid + 1).join(""), substrWidth = this._getTextWidth(substr);
					if ((shouldAddEllipsis && fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx ? substrWidth + additionalWidth : substrWidth) <= maxWidth) {
						low = mid + 1;
						match = substr;
						matchWidth = substrWidth;
					} else high = mid;
				}
				if (match) {
					if (wrapAtWord) {
						const lineArray = stringToArray(line);
						const matchArray = stringToArray(match);
						const nextChar = lineArray[matchArray.length];
						const nextIsSpaceOrDash = nextChar === SPACE || nextChar === DASH;
						let wrapIndex;
						if (nextIsSpaceOrDash && matchWidth <= maxWidth) wrapIndex = matchArray.length;
						else {
							const lastSpaceIndex = matchArray.lastIndexOf(SPACE);
							const lastDashIndex = matchArray.lastIndexOf(DASH);
							wrapIndex = Math.max(lastSpaceIndex, lastDashIndex) + 1;
						}
						if (wrapIndex > 0) {
							low = wrapIndex;
							match = lineArray.slice(0, low).join("");
							matchWidth = this._getTextWidth(match);
						}
					}
					match = match.trimRight();
					this._addTextLine(match);
					textWidth = Math.max(textWidth, matchWidth);
					currentHeightPx += lineHeightPx;
					if (this._shouldHandleEllipsis(currentHeightPx)) {
						this._tryToAddEllipsisToLastLine();
						break;
					}
					line = stringToArray(line).slice(low).join("").trimLeft();
					if (line.length > 0) {
						lineWidth = this._getTextWidth(line);
						if (lineWidth <= maxWidth) {
							this._addTextLine(line);
							currentHeightPx += lineHeightPx;
							textWidth = Math.max(textWidth, lineWidth);
							break;
						}
					}
				} else break;
			}
			else {
				this._addTextLine(line);
				currentHeightPx += lineHeightPx;
				textWidth = Math.max(textWidth, lineWidth);
				if (this._shouldHandleEllipsis(currentHeightPx) && i < max - 1) this._tryToAddEllipsisToLastLine();
			}
			if (this.textArr[this.textArr.length - 1]) this.textArr[this.textArr.length - 1].lastInParagraph = true;
			if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) break;
		}
		this.textHeight = fontSize;
		this.textWidth = textWidth;
	}
	_shouldHandleEllipsis(currentHeightPx) {
		const fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== AUTO && height !== void 0, maxHeightPx = height - this.padding() * 2;
		return !(this.wrap() !== NONE) || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
	}
	_tryToAddEllipsisToLastLine() {
		const width = this.attrs.width, fixedWidth = width !== AUTO && width !== void 0, maxWidth = width - this.padding() * 2, shouldAddEllipsis = this.ellipsis();
		const lastLine = this.textArr[this.textArr.length - 1];
		if (!lastLine || !shouldAddEllipsis) return;
		if (fixedWidth) {
			if (!(this._getTextWidth(lastLine.text + ELLIPSIS) < maxWidth)) lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
		}
		this.textArr.splice(this.textArr.length - 1, 1);
		this._addTextLine(lastLine.text + ELLIPSIS);
	}
	getStrokeScaleEnabled() {
		return true;
	}
	_useBufferCanvas() {
		const hasLine = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1;
		const hasShadow = this.hasShadow();
		if (hasLine && hasShadow) return true;
		if (hasShadow && this.getAbsoluteOpacity() !== 1 && hasShadowOpacityBug()) return true;
		return super._useBufferCanvas();
	}
};
Text$1.prototype._fillFunc = _fillFunc$1;
Text$1.prototype._strokeFunc = _strokeFunc$1;
Text$1.prototype.className = TEXT_UPPER;
Text$1.prototype._attrsAffectingSize = [
	"text",
	"fontSize",
	"padding",
	"wrap",
	"lineHeight",
	"letterSpacing"
];
_registerNode(Text$1);
Factory.overWriteSetter(Text$1, "width", getNumberOrAutoValidator());
Factory.overWriteSetter(Text$1, "height", getNumberOrAutoValidator());
Factory.addGetterSetter(Text$1, "direction", INHERIT);
Factory.addGetterSetter(Text$1, "fontFamily", "Arial");
Factory.addGetterSetter(Text$1, "fontSize", 12, getNumberValidator());
Factory.addGetterSetter(Text$1, "fontStyle", NORMAL$1);
Factory.addGetterSetter(Text$1, "fontVariant", NORMAL$1);
Factory.addGetterSetter(Text$1, "padding", 0, getNumberValidator());
Factory.addGetterSetter(Text$1, "align", LEFT);
Factory.addGetterSetter(Text$1, "verticalAlign", TOP);
Factory.addGetterSetter(Text$1, "lineHeight", 1, getNumberValidator());
Factory.addGetterSetter(Text$1, "wrap", WORD);
Factory.addGetterSetter(Text$1, "ellipsis", false, getBooleanValidator());
Factory.addGetterSetter(Text$1, "letterSpacing", 0, getNumberValidator());
Factory.addGetterSetter(Text$1, "text", "", getStringValidator());
Factory.addGetterSetter(Text$1, "textDecoration", "");
Factory.addGetterSetter(Text$1, "underlineOffset", void 0, getNumberValidator());
Factory.addGetterSetter(Text$1, "charRenderFunc", void 0);
var EMPTY_STRING = "", NORMAL = "normal";
function _fillFunc(context) {
	context.fillText(this.partialText, 0, 0);
}
function _strokeFunc(context) {
	context.strokeText(this.partialText, 0, 0);
}
var TextPath = class extends Shape {
	constructor(config) {
		super(config);
		this.dummyCanvas = Util.createCanvasElement();
		this.dataArray = [];
		this._readDataAttribute();
		this.on("dataChange.konva", function() {
			this._readDataAttribute();
			this._setTextData();
		});
		this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData);
		this._setTextData();
	}
	_getTextPathLength() {
		return Path.getPathLength(this.dataArray);
	}
	_getPointAtLength(length$1) {
		if (!this.attrs.data) return null;
		if (length$1 > this.pathLength) return null;
		return Path.getPointAtLengthOfDataArray(length$1, this.dataArray);
	}
	_readDataAttribute() {
		this.dataArray = Path.parsePathData(this.attrs.data);
		this.pathLength = this._getTextPathLength();
	}
	_sceneFunc(context) {
		context.setAttr("font", this._getContextFont());
		context.setAttr("textBaseline", this.textBaseline());
		context.setAttr("textAlign", "left");
		context.save();
		const textDecoration = this.textDecoration();
		const fill = this.fill();
		const fontSize = this.fontSize();
		const glyphInfo = this.glyphInfo;
		const hasUnderline = textDecoration.indexOf("underline") !== -1;
		const hasLineThrough = textDecoration.indexOf("line-through") !== -1;
		if (hasUnderline) context.beginPath();
		for (let i = 0; i < glyphInfo.length; i++) {
			context.save();
			const p0 = glyphInfo[i].p0;
			context.translate(p0.x, p0.y);
			context.rotate(glyphInfo[i].rotation);
			this.partialText = glyphInfo[i].text;
			context.fillStrokeShape(this);
			if (hasUnderline) {
				if (i === 0) context.moveTo(0, fontSize / 2 + 1);
				context.lineTo(glyphInfo[i].width, fontSize / 2 + 1);
			}
			context.restore();
		}
		if (hasUnderline) {
			context.strokeStyle = fill;
			context.lineWidth = fontSize / 20;
			context.stroke();
		}
		if (hasLineThrough) {
			context.beginPath();
			for (let i = 0; i < glyphInfo.length; i++) {
				context.save();
				const p0 = glyphInfo[i].p0;
				context.translate(p0.x, p0.y);
				context.rotate(glyphInfo[i].rotation);
				if (i === 0) context.moveTo(0, 0);
				context.lineTo(glyphInfo[i].width, 0);
				context.restore();
			}
			context.strokeStyle = fill;
			context.lineWidth = fontSize / 20;
			context.stroke();
		}
		context.restore();
	}
	_hitFunc(context) {
		context.beginPath();
		const glyphInfo = this.glyphInfo;
		if (glyphInfo.length >= 1) {
			const p0 = glyphInfo[0].p0;
			context.moveTo(p0.x, p0.y);
		}
		for (let i = 0; i < glyphInfo.length; i++) {
			const p1 = glyphInfo[i].p1;
			context.lineTo(p1.x, p1.y);
		}
		context.setAttr("lineWidth", this.fontSize());
		context.setAttr("strokeStyle", this.colorKey);
		context.stroke();
	}
	getTextWidth() {
		return this.textWidth;
	}
	getTextHeight() {
		Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.");
		return this.textHeight;
	}
	setText(text) {
		return Text$1.prototype.setText.call(this, text);
	}
	_getContextFont() {
		return Text$1.prototype._getContextFont.call(this);
	}
	_getTextSize(text) {
		const _context = this.dummyCanvas.getContext("2d");
		_context.save();
		_context.font = this._getContextFont();
		const metrics = _context.measureText(text);
		_context.restore();
		return {
			width: metrics.width,
			height: parseInt(`${this.fontSize()}`, 10)
		};
	}
	_setTextData() {
		const charArr = stringToArray(this.text());
		const chars = [];
		let width = 0;
		for (let i = 0; i < charArr.length; i++) {
			chars.push({
				char: charArr[i],
				width: this._getTextSize(charArr[i]).width
			});
			width += chars[i].width;
		}
		const { width: fullTextWidth, height } = this._getTextSize(this.attrs.text);
		this.textWidth = width;
		this.textHeight = height;
		this.glyphInfo = [];
		if (!this.attrs.data) return null;
		const letterSpacing = this.letterSpacing();
		const align = this.align();
		const kerningFunc = this.kerningFunc();
		const kerningAdjustment = Math.max(0, width - fullTextWidth);
		const textWidth = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * letterSpacing, 0);
		let offset = 0;
		if (align === "center") offset = Math.max(0, this.pathLength / 2 - textWidth / 2);
		if (align === "right") offset = Math.max(0, this.pathLength - textWidth);
		let offsetToGlyph = offset;
		for (let i = 0; i < chars.length; i++) {
			const charStartPoint = this._getPointAtLength(offsetToGlyph);
			if (!charStartPoint) return;
			const char = chars[i].char;
			let glyphWidth = chars[i].width + letterSpacing;
			if (char === " " && align === "justify") {
				const numberOfSpaces = this.text().split(" ").length - 1;
				glyphWidth += (this.pathLength - textWidth) / numberOfSpaces;
			}
			const charEndLength = offsetToGlyph + glyphWidth;
			const charEndPoint = this._getPointAtLength(charEndLength > this.pathLength && charEndLength - this.pathLength <= kerningAdjustment ? this.pathLength : charEndLength);
			if (!charEndPoint) return;
			const width$1 = Path.getLineLength(charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
			let kern = 0;
			if (kerningFunc) try {
				kern = kerningFunc(chars[i - 1].char, char) * this.fontSize();
			} catch (e) {
				kern = 0;
			}
			charStartPoint.x += kern;
			charEndPoint.x += kern;
			this.textWidth += kern;
			const midpoint = Path.getPointOnLine(kern + width$1 / 2, charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
			const rotation = Math.atan2(charEndPoint.y - charStartPoint.y, charEndPoint.x - charStartPoint.x);
			this.glyphInfo.push({
				transposeX: midpoint.x,
				transposeY: midpoint.y,
				text: charArr[i],
				rotation,
				p0: charStartPoint,
				p1: charEndPoint,
				width: width$1
			});
			offsetToGlyph += glyphWidth;
		}
	}
	getSelfRect() {
		if (!this.glyphInfo.length) return {
			x: 0,
			y: 0,
			width: 0,
			height: 0
		};
		const points = [];
		this.glyphInfo.forEach(function(info) {
			points.push(info.p0.x);
			points.push(info.p0.y);
			points.push(info.p1.x);
			points.push(info.p1.y);
		});
		let minX = points[0] || 0;
		let maxX = points[0] || 0;
		let minY = points[1] || 0;
		let maxY = points[1] || 0;
		let x, y;
		for (let i = 0; i < points.length / 2; i++) {
			x = points[i * 2];
			y = points[i * 2 + 1];
			minX = Math.min(minX, x);
			maxX = Math.max(maxX, x);
			minY = Math.min(minY, y);
			maxY = Math.max(maxY, y);
		}
		const fontSize = this.fontSize();
		return {
			x: minX - fontSize / 2,
			y: minY - fontSize / 2,
			width: maxX - minX + fontSize,
			height: maxY - minY + fontSize
		};
	}
	destroy() {
		Util.releaseCanvas(this.dummyCanvas);
		return super.destroy();
	}
};
TextPath.prototype._fillFunc = _fillFunc;
TextPath.prototype._strokeFunc = _strokeFunc;
TextPath.prototype._fillFuncHit = _fillFunc;
TextPath.prototype._strokeFuncHit = _strokeFunc;
TextPath.prototype.className = "TextPath";
TextPath.prototype._attrsAffectingSize = [
	"text",
	"fontSize",
	"data"
];
_registerNode(TextPath);
Factory.addGetterSetter(TextPath, "data");
Factory.addGetterSetter(TextPath, "fontFamily", "Arial");
Factory.addGetterSetter(TextPath, "fontSize", 12, getNumberValidator());
Factory.addGetterSetter(TextPath, "fontStyle", NORMAL);
Factory.addGetterSetter(TextPath, "align", "left");
Factory.addGetterSetter(TextPath, "letterSpacing", 0, getNumberValidator());
Factory.addGetterSetter(TextPath, "textBaseline", "middle");
Factory.addGetterSetter(TextPath, "fontVariant", NORMAL);
Factory.addGetterSetter(TextPath, "text", EMPTY_STRING);
Factory.addGetterSetter(TextPath, "textDecoration", "");
Factory.addGetterSetter(TextPath, "kerningFunc", void 0);
var EVENTS_NAME = "tr-konva";
var ATTR_CHANGE_LIST = [
	"resizeEnabledChange",
	"rotateAnchorOffsetChange",
	"rotateAnchorAngleChange",
	"rotateEnabledChange",
	"enabledAnchorsChange",
	"anchorSizeChange",
	"borderEnabledChange",
	"borderStrokeChange",
	"borderStrokeWidthChange",
	"borderDashChange",
	"anchorStrokeChange",
	"anchorStrokeWidthChange",
	"anchorFillChange",
	"anchorCornerRadiusChange",
	"ignoreStrokeChange",
	"anchorStyleFuncChange"
].map((e) => e + `.${EVENTS_NAME}`).join(" ");
var NODES_RECT = "nodesRect";
var TRANSFORM_CHANGE_STR = [
	"widthChange",
	"heightChange",
	"scaleXChange",
	"scaleYChange",
	"skewXChange",
	"skewYChange",
	"rotationChange",
	"offsetXChange",
	"offsetYChange",
	"transformsEnabledChange",
	"strokeWidthChange",
	"draggableChange"
];
var ANGLES = {
	"top-left": -45,
	"top-center": 0,
	"top-right": 45,
	"middle-right": -90,
	"middle-left": 90,
	"bottom-left": -135,
	"bottom-center": 180,
	"bottom-right": 135
};
var TOUCH_DEVICE = "ontouchstart" in Konva$2._global;
function getCursor(anchorName, rad, rotateCursor) {
	if (anchorName === "rotater") return rotateCursor;
	rad += Util.degToRad(ANGLES[anchorName] || 0);
	const angle = (Util.radToDeg(rad) % 360 + 360) % 360;
	if (Util._inRange(angle, 337.5, 360) || Util._inRange(angle, 0, 22.5)) return "ns-resize";
	else if (Util._inRange(angle, 22.5, 67.5)) return "nesw-resize";
	else if (Util._inRange(angle, 67.5, 112.5)) return "ew-resize";
	else if (Util._inRange(angle, 112.5, 157.5)) return "nwse-resize";
	else if (Util._inRange(angle, 157.5, 202.5)) return "ns-resize";
	else if (Util._inRange(angle, 202.5, 247.5)) return "nesw-resize";
	else if (Util._inRange(angle, 247.5, 292.5)) return "ew-resize";
	else if (Util._inRange(angle, 292.5, 337.5)) return "nwse-resize";
	else {
		Util.error("Transformer has unknown angle for cursor detection: " + angle);
		return "pointer";
	}
}
var ANCHORS_NAMES = [
	"top-left",
	"top-center",
	"top-right",
	"middle-right",
	"middle-left",
	"bottom-left",
	"bottom-center",
	"bottom-right"
];
var MAX_SAFE_INTEGER = 1e8;
function getCenter(shape) {
	return {
		x: shape.x + shape.width / 2 * Math.cos(shape.rotation) + shape.height / 2 * Math.sin(-shape.rotation),
		y: shape.y + shape.height / 2 * Math.cos(shape.rotation) + shape.width / 2 * Math.sin(shape.rotation)
	};
}
function rotateAroundPoint(shape, angleRad, point) {
	const x = point.x + (shape.x - point.x) * Math.cos(angleRad) - (shape.y - point.y) * Math.sin(angleRad);
	const y = point.y + (shape.x - point.x) * Math.sin(angleRad) + (shape.y - point.y) * Math.cos(angleRad);
	return {
		...shape,
		rotation: shape.rotation + angleRad,
		x,
		y
	};
}
function rotateAroundCenter(shape, deltaRad) {
	return rotateAroundPoint(shape, deltaRad, getCenter(shape));
}
function getSnap(snaps, newRotationRad, tol) {
	let snapped = newRotationRad;
	for (let i = 0; i < snaps.length; i++) {
		const angle = Konva$2.getAngle(snaps[i]);
		const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
		if (Math.min(absDiff, Math.PI * 2 - absDiff) < tol) snapped = angle;
	}
	return snapped;
}
var activeTransformersCount = 0;
var Transformer = class extends Group {
	constructor(config) {
		super(config);
		this._movingAnchorName = null;
		this._transforming = false;
		this._elementsCreated = false;
		this._createElements();
		this._handleMouseMove = this._handleMouseMove.bind(this);
		this._handleMouseUp = this._handleMouseUp.bind(this);
		this.update = this.update.bind(this);
		this.on(ATTR_CHANGE_LIST, this.update);
		if (this.getNode()) this.update();
	}
	attachTo(node) {
		this.setNode(node);
		return this;
	}
	setNode(node) {
		Util.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.");
		return this.setNodes([node]);
	}
	getNode() {
		return this._nodes && this._nodes[0];
	}
	_getEventNamespace() {
		return EVENTS_NAME + this._id;
	}
	setNodes(nodes = []) {
		if (this._nodes && this._nodes.length) this.detach();
		this._nodes = nodes = nodes.filter((node) => {
			if (node.isAncestorOf(this)) {
				Util.error("Konva.Transformer cannot be an a child of the node you are trying to attach");
				return false;
			}
			return true;
		});
		if (nodes.length === 1 && this.useSingleNodeRotation()) this.rotation(nodes[0].getAbsoluteRotation());
		else this.rotation(0);
		this._nodes.forEach((node) => {
			const onChange$1 = () => {
				if (this.nodes().length === 1 && this.useSingleNodeRotation()) this.rotation(this.nodes()[0].getAbsoluteRotation());
				this._resetTransformCache();
				if (!this._transforming && !this.isDragging()) this.update();
			};
			if (node._attrsAffectingSize.length) {
				const additionalEvents = node._attrsAffectingSize.map((prop) => prop + "Change." + this._getEventNamespace()).join(" ");
				node.on(additionalEvents, onChange$1);
			}
			node.on(TRANSFORM_CHANGE_STR.map((e) => e + `.${this._getEventNamespace()}`).join(" "), onChange$1);
			node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange$1);
			this._proxyDrag(node);
		});
		this._resetTransformCache();
		if (!!this.findOne(".top-left")) this.update();
		return this;
	}
	_proxyDrag(node) {
		let lastPos;
		node.on(`dragstart.${this._getEventNamespace()}`, (e) => {
			lastPos = node.getAbsolutePosition();
			if (!this.isDragging() && node !== this.findOne(".back")) this.startDrag(e, false);
		});
		node.on(`dragmove.${this._getEventNamespace()}`, (e) => {
			if (!lastPos) return;
			const abs = node.getAbsolutePosition();
			const dx = abs.x - lastPos.x;
			const dy = abs.y - lastPos.y;
			this.nodes().forEach((otherNode) => {
				if (otherNode === node) return;
				if (otherNode.isDragging()) return;
				const otherAbs = otherNode.getAbsolutePosition();
				otherNode.setAbsolutePosition({
					x: otherAbs.x + dx,
					y: otherAbs.y + dy
				});
				otherNode.startDrag(e);
			});
			lastPos = null;
		});
	}
	getNodes() {
		return this._nodes || [];
	}
	getActiveAnchor() {
		return this._movingAnchorName;
	}
	detach() {
		if (this._nodes) this._nodes.forEach((node) => {
			node.off("." + this._getEventNamespace());
		});
		this._nodes = [];
		this._resetTransformCache();
	}
	_resetTransformCache() {
		this._clearCache(NODES_RECT);
		this._clearCache("transform");
		this._clearSelfAndDescendantCache("absoluteTransform");
	}
	_getNodeRect() {
		return this._getCache(NODES_RECT, this.__getNodeRect);
	}
	__getNodeShape(node, rot = this.rotation(), relative) {
		const rect = node.getClientRect({
			skipTransform: true,
			skipShadow: true,
			skipStroke: this.ignoreStroke()
		});
		const absScale = node.getAbsoluteScale(relative);
		const absPos = node.getAbsolutePosition(relative);
		const dx = rect.x * absScale.x - node.offsetX() * absScale.x;
		const dy = rect.y * absScale.y - node.offsetY() * absScale.y;
		const rotation = (Konva$2.getAngle(node.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2);
		return rotateAroundPoint({
			x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
			y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
			width: rect.width * absScale.x,
			height: rect.height * absScale.y,
			rotation
		}, -Konva$2.getAngle(rot), {
			x: 0,
			y: 0
		});
	}
	__getNodeRect() {
		if (!this.getNode()) return {
			x: -MAX_SAFE_INTEGER,
			y: -MAX_SAFE_INTEGER,
			width: 0,
			height: 0,
			rotation: 0
		};
		const totalPoints = [];
		this.nodes().map((node) => {
			const box = node.getClientRect({
				skipTransform: true,
				skipShadow: true,
				skipStroke: this.ignoreStroke()
			});
			const points = [
				{
					x: box.x,
					y: box.y
				},
				{
					x: box.x + box.width,
					y: box.y
				},
				{
					x: box.x + box.width,
					y: box.y + box.height
				},
				{
					x: box.x,
					y: box.y + box.height
				}
			];
			const trans = node.getAbsoluteTransform();
			points.forEach(function(point) {
				const transformed = trans.point(point);
				totalPoints.push(transformed);
			});
		});
		const tr = new Transform();
		tr.rotate(-Konva$2.getAngle(this.rotation()));
		let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
		totalPoints.forEach(function(point) {
			const transformed = tr.point(point);
			if (minX === void 0) {
				minX = maxX = transformed.x;
				minY = maxY = transformed.y;
			}
			minX = Math.min(minX, transformed.x);
			minY = Math.min(minY, transformed.y);
			maxX = Math.max(maxX, transformed.x);
			maxY = Math.max(maxY, transformed.y);
		});
		tr.invert();
		const p = tr.point({
			x: minX,
			y: minY
		});
		return {
			x: p.x,
			y: p.y,
			width: maxX - minX,
			height: maxY - minY,
			rotation: Konva$2.getAngle(this.rotation())
		};
	}
	getX() {
		return this._getNodeRect().x;
	}
	getY() {
		return this._getNodeRect().y;
	}
	getWidth() {
		return this._getNodeRect().width;
	}
	getHeight() {
		return this._getNodeRect().height;
	}
	_createElements() {
		this._createBack();
		ANCHORS_NAMES.forEach((name) => {
			this._createAnchor(name);
		});
		this._createAnchor("rotater");
		this._elementsCreated = true;
	}
	_createAnchor(name) {
		const anchor = new Rect({
			stroke: "rgb(0, 161, 255)",
			fill: "white",
			strokeWidth: 1,
			name: name + " _anchor",
			dragDistance: 0,
			draggable: true,
			hitStrokeWidth: TOUCH_DEVICE ? 10 : "auto"
		});
		const self$1 = this;
		anchor.on("mousedown touchstart", function(e) {
			self$1._handleMouseDown(e);
		});
		anchor.on("dragstart", (e) => {
			anchor.stopDrag();
			e.cancelBubble = true;
		});
		anchor.on("dragend", (e) => {
			e.cancelBubble = true;
		});
		anchor.on("mouseenter", () => {
			const cursor = getCursor(name, Konva$2.getAngle(this.rotation()), this.rotateAnchorCursor());
			anchor.getStage().content && (anchor.getStage().content.style.cursor = cursor);
			this._cursorChange = true;
		});
		anchor.on("mouseout", () => {
			anchor.getStage().content && (anchor.getStage().content.style.cursor = "");
			this._cursorChange = false;
		});
		this.add(anchor);
	}
	_createBack() {
		const back = new Shape({
			name: "back",
			width: 0,
			height: 0,
			sceneFunc(ctx, shape) {
				const tr = shape.getParent();
				const padding = tr.padding();
				const width = shape.width();
				const height = shape.height();
				ctx.beginPath();
				ctx.rect(-padding, -padding, width + padding * 2, height + padding * 2);
				if (tr.rotateEnabled() && tr.rotateLineVisible()) {
					const rotateAnchorAngle = tr.rotateAnchorAngle();
					const rotateAnchorOffset = tr.rotateAnchorOffset();
					const rad = Util.degToRad(rotateAnchorAngle);
					const dirX = Math.sin(rad);
					const dirY = -Math.cos(rad);
					const cx = width / 2;
					const cy = height / 2;
					let t = Infinity;
					if (dirY < 0) t = Math.min(t, -cy / dirY);
					else if (dirY > 0) t = Math.min(t, (height - cy) / dirY);
					if (dirX < 0) t = Math.min(t, -cx / dirX);
					else if (dirX > 0) t = Math.min(t, (width - cx) / dirX);
					const edgeX = cx + dirX * t;
					const edgeY = cy + dirY * t;
					const sign = Util._sign(height);
					const endX = edgeX + dirX * rotateAnchorOffset * sign;
					const endY = edgeY + dirY * rotateAnchorOffset * sign;
					ctx.moveTo(edgeX, edgeY);
					ctx.lineTo(endX, endY);
				}
				ctx.fillStrokeShape(shape);
			},
			hitFunc: (ctx, shape) => {
				if (!this.shouldOverdrawWholeArea()) return;
				const padding = this.padding();
				ctx.beginPath();
				ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
				ctx.fillStrokeShape(shape);
			}
		});
		this.add(back);
		this._proxyDrag(back);
		back.on("dragstart", (e) => {
			e.cancelBubble = true;
		});
		back.on("dragmove", (e) => {
			e.cancelBubble = true;
		});
		back.on("dragend", (e) => {
			e.cancelBubble = true;
		});
		this.on("dragmove", (e) => {
			this.update();
		});
	}
	_handleMouseDown(e) {
		if (this._transforming) return;
		this._movingAnchorName = e.target.name().split(" ")[0];
		const attrs = this._getNodeRect();
		const width = attrs.width;
		const height = attrs.height;
		const hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
		this.sin = Math.abs(height / hypotenuse);
		this.cos = Math.abs(width / hypotenuse);
		if (typeof window !== "undefined") {
			window.addEventListener("mousemove", this._handleMouseMove);
			window.addEventListener("touchmove", this._handleMouseMove);
			window.addEventListener("mouseup", this._handleMouseUp, true);
			window.addEventListener("touchend", this._handleMouseUp, true);
		}
		this._transforming = true;
		const ap = e.target.getAbsolutePosition();
		const pos = e.target.getStage().getPointerPosition();
		this._anchorDragOffset = {
			x: pos.x - ap.x,
			y: pos.y - ap.y
		};
		activeTransformersCount++;
		this._fire("transformstart", {
			evt: e.evt,
			target: this.getNode()
		});
		this._nodes.forEach((target) => {
			target._fire("transformstart", {
				evt: e.evt,
				target
			});
		});
	}
	_handleMouseMove(e) {
		let x, y, newHypotenuse;
		const anchorNode = this.findOne("." + this._movingAnchorName);
		const stage = anchorNode.getStage();
		stage.setPointersPositions(e);
		const pp = stage.getPointerPosition();
		let newNodePos = {
			x: pp.x - this._anchorDragOffset.x,
			y: pp.y - this._anchorDragOffset.y
		};
		const oldAbs = anchorNode.getAbsolutePosition();
		if (this.anchorDragBoundFunc()) newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
		anchorNode.setAbsolutePosition(newNodePos);
		const newAbs = anchorNode.getAbsolutePosition();
		if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) return;
		if (this._movingAnchorName === "rotater") {
			const attrs = this._getNodeRect();
			x = anchorNode.x() - attrs.width / 2;
			y = -anchorNode.y() + attrs.height / 2;
			const rotateAnchorAngleRad = Konva$2.getAngle(this.rotateAnchorAngle());
			let delta = Math.atan2(-y, x) + Math.PI / 2 - rotateAnchorAngleRad;
			if (attrs.height < 0) delta -= Math.PI;
			const newRotation = Konva$2.getAngle(this.rotation()) + delta;
			const tol = Konva$2.getAngle(this.rotationSnapTolerance());
			const shape = rotateAroundCenter(attrs, getSnap(this.rotationSnaps(), newRotation, tol) - attrs.rotation);
			this._fitNodesInto(shape, e);
			return;
		}
		const shiftBehavior = this.shiftBehavior();
		let keepProportion;
		if (shiftBehavior === "inverted") keepProportion = this.keepRatio() && !e.shiftKey;
		else if (shiftBehavior === "none") keepProportion = this.keepRatio();
		else keepProportion = this.keepRatio() || e.shiftKey;
		let centeredScaling = this.centeredScaling() || e.altKey;
		if (this._movingAnchorName === "top-left") {
			if (keepProportion) {
				const comparePoint = centeredScaling ? {
					x: this.width() / 2,
					y: this.height() / 2
				} : {
					x: this.findOne(".bottom-right").x(),
					y: this.findOne(".bottom-right").y()
				};
				newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
				const reverseX = this.findOne(".top-left").x() > comparePoint.x ? -1 : 1;
				const reverseY = this.findOne(".top-left").y() > comparePoint.y ? -1 : 1;
				x = newHypotenuse * this.cos * reverseX;
				y = newHypotenuse * this.sin * reverseY;
				this.findOne(".top-left").x(comparePoint.x - x);
				this.findOne(".top-left").y(comparePoint.y - y);
			}
		} else if (this._movingAnchorName === "top-center") this.findOne(".top-left").y(anchorNode.y());
		else if (this._movingAnchorName === "top-right") {
			if (keepProportion) {
				const comparePoint = centeredScaling ? {
					x: this.width() / 2,
					y: this.height() / 2
				} : {
					x: this.findOne(".bottom-left").x(),
					y: this.findOne(".bottom-left").y()
				};
				newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
				const reverseX = this.findOne(".top-right").x() < comparePoint.x ? -1 : 1;
				const reverseY = this.findOne(".top-right").y() > comparePoint.y ? -1 : 1;
				x = newHypotenuse * this.cos * reverseX;
				y = newHypotenuse * this.sin * reverseY;
				this.findOne(".top-right").x(comparePoint.x + x);
				this.findOne(".top-right").y(comparePoint.y - y);
			}
			var pos = anchorNode.position();
			this.findOne(".top-left").y(pos.y);
			this.findOne(".bottom-right").x(pos.x);
		} else if (this._movingAnchorName === "middle-left") this.findOne(".top-left").x(anchorNode.x());
		else if (this._movingAnchorName === "middle-right") this.findOne(".bottom-right").x(anchorNode.x());
		else if (this._movingAnchorName === "bottom-left") {
			if (keepProportion) {
				const comparePoint = centeredScaling ? {
					x: this.width() / 2,
					y: this.height() / 2
				} : {
					x: this.findOne(".top-right").x(),
					y: this.findOne(".top-right").y()
				};
				newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
				const reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
				const reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
				x = newHypotenuse * this.cos * reverseX;
				y = newHypotenuse * this.sin * reverseY;
				anchorNode.x(comparePoint.x - x);
				anchorNode.y(comparePoint.y + y);
			}
			pos = anchorNode.position();
			this.findOne(".top-left").x(pos.x);
			this.findOne(".bottom-right").y(pos.y);
		} else if (this._movingAnchorName === "bottom-center") this.findOne(".bottom-right").y(anchorNode.y());
		else if (this._movingAnchorName === "bottom-right") {
			if (keepProportion) {
				const comparePoint = centeredScaling ? {
					x: this.width() / 2,
					y: this.height() / 2
				} : {
					x: this.findOne(".top-left").x(),
					y: this.findOne(".top-left").y()
				};
				newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
				const reverseX = this.findOne(".bottom-right").x() < comparePoint.x ? -1 : 1;
				const reverseY = this.findOne(".bottom-right").y() < comparePoint.y ? -1 : 1;
				x = newHypotenuse * this.cos * reverseX;
				y = newHypotenuse * this.sin * reverseY;
				this.findOne(".bottom-right").x(comparePoint.x + x);
				this.findOne(".bottom-right").y(comparePoint.y + y);
			}
		} else console.error(/* @__PURE__ */ new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
		centeredScaling = this.centeredScaling() || e.altKey;
		if (centeredScaling) {
			const topLeft = this.findOne(".top-left");
			const bottomRight = this.findOne(".bottom-right");
			const topOffsetX = topLeft.x();
			const topOffsetY = topLeft.y();
			const bottomOffsetX = this.getWidth() - bottomRight.x();
			const bottomOffsetY = this.getHeight() - bottomRight.y();
			bottomRight.move({
				x: -topOffsetX,
				y: -topOffsetY
			});
			topLeft.move({
				x: bottomOffsetX,
				y: bottomOffsetY
			});
		}
		const absPos = this.findOne(".top-left").getAbsolutePosition();
		x = absPos.x;
		y = absPos.y;
		const width = this.findOne(".bottom-right").x() - this.findOne(".top-left").x();
		const height = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
		this._fitNodesInto({
			x,
			y,
			width,
			height,
			rotation: Konva$2.getAngle(this.rotation())
		}, e);
	}
	_handleMouseUp(e) {
		this._removeEvents(e);
	}
	getAbsoluteTransform() {
		return this.getTransform();
	}
	_removeEvents(e) {
		var _a;
		if (this._transforming) {
			this._transforming = false;
			if (typeof window !== "undefined") {
				window.removeEventListener("mousemove", this._handleMouseMove);
				window.removeEventListener("touchmove", this._handleMouseMove);
				window.removeEventListener("mouseup", this._handleMouseUp, true);
				window.removeEventListener("touchend", this._handleMouseUp, true);
			}
			const node = this.getNode();
			activeTransformersCount--;
			this._fire("transformend", {
				evt: e,
				target: node
			});
			(_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
			if (node) this._nodes.forEach((target) => {
				var _a$1;
				target._fire("transformend", {
					evt: e,
					target
				});
				(_a$1 = target.getLayer()) === null || _a$1 === void 0 || _a$1.batchDraw();
			});
			this._movingAnchorName = null;
		}
	}
	_fitNodesInto(newAttrs, evt) {
		const oldAttrs = this._getNodeRect();
		const minSize = 1;
		if (Util._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
			this.update();
			return;
		}
		if (Util._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
			this.update();
			return;
		}
		const t = new Transform();
		t.rotate(Konva$2.getAngle(this.rotation()));
		if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
			const offset = t.point({
				x: -this.padding() * 2,
				y: 0
			});
			newAttrs.x += offset.x;
			newAttrs.y += offset.y;
			newAttrs.width += this.padding() * 2;
			this._movingAnchorName = this._movingAnchorName.replace("left", "right");
			this._anchorDragOffset.x -= offset.x;
			this._anchorDragOffset.y -= offset.y;
		} else if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
			const offset = t.point({
				x: this.padding() * 2,
				y: 0
			});
			this._movingAnchorName = this._movingAnchorName.replace("right", "left");
			this._anchorDragOffset.x -= offset.x;
			this._anchorDragOffset.y -= offset.y;
			newAttrs.width += this.padding() * 2;
		}
		if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
			const offset = t.point({
				x: 0,
				y: -this.padding() * 2
			});
			newAttrs.x += offset.x;
			newAttrs.y += offset.y;
			this._movingAnchorName = this._movingAnchorName.replace("top", "bottom");
			this._anchorDragOffset.x -= offset.x;
			this._anchorDragOffset.y -= offset.y;
			newAttrs.height += this.padding() * 2;
		} else if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
			const offset = t.point({
				x: 0,
				y: this.padding() * 2
			});
			this._movingAnchorName = this._movingAnchorName.replace("bottom", "top");
			this._anchorDragOffset.x -= offset.x;
			this._anchorDragOffset.y -= offset.y;
			newAttrs.height += this.padding() * 2;
		}
		if (this.boundBoxFunc()) {
			const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
			if (bounded) newAttrs = bounded;
			else Util.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
		}
		const baseSize = 1e7;
		const oldTr = new Transform();
		oldTr.translate(oldAttrs.x, oldAttrs.y);
		oldTr.rotate(oldAttrs.rotation);
		oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
		const newTr = new Transform();
		const newScaleX = newAttrs.width / baseSize;
		const newScaleY = newAttrs.height / baseSize;
		if (this.flipEnabled() === false) {
			newTr.translate(newAttrs.x, newAttrs.y);
			newTr.rotate(newAttrs.rotation);
			newTr.translate(newAttrs.width < 0 ? newAttrs.width : 0, newAttrs.height < 0 ? newAttrs.height : 0);
			newTr.scale(Math.abs(newScaleX), Math.abs(newScaleY));
		} else {
			newTr.translate(newAttrs.x, newAttrs.y);
			newTr.rotate(newAttrs.rotation);
			newTr.scale(newScaleX, newScaleY);
		}
		const delta = newTr.multiply(oldTr.invert());
		this._nodes.forEach((node) => {
			var _a;
			if (!node.getStage()) return;
			const parentTransform = node.getParent().getAbsoluteTransform();
			const localTransform = node.getTransform().copy();
			localTransform.translate(node.offsetX(), node.offsetY());
			const newLocalTransform = new Transform();
			newLocalTransform.multiply(parentTransform.copy().invert()).multiply(delta).multiply(parentTransform).multiply(localTransform);
			const attrs = newLocalTransform.decompose();
			node.setAttrs(attrs);
			(_a = node.getLayer()) === null || _a === void 0 || _a.batchDraw();
		});
		this.rotation(Util._getRotation(newAttrs.rotation));
		this._nodes.forEach((node) => {
			this._fire("transform", {
				evt,
				target: node
			});
			node._fire("transform", {
				evt,
				target: node
			});
		});
		this._resetTransformCache();
		this.update();
		this.getLayer().batchDraw();
	}
	forceUpdate() {
		this._resetTransformCache();
		this.update();
	}
	_batchChangeChild(selector, attrs) {
		this.findOne(selector).setAttrs(attrs);
	}
	update() {
		var _a;
		const attrs = this._getNodeRect();
		this.rotation(Util._getRotation(attrs.rotation));
		const width = attrs.width;
		const height = attrs.height;
		const enabledAnchors = this.enabledAnchors();
		const resizeEnabled = this.resizeEnabled();
		const padding = this.padding();
		const anchorSize = this.anchorSize();
		const anchors = this.find("._anchor");
		anchors.forEach((node) => {
			node.setAttrs({
				width: anchorSize,
				height: anchorSize,
				offsetX: anchorSize / 2,
				offsetY: anchorSize / 2,
				stroke: this.anchorStroke(),
				strokeWidth: this.anchorStrokeWidth(),
				fill: this.anchorFill(),
				cornerRadius: this.anchorCornerRadius()
			});
		});
		this._batchChangeChild(".top-left", {
			x: 0,
			y: 0,
			offsetX: anchorSize / 2 + padding,
			offsetY: anchorSize / 2 + padding,
			visible: resizeEnabled && enabledAnchors.indexOf("top-left") >= 0
		});
		this._batchChangeChild(".top-center", {
			x: width / 2,
			y: 0,
			offsetY: anchorSize / 2 + padding,
			visible: resizeEnabled && enabledAnchors.indexOf("top-center") >= 0
		});
		this._batchChangeChild(".top-right", {
			x: width,
			y: 0,
			offsetX: anchorSize / 2 - padding,
			offsetY: anchorSize / 2 + padding,
			visible: resizeEnabled && enabledAnchors.indexOf("top-right") >= 0
		});
		this._batchChangeChild(".middle-left", {
			x: 0,
			y: height / 2,
			offsetX: anchorSize / 2 + padding,
			visible: resizeEnabled && enabledAnchors.indexOf("middle-left") >= 0
		});
		this._batchChangeChild(".middle-right", {
			x: width,
			y: height / 2,
			offsetX: anchorSize / 2 - padding,
			visible: resizeEnabled && enabledAnchors.indexOf("middle-right") >= 0
		});
		this._batchChangeChild(".bottom-left", {
			x: 0,
			y: height,
			offsetX: anchorSize / 2 + padding,
			offsetY: anchorSize / 2 - padding,
			visible: resizeEnabled && enabledAnchors.indexOf("bottom-left") >= 0
		});
		this._batchChangeChild(".bottom-center", {
			x: width / 2,
			y: height,
			offsetY: anchorSize / 2 - padding,
			visible: resizeEnabled && enabledAnchors.indexOf("bottom-center") >= 0
		});
		this._batchChangeChild(".bottom-right", {
			x: width,
			y: height,
			offsetX: anchorSize / 2 - padding,
			offsetY: anchorSize / 2 - padding,
			visible: resizeEnabled && enabledAnchors.indexOf("bottom-right") >= 0
		});
		const rotateAnchorAngle = this.rotateAnchorAngle();
		const rotateAnchorOffset = this.rotateAnchorOffset();
		const rad = Util.degToRad(rotateAnchorAngle);
		const dirX = Math.sin(rad);
		const dirY = -Math.cos(rad);
		const cx = width / 2;
		const cy = height / 2;
		let t = Infinity;
		if (dirY < 0) t = Math.min(t, -cy / dirY);
		else if (dirY > 0) t = Math.min(t, (height - cy) / dirY);
		if (dirX < 0) t = Math.min(t, -cx / dirX);
		else if (dirX > 0) t = Math.min(t, (width - cx) / dirX);
		const edgeX = cx + dirX * t;
		const edgeY = cy + dirY * t;
		const sign = Util._sign(height);
		this._batchChangeChild(".rotater", {
			x: edgeX + dirX * rotateAnchorOffset * sign,
			y: edgeY + dirY * rotateAnchorOffset * sign - padding * dirY,
			visible: this.rotateEnabled()
		});
		this._batchChangeChild(".back", {
			width,
			height,
			visible: this.borderEnabled(),
			stroke: this.borderStroke(),
			strokeWidth: this.borderStrokeWidth(),
			dash: this.borderDash(),
			draggable: this.nodes().some((node) => node.draggable()),
			x: 0,
			y: 0
		});
		const styleFunc = this.anchorStyleFunc();
		if (styleFunc) anchors.forEach((node) => {
			styleFunc(node);
		});
		(_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
	}
	isTransforming() {
		return this._transforming;
	}
	stopTransform() {
		if (this._transforming) {
			this._removeEvents();
			const anchorNode = this.findOne("." + this._movingAnchorName);
			if (anchorNode) anchorNode.stopDrag();
		}
	}
	destroy() {
		if (this.getStage() && this._cursorChange) this.getStage().content && (this.getStage().content.style.cursor = "");
		Group.prototype.destroy.call(this);
		this.detach();
		this._removeEvents();
		return this;
	}
	add(...children) {
		if (this._elementsCreated) {
			Util.error("You cannot add external nodes to the Transformer. Use tr.nodes([node]) instead.");
			return this;
		}
		return super.add(...children);
	}
	toObject() {
		return Node$1.prototype.toObject.call(this);
	}
	clone(obj) {
		return Node$1.prototype.clone.call(this, obj);
	}
	getClientRect() {
		if (this.nodes().length > 0) return super.getClientRect();
		else return {
			x: 0,
			y: 0,
			width: 0,
			height: 0
		};
	}
};
Transformer.isTransforming = () => {
	return activeTransformersCount > 0;
};
function validateAnchors(val) {
	if (!(val instanceof Array)) Util.warn("enabledAnchors value should be an array");
	if (val instanceof Array) val.forEach(function(name) {
		if (ANCHORS_NAMES.indexOf(name) === -1) Util.warn("Unknown anchor name: " + name + ". Available names are: " + ANCHORS_NAMES.join(", "));
	});
	return val || [];
}
Transformer.prototype.className = "Transformer";
_registerNode(Transformer);
Factory.addGetterSetter(Transformer, "enabledAnchors", ANCHORS_NAMES, validateAnchors);
Factory.addGetterSetter(Transformer, "flipEnabled", true, getBooleanValidator());
Factory.addGetterSetter(Transformer, "resizeEnabled", true);
Factory.addGetterSetter(Transformer, "anchorSize", 10, getNumberValidator());
Factory.addGetterSetter(Transformer, "rotateEnabled", true);
Factory.addGetterSetter(Transformer, "rotateLineVisible", true);
Factory.addGetterSetter(Transformer, "rotationSnaps", []);
Factory.addGetterSetter(Transformer, "rotateAnchorOffset", 50, getNumberValidator());
Factory.addGetterSetter(Transformer, "rotateAnchorAngle", 0, getNumberValidator());
Factory.addGetterSetter(Transformer, "rotateAnchorCursor", "crosshair");
Factory.addGetterSetter(Transformer, "rotationSnapTolerance", 5, getNumberValidator());
Factory.addGetterSetter(Transformer, "borderEnabled", true);
Factory.addGetterSetter(Transformer, "anchorStroke", "rgb(0, 161, 255)");
Factory.addGetterSetter(Transformer, "anchorStrokeWidth", 1, getNumberValidator());
Factory.addGetterSetter(Transformer, "anchorFill", "white");
Factory.addGetterSetter(Transformer, "anchorCornerRadius", 0, getNumberValidator());
Factory.addGetterSetter(Transformer, "borderStroke", "rgb(0, 161, 255)");
Factory.addGetterSetter(Transformer, "borderStrokeWidth", 1, getNumberValidator());
Factory.addGetterSetter(Transformer, "borderDash");
Factory.addGetterSetter(Transformer, "keepRatio", true);
Factory.addGetterSetter(Transformer, "shiftBehavior", "default");
Factory.addGetterSetter(Transformer, "centeredScaling", false);
Factory.addGetterSetter(Transformer, "ignoreStroke", false);
Factory.addGetterSetter(Transformer, "padding", 0, getNumberValidator());
Factory.addGetterSetter(Transformer, "nodes");
Factory.addGetterSetter(Transformer, "node");
Factory.addGetterSetter(Transformer, "boundBoxFunc");
Factory.addGetterSetter(Transformer, "anchorDragBoundFunc");
Factory.addGetterSetter(Transformer, "anchorStyleFunc");
Factory.addGetterSetter(Transformer, "shouldOverdrawWholeArea", false);
Factory.addGetterSetter(Transformer, "useSingleNodeRotation", true);
Factory.backCompat(Transformer, {
	lineEnabled: "borderEnabled",
	rotateHandlerOffset: "rotateAnchorOffset",
	enabledHandlers: "enabledAnchors"
});
var Wedge = class extends Shape {
	_sceneFunc(context) {
		context.beginPath();
		context.arc(0, 0, this.radius(), 0, Konva$2.getAngle(this.angle()), this.clockwise());
		context.lineTo(0, 0);
		context.closePath();
		context.fillStrokeShape(this);
	}
	getWidth() {
		return this.radius() * 2;
	}
	getHeight() {
		return this.radius() * 2;
	}
	setWidth(width) {
		this.radius(width / 2);
	}
	setHeight(height) {
		this.radius(height / 2);
	}
};
Wedge.prototype.className = "Wedge";
Wedge.prototype._centroid = true;
Wedge.prototype._attrsAffectingSize = ["radius"];
_registerNode(Wedge);
Factory.addGetterSetter(Wedge, "radius", 0, getNumberValidator());
Factory.addGetterSetter(Wedge, "angle", 0, getNumberValidator());
Factory.addGetterSetter(Wedge, "clockwise", false);
Factory.backCompat(Wedge, {
	angleDeg: "angle",
	getAngleDeg: "getAngle",
	setAngleDeg: "setAngle"
});
function BlurStack() {
	this.r = 0;
	this.g = 0;
	this.b = 0;
	this.a = 0;
	this.next = null;
}
var mul_table = [
	512,
	512,
	456,
	512,
	328,
	456,
	335,
	512,
	405,
	328,
	271,
	456,
	388,
	335,
	292,
	512,
	454,
	405,
	364,
	328,
	298,
	271,
	496,
	456,
	420,
	388,
	360,
	335,
	312,
	292,
	273,
	512,
	482,
	454,
	428,
	405,
	383,
	364,
	345,
	328,
	312,
	298,
	284,
	271,
	259,
	496,
	475,
	456,
	437,
	420,
	404,
	388,
	374,
	360,
	347,
	335,
	323,
	312,
	302,
	292,
	282,
	273,
	265,
	512,
	497,
	482,
	468,
	454,
	441,
	428,
	417,
	405,
	394,
	383,
	373,
	364,
	354,
	345,
	337,
	328,
	320,
	312,
	305,
	298,
	291,
	284,
	278,
	271,
	265,
	259,
	507,
	496,
	485,
	475,
	465,
	456,
	446,
	437,
	428,
	420,
	412,
	404,
	396,
	388,
	381,
	374,
	367,
	360,
	354,
	347,
	341,
	335,
	329,
	323,
	318,
	312,
	307,
	302,
	297,
	292,
	287,
	282,
	278,
	273,
	269,
	265,
	261,
	512,
	505,
	497,
	489,
	482,
	475,
	468,
	461,
	454,
	447,
	441,
	435,
	428,
	422,
	417,
	411,
	405,
	399,
	394,
	389,
	383,
	378,
	373,
	368,
	364,
	359,
	354,
	350,
	345,
	341,
	337,
	332,
	328,
	324,
	320,
	316,
	312,
	309,
	305,
	301,
	298,
	294,
	291,
	287,
	284,
	281,
	278,
	274,
	271,
	268,
	265,
	262,
	259,
	257,
	507,
	501,
	496,
	491,
	485,
	480,
	475,
	470,
	465,
	460,
	456,
	451,
	446,
	442,
	437,
	433,
	428,
	424,
	420,
	416,
	412,
	408,
	404,
	400,
	396,
	392,
	388,
	385,
	381,
	377,
	374,
	370,
	367,
	363,
	360,
	357,
	354,
	350,
	347,
	344,
	341,
	338,
	335,
	332,
	329,
	326,
	323,
	320,
	318,
	315,
	312,
	310,
	307,
	304,
	302,
	299,
	297,
	294,
	292,
	289,
	287,
	285,
	282,
	280,
	278,
	275,
	273,
	271,
	269,
	267,
	265,
	263,
	261,
	259
];
var shg_table = [
	9,
	11,
	12,
	13,
	13,
	14,
	14,
	15,
	15,
	15,
	15,
	16,
	16,
	16,
	16,
	17,
	17,
	17,
	17,
	17,
	17,
	17,
	18,
	18,
	18,
	18,
	18,
	18,
	18,
	18,
	18,
	19,
	19,
	19,
	19,
	19,
	19,
	19,
	19,
	19,
	19,
	19,
	19,
	19,
	19,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	20,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	21,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	22,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	23,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24,
	24
];
function filterGaussBlurRGBA(imageData, radius) {
	const pixels = imageData.data, width = imageData.width, height = imageData.height;
	let p, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
	const div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2, stackStart = new BlurStack(), mul_sum = mul_table[radius], shg_sum = shg_table[radius];
	let stackEnd = null, stack = stackStart, stackIn = null, stackOut = null;
	for (let i = 1; i < div; i++) {
		stack = stack.next = new BlurStack();
		if (i === radiusPlus1) stackEnd = stack;
	}
	stack.next = stackStart;
	yw = yi = 0;
	for (let y = 0; y < height; y++) {
		r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
		r_out_sum = radiusPlus1 * (pr = pixels[yi]);
		g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
		b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
		a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
		r_sum += sumFactor * pr;
		g_sum += sumFactor * pg;
		b_sum += sumFactor * pb;
		a_sum += sumFactor * pa;
		stack = stackStart;
		for (let i = 0; i < radiusPlus1; i++) {
			stack.r = pr;
			stack.g = pg;
			stack.b = pb;
			stack.a = pa;
			stack = stack.next;
		}
		for (let i = 1; i < radiusPlus1; i++) {
			p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
			r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
			g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
			b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
			a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
			r_in_sum += pr;
			g_in_sum += pg;
			b_in_sum += pb;
			a_in_sum += pa;
			stack = stack.next;
		}
		stackIn = stackStart;
		stackOut = stackEnd;
		for (let x = 0; x < width; x++) {
			pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
			if (pa !== 0) {
				pa = 255 / pa;
				pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
				pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
				pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
			} else pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
			r_sum -= r_out_sum;
			g_sum -= g_out_sum;
			b_sum -= b_out_sum;
			a_sum -= a_out_sum;
			r_out_sum -= stackIn.r;
			g_out_sum -= stackIn.g;
			b_out_sum -= stackIn.b;
			a_out_sum -= stackIn.a;
			p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
			r_in_sum += stackIn.r = pixels[p];
			g_in_sum += stackIn.g = pixels[p + 1];
			b_in_sum += stackIn.b = pixels[p + 2];
			a_in_sum += stackIn.a = pixels[p + 3];
			r_sum += r_in_sum;
			g_sum += g_in_sum;
			b_sum += b_in_sum;
			a_sum += a_in_sum;
			stackIn = stackIn.next;
			r_out_sum += pr = stackOut.r;
			g_out_sum += pg = stackOut.g;
			b_out_sum += pb = stackOut.b;
			a_out_sum += pa = stackOut.a;
			r_in_sum -= pr;
			g_in_sum -= pg;
			b_in_sum -= pb;
			a_in_sum -= pa;
			stackOut = stackOut.next;
			yi += 4;
		}
		yw += width;
	}
	for (let x = 0; x < width; x++) {
		g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
		yi = x << 2;
		r_out_sum = radiusPlus1 * (pr = pixels[yi]);
		g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
		b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
		a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
		r_sum += sumFactor * pr;
		g_sum += sumFactor * pg;
		b_sum += sumFactor * pb;
		a_sum += sumFactor * pa;
		stack = stackStart;
		for (let i = 0; i < radiusPlus1; i++) {
			stack.r = pr;
			stack.g = pg;
			stack.b = pb;
			stack.a = pa;
			stack = stack.next;
		}
		let yp = width;
		for (let i = 1; i <= radius; i++) {
			yi = yp + x << 2;
			r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
			g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
			b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
			a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
			r_in_sum += pr;
			g_in_sum += pg;
			b_in_sum += pb;
			a_in_sum += pa;
			stack = stack.next;
			if (i < heightMinus1) yp += width;
		}
		yi = x;
		stackIn = stackStart;
		stackOut = stackEnd;
		for (let y = 0; y < height; y++) {
			p = yi << 2;
			pixels[p + 3] = pa = a_sum * mul_sum >> shg_sum;
			if (pa > 0) {
				pa = 255 / pa;
				pixels[p] = (r_sum * mul_sum >> shg_sum) * pa;
				pixels[p + 1] = (g_sum * mul_sum >> shg_sum) * pa;
				pixels[p + 2] = (b_sum * mul_sum >> shg_sum) * pa;
			} else pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
			r_sum -= r_out_sum;
			g_sum -= g_out_sum;
			b_sum -= b_out_sum;
			a_sum -= a_out_sum;
			r_out_sum -= stackIn.r;
			g_out_sum -= stackIn.g;
			b_out_sum -= stackIn.b;
			a_out_sum -= stackIn.a;
			p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
			r_sum += r_in_sum += stackIn.r = pixels[p];
			g_sum += g_in_sum += stackIn.g = pixels[p + 1];
			b_sum += b_in_sum += stackIn.b = pixels[p + 2];
			a_sum += a_in_sum += stackIn.a = pixels[p + 3];
			stackIn = stackIn.next;
			r_out_sum += pr = stackOut.r;
			g_out_sum += pg = stackOut.g;
			b_out_sum += pb = stackOut.b;
			a_out_sum += pa = stackOut.a;
			r_in_sum -= pr;
			g_in_sum -= pg;
			b_in_sum -= pb;
			a_in_sum -= pa;
			stackOut = stackOut.next;
			yi += width;
		}
	}
}
const Blur = function Blur$1(imageData) {
	const radius = Math.round(this.blurRadius());
	if (radius > 0) filterGaussBlurRGBA(imageData, radius);
};
Factory.addGetterSetter(Node$1, "blurRadius", 0, getNumberValidator(), Factory.afterSetFilter);
const Brighten = function(imageData) {
	const brightness = this.brightness() * 255, data = imageData.data, len = data.length;
	for (let i = 0; i < len; i += 4) {
		data[i] += brightness;
		data[i + 1] += brightness;
		data[i + 2] += brightness;
	}
};
Factory.addGetterSetter(Node$1, "brightness", 0, getNumberValidator(), Factory.afterSetFilter);
const Brightness = function(imageData) {
	const brightness = this.brightness(), data = imageData.data, len = data.length;
	for (let i = 0; i < len; i += 4) {
		data[i] = Math.min(255, data[i] * brightness);
		data[i + 1] = Math.min(255, data[i + 1] * brightness);
		data[i + 2] = Math.min(255, data[i + 2] * brightness);
	}
};
const Contrast = function(imageData) {
	const adjust = Math.pow((this.contrast() + 100) / 100, 2);
	const data = imageData.data, nPixels = data.length;
	let red = 150, green = 150, blue = 150;
	for (let i = 0; i < nPixels; i += 4) {
		red = data[i];
		green = data[i + 1];
		blue = data[i + 2];
		red /= 255;
		red -= .5;
		red *= adjust;
		red += .5;
		red *= 255;
		green /= 255;
		green -= .5;
		green *= adjust;
		green += .5;
		green *= 255;
		blue /= 255;
		blue -= .5;
		blue *= adjust;
		blue += .5;
		blue *= 255;
		red = red < 0 ? 0 : red > 255 ? 255 : red;
		green = green < 0 ? 0 : green > 255 ? 255 : green;
		blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
		data[i] = red;
		data[i + 1] = green;
		data[i + 2] = blue;
	}
};
Factory.addGetterSetter(Node$1, "contrast", 0, getNumberValidator(), Factory.afterSetFilter);
const Emboss = function(imageData) {
	var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	const data = imageData.data;
	const w = imageData.width;
	const h$1 = imageData.height;
	const strength01 = Math.min(1, Math.max(0, (_b = (_a = this.embossStrength) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : .5));
	const whiteLevel01 = Math.min(1, Math.max(0, (_d = (_c = this.embossWhiteLevel) === null || _c === void 0 ? void 0 : _c.call(this)) !== null && _d !== void 0 ? _d : .5));
	const directionDeg = (_g = {
		"top-left": 315,
		top: 270,
		"top-right": 225,
		right: 180,
		"bottom-right": 135,
		bottom: 90,
		"bottom-left": 45,
		left: 0
	}[(_f = (_e = this.embossDirection) === null || _e === void 0 ? void 0 : _e.call(this)) !== null && _f !== void 0 ? _f : "top-left"]) !== null && _g !== void 0 ? _g : 315;
	const blend = !!((_j = (_h = this.embossBlend) === null || _h === void 0 ? void 0 : _h.call(this)) !== null && _j !== void 0 ? _j : false);
	const strength = strength01 * 10;
	const bias = whiteLevel01 * 255;
	const dirRad = directionDeg * Math.PI / 180;
	const cx = Math.cos(dirRad);
	const cy = Math.sin(dirRad);
	const SCALE = 128 / 1020 * strength;
	const src = new Uint8ClampedArray(data);
	const lum = new Float32Array(w * h$1);
	for (let p = 0, i = 0; i < data.length; i += 4, p++) lum[p] = .2126 * src[i] + .7152 * src[i + 1] + .0722 * src[i + 2];
	const Gx = [
		-1,
		0,
		1,
		-2,
		0,
		2,
		-1,
		0,
		1
	];
	const Gy = [
		-1,
		-2,
		-1,
		0,
		0,
		0,
		1,
		2,
		1
	];
	const OFF = [
		-w - 1,
		-w,
		-w + 1,
		-1,
		0,
		1,
		w - 1,
		w,
		w + 1
	];
	const clamp8 = (v) => v < 0 ? 0 : v > 255 ? 255 : v;
	for (let y = 1; y < h$1 - 1; y++) for (let x = 1; x < w - 1; x++) {
		const p = y * w + x;
		let sx = 0, sy = 0;
		sx += lum[p + OFF[0]] * Gx[0];
		sy += lum[p + OFF[0]] * Gy[0];
		sx += lum[p + OFF[1]] * Gx[1];
		sy += lum[p + OFF[1]] * Gy[1];
		sx += lum[p + OFF[2]] * Gx[2];
		sy += lum[p + OFF[2]] * Gy[2];
		sx += lum[p + OFF[3]] * Gx[3];
		sy += lum[p + OFF[3]] * Gy[3];
		sx += lum[p + OFF[5]] * Gx[5];
		sy += lum[p + OFF[5]] * Gy[5];
		sx += lum[p + OFF[6]] * Gx[6];
		sy += lum[p + OFF[6]] * Gy[6];
		sx += lum[p + OFF[7]] * Gx[7];
		sy += lum[p + OFF[7]] * Gy[7];
		sx += lum[p + OFF[8]] * Gx[8];
		sy += lum[p + OFF[8]] * Gy[8];
		const outGray = clamp8(bias + (cx * sx + cy * sy) * SCALE);
		const o = p * 4;
		if (blend) {
			const delta = outGray - bias;
			data[o] = clamp8(src[o] + delta);
			data[o + 1] = clamp8(src[o + 1] + delta);
			data[o + 2] = clamp8(src[o + 2] + delta);
			data[o + 3] = src[o + 3];
		} else {
			data[o] = data[o + 1] = data[o + 2] = outGray;
			data[o + 3] = src[o + 3];
		}
	}
	for (let x = 0; x < w; x++) {
		let oTop = x * 4, oBot = ((h$1 - 1) * w + x) * 4;
		data[oTop] = src[oTop];
		data[oTop + 1] = src[oTop + 1];
		data[oTop + 2] = src[oTop + 2];
		data[oTop + 3] = src[oTop + 3];
		data[oBot] = src[oBot];
		data[oBot + 1] = src[oBot + 1];
		data[oBot + 2] = src[oBot + 2];
		data[oBot + 3] = src[oBot + 3];
	}
	for (let y = 1; y < h$1 - 1; y++) {
		let oL = y * w * 4, oR = (y * w + (w - 1)) * 4;
		data[oL] = src[oL];
		data[oL + 1] = src[oL + 1];
		data[oL + 2] = src[oL + 2];
		data[oL + 3] = src[oL + 3];
		data[oR] = src[oR];
		data[oR + 1] = src[oR + 1];
		data[oR + 2] = src[oR + 2];
		data[oR + 3] = src[oR + 3];
	}
	return imageData;
};
Factory.addGetterSetter(Node$1, "embossStrength", .5, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node$1, "embossWhiteLevel", .5, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node$1, "embossDirection", "top-left", void 0, Factory.afterSetFilter);
Factory.addGetterSetter(Node$1, "embossBlend", false, void 0, Factory.afterSetFilter);
function remap(fromValue, fromMin, fromMax, toMin, toMax) {
	const fromRange = fromMax - fromMin, toRange = toMax - toMin;
	if (fromRange === 0) return toMin + toRange / 2;
	if (toRange === 0) return toMin;
	let toValue = (fromValue - fromMin) / fromRange;
	toValue = toRange * toValue + toMin;
	return toValue;
}
const Enhance = function(imageData) {
	const data = imageData.data, nSubPixels = data.length;
	let rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b;
	const enhanceAmount = this.enhance();
	if (enhanceAmount === 0) return;
	for (let i = 0; i < nSubPixels; i += 4) {
		r = data[i + 0];
		if (r < rMin) rMin = r;
		else if (r > rMax) rMax = r;
		g = data[i + 1];
		if (g < gMin) gMin = g;
		else if (g > gMax) gMax = g;
		b = data[i + 2];
		if (b < bMin) bMin = b;
		else if (b > bMax) bMax = b;
	}
	if (rMax === rMin) {
		rMax = 255;
		rMin = 0;
	}
	if (gMax === gMin) {
		gMax = 255;
		gMin = 0;
	}
	if (bMax === bMin) {
		bMax = 255;
		bMin = 0;
	}
	let rGoalMax, rGoalMin, gGoalMax, gGoalMin, bGoalMax, bGoalMin;
	if (enhanceAmount > 0) {
		rGoalMax = rMax + enhanceAmount * (255 - rMax);
		rGoalMin = rMin - enhanceAmount * (rMin - 0);
		gGoalMax = gMax + enhanceAmount * (255 - gMax);
		gGoalMin = gMin - enhanceAmount * (gMin - 0);
		bGoalMax = bMax + enhanceAmount * (255 - bMax);
		bGoalMin = bMin - enhanceAmount * (bMin - 0);
	} else {
		const rMid = (rMax + rMin) * .5;
		rGoalMax = rMax + enhanceAmount * (rMax - rMid);
		rGoalMin = rMin + enhanceAmount * (rMin - rMid);
		const gMid = (gMax + gMin) * .5;
		gGoalMax = gMax + enhanceAmount * (gMax - gMid);
		gGoalMin = gMin + enhanceAmount * (gMin - gMid);
		const bMid = (bMax + bMin) * .5;
		bGoalMax = bMax + enhanceAmount * (bMax - bMid);
		bGoalMin = bMin + enhanceAmount * (bMin - bMid);
	}
	for (let i = 0; i < nSubPixels; i += 4) {
		data[i + 0] = remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
		data[i + 1] = remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
		data[i + 2] = remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
	}
};
Factory.addGetterSetter(Node$1, "enhance", 0, getNumberValidator(), Factory.afterSetFilter);
const Grayscale = function(imageData) {
	const data = imageData.data, len = data.length;
	for (let i = 0; i < len; i += 4) {
		const brightness = .34 * data[i] + .5 * data[i + 1] + .16 * data[i + 2];
		data[i] = brightness;
		data[i + 1] = brightness;
		data[i + 2] = brightness;
	}
};
Factory.addGetterSetter(Node$1, "hue", 0, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node$1, "saturation", 0, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node$1, "luminance", 0, getNumberValidator(), Factory.afterSetFilter);
const HSL = function(imageData) {
	const data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h$1 = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127;
	const vsu = v * s * Math.cos(h$1 * Math.PI / 180), vsw = v * s * Math.sin(h$1 * Math.PI / 180);
	const rr = .299 * v + .701 * vsu + .167 * vsw, rg = .587 * v - .587 * vsu + .33 * vsw, rb = .114 * v - .114 * vsu - .497 * vsw;
	const gr = .299 * v - .299 * vsu - .328 * vsw, gg = .587 * v + .413 * vsu + .035 * vsw, gb = .114 * v - .114 * vsu + .293 * vsw;
	const br = .299 * v - .3 * vsu + 1.25 * vsw, bg = .587 * v - .586 * vsu - 1.05 * vsw, bb = .114 * v + .886 * vsu - .2 * vsw;
	let r, g, b, a;
	for (let i = 0; i < nPixels; i += 4) {
		r = data[i + 0];
		g = data[i + 1];
		b = data[i + 2];
		a = data[i + 3];
		data[i + 0] = rr * r + rg * g + rb * b + l;
		data[i + 1] = gr * r + gg * g + gb * b + l;
		data[i + 2] = br * r + bg * g + bb * b + l;
		data[i + 3] = a;
	}
};
const HSV = function(imageData) {
	const data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h$1 = Math.abs(this.hue() + 360) % 360;
	const vsu = v * s * Math.cos(h$1 * Math.PI / 180), vsw = v * s * Math.sin(h$1 * Math.PI / 180);
	const rr = .299 * v + .701 * vsu + .167 * vsw, rg = .587 * v - .587 * vsu + .33 * vsw, rb = .114 * v - .114 * vsu - .497 * vsw;
	const gr = .299 * v - .299 * vsu - .328 * vsw, gg = .587 * v + .413 * vsu + .035 * vsw, gb = .114 * v - .114 * vsu + .293 * vsw;
	const br = .299 * v - .3 * vsu + 1.25 * vsw, bg = .587 * v - .586 * vsu - 1.05 * vsw, bb = .114 * v + .886 * vsu - .2 * vsw;
	for (let i = 0; i < nPixels; i += 4) {
		const r = data[i + 0];
		const g = data[i + 1];
		const b = data[i + 2];
		const a = data[i + 3];
		data[i + 0] = rr * r + rg * g + rb * b;
		data[i + 1] = gr * r + gg * g + gb * b;
		data[i + 2] = br * r + bg * g + bb * b;
		data[i + 3] = a;
	}
};
Factory.addGetterSetter(Node$1, "hue", 0, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node$1, "saturation", 0, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node$1, "value", 0, getNumberValidator(), Factory.afterSetFilter);
const Invert = function(imageData) {
	const data = imageData.data, len = data.length;
	for (let i = 0; i < len; i += 4) {
		data[i] = 255 - data[i];
		data[i + 1] = 255 - data[i + 1];
		data[i + 2] = 255 - data[i + 2];
	}
};
var ToPolar = function(src, dst, opt) {
	const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
	let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
	let x = xSize - xMid;
	let y = ySize - yMid;
	const rad = Math.sqrt(x * x + y * y);
	rMax = rad > rMax ? rad : rMax;
	const rSize = ySize, tSize = xSize;
	const conversion = 360 / tSize * Math.PI / 180;
	for (let theta = 0; theta < tSize; theta += 1) {
		const sin = Math.sin(theta * conversion);
		const cos = Math.cos(theta * conversion);
		for (let radius = 0; radius < rSize; radius += 1) {
			x = Math.floor(xMid + rMax * radius / rSize * cos);
			y = Math.floor(yMid + rMax * radius / rSize * sin);
			let i = (y * xSize + x) * 4;
			const r = srcPixels[i + 0];
			const g = srcPixels[i + 1];
			const b = srcPixels[i + 2];
			const a = srcPixels[i + 3];
			i = (theta + radius * xSize) * 4;
			dstPixels[i + 0] = r;
			dstPixels[i + 1] = g;
			dstPixels[i + 2] = b;
			dstPixels[i + 3] = a;
		}
	}
};
var FromPolar = function(src, dst, opt) {
	const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
	let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
	let x = xSize - xMid;
	let y = ySize - yMid;
	const rad = Math.sqrt(x * x + y * y);
	rMax = rad > rMax ? rad : rMax;
	const rSize = ySize, tSize = xSize, phaseShift = opt.polarRotation || 0;
	let x1, y1;
	for (x = 0; x < xSize; x += 1) for (y = 0; y < ySize; y += 1) {
		const dx = x - xMid;
		const dy = y - yMid;
		const radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
		let theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
		theta = theta * tSize / 360;
		x1 = Math.floor(theta);
		y1 = Math.floor(radius);
		let i = (y1 * xSize + x1) * 4;
		const r = srcPixels[i + 0];
		const g = srcPixels[i + 1];
		const b = srcPixels[i + 2];
		const a = srcPixels[i + 3];
		i = (y * xSize + x) * 4;
		dstPixels[i + 0] = r;
		dstPixels[i + 1] = g;
		dstPixels[i + 2] = b;
		dstPixels[i + 3] = a;
	}
};
const Kaleidoscope = function(imageData) {
	const xSize = imageData.width, ySize = imageData.height;
	let x, y, xoff, i, r, g, b, a, srcPos, dstPos;
	let power = Math.round(this.kaleidoscopePower());
	const angle = Math.round(this.kaleidoscopeAngle());
	const offset = Math.floor(xSize * (angle % 360) / 360);
	if (power < 1) return;
	const tempCanvas = Util.createCanvasElement();
	tempCanvas.width = xSize;
	tempCanvas.height = ySize;
	const scratchData = tempCanvas.getContext("2d").getImageData(0, 0, xSize, ySize);
	Util.releaseCanvas(tempCanvas);
	ToPolar(imageData, scratchData, {
		polarCenterX: xSize / 2,
		polarCenterY: ySize / 2
	});
	let minSectionSize = xSize / Math.pow(2, power);
	while (minSectionSize <= 8) {
		minSectionSize = minSectionSize * 2;
		power -= 1;
	}
	minSectionSize = Math.ceil(minSectionSize);
	let sectionSize = minSectionSize;
	let xStart = 0, xEnd = sectionSize, xDelta = 1;
	if (offset + minSectionSize > xSize) {
		xStart = sectionSize;
		xEnd = 0;
		xDelta = -1;
	}
	for (y = 0; y < ySize; y += 1) for (x = xStart; x !== xEnd; x += xDelta) {
		xoff = Math.round(x + offset) % xSize;
		srcPos = (xSize * y + xoff) * 4;
		r = scratchData.data[srcPos + 0];
		g = scratchData.data[srcPos + 1];
		b = scratchData.data[srcPos + 2];
		a = scratchData.data[srcPos + 3];
		dstPos = (xSize * y + x) * 4;
		scratchData.data[dstPos + 0] = r;
		scratchData.data[dstPos + 1] = g;
		scratchData.data[dstPos + 2] = b;
		scratchData.data[dstPos + 3] = a;
	}
	for (y = 0; y < ySize; y += 1) {
		sectionSize = Math.floor(minSectionSize);
		for (i = 0; i < power; i += 1) {
			for (x = 0; x < sectionSize + 1; x += 1) {
				srcPos = (xSize * y + x) * 4;
				r = scratchData.data[srcPos + 0];
				g = scratchData.data[srcPos + 1];
				b = scratchData.data[srcPos + 2];
				a = scratchData.data[srcPos + 3];
				dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
				scratchData.data[dstPos + 0] = r;
				scratchData.data[dstPos + 1] = g;
				scratchData.data[dstPos + 2] = b;
				scratchData.data[dstPos + 3] = a;
			}
			sectionSize *= 2;
		}
	}
	FromPolar(scratchData, imageData, { polarRotation: 0 });
};
Factory.addGetterSetter(Node$1, "kaleidoscopePower", 2, getNumberValidator(), Factory.afterSetFilter);
Factory.addGetterSetter(Node$1, "kaleidoscopeAngle", 0, getNumberValidator(), Factory.afterSetFilter);
function pixelAt(idata, x, y) {
	let idx = (y * idata.width + x) * 4;
	const d = [];
	d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
	return d;
}
function rgbDistance(p1, p2) {
	return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2) + Math.pow(p1[2] - p2[2], 2));
}
function rgbMean(pTab) {
	const m = [
		0,
		0,
		0
	];
	for (let i = 0; i < pTab.length; i++) {
		m[0] += pTab[i][0];
		m[1] += pTab[i][1];
		m[2] += pTab[i][2];
	}
	m[0] /= pTab.length;
	m[1] /= pTab.length;
	m[2] /= pTab.length;
	return m;
}
function backgroundMask(idata, threshold) {
	const rgbv_no = pixelAt(idata, 0, 0);
	const rgbv_ne = pixelAt(idata, idata.width - 1, 0);
	const rgbv_so = pixelAt(idata, 0, idata.height - 1);
	const rgbv_se = pixelAt(idata, idata.width - 1, idata.height - 1);
	const thres = threshold || 10;
	if (rgbDistance(rgbv_no, rgbv_ne) < thres && rgbDistance(rgbv_ne, rgbv_se) < thres && rgbDistance(rgbv_se, rgbv_so) < thres && rgbDistance(rgbv_so, rgbv_no) < thres) {
		const mean = rgbMean([
			rgbv_ne,
			rgbv_no,
			rgbv_se,
			rgbv_so
		]);
		const mask = [];
		for (let i = 0; i < idata.width * idata.height; i++) mask[i] = rgbDistance(mean, [
			idata.data[i * 4],
			idata.data[i * 4 + 1],
			idata.data[i * 4 + 2]
		]) < thres ? 0 : 255;
		return mask;
	}
}
function applyMask(idata, mask) {
	for (let i = 0; i < idata.width * idata.height; i++) idata.data[4 * i + 3] = mask[i];
}
function erodeMask(mask, sw, sh) {
	const weights = [
		1,
		1,
		1,
		1,
		0,
		1,
		1,
		1,
		1
	];
	const side = Math.round(Math.sqrt(weights.length));
	const halfSide = Math.floor(side / 2);
	const maskResult = [];
	for (let y = 0; y < sh; y++) for (let x = 0; x < sw; x++) {
		const so = y * sw + x;
		let a = 0;
		for (let cy = 0; cy < side; cy++) for (let cx = 0; cx < side; cx++) {
			const scy = y + cy - halfSide;
			const scx = x + cx - halfSide;
			if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
				const srcOff = scy * sw + scx;
				const wt = weights[cy * side + cx];
				a += mask[srcOff] * wt;
			}
		}
		maskResult[so] = a === 2040 ? 255 : 0;
	}
	return maskResult;
}
function dilateMask(mask, sw, sh) {
	const weights = [
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1
	];
	const side = Math.round(Math.sqrt(weights.length));
	const halfSide = Math.floor(side / 2);
	const maskResult = [];
	for (let y = 0; y < sh; y++) for (let x = 0; x < sw; x++) {
		const so = y * sw + x;
		let a = 0;
		for (let cy = 0; cy < side; cy++) for (let cx = 0; cx < side; cx++) {
			const scy = y + cy - halfSide;
			const scx = x + cx - halfSide;
			if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
				const srcOff = scy * sw + scx;
				const wt = weights[cy * side + cx];
				a += mask[srcOff] * wt;
			}
		}
		maskResult[so] = a >= 1020 ? 255 : 0;
	}
	return maskResult;
}
function smoothEdgeMask(mask, sw, sh) {
	const weights = [
		1 / 9,
		1 / 9,
		1 / 9,
		1 / 9,
		1 / 9,
		1 / 9,
		1 / 9,
		1 / 9,
		1 / 9
	];
	const side = Math.round(Math.sqrt(weights.length));
	const halfSide = Math.floor(side / 2);
	const maskResult = [];
	for (let y = 0; y < sh; y++) for (let x = 0; x < sw; x++) {
		const so = y * sw + x;
		let a = 0;
		for (let cy = 0; cy < side; cy++) for (let cx = 0; cx < side; cx++) {
			const scy = y + cy - halfSide;
			const scx = x + cx - halfSide;
			if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
				const srcOff = scy * sw + scx;
				const wt = weights[cy * side + cx];
				a += mask[srcOff] * wt;
			}
		}
		maskResult[so] = a;
	}
	return maskResult;
}
const Mask = function(imageData) {
	let mask = backgroundMask(imageData, this.threshold());
	if (mask) {
		mask = erodeMask(mask, imageData.width, imageData.height);
		mask = dilateMask(mask, imageData.width, imageData.height);
		mask = smoothEdgeMask(mask, imageData.width, imageData.height);
		applyMask(imageData, mask);
	}
	return imageData;
};
Factory.addGetterSetter(Node$1, "threshold", 0, getNumberValidator(), Factory.afterSetFilter);
const Noise = function(imageData) {
	const amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2;
	for (let i = 0; i < nPixels; i += 4) {
		data[i + 0] += half - 2 * half * Math.random();
		data[i + 1] += half - 2 * half * Math.random();
		data[i + 2] += half - 2 * half * Math.random();
	}
};
Factory.addGetterSetter(Node$1, "noise", .2, getNumberValidator(), Factory.afterSetFilter);
const Pixelate = function(imageData) {
	let pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), data = imageData.data;
	if (pixelSize <= 0) {
		Util.error("pixelSize value can not be <= 0");
		return;
	}
	for (let xBin = 0; xBin < nBinsX; xBin += 1) for (let yBin = 0; yBin < nBinsY; yBin += 1) {
		let red = 0;
		let green = 0;
		let blue = 0;
		let alpha = 0;
		const xBinStart = xBin * pixelSize;
		const xBinEnd = xBinStart + pixelSize;
		const yBinStart = yBin * pixelSize;
		const yBinEnd = yBinStart + pixelSize;
		let pixelsInBin = 0;
		for (let x = xBinStart; x < xBinEnd; x += 1) {
			if (x >= width) continue;
			for (let y = yBinStart; y < yBinEnd; y += 1) {
				if (y >= height) continue;
				const i = (width * y + x) * 4;
				red += data[i + 0];
				green += data[i + 1];
				blue += data[i + 2];
				alpha += data[i + 3];
				pixelsInBin += 1;
			}
		}
		red = red / pixelsInBin;
		green = green / pixelsInBin;
		blue = blue / pixelsInBin;
		alpha = alpha / pixelsInBin;
		for (let x = xBinStart; x < xBinEnd; x += 1) {
			if (x >= width) continue;
			for (let y = yBinStart; y < yBinEnd; y += 1) {
				if (y >= height) continue;
				const i = (width * y + x) * 4;
				data[i + 0] = red;
				data[i + 1] = green;
				data[i + 2] = blue;
				data[i + 3] = alpha;
			}
		}
	}
};
Factory.addGetterSetter(Node$1, "pixelSize", 8, getNumberValidator(), Factory.afterSetFilter);
const Posterize = function(imageData) {
	const levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels;
	for (let i = 0; i < len; i += 1) data[i] = Math.floor(data[i] / scale) * scale;
};
Factory.addGetterSetter(Node$1, "levels", .5, getNumberValidator(), Factory.afterSetFilter);
const RGB = function(imageData) {
	const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue();
	for (let i = 0; i < nPixels; i += 4) {
		const brightness = (.34 * data[i] + .5 * data[i + 1] + .16 * data[i + 2]) / 255;
		data[i] = brightness * red;
		data[i + 1] = brightness * green;
		data[i + 2] = brightness * blue;
		data[i + 3] = data[i + 3];
	}
};
Factory.addGetterSetter(Node$1, "red", 0, function(val) {
	this._filterUpToDate = false;
	if (val > 255) return 255;
	else if (val < 0) return 0;
	else return Math.round(val);
});
Factory.addGetterSetter(Node$1, "green", 0, function(val) {
	this._filterUpToDate = false;
	if (val > 255) return 255;
	else if (val < 0) return 0;
	else return Math.round(val);
});
Factory.addGetterSetter(Node$1, "blue", 0, RGBComponent, Factory.afterSetFilter);
const RGBA = function(imageData) {
	const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha();
	for (let i = 0; i < nPixels; i += 4) {
		const ia = 1 - alpha;
		data[i] = red * alpha + data[i] * ia;
		data[i + 1] = green * alpha + data[i + 1] * ia;
		data[i + 2] = blue * alpha + data[i + 2] * ia;
	}
};
Factory.addGetterSetter(Node$1, "red", 0, function(val) {
	this._filterUpToDate = false;
	if (val > 255) return 255;
	else if (val < 0) return 0;
	else return Math.round(val);
});
Factory.addGetterSetter(Node$1, "green", 0, function(val) {
	this._filterUpToDate = false;
	if (val > 255) return 255;
	else if (val < 0) return 0;
	else return Math.round(val);
});
Factory.addGetterSetter(Node$1, "blue", 0, RGBComponent, Factory.afterSetFilter);
Factory.addGetterSetter(Node$1, "alpha", 1, function(val) {
	this._filterUpToDate = false;
	if (val > 1) return 1;
	else if (val < 0) return 0;
	else return val;
});
const Sepia = function(imageData) {
	const data = imageData.data, nPixels = data.length;
	for (let i = 0; i < nPixels; i += 4) {
		const r = data[i + 0];
		const g = data[i + 1];
		const b = data[i + 2];
		data[i + 0] = Math.min(255, r * .393 + g * .769 + b * .189);
		data[i + 1] = Math.min(255, r * .349 + g * .686 + b * .168);
		data[i + 2] = Math.min(255, r * .272 + g * .534 + b * .131);
	}
};
const Solarize = function(imageData) {
	const threshold = 128;
	const d = imageData.data;
	for (let i = 0; i < d.length; i += 4) {
		const r = d[i], g = d[i + 1], b = d[i + 2];
		if (.2126 * r + .7152 * g + .0722 * b >= threshold) {
			d[i] = 255 - r;
			d[i + 1] = 255 - g;
			d[i + 2] = 255 - b;
		}
	}
	return imageData;
};
const Threshold = function(imageData) {
	const level = this.threshold() * 255, data = imageData.data, len = data.length;
	for (let i = 0; i < len; i += 1) data[i] = data[i] < level ? 0 : 255;
};
Factory.addGetterSetter(Node$1, "threshold", .5, getNumberValidator(), Factory.afterSetFilter);
var lib_default = Konva$1.Util._assign(Konva$1, {
	Arc,
	Arrow,
	Circle,
	Ellipse,
	Image,
	Label,
	Tag,
	Line,
	Path,
	Rect,
	RegularPolygon,
	Ring,
	Sprite,
	Star,
	Text: Text$1,
	TextPath,
	Transformer,
	Wedge,
	Filters: {
		Blur,
		Brightness,
		Brighten,
		Contrast,
		Emboss,
		Enhance,
		Grayscale,
		HSL,
		HSV,
		Invert,
		Kaleidoscope,
		Mask,
		Noise,
		Pixelate,
		Posterize,
		RGB,
		RGBA,
		Sepia,
		Solarize,
		Threshold
	}
});
var VALID_MODES = ["dialog", "floating"];
var VALID_PLACEMENTS = [
	"top-right",
	"top-left",
	"bottom-right",
	"bottom-left",
	"top-center",
	"bottom-center"
];
function validateRequest(request) {
	if (!request || typeof request !== "object") throw new Error("SurfaceManager: request must be a non-null object.");
	if (!VALID_MODES.includes(request.mode)) throw new Error(`SurfaceManager: mode must be "dialog" or "floating", got "${request.mode}".`);
	const hasKind = "kind" in request && request.kind != null;
	const hasComponent = "component" in request && request.component != null;
	const hasRender = "render" in request && typeof request.render === "function";
	if (hasComponent && hasRender) throw new Error("SurfaceManager: request cannot provide both \"component\" and \"render\". Use one or the other.");
	if (!hasKind && !hasComponent && !hasRender) throw new Error("SurfaceManager: request must provide \"kind\" (intent-based) or \"component\"/\"render\" (direct-render).");
	if (request.mode === "floating" && request.floating?.placement != null) {
		if (!VALID_PLACEMENTS.includes(request.floating.placement)) throw new Error(`SurfaceManager: floating.placement must be one of ${VALID_PLACEMENTS.join(", ")}, got "${request.floating.placement}".`);
	}
}
var SurfaceManager = class {
	activeDialog = shallowRef(null);
	activeFloating = shallowRef(null);
	#destroyed = false;
	#nextId = 1;
	#getModuleConfig;
	constructor({ getModuleConfig }) {
		this.#getModuleConfig = getModuleConfig;
	}
	open(rawRequest) {
		if (this.#destroyed) return this.#createDestroyedHandle(rawRequest);
		validateRequest(rawRequest);
		const request = this.#normalizeRequest(rawRequest);
		const { component, props, render } = this.#resolveRendering(request);
		let settle;
		let settled = false;
		const result = new Promise((resolve) => {
			settle = (outcome) => {
				if (settled) return false;
				settled = true;
				resolve(outcome);
				return true;
			};
		});
		let surface;
		const resolveContent = (data) => {
			if (!settle({
				status: "submitted",
				data
			})) return;
			this.#clearSlot(surface);
		};
		const closeContent = (reason) => {
			if (!settle({
				status: "closed",
				reason
			})) return;
			this.#clearSlot(surface);
		};
		surface = {
			id: request.id,
			mode: request.mode,
			request,
			component,
			props,
			render,
			resolve: resolveContent,
			close: closeContent,
			settle: (outcome) => settle(outcome),
			get settled() {
				return settled;
			}
		};
		const slot = request.mode === "dialog" ? "activeDialog" : "activeFloating";
		const previous = this[slot].value;
		if (previous && !previous.settled) previous.settle({
			status: "replaced",
			replacedBy: request.id
		});
		this[slot].value = surface;
		return {
			id: request.id,
			mode: request.mode,
			close: (reason) => this.#closeSurface(surface, reason),
			result
		};
	}
	close(id, reason) {
		if (id != null) {
			const surface = this.#findById(id);
			if (surface) this.#closeSurface(surface, reason);
			return;
		}
		const dialog = this.activeDialog.value;
		if (dialog && !dialog.settled) {
			this.#closeSurface(dialog, reason);
			return;
		}
		const floating = this.activeFloating.value;
		if (floating && !floating.settled) this.#closeSurface(floating, reason);
	}
	settleAll(outcome) {
		for (const slot of [this.activeDialog, this.activeFloating]) {
			const surface = slot.value;
			if (surface && !surface.settled) surface.settle(outcome);
			slot.value = null;
		}
	}
	destroy() {
		this.#destroyed = true;
		this.settleAll({ status: "destroyed" });
	}
	#closeSurface(surface, reason) {
		if (surface.settled) return;
		surface.settle({
			status: "closed",
			reason
		});
		this.#clearSlot(surface);
	}
	#clearSlot(surface) {
		const slot = surface.mode === "dialog" ? this.activeDialog : this.activeFloating;
		if (slot.value === surface) slot.value = null;
	}
	#findById(id) {
		if (this.activeDialog.value?.id === id) return this.activeDialog.value;
		if (this.activeFloating.value?.id === id) return this.activeFloating.value;
		return null;
	}
	#normalizeRequest(raw) {
		const id = raw.id ?? `surface-${this.#nextId++}`;
		const moduleConfig = this.#getModuleConfig() ?? {};
		const modeDefaults = raw.mode === "dialog" ? moduleConfig.dialog : moduleConfig.floating;
		const normalizedDialog = raw.mode === "dialog" ? {
			maxWidth: modeDefaults?.maxWidth,
			...raw.dialog
		} : raw.dialog;
		const normalizedFloating = raw.mode === "floating" ? {
			placement: modeDefaults?.placement ?? "top-right",
			width: modeDefaults?.width,
			maxWidth: modeDefaults?.maxWidth,
			maxHeight: modeDefaults?.maxHeight,
			autoFocus: modeDefaults?.autoFocus ?? true,
			closeOnOutsidePointerDown: modeDefaults?.closeOnOutsidePointerDown ?? false,
			...raw.floating
		} : raw.floating;
		return {
			...raw,
			id,
			closeOnEscape: raw.closeOnEscape ?? modeDefaults?.closeOnEscape ?? true,
			closeOnBackdrop: raw.mode === "dialog" ? raw.closeOnBackdrop ?? modeDefaults?.closeOnBackdrop ?? true : false,
			dialog: normalizedDialog,
			floating: normalizedFloating
		};
	}
	#resolveRendering(request) {
		if ("component" in request && request.component != null) return {
			component: request.component,
			props: request.props
		};
		if ("render" in request && typeof request.render === "function") return { render: request.render };
		const resolver = this.#getModuleConfig()?.resolver;
		if (typeof resolver === "function") {
			const resolution = resolver(request);
			if (resolution != null) {
				if (resolution.type === "none") throw new Error(`SurfaceManager: resolver explicitly suppressed surface for kind "${request.kind}".`);
				if (resolution.type === "custom") return {
					component: resolution.component,
					props: resolution.props
				};
				if (resolution.type === "external") return { render: resolution.render };
			}
		}
		throw new Error(`SurfaceManager: no renderer resolved for kind "${request.kind}". Provide a resolver via modules.surfaces.resolver, or use a direct-render request.`);
	}
	#createDestroyedHandle(rawRequest) {
		return {
			id: rawRequest?.id ?? `surface-${this.#nextId++}`,
			mode: rawRequest?.mode ?? "dialog",
			close: () => {},
			result: Promise.resolve({ status: "destroyed" })
		};
	}
};
var MIGRATION_URL = "https://docs.superdoc.dev/guides/migration/document-api";
var _warned = /* @__PURE__ */ new Set();
function warnOnce$1(key, message) {
	if (_warned.has(key)) return;
	_warned.add(key);
	console.warn(message);
}
var DEPRECATED_PROPERTIES = {
	state: "editor.state",
	view: "editor.view",
	schema: "editor.schema",
	commands: "editor.commands",
	chain: "editor.chain()",
	can: "editor.can()",
	dispatch: "editor.dispatch()"
};
var RAW_EDITOR = Symbol.for("superdoc:rawEditor");
var _boundFns = /* @__PURE__ */ new WeakMap();
function createDeprecatedEditorProxy(editor) {
	if (!editor || editor[RAW_EDITOR]) return editor;
	return new Proxy(editor, { get(target, prop) {
		if (prop === RAW_EDITOR) return target;
		const deprecatedName = DEPRECATED_PROPERTIES[prop];
		if (deprecatedName) warnOnce$1(`deprecated:${String(prop)}`, `[SuperDoc] ${deprecatedName} is deprecated and will be removed in a future version. Use the Document API (editor.doc) instead. See ${MIGRATION_URL}`);
		const value = Reflect.get(target, prop, target);
		if (typeof value === "function") {
			let cache = _boundFns.get(target);
			if (!cache) {
				cache = /* @__PURE__ */ new Map();
				_boundFns.set(target, cache);
			}
			if (!cache.has(prop)) cache.set(prop, value.bind(target));
			return cache.get(prop);
		}
		return value;
	} });
}
var ALLOWED_MODES = [
	"review",
	"original",
	"final",
	"off"
];
var ALLOWED_REPLACEMENTS = ["paired", "independent"];
var NORMALIZED_MARKER = Symbol.for("@superdoc/trackChanges:normalized");
var warnedKeys = /* @__PURE__ */ new Set();
function warnOnce(legacyPath, newPath) {
	if (warnedKeys.has(legacyPath)) return;
	warnedKeys.add(legacyPath);
	console.warn(`[SuperDoc] ${legacyPath} is deprecated — use ${newPath} instead.`);
}
function resolveBool(newVal, legacyVal, fallback) {
	if (typeof newVal === "boolean") return newVal;
	if (typeof legacyVal === "boolean") return legacyVal;
	return fallback;
}
function resolveMode(newVal, legacyVal, fallback) {
	if (typeof newVal === "string" && ALLOWED_MODES.includes(newVal)) return newVal;
	if (typeof legacyVal === "string" && ALLOWED_MODES.includes(legacyVal)) return legacyVal;
	return fallback;
}
function coerceReplacements(value) {
	if (typeof value === "string" && ALLOWED_REPLACEMENTS.includes(value)) return value;
	return null;
}
function pickObject(value) {
	if (!value || typeof value !== "object" || Array.isArray(value)) return null;
	return value;
}
function normalizeTrackChangesConfig(config) {
	const alreadyNormalized = config[NORMALIZED_MARKER] === true;
	if (!pickObject(config.modules)) config.modules = {};
	const fromCanonical = pickObject(config.modules.trackChanges);
	const fromLegacyVisible = pickObject(config.trackChanges);
	const fromLegacyLayout = pickObject(config.layoutEngineOptions?.trackedChanges);
	if (!alreadyNormalized) {
		if (fromLegacyVisible) warnOnce("config.trackChanges", "config.modules.trackChanges");
		if (fromLegacyLayout) warnOnce("config.layoutEngineOptions.trackedChanges", "config.modules.trackChanges");
	}
	const visible = resolveBool(fromCanonical?.visible, fromLegacyVisible?.visible, false);
	const enabled = resolveBool(fromCanonical?.enabled, fromLegacyLayout?.enabled, true);
	const replacements = coerceReplacements(fromCanonical?.replacements) ?? "paired";
	const authorColors = pickObject(fromCanonical?.authorColors) ? fromCanonical.authorColors : void 0;
	const defaultMode = config.documentMode === "viewing" ? visible ? "review" : "original" : "review";
	const mode = resolveMode(fromCanonical?.mode, fromLegacyLayout?.mode, defaultMode);
	const normalized = {
		visible,
		mode,
		enabled,
		replacements
	};
	if (authorColors) normalized.authorColors = authorColors;
	config.modules.trackChanges = normalized;
	config.trackChanges = { visible };
	if (!pickObject(config.layoutEngineOptions)) config.layoutEngineOptions = {};
	config.layoutEngineOptions.trackedChanges = {
		mode,
		enabled
	};
	Object.defineProperty(config, NORMALIZED_MARKER, {
		value: true,
		writable: true,
		configurable: true,
		enumerable: false
	});
	return normalized;
}
var EditorRuntimeRegistry = class {
	#runtimes = /* @__PURE__ */ new Map();
	#rootToId = /* @__PURE__ */ new Map();
	#activeId = null;
	#listeners = /* @__PURE__ */ new Set();
	register(runtime) {
		if (this.#runtimes.has(runtime.id)) throw new Error(`EditorRuntimeRegistry: duplicate runtime id "${runtime.id}"`);
		const root = runtime.root;
		const existingForRoot = root ? this.#rootToId.get(root) : void 0;
		if (existingForRoot !== void 0 && existingForRoot !== runtime.id) throw new Error(`EditorRuntimeRegistry: root element already registered to runtime "${existingForRoot}"`);
		this.#runtimes.set(runtime.id, runtime);
		if (root) this.#rootToId.set(root, runtime.id);
	}
	unregister(runtimeId) {
		const runtime = this.#runtimes.get(runtimeId);
		if (!runtime) return false;
		this.#runtimes.delete(runtimeId);
		if (runtime.root) this.#rootToId.delete(runtime.root);
		if (this.#activeId === runtimeId) {
			this.#activeId = null;
			this.#emit({
				previousRuntimeId: runtimeId,
				nextRuntimeId: null,
				reason: "active-runtime-unregistered",
				legacyEditorProjection: null
			});
		}
		return true;
	}
	get(runtimeId) {
		return this.#runtimes.get(runtimeId) ?? null;
	}
	getAll() {
		return Array.from(this.#runtimes.values());
	}
	getAllByDocumentId(documentId) {
		const matches = [];
		for (const runtime of this.#runtimes.values()) if (runtime.documentId === documentId) matches.push(runtime);
		return matches;
	}
	getActive() {
		if (this.#activeId === null) return null;
		return this.#runtimes.get(this.#activeId);
	}
	getActiveId() {
		return this.#activeId;
	}
	setActive(runtimeId, reason) {
		if (runtimeId !== null && !this.#runtimes.has(runtimeId)) throw new Error(`EditorRuntimeRegistry: cannot activate unknown runtime "${runtimeId}"`);
		if (runtimeId === this.#activeId) return;
		const previousRuntimeId = this.#activeId;
		this.#activeId = runtimeId;
		let legacyEditorProjection = null;
		if (runtimeId !== null) legacyEditorProjection = this.#runtimes.get(runtimeId).getLegacyEditorProjection?.() ?? null;
		this.#emit({
			previousRuntimeId,
			nextRuntimeId: runtimeId,
			reason,
			legacyEditorProjection
		});
	}
	resolveFromEventTarget(target) {
		const element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
		if (!element) return null;
		const host = element.closest(`[${RUNTIME_ROOT_ATTRIBUTE}]`);
		if (!host) return null;
		const id = host.getAttribute(RUNTIME_ROOT_ATTRIBUTE);
		const runtime = id ? this.get(id) : null;
		if (!runtime) return null;
		return runtime.root === host ? runtime : null;
	}
	subscribe(listener) {
		this.#listeners.add(listener);
		return () => {
			this.#listeners.delete(listener);
		};
	}
	clear() {
		this.#runtimes.clear();
		this.#rootToId.clear();
		this.#activeId = null;
		this.#listeners.clear();
	}
	#emit(change) {
		for (const listener of Array.from(this.#listeners)) try {
			listener(change);
		} catch {}
	}
};
var DEFAULT_USER = Object.freeze({
	id: null,
	name: "Default SuperDoc user",
	email: null
});
var DEFAULT_AWARENESS_PALETTE = Object.freeze([
	"#FF6B6B",
	"#4ECDC4",
	"#45B7D1",
	"#FFA07A",
	"#98D8C8",
	"#F7DC6F",
	"#BB8FCE",
	"#85C1E2",
	"#F1948A",
	"#82E0AA",
	"#F8C471",
	"#AED6F1",
	"#D7BDE2",
	"#A3E4D7",
	"#F0B27A",
	"#AEB6BF",
	"#E74C3C",
	"#2ECC71",
	"#3498DB",
	"#E67E22",
	"#1ABC9C",
	"#9B59B6",
	"#34495E",
	"#F39C12"
]);
function isCommandCapableV1LegacyProjection(projection) {
	if (!projection || typeof projection !== "object") return false;
	const candidate = projection;
	if (candidate.editorVersion === 2) return false;
	return Boolean(candidate.commands) && typeof candidate.commands === "object";
}
var SuperDoc = class extends import_eventemitter3.default {
	static {
		this.allowedTypes = [
			DOCX,
			PDF,
			HTML
		];
	}
	#destroyed = false;
	#isUpgrading = false;
	#abortUpgrade = null;
	#mountWrapper = null;
	#surfaceManager;
	#editorRuntimeRegistry = new EditorRuntimeRegistry();
	#editorRuntimeRegistryUnsub = null;
	#applyingRuntimeActiveChange = false;
	constructor(config) {
		super();
		this.version = "0.0.0";
		this.users = [];
		this.whiteboard = null;
		this.colors = [];
		this.readyEditors = 0;
		this.pendingCollaborationSaves = 0;
		this.config = {
			selector: "#superdoc",
			documentMode: "editing",
			allowSelectionInViewMode: false,
			role: "editor",
			document: {},
			documents: [],
			editorExtensions: [],
			colors: [],
			users: [],
			user: { ...DEFAULT_USER },
			layoutEngineOptions: {},
			modules: {},
			licenseKey: void 0,
			telemetry: { enabled: true },
			title: "SuperDoc",
			conversations: [],
			isInternal: false,
			comments: { visible: false },
			toolbarGroups: [
				"left",
				"center",
				"right"
			],
			toolbarIcons: {},
			toolbarTexts: {},
			uiDisplayFallbackFont: "Arial, Helvetica, sans-serif",
			isDev: false,
			disablePiniaDevtools: false,
			onEditorBeforeCreate: () => null,
			onEditorCreate: () => null,
			onEditorDestroy: () => null,
			onContentError: () => null,
			onReady: () => null,
			onCommentsUpdate: () => null,
			onContentControlActiveChange: () => null,
			onContentControlClick: () => null,
			onAwarenessUpdate: () => null,
			onLocked: () => null,
			onPdfDocumentReady: () => null,
			onSidebarToggle: () => null,
			onCollaborationReady: () => null,
			onEditorUpdate: () => null,
			onCommentsListChange: () => null,
			onException: () => null,
			onListDefinitionsChange: () => null,
			onPaginationUpdate: () => null,
			onTransaction: () => null,
			disableContextMenu: false,
			viewOptions: { layout: "print" },
			useLayoutEngine: true
		};
		if (!config.selector) throw new Error("SuperDoc: selector is required");
		const container = typeof config.selector === "string" ? document.querySelector(config.selector) : config.selector;
		if (!(container instanceof HTMLElement)) throw new Error("SuperDoc: selector must be a valid CSS selector string or DOM element");
		this.#surfaceManager = new SurfaceManager({ getModuleConfig: () => this.config.modules?.surfaces });
		this.#init(config, container);
	}
	async #init(config, container) {
		this.config = {
			...this.config,
			...config
		};
		if (!this.config.comments || typeof this.config.comments !== "object") this.config.comments = { visible: false };
		else if (typeof this.config.comments.visible !== "boolean") this.config.comments.visible = false;
		normalizeTrackChangesConfig(this.config);
		this.config.documents = this.config.documents || [];
		this.config.layoutEngineOptions = this.config.layoutEngineOptions || {};
		const isWebLayout = this.config.viewOptions?.layout === "web";
		const isSemanticFlow = this.config.layoutEngineOptions?.flowMode === "semantic";
		if (isWebLayout && this.config.useLayoutEngine && !isSemanticFlow) {
			console.warn("[SuperDoc] Web layout uses PM fallback unless layoutEngineOptions.flowMode is set to 'semantic'. Automatically disabling layout engine.");
			this.config.useLayoutEngine = false;
		}
		if (!isWebLayout && isSemanticFlow) {
			console.warn("[SuperDoc] flowMode 'semantic' is only valid with web layout. Coercing to 'paginated'.");
			this.config.layoutEngineOptions.flowMode = "paginated";
		}
		const incomingUser = this.config.user;
		if (!incomingUser || typeof incomingUser !== "object") this.config.user = { ...DEFAULT_USER };
		else {
			this.config.user = {
				...DEFAULT_USER,
				...incomingUser
			};
			if (!this.config.user.name) this.config.user.name = DEFAULT_USER.name;
		}
		if (!this.config.layoutEngineOptions.virtualization) this.config.layoutEngineOptions.virtualization = {
			enabled: true,
			window: 5,
			overscan: 1
		};
		this.config.modules = this.config.modules || {};
		if (!Object.prototype.hasOwnProperty.call(this.config.modules, "comments")) this.config.modules.comments = {};
		this.config.modules.comments = normalizeCommentsUiPolicy(this.config.modules.comments);
		this.config.colors = shuffleArray(this.config.colors);
		this.userColorMap = /* @__PURE__ */ new Map();
		this.colorIndex = 0;
		this.version = "1.40.0";
		this.#log("🦋 [superdoc] Using SuperDoc version:", this.version);
		this.superdocId = config.superdocId || v4_default();
		this.colors = this.config.colors ?? [];
		this.#initDocuments();
		await this.#initCollaboration(this.config.modules);
		if (this.#destroyed) {
			this.#cleanupCollaboration();
			return;
		}
		if (this.config.cspNonce) this.#patchNaiveUIStyles();
		this.user = this.config.user;
		this.users = this.config.users || [];
		this.socket = null;
		this.isDev = this.config.isDev || false;
		this.activeEditor = null;
		this.comments = [];
		if (!this.#editorRuntimeRegistryUnsub) this.#editorRuntimeRegistryUnsub = this.#editorRuntimeRegistry.subscribe((change) => {
			this.#applyActiveRuntimeChange(change.nextRuntimeId, change.legacyEditorProjection);
		});
		this.isLocked = this.config.isLocked || false;
		this.lockedBy = this.config.lockedBy || null;
		const mountWrapper = document.createElement("div");
		mountWrapper.style.display = "contents";
		container.appendChild(mountWrapper);
		this.#mountWrapper = mountWrapper;
		this.#initListeners();
		this.#initWhiteboard();
		this.#addToolbar();
		this.#startRuntime();
	}
	#startRuntime() {
		this.#initVueApp();
		this.readyEditors = 0;
		if (!this.app) throw new Error("SuperDoc: #startRuntime called before #initVueApp populated this.app");
		this.app.mount(this.#mountWrapper);
	}
	#initWhiteboard() {
		const config = this.config.modules?.whiteboard;
		const enabled = config !== false && (config?.enabled ?? false);
		this.whiteboard = new Whiteboard({
			Renderer: lib_default,
			superdoc: this,
			enabled
		});
		this.emit("whiteboard:init", { whiteboard: this.whiteboard });
	}
	get requiredNumberOfEditors() {
		return this.#requireSuperdocStore("requiredNumberOfEditors").documents.filter((d) => d.type === DOCX).length;
	}
	get state() {
		return {
			documents: this.#requireSuperdocStore("state").documents,
			users: this.users
		};
	}
	getPresentationEditorForDocument(documentId) {
		if (typeof documentId !== "string" || documentId.length === 0) return null;
		return (this.superdocStore?.documents ?? []).find((doc) => doc?.getEditor?.()?.options?.documentId === documentId)?.getPresentationEditor?.() ?? null;
	}
	getComment(commentId) {
		if (typeof commentId !== "string" || commentId.length === 0) return null;
		return this.commentsStore?.getComment?.(commentId) ?? null;
	}
	get element() {
		if (typeof this.config.selector === "string") return document.querySelector(this.config.selector);
		return this.config.selector;
	}
	#patchNaiveUIStyles() {
		const cspNonce = this.config.cspNonce;
		const originalCreateElement = document.createElement;
		document.createElement = function(tagName) {
			const element = originalCreateElement.call(this, tagName);
			if (tagName.toLowerCase() === "style") element.setAttribute("nonce", cspNonce);
			return element;
		};
	}
	#initDocuments() {
		const doc = this.config.document;
		const hasDocumentConfig = !!doc && typeof doc === "object" && Object.keys(doc)?.length;
		const hasDocumentUrl = !!doc && typeof doc === "string" && doc.length > 0;
		const hasDocumentFile = !!doc && typeof File === "function" && doc instanceof File;
		const hasDocumentBlob = !!doc && doc instanceof Blob && !(doc instanceof File);
		const hasListOfDocuments = this.config.documents && this.config.documents?.length;
		if (hasDocumentConfig && hasListOfDocuments) console.warn("🦋 [superdoc] You can only provide one of document or documents");
		if (hasDocumentConfig) {
			const normalized = normalizeDocumentEntry(this.config.document);
			this.config.documents = [{
				id: v4_default(),
				...normalized
			}];
		} else if (hasDocumentUrl) this.config.documents = [{
			id: v4_default(),
			type: DOCX,
			url: this.config.document,
			name: "document.docx"
		}];
		else if (hasDocumentFile) {
			const normalized = normalizeDocumentEntry(this.config.document);
			this.config.documents = [{
				id: v4_default(),
				...normalized
			}];
		} else if (hasDocumentBlob) {
			const normalized = normalizeDocumentEntry(this.config.document);
			this.config.documents = [{
				id: v4_default(),
				...normalized
			}];
		}
		if (Array.isArray(this.config.documents) && this.config.documents.length > 0) this.config.documents = this.config.documents.map((d) => {
			const normalized = normalizeDocumentEntry(d);
			if (!normalized || typeof normalized !== "object") return normalized;
			const existingId = typeof normalized === "object" && "id" in normalized && normalized.id || d && typeof d === "object" && "id" in d && d.id;
			return {
				...normalized,
				id: existingId || v4_default()
			};
		});
	}
	#initVueApp() {
		const { app, pinia, superdocStore, commentsStore, highContrastModeStore } = createSuperdocVueApp({ disablePiniaDevtools: Boolean(this.config.disablePiniaDevtools) });
		this.app = app;
		this.pinia = pinia;
		this.app.config.globalProperties.$config = this.config;
		this.app.config.globalProperties.$documentMode = this.config.documentMode;
		this.app.config.globalProperties.$superdoc = this;
		this.app.provide("surfaceManager", this.#surfaceManager);
		this.superdocStore = superdocStore;
		this.commentsStore = commentsStore;
		this.highContrastModeStore = highContrastModeStore;
		if (typeof this.superdocStore.setExceptionHandler === "function") this.superdocStore.setExceptionHandler((payload) => this.emit("exception", payload));
		this.superdocStore.init(this.config);
		const commentsModuleConfig = this.config.modules.comments;
		this.commentsStore.init(commentsModuleConfig || {});
		if (this.isCollaborative) initCollaborationComments(this);
		this.#syncViewingVisibility();
	}
	#onConfig(event, listener) {
		if (listener) this.on(event, listener);
	}
	#initListeners() {
		this.#onConfig("editorBeforeCreate", this.config.onEditorBeforeCreate);
		this.#onConfig("editorCreate", this.config.onEditorCreate);
		this.#onConfig("editorDestroy", this.config.onEditorDestroy);
		this.#onConfig("ready", this.config.onReady);
		this.#onConfig("comments-update", this.config.onCommentsUpdate);
		this.#onConfig("content-control:active-change", this.config.onContentControlActiveChange);
		this.#onConfig("content-control:click", this.config.onContentControlClick);
		this.#onConfig("awareness-update", this.config.onAwarenessUpdate);
		this.#onConfig("locked", this.config.onLocked);
		this.#onConfig("pdf:document-ready", this.config.onPdfDocumentReady);
		this.#onConfig("sidebar-toggle", this.config.onSidebarToggle);
		this.#onConfig("collaboration-ready", this.config.onCollaborationReady);
		this.#onConfig("editor-update", this.config.onEditorUpdate);
		this.on("content-error", this.onContentError);
		this.#onConfig("exception", this.config.onException);
		this.#onConfig("list-definitions-change", this.config.onListDefinitionsChange);
		this.#onConfig("pagination-update", this.config.onPaginationUpdate);
		this.#onConfig("fonts-resolved", this.config.onFontsResolved);
		this.#onConfig("fonts-changed", this.config.onFontsChanged);
		this.#onConfig("zoomChange", this.config.onZoomChange);
		this.#onConfig("viewport-change", this.config.onViewportChange);
	}
	async #initCollaboration({ collaboration: collaborationModuleConfig, comments: commentsConfig = {} } = {}) {
		if (!collaborationModuleConfig) return this.config.documents;
		const { ydoc: externalYdoc, provider: externalProvider } = collaborationModuleConfig;
		if (externalYdoc && externalProvider) {
			if (!this.config.documents || this.config.documents.length === 0) this.config.documents = [{
				id: v4_default(),
				type: DOCX,
				name: "document.docx"
			}];
			this.#attachExternalCollaboration(externalYdoc, externalProvider);
			initCollaborationComments(this);
			return this.config.documents;
		}
		this.isCollaborative = true;
		if (collaborationModuleConfig.providerType === "hocuspocus") this.config.socket = new HocuspocusProviderWebsocket({ url: collaborationModuleConfig.url });
		const processedDocuments = makeDocumentsCollaborative(this);
		if (commentsConfig && commentsConfig.useInternalExternalComments && !commentsConfig.suppressInternalExternalComments) {
			const sdResult = initSuperdocYdoc(this);
			if (!sdResult) throw new Error("SuperDoc: `modules.comments.useInternalExternalComments` requires `superdocId` to be set in the config.");
			this.ydoc = markRaw(sdResult.ydoc);
			this.provider = markRaw(sdResult.provider);
		} else {
			this.ydoc = markRaw(processedDocuments[0].ydoc);
			this.provider = markRaw(processedDocuments[0].provider);
		}
		initCollaborationComments(this);
		return processedDocuments;
	}
	#attachExternalCollaboration(ydoc, provider) {
		this.isCollaborative = true;
		this._commentsCollabInitialized = false;
		this.ydoc = markRaw(ydoc);
		this.provider = markRaw(provider);
		this.#assignUserColor();
		const internalConfig = this.config;
		this._cleanupAwareness = setupAwarenessHandler(provider, this, internalConfig.user);
		internalConfig.documents.forEach((doc) => {
			doc.ydoc = ydoc;
			doc.provider = provider;
			doc.role = this.config.role;
		});
	}
	#detachCollaboration() {
		if (typeof this._cleanupAwareness === "function") {
			this._cleanupAwareness();
			this._cleanupAwareness = null;
		}
		this.isCollaborative = false;
		this._commentsCollabInitialized = false;
		this.ydoc = void 0;
		this.provider = void 0;
		const cfg = this.config;
		delete cfg.modules.collaboration;
		cfg.documents.forEach((doc) => {
			delete doc.ydoc;
			delete doc.provider;
		});
	}
	#assignUserColor() {
		const user = this.config.user;
		if (!user || user.color) return;
		const palette = this.colors.length > 0 ? this.colors : DEFAULT_AWARENESS_PALETTE;
		const userKey = user.id || user.email || user.name || "";
		let hash = 5381;
		for (let i = 0; i < userKey.length; i++) hash = (hash << 5) + hash ^ userKey.charCodeAt(i);
		user.color = palette[Math.abs(hash) % palette.length];
	}
	async upgradeToCollaboration({ ydoc, provider }) {
		this.#validateUpgradePrerequisites({
			ydoc,
			provider
		});
		this.#isUpgrading = true;
		try {
			const sourceEditor = this.#resolveSourceEditor();
			await this.#waitForProviderSync(provider);
			this.#assertNotDestroyed();
			seedEditorStateToYDoc(sourceEditor, ydoc);
			overwriteRoomComments(ydoc, this.#requireCommentsStore("upgradeToCollaboration").commentsList);
			overwriteRoomLockState(ydoc, {
				isLocked: this.isLocked ?? false,
				lockedBy: this.lockedBy ?? null
			});
			this.config.modules.collaboration = {
				ydoc,
				provider
			};
			this.#attachExternalCollaboration(ydoc, provider);
			this.#setStoreDocumentCollaboration(ydoc, provider);
			const editorInstance = this.#resolveUpgradeTarget();
			try {
				editorInstance.attachCollaboration({
					ydoc,
					collaborationProvider: provider
				});
			} catch (attachError) {
				this.#rollbackCollaborationAttach();
				throw attachError;
			}
			await this.#waitForCollaborationReady(editorInstance);
			if (this.#destroyed) return;
			initCollaborationComments(this);
		} finally {
			this.#abortUpgrade = null;
			this.#isUpgrading = false;
		}
	}
	#assertNotDestroyed() {
		if (this.#destroyed) throw new Error("SuperDoc: instance was destroyed during upgrade");
	}
	#requireSuperdocStore(methodName) {
		if (!this.superdocStore) throw new Error(`SuperDoc: ${methodName} requires the instance to be ready; wait for the "ready" event before calling.`);
		return this.superdocStore;
	}
	#requireCommentsStore(methodName) {
		if (!this.commentsStore) throw new Error(`SuperDoc: ${methodName} requires the instance to be ready; wait for the "ready" event before calling.`);
		return this.commentsStore;
	}
	#requireReady(methodName) {
		if (!this.superdocStore) throw new Error(`SuperDoc: ${methodName} requires the instance to be ready; wait for the "ready" event before calling.`);
	}
	#setStoreDocumentCollaboration(ydoc, provider) {
		const storeDocs = this.superdocStore?.documents;
		if (!Array.isArray(storeDocs)) return;
		for (const doc of storeDocs) {
			const raw = toRaw(doc);
			if (raw.ydoc && typeof raw.ydoc === "object" && "value" in raw.ydoc) raw.ydoc.value = ydoc;
			if (raw.provider && typeof raw.provider === "object" && "value" in raw.provider) raw.provider.value = provider;
		}
	}
	#resolveUpgradeTarget() {
		const storeDocs = this.superdocStore?.documents;
		if (!storeDocs?.length) throw new Error("SuperDoc: no store documents available for upgrade");
		const target = storeDocs[0].getPresentationEditor?.() || storeDocs[0].getEditor?.();
		if (!target?.attachCollaboration) throw new Error("SuperDoc: editor does not support attachCollaboration");
		return target;
	}
	#rollbackCollaborationAttach() {
		this.#detachCollaboration();
		this.#setStoreDocumentCollaboration(null, null);
	}
	#waitForCollaborationReady(editorInstance) {
		const TIMEOUT_MS = 1e4;
		const editor = editorInstance.editor ?? editorInstance;
		if (editor.options?.collaborationIsReady) return Promise.resolve();
		return new Promise((resolve) => {
			let settled = false;
			const cleanup = () => {
				if (settled) return;
				settled = true;
				clearTimeout(timer);
				if (typeof editor.off === "function") editor.off("collaborationReady", onReady);
			};
			const timer = setTimeout(() => {
				cleanup();
				console.warn("[SuperDoc] collaborationReady did not fire within 10 s after collaboration attach. Continuing — collaboration is active but cursor/presence setup may be delayed.");
				resolve(void 0);
			}, TIMEOUT_MS);
			const onReady = () => {
				cleanup();
				resolve(void 0);
			};
			this.#abortUpgrade = () => {
				cleanup();
				resolve(void 0);
			};
			if (typeof editor.on === "function") editor.on("collaborationReady", onReady);
			else {
				cleanup();
				resolve(void 0);
			}
		});
	}
	#waitForProviderSync(provider) {
		const SYNC_TIMEOUT_MS = 1e4;
		return new Promise((resolve, reject) => {
			let timer;
			let settled = false;
			let syncCleanup = () => {};
			const settle = () => {
				settled = true;
				clearTimeout(timer);
				syncCleanup();
			};
			syncCleanup = onCollaborationProviderSynced(provider, () => {
				if (settled) return;
				settle();
				resolve();
			});
			if (!settled) timer = setTimeout(() => {
				settle();
				reject(/* @__PURE__ */ new Error(`SuperDoc: collaboration provider did not sync within ${SYNC_TIMEOUT_MS} ms. The provider exposes on/off but never emitted sync(true) or synced.`));
			}, SYNC_TIMEOUT_MS);
			this.#abortUpgrade = () => {
				if (settled) return;
				settle();
				reject(/* @__PURE__ */ new Error("SuperDoc: instance was destroyed during upgrade"));
			};
		});
	}
	#validateUpgradePrerequisites({ ydoc, provider }) {
		if (this.#destroyed) throw new Error("SuperDoc: cannot upgrade a destroyed instance");
		if (this.#isUpgrading) throw new Error("SuperDoc: upgrade already in progress");
		if (this.isCollaborative) throw new Error("SuperDoc: instance is already collaborative");
		if (!ydoc || !provider) throw new Error("SuperDoc: upgradeToCollaboration() requires both ydoc and provider");
		const cfg = this.config;
		const docxDocs = cfg.documents.filter((d) => d.type === DOCX);
		if (docxDocs.length === 0) throw new Error("SuperDoc: no DOCX document found for upgrade");
		if (docxDocs.length > 1) throw new Error("SuperDoc: upgradeToCollaboration() only supports a single DOCX document");
		if (cfg.documents.length !== docxDocs.length) throw new Error("SuperDoc: upgradeToCollaboration() only supports single-DOCX instances");
	}
	#resolveSourceEditor() {
		const docxDoc = this.config.documents.find((d) => d.type === DOCX);
		const editor = this.#requireSuperdocStore("upgradeToCollaboration").documents.find((d) => d.id === docxDoc.id)?.getEditor?.();
		if (!editor) throw new Error("SuperDoc: source editor not yet created — wait for the ready event before upgrading");
		return editor;
	}
	addSharedUser(user) {
		this.#requireReady("addSharedUser");
		const userKey = getActorIdentityKey({ actor: user });
		if (userKey && this.users.some((u) => getActorIdentityKey({ actor: u }) === userKey)) return;
		this.users.push(user);
	}
	removeSharedUser(userOrEmail) {
		this.#requireReady("removeSharedUser");
		const legacyEmail = typeof userOrEmail === "string" ? normalizeActorEmail(userOrEmail) : "";
		const targetKey = typeof userOrEmail === "string" ? `email:${legacyEmail}` : getActorIdentityKey({ actor: userOrEmail });
		this.users = this.users.filter((u) => {
			const existingKey = getActorIdentityKey({ actor: u });
			if (targetKey) return existingKey !== targetKey;
			if (legacyEmail) return normalizeActorEmail(u.email) !== legacyEmail;
			return true;
		});
	}
	onContentError({ error, editor }) {
		const { documentId } = editor.options;
		const doc = this.#requireSuperdocStore("onContentError").documents.find((d) => d.id === documentId);
		this.config.onContentError?.({
			error,
			editor,
			documentId: doc.id,
			file: doc.data
		});
	}
	broadcastPdfDocumentReady() {
		this.emit("pdf:document-ready");
	}
	broadcastReady() {
		if (this.readyEditors === this.requiredNumberOfEditors) this.emit("ready", { superdoc: this });
	}
	broadcastEditorBeforeCreate(editor) {
		this.emit("editorBeforeCreate", { editor: createDeprecatedEditorProxy(editor) });
	}
	broadcastEditorCreate(editor) {
		this.readyEditors++;
		this.broadcastReady();
		this.#wireFontsChangedRelay(editor);
		this.emit("editorCreate", { editor: createDeprecatedEditorProxy(editor) });
	}
	#fontsRelayEditors = /* @__PURE__ */ new WeakSet();
	#wireFontsChangedRelay(editor) {
		if (!editor || typeof editor.on !== "function") return;
		if (this.#fontsRelayEditors.has(editor)) return;
		this.#fontsRelayEditors.add(editor);
		editor.on("fonts-changed", (payload) => {
			if (this.#fontReportSurfaces(editor)) this.#deliverFontsChanged(payload);
		});
		const cached = editor.presentationEditor?.getLastFontsChangedPayload?.();
		if (cached && this.#fontReportSurfaces(editor)) this.#deliverFontsChanged(cached);
	}
	#fontReportSurfaces(editor) {
		return !this.activeEditor || editor === this.activeEditor;
	}
	#lastFontsChangedPayload = null;
	#deliverFontsChanged(payload) {
		this.#lastFontsChangedPayload = payload;
		this.emit("fonts-changed", payload);
	}
	broadcastEditorDestroy() {
		this.emit("editorDestroy");
	}
	broadcastSidebarToggle(isOpened) {
		this.emit("sidebar-toggle", isOpened);
	}
	#log(...args) {
		(console.debug ? console.debug : console.log)("🦋 🦸‍♀️ [superdoc]", ...args);
	}
	#fontsApi = null;
	get fonts() {
		if (!this.#fontsApi) this.#fontsApi = {
			getReport: () => this.activeEditor?.presentationEditor?.getFontReport() ?? [],
			getMissingFonts: () => this.activeEditor?.presentationEditor?.getMissingFonts() ?? [],
			getDocumentFontOptions: () => this.activeEditor?.presentationEditor?.getDocumentFontOptions() ?? [],
			getDocumentFonts: () => [...new Set((this.activeEditor?.presentationEditor?.getFontReport() ?? []).map((record) => record.logicalFamily))],
			onReport: (callback) => {
				const activeEditor = this.activeEditor;
				const current = activeEditor ? activeEditor.presentationEditor?.getLastFontsChangedPayload?.() ?? null : this.#lastFontsChangedPayload ?? null;
				if (current) callback(current);
				this.on("fonts-changed", callback);
				return () => this.off("fonts-changed", callback);
			},
			map: (mappings) => {
				const pe = this.activeEditor?.presentationEditor;
				if (!pe) throw new Error("superdoc.fonts.map requires an active editor");
				pe.mapFonts(mappings);
			},
			unmap: (families) => {
				const pe = this.activeEditor?.presentationEditor;
				if (!pe) throw new Error("superdoc.fonts.unmap requires an active editor");
				pe.unmapFonts(families);
			},
			add: (families) => {
				const pe = this.activeEditor?.presentationEditor;
				if (!pe) throw new Error("superdoc.fonts.add requires an active editor");
				pe.addFonts(Array.isArray(families) ? families : [families]);
			},
			preload: (families) => {
				const pe = this.activeEditor?.presentationEditor;
				if (!pe) throw new Error("superdoc.fonts.preload requires an active editor");
				return pe.preloadFonts(families);
			}
		};
		return this.#fontsApi;
	}
	#clearActiveEditorProjection() {
		this.activeEditor = null;
		if (this.toolbar?.setActiveEditor) this.toolbar.setActiveEditor(null);
		else if (this.toolbar) this.toolbar.activeEditor = null;
	}
	#applyActiveEditorProjection(editor) {
		this.activeEditor = editor;
		if (editor?.editorVersion === 2) return;
		if (this.toolbar) {
			this.activeEditor.toolbar = this.toolbar;
			this.toolbar.setActiveEditor(editor);
		}
	}
	#applyActiveRuntimeChange(nextRuntimeId, projection) {
		this.#applyingRuntimeActiveChange = true;
		try {
			if (nextRuntimeId === null) {
				this.#clearActiveEditorProjection();
				return;
			}
			if (this.#editorRuntimeRegistry.get(nextRuntimeId)?.kind === "v1" && isCommandCapableV1LegacyProjection(projection)) this.setActiveEditor(projection);
			else this.#clearActiveEditorProjection();
		} finally {
			this.#applyingRuntimeActiveChange = false;
		}
	}
	#resolveRuntimeIdForEditor(editor) {
		if (!editor) return null;
		for (const runtime of this.#editorRuntimeRegistry.getAll()) {
			if (runtime.kind !== "v1") continue;
			if (runtime.getLegacyEditorProjection?.() === editor) return runtime.id;
		}
		const documentId = editor.options?.documentId;
		if (typeof documentId === "string" && documentId.length > 0) {
			const matches = this.#editorRuntimeRegistry.getAllByDocumentId(documentId).filter((runtime) => runtime.kind === "v1");
			if (matches.length === 1) return matches[0].id;
		}
		return null;
	}
	setActiveEditor(editor) {
		if (!isCommandCapableV1LegacyProjection(editor)) {
			this.#clearActiveEditorProjection();
			return;
		}
		if (!this.#applyingRuntimeActiveChange) {
			const runtimeId = this.#resolveRuntimeIdForEditor(editor);
			if (runtimeId !== null) {
				const wasAlreadyActive = this.#editorRuntimeRegistry.getActive()?.id === runtimeId;
				this.#editorRuntimeRegistry.setActive(runtimeId, "set-active-editor");
				if (wasAlreadyActive) {
					const projection = this.#editorRuntimeRegistry.get(runtimeId)?.getLegacyEditorProjection?.() ?? null;
					if (isCommandCapableV1LegacyProjection(projection)) this.#applyActiveEditorProjection(projection);
					else this.#clearActiveEditorProjection();
				}
				return;
			}
		}
		this.#applyActiveEditorProjection(editor);
	}
	registerEditorRuntime(runtime) {
		this.#editorRuntimeRegistry.register(runtime);
	}
	unregisterEditorRuntime(runtimeId) {
		return this.#editorRuntimeRegistry.unregister(runtimeId);
	}
	getActiveRuntime() {
		return this.#editorRuntimeRegistry.getActive();
	}
	setActiveRuntime(runtimeId, reason) {
		this.#editorRuntimeRegistry.setActive(runtimeId, reason);
	}
	resolveRuntimeFromEventTarget(target) {
		return this.#editorRuntimeRegistry.resolveFromEventTarget(target);
	}
	activateRuntimeFromEventTarget(target, reason) {
		const runtime = this.#editorRuntimeRegistry.resolveFromEventTarget(target);
		if (!runtime) return false;
		this.#editorRuntimeRegistry.setActive(runtime.id, reason);
		return true;
	}
	toggleRuler() {
		const store = this.#requireSuperdocStore("toggleRuler");
		this.config.rulers = !this.config.rulers;
		store.documents.forEach((doc) => {
			doc.rulers = this.config.rulers;
		});
	}
	canPerformPermission({ permission, role = this.config.role, isInternal = this.config.isInternal, comment = null, trackedChange = null } = {}) {
		if (!permission) return false;
		let resolvedComment = comment ?? trackedChange?.comment ?? null;
		const commentId = trackedChange?.commentId || trackedChange?.id;
		if (!resolvedComment && commentId && this.commentsStore?.getComment) {
			const storeComment = this.commentsStore.getComment(commentId);
			const getValues = storeComment?.getValues;
			resolvedComment = typeof getValues === "function" ? getValues.call(storeComment) : storeComment;
		}
		return isAllowed(permission, role, isInternal, {
			superdoc: this,
			currentUser: this.config.user,
			comment: resolvedComment ?? null,
			trackedChange: trackedChange ?? null
		});
	}
	#addToolbar() {
		const moduleConfig = this.config.modules?.toolbar || {};
		this.toolbarElement = this.config.modules?.toolbar?.selector || this.config.toolbar;
		this.toolbar = null;
		const excludeItems = [...moduleConfig.excludeItems || []];
		if (!this.config.rulers || this.config.viewOptions?.layout === "web") excludeItems.push("ruler");
		this.toolbar = new SuperToolbar({
			selector: this.toolbarElement || null,
			isDev: this.isDev || false,
			toolbarGroups: this.config.toolbarGroups,
			role: this.config.role,
			icons: this.config.modules?.toolbar?.icons || this.config.toolbarIcons,
			texts: this.config.modules?.toolbar?.texts || this.config.toolbarTexts,
			fonts: this.config.modules?.toolbar?.fonts || null,
			hideButtons: this.config.modules?.toolbar?.hideButtons ?? true,
			responsiveToContainer: this.config.modules?.toolbar?.responsiveToContainer ?? false,
			documentMode: this.config.documentMode,
			superdoc: this,
			aiApiKey: this.config.modules?.ai?.apiKey,
			aiEndpoint: this.config.modules?.ai?.endpoint,
			uiDisplayFallbackFont: this.config.uiDisplayFallbackFont,
			...moduleConfig,
			excludeItems
		});
		if (this.config.onException) this.toolbar.on("exception", this.config.onException);
		this.once("editorCreate", () => this.toolbar?.updateToolbarState());
	}
	addCommentsList(element) {
		if (!this.config?.modules?.comments || this.config.role === "viewer") return;
		if (element) this.config.modules.comments.element = element;
		this.commentsList = new SuperComments(this.config.modules?.comments, this);
		if (this.config.onCommentsListChange) this.config.onCommentsListChange({ isRendered: true });
	}
	removeCommentsList() {
		if (this.commentsList) {
			this.commentsList.close();
			this.commentsList = null;
			if (this.config.onCommentsListChange) this.config.onCommentsListChange({ isRendered: false });
		}
	}
	scrollToComment(commentId, options = {}) {
		if (!this.config?.modules?.comments) return false;
		if (!commentId || typeof commentId !== "string") return false;
		const root = this.element || document;
		const escaped = globalThis.CSS?.escape ? globalThis.CSS.escape(commentId) : commentId.replace(/"/g, "\\\"");
		const element = root.querySelector(`[data-comment-ids*="${escaped}"]`);
		if (!element) return false;
		const { behavior = "smooth", block = "start" } = options ?? {};
		element.scrollIntoView({
			behavior,
			block
		});
		this.commentsStore?.setActiveComment?.(this, commentId);
		return true;
	}
	async navigateTo(target) {
		const storeDocs = this.superdocStore?.documents;
		if (!storeDocs?.length) return false;
		const presentationEditor = storeDocs[0].getPresentationEditor?.();
		if (!presentationEditor?.navigateTo) return false;
		return presentationEditor.navigateTo(target);
	}
	async scrollToElement(elementId) {
		const storeDocs = this.superdocStore?.documents;
		if (!storeDocs?.length) return false;
		const presentationEditor = storeDocs[0].getPresentationEditor?.();
		if (!presentationEditor?.scrollToElement) return false;
		return presentationEditor.scrollToElement(elementId);
	}
	setDisableContextMenu(disabled = true) {
		const nextValue = Boolean(disabled);
		if (this.config.disableContextMenu === nextValue) return;
		this.config.disableContextMenu = nextValue;
		this.superdocStore?.documents?.forEach((doc) => {
			const presentationEditor = doc.getPresentationEditor?.();
			if (presentationEditor?.setContextMenuDisabled) presentationEditor.setContextMenuDisabled(nextValue);
			const editor = doc.getEditor?.();
			if (editor?.setOptions) editor.setOptions({ disableContextMenu: nextValue });
		});
	}
	setShowBookmarks(show = true) {
		const nextValue = Boolean(show);
		const layoutOptions = this.config.layoutEngineOptions = this.config.layoutEngineOptions || {};
		if (layoutOptions.showBookmarks === nextValue) return;
		layoutOptions.showBookmarks = nextValue;
		this.superdocStore?.documents?.forEach((doc) => {
			(doc.getPresentationEditor?.())?.setShowBookmarks?.(nextValue);
		});
	}
	setShowFormattingMarks(show = true) {
		const nextValue = Boolean(show);
		const layoutOptions = this.config.layoutEngineOptions = this.config.layoutEngineOptions || {};
		if (layoutOptions.showFormattingMarks === nextValue) return;
		layoutOptions.showFormattingMarks = nextValue;
		this.superdocStore?.documents?.forEach((doc) => {
			(doc.getPresentationEditor?.())?.setShowFormattingMarks?.(nextValue);
		});
		this.emit("formatting-marks-change", {
			showFormattingMarks: nextValue,
			superdoc: this
		});
		this.toolbar?.updateToolbarState?.();
	}
	toggleFormattingMarks() {
		const currentValue = Boolean(this.config.layoutEngineOptions?.showFormattingMarks);
		this.setShowFormattingMarks(!currentValue);
	}
	setDocumentMode(type) {
		if (!type) return;
		this.#requireReady("setDocumentMode");
		type = type.toLowerCase();
		this.config.documentMode = type;
		this.#syncViewingVisibility();
		const types = {
			viewing: () => this.#setModeViewing(),
			editing: () => this.#setModeEditing(),
			suggesting: () => this.#setModeSuggesting()
		};
		if (types[type]) {
			types[type]();
			this.emit("document-mode-change", { documentMode: type });
		}
	}
	#applyDocumentMode(doc, mode) {
		const presentationEditor = typeof doc.getPresentationEditor === "function" ? doc.getPresentationEditor() : null;
		if (presentationEditor) {
			presentationEditor.setDocumentMode(mode);
			return;
		}
		const editor = typeof doc.getEditor === "function" ? doc.getEditor() : null;
		if (editor) editor.setDocumentMode(mode);
	}
	setTrackedChangesPreferences(preferences) {
		const normalized = preferences && Object.keys(preferences).length ? { ...preferences } : void 0;
		if (!this.config.layoutEngineOptions) this.config.layoutEngineOptions = {};
		this.config.layoutEngineOptions.trackedChanges = normalized;
		this.superdocStore?.documents?.forEach((doc) => {
			const presentationEditor = typeof doc.getPresentationEditor === "function" ? doc.getPresentationEditor() : null;
			if (presentationEditor?.setTrackedChangesOverrides) presentationEditor.setTrackedChangesOverrides(normalized);
		});
	}
	#setModeEditing() {
		if (this.config.role !== "editor") return this.#setModeSuggesting();
		const store = this.#requireSuperdocStore("setDocumentMode");
		if (store.documents.length > 0) {
			const firstEditor = store.documents[0]?.getEditor();
			if (firstEditor) this.setActiveEditor(firstEditor);
		}
		this.setTrackedChangesPreferences({
			mode: "review",
			enabled: true
		});
		store.documents.forEach((doc) => {
			doc.restoreComments?.();
			this.#applyDocumentMode(doc, "editing");
		});
	}
	#setModeSuggesting() {
		if (!["editor", "suggester"].includes(this.config.role ?? "")) return this.#setModeViewing();
		const store = this.#requireSuperdocStore("setDocumentMode");
		if (store.documents.length > 0) {
			const firstEditor = store.documents[0]?.getEditor();
			if (firstEditor) this.setActiveEditor(firstEditor);
		}
		this.setTrackedChangesPreferences({
			mode: "review",
			enabled: true
		});
		store.documents.forEach((doc) => {
			doc.restoreComments?.();
			this.#applyDocumentMode(doc, "suggesting");
		});
	}
	#setModeViewing() {
		const store = this.#requireSuperdocStore("setDocumentMode");
		if (this.toolbar?.setActiveEditor) this.toolbar.setActiveEditor(null);
		else if (this.toolbar) this.toolbar.activeEditor = null;
		const commentsVisible = this.config.comments?.visible === true;
		const trackChangesVisible = this.config.trackChanges?.visible === true;
		this.setTrackedChangesPreferences(trackChangesVisible ? {
			mode: "review",
			enabled: true
		} : {
			mode: "original",
			enabled: true
		});
		if (!commentsVisible && !trackChangesVisible) this.commentsStore?.clearEditorCommentPositions?.();
		store.documents.forEach((doc) => {
			if (commentsVisible || trackChangesVisible) doc.restoreComments?.();
			else doc.removeComments?.();
			this.#applyDocumentMode(doc, "viewing");
		});
	}
	#syncViewingVisibility() {
		const commentsVisible = this.config.comments?.visible === true;
		const trackChangesVisible = this.config.trackChanges?.visible === true;
		const isViewingMode = this.config.documentMode === "viewing";
		const shouldRenderCommentsInViewing = commentsVisible || trackChangesVisible;
		if (this.commentsStore?.setViewingVisibility) this.commentsStore.setViewingVisibility({
			documentMode: this.config.documentMode,
			commentsVisible,
			trackChangesVisible
		});
		const docs = this.superdocStore?.documents;
		if (Array.isArray(docs) && docs.length > 0) docs.forEach((doc) => {
			const presentationEditor = typeof doc.getPresentationEditor === "function" ? doc.getPresentationEditor() : null;
			if (presentationEditor?.setViewingCommentOptions) presentationEditor.setViewingCommentOptions({
				emitCommentPositionsInViewing: isViewingMode && shouldRenderCommentsInViewing,
				enableCommentsInViewing: isViewingMode && commentsVisible
			});
		});
	}
	search(text) {
		const commands = this.activeEditor?.commands;
		const search = commands?.search;
		if (typeof search !== "function") return void 0;
		return search.call(commands, text, { searchModel: "visible" });
	}
	goToSearchResult(match) {
		const commands = this.activeEditor?.commands;
		const goToSearchResult = commands?.goToSearchResult;
		if (typeof goToSearchResult !== "function") return void 0;
		return goToSearchResult.call(commands, match);
	}
	getZoom() {
		return this.superdocStore?.activeZoom ?? 100;
	}
	setZoom(percent) {
		if (typeof percent !== "number" || !Number.isFinite(percent) || percent <= 0) {
			console.warn("[SuperDoc] setZoom expects a positive number representing percentage");
			return;
		}
		if (!this.superdocStore) {
			console.warn("[SuperDoc] setZoom called before initialization; use config.zoom.initial for the starting zoom");
			return;
		}
		this.superdocStore.activeZoom = percent;
		this.superdocStore.zoomMode = "manual";
		this.emit("zoomChange", {
			zoom: percent,
			mode: "manual"
		});
	}
	setZoomMode(mode) {
		if (mode !== "manual" && mode !== "fit-width") {
			console.warn("[SuperDoc] setZoomMode expects 'manual' or 'fit-width'");
			return;
		}
		if (!this.superdocStore) {
			console.warn("[SuperDoc] setZoomMode called before initialization; use config.zoom.mode for the starting mode");
			return;
		}
		if (this.superdocStore.zoomMode === mode) return;
		this.superdocStore.zoomMode = mode;
		this.emit("zoomChange", {
			zoom: this.getZoom(),
			mode
		});
	}
	getZoomState() {
		const fit = resolveFitWidthOptions(this.config.zoom?.fitWidth);
		return {
			mode: this.superdocStore?.zoomMode ?? "manual",
			value: this.superdocStore?.activeZoom ?? 100,
			fitZoom: this.superdocStore?.viewportMetrics?.fitZoom ?? null,
			min: fit.min,
			max: fit.max
		};
	}
	getViewportMetrics() {
		return this.superdocStore?.viewportMetrics ?? null;
	}
	setLocked(lock = true) {
		this.config.documents.forEach((doc) => {
			const ydoc = doc.ydoc;
			const metaMap = ydoc.getMap("meta");
			ydoc.transact(() => {
				metaMap.set("locked", lock);
				metaMap.set("lockedBy", this.user);
			});
		});
	}
	getHTML(options = {}) {
		const editors = [];
		this.#requireSuperdocStore("getHTML").documents.forEach((doc) => {
			const editor = doc.getEditor?.();
			if (editor) editors.push(editor);
		});
		return editors.map((editor) => editor.getHTML(options));
	}
	lockSuperdoc(isLocked = false, lockedBy = null) {
		this.isLocked = isLocked;
		this.lockedBy = lockedBy;
		this.#log("🦋 [superdoc] Locking superdoc:", isLocked, lockedBy, "\n\n\n");
		this.emit("locked", {
			isLocked,
			lockedBy
		});
	}
	async export({ exportType = ["docx"], commentsType = "external", exportedName, additionalFiles = [], additionalFileNames = [], isFinalDoc = false, triggerDownload = true, fieldsHighlightColor = null } = {}) {
		const baseFileName = exportedName ? cleanName(exportedName) : cleanName(this.config.title);
		const docxFiles = await this.exportEditorsToDOCX({
			commentsType,
			isFinalDoc,
			fieldsHighlightColor
		});
		const blobsToZip = [...additionalFiles];
		const filenames = [...additionalFileNames];
		if (exportType.includes("docx")) docxFiles.forEach((blob) => {
			blobsToZip.push(blob);
			filenames.push(`${baseFileName}.docx`);
		});
		if (blobsToZip.length === 1) {
			if (triggerDownload) return createDownload(blobsToZip[0], baseFileName, exportType[0]);
			return blobsToZip[0];
		}
		const zip = await createZip(blobsToZip, filenames);
		if (triggerDownload) return createDownload(zip, baseFileName, "zip");
		return zip;
	}
	async exportEditorsToDOCX({ commentsType, isFinalDoc, fieldsHighlightColor } = {}) {
		let comments;
		const uiStoreHydrated = this.config?.modules?.comments !== false;
		if (commentsType === "clean") comments = [];
		else if (uiStoreHydrated && this.commentsStore && typeof this.commentsStore.translateCommentsForExport === "function") {
			comments = this.commentsStore.translateCommentsForExport();
			if (!Array.isArray(comments)) comments = [];
		}
		const bridgedExportErrors = /* @__PURE__ */ new WeakSet();
		const rememberBridgedExportError = (payload) => {
			if ("editor" in payload && payload.error && typeof payload.error === "object") bridgedExportErrors.add(payload.error);
		};
		this.on("exception", rememberBridgedExportError);
		try {
			const docxPromises = this.#requireSuperdocStore("exportEditorsToDOCX").documents.map(async (doc) => {
				if (!doc || doc.type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document") return null;
				const editor = typeof doc.getEditor === "function" ? doc.getEditor() : null;
				const fallbackDocx = () => {
					if (!doc.data) return null;
					if (doc.data.type && doc.data.type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document") return null;
					return doc.data;
				};
				if (!editor) return fallbackDocx();
				try {
					const exported = await editor.exportDocx({
						isFinalDoc,
						comments,
						commentsType,
						fieldsHighlightColor
					});
					if (exported) return exported;
				} catch (error) {
					if (!error || typeof error !== "object" || !bridgedExportErrors.has(error)) this.emit("exception", {
						error,
						document: doc
					});
				}
				return fallbackDocx();
			});
			return (await Promise.all(docxPromises)).filter((file) => file != null);
		} finally {
			this.off("exception", rememberBridgedExportError);
		}
	}
	async #triggerCollaborationSaves() {
		this.#log("🦋 [superdoc] Triggering collaboration saves");
		const store = this.#requireSuperdocStore("save");
		return new Promise((resolve) => {
			store.documents.forEach((doc, index) => {
				this.#log(`Before reset - Doc ${index}: pending = ${this.pendingCollaborationSaves}`);
				this.pendingCollaborationSaves = 0;
				if (doc.ydoc) {
					this.pendingCollaborationSaves++;
					this.#log(`After increment - Doc ${index}: pending = ${this.pendingCollaborationSaves}`);
					const metaMap = doc.ydoc.getMap("meta");
					metaMap.observe((event) => {
						if (event.changes.keys.has("immediate-save-finished")) {
							this.pendingCollaborationSaves--;
							if (this.pendingCollaborationSaves <= 0) resolve();
						}
					});
					metaMap.set("immediate-save", true);
				}
			});
			this.#log(`FINAL pending = ${this.pendingCollaborationSaves}, but we have ${store.documents.filter((d) => d.ydoc).length} docs!`);
		});
	}
	async save() {
		const savePromises = [this.#triggerCollaborationSaves()];
		this.#log("🦋 [superdoc] Saving superdoc");
		await Promise.all(savePromises);
		this.#log("🦋 [superdoc] Save complete");
	}
	#cleanupCollaboration() {
		if (typeof this._cleanupAwareness === "function") {
			this._cleanupAwareness();
			this._cleanupAwareness = null;
		}
		const cfg = this.config;
		cfg.socket?.cancelWebsocketRetry?.();
		cfg.socket?.disconnect();
		cfg.socket?.destroy();
		this.ydoc?.destroy();
		this.provider?.disconnect?.();
		this.provider?.destroy?.();
		cfg.documents.forEach((doc) => {
			doc.provider?.disconnect?.();
			doc.provider?.destroy?.();
			doc.ydoc?.destroy();
		});
	}
	openSurface(request) {
		return this.#surfaceManager.open(request);
	}
	closeSurface(id) {
		this.#surfaceManager.close(id);
	}
	destroy() {
		this.#destroyed = true;
		if (this.#abortUpgrade) {
			this.#abortUpgrade();
			this.#abortUpgrade = null;
		}
		if (this.#surfaceManager) this.#surfaceManager.destroy();
		this.toolbar?.destroy();
		if (this.app) {
			this.#log("[superdoc] Unmounting app");
			this.superdocStore?.reset();
			this.app.unmount();
			this.removeAllListeners();
			delete this.app.config.globalProperties.$config;
			delete this.app.config.globalProperties.$superdoc;
		}
		this.#cleanupCollaboration();
		this.#editorRuntimeRegistryUnsub?.();
		this.#editorRuntimeRegistryUnsub = null;
		this.#editorRuntimeRegistry.clear();
		if (this.#mountWrapper) {
			this.#mountWrapper.remove();
			this.#mountWrapper = null;
		}
	}
	focus() {
		const runtime = this.getActiveRuntime();
		if (runtime?.getCapabilities().lifecycle.canFocus) {
			runtime.focus().catch((err) => {
				console.warn("[SuperDoc] active editor runtime focus failed", err);
			});
			return;
		}
		if (this.activeEditor) this.activeEditor.focus?.();
		else this.#requireSuperdocStore("focus").documents.find((doc) => {
			const editor = doc.getEditor?.();
			if (!editor) return false;
			editor.focus?.();
			return true;
		});
	}
	setHighContrastMode(isHighContrast) {
		if (!this.activeEditor) return;
		this.activeEditor.setHighContrastMode?.(isHighContrast);
		this.highContrastModeStore?.setHighContrastMode(isHighContrast);
	}
};
var COLORS_TO_VARS = {
	action: "--sd-ui-action",
	actionHover: "--sd-ui-action-hover",
	actionText: "--sd-ui-action-text",
	bg: "--sd-ui-bg",
	hoverBg: "--sd-ui-hover-bg",
	activeBg: "--sd-ui-active-bg",
	disabledBg: "--sd-ui-disabled-bg",
	text: "--sd-ui-text",
	textMuted: "--sd-ui-text-muted",
	textDisabled: "--sd-ui-text-disabled",
	border: "--sd-ui-border"
};
var themeCounter = 0;
function generateTheme(config) {
	const { name, font, radius, shadow, colors, vars } = config;
	const className = `sd-theme-${(name ? name.replace(/[^a-zA-Z0-9-_]/g, "-") : null) || `custom-${++themeCounter}`}`;
	const declarations = [];
	if (colors) for (const [key, value] of Object.entries(colors)) {
		if (value == null) continue;
		const varName = COLORS_TO_VARS[key];
		if (varName) declarations.push(`  ${varName}: ${value};`);
	}
	if (font != null) declarations.push(`  --sd-ui-font-family: ${font};`);
	if (radius != null) declarations.push(`  --sd-ui-radius: ${radius};`);
	if (shadow != null) declarations.push(`  --sd-ui-shadow: ${shadow};`);
	if (vars) for (const [varName, value] of Object.entries(vars)) {
		if (value == null) continue;
		declarations.push(`  ${varName}: ${value};`);
	}
	return {
		className,
		css: declarations.length > 0 ? `.${className} {\n${declarations.join("\n")}\n}` : ""
	};
}
function injectThemeStyle(className, css) {
	if (typeof document === "undefined" || !css) return;
	let style = document.querySelector(`[data-sd-theme="${className}"]`);
	if (!style) {
		style = document.createElement("style");
		style.setAttribute("data-sd-theme", className);
		document.head.appendChild(style);
	}
	style.textContent = css;
}
function createTheme(config) {
	const { className, css } = generateTheme(config);
	injectThemeStyle(className, css);
	return className;
}
function buildTheme(config) {
	return generateTheme(config);
}
export { compareVersions as a, getSchemaIntrospection as i, createTheme as n, SuperDoc as r, buildTheme as t };
